/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K]
}
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>
}
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>
}
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never }
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never
    }
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string }
  String: { input: string; output: string }
  Boolean: { input: boolean; output: boolean }
  Int: { input: number; output: number }
  Float: { input: number; output: number }
  ChimeCredentials: { input: string; output: string }
  ChimeMediaStreamCredentials: { input: any; output: any }
  /** ISO-8601 Date */
  Date: { input: string; output: string }
  /** ISO-8601 DateTime */
  DateTime: { input: string; output: string }
  /** Map of BCP-47 language tag to display name, e.g. { "en": "Hamburg", "de": "Hamburg" }. */
  DisplayNames: {
    input: Partial<Record<'de' | 'en' | 'no', string>>
    output: Partial<Record<'de' | 'en' | 'no', string>>
  }
  /** ISO-8601 time duration */
  Duration: { input: string; output: string }
  /** GeoJSON as a JSON string */
  GeoJSONSerializedObject: { input: any; output: any }
  /** An instantaneous point on the time-line represented by a standard date time string */
  Instant: { input: any; output: any }
  /** ISO-8601 local time without offset, e.g. 22:00:00 */
  LocalTime: { input: any; output: any }
  /** ISO-8601 Date and time with offset (2011-12-03T10:15:30+01:00) */
  OffsetDateTime: { input: any; output: any }
  /** Percentage in the range 0.0 - 100.0. However, the value may exceed the specified range. */
  Percentage: { input: any; output: any }
  RefundSuccess: { input: any; output: any }
  /** Represented as an ISO8601 Time, e.g. 03:02:01 - https://en.wikipedia.org/wiki/ISO_8601#Times */
  TimeOfDay: { input: string; output: string }
  /** TimeZone represents a time zone offset, and also figures out daylight savings. */
  TimeZone: { input: string; output: string }
  /** The ridepooling service tenant that owns the trip, e.g. moia */
  TripRidepoolingServiceTenant: { input: any; output: any }
  /** The customer tenant the trip was ordered through, e.g. moia or switchh. */
  TripTenant: { input: any; output: any }
  /**
   * A UUID is a unique 128-bit number, stored as 16 octets. UUIDs are parsed as
   * Strings within GraphQL. UUIDs are used to assign unique identifiers to
   * entities without requiring a central allocating authority.
   *
   * # References
   *
   * * [Wikipedia: Universally Unique Identifier](http://en.wikipedia.org/wiki/Universally_unique_identifier)
   * * [RFC4122: A Universally Unique Identifier (UUID) URN Namespace](http://tools.ietf.org/html/rfc4122)
   */
  UUID: { input: string; output: string }
  Unit: { input: any; output: any }
  /** Represented as no value being returned - https://the-guild.dev/graphql/scalars/docs/scalars/void */
  Void: { input: any; output: any }
  /** Represented as an ISO8601 Year-month, e.g. 2024-02 - https://en.wikipedia.org/wiki/ISO_8601#Calendar_dates */
  YearMonth: { input: string; output: string }
}

export enum AdConnectivityState {
  Connected = 'CONNECTED',
  Interrupted = 'INTERRUPTED',
}

export type AdConnectivityStateWithTimestamp = {
  __typename?: 'ADConnectivityStateWithTimestamp'
  connectivityState: AdConnectivityState
  timestamp: Scalars['DateTime']['output']
}

export type AdTelemetry = {
  __typename?: 'ADTelemetry'
  cabinConnectivityState: Maybe<AdConnectivityStateWithTimestamp>
  centralLockLocked: Maybe<AdTelemetryBooleanWithTimestamp>
  /** Energy consumed in Watts per second */
  consumedEnergy: Maybe<AdTelemetryFloatWithTimestamp>
  /** @deprecated Use rightSlidingDoorOpen instead */
  doorsOpen: Maybe<AdTelemetryBooleanWithTimestamp>
  highVoltBatterySOCPercentage: Maybe<AdTelemetryFloatWithTimestamp>
  ignitionOn: Maybe<AdTelemetryBooleanWithTimestamp>
  interiorTemperatureCelsius: Maybe<AdTelemetryFloatWithTimestamp>
  location: Maybe<LocationWithTimestamp>
  mileageKilometer: Maybe<AdTelemetryIntWithTimestamp>
  missionConnectivityState: Maybe<AdConnectivityStateWithTimestamp>
  remainingCruisingRangeKilometer: Maybe<AdTelemetryFloatWithTimestamp>
  rightSlidingDoorOpen: Maybe<AdTelemetryBooleanWithTimestamp>
  sdsConnectivityState: Maybe<AdConnectivityStateWithTimestamp>
  sdsMode: Maybe<SdsModeWithTimestamp>
  signalConnectivityState: Maybe<AdConnectivityStateWithTimestamp>
  /** Current speed of vehicle in meters per second */
  speed: Maybe<AdTelemetryFloatWithTimestamp>
  vehicleConnectivityState: Maybe<AdConnectivityStateWithTimestamp>
}

export type AdTelemetryBooleanWithTimestamp = {
  __typename?: 'ADTelemetryBooleanWithTimestamp'
  /** DateTime when the value changed the last time. */
  timestamp: Scalars['DateTime']['output']
  value: Scalars['Boolean']['output']
}

export type AdTelemetryFloatWithTimestamp = {
  __typename?: 'ADTelemetryFloatWithTimestamp'
  /** DateTime when the value changed the last time. */
  timestamp: Scalars['DateTime']['output']
  value: Scalars['Float']['output']
}

export type AdTelemetryIntWithTimestamp = {
  __typename?: 'ADTelemetryIntWithTimestamp'
  /** DateTime when the value changed the last time. */
  timestamp: Scalars['DateTime']['output']
  value: Scalars['Int']['output']
}

export type Action = {
  __typename?: 'Action'
  automated: Scalars['Boolean']['output']
  condition: Maybe<ActionCondition>
  created: Scalars['DateTime']['output']
  description: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  modified: Scalars['DateTime']['output']
  modifiedBy: Scalars['String']['output']
  reason: ActionReason
  scheduleStatus: ActionScheduleStatus
  timeRange: TimeRange
  type: ActionType
}

export enum ActionCondition {
  AllStopDeactivationsExpired = 'AllStopDeactivationsExpired',
}

export enum ActionEntityType {
  Area = 'Area',
  ServiceArea = 'ServiceArea',
  Stop = 'Stop',
}

export type ActionInput = {
  actionType: ActionType
  condition?: InputMaybe<ActionCondition>
  description?: InputMaybe<Scalars['String']['input']>
  entityId: Scalars['String']['input']
  entityType: ActionEntityType
  reason?: InputMaybe<ActionReason>
  timeRange: TimeRangeInput
}

export enum ActionReason {
  ActivationPeriod = 'ActivationPeriod',
  AuthorityCheckPending = 'AuthorityCheckPending',
  BadStopVoting = 'BadStopVoting',
  Complaint = 'Complaint',
  ConstructionSite = 'ConstructionSite',
  Demo = 'Demo',
  IndividualEvent = 'IndividualEvent',
  OutOfServiceArea = 'OutOfServiceArea',
  PolygonUpdate = 'PolygonUpdate',
  RecurringEvent = 'RecurringEvent',
  Stvo = 'STVO',
  ScheduledForDeletionWithin24Hours = 'ScheduledForDeletionWithin24Hours',
  Unreachable = 'Unreachable',
}

export enum ActionScheduleStatus {
  Expired = 'Expired',
  ExpiredRecurring = 'ExpiredRecurring',
  Ongoing = 'Ongoing',
  OngoingRecurring = 'OngoingRecurring',
  Unknown = 'Unknown',
  Upcoming = 'Upcoming',
  UpcomingRecurring = 'UpcomingRecurring',
}

export enum ActionType {
  AdStopFlagRemoval = 'AdStopFlagRemoval',
  EntityDeletion = 'EntityDeletion',
  ServiceAreaUpdate = 'ServiceAreaUpdate',
  StopDeactivation = 'StopDeactivation',
}

export type ActivateClimateControlInput = {
  vehicleID: Scalars['ID']['input']
}

export type ActivateClimateControlResponse = {
  __typename?: 'ActivateClimateControlResponse'
  vehicle: Vehicle
}

export type ActivateVehicleInput = {
  vehicleId: Scalars['ID']['input']
}

export type ActiveTripSegment = {
  __typename?: 'ActiveTripSegment'
  id: Scalars['ID']['output']
  metadata: Array<Array<Scalars['String']['output']>>
  safetyDriverTripConfirmationState: SafetyDriverTripConfirmationState
  segment: Maybe<TripSegmentWithStatus>
  status: TripStatus
  terminationInfo: Maybe<TripTerminationInfo>
  type: TripType
  vin: Scalars['String']['output']
}

export type AddLegalDocumentVersionMutationInput = {
  id: Scalars['ID']['input']
  localization: Array<LocalizationInput>
  tenant: Scalars['String']['input']
}

/** Input for adding a new status entry to a vehicle. */
export type AddVehicleToFleetInput = {
  /**
   * Optional ids of existing status entries fully swallowed by the new entry
   * (total overlap) that should be removed. Each id must belong to the target
   * vehicle.
   */
  deletedIds?: InputMaybe<Array<Scalars['ID']['input']>>
  /** End date of the status period. */
  endDate: Scalars['Date']['input']
  /** Vehicle identifier (e.g. VN41S170816). */
  id: Scalars['ID']['input']
  /** Integration stage name. */
  integrationStage: Scalars['String']['input']
  /** Location name. */
  location: Scalars['String']['input']
  /** Optional notes. */
  notes?: InputMaybe<Scalars['String']['input']>
  /**
   * Optional list of splits: the new entry lands inside an existing period, so a
   * new "after" row is created for the given dates, cloning the referenced row's
   * location, integration stage, technical status, and notes.
   */
  splitEntries?: InputMaybe<Array<FleetPlannerVehicleSplitInput>>
  /** Start date of the status period. */
  startDate: Scalars['Date']['input']
  /** Technical status to assign. */
  technicalStatus: FleetPlannerVehicleTechnicalStatusInput
  /**
   * Optional list of existing status entries whose start/end dates should shift
   * to accommodate the new entry (client-computed reschedule). Reuses the shared
   * date-update shape; each id must belong to the target vehicle.
   */
  updatedDates?: InputMaybe<Array<FleetPlannerVehicleDateUpdateInput>>
}

export type AdminPanelGroupWithUserCount = {
  __typename?: 'AdminPanelGroupWithUserCount'
  DEDescription: Maybe<Scalars['String']['output']>
  ENDescription: Maybe<Scalars['String']['output']>
  critical: Scalars['Boolean']['output']
  displayName: Scalars['String']['output']
  gdpr: Scalars['Boolean']['output']
  name: Scalars['String']['output']
  rights: Maybe<Array<Scalars['String']['output']>>
  userCount: Scalars['Int']['output']
}

export type AdminPanelSwapGroupInput = {
  expires?: InputMaybe<Scalars['DateTime']['input']>
  /** @deprecated Use groupsList instead */
  groupName?: InputMaybe<Scalars['String']['input']>
  groupsList?: InputMaybe<Array<Scalars['String']['input']>>
}

export type AdminPanelUserManagementUserFormDetails = {
  __typename?: 'AdminPanelUserManagementUserFormDetails'
  adminPanelGroups: Array<BackofficeUserManagementGroup>
  approvers: Array<BackofficeUserManagementGroup>
  backofficeGroups: Array<BackofficeUserManagementGroup>
  customerTenants: Maybe<Array<Scalars['String']['output']>>
  fleets: Array<BackofficeUserManagementFleet>
  /** Service area details for display when available. */
  fullServiceAreas: Array<BackofficeUserManagementServiceArea>
  operatorTenants: Maybe<Array<Scalars['String']['output']>>
  ridepoolingServiceTenants: Maybe<Array<Scalars['String']['output']>>
  serviceAreaDetails: Array<Maybe<ServiceArea>>
  serviceAreas: Array<Scalars['String']['output']>
  userTypes: Array<UserType>
}

/** Deprecated: to be replaced by OpenVehicleInput, OpenVehicleForBackofficeUserInput, CloseVehicleInput, CloseVehicleForBackofficeUserInput */
export type AdminVehicleInteractionInput = {
  interactionType: VehicleInteractionType
  isBatchInteraction?: InputMaybe<Scalars['Boolean']['input']>
  reason?: InputMaybe<InteractionReason>
  reasonFreeText?: InputMaybe<Scalars['String']['input']>
  token?: InputMaybe<Scalars['String']['input']>
  vehicleID: Scalars['ID']['input']
}

export type AggregatedVehicleHubArrivalsAndDeparturesResponse = {
  __typename?: 'AggregatedVehicleHubArrivalsAndDeparturesResponse'
  from: Scalars['DateTime']['output']
  hubArrivalsOrDeparturesByType: Array<HubArrivalsOrDeparturesByType>
  to: Scalars['DateTime']['output']
}

export type AllowlistPhoneNumberInput = {
  phoneNumber: Scalars['String']['input']
  tenant: Scalars['String']['input']
}

export type AnalyticsCodebeamerRequirement = {
  __typename?: 'AnalyticsCodebeamerRequirement'
  description: Scalars['String']['output']
  id: Scalars['String']['output']
  primitiveDisplayNames: Array<Scalars['String']['output']>
  primitiveTaxonomies: Array<Scalars['String']['output']>
  url: Scalars['String']['output']
  videoLinks: Array<Scalars['String']['output']>
}

export type AnalyticsFilters = {
  __typename?: 'AnalyticsFilters'
  locations: Array<Scalars['String']['output']>
  maneuverTypes: Array<Scalars['String']['output']>
  oddElementTypes: Array<Scalars['String']['output']>
  swVersions: Array<Scalars['String']['output']>
  testTypes: Array<Scalars['String']['output']>
}

export type AnalyticsFiltersInput = {
  city?: InputMaybe<Scalars['String']['input']>
  endDate?: InputMaybe<Scalars['String']['input']>
  missionType?: InputMaybe<Scalars['String']['input']>
  softwareVersion?: InputMaybe<Scalars['String']['input']>
  startDate?: InputMaybe<Scalars['String']['input']>
}

export type AnalyticsKpi = {
  __typename?: 'AnalyticsKpi'
  kpiName: Scalars['String']['output']
  value: Scalars['Float']['output']
}

export type AnalyticsLogDetail = {
  __typename?: 'AnalyticsLogDetail'
  endTime: Scalars['String']['output']
  location: Scalars['String']['output']
  meDebuggerUrl: Scalars['String']['output']
  primitiveTypeName: Scalars['String']['output']
  sessionId: Scalars['String']['output']
  startTime: Scalars['String']['output']
}

export type AnalyticsPrimitiveChart = {
  __typename?: 'AnalyticsPrimitiveChart'
  count: Scalars['Int']['output']
  date: Scalars['String']['output']
}

export type AnalyticsPrimitiveDetail = {
  __typename?: 'AnalyticsPrimitiveDetail'
  codebeamerId: Scalars['String']['output']
  codebeamerUrl: Scalars['String']['output']
  endTime: Scalars['String']['output']
  location: Scalars['String']['output']
  meDebuggerUrl: Scalars['String']['output']
  primitiveTypeName: Scalars['String']['output']
  startTime: Scalars['String']['output']
  swVersion: Scalars['String']['output']
  testType: Scalars['String']['output']
  vehicleId: Scalars['String']['output']
  vtr: Scalars['String']['output']
}

export type AnalyticsPrimitiveDetailsResponse = {
  __typename?: 'AnalyticsPrimitiveDetailsResponse'
  chart: Array<AnalyticsPrimitiveChart>
  details: Array<AnalyticsPrimitiveDetail>
  summary: AnalyticsPrimitiveSummary
  total: Scalars['Int']['output']
}

export type AnalyticsPrimitiveLogsResponse = {
  __typename?: 'AnalyticsPrimitiveLogsResponse'
  logDetails: Array<AnalyticsLogDetail>
  total: Scalars['Int']['output']
}

export type AnalyticsPrimitiveSummary = {
  __typename?: 'AnalyticsPrimitiveSummary'
  coverageAmount: Scalars['Int']['output']
  coverageRequired: Scalars['Int']['output']
  evaluationPercentage: Scalars['Float']['output']
  primitiveDisplayName: Scalars['String']['output']
  primitiveTaxonomy: Scalars['String']['output']
  primitiveType: Scalars['String']['output']
}

export type AnchorPoint = {
  __typename?: 'AnchorPoint'
  location: Location
  name: Scalars['String']['output']
}

export type AnchorRoute = {
  __typename?: 'AnchorRoute'
  description: Scalars['String']['output']
  error: Maybe<Scalars['String']['output']>
  route: Array<Location>
  violations: Array<Scalars['String']['output']>
}

export type Annotation = {
  __typename?: 'Annotation'
  annotation: Maybe<Scalars['String']['output']>
  assessedBy: Maybe<Scalars['String']['output']>
  assessedOn: Maybe<Scalars['DateTime']['output']>
  bucketConnection: Maybe<Scalars['String']['output']>
  catType: Maybe<Scalars['String']['output']>
  category: Maybe<Scalars['String']['output']>
  city: Maybe<Scalars['String']['output']>
  codriver: Maybe<Scalars['String']['output']>
  comment: Maybe<Scalars['String']['output']>
  correspondingFeatures: Maybe<Array<Scalars['String']['output']>>
  correspondingScenario: Maybe<Scalars['String']['output']>
  correspondingTriggeringCondition: Maybe<Array<Scalars['String']['output']>>
  country: Maybe<Scalars['String']['output']>
  createEventTicket: Scalars['Boolean']['output']
  creationDate: Maybe<Scalars['DateTime']['output']>
  driver: Maybe<Scalars['String']['output']>
  egoManoeuvre: Maybe<Array<Scalars['String']['output']>>
  environmentConditions: Maybe<Array<Scalars['String']['output']>>
  eventJiraTicket: Maybe<Scalars['String']['output']>
  eventTags: Maybe<Array<Scalars['String']['output']>>
  failedRequirements: Maybe<Array<Scalars['String']['output']>>
  fullEventIdGenerated: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  jiraIssue: Maybe<Scalars['String']['output']>
  logSliceLink: Maybe<Scalars['String']['output']>
  mapVersion: Maybe<Scalars['String']['output']>
  mission: Maybe<Scalars['String']['output']>
  missionSegment: Maybe<Scalars['String']['output']>
  parameterSet: Maybe<Scalars['String']['output']>
  rcRoute: Maybe<Array<Scalars['String']['output']>>
  rcRun: Maybe<Array<Scalars['String']['output']>>
  relevantOddElements: Maybe<Array<Scalars['String']['output']>>
  reqCategory1: Maybe<Scalars['String']['output']>
  reqCategory2: Maybe<Scalars['String']['output']>
  reqCategory3: Maybe<Scalars['String']['output']>
  sdsProviderId: Maybe<Scalars['String']['output']>
  sessionId: Maybe<Scalars['String']['output']>
  swRelease: Maybe<Scalars['String']['output']>
  testEnvironment: Maybe<Scalars['String']['output']>
  testcase: Maybe<Scalars['String']['output']>
  timestamp: Maybe<Scalars['DateTime']['output']>
  triageNotes: Maybe<Scalars['String']['output']>
  vehicle: Maybe<Scalars['String']['output']>
  vnvComment: Maybe<Scalars['String']['output']>
  vnvConfirmation: Maybe<Scalars['String']['output']>
}

export enum AnnotationCategory {
  DeadlockStuckState = 'DEADLOCK_STUCK_STATE',
  LaneChangeDecision = 'LANE_CHANGE_DECISION',
  LateralPositioning = 'LATERAL_POSITIONING',
  MapError = 'MAP_ERROR',
  OverspeedInsufficientBraking = 'OVERSPEED_INSUFFICIENT_BRAKING',
  RouteAdherence = 'ROUTE_ADHERENCE',
  SignalUsage = 'SIGNAL_USAGE',
  Uncategorised = 'UNCATEGORISED',
  UnderspeedExcessBraking = 'UNDERSPEED_EXCESS_BRAKING',
}

export type AnnotationClassification = {
  __typename?: 'AnnotationClassification'
  category: AnnotationCategory
  confidence: Maybe<Scalars['Float']['output']>
  createdAtMs: Scalars['Float']['output']
  createdBy: Maybe<Scalars['String']['output']>
  mapContribution: Maybe<Scalars['Boolean']['output']>
  modelVersion: Maybe<Scalars['String']['output']>
  reasonCode: Maybe<AnnotationReasonCode>
  reasonPath: Array<Scalars['String']['output']>
  source: AnnotationClassificationSource
  taxonomyVendor: Maybe<Scalars['String']['output']>
  taxonomyVersion: Maybe<Scalars['String']['output']>
  trafficLawViolation: Maybe<Scalars['Boolean']['output']>
}

export enum AnnotationClassificationSource {
  Human = 'HUMAN',
  Model = 'MODEL',
  VendorTriage = 'VENDOR_TRIAGE',
}

export type AnnotationInput = {
  annotation?: InputMaybe<Scalars['String']['input']>
  bucketConnection?: InputMaybe<Scalars['String']['input']>
  catType?: InputMaybe<Scalars['String']['input']>
  category?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Scalars['String']['input']>
  codriver?: InputMaybe<Scalars['String']['input']>
  comment?: InputMaybe<Scalars['String']['input']>
  correspondingFeatures?: InputMaybe<Array<Scalars['String']['input']>>
  correspondingScenario?: InputMaybe<Scalars['String']['input']>
  correspondingTriggeringCondition?: InputMaybe<
    Array<Scalars['String']['input']>
  >
  country?: InputMaybe<Scalars['String']['input']>
  createEventTicket?: Scalars['Boolean']['input']
  driver?: InputMaybe<Scalars['String']['input']>
  egoManoeuvre?: InputMaybe<Array<Scalars['String']['input']>>
  environmentConditions?: InputMaybe<Array<Scalars['String']['input']>>
  eventJiraTicket?: InputMaybe<Scalars['String']['input']>
  eventTags?: InputMaybe<Array<Scalars['String']['input']>>
  failedRequirements?: InputMaybe<Array<Scalars['String']['input']>>
  fullEventIdGenerated?: InputMaybe<Scalars['String']['input']>
  jiraIssue?: InputMaybe<Scalars['String']['input']>
  mapVersion?: InputMaybe<Scalars['String']['input']>
  mission?: InputMaybe<Scalars['String']['input']>
  missionSegment?: InputMaybe<Scalars['String']['input']>
  parameterSet?: InputMaybe<Scalars['String']['input']>
  rcRoute?: InputMaybe<Array<Scalars['String']['input']>>
  rcRun?: InputMaybe<Array<Scalars['String']['input']>>
  relevantOddElements?: InputMaybe<Array<Scalars['String']['input']>>
  reqCategory1?: InputMaybe<Scalars['String']['input']>
  reqCategory2?: InputMaybe<Scalars['String']['input']>
  reqCategory3?: InputMaybe<Scalars['String']['input']>
  sdsProviderId?: InputMaybe<Scalars['String']['input']>
  sessionId?: InputMaybe<Scalars['String']['input']>
  swRelease?: InputMaybe<Scalars['String']['input']>
  testEnvironment?: InputMaybe<Scalars['String']['input']>
  testcase?: InputMaybe<Scalars['String']['input']>
  triageNotes?: InputMaybe<Scalars['String']['input']>
  vehicle?: InputMaybe<Scalars['String']['input']>
  vnvComment?: InputMaybe<Scalars['String']['input']>
  vnvConfirmation?: InputMaybe<Scalars['String']['input']>
}

export type AnnotationQueryResponse = {
  __typename?: 'AnnotationQueryResponse'
  item: Annotation
}

export enum AnnotationReasonCode {
  ExcessOffsetSteering = 'EXCESS_OFFSET_STEERING',
  Irrelevant = 'IRRELEVANT',
  JunctionLateToStart = 'JUNCTION_LATE_TO_START',
  JunctionNotYielding = 'JUNCTION_NOT_YIELDING',
  JunctionShouldStopTfl = 'JUNCTION_SHOULD_STOP_TFL',
  JunctionWrongStop = 'JUNCTION_WRONG_STOP',
  NarrowScenario = 'NARROW_SCENARIO',
  ObjectRelated = 'OBJECT_RELATED',
  OutOfLane = 'OUT_OF_LANE',
  RouteNotFollowed = 'ROUTE_NOT_FOLLOWED',
  ShouldNotChangeLaneOccupied = 'SHOULD_NOT_CHANGE_LANE_OCCUPIED',
  SignalFalse = 'SIGNAL_FALSE',
  SignalMiss = 'SIGNAL_MISS',
  SpeedLimitLegalSpeed = 'SPEED_LIMIT_LEGAL_SPEED',
  SpeedSign = 'SPEED_SIGN',
  SuddenSharpSteering = 'SUDDEN_SHARP_STEERING',
  TooCloseObject = 'TOO_CLOSE_OBJECT',
  TooCloseRoadEdge = 'TOO_CLOSE_ROAD_EDGE',
  TooSlowGeneral = 'TOO_SLOW_GENERAL',
  UnnecessaryBraking = 'UNNECESSARY_BRAKING',
}

export type AnnotationResolution = {
  __typename?: 'AnnotationResolution'
  evidenceRef: Scalars['String']['output']
  evidenceType: Scalars['String']['output']
  note: Maybe<Scalars['String']['output']>
  resolvedAtMs: Scalars['Float']['output']
  resolvedBy: Scalars['String']['output']
}

export type AnnotationsQueryResponse = {
  __typename?: 'AnnotationsQueryResponse'
  items: Array<Annotation>
  pageInfo: VnvBackofficePageInfo
}

export enum ApiEventType {
  ApiEventTypeAppFeedback = 'API_EVENT_TYPE_APP_FEEDBACK',
  ApiEventTypeCustomerSupportRequested = 'API_EVENT_TYPE_CUSTOMER_SUPPORT_REQUESTED',
  ApiEventTypeFleetosTrace = 'API_EVENT_TYPE_FLEETOS_TRACE',
  ApiEventTypeInvalid = 'API_EVENT_TYPE_INVALID',
  ApiEventTypeRideQualityComment = 'API_EVENT_TYPE_RIDE_QUALITY_COMMENT',
  ApiEventTypeTripQueued = 'API_EVENT_TYPE_TRIP_QUEUED',
}

/** Collection of properties that are only available when the customer is managed by our whitelabel apps */
export type AppCustomerInformation = {
  __typename?: 'AppCustomerInformation'
  /** The optional sign up IP address of the customer */
  createdIpAddress: Maybe<Scalars['String']['output']>
  /** The status of the pending deletion */
  deletionScheduledAt: Maybe<Scalars['OffsetDateTime']['output']>
  /** The email verified flag for the customer */
  emailVerified: Maybe<Scalars['Boolean']['output']>
  /** The extended walking time flag for the customer */
  extendedWalkingTime: Maybe<Scalars['Boolean']['output']>
  /** HVV Partnership valid until date (ISO-8601) */
  hvvPartnershipValidUntil: Maybe<Scalars['OffsetDateTime']['output']>
  /** List of legal document confirmations */
  legalDocumentConfirmations: Array<LegalDocumentConfirmation>
  /** The customers locale/language (BCP 47) */
  locale: Maybe<Scalars['String']['output']>
  /** The phone verified flag for the customer */
  phoneVerified: Maybe<Scalars['Boolean']['output']>
  /** The accessibility flag for severely disabled customers */
  severelyDisabled: Maybe<SeverelyDisabled>
  /** The status of the customer. Either 'ENABLED' or 'DISABLED'. */
  status: CustomerStatus
  /** List of changes to the status of the customer */
  statusHistory: Maybe<Array<StatusHistoryEntry>>
  /** The visual impairment flag for the customer */
  visualImpairment: Maybe<Scalars['Boolean']['output']>
  /** The accessibility flag for the wheelchair of the customer */
  wheelchairAccess: Maybe<Scalars['Boolean']['output']>
}

export type ApplePay = {
  __typename?: 'ApplePay'
  /** Fake field because GraphQL does not support empty objects. Do not query, use __typename instead. */
  _: Maybe<Scalars['Boolean']['output']>
}

export type ApproveCustomPriceConfigInput = {
  id: Scalars['ID']['input']
  version: Scalars['Int']['input']
}

/** For possible errors see type CreateDefaultPriceConfigResponse */
export type ApproveCustomPriceConfigResponse = {
  __typename?: 'ApproveCustomPriceConfigResponse'
  config: CustomPriceConfigResponse
}

export type ApproveDefaultPriceConfigInput = {
  id: Scalars['ID']['input']
  version: Scalars['Int']['input']
}

/** For possible errors see type CreateDefaultPriceConfigResponse */
export type ApproveDefaultPriceConfigResponse = {
  __typename?: 'ApproveDefaultPriceConfigResponse'
  config: DefaultPriceConfigResponse
}

/** Input object for archiving a pricing polygon in the polygon library */
export type ArchivePriceConfigPolygonInput = {
  id: Scalars['ID']['input']
}

export type ArchivePriceConfigPolygonResponse = {
  __typename?: 'ArchivePriceConfigPolygonResponse'
  polygon: PriceConfigPolygon
}

export type ArchiveVehicleInput = {
  vehicleId: Scalars['ID']['input']
}

export type Area = {
  __typename?: 'Area'
  actions: Array<Action>
  areaCapacityConfiguration: Maybe<AreaCapacityConfiguration>
  changeDescription: Scalars['String']['output']
  created: Scalars['DateTime']['output']
  description: Maybe<Scalars['String']['output']>
  details: Maybe<AreaDetails>
  /** GeoJSON geometry object */
  geometry: Scalars['String']['output']
  hasOverlappingActions: Scalars['Boolean']['output']
  id: Scalars['ID']['output']
  keepOutZone: Maybe<Scalars['Boolean']['output']>
  metadata: Array<MetadataString>
  modified: Scalars['DateTime']['output']
  modifiedBy: Scalars['String']['output']
  name: Maybe<Scalars['String']['output']>
  serviceArea: ServiceArea
  status: Maybe<AreaStatus>
  /**
   * Number of vehicles returning to this hub in the specified interval.
   * Defaults to the next 30 minutes.
   */
  totalReturningVehicles: Maybe<Scalars['Int']['output']>
  type: AreaType
}

export type AreaTotalReturningVehiclesArgs = {
  interval?: InputMaybe<DateTimeIntervalInput>
}

export type AreaCapacityConfiguration = {
  __typename?: 'AreaCapacityConfiguration'
  acPowerChargingCapacity: Scalars['Int']['output']
  highPowerChargingCapacity: Scalars['Int']['output']
  highPowerChargingCapacityCritical: Scalars['Int']['output']
  highPowerChargingCapacityMax: Scalars['Int']['output']
  maxBreaks: Scalars['Int']['output']
  parkingCapacity: Scalars['Int']['output']
  plannedBreaksAllowed: Scalars['Boolean']['output']
  shortBreaksAllowed: Scalars['Boolean']['output']
}

export type AreaCapacityConfigurationInput = {
  acPowerChargingCapacity: Scalars['Int']['input']
  changeDescription?: InputMaybe<Scalars['String']['input']>
  highPowerChargingCapacity: Scalars['Int']['input']
  highPowerChargingCapacityCritical: Scalars['Int']['input']
  highPowerChargingCapacityMax: Scalars['Int']['input']
  maxBreaks?: InputMaybe<Scalars['Int']['input']>
  parkingCapacity: Scalars['Int']['input']
  plannedBreaksAllowed?: InputMaybe<Scalars['Boolean']['input']>
  shortBreaksAllowed?: InputMaybe<Scalars['Boolean']['input']>
}

export type AreaDetails =
  | CooperationDetails
  | HubDetails
  | InFieldBreakDetails
  | ShortBreakDetails

export type AreaFilterInput = {
  keepOutZone?: InputMaybe<Scalars['Boolean']['input']>
  status?: InputMaybe<Array<SearchAreaStatus>>
  type?: InputMaybe<Array<SearchAreaType>>
}

export type AreaInput = {
  changeDescription?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  /** GeoJSON geometry object */
  geometry: Scalars['String']['input']
  keepOutZone?: InputMaybe<Scalars['Boolean']['input']>
  metadata: Array<MetadataStringInput>
  name?: InputMaybe<Scalars['String']['input']>
  navigationStopId?: InputMaybe<Scalars['String']['input']>
  type: AreaType
}

export type AreaLogRecord = ShiftStateLogRecord & {
  __typename?: 'AreaLogRecord'
  /** @deprecated Use ServiceBreakLocation instead */
  area: Maybe<Area>
  eventTime: Scalars['DateTime']['output']
  serviceBreakLocation: Maybe<ServiceBreakLocation>
  shiftId: Maybe<Scalars['ID']['output']>
  type: ShiftStateLogRecordType
  vehicleId: Scalars['ID']['output']
}

export enum AreaStatus {
  Active = 'Active',
  Expired = 'Expired',
  Inactive = 'Inactive',
  Scheduled = 'Scheduled',
}

export enum AreaType {
  ConstructionSite = 'ConstructionSite',
  Cooperation = 'Cooperation',
  Event = 'Event',
  Funding = 'Funding',
  Hub = 'Hub',
  InFieldBreak = 'InFieldBreak',
  Other = 'Other',
  Scouting = 'Scouting',
  ShortBreak = 'ShortBreak',
}

export type AreaUtilization = {
  __typename?: 'AreaUtilization'
  area: Area
  utilization: Scalars['Int']['output']
}

export type AssignCdisBoxToVehicleInput = {
  fleetVehicleId: Scalars['ID']['input']
  imei: Scalars['String']['input']
}

export type AssignRfidToCdisInput = {
  fleetVehicleId: Scalars['ID']['input']
  rfidTag: Scalars['String']['input']
}

export type AssignTabletToVehicleInput = {
  /** Set this to true if the tablet should be put in development MDM organization group (shouldn't get a prd/int MDM profile) */
  developmentMode?: InputMaybe<Scalars['Boolean']['input']>
  imei: Scalars['ID']['input']
  /** Set this to true if the tablet is a simulated tablet (not connected to the MDM) */
  isSimulated?: InputMaybe<Scalars['Boolean']['input']>
  phoneNumber?: InputMaybe<Scalars['String']['input']>
  vehicleId: Scalars['ID']['input']
}

/** A Cdis box that has reported for a vehicle and whose connection has been approved */
export type AssignedCdisBox = {
  __typename?: 'AssignedCdisBox'
  /** A unique serial number for identifying devices (International Mobile Equipment Identity) */
  imei: Scalars['String']['output']
  /** Timestamp at which the box was last updated */
  updatedAt: Scalars['Date']['output']
  /** A unique serial number for identifying vehicles (Vehicle Identification Number) */
  vin: Scalars['String']['output']
}

export type AssignedVtr = {
  __typename?: 'AssignedVtr'
  codebeamerIds: Array<Scalars['String']['output']>
  vtr: Scalars['String']['output']
}

export type AssignedVtrInput = {
  codebeamerIds: Array<Scalars['String']['input']>
  vtr: Scalars['String']['input']
}

export type AvailableVehiclesResponse = {
  __typename?: 'AvailableVehiclesResponse'
  vehicles: Array<Vehicle>
  vehiclesArePrioritized: Scalars['Boolean']['output']
}

export type BackofficeMetric = {
  dimensions: Array<BackofficeMetricDimension>
  name: Scalars['String']['input']
  unit?: InputMaybe<BackofficeMetricUnit>
  value: Scalars['Float']['input']
}

export type BackofficeMetricDimension = {
  name: Scalars['String']['input']
  value: Scalars['String']['input']
}

export type BackofficeMetricInput = {
  metadata: BackofficeMetricMetadata
  metrics: Array<BackofficeMetric>
  namespace?: InputMaybe<Scalars['String']['input']>
}

export type BackofficeMetricMetadata = {
  timestamp: Scalars['DateTime']['input']
  userAgent: Scalars['String']['input']
}

export enum BackofficeMetricUnit {
  Bits = 'BITS',
  BitsPerSecond = 'BITS_PER_SECOND',
  Bytes = 'BYTES',
  BytesPerSecond = 'BYTES_PER_SECOND',
  Count = 'COUNT',
  CountPerSecond = 'COUNT_PER_SECOND',
  Gigabits = 'GIGABITS',
  GigabitsPerSecond = 'GIGABITS_PER_SECOND',
  Gigabytes = 'GIGABYTES',
  GigabytesPerSecond = 'GIGABYTES_PER_SECOND',
  Kilobits = 'KILOBITS',
  KilobitsPerSecond = 'KILOBITS_PER_SECOND',
  Kilobytes = 'KILOBYTES',
  KilobytesPerSecond = 'KILOBYTES_PER_SECOND',
  Megabits = 'MEGABITS',
  MegabitsPerSecond = 'MEGABITS_PER_SECOND',
  Megabytes = 'MEGABYTES',
  MegabytesPerSecond = 'MEGABYTES_PER_SECOND',
  Microseconds = 'MICROSECONDS',
  Milliseconds = 'MILLISECONDS',
  None = 'NONE',
  Percent = 'PERCENT',
  Seconds = 'SECONDS',
  Terabits = 'TERABITS',
  TerabitsPerSecond = 'TERABITS_PER_SECOND',
  Terabytes = 'TERABYTES',
  TerabytesPerSecond = 'TERABYTES_PER_SECOND',
}

export type BackofficeOrganization = {
  __typename?: 'BackofficeOrganization'
  cognitoIdentityProviderName: Maybe<Scalars['String']['output']>
  customerTenants: Array<Scalars['String']['output']>
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  operatorTenants: Array<Scalars['String']['output']>
  ridepoolingServiceTenants: Array<Scalars['String']['output']>
  /**
   * Subdomain of the organization's Backoffice URL, e.g. `hochbahn` for
   * `hochbahn.backoffice.moia-group.io`. Readable by any authenticated Backoffice user.
   */
  subDomain: Scalars['String']['output']
}

export enum BackofficeSignInMethod {
  EmailPassword = 'EMAIL_PASSWORD',
  ExternalSso = 'EXTERNAL_SSO',
}

export enum BackofficeSignUpStatus {
  Completed = 'COMPLETED',
  ForceChangePassword = 'FORCE_CHANGE_PASSWORD',
  PendingExternalSsoLink = 'PENDING_EXTERNAL_SSO_LINK',
}

export type BackofficeStatus = {
  __typename?: 'BackofficeStatus'
  creationDate: Scalars['String']['output']
  id: Scalars['ID']['output']
  notes: Scalars['String']['output']
  organizations: Array<Scalars['String']['output']>
  title: Scalars['String']['output']
  type: BackofficeStatusType
}

export type BackofficeStatusCreate = {
  notes: Scalars['String']['input']
  organizations: Array<Scalars['String']['input']>
  title: Scalars['String']['input']
  type: BackofficeStatusType
}

export type BackofficeStatusDelete = {
  id: Scalars['ID']['input']
}

export type BackofficeStatusDeleteMediaByFileNameResponse = {
  __typename?: 'BackofficeStatusDeleteMediaByFileNameResponse'
  success: Scalars['Boolean']['output']
}

export type BackofficeStatusDeleteResponse = {
  __typename?: 'BackofficeStatusDeleteResponse'
  success: Scalars['Boolean']['output']
}

export enum BackofficeStatusType {
  InReview = 'IN_REVIEW',
  Open = 'OPEN',
  Resolved = 'RESOLVED',
}

export type BackofficeStatusUpdate = {
  creationDate: Scalars['String']['input']
  id: Scalars['ID']['input']
  notes: Scalars['String']['input']
  organizations: Array<Scalars['String']['input']>
  title: Scalars['String']['input']
  type: BackofficeStatusType
}

export type BackofficeStatusesLastVisitResponse = {
  __typename?: 'BackofficeStatusesLastVisitResponse'
  email: Scalars['String']['output']
  lastVisitDate: Scalars['String']['output']
}

export type BackofficeStatusesResponse = {
  __typename?: 'BackofficeStatusesResponse'
  statuses: Array<BackofficeStatus>
  total: Scalars['Int']['output']
}

export type BackofficeTimedUser = {
  __typename?: 'BackofficeTimedUser'
  expires: Maybe<Scalars['DateTime']['output']>
  user: BackofficeUserIdentity
}

export type BackofficeUpdate = {
  __typename?: 'BackofficeUpdate'
  creationDate: Scalars['String']['output']
  description: Scalars['String']['output']
  id: Scalars['ID']['output']
  images: Maybe<Array<Maybe<Scalars['String']['output']>>>
  link: Maybe<Scalars['String']['output']>
  organizations: Array<Scalars['String']['output']>
  title: Scalars['String']['output']
  type: BackofficeUpdateType
}

export type BackofficeUpdateCreate = {
  description: Scalars['String']['input']
  images?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  link?: InputMaybe<Scalars['String']['input']>
  organizations: Array<Scalars['String']['input']>
  title: Scalars['String']['input']
  type: BackofficeUpdateType
}

export type BackofficeUpdateDelete = {
  id: Scalars['ID']['input']
}

export type BackofficeUpdateDeleteResponse = {
  __typename?: 'BackofficeUpdateDeleteResponse'
  success: Scalars['Boolean']['output']
}

export type BackofficeUpdateFilePresignedResponse = {
  __typename?: 'BackofficeUpdateFilePresignedResponse'
  fileName: Scalars['String']['output']
  preSignedUrl: Scalars['String']['output']
}

export type BackofficeUpdateFilePresignedUrlInput = {
  contentType: Scalars['String']['input']
  fileName: Scalars['String']['input']
}

export type BackofficeUpdateGetMediaFilePresignedUrlInput = {
  fileName: Scalars['String']['input']
}

export enum BackofficeUpdateType {
  Deprecated = 'DEPRECATED',
  Improved = 'IMPROVED',
  New = 'NEW',
}

export type BackofficeUpdateUpdate = {
  creationDate: Scalars['String']['input']
  description: Scalars['String']['input']
  id: Scalars['ID']['input']
  images?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  link?: InputMaybe<Scalars['String']['input']>
  organizations: Array<Scalars['String']['input']>
  title: Scalars['String']['input']
  type: BackofficeUpdateType
}

export type BackofficeUpdatesLastVisitResponse = {
  __typename?: 'BackofficeUpdatesLastVisitResponse'
  email: Scalars['String']['output']
  lastVisitDate: Scalars['String']['output']
}

export type BackofficeUpdatesResponse = {
  __typename?: 'BackofficeUpdatesResponse'
  total: Scalars['Int']['output']
  updates: Array<BackofficeUpdate>
}

export type BackofficeUser = IBackofficeUserIdentity & {
  __typename?: 'BackofficeUser'
  adminPanelEnabled: Maybe<Scalars['Boolean']['output']>
  adminPanelOrganizations: Maybe<Array<Scalars['String']['output']>>
  /** TODO: Nastja make it required after all groups are migrated to Backoffice type */
  adminPanelTimedGroups: Maybe<Array<BackofficeUserTimeGroup>>
  allFleets: Scalars['Boolean']['output']
  backofficeEnabled: Maybe<Scalars['Boolean']['output']>
  cognitoUsername: Scalars['String']['output']
  createDate: Scalars['DateTime']['output']
  critical: Scalars['Boolean']['output']
  customerTenants: Maybe<Array<Scalars['String']['output']>>
  email: Scalars['String']['output']
  enabled: Scalars['Boolean']['output']
  firstName: Scalars['String']['output']
  fleets: Array<Scalars['String']['output']>
  /** Resolves `fleets` (IDs) to their full fleet objects. */
  fullFleets: Maybe<Array<BackofficeUserManagementFleet>>
  gdpr: Scalars['Boolean']['output']
  groupsApprover: Array<Scalars['String']['output']>
  id: Scalars['ID']['output']
  lastLoginDate: Maybe<Scalars['String']['output']>
  lastModifiedDate: Scalars['DateTime']['output']
  lastName: Scalars['String']['output']
  markedForDeletion: Maybe<Scalars['String']['output']>
  mfaActivated: Maybe<Scalars['Boolean']['output']>
  operatorTenants: Maybe<Array<Scalars['String']['output']>>
  organizationId: Scalars['String']['output']
  ridepoolingServiceTenants: Maybe<Array<Scalars['String']['output']>>
  signInMethod: BackofficeSignInMethod
  signUpStatus: BackofficeSignUpStatus
  /** @deprecated Use signInMethod instead */
  status: UserStatus
  systemUser: Scalars['Boolean']['output']
  timedGroups: Array<BackofficeUserTimeGroup>
  timedServiceAreas: Array<BackofficeUserTimeArea>
  userType: UserType
  username: Scalars['String']['output']
}

export type BackofficeUserIdentity = IBackofficeUserIdentity & {
  __typename?: 'BackofficeUserIdentity'
  email: Maybe<Scalars['String']['output']>
  firstName: Scalars['String']['output']
  id: Scalars['ID']['output']
  lastName: Scalars['String']['output']
  organizationId: Scalars['String']['output']
  username: Maybe<Scalars['String']['output']>
}

export type BackofficeUserInput = {
  adminPanelEnabled?: InputMaybe<Scalars['Boolean']['input']>
  adminPanelOrganizations?: InputMaybe<Array<Scalars['String']['input']>>
  adminPanelTimedGroups?: InputMaybe<Array<BackofficeUserTimeGroupInput>>
  allFleets: Scalars['Boolean']['input']
  backofficeEnabled?: InputMaybe<Scalars['Boolean']['input']>
  customerTenants?: InputMaybe<Array<Scalars['String']['input']>>
  firstName: Scalars['String']['input']
  fleets: Array<Scalars['String']['input']>
  groupsApprover: Array<Scalars['String']['input']>
  lastName: Scalars['String']['input']
  operatorTenants?: InputMaybe<Array<Scalars['String']['input']>>
  ridepoolingServiceTenants?: InputMaybe<Array<Scalars['String']['input']>>
  systemUser: Scalars['Boolean']['input']
  timedGroups: Array<BackofficeUserTimeGroupInput>
  timedServiceAreas: Array<BackofficeUserTimeAreaInput>
  userType: UserType
}

/**
 * Limited user view for cross-organization access.
 * Only exposes basic identity fields when viewing users from related organizations.
 */
export type BackofficeUserLimited = IBackofficeUserIdentity & {
  __typename?: 'BackofficeUserLimited'
  firstName: Scalars['String']['output']
  id: Scalars['ID']['output']
  lastName: Scalars['String']['output']
  organizationId: Scalars['String']['output']
}

export type BackofficeUserManagementAddUserToGroupInput = {
  expires?: InputMaybe<Scalars['String']['input']>
  groupName: Scalars['String']['input']
  notes: Scalars['String']['input']
  userId: Scalars['ID']['input']
}

export type BackofficeUserManagementCreateBackofficeGroupInput = {
  DEDescription: Scalars['String']['input']
  ENDescription: Scalars['String']['input']
  assignedOrganizations?: InputMaybe<Array<Scalars['String']['input']>>
  displayName: Scalars['String']['input']
  notes: Scalars['String']['input']
  rights?: InputMaybe<Array<Scalars['String']['input']>>
}

export type BackofficeUserManagementCreateBackofficeUserInput = {
  email: Scalars['String']['input']
  notes: Scalars['String']['input']
  organizationId?: InputMaybe<Scalars['String']['input']>
  signInMethod: BackofficeSignInMethod
  userData: BackofficeUserInput
}

export type BackofficeUserManagementDeleteBackofficeGroupInput = {
  name: Scalars['String']['input']
  notes: Scalars['String']['input']
}

export type BackofficeUserManagementDeleteBackofficeUserInput = {
  id: Scalars['ID']['input']
  notes: Scalars['String']['input']
}

export type BackofficeUserManagementDisableBackofficeUserInput = {
  id: Scalars['ID']['input']
}

export type BackofficeUserManagementEnableBackofficeUserInput = {
  id: Scalars['ID']['input']
}

export type BackofficeUserManagementFleet = {
  __typename?: 'BackofficeUserManagementFleet'
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  operatorTenant: Scalars['String']['output']
}

export type BackofficeUserManagementGroup = {
  __typename?: 'BackofficeUserManagementGroup'
  DEDescription: Maybe<Scalars['String']['output']>
  ENDescription: Maybe<Scalars['String']['output']>
  assignedOrganizations: Maybe<Array<Scalars['String']['output']>>
  critical: Scalars['Boolean']['output']
  displayName: Scalars['String']['output']
  gdpr: Scalars['Boolean']['output']
  name: Scalars['String']['output']
  rights: Maybe<Array<Scalars['String']['output']>>
  /** TODO: Nastja make it required after all groups are migrated to Backoffice type */
  type: Maybe<GroupType>
}

export type BackofficeUserManagementGroupExtended = {
  __typename?: 'BackofficeUserManagementGroupExtended'
  DEDescription: Maybe<Scalars['String']['output']>
  ENDescription: Maybe<Scalars['String']['output']>
  approvers: Array<BackofficeUserIdentity>
  assignedOrganizations: Array<Scalars['String']['output']>
  critical: Scalars['Boolean']['output']
  displayName: Scalars['String']['output']
  gdpr: Scalars['Boolean']['output']
  name: Scalars['String']['output']
  rights: Maybe<Array<Scalars['String']['output']>>
  users: Array<BackofficeTimedUser>
}

export type BackofficeUserManagementGroupHistory = {
  __typename?: 'BackofficeUserManagementGroupHistory'
  action: Scalars['String']['output']
  affectedAttribute: Scalars['String']['output']
  author: Scalars['String']['output']
  description: Scalars['String']['output']
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  notes: Scalars['String']['output']
  timestamp: Scalars['String']['output']
}

export type BackofficeUserManagementLogoutBackofficeUserInput = {
  id: Scalars['ID']['input']
}

export type BackofficeUserManagementRemoveUserFromGroupInput = {
  expires?: InputMaybe<Scalars['DateTime']['input']>
  groupName: Scalars['String']['input']
  notes: Scalars['String']['input']
  userId: Scalars['ID']['input']
}

export type BackofficeUserManagementResetMfaBackofficeUserInput = {
  id: Scalars['ID']['input']
}

/** Service area details stored by user-management for cross-organization display. */
export type BackofficeUserManagementServiceArea = {
  __typename?: 'BackofficeUserManagementServiceArea'
  /** The customer tenants assigned to this service area. */
  customerTenants: Array<Scalars['String']['output']>
  /** Localized display names for this service area. */
  displayNames: Scalars['DisplayNames']['output']
  /** Service area id. */
  id: Scalars['ID']['output']
  /** The operator tenants assigned to this service area. */
  operatorTenants: Array<Scalars['String']['output']>
  /** The ridepooling service tenant owning this service area. */
  ridepoolingServiceTenant: Scalars['String']['output']
  /**
   * Tenants this service area is assigned to.
   * @deprecated Use ridepoolingServiceTenant, customerTenants and operatorTenants instead.
   */
  tenants: Array<Scalars['String']['output']>
}

export type BackofficeUserManagementSwapGroupsInput = {
  /** @deprecated Use groupsList instead */
  groupName?: InputMaybe<Scalars['String']['input']>
  groupsList?: InputMaybe<Array<Scalars['String']['input']>>
}

export type BackofficeUserManagementUpdateBackofficeGroupInput = {
  DEDescription: Scalars['String']['input']
  ENDescription: Scalars['String']['input']
  assignedOrganizations?: InputMaybe<Array<Scalars['String']['input']>>
  displayName: Scalars['String']['input']
  name: Scalars['String']['input']
  notes: Scalars['String']['input']
  rights?: InputMaybe<Array<Scalars['String']['input']>>
}

export type BackofficeUserManagementUpdateBackofficeUserInput = {
  notes: Scalars['String']['input']
  userData: BackofficeUserInput
  userId: Scalars['ID']['input']
}

export type BackofficeUserManagementUserFormDetails = {
  __typename?: 'BackofficeUserManagementUserFormDetails'
  adminPanelGroups: Array<BackofficeUserManagementGroup>
  approvers: Array<BackofficeUserManagementGroup>
  customerTenants: Maybe<Array<Scalars['String']['output']>>
  fleets: Array<BackofficeUserManagementFleet>
  /** Service area details for display when available. */
  fullServiceAreas: Array<BackofficeUserManagementServiceArea>
  groups: Array<BackofficeUserManagementGroup>
  operatorTenants: Maybe<Array<Scalars['String']['output']>>
  ridepoolingServiceTenants: Maybe<Array<Scalars['String']['output']>>
  serviceAreaDetails: Array<Maybe<ServiceArea>>
  serviceAreas: Array<Scalars['String']['output']>
  userTypes: Array<UserType>
}

export type BackofficeUserManagementUserHistory = {
  __typename?: 'BackofficeUserManagementUserHistory'
  action: Scalars['String']['output']
  affectedAttribute: Scalars['String']['output']
  author: Scalars['String']['output']
  description: Scalars['String']['output']
  email: Scalars['String']['output']
  id: Scalars['ID']['output']
  notes: Scalars['String']['output']
  organization: Maybe<BackofficeOrganization>
  timestamp: Scalars['String']['output']
  userName: Scalars['String']['output']
}

export type BackofficeUserManagementUsersHistoryInput = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>
  startDate?: InputMaybe<Scalars['DateTime']['input']>
  tenants?: InputMaybe<Array<Scalars['String']['input']>>
}

/**
 * Union type for user queries that may return full or limited user data
 * based on the requesting user's organization relationship.
 */
export type BackofficeUserResult = BackofficeUser | BackofficeUserLimited

export type BackofficeUserTimeArea = {
  __typename?: 'BackofficeUserTimeArea'
  expires: Maybe<Scalars['DateTime']['output']>
  /** Service area details for display when available. */
  fullServiceArea: Maybe<BackofficeUserManagementServiceArea>
  serviceArea: Scalars['String']['output']
}

export type BackofficeUserTimeAreaInput = {
  expires?: InputMaybe<Scalars['DateTime']['input']>
  serviceArea: Scalars['String']['input']
}

export type BackofficeUserTimeGroup = {
  __typename?: 'BackofficeUserTimeGroup'
  displayName: Maybe<Scalars['String']['output']>
  expires: Maybe<Scalars['DateTime']['output']>
  groupName: Scalars['String']['output']
}

export type BackofficeUserTimeGroupInput = {
  expires?: InputMaybe<Scalars['DateTime']['input']>
  groupName: Scalars['String']['input']
}

export type BookingTimeSlot = {
  __typename?: 'BookingTimeSlot'
  bookedCount: Scalars['Int']['output']
  end: Scalars['DateTime']['output']
  maxCapacity: Scalars['Int']['output']
  serviceBreakLocationId: Scalars['ID']['output']
  start: Scalars['DateTime']['output']
  updatedAt: Scalars['DateTime']['output']
  vehicleIds: Array<Scalars['ID']['output']>
  version: Scalars['Int']['output']
}

export type BookingTimeSlotsInput = {
  end: Scalars['DateTime']['input']
  serviceBreakLocationId: Scalars['ID']['input']
  start: Scalars['DateTime']['input']
}

export type BookingTimeSlotsResponse = {
  __typename?: 'BookingTimeSlotsResponse'
  timeSlots: Array<BookingTimeSlot>
}

export type BoundingBox = {
  __typename?: 'BoundingBox'
  maxLat: Scalars['Float']['output']
  maxLon: Scalars['Float']['output']
  minLat: Scalars['Float']['output']
  minLon: Scalars['Float']['output']
}

export type BoundingBoxFilterInput = {
  maxLat: Scalars['Float']['input']
  maxLon: Scalars['Float']['input']
  minLat: Scalars['Float']['input']
  minLon: Scalars['Float']['input']
}

export type BoxPc = {
  __typename?: 'BoxPc'
  artifactName: Maybe<Scalars['String']['output']>
  cpuId: Scalars['ID']['output']
  /** @deprecated We are moving away from Greengrass */
  greengrassDeviceId: Scalars['String']['output']
  /** @deprecated We are moving away from Greengrass */
  greengrassProvisioningState: Maybe<GreengrassProvisioningState>
  macAddr: Scalars['String']['output']
  provisioningState: ProvisioningState
}

export type BoxPcReplacedChange = FleetEntityChange & {
  __typename?: 'BoxPcReplacedChange'
  backofficeUser: Maybe<BackofficeUser>
  changedAt: Scalars['DateTime']['output']
  changes: BoxPcReplacedChangeFields
}

export type BoxPcReplacedChangeFields = VehicleChangeFields & {
  __typename?: 'BoxPcReplacedChangeFields'
  boxPcNew: Maybe<BoxPc>
  boxPcOld: Maybe<BoxPc>
  vehicleID: Scalars['ID']['output']
}

export type BoxPcWipedChange = FleetEntityChange & {
  __typename?: 'BoxPcWipedChange'
  backofficeUser: Maybe<BackofficeUser>
  changedAt: Scalars['DateTime']['output']
  changes: BoxPcWipedChangeFields
}

export type BoxPcWipedChangeFields = VehicleChangeFields & {
  __typename?: 'BoxPcWipedChangeFields'
  boxPcWiped: Maybe<BoxPc>
  vehicleID: Scalars['ID']['output']
}

export type BulkStopDeleteError = {
  __typename?: 'BulkStopDeleteError'
  code: Scalars['String']['output']
  displayNames: Maybe<Scalars['DisplayNames']['output']>
  stopId: Scalars['String']['output']
}

export type BulkStopUpdateError = {
  __typename?: 'BulkStopUpdateError'
  code: Scalars['String']['output']
  displayNames: Maybe<Scalars['DisplayNames']['output']>
  stopId: Scalars['String']['output']
}

export type BulkStopUpdateInput = {
  excludeFromReallocations?: InputMaybe<Scalars['Boolean']['input']>
  flagsToAdd?: InputMaybe<Array<StopFlag>>
  flagsToRemove?: InputMaybe<Array<StopFlag>>
  stopType?: InputMaybe<StopType>
}

export type BulkStopUpdateResult = {
  __typename?: 'BulkStopUpdateResult'
  failed: Array<BulkStopUpdateError>
  successful: Array<BulkStopUpdateSuccess>
}

export type BulkStopUpdateSuccess = {
  __typename?: 'BulkStopUpdateSuccess'
  displayNames: Maybe<Scalars['DisplayNames']['output']>
  stopId: Scalars['String']['output']
}

export enum CdisError {
  ErrorBatteryLevelLow = 'ERROR_BATTERY_LEVEL_LOW',
  ErrorBonnetOpen = 'ERROR_BONNET_OPEN',
  ErrorCanBusActive = 'ERROR_CAN_BUS_ACTIVE',
  ErrorClamp_15On = 'ERROR_CLAMP_15_ON',
  ErrorClampSOn = 'ERROR_CLAMP_S_ON',
  ErrorClimateControlTimeout = 'ERROR_CLIMATE_CONTROL_TIMEOUT',
  ErrorConvertibleRoofOpen = 'ERROR_CONVERTIBLE_ROOF_OPEN',
  ErrorEngineOn = 'ERROR_ENGINE_ON',
  ErrorFrontDriverSideDoorOpen = 'ERROR_FRONT_DRIVER_SIDE_DOOR_OPEN',
  ErrorFrontDriverSideWindowOpen = 'ERROR_FRONT_DRIVER_SIDE_WINDOW_OPEN',
  ErrorFrontPassengerSideDoorOpen = 'ERROR_FRONT_PASSENGER_SIDE_DOOR_OPEN',
  ErrorFrontPassengerSideWindowOpen = 'ERROR_FRONT_PASSENGER_SIDE_WINDOW_OPEN',
  ErrorLightsOn = 'ERROR_LIGHTS_ON',
  ErrorMissingChargingCable = 'ERROR_MISSING_CHARGING_CABLE',
  ErrorMissingRfid1 = 'ERROR_MISSING_RFID1',
  ErrorNoCdisBoxAssigned = 'ERROR_NO_CDIS_BOX_ASSIGNED',
  ErrorRearDriverSideDoorOpen = 'ERROR_REAR_DRIVER_SIDE_DOOR_OPEN',
  ErrorRearDriverSideWindowOpen = 'ERROR_REAR_DRIVER_SIDE_WINDOW_OPEN',
  ErrorRearPassengerSideDoorOpen = 'ERROR_REAR_PASSENGER_SIDE_DOOR_OPEN',
  ErrorRearPassengerSideWindowOpen = 'ERROR_REAR_PASSENGER_SIDE_WINDOW_OPEN',
  ErrorRequestTooOld = 'ERROR_REQUEST_TOO_OLD',
  ErrorShutdownTimeOutOfRange = 'ERROR_SHUTDOWN_TIME_OUT_OF_RANGE',
  ErrorSunRoofOpen = 'ERROR_SUN_ROOF_OPEN',
  ErrorTimeoutWaitingForCentralLocking = 'ERROR_TIMEOUT_WAITING_FOR_CENTRAL_LOCKING',
  ErrorTrunkOpen = 'ERROR_TRUNK_OPEN',
  ErrorUnknown = 'ERROR_UNKNOWN',
  ErrorVehicleIsMoving = 'ERROR_VEHICLE_IS_MOVING',
  None = 'NONE',
}

export type Camera = {
  __typename?: 'Camera'
  macAddr: Scalars['ID']['output']
  serialNumber: Maybe<Scalars['String']['output']>
}

export type CameraReplacedChange = FleetEntityChange & {
  __typename?: 'CameraReplacedChange'
  backofficeUser: Maybe<BackofficeUser>
  changedAt: Scalars['DateTime']['output']
  changes: CameraReplacedChangeFields
}

export type CameraReplacedChangeFields = VehicleChangeFields & {
  __typename?: 'CameraReplacedChangeFields'
  cameraNew: Maybe<Camera>
  cameraOld: Maybe<Camera>
  vehicleID: Scalars['ID']['output']
}

export type Campaign = {
  __typename?: 'Campaign'
  approvals: Maybe<CampaignApprovals>
  createdAt: Scalars['DateTime']['output']
  createdBy: Scalars['String']['output']
  dataplatformUsecaseId: Maybe<Scalars['String']['output']>
  dcomOrderId: Maybe<Scalars['Int']['output']>
  description: Maybe<Scalars['String']['output']>
  endDate: Scalars['DateTime']['output']
  gdcOrderId: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  legallyRelevant: Maybe<CampaignLegalRelevance>
  name: Scalars['String']['output']
  startDate: Scalars['DateTime']['output']
  state: CampaignState
  triggerEntries: Array<CampaignTriggerEntry>
  updatedAt: Scalars['DateTime']['output']
  updatedBy: Scalars['String']['output']
  validationReport: Maybe<CampaignValidationReport>
}

export type CampaignApproval = {
  __typename?: 'CampaignApproval'
  state: CampaignApprovalState
  updatedAt: Maybe<Scalars['DateTime']['output']>
  updatedBy: Maybe<Scalars['String']['output']>
}

export enum CampaignApprovalState {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
}

export enum CampaignApprovalType {
  Financial = 'FINANCIAL',
  Legal = 'LEGAL',
  Technical = 'TECHNICAL',
}

export type CampaignApprovalUpdateInput = {
  campaignId: Scalars['ID']['input']
  state: CampaignApprovalState
  type: CampaignApprovalType
}

export type CampaignApprovalUpdateResponse = CampaignStateTransitionResponse & {
  __typename?: 'CampaignApprovalUpdateResponse'
  campaignId: Scalars['ID']['output']
  errors: Array<Scalars['String']['output']>
  status: CampaignTransitionStatus
}

export type CampaignApprovals = {
  __typename?: 'CampaignApprovals'
  financial: CampaignApproval
  legal: CampaignApproval
  technical: CampaignApproval
}

export type CampaignCollectionSignal = {
  __typename?: 'CampaignCollectionSignal'
  signalName: Scalars['String']['output']
  signalPriority: Maybe<Scalars['Int']['output']>
  signalSamplingRate: Maybe<Scalars['String']['output']>
}

export type CampaignCollectionSignalInput = {
  signalName: Scalars['String']['input']
  signalPriority?: InputMaybe<Scalars['Int']['input']>
  signalSamplingRate?: InputMaybe<Scalars['String']['input']>
}

export enum CampaignConfigPurpose {
  B2BMarketingCampaign = 'B2B_MARKETING_CAMPAIGN',
  B2CMarketingCampaign = 'B2C_MARKETING_CAMPAIGN',
  Barter = 'BARTER',
  Experiment = 'EXPERIMENT',
  Pricing = 'PRICING',
}

/** Campaign Management Input Types */
export type CampaignCreateInput = {
  description?: InputMaybe<Scalars['String']['input']>
  endDate: Scalars['DateTime']['input']
  name: Scalars['String']['input']
  startDate: Scalars['DateTime']['input']
}

export type CampaignCreateResponse = {
  __typename?: 'CampaignCreateResponse'
  campaign: Campaign
}

export type CampaignFleet = {
  __typename?: 'CampaignFleet'
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  regionId: Scalars['ID']['output']
  state: Maybe<Scalars['String']['output']>
}

export type CampaignFleetsResponse = ListResponse & {
  __typename?: 'CampaignFleetsResponse'
  items: Array<CampaignFleet>
  total: Scalars['Int']['output']
}

export type CampaignHistoryEntry = {
  __typename?: 'CampaignHistoryEntry'
  createdAt: Scalars['DateTime']['output']
  event: Scalars['String']['output']
  user: Scalars['String']['output']
}

export type CampaignHistoryQueryInput = {
  campaignId: Scalars['ID']['input']
  cursor?: InputMaybe<Scalars['ID']['input']>
  limit: Scalars['Int']['input']
}

export type CampaignHistoryResponse = CursorListResponse & {
  __typename?: 'CampaignHistoryResponse'
  items: Array<CampaignHistoryEntry>
  nextCursor: Maybe<Scalars['ID']['output']>
  total: Maybe<Scalars['Int']['output']>
}

export enum CampaignLegalRelevance {
  Ism = 'ISM',
  No = 'NO',
}

export type CampaignSendBackToDraftInput = {
  campaignId: Scalars['ID']['input']
}

export type CampaignSendBackToDraftResponse =
  CampaignStateTransitionResponse & {
    __typename?: 'CampaignSendBackToDraftResponse'
    campaignId: Scalars['ID']['output']
    errors: Array<Scalars['String']['output']>
    status: CampaignTransitionStatus
  }

export type CampaignSendForApprovalInput = {
  campaignId: Scalars['ID']['input']
}

export type CampaignSendForApprovalResponse =
  CampaignStateTransitionResponse & {
    __typename?: 'CampaignSendForApprovalResponse'
    campaignId: Scalars['ID']['output']
    errors: Array<Scalars['String']['output']>
    status: CampaignTransitionStatus
  }

export type CampaignSensor = {
  __typename?: 'CampaignSensor'
  name: Scalars['String']['output']
}

export type CampaignSensorsResponse = ListResponse & {
  __typename?: 'CampaignSensorsResponse'
  items: Array<CampaignSensor>
  total: Scalars['Int']['output']
}

export type CampaignService = {
  __typename?: 'CampaignService'
  name: Scalars['String']['output']
  resources: Array<CampaignServiceResource>
}

export type CampaignServiceProperty = {
  __typename?: 'CampaignServiceProperty'
  description: Maybe<Scalars['String']['output']>
  name: Scalars['String']['output']
  properties: Maybe<Array<CampaignServiceProperty>>
  type: Maybe<Scalars['String']['output']>
}

export type CampaignServiceResource = {
  __typename?: 'CampaignServiceResource'
  name: Scalars['String']['output']
  properties: Array<CampaignServiceProperty>
}

export type CampaignServicesResponse = ListResponse & {
  __typename?: 'CampaignServicesResponse'
  items: Array<CampaignService>
  total: Scalars['Int']['output']
}

export type CampaignSignal = {
  __typename?: 'CampaignSignal'
  collection: Scalars['Boolean']['output']
  description: Maybe<Scalars['String']['output']>
  metadata: Maybe<CampaignSignalMetadata>
  name: Scalars['String']['output']
  source: CampaignSignalSource
  trigger: Scalars['Boolean']['output']
}

export type CampaignSignalMetadata = {
  __typename?: 'CampaignSignalMetadata'
  category: Maybe<Scalars['String']['output']>
  scales: Array<CampaignSignalScale>
  unit: Maybe<Scalars['String']['output']>
}

export type CampaignSignalScale = {
  __typename?: 'CampaignSignalScale'
  denominator: Maybe<Array<Scalars['Float']['output']>>
  description: Maybe<Scalars['String']['output']>
  lowerLimit: Scalars['Float']['output']
  numerator: Maybe<Array<Scalars['Float']['output']>>
  physicalMax: Maybe<Scalars['Float']['output']>
  physicalMin: Maybe<Scalars['Float']['output']>
  text: Maybe<Scalars['String']['output']>
  type: Scalars['String']['output']
  upperLimit: Scalars['Float']['output']
}

export enum CampaignSignalSource {
  Arxml = 'ARXML',
  Platform = 'PLATFORM',
}

export type CampaignSignalsResponse = ListResponse & {
  __typename?: 'CampaignSignalsResponse'
  items: Array<CampaignSignal>
  total: Scalars['Int']['output']
}

export type CampaignStartTestInput = {
  campaignId: Scalars['ID']['input']
}

export type CampaignStartTestResponse = CampaignStateTransitionResponse & {
  __typename?: 'CampaignStartTestResponse'
  campaignId: Scalars['ID']['output']
  correlationId: Scalars['ID']['output']
  errors: Array<Scalars['String']['output']>
  status: CampaignTransitionStatus
}

export enum CampaignState {
  Active = 'ACTIVE',
  ApprovalPending = 'APPROVAL_PENDING',
  Approved = 'APPROVED',
  Draft = 'DRAFT',
  Rejected = 'REJECTED',
  StartingTest = 'STARTING_TEST',
  StartingTestFailed = 'STARTING_TEST_FAILED',
  Stopped = 'STOPPED',
  StoppingTest = 'STOPPING_TEST',
  StoppingTestFailed = 'STOPPING_TEST_FAILED',
  Tested = 'TESTED',
  Testing = 'TESTING',
  Valid = 'VALID',
  ValidationFailed = 'VALIDATION_FAILED',
  ValidationInProgress = 'VALIDATION_IN_PROGRESS',
}

export type CampaignStateTransitionResponse = {
  campaignId: Scalars['ID']['output']
  errors: Array<Scalars['String']['output']>
  status: CampaignTransitionStatus
}

export type CampaignStopInput = {
  campaignId: Scalars['ID']['input']
}

export type CampaignStopResponse = CampaignStateTransitionResponse & {
  __typename?: 'CampaignStopResponse'
  campaignId: Scalars['ID']['output']
  errors: Array<Scalars['String']['output']>
  status: CampaignTransitionStatus
}

export type CampaignStopTestInput = {
  campaignId: Scalars['ID']['input']
}

export type CampaignStopTestResponse = CampaignStateTransitionResponse & {
  __typename?: 'CampaignStopTestResponse'
  campaignId: Scalars['ID']['output']
  correlationId: Scalars['ID']['output']
  errors: Array<Scalars['String']['output']>
  status: CampaignTransitionStatus
}

export type CampaignSummary = {
  __typename?: 'CampaignSummary'
  createdAt: Scalars['DateTime']['output']
  createdBy: Scalars['String']['output']
  description: Maybe<Scalars['String']['output']>
  endDate: Scalars['DateTime']['output']
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  startDate: Scalars['DateTime']['output']
  state: CampaignState
  updatedAt: Scalars['DateTime']['output']
  updatedBy: Scalars['String']['output']
}

export enum CampaignTransitionStatus {
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Ok = 'OK',
}

export type CampaignTriggerEntry = {
  __typename?: 'CampaignTriggerEntry'
  collectionSignals: Array<CampaignCollectionSignal>
  dataExtraction: Maybe<Scalars['Int']['output']>
  name: Scalars['String']['output']
  postEventTime: Maybe<Scalars['Int']['output']>
  preEventTime: Maybe<Scalars['Int']['output']>
  sdsRawData: Maybe<Scalars['Int']['output']>
  triggerLogic: Maybe<Scalars['String']['output']>
  triggerLogicStop: Maybe<Scalars['String']['output']>
  triggerSignals: Array<CampaignTriggerSignal>
}

export type CampaignTriggerEntryInput = {
  collectionSignals: Array<CampaignCollectionSignalInput>
  dataExtraction?: InputMaybe<Scalars['Int']['input']>
  name: Scalars['String']['input']
  postEventTime?: InputMaybe<Scalars['Int']['input']>
  preEventTime?: InputMaybe<Scalars['Int']['input']>
  sdsRawData?: InputMaybe<Scalars['Int']['input']>
  triggerLogic?: InputMaybe<Scalars['String']['input']>
  triggerLogicStop?: InputMaybe<Scalars['String']['input']>
  triggerSignals: Array<CampaignTriggerSignalInput>
}

export type CampaignTriggerSignal = {
  __typename?: 'CampaignTriggerSignal'
  signalName: Scalars['String']['output']
}

export type CampaignTriggerSignalInput = {
  signalName: Scalars['String']['input']
}

export type CampaignUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>
  endDate?: InputMaybe<Scalars['DateTime']['input']>
  id: Scalars['ID']['input']
  legallyRelevant?: InputMaybe<CampaignLegalRelevance>
  name?: InputMaybe<Scalars['String']['input']>
  startDate?: InputMaybe<Scalars['DateTime']['input']>
  triggerEntries?: InputMaybe<Array<CampaignTriggerEntryInput>>
}

export type CampaignUpdateResponse = {
  __typename?: 'CampaignUpdateResponse'
  campaign: Campaign
}

export type CampaignValidateInput = {
  campaignId: Scalars['ID']['input']
}

export type CampaignValidateResponse = CampaignStateTransitionResponse & {
  __typename?: 'CampaignValidateResponse'
  campaignId: Scalars['ID']['output']
  correlationId: Scalars['ID']['output']
  errors: Array<Scalars['String']['output']>
  status: CampaignTransitionStatus
}

export type CampaignValidationMessage = {
  __typename?: 'CampaignValidationMessage'
  message: Scalars['String']['output']
}

export type CampaignValidationReport = {
  __typename?: 'CampaignValidationReport'
  correlationId: Scalars['ID']['output']
  createdAt: Scalars['DateTime']['output']
  messages: Maybe<Array<CampaignValidationMessage>>
}

export type CampaignVehicle = {
  __typename?: 'CampaignVehicle'
  fleetId: Maybe<Scalars['ID']['output']>
  id: Scalars['ID']['output']
  label: Maybe<Scalars['Int']['output']>
  licensePlate: Maybe<Scalars['String']['output']>
  regionId: Maybe<Scalars['ID']['output']>
  sdsProvider: Maybe<Scalars['String']['output']>
  state: Maybe<Scalars['String']['output']>
  vehicleType: Maybe<Scalars['String']['output']>
  vin: Scalars['String']['output']
}

export type CampaignVehicleSelectionResponse = ListResponse & {
  __typename?: 'CampaignVehicleSelectionResponse'
  items: Array<Scalars['String']['output']>
  total: Scalars['Int']['output']
}

export type CampaignVehicleSelectionUpdateInput = {
  campaignId: Scalars['ID']['input']
  vins: Array<Scalars['String']['input']>
}

export type CampaignVehicleSelectionUpdateResponse = {
  __typename?: 'CampaignVehicleSelectionUpdateResponse'
  campaignId: Scalars['ID']['output']
  vins: Array<Scalars['String']['output']>
}

export type CampaignVehiclesQueryInput = {
  cursor?: InputMaybe<Scalars['ID']['input']>
  fleetId?: InputMaybe<Scalars['ID']['input']>
  limit: Scalars['Int']['input']
}

export type CampaignVehiclesResponse = CursorListResponse & {
  __typename?: 'CampaignVehiclesResponse'
  items: Array<CampaignVehicle>
  nextCursor: Maybe<Scalars['ID']['output']>
  total: Maybe<Scalars['Int']['output']>
}

export type CampaignsQueryResponse = CursorListResponse & {
  __typename?: 'CampaignsQueryResponse'
  items: Array<CampaignSummary>
  nextCursor: Maybe<Scalars['ID']['output']>
  total: Maybe<Scalars['Int']['output']>
}

export enum CancelationReason {
  CancelationReasonCantFindVehicle = 'CANCELATION_REASON_CANT_FIND_VEHICLE',
  CancelationReasonDrivingWrongWay = 'CANCELATION_REASON_DRIVING_WRONG_WAY',
  CancelationReasonEarlyDropoff = 'CANCELATION_REASON_EARLY_DROPOFF',
  CancelationReasonEmployeeRequest = 'CANCELATION_REASON_EMPLOYEE_REQUEST',
  CancelationReasonHighEta = 'CANCELATION_REASON_HIGH_ETA',
  CancelationReasonInvalid = 'CANCELATION_REASON_INVALID',
  CancelationReasonNeedToEdit = 'CANCELATION_REASON_NEED_TO_EDIT',
  CancelationReasonNoLongerNeed = 'CANCELATION_REASON_NO_LONGER_NEED',
  CancelationReasonNoShow = 'CANCELATION_REASON_NO_SHOW',
  CancelationReasonOther = 'CANCELATION_REASON_OTHER',
  CancelationReasonPickupTimeout = 'CANCELATION_REASON_PICKUP_TIMEOUT',
  CancelationReasonRiderNotReady = 'CANCELATION_REASON_RIDER_NOT_READY',
  CancelationReasonTesting = 'CANCELATION_REASON_TESTING',
  CancelationReasonTroubleshooting = 'CANCELATION_REASON_TROUBLESHOOTING',
  CancelationReasonUncomfortable = 'CANCELATION_REASON_UNCOMFORTABLE',
  CancelationReasonWrongDropoffLocation = 'CANCELATION_REASON_WRONG_DROPOFF_LOCATION',
}

export enum CancellationType {
  CustomerCanceled = 'CUSTOMER_CANCELED',
  CustomerNotShown = 'CUSTOMER_NOT_SHOWN',
  None = 'NONE',
  VehicleServiceAbortion = 'VEHICLE_SERVICE_ABORTION',
}

/** A claim describing how one capacity type occupies space from another. */
export type CapacityClaim = {
  __typename?: 'CapacityClaim'
  /** The number of units claimed. */
  count: Scalars['Int']['output']
  /** The key that claims space. */
  sourceKey: CapacityKey
  /** The capacity type that loses space. */
  targetKey: CapacityTypeKey
}

/** Input for defining a capacity claim. */
export type CapacityClaimInput = {
  /** The number of units claimed. */
  count: Scalars['Int']['input']
  /** The key that claims space — either a capacity type or a convertible type. */
  sourceKey: CapacityKeyInput
  /** The capacity type that loses space. */
  targetKey: CapacityTypeKey
}

/** Input for setting vehicle-level capacity overrides. */
export type CapacityConfigVehicleOverridesInput = {
  overrides: Array<CapacityVehicleOverrideInput>
  vehicleId: Scalars['ID']['input']
}

/**
 * A key that identifies either a capacity type or a convertible type.
 * Exactly one of the two fields must be set.
 */
export type CapacityKey = {
  __typename?: 'CapacityKey'
  /** The capacity type key, if this claim key refers to a capacity type. */
  capacityType: Maybe<CapacityTypeKey>
  /** The convertible type key, if this claim key refers to a convertible type. */
  convertibleType: Maybe<ConvertibleTypeKey>
}

/** Input for identifying a capacity key — exactly one of capacity_type or convertible_type must be set. */
export type CapacityKeyInput = {
  /** The capacity type key, if this key refers to a capacity type. */
  capacityType?: InputMaybe<CapacityTypeKey>
  /** The convertible type key, if this key refers to a convertible type. */
  convertibleType?: InputMaybe<ConvertibleTypeKey>
}

/** A vehicle-level override for a single capacity type or convertible type. */
export type CapacityOverride = {
  __typename?: 'CapacityOverride'
  /** The overridden count. */
  count: Scalars['Int']['output']
  /** The capacity type or convertible type key being overridden. */
  key: CapacityKey
}

/** A single capacity entry for a vehicle configuration. */
export type CapacityType = {
  __typename?: 'CapacityType'
  /** Optional reference to a convertible type that this capacity type uses. */
  convertibleTypeKey: Maybe<ConvertibleTypeKey>
  /** The number of units available for this capacity type. */
  count: Scalars['Int']['output']
  /** The type of capacity this entry represents. */
  key: CapacityTypeKey
}

/** Input for defining a capacity entry on a vehicle configuration. */
export type CapacityTypeInput = {
  /** Optional reference to a convertible type that this capacity type uses. */
  convertibleTypeKey?: InputMaybe<ConvertibleTypeKey>
  /** The number of units available for this capacity type. */
  count: Scalars['Int']['input']
  /** The type of capacity this entry represents. */
  key: CapacityTypeKey
}

export enum CapacityTypeKey {
  BoosterSeat = 'BOOSTER_SEAT',
  ChildSeat = 'CHILD_SEAT',
  FoldableSeat = 'FOLDABLE_SEAT',
  LargeLuggage = 'LARGE_LUGGAGE',
  ServiceAnimal = 'SERVICE_ANIMAL',
  StandardSeat = 'STANDARD_SEAT',
  StandingSpace = 'STANDING_SPACE',
  Wheelchair = 'WHEELCHAIR',
}

/** Input for setting a capacity override on a specific vehicle. */
export type CapacityVehicleOverrideInput = {
  /** The overridden count. Must be less than or equal to the base count on the capacity config. */
  count: Scalars['Int']['input']
  /** The capacity type or convertible type key to override. */
  key: CapacityKeyInput
}

export type CardData = {
  __typename?: 'CardData'
  cardType: Maybe<Scalars['String']['output']>
  last4Digits: Maybe<Scalars['String']['output']>
}

export type CbPreview = {
  __typename?: 'CbPreview'
  codebeamerTestcaseId: Scalars['String']['output']
  fleetTarget: Scalars['String']['output']
  location: Scalars['String']['output']
  modifiedBy: Scalars['String']['output']
  numUniqueElements: Scalars['Int']['output']
  oddElementTypes: Array<Scalars['String']['output']>
  parent: Scalars['String']['output']
  status: Scalars['String']['output']
  submittedBy: Scalars['String']['output']
  targetConstraints: Scalars['String']['output']
  targetNumPerElement: Scalars['Int']['output']
  targetUnit: Scalars['String']['output']
  taxonomies: Array<Scalars['String']['output']>
  tracker: Scalars['String']['output']
  type: Scalars['String']['output']
}

export type Cdis = {
  __typename?: 'Cdis'
  /** Imei which identifies the CDIS Box. */
  imei: Scalars['String']['output']
  /** [Optional] Imsi which is associated with the SimCard of the CDIS Box. */
  imsi: Maybe<Scalars['String']['output']>
  /** [Optional] The assigned RFID Tag from a physical key of the vehicle. */
  rfid: Maybe<Scalars['String']['output']>
  /** Timestamp at which the box was last updated */
  updatedAt: Scalars['Date']['output']
}

export type CdisBox = {
  __typename?: 'CdisBox'
  imei: Scalars['ID']['output']
  imsi: Scalars['String']['output']
  macAddr: Scalars['String']['output']
  serialNumber: Scalars['String']['output']
}

export type CdisBoxReplacedChange = FleetEntityChange & {
  __typename?: 'CdisBoxReplacedChange'
  backofficeUser: Maybe<BackofficeUser>
  changedAt: Scalars['DateTime']['output']
  changes: CdisBoxReplacedChangeFields
}

export type CdisBoxReplacedChangeFields = VehicleChangeFields & {
  __typename?: 'CdisBoxReplacedChangeFields'
  cdisBoxNew: Maybe<CdisBox>
  cdisBoxOld: Maybe<CdisBox>
  vehicleID: Scalars['ID']['output']
}

export enum CentralLockState {
  Locked = 'LOCKED',
  Unlocked = 'UNLOCKED',
}

export enum ChangeEventOperation {
  Created = 'CREATED',
  Deleted = 'DELETED',
  Updated = 'UPDATED',
}

export enum ChargingMode {
  Ac = 'AC',
  Dc = 'DC',
  Off = 'OFF',
}

export type CheckpointProgress = {
  __typename?: 'CheckpointProgress'
  checkpointDistanceFromStart: Scalars['Float']['output']
  location: Maybe<TripGeolocation>
  oddElementType: TripOddElementType
  segmentId: Scalars['String']['output']
  sequenceId: Scalars['Int']['output']
  status: CheckpointProgressStatus
}

export enum CheckpointProgressStatus {
  CheckpointProgressStatusCompleted = 'CHECKPOINT_PROGRESS_STATUS_COMPLETED',
  CheckpointProgressStatusInvalid = 'CHECKPOINT_PROGRESS_STATUS_INVALID',
  CheckpointProgressStatusInProgress = 'CHECKPOINT_PROGRESS_STATUS_IN_PROGRESS',
  CheckpointProgressStatusInQueue = 'CHECKPOINT_PROGRESS_STATUS_IN_QUEUE',
  CheckpointProgressStatusSkipped = 'CHECKPOINT_PROGRESS_STATUS_SKIPPED',
}

export type ChildAge = {
  __typename?: 'ChildAge'
  max: Scalars['Int']['output']
  min: Scalars['Int']['output']
}

export type ChildAgeInput = {
  max: Scalars['Int']['input']
  min: Scalars['Int']['input']
}

export type ChildrenPricing = {
  __typename?: 'ChildrenPricing'
  accompaniedChildrenFree: Scalars['Boolean']['output']
  accompaniedChildrenFreeDisplayText: Maybe<Array<PriceConfigDisplayText>>
  unaccompaniedChildrenDiscount: Scalars['Float']['output']
  unaccompaniedChildrenDiscountDisplayText: Maybe<Array<PriceConfigDisplayText>>
}

export type ChildrenPricingInput = {
  accompaniedChildrenFree: Scalars['Boolean']['input']
  accompaniedChildrenFreeDisplayText?: InputMaybe<
    Array<PriceConfigDisplayTextInput>
  >
  unaccompaniedChildrenDiscount: Scalars['Float']['input']
  unaccompaniedChildrenDiscountDisplayText?: InputMaybe<
    Array<PriceConfigDisplayTextInput>
  >
}

export enum ClimateControlState {
  Cooling = 'COOLING',
  Heating = 'HEATING',
  Off = 'OFF',
}

export type CloseTemporaryBackofficeSessionInput = {
  /**
   * Manual description of the customer data changes made during the session.
   * Required when customerDataModified is true.
   */
  closureNotes?: InputMaybe<Scalars['String']['input']>
  /** Whether the actor modified customer data during this session. */
  customerDataModified: Scalars['Boolean']['input']
  sessionId: Scalars['ID']['input']
}

export type CloseVehicleByBackofficeUserInput = {
  isBatchInteraction: Scalars['Boolean']['input']
  vehicleID: Scalars['ID']['input']
}

/** The CLOSE interaction looks up the matching OPEN interaction and takes all data from there */
export type CloseVehicleInput = {
  vehicleID: Scalars['ID']['input']
}

export type ClosestHubResponse = {
  __typename?: 'ClosestHubResponse'
  hub: Hub
}

export type ConfigOption = {
  __typename?: 'ConfigOption'
  id: Scalars['String']['output']
  name: Scalars['String']['output']
}

export type ConfigQueryResponse = {
  __typename?: 'ConfigQueryResponse'
  bucketConnection: Array<ConfigOption>
  correspondingFeatures: Array<ConfigOption>
  correspondingScenario: Array<ConfigOption>
  correspondingTriggering: Array<ConfigOption>
  egoManoeuvre: Array<ConfigOption>
  environmentConditions: Array<ConfigOption>
  eventTag: Array<ConfigOption>
  failedRequirements: Array<ConfigOption>
  jiraTicket: Array<ConfigOption>
  rcRoute: Array<ConfigOption>
  rcRun: Array<ConfigOption>
  relevantOdd: Array<ConfigOption>
  testEnvironment: Array<ConfigOption>
  testcase: Array<ConfigOption>
  vnvConfirmation: Array<ConfigOption>
}

export type ConfirmTripSegmentResult = {
  __typename?: 'ConfirmTripSegmentResult'
  errorMessage: Scalars['String']['output']
  failureReasons: Array<ConfirmationFailureReason>
  result: ConfirmationResult
  segmentId: Scalars['String']['output']
  tripId: Scalars['String']['output']
}

export enum ConfirmationFailureReason {
  ConfirmationFailureReasonCabinNotReady = 'CONFIRMATION_FAILURE_REASON_CABIN_NOT_READY',
  ConfirmationFailureReasonDeserialization = 'CONFIRMATION_FAILURE_REASON_DESERIALIZATION',
  ConfirmationFailureReasonInvalid = 'CONFIRMATION_FAILURE_REASON_INVALID',
  ConfirmationFailureReasonTimeout = 'CONFIRMATION_FAILURE_REASON_TIMEOUT',
}

export enum ConfirmationResult {
  ConfirmationResultFailed = 'CONFIRMATION_RESULT_FAILED',
  ConfirmationResultInvalid = 'CONFIRMATION_RESULT_INVALID',
  ConfirmationResultSuccess = 'CONFIRMATION_RESULT_SUCCESS',
}

export enum ConfirmationType {
  ConfirmationTypeCabinReady = 'CONFIRMATION_TYPE_CABIN_READY',
  ConfirmationTypeInvalid = 'CONFIRMATION_TYPE_INVALID',
  ConfirmationTypeQrCodeValidated = 'CONFIRMATION_TYPE_QR_CODE_VALIDATED',
  ConfirmationTypeReadyForInLanePu = 'CONFIRMATION_TYPE_READY_FOR_IN_LANE_PU',
  ConfirmationTypeReadyToGo = 'CONFIRMATION_TYPE_READY_TO_GO',
  ConfirmationTypeSeatbeltsBuckled = 'CONFIRMATION_TYPE_SEATBELTS_BUCKLED',
}

export enum ConnectedState {
  ConnectedInterrupted = 'CONNECTED_INTERRUPTED',
  ConnectedOffline = 'CONNECTED_OFFLINE',
  ConnectedOnline = 'CONNECTED_ONLINE',
  ConnectedStateUnknown = 'CONNECTED_STATE_UNKNOWN',
}

export type ConvertibleType = {
  __typename?: 'ConvertibleType'
  count: Scalars['Int']['output']
  key: ConvertibleTypeKey
}

export type ConvertibleTypeInput = {
  count: Scalars['Int']['input']
  key: ConvertibleTypeKey
}

export enum ConvertibleTypeKey {
  ConvertibleChildSeat = 'CONVERTIBLE_CHILD_SEAT',
}

export type CooperationDetails = {
  __typename?: 'CooperationDetails'
  stop: Maybe<NavigationStop>
}

export type CoordinateInput = {
  latitude: Scalars['Float']['input']
  longitude: Scalars['Float']['input']
}

export enum CountryCode {
  Ac = 'AC',
  Ad = 'AD',
  Ae = 'AE',
  Af = 'AF',
  Ag = 'AG',
  Ai = 'AI',
  Al = 'AL',
  Am = 'AM',
  An = 'AN',
  Ao = 'AO',
  Aq = 'AQ',
  Ar = 'AR',
  As = 'AS',
  At = 'AT',
  Au = 'AU',
  Aw = 'AW',
  Ax = 'AX',
  Az = 'AZ',
  Ba = 'BA',
  Bb = 'BB',
  Bd = 'BD',
  Be = 'BE',
  Bf = 'BF',
  Bg = 'BG',
  Bh = 'BH',
  Bi = 'BI',
  Bj = 'BJ',
  Bl = 'BL',
  Bm = 'BM',
  Bn = 'BN',
  Bo = 'BO',
  Bq = 'BQ',
  Br = 'BR',
  Bs = 'BS',
  Bt = 'BT',
  Bu = 'BU',
  Bv = 'BV',
  Bw = 'BW',
  By = 'BY',
  Bz = 'BZ',
  Ca = 'CA',
  Cc = 'CC',
  Cd = 'CD',
  Cf = 'CF',
  Cg = 'CG',
  Ch = 'CH',
  Ci = 'CI',
  Ck = 'CK',
  Cl = 'CL',
  Cm = 'CM',
  Cn = 'CN',
  Co = 'CO',
  Cp = 'CP',
  Cr = 'CR',
  Cs = 'CS',
  Cu = 'CU',
  Cv = 'CV',
  Cw = 'CW',
  Cx = 'CX',
  Cy = 'CY',
  Cz = 'CZ',
  De = 'DE',
  Dg = 'DG',
  Dj = 'DJ',
  Dk = 'DK',
  Dm = 'DM',
  Do = 'DO',
  Dz = 'DZ',
  Ea = 'EA',
  Ec = 'EC',
  Ee = 'EE',
  Eg = 'EG',
  Eh = 'EH',
  Er = 'ER',
  Es = 'ES',
  Et = 'ET',
  Eu = 'EU',
  Ez = 'EZ',
  Fi = 'FI',
  Fj = 'FJ',
  Fk = 'FK',
  Fm = 'FM',
  Fo = 'FO',
  Fr = 'FR',
  Fx = 'FX',
  Ga = 'GA',
  Gb = 'GB',
  Gd = 'GD',
  Ge = 'GE',
  Gf = 'GF',
  Gg = 'GG',
  Gh = 'GH',
  Gi = 'GI',
  Gl = 'GL',
  Gm = 'GM',
  Gn = 'GN',
  Gp = 'GP',
  Gq = 'GQ',
  Gr = 'GR',
  Gs = 'GS',
  Gt = 'GT',
  Gu = 'GU',
  Gw = 'GW',
  Gy = 'GY',
  Hk = 'HK',
  Hm = 'HM',
  Hn = 'HN',
  Hr = 'HR',
  Ht = 'HT',
  Hu = 'HU',
  Ic = 'IC',
  Id = 'ID',
  Ie = 'IE',
  Il = 'IL',
  Im = 'IM',
  In = 'IN',
  Io = 'IO',
  Iq = 'IQ',
  Ir = 'IR',
  Is = 'IS',
  It = 'IT',
  Je = 'JE',
  Jm = 'JM',
  Jo = 'JO',
  Jp = 'JP',
  Ke = 'KE',
  Kg = 'KG',
  Kh = 'KH',
  Ki = 'KI',
  Km = 'KM',
  Kn = 'KN',
  Kp = 'KP',
  Kr = 'KR',
  Kw = 'KW',
  Ky = 'KY',
  Kz = 'KZ',
  La = 'LA',
  Lb = 'LB',
  Lc = 'LC',
  Li = 'LI',
  Lk = 'LK',
  Lr = 'LR',
  Ls = 'LS',
  Lt = 'LT',
  Lu = 'LU',
  Lv = 'LV',
  Ly = 'LY',
  Ma = 'MA',
  Mc = 'MC',
  Md = 'MD',
  Me = 'ME',
  Mf = 'MF',
  Mg = 'MG',
  Mh = 'MH',
  Mk = 'MK',
  Ml = 'ML',
  Mm = 'MM',
  Mn = 'MN',
  Mo = 'MO',
  Mp = 'MP',
  Mq = 'MQ',
  Mr = 'MR',
  Ms = 'MS',
  Mt = 'MT',
  Mu = 'MU',
  Mv = 'MV',
  Mw = 'MW',
  Mx = 'MX',
  My = 'MY',
  Mz = 'MZ',
  Na = 'NA',
  Nc = 'NC',
  Ne = 'NE',
  Nf = 'NF',
  Ng = 'NG',
  Ni = 'NI',
  Nl = 'NL',
  No = 'NO',
  Np = 'NP',
  Nr = 'NR',
  Nt = 'NT',
  Nu = 'NU',
  Nz = 'NZ',
  Om = 'OM',
  Pa = 'PA',
  Pe = 'PE',
  Pf = 'PF',
  Pg = 'PG',
  Ph = 'PH',
  Pk = 'PK',
  Pl = 'PL',
  Pm = 'PM',
  Pn = 'PN',
  Pr = 'PR',
  Ps = 'PS',
  Pt = 'PT',
  Pw = 'PW',
  Py = 'PY',
  Qa = 'QA',
  Re = 'RE',
  Ro = 'RO',
  Rs = 'RS',
  Ru = 'RU',
  Rw = 'RW',
  Sa = 'SA',
  Sb = 'SB',
  Sc = 'SC',
  Sd = 'SD',
  Se = 'SE',
  Sf = 'SF',
  Sg = 'SG',
  Sh = 'SH',
  Si = 'SI',
  Sj = 'SJ',
  Sk = 'SK',
  Sl = 'SL',
  Sm = 'SM',
  Sn = 'SN',
  So = 'SO',
  Sr = 'SR',
  Ss = 'SS',
  St = 'ST',
  Su = 'SU',
  Sv = 'SV',
  Sx = 'SX',
  Sy = 'SY',
  Sz = 'SZ',
  Ta = 'TA',
  Tc = 'TC',
  Td = 'TD',
  Tf = 'TF',
  Tg = 'TG',
  Th = 'TH',
  Tj = 'TJ',
  Tk = 'TK',
  Tl = 'TL',
  Tm = 'TM',
  Tn = 'TN',
  To = 'TO',
  Tp = 'TP',
  Tr = 'TR',
  Tt = 'TT',
  Tv = 'TV',
  Tw = 'TW',
  Tz = 'TZ',
  Ua = 'UA',
  Ug = 'UG',
  Uk = 'UK',
  Um = 'UM',
  Undefined = 'UNDEFINED',
  Us = 'US',
  Uy = 'UY',
  Uz = 'UZ',
  Va = 'VA',
  Vc = 'VC',
  Ve = 'VE',
  Vg = 'VG',
  Vi = 'VI',
  Vn = 'VN',
  Vu = 'VU',
  Wf = 'WF',
  Ws = 'WS',
  Xi = 'XI',
  Xk = 'XK',
  Xu = 'XU',
  Ye = 'YE',
  Yt = 'YT',
  Yu = 'YU',
  Za = 'ZA',
  Zm = 'ZM',
  Zr = 'ZR',
  Zw = 'ZW',
}

export type CouponInfo = {
  __typename?: 'CouponInfo'
  code: Scalars['String']['output']
  state: CouponState
  validFrom: Scalars['Instant']['output']
  validUntil: Scalars['Instant']['output']
}

export enum CouponState {
  Assigned = 'Assigned',
  Available = 'Available',
  Expired = 'Expired',
  Redeemed = 'Redeemed',
}

export type CreateCustomPriceConfigInput = {
  childrenPricing: ChildrenPricingInput
  classicServiceClass: ServiceClassParametersInput
  conditions?: InputMaybe<CustomPriceConfigConditionsInput>
  couponsAllowed: Scalars['Boolean']['input']
  displayText: Array<CustomPriceConfigDisplayTextInput>
  dynamicPricing?: InputMaybe<DynamicPricingInput>
  expressServiceClass: ServiceClassParametersInput
  expressServiceClassSurcharge: MoneyInput
  name: Scalars['String']['input']
  parameters: PriceConfigParametersInput
  priority: Scalars['Int']['input']
  purpose: CustomPriceConfigPurpose
  serviceAreaID: Scalars['ID']['input']
  validFrom: Scalars['DateTime']['input']
  validUntil: Scalars['DateTime']['input']
}

/** For possible errors see type CreateDefaultPriceConfigResponse */
export type CreateCustomPriceConfigResponse = {
  __typename?: 'CreateCustomPriceConfigResponse'
  config: CustomPriceConfigResponse
}

export type CreateDefaultPriceConfigInput = {
  childrenPricing: ChildrenPricingInput
  classicServiceClass: ServiceClassParametersInput
  dynamicPricing?: InputMaybe<DynamicPricingInput>
  expressServiceClass: ServiceClassParametersInput
  expressServiceClassSurcharge: MoneyInput
  name: Scalars['String']['input']
  parameters: PriceConfigParametersInput
  serviceAreaID: Scalars['ID']['input']
  validFrom: Scalars['DateTime']['input']
}

/**
 * Possible Errors:
 * 1. Server Errors, e.g.:
 * errors: [
 * {
 * message: "failed to generate uuid",
 * path: [ "input"],
 * }
 * ]
 * 2. Not found, e.g.:
 * errors: [
 * {
 * message: "price config not found",
 * path: [ "deleteDefaultPriceConfig"],
 * }
 * ]
 * 3. Unauthorized, e.g.:
 * errors: [
 * {
 * message: "operation unauthorized",
 * path": ["createDefaultPriceConfig"]
 * }
 * ]
 * 4. Validation Errors, e.g.:
 * ...
 */
export type CreateDefaultPriceConfigResponse = {
  __typename?: 'CreateDefaultPriceConfigResponse'
  config: DefaultPriceConfigResponse
}

/** Input for creating a new demo route */
export type CreateDemoRouteInput = {
  /** Ending point of the route */
  destination: DemoRouteWaypointInput
  /** The ID of the fleet this route belongs to */
  fleetId: Scalars['ID']['input']
  /** Whether this route should be active upon creation (defaults to true if not specified) */
  isActive?: InputMaybe<Scalars['Boolean']['input']>
  /** Optional descriptive name for the route */
  name?: InputMaybe<Scalars['String']['input']>
  /** Starting point of the route */
  origin: DemoRouteWaypointInput
  /** Intermediate waypoints that the route must pass through */
  viaPoints: Array<DemoRouteWaypointInput>
}

export type CreateImpersonationSessionInput = {
  reason: Scalars['String']['input']
  targetUserEmail: Scalars['String']['input']
  ticketReference?: InputMaybe<Scalars['String']['input']>
}

export type CreateLegalDocumentMutationInput = {
  localization: Array<LocalizationInput>
  tenant: Scalars['String']['input']
  type: Type
}

export type CreateOverwatchFleetFleetInput = {
  aliasId: Scalars['String']['input']
  description: Scalars['String']['input']
  geonetName: Scalars['String']['input']
  id?: InputMaybe<Scalars['String']['input']>
  integrationId: Scalars['String']['input']
  /** @deprecated Phantom fleets removed. Accepted but ignored. */
  isPhantom?: InputMaybe<Scalars['Boolean']['input']>
  metropolisId: Scalars['Int']['input']
  name: Scalars['String']['input']
  tenantId: Scalars['String']['input']
}

export type CreateOverwatchFleetInput = {
  fleet: CreateOverwatchFleetFleetInput
}

export type CreateOverwatchVehicleInput = {
  fleetId: Scalars['ID']['input']
  geonetName: Scalars['String']['input']
  inService: Scalars['Boolean']['input']
  name: Scalars['String']['input']
  platform: Scalars['String']['input']
  vin: Scalars['String']['input']
}

/** Input object for creating a pricing polygon in the polygon library */
export type CreatePriceConfigPolygonInput = {
  locations: Array<LocationInput>
  name: Scalars['String']['input']
  serviceAreaID: Scalars['ID']['input']
}

export type CreatePriceConfigPolygonResponse = {
  __typename?: 'CreatePriceConfigPolygonResponse'
  polygon: PriceConfigPolygon
}

export type CreatePricingCampaignResponse = {
  __typename?: 'CreatePricingCampaignResponse'
  campaign: PricingCampaign
}

export type CreateScopedAccessSessionInput = {
  organizationId: Scalars['String']['input']
  permissions: ScopedAccessSessionPermissionsInput
  reason: Scalars['String']['input']
  ticketReference?: InputMaybe<Scalars['String']['input']>
}

export type CreateTemporaryBackofficeSessionResponse = {
  __typename?: 'CreateTemporaryBackofficeSessionResponse'
  /** The temporary backoffice session that was created. */
  session: TemporaryBackofficeSession
  /**
   * The session transfer token that lets the Admin Panel open this session in
   * a new Backoffice tab without re-entering credentials.
   */
  sessionTransferToken: SessionTransferTokenResponse
}

export type CreateTranscribedTripAnnotationInput = {
  audioS3Uri: Scalars['String']['input']
  driverId: Scalars['String']['input']
  languageCode?: InputMaybe<Scalars['String']['input']>
  location: TripGeolocationInput
  recordedAtMs: Scalars['Float']['input']
  severity: TripAnnotationSeverity
  transcriptTurns: Array<TranscriptTurnInput>
  transcriptionVendor: TranscriptionVendor
  tripId?: InputMaybe<Scalars['String']['input']>
  vehicleId: Scalars['String']['input']
  vtrId?: InputMaybe<Scalars['String']['input']>
}

export type CreateWorkOrdersInput = {
  assigneeId?: InputMaybe<Scalars['ID']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  dueAt?: InputMaybe<Scalars['DateTime']['input']>
  operationalImpact?: InputMaybe<WorkOrderOperationalImpact>
  priority?: InputMaybe<WorkOrderPriority>
  serviceItem: WorkOrderServiceItem
  status: WorkOrderStatus
  vehicleIDs: Array<Scalars['ID']['input']>
}

export type CreditCard = {
  __typename?: 'CreditCard'
  last4Digits: Scalars['String']['output']
  provider: Scalars['String']['output']
}

export enum Criticality {
  Accident = 'ACCIDENT',
  CriticalIiIncident = 'CRITICAL_II_INCIDENT',
  CriticalIIncident = 'CRITICAL_I_INCIDENT',
  MajorIiIncident = 'MAJOR_II_INCIDENT',
  MajorIDynIncident = 'MAJOR_I_DYN_INCIDENT',
  MajorIIncident = 'MAJOR_I_INCIDENT',
  MinorIncident = 'MINOR_INCIDENT',
  NoIncident = 'NO_INCIDENT',
  ReversibleIncident = 'REVERSIBLE_INCIDENT',
  SporadicIncident = 'SPORADIC_INCIDENT',
  UncontrollableIrrelevantIncident = 'UNCONTROLLABLE_IRRELEVANT_INCIDENT',
}

export enum CurrencyCode {
  Aed = 'AED',
  Afn = 'AFN',
  All = 'ALL',
  Amd = 'AMD',
  Ang = 'ANG',
  Aoa = 'AOA',
  Ars = 'ARS',
  Aud = 'AUD',
  Awg = 'AWG',
  Azn = 'AZN',
  Bam = 'BAM',
  Bbd = 'BBD',
  Bdt = 'BDT',
  Bgn = 'BGN',
  Bhd = 'BHD',
  Bif = 'BIF',
  Bmd = 'BMD',
  Bnd = 'BND',
  Bob = 'BOB',
  Bov = 'BOV',
  Brl = 'BRL',
  Bsd = 'BSD',
  Btn = 'BTN',
  Bwp = 'BWP',
  Byn = 'BYN',
  Byr = 'BYR',
  Bzd = 'BZD',
  Cad = 'CAD',
  Cdf = 'CDF',
  Che = 'CHE',
  Chf = 'CHF',
  Chw = 'CHW',
  Clf = 'CLF',
  Clp = 'CLP',
  Cny = 'CNY',
  Cop = 'COP',
  Cou = 'COU',
  Crc = 'CRC',
  Cuc = 'CUC',
  Cup = 'CUP',
  Cve = 'CVE',
  Czk = 'CZK',
  Djf = 'DJF',
  Dkk = 'DKK',
  Dop = 'DOP',
  Dzd = 'DZD',
  Egp = 'EGP',
  Ern = 'ERN',
  Etb = 'ETB',
  Eur = 'EUR',
  Fjd = 'FJD',
  Fkp = 'FKP',
  Gbp = 'GBP',
  Gel = 'GEL',
  Ghs = 'GHS',
  Gip = 'GIP',
  Gmd = 'GMD',
  Gnf = 'GNF',
  Gtq = 'GTQ',
  Gyd = 'GYD',
  Hkd = 'HKD',
  Hnl = 'HNL',
  Hrk = 'HRK',
  Htg = 'HTG',
  Huf = 'HUF',
  Idr = 'IDR',
  Ils = 'ILS',
  Inr = 'INR',
  Iqd = 'IQD',
  Irr = 'IRR',
  Isk = 'ISK',
  Jmd = 'JMD',
  Jod = 'JOD',
  Jpy = 'JPY',
  Kes = 'KES',
  Kgs = 'KGS',
  Khr = 'KHR',
  Kmf = 'KMF',
  Kpw = 'KPW',
  Krw = 'KRW',
  Kwd = 'KWD',
  Kyd = 'KYD',
  Kzt = 'KZT',
  Lak = 'LAK',
  Lbp = 'LBP',
  Lkr = 'LKR',
  Lrd = 'LRD',
  Lsl = 'LSL',
  Ltl = 'LTL',
  Lyd = 'LYD',
  Mad = 'MAD',
  Mdl = 'MDL',
  Mga = 'MGA',
  Mkd = 'MKD',
  Mmk = 'MMK',
  Mnt = 'MNT',
  Mop = 'MOP',
  Mro = 'MRO',
  Mru = 'MRU',
  Mur = 'MUR',
  Mvr = 'MVR',
  Mwk = 'MWK',
  Mxn = 'MXN',
  Mxv = 'MXV',
  Myr = 'MYR',
  Mzn = 'MZN',
  Nad = 'NAD',
  Ngn = 'NGN',
  Nio = 'NIO',
  Nok = 'NOK',
  Npr = 'NPR',
  Nzd = 'NZD',
  Omr = 'OMR',
  Pab = 'PAB',
  Pen = 'PEN',
  Pgk = 'PGK',
  Php = 'PHP',
  Pkr = 'PKR',
  Pln = 'PLN',
  Pyg = 'PYG',
  Qar = 'QAR',
  Ron = 'RON',
  Rsd = 'RSD',
  Rub = 'RUB',
  Rur = 'RUR',
  Rwf = 'RWF',
  Sar = 'SAR',
  Sbd = 'SBD',
  Scr = 'SCR',
  Sdg = 'SDG',
  Sek = 'SEK',
  Sgd = 'SGD',
  Shp = 'SHP',
  Sll = 'SLL',
  Sos = 'SOS',
  Srd = 'SRD',
  Ssp = 'SSP',
  Std = 'STD',
  Stn = 'STN',
  Svc = 'SVC',
  Syp = 'SYP',
  Szl = 'SZL',
  Thb = 'THB',
  Tjs = 'TJS',
  Tmt = 'TMT',
  Tnd = 'TND',
  Top = 'TOP',
  Try = 'TRY',
  Ttd = 'TTD',
  Twd = 'TWD',
  Tzs = 'TZS',
  Uah = 'UAH',
  Ugx = 'UGX',
  Undefined = 'UNDEFINED',
  Usd = 'USD',
  Usn = 'USN',
  Uss = 'USS',
  Uyi = 'UYI',
  Uyu = 'UYU',
  Uzs = 'UZS',
  Vef = 'VEF',
  Ves = 'VES',
  Vnd = 'VND',
  Vuv = 'VUV',
  Wst = 'WST',
  Xaf = 'XAF',
  Xag = 'XAG',
  Xau = 'XAU',
  Xba = 'XBA',
  Xbb = 'XBB',
  Xbc = 'XBC',
  Xbd = 'XBD',
  Xcd = 'XCD',
  Xdr = 'XDR',
  Xof = 'XOF',
  Xpd = 'XPD',
  Xpf = 'XPF',
  Xpt = 'XPT',
  Xsu = 'XSU',
  Xts = 'XTS',
  Xua = 'XUA',
  Xxx = 'XXX',
  Yer = 'YER',
  Zar = 'ZAR',
  Zmw = 'ZMW',
  Zwl = 'ZWL',
}

export type CurrentlyDrivenRouteResponse = {
  __typename?: 'CurrentlyDrivenRouteResponse'
  hasActiveRoute: Scalars['Boolean']['output']
  vehicleId: Scalars['ID']['output']
  vehicleRoute: Maybe<VehicleRoute>
}

export type CursorListResponse = {
  /** Identifier for the first item that would be in the next response page */
  nextCursor: Maybe<Scalars['ID']['output']>
  /** Total items in the set that can be paginated over. Can be emtpy to indicate the total is unknown */
  total: Maybe<Scalars['Int']['output']>
}

export type CursorPaginationInput = {
  cursor?: InputMaybe<Scalars['ID']['input']>
  limit: Scalars['Int']['input']
}

export type CustomConfigOrderByInput = {
  validFrom?: InputMaybe<Sort>
  validUntil?: InputMaybe<Sort>
}

export type CustomPriceConfigConditions = {
  __typename?: 'CustomPriceConfigConditions'
  passengerCountCondition: Maybe<CustomPriceConfigPassengerCountCondition>
  polygonLocationConditions: Maybe<
    Array<Maybe<CustomPriceConfigPolygonLocationCondition>>
  >
  serviceClassCondition: Maybe<CustomPriceConfigServiceClassCondition>
  testGroupCondition: Maybe<CustomPriceConfigTestGroupCondition>
  timeCondition: Maybe<CustomPriceConfigTimeCondition>
}

export type CustomPriceConfigConditionsInput = {
  passengerCountCondition?: InputMaybe<CustomPriceConfigPassengerCountConditionInput>
  polygonLocationConditions?: InputMaybe<
    Array<InputMaybe<CustomPriceConfigPolygonLocationConditionInput>>
  >
  serviceClassCondition?: InputMaybe<CustomPriceConfigServiceClassConditionInput>
  testGroupCondition?: InputMaybe<CustomPriceConfigTestGroupConditionInput>
  timeCondition?: InputMaybe<CustomPriceConfigTimeConditionInput>
}

export type CustomPriceConfigDisplayText = {
  __typename?: 'CustomPriceConfigDisplayText'
  header: Maybe<Scalars['String']['output']>
  locale: Scalars['String']['output']
  text: Maybe<Scalars['String']['output']>
}

export type CustomPriceConfigDisplayTextInput = {
  header?: InputMaybe<Scalars['String']['input']>
  locale: Scalars['String']['input']
  text?: InputMaybe<Scalars['String']['input']>
}

export type CustomPriceConfigPassengerCountCondition = {
  __typename?: 'CustomPriceConfigPassengerCountCondition'
  passengerCount: Scalars['Int']['output']
}

export type CustomPriceConfigPassengerCountConditionInput = {
  passengerCount: Scalars['Int']['input']
}

export type CustomPriceConfigPolygonLocationCondition = {
  __typename?: 'CustomPriceConfigPolygonLocationCondition'
  action: LocationActionCondition
  polygon: PriceConditionPolygon
}

export type CustomPriceConfigPolygonLocationConditionInput = {
  action: LocationActionCondition
  polygon: PriceConfigPolygonInput
}

export enum CustomPriceConfigPurpose {
  B2BMarketingCampaign = 'B2B_MARKETING_CAMPAIGN',
  B2CMarketingCampaign = 'B2C_MARKETING_CAMPAIGN',
  Barter = 'BARTER',
  Experiment = 'EXPERIMENT',
  Legacy = 'LEGACY',
  Pricing = 'PRICING',
}

export type CustomPriceConfigResponse = {
  __typename?: 'CustomPriceConfigResponse'
  changeLog: Array<PriceConfigChangeLogEntry>
  childrenPricing: ChildrenPricing
  classicServiceClass: Maybe<ServiceClassParameters>
  conditions: Maybe<CustomPriceConfigConditions>
  couponsAllowed: Scalars['Boolean']['output']
  displayText: Array<CustomPriceConfigDisplayText>
  dynamicPricing: Maybe<DynamicPricing>
  expressServiceClass: Maybe<ServiceClassParameters>
  expressServiceClassSurcharge: Money
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  parameters: PriceConfigParameters
  possibleStateActions: Array<PriceConfigStateAction>
  priority: Scalars['Int']['output']
  purpose: CustomPriceConfigPurpose
  serviceAreaID: Scalars['ID']['output']
  state: PriceConfigState
  validFrom: Scalars['DateTime']['output']
  validUntil: Scalars['DateTime']['output']
  version: Scalars['Int']['output']
}

export enum CustomPriceConfigServiceClass {
  Classic = 'CLASSIC',
  Express = 'EXPRESS',
}

export type CustomPriceConfigServiceClassCondition = {
  __typename?: 'CustomPriceConfigServiceClassCondition'
  serviceClass: CustomPriceConfigServiceClass
}

export type CustomPriceConfigServiceClassConditionInput = {
  serviceClass: CustomPriceConfigServiceClass
}

export type CustomPriceConfigTestGroupCondition = {
  __typename?: 'CustomPriceConfigTestGroupCondition'
  group: Maybe<Scalars['String']['output']>
}

export type CustomPriceConfigTestGroupConditionInput = {
  /** test group to be member of to match condition */
  group?: InputMaybe<Scalars['String']['input']>
}

export type CustomPriceConfigTimeCondition = {
  __typename?: 'CustomPriceConfigTimeCondition'
  days: Array<DayOfWeek>
  timeSlots: Array<PriceConfigTimeSlot>
}

export type CustomPriceConfigTimeConditionInput = {
  days: Array<DayOfWeek>
  timeSlots?: InputMaybe<Array<PriceConfigTimeSlotInput>>
}

export type CustomPriceConfigsResponse = ListResponse & {
  __typename?: 'CustomPriceConfigsResponse'
  customPriceConfigs: Array<CustomPriceConfigResponse>
  total: Scalars['Int']['output']
}

export type CustomRoadBlockageFilterInput = {
  reasons?: InputMaybe<Array<RoadBlockageReason>>
  reportStatuses?: InputMaybe<Array<RoadBlockageReportStatus>>
  statuses?: InputMaybe<Array<RoadBlockageStatus>>
}

export type CustomTurnRestrictionFilterInput = {
  reasons?: InputMaybe<Array<TurnRestrictionReason>>
  statuses?: InputMaybe<Array<TurnRestrictionStatus>>
}

/** Deprecated: Use CustomerV2 instead. The data that is gathered for a customer. */
export type Customer = {
  __typename?: 'Customer'
  /**
   * The optional sign up IP address of the customer
   * @deprecated Use CustomerV2.appManagedFields.createdIpAddress instead.
   */
  createdIpAddress: Maybe<Scalars['String']['output']>
  /**
   * Creation date of the customer profile (ISO-8601 Date and time with offset)
   * @deprecated Use CustomerV2.createdAt instead.
   */
  creationDate: Maybe<Scalars['OffsetDateTime']['output']>
  /**
   * The status of the pending deletion
   * @deprecated Use CustomerV2.appManagedFields.deletionScheduledAt instead.
   */
  deletionScheduledAt: Maybe<Scalars['OffsetDateTime']['output']>
  /**
   * Email address of the customer
   * @deprecated Use CustomerV2.emailAddress instead.
   */
  email: Maybe<Scalars['String']['output']>
  /**
   * The email verified flag for the customer
   * @deprecated Use CustomerV2.appManagedFields.emailVerified instead.
   */
  emailVerified: Scalars['Boolean']['output']
  /**
   * The extended walking time flag for the customer
   * @deprecated Use CustomerV2.appManagedFields.extendedWalkingTime instead.
   */
  extendedWalkingTime: Scalars['Boolean']['output']
  /**
   * The first name of the customer
   * @deprecated Use CustomerV2.givenName instead.
   */
  firstName: Maybe<Scalars['String']['output']>
  /** Whether HVV discount is active */
  hvvDiscountActive: Scalars['Boolean']['output']
  /**
   * HVV  Partnership valid until  date (ISO-8601 Date and time with offset)
   * @deprecated Use CustomerV2.appManagedFields.hvvPartnershipValidUntil instead.
   */
  hvvPartnershipValidUntil: Maybe<Scalars['OffsetDateTime']['output']>
  /**
   * Unique identifier of the customer created by cognito
   * @deprecated Use CustomerV2.id instead.
   */
  id: Scalars['ID']['output']
  /**
   * Last modified date of the customer data (ISO-8601 Date and time with offset)
   * @deprecated Use CustomerV2.modifiedAt instead.
   */
  lastModifiedDate: Maybe<Scalars['OffsetDateTime']['output']>
  /**
   * The last name of the customer
   * @deprecated Use CustomerV2.familyName instead.
   */
  lastName: Maybe<Scalars['String']['output']>
  /**
   * List of legal document confirmations
   * @deprecated Use CustomerV2.appManagedFields.legalDocumentConfirmations instead.
   */
  legalDocumentConfirmations: Array<LegalDocumentConfirmation>
  /**
   * The customers locale/language (BCP 47, based on customers mobile device language settings)
   * @deprecated Use CustomerV2.languageCode instead.
   */
  locale: Scalars['String']['output']
  /**
   * The phone number of the customer.
   * @deprecated Use CustomerV2.phoneNumber instead.
   */
  phoneNumber: Maybe<Scalars['String']['output']>
  /**
   * The phone verified flag for the customer
   * @deprecated Use CustomerV2.appManagedFields.phoneVerified instead.
   */
  phoneVerified: Scalars['Boolean']['output']
  /**
   * The accessibility flag for severely disabled customers
   * @deprecated Use CustomerV2.appManagedFields.severelyDisabled instead.
   */
  severelyDisabled: Maybe<SeverelyDisabled>
  /** Severely disabled state for the customer */
  severelyDisabledState: SeverelyDisabledState
  /**
   * The status of the customer. Either 'ENABLED' or 'DISABLED'. If 'DISABLED', the customer cannot sign in.
   * @deprecated Use CustomerV2.appManagedFields.status instead.
   */
  status: CustomerStatus
  /**
   * List of changes to the status of the customer
   * @deprecated Use CustomerV2.appManagedFields.statusHistory instead.
   */
  statusHistory: Array<StatusHistoryEntry>
  /**
   * Tenant identifier of the customer
   * @deprecated Use CustomerV2.customerTenant instead.
   */
  tenant: Scalars['String']['output']
  /**
   * The visual impairment flag for the customer
   * @deprecated Use CustomerV2.appManagedFields.visualImpairment instead.
   */
  visualImpairment: Maybe<Scalars['Boolean']['output']>
  /**
   * The accessibility flag for the wheelchair of the customer
   * @deprecated Use CustomerV2.appManagedFields.wheelchairAccess instead.
   */
  wheelchairAccess: Scalars['Boolean']['output']
}

export enum CustomerFlag {
  AdEnabled = 'AD_ENABLED',
  HvvDiscountEnabled = 'HVV_DISCOUNT_ENABLED',
  InternalTester = 'INTERNAL_TESTER',
  SeverelyDisabledFreeRideCompanion = 'SEVERELY_DISABLED_FREE_RIDE_COMPANION',
  SeverelyDisabledFreeRideSelf = 'SEVERELY_DISABLED_FREE_RIDE_SELF',
}

export type CustomerResponse = {
  __typename?: 'CustomerResponse'
  /** @deprecated Use customerV2(id, customerTenant) query instead. */
  customer: Maybe<Customer>
}

export enum CustomerStatus {
  /** Disabled */
  Disabled = 'DISABLED',
  /** Enabled */
  Enabled = 'ENABLED',
}

/** App-specific fields for the unified customer view */
export type CustomerV2 = {
  __typename?: 'CustomerV2'
  /** Collection of properties that are only available when `isManagedByApp` is `true` */
  appManagedFields: Maybe<AppCustomerInformation>
  /** When the customer was created (ISO-8601) */
  createdAt: Maybe<Scalars['DateTime']['output']>
  /** Tenant the customer belongs to */
  customerTenant: Scalars['String']['output']
  /** Email address of the customer */
  emailAddress: Maybe<Scalars['String']['output']>
  /** Last name of the customer */
  familyName: Maybe<Scalars['String']['output']>
  /** Active flags for this customer. Flags are filtered by the caller's permissions */
  flags: Array<CustomerFlag>
  /** First name of the customer */
  givenName: Maybe<Scalars['String']['output']>
  /** Unique identifier of the customer */
  id: Scalars['ID']['output']
  /** Whether this customer is managed by our whitelabel apps */
  isManagedByApp: Scalars['Boolean']['output']
  /** Language code (BCP 47) */
  languageCode: Maybe<Scalars['String']['output']>
  /** When the customer was last modified (ISO-8601) */
  modifiedAt: Maybe<Scalars['DateTime']['output']>
  /** Phone number of the customer */
  phoneNumber: Maybe<Scalars['String']['output']>
}

export type CustomersResponse = {
  __typename?: 'CustomersResponse'
  customers: Array<Maybe<Customer>>
  total: Scalars['Int']['output']
}

export type DateTimeInterval = {
  __typename?: 'DateTimeInterval'
  from: Scalars['DateTime']['output']
  to: Scalars['DateTime']['output']
}

export type DateTimeIntervalInput = {
  from?: InputMaybe<Scalars['DateTime']['input']>
  to?: InputMaybe<Scalars['DateTime']['input']>
}

export enum DayOfWeek {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY',
}

export type DeactivateVehicleInput = {
  changeReasonFreeText?: InputMaybe<Scalars['String']['input']>
  /** Date and time when the vehicle is expected to be activated again, basically a downtime forecast. */
  expectedActivationAt?: InputMaybe<Scalars['DateTime']['input']>
  vehicleId: Scalars['ID']['input']
  vehicleStateChangeReason?: InputMaybe<VehicleStateChangeReason>
}

export enum Deactivation {
  Any = 'ANY',
  Current = 'CURRENT',
  Planned = 'PLANNED',
}

export type DeactivationAlert = {
  __typename?: 'DeactivationAlert'
  alertType: DeactivationAlertType
  created: Scalars['DateTime']['output']
  id: Scalars['ID']['output']
  metadata: DeactivationAlertMetadata
  modified: Scalars['DateTime']['output']
  modifiedBy: Maybe<Scalars['String']['output']>
  resolved: Scalars['Boolean']['output']
  serviceAreaId: Scalars['String']['output']
}

export type DeactivationAlertMetadata = {
  __typename?: 'DeactivationAlertMetadata'
  activeStops: Scalars['Int']['output']
  deactivatedStops: Scalars['Int']['output']
  percentage: Scalars['Int']['output']
  threshold: Scalars['Int']['output']
  totalStops: Scalars['Int']['output']
}

export enum DeactivationAlertType {
  NetworkDeactivationBlocked = 'NETWORK_DEACTIVATION_BLOCKED',
  NetworkDeactivationThreshold = 'NETWORK_DEACTIVATION_THRESHOLD',
}

export type DefaultPriceConfigResponse = {
  __typename?: 'DefaultPriceConfigResponse'
  changeLog: Array<PriceConfigChangeLogEntry>
  childrenPricing: ChildrenPricing
  classicServiceClass: Maybe<ServiceClassParameters>
  dynamicPricing: Maybe<DynamicPricing>
  expressServiceClass: Maybe<ServiceClassParameters>
  expressServiceClassSurcharge: Money
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  parameters: PriceConfigParameters
  possibleStateActions: Array<PriceConfigStateAction>
  serviceAreaID: Scalars['ID']['output']
  state: PriceConfigState
  validFrom: Scalars['DateTime']['output']
  version: Scalars['Int']['output']
}

export type DefaultPriceConfigsResponse = ListResponse & {
  __typename?: 'DefaultPriceConfigsResponse'
  defaultPriceConfigs: Array<DefaultPriceConfigResponse>
  total: Scalars['Int']['output']
}

export type DeleteCustomPriceConfigInput = {
  id: Scalars['ID']['input']
  version: Scalars['Int']['input']
}

/** For possible errors see type CreateDefaultPriceConfigResponse */
export type DeleteCustomPriceConfigResponse = {
  __typename?: 'DeleteCustomPriceConfigResponse'
  config: CustomPriceConfigResponse
}

export type DeleteDefaultPriceConfigInput = {
  id: Scalars['ID']['input']
  version: Scalars['Int']['input']
}

/** For possible errors see type CreateDefaultPriceConfigResponse */
export type DeleteDefaultPriceConfigResponse = {
  __typename?: 'DeleteDefaultPriceConfigResponse'
  config: DefaultPriceConfigResponse
}

export type DeleteWorkOrderInput = {
  id: Scalars['ID']['input']
  updatedAt: Scalars['DateTime']['input']
}

export type DeleteWorkOrderResponse = {
  __typename?: 'DeleteWorkOrderResponse'
  success: Scalars['Boolean']['output']
}

/** A demo route used for testing and demonstration purposes */
export type DemoRoute = {
  __typename?: 'DemoRoute'
  /** Timestamp when the route was created (Unix timestamp in milliseconds) */
  createdAt: Scalars['Float']['output']
  /** Ending point of the route */
  destination: DemoRouteWaypoint
  /** The fleet this route belongs to */
  fleet: Fleet
  /** Unique identifier for the demo route */
  id: Scalars['ID']['output']
  /** Whether this route is currently active and available for use */
  isActive: Scalars['Boolean']['output']
  /** The user who last updated the route */
  lastUpdatedBy: Scalars['String']['output']
  /** Optional descriptive name for the route */
  name: Maybe<Scalars['String']['output']>
  /** Starting point of the route */
  origin: DemoRouteWaypoint
  /** Timestamp when the route was last updated (Unix timestamp in milliseconds) */
  updatedAt: Scalars['Float']['output']
  /** Intermediate waypoints that the route must pass through */
  viaPoints: Array<DemoRouteWaypoint>
}

/** A geographical coordinate point without heading information */
export type DemoRouteCoordinate = {
  __typename?: 'DemoRouteCoordinate'
  /** Latitude coordinate in decimal degrees */
  lat: Scalars['Float']['output']
  /** Longitude coordinate in decimal degrees */
  lon: Scalars['Float']['output']
}

/** A segment of a route between two points, containing path coordinates and metadata */
export type DemoRouteLeg = {
  __typename?: 'DemoRouteLeg'
  /** The length of this route leg in meters */
  lengthMeters: Scalars['Float']['output']
  /** The sequence of coordinates that make up this route leg */
  path: Array<DemoRouteCoordinate>
  /** Any routing violations that were detected in this leg */
  violationNotices: Maybe<Array<DemoRouteViolationNotice>>
}

/** A preview of a calculated route with timing information and path details */
export type DemoRoutePreview = {
  __typename?: 'DemoRoutePreview'
  /** Estimated time of arrival in seconds for the complete route */
  etaInSeconds: Scalars['Float']['output']
  /** The legs that make up the complete route */
  route: Array<DemoRouteLeg>
  sdsValidation: Maybe<Array<SdsValidationResult>>
}

/** Input for generating a demo route preview */
export type DemoRoutePreviewInput = {
  /** Ending point of the route */
  destination: DemoRouteWaypointInput
  /** Optional ID of the fleet to use for sds validation */
  fleetId?: InputMaybe<Scalars['ID']['input']>
  /** Starting point of the route */
  origin: DemoRouteWaypointInput
  /** Intermediate waypoints for the route */
  viaPoints: Array<DemoRouteWaypointInput>
}

/** Enumeration of possible routing violations that can occur when calculating a route */
export enum DemoRouteRoutingViolation {
  /** The route uses a road that is marked as blocked */
  ViolationBlockedRoadUsed = 'VIOLATION_BLOCKED_ROAD_USED',
  /** The route includes a turn that is forbidden */
  ViolationForbiddenTurnUsed = 'VIOLATION_FORBIDDEN_TURN_USED',
  /** Default invalid state */
  ViolationInvalid = 'VIOLATION_INVALID',
  /** The route passes through a local zone that should be avoided */
  ViolationLocalZoneUsed = 'VIOLATION_LOCAL_ZONE_USED',
  /** The route violates a time-dependent restriction (e.g., no entry during certain hours) */
  ViolationTimeDependentRestrictionViolated = 'VIOLATION_TIME_DEPENDENT_RESTRICTION_VIOLATED',
  /** The route includes a turn that is forbidden specifically for this vehicle type */
  ViolationTurnForbiddenForVehicleTypeUsed = 'VIOLATION_TURN_FORBIDDEN_FOR_VEHICLE_TYPE_USED',
  /** The route includes road segments that are incompatible with the vehicle type */
  ViolationVehicleTypeIncompatibleSegmentsUsed = 'VIOLATION_VEHICLE_TYPE_INCOMPATIBLE_SEGMENTS_USED',
  /** The calculated route ends in a direction that doesn't match the destination heading */
  ViolationWrongDirectionAtDestination = 'VIOLATION_WRONG_DIRECTION_AT_DESTINATION',
  /** The calculated route starts in a direction that doesn't match the origin heading */
  ViolationWrongDirectionAtOrigin = 'VIOLATION_WRONG_DIRECTION_AT_ORIGIN',
}

/** A notice about a routing violation that occurred at a specific segment of the route */
export type DemoRouteViolationNotice = {
  __typename?: 'DemoRouteViolationNotice'
  /** The type of violation that occurred */
  issue: Maybe<DemoRouteRoutingViolation>
  /** The number of coordinates affected by this violation */
  numCoordinates: Maybe<Scalars['Int']['output']>
  /** The starting index in the path array where the violation begins */
  startIndex: Maybe<Scalars['Int']['output']>
}

/** A waypoint with geographical coordinates and heading direction */
export type DemoRouteWaypoint = {
  __typename?: 'DemoRouteWaypoint'
  /** Heading direction in degrees (0-359), where 0 is North, 90 is East, etc. */
  heading: Scalars['Float']['output']
  /** Latitude coordinate in decimal degrees */
  lat: Scalars['Float']['output']
  /** Longitude coordinate in decimal degrees */
  lon: Scalars['Float']['output']
}

/** Input type for creating or updating a waypoint */
export type DemoRouteWaypointInput = {
  /** Heading direction in degrees (0-359), where 0 is North, 90 is East, etc. */
  heading: Scalars['Float']['input']
  /** Latitude coordinate in decimal degrees */
  lat: Scalars['Float']['input']
  /** Longitude coordinate in decimal degrees */
  lon: Scalars['Float']['input']
}

export enum DestinationType {
  DestinationTypeBreak = 'DESTINATION_TYPE_BREAK',
  DestinationTypeGoodsDropOff = 'DESTINATION_TYPE_GOODS_DROP_OFF',
  DestinationTypeGoodsDropOffLarge = 'DESTINATION_TYPE_GOODS_DROP_OFF_LARGE',
  DestinationTypeGoodsDropOffSmall = 'DESTINATION_TYPE_GOODS_DROP_OFF_SMALL',
  DestinationTypeGoodsPickUp = 'DESTINATION_TYPE_GOODS_PICK_UP',
  DestinationTypeGoodsPickUpLarge = 'DESTINATION_TYPE_GOODS_PICK_UP_LARGE',
  DestinationTypeGoodsPickUpSmall = 'DESTINATION_TYPE_GOODS_PICK_UP_SMALL',
  DestinationTypeGoodsReturn = 'DESTINATION_TYPE_GOODS_RETURN',
  DestinationTypeInvalid = 'DESTINATION_TYPE_INVALID',
  DestinationTypePeopleDropOff = 'DESTINATION_TYPE_PEOPLE_DROP_OFF',
  DestinationTypePeoplePickUp = 'DESTINATION_TYPE_PEOPLE_PICK_UP',
  DestinationTypePullOver = 'DESTINATION_TYPE_PULL_OVER',
  DestinationTypeRefueling = 'DESTINATION_TYPE_REFUELING',
  DestinationTypeRepositioning = 'DESTINATION_TYPE_REPOSITIONING',
  DestinationTypeTerminal = 'DESTINATION_TYPE_TERMINAL',
}

export type DetailsDto = {
  __typename?: 'DetailsDto'
  key: Scalars['String']['output']
  value: Scalars['String']['output']
}

export type DisableCustomerInput = {
  /** Reason for disabling a customer */
  disabledReason: DisabledReason
  id: Scalars['ID']['input']
  /** Customer tenant */
  tenant: Scalars['String']['input']
}

export type DisableCustomerResponse = {
  __typename?: 'DisableCustomerResponse'
  success: Scalars['Boolean']['output']
}

/** Reason why customer was disabled */
export enum DisabledReason {
  /** Customer account deletion requested */
  CustomerDeletionRequested = 'CUSTOMER_DELETION_REQUESTED',
  /** Escalation with police */
  EscalationWithPolice = 'ESCALATION_WITH_POLICE',
  /** Fraud */
  Fraud = 'FRAUD',
  /** Misbehaviour */
  Misbehaviour = 'MISBEHAVIOUR',
  /** Racism */
  Racism = 'RACISM',
  /** Sexism */
  Sexism = 'SEXISM',
  /** Vandalism */
  Vandalism = 'VANDALISM',
  /** Vehicle pollution */
  VehiclePollution = 'VEHICLE_POLLUTION',
  /** Violation of General Terms and Conditions */
  ViolationOfGtc = 'VIOLATION_OF_GTC',
  /** Violence */
  Violence = 'VIOLENCE',
}

export type DisapproveCustomPriceConfigInput = {
  id: Scalars['ID']['input']
  version: Scalars['Int']['input']
}

/** For possible errors see type CreateDefaultPriceConfigResponse */
export type DisapproveCustomPriceConfigResponse = {
  __typename?: 'DisapproveCustomPriceConfigResponse'
  config: CustomPriceConfigResponse
}

export type DisapproveDefaultPriceConfigInput = {
  id: Scalars['ID']['input']
  version: Scalars['Int']['input']
}

/** For possible errors see type CreateDefaultPriceConfigResponse */
export type DisapproveDefaultPriceConfigResponse = {
  __typename?: 'DisapproveDefaultPriceConfigResponse'
  config: DefaultPriceConfigResponse
}

export type DisengagementHeatmapDataPoint = {
  __typename?: 'DisengagementHeatmapDataPoint'
  disengagementReason: Scalars['String']['output']
  initiator: Scalars['String']['output']
  location: Maybe<Geolocation>
  softwareVersion: Scalars['String']['output']
  timestampMs: Scalars['Float']['output']
}

/** The classified disengagement, present once the session is done. */
export type DisengagementVoicebotRecord = {
  __typename?: 'DisengagementVoicebotRecord'
  completedAt: Scalars['DateTime']['output']
  /** True when the turn cap was hit before classification completed. */
  escalated: Scalars['Boolean']['output']
  slots: DisengagementVoicebotSlots
}

export type DisengagementVoicebotSession = {
  __typename?: 'DisengagementVoicebotSession'
  /** True once the classification is complete or the session escalated. */
  done: Scalars['Boolean']['output']
  escalated: Scalars['Boolean']['output']
  /** LLM model driving the conversation. */
  model: Maybe<Scalars['String']['output']>
  record: Maybe<DisengagementVoicebotRecord>
  sessionId: Scalars['UUID']['output']
  slots: DisengagementVoicebotSlots
  totalInputTokens: Scalars['Int']['output']
  totalOutputTokens: Scalars['Int']['output']
  transcript: Array<DisengagementVoicebotTranscriptEntry>
  /** Driver turns taken so far. */
  turnCount: Scalars['Int']['output']
}

/** Classification filled so far. Codes come from the backend's taxonomy; null means not filled yet. */
export type DisengagementVoicebotSlots = {
  __typename?: 'DisengagementVoicebotSlots'
  severity: Maybe<Scalars['String']['output']>
  severityConfirmed: Scalars['Boolean']['output']
  severityLabel: Maybe<Scalars['String']['output']>
  what: Maybe<Scalars['String']['output']>
  whatLabel: Maybe<Scalars['String']['output']>
  why: Maybe<Scalars['String']['output']>
  whyLabel: Maybe<Scalars['String']['output']>
}

export enum DisengagementVoicebotSpeaker {
  Assistant = 'ASSISTANT',
  Driver = 'DRIVER',
}

export type DisengagementVoicebotSpeech = {
  __typename?: 'DisengagementVoicebotSpeech'
  /** Base64-encoded audio. */
  audioBase64: Scalars['String']['output']
  /** MIME type of the audio, e.g. audio/mpeg. */
  mimeType: Scalars['String']['output']
}

export type DisengagementVoicebotTranscriptEntry = {
  __typename?: 'DisengagementVoicebotTranscriptEntry'
  speaker: DisengagementVoicebotSpeaker
  spokenAt: Scalars['DateTime']['output']
  text: Scalars['String']['output']
}

export type DisengagementVoicebotTurn = {
  __typename?: 'DisengagementVoicebotTurn'
  /** The question to speak next; empty once the session is done. */
  assistantText: Scalars['String']['output']
  session: DisengagementVoicebotSession
}

export type DispatchedTrip = {
  __typename?: 'DispatchedTrip'
  dispatchingStatus: DispatchingStatus
  lastDispatchingStatusMs: Scalars['Float']['output']
  metroId: Scalars['Int']['output']
  savedTripId: Scalars['String']['output']
  vin: Scalars['String']['output']
}

export enum DispatchingStatus {
  DispatchingStatusInvalid = 'DISPATCHING_STATUS_INVALID',
  DispatchingStatusRouteDispatching = 'DISPATCHING_STATUS_ROUTE_DISPATCHING',
  DispatchingStatusRouteDispatchFailed = 'DISPATCHING_STATUS_ROUTE_DISPATCH_FAILED',
  DispatchingStatusRouteDispatchSuccess = 'DISPATCHING_STATUS_ROUTE_DISPATCH_SUCCESS',
  DispatchingStatusRouteValidating = 'DISPATCHING_STATUS_ROUTE_VALIDATING',
  DispatchingStatusRouteValidationFailed = 'DISPATCHING_STATUS_ROUTE_VALIDATION_FAILED',
  DispatchingStatusRouteValidationSuccess = 'DISPATCHING_STATUS_ROUTE_VALIDATION_SUCCESS',
}

export enum DoorState {
  Closed = 'CLOSED',
  Open = 'OPEN',
}

export type DsBossCreateOrUpdate = {
  description?: InputMaybe<Scalars['String']['input']>
  isFinal: Scalars['Boolean']['input']
  iteration: Scalars['String']['input']
  monthlyParameters?: InputMaybe<Array<InputMaybe<DsBossMonthlyParameterInput>>>
  predictionEndTimestampUtc: Scalars['DateTime']['input']
  predictionStartTimestampUtc: Scalars['DateTime']['input']
  process: DsBossProcess
  ridePoolingServiceTenant?: InputMaybe<Scalars['String']['input']>
  scenarioId?: InputMaybe<Scalars['ID']['input']>
  scenarioName: Scalars['String']['input']
  serviceAreaId: Scalars['ID']['input']
  timeDependentParameters?: InputMaybe<
    Array<InputMaybe<DsBossTimeDependentParameterInput>>
  >
  trainingEndTimestampUtc: Scalars['DateTime']['input']
  trainingStartTimestampUtc: Scalars['DateTime']['input']
  useSciFactors?: InputMaybe<Scalars['Boolean']['input']>
}

export type DsBossCreateOrUpdateResponse = {
  __typename?: 'DsBossCreateOrUpdateResponse'
  scenarioId: Scalars['ID']['output']
  status: DsBossCreateOrUpdateStatus
}

export enum DsBossCreateOrUpdateStatus {
  Created = 'Created',
  Error = 'Error',
  ParallelRun = 'ParallelRun',
  SavedFinalOutput = 'SavedFinalOutput',
  Updated = 'Updated',
}

export type DsBossDelete = {
  iteration: Scalars['String']['input']
  ridePoolingServiceTenant?: InputMaybe<Scalars['String']['input']>
  scenarioId: Scalars['ID']['input']
  serviceAreaId: Scalars['ID']['input']
}

export type DsBossDeleteResponse = {
  __typename?: 'DsBossDeleteResponse'
  status: DsBossDeleteStatus
}

export enum DsBossDeleteStatus {
  Deleted = 'DELETED',
  Error = 'ERROR',
  MarkedFinal = 'MARKED_FINAL',
  StillRunning = 'STILL_RUNNING',
}

export enum DsBossFileType {
  MonthlyAggregatesExcel = 'MONTHLY_AGGREGATES_EXCEL',
  PlanningDfParquet = 'PLANNING_DF_PARQUET',
}

export type DsBossGetBasedOnScenarioId = {
  dsBossFileType?: InputMaybe<DsBossFileType>
  iteration: Scalars['String']['input']
  ridePoolingServiceTenant?: InputMaybe<Scalars['String']['input']>
  scenarioId: Scalars['ID']['input']
  serviceAreaId: Scalars['ID']['input']
}

export type DsBossGetBasedOnServiceAreaId = {
  ridePoolingServiceTenant?: InputMaybe<Scalars['String']['input']>
  serviceAreaId: Scalars['ID']['input']
}

export type DsBossGetFileResponse = {
  __typename?: 'DsBossGetFileResponse'
  dsBossFileType: DsBossFileType
  file: Maybe<Scalars['String']['output']>
  fileUrl: Maybe<Scalars['String']['output']>
  status: DsBossStatus
  statusMessage: Maybe<Scalars['String']['output']>
}

export type DsBossMonthlyParameter = {
  __typename?: 'DsBossMonthlyParameter'
  description: Maybe<Scalars['String']['output']>
  month: Scalars['Int']['output']
  parameterName: DsBossMonthlyParameterName
  value: Scalars['Float']['output']
  year: Scalars['Int']['output']
}

export type DsBossMonthlyParameterInput = {
  description?: InputMaybe<Scalars['String']['input']>
  month: Scalars['Int']['input']
  parameterName: DsBossMonthlyParameterName
  value: Scalars['Float']['input']
  year: Scalars['Int']['input']
}

export enum DsBossMonthlyParameterName {
  MonthlyExpectedSupply = 'MONTHLY_EXPECTED_SUPPLY',
  MonthlySupplyConstraint = 'MONTHLY_SUPPLY_CONSTRAINT',
}

export enum DsBossProcess {
  Budget = 'BUDGET',
  Rmp = 'RMP',
}

export type DsBossScenarioDetails = {
  __typename?: 'DsBossScenarioDetails'
  creationTimestampUtc: Scalars['DateTime']['output']
  description: Maybe<Scalars['String']['output']>
  isFinal: Scalars['Boolean']['output']
  iteration: Scalars['String']['output']
  lastEditedUtc: Scalars['DateTime']['output']
  monthlyParameters: Maybe<Array<Maybe<DsBossMonthlyParameter>>>
  predictionEndTimestampUtc: Scalars['DateTime']['output']
  predictionStartTimestampUtc: Scalars['DateTime']['output']
  process: DsBossProcess
  ridePoolingServiceTenant: Maybe<Scalars['String']['output']>
  scenarioId: Scalars['ID']['output']
  scenarioName: Scalars['String']['output']
  serviceAreaId: Scalars['ID']['output']
  status: DsBossStatus
  timeDependentParameters: Maybe<Array<Maybe<DsBossTimeDependentParameter>>>
  trainingEndTimestampUtc: Scalars['DateTime']['output']
  trainingStartTimestampUtc: Scalars['DateTime']['output']
  useSciFactors: Maybe<Scalars['Boolean']['output']>
}

export type DsBossScenarioDetailsResponse = {
  __typename?: 'DsBossScenarioDetailsResponse'
  scenarioDetails: Maybe<DsBossScenarioDetails>
}

export type DsBossScenarioShortDescription = {
  __typename?: 'DsBossScenarioShortDescription'
  creationTimestampUtc: Scalars['DateTime']['output']
  isFinal: Scalars['Boolean']['output']
  iteration: Scalars['String']['output']
  lastEditedUtc: Scalars['DateTime']['output']
  predictionEndTimestampUtc: Scalars['DateTime']['output']
  predictionStartTimestampUtc: Scalars['DateTime']['output']
  ridePoolingServiceTenant: Maybe<Scalars['String']['output']>
  scenarioId: Scalars['String']['output']
  scenarioName: Scalars['String']['output']
  serviceAreaId: Scalars['ID']['output']
}

export type DsBossScenariosResponse = ListResponse & {
  __typename?: 'DsBossScenariosResponse'
  missingValues: Maybe<Scalars['Boolean']['output']>
  scenarios: Maybe<Array<Maybe<DsBossScenarioShortDescription>>>
  total: Scalars['Int']['output']
}

export enum DsBossStatus {
  Error = 'ERROR',
  Finished = 'FINISHED',
  Running = 'RUNNING',
}

export type DsBossTimeDependentParameter = {
  __typename?: 'DsBossTimeDependentParameter'
  description: Maybe<Scalars['String']['output']>
  endTimestampUtc: Scalars['DateTime']['output']
  parameterName: DsBossTimeDependentParameterName
  startTimestampUtc: Scalars['DateTime']['output']
  value: Scalars['Float']['output']
}

export type DsBossTimeDependentParameterInput = {
  description?: InputMaybe<Scalars['String']['input']>
  endTimestampUtc: Scalars['DateTime']['input']
  parameterName: DsBossTimeDependentParameterName
  startTimestampUtc: Scalars['DateTime']['input']
  value: Scalars['Float']['input']
}

export enum DsBossTimeDependentParameterName {
  DemandScalingFactor = 'DEMAND_SCALING_FACTOR',
  MaxVehicles = 'MAX_VEHICLES',
  MinVehicles = 'MIN_VEHICLES',
  PassengersScalingFactor = 'PASSENGERS_SCALING_FACTOR',
  PlannedVrhScalingFactor = 'PLANNED_VRH_SCALING_FACTOR',
  TargetAcceptanceRate = 'TARGET_ACCEPTANCE_RATE',
  TargetPrice = 'TARGET_PRICE',
  TravelTimeScalingFactor = 'TRAVEL_TIME_SCALING_FACTOR',
}

export type DsBossUpdateBasedOnScenarioId = {
  iteration: Scalars['String']['input']
  ridePoolingServiceTenant?: InputMaybe<Scalars['String']['input']>
  scenarioId: Scalars['ID']['input']
  serviceAreaId: Scalars['ID']['input']
}

export type DynamicPricing = {
  __typename?: 'DynamicPricing'
  lowerBoundDeviationToDistanceBased: Maybe<Scalars['Float']['output']>
  /** @deprecated Use `lowerBoundDeviationToDistanceBased` and `upperBoundDeviationToDistanceBased`. */
  maxDeviationToDistanceBased: Maybe<Scalars['Float']['output']>
  minPrice: Money
  upperBoundDeviationToDistanceBased: Maybe<Scalars['Float']['output']>
}

export type DynamicPricingInput = {
  lowerBoundDeviationToDistanceBased?: InputMaybe<Scalars['Float']['input']>
  maxDeviationToDistanceBased?: InputMaybe<Scalars['Float']['input']>
  minPrice: MoneyInput
  upperBoundDeviationToDistanceBased?: InputMaybe<Scalars['Float']['input']>
}

export type EmsLicense = {
  __typename?: 'EMSLicense'
  issuedBy: Maybe<Scalars['String']['output']>
  licenseNumber: Maybe<Scalars['String']['output']>
  typeOfLicense: Maybe<Scalars['String']['output']>
  validFrom: Maybe<Scalars['Date']['output']>
  validUntil: Maybe<Scalars['Date']['output']>
}

export type EdgeGeolocations = {
  __typename?: 'EdgeGeolocations'
  edgeCoordinates: Array<Geolocation>
}

export type EditCurrentStateChangeInput = {
  changeReasonFreeText?: InputMaybe<Scalars['String']['input']>
  expectedActivationAt?: InputMaybe<Scalars['DateTime']['input']>
  vehicleID: Scalars['ID']['input']
  vehicleStateChangeReason: VehicleStateChangeReason
}

/** Input for editing an existing vehicle status entry (deprecated). */
export type EditVehicleInFleetInput = {
  /** End date of the status period. */
  endDate: Scalars['Date']['input']
  /** Status entry ID to edit. */
  id: Scalars['ID']['input']
  /** Integration stage name. */
  integrationStage: Scalars['String']['input']
  /** Location name. */
  location: Scalars['String']['input']
  /** Optional notes. */
  notes?: InputMaybe<Scalars['String']['input']>
  /** Start date of the status period. */
  startDate: Scalars['Date']['input']
  /** Technical status to assign. */
  technicalStatus: FleetPlannerVehicleTechnicalStatusInput
}

export enum Eligibility {
  /** Only caretaker is eligible for travel */
  EligibilityCaretaker = 'ELIGIBILITY_CARETAKER',
  /** Only customer is eligible for travel */
  EligibilityCustomer = 'ELIGIBILITY_CUSTOMER',
  /** Customer and caretaker are eligible for travel */
  EligibilityCustomerPlusCaretaker = 'ELIGIBILITY_CUSTOMER_PLUS_CARETAKER',
  /** Invalid/Unknown eligibility */
  EligibilityInvalid = 'ELIGIBILITY_INVALID',
}

/** Deprecated: to be replaced by OpenVehicleInput, OpenVehicleForBackofficeUserInput, CloseVehicleInput, CloseVehicleForBackofficeUserInput */
export type EmergencyVehicleInteractionInput = {
  interactionType: VehicleInteractionType
  reason?: InputMaybe<InteractionReason>
  reasonFreeText?: InputMaybe<Scalars['String']['input']>
  token?: InputMaybe<Scalars['String']['input']>
  vehicleID: Scalars['ID']['input']
}

export type Employee = {
  __typename?: 'Employee'
  address: Maybe<EmployeeAddress>
  birthCountry: Maybe<Scalars['String']['output']>
  /** If set, contains the timestamp when this driver is to be blocked automatically. */
  blockScheduledAt: Maybe<Scalars['DateTime']['output']>
  blockScheduledReason: Maybe<Scalars['String']['output']>
  blocked: Scalars['Boolean']['output']
  /** Reason for suspension/block. Not set if driver is not suspended. */
  blockedReason: Maybe<Scalars['String']['output']>
  confirmed: Scalars['Boolean']['output']
  contractor: Maybe<Scalars['String']['output']>
  contracts: Maybe<Array<EmployeeContract>>
  dateOfBirth: Maybe<Scalars['Date']['output']>
  deputySupervisorUser: Maybe<BackofficeUser>
  driverLicense: Maybe<EmsLicense>
  email: Maybe<Scalars['String']['output']>
  emailVerified: Scalars['Boolean']['output']
  emergencyContact: EmployeeEmergencyContact
  employeeVehicleInteraction: EmployeeVehicleInteraction
  entryDate: Maybe<Scalars['Date']['output']>
  exitDate: Maybe<Scalars['Date']['output']>
  externalId: Maybe<Scalars['String']['output']>
  firstName: Maybe<Scalars['String']['output']>
  fleets: Array<Maybe<Fleet>>
  hubStartDate: Maybe<Scalars['Date']['output']>
  id: Scalars['ID']['output']
  lastName: Maybe<Scalars['String']['output']>
  mobile: Maybe<Scalars['String']['output']>
  mobileVerified: Scalars['Boolean']['output']
  nationality: Maybe<Scalars['String']['output']>
  onboardingEnddate: Maybe<Scalars['Date']['output']>
  operatorTenant: Maybe<Scalars['String']['output']>
  passengerTransportLicense: Maybe<EmsLicense>
  profilePictureTimestamp: Maybe<Scalars['String']['output']>
  /** URL to profile picture for this employee. Generates a pre-signed URL that is valid for 60 seconds. */
  profilePictureURL: Maybe<Scalars['String']['output']>
  regionId: Maybe<Scalars['ID']['output']>
  roles: Array<Role>
  sdoQualification: Scalars['Boolean']['output']
  serviceAreaId: Maybe<Scalars['ID']['output']>
  serviceBreakLocation: Maybe<ServiceBreakLocation>
  status: EmployeeStatus
  supervisorUser: Maybe<BackofficeUser>
  wavQualification: Scalars['Boolean']['output']
}

export type EmployeeAbsence = {
  __typename?: 'EmployeeAbsence'
  key: Maybe<EmployeeAbsenceKey>
}

export enum EmployeeAbsenceKey {
  AbsentUnknown = 'ABSENT_UNKNOWN',
  CancellationCertificate = 'CANCELLATION_CERTIFICATE',
  CancellationNoCertificate = 'CANCELLATION_NO_CERTIFICATE',
  ChildSick = 'CHILD_SICK',
  Cure = 'CURE',
  EducationalLeave = 'EDUCATIONAL_LEAVE',
  MaternityLeave = 'MATERNITY_LEAVE',
  PaidLeave = 'PAID_LEAVE',
  ParentalLeave = 'PARENTAL_LEAVE',
  Quarantine = 'QUARANTINE',
  Sabbatical = 'SABBATICAL',
  SickCertificate = 'SICK_CERTIFICATE',
  SickNoCertificate = 'SICK_NO_CERTIFICATE',
  SpecialLeave = 'SPECIAL_LEAVE',
  UnpaidLeave = 'UNPAID_LEAVE',
  Vacation = 'VACATION',
  VacationPrioritized = 'VACATION_PRIORITIZED',
  WorkAccident = 'WORK_ACCIDENT',
}

export type EmployeeAddress = {
  __typename?: 'EmployeeAddress'
  city: Maybe<Scalars['String']['output']>
  countryCode: Maybe<Scalars['String']['output']>
  state: Maybe<Scalars['String']['output']>
  /** Street Name with House Number */
  streetAddress: Maybe<Scalars['String']['output']>
  zipCode: Maybe<Scalars['String']['output']>
}

export type EmployeeAuthDataChangeValueInput = {
  employeeId: Scalars['ID']['input']
  newValue: Scalars['String']['input']
  type: EmployeeAuthDataType
}

export type EmployeeAuthDataResendCodeInput = {
  accessToken: Scalars['String']['input']
  employeeId: Scalars['ID']['input']
  type: EmployeeAuthDataType
}

export type EmployeeAuthDataResendCodeResponse = {
  __typename?: 'EmployeeAuthDataResendCodeResponse'
  success: Scalars['Boolean']['output']
}

export enum EmployeeAuthDataType {
  Email = 'EMAIL',
  Mobile = 'MOBILE',
}

export type EmployeeAuthDataVerifyCodeInput = {
  accessToken: Scalars['String']['input']
  code: Scalars['String']['input']
  employeeId: Scalars['ID']['input']
  type: EmployeeAuthDataType
}

export type EmployeeBlockInput = {
  /** List of employee IDs to block */
  employees: Array<Scalars['ID']['input']>
  /** Blocking note */
  note?: InputMaybe<Scalars['String']['input']>
  /** Reason for blocking */
  reason: Scalars['String']['input']
}

export type EmployeeBlockResponse = {
  __typename?: 'EmployeeBlockResponse'
  blockedEmployees: Array<Employee>
}

export enum EmployeeBlockingState {
  Blocked = 'BLOCKED',
  NotBlocked = 'NOT_BLOCKED',
  PlannedBlocked = 'PLANNED_BLOCKED',
}

export type EmployeeContract = {
  __typename?: 'EmployeeContract'
  hours: Maybe<Scalars['Float']['output']>
  start: Maybe<Scalars['Date']['output']>
}

export type EmployeeCreateNoteFileGetUrlResponse = {
  __typename?: 'EmployeeCreateNoteFileGetUrlResponse'
  preSignedViewUrl: Maybe<Scalars['String']['output']>
}

export type EmployeeCreateNoteInput = {
  category: EmployeeNoteCategory
  employeeId: Scalars['ID']['input']
  files: Array<EmployeeNoteFileInput>
  note?: InputMaybe<Scalars['String']['input']>
  personalNote?: InputMaybe<Scalars['String']['input']>
  subject: Scalars['String']['input']
}

export type EmployeeCreateNoteResponse = {
  __typename?: 'EmployeeCreateNoteResponse'
  note: EmployeeNote
}

export type EmployeeCreateNotesInput = {
  category: EmployeeNoteCategory
  employeeIds: Array<Scalars['ID']['input']>
  note?: InputMaybe<Scalars['String']['input']>
  personalNote?: InputMaybe<Scalars['String']['input']>
  subject: Scalars['String']['input']
}

export type EmployeeCreateNotesResponse = {
  __typename?: 'EmployeeCreateNotesResponse'
  notes: Array<EmployeeNote>
}

export type EmployeeCreateScheduledBlockInput = {
  /** List of employee IDs to block */
  employees: Array<Scalars['ID']['input']>
  /** Blocking note */
  note?: InputMaybe<Scalars['String']['input']>
  /** Reason for blocking */
  reason: Scalars['String']['input']
  /** Scheduled Blocking time-point */
  scheduledAt: Scalars['DateTime']['input']
}

export type EmployeeDeleteMessagesInput = {
  employeeId: Scalars['ID']['input']
  messageIds: Array<Scalars['ID']['input']>
}

export type EmployeeDeleteMessagesResponse = {
  __typename?: 'EmployeeDeleteMessagesResponse'
  deletedMessageIds: Array<Scalars['ID']['output']>
}

export type EmployeeDeleteNotesInput = {
  employeeId: Scalars['ID']['input']
  noteIds: Array<Scalars['ID']['input']>
}

export type EmployeeDeleteNotesResponse = {
  __typename?: 'EmployeeDeleteNotesResponse'
  deletedIds: Array<Scalars['ID']['output']>
  success: Scalars['Boolean']['output']
}

export type EmployeeDeleteProfileInput = {
  employeeId: Scalars['ID']['input']
}

export type EmployeeDeleteProfileResponse = {
  __typename?: 'EmployeeDeleteProfileResponse'
  deleted: Scalars['Boolean']['output']
  employeeId: Scalars['ID']['output']
}

export type EmployeeDeleteScheduledBlockInput = {
  blockId: Scalars['ID']['input']
}

export type EmployeeDeleteScheduledBlockResponse = {
  __typename?: 'EmployeeDeleteScheduledBlockResponse'
  deleted: Scalars['Boolean']['output']
}

export enum EmployeeDocumentValidity {
  Expired = 'EXPIRED',
  ExpiredSoon = 'EXPIRED_SOON',
  Valid = 'VALID',
}

export type EmployeeEmergencyContact = {
  __typename?: 'EmployeeEmergencyContact'
  filled: Maybe<Scalars['Boolean']['output']>
  name: Maybe<Scalars['String']['output']>
  phone: Maybe<Scalars['String']['output']>
}

export type EmployeeGetScheduledBlocksResponse = {
  __typename?: 'EmployeeGetScheduledBlocksResponse'
  scheduledBlocks: Array<EmployeeScheduledBlock>
}

export type EmployeeHubCheckInStateResponse = {
  __typename?: 'EmployeeHubCheckInStateResponse'
  checkInPossible: Scalars['Boolean']['output']
  checkInPossibleAt: Maybe<Scalars['DateTime']['output']>
  checkedIn: Scalars['Boolean']['output']
  checkedInAt: Maybe<Scalars['DateTime']['output']>
  checkedInHub: Maybe<Hub>
  checkedInServiceBreakLocation: Maybe<ServiceBreakLocation>
}

export type EmployeeLogResponse = {
  __typename?: 'EmployeeLogResponse'
  log: Array<ShiftStateLogRecord>
}

export type EmployeeMessage = {
  __typename?: 'EmployeeMessage'
  acknowledgedAt: Maybe<Scalars['DateTime']['output']>
  acknowledgement: EmployeeMessageAcknowledgement
  body: Scalars['String']['output']
  category: EmployeeMessageCategory
  copySentAsMail: Scalars['Boolean']['output']
  copySentAsSms: Scalars['Boolean']['output']
  createdAt: Scalars['DateTime']['output']
  id: Scalars['ID']['output']
  read: Scalars['Boolean']['output']
  /** If null, the message was sent by the system. */
  senderUser: Maybe<BackofficeUser>
  subject: Maybe<Scalars['String']['output']>
  url: Maybe<Scalars['String']['output']>
}

export enum EmployeeMessageAcknowledgement {
  Done = 'DONE',
  NotRequired = 'NOT_REQUIRED',
  Required = 'REQUIRED',
}

export enum EmployeeMessageCategory {
  General = 'GENERAL',
  Personal = 'PERSONAL',
  ReleaseNotes = 'RELEASE_NOTES',
  System = 'SYSTEM',
  Voucher = 'VOUCHER',
}

export type EmployeeMessageResponse = {
  __typename?: 'EmployeeMessageResponse'
  message: EmployeeMessage
}

export type EmployeeMessagesResponse = {
  __typename?: 'EmployeeMessagesResponse'
  messages: Array<EmployeeMessage>
}

export type EmployeeNote = {
  __typename?: 'EmployeeNote'
  category: EmployeeNoteCategory
  createdAt: Scalars['DateTime']['output']
  createdByUser: Maybe<BackofficeUser>
  employeeId: Scalars['ID']['output']
  files: Array<EmployeeNoteFile>
  lastModifiedAt: Maybe<Scalars['DateTime']['output']>
  lastModifiedByUser: Maybe<BackofficeUser>
  note: Maybe<Scalars['String']['output']>
  noteId: Scalars['ID']['output']
  personalNote: Maybe<Scalars['String']['output']>
  subject: Scalars['String']['output']
}

export enum EmployeeNoteCategory {
  DriverBlocking = 'DRIVER_BLOCKING',
  DriverTraining = 'DRIVER_TRAINING',
  EmployeeConversation = 'EMPLOYEE_CONVERSATION',
  OnboardingMap = 'ONBOARDING_MAP',
  Other = 'OTHER',
  PersonalMatter = 'PERSONAL_MATTER',
}

export type EmployeeNoteCreateFileGetUrlInput = {
  employeeId: Scalars['ID']['input']
  fileName: Scalars['String']['input']
  noteId: Scalars['ID']['input']
}

export type EmployeeNoteFile = {
  __typename?: 'EmployeeNoteFile'
  isPersonalFile: Maybe<Scalars['Boolean']['output']>
  name: Scalars['String']['output']
  noteId: Maybe<Scalars['ID']['output']>
}

export type EmployeeNoteFileInput = {
  name: Scalars['String']['input']
}

export type EmployeeNoteFilePreSignedUrlInput = {
  employeeId: Scalars['ID']['input']
  fileName: Scalars['String']['input']
  isPersonalFile?: InputMaybe<Scalars['Boolean']['input']>
}

export type EmployeeNoteFilePreSignedUrlResponse = {
  __typename?: 'EmployeeNoteFilePreSignedUrlResponse'
  employeeId: Scalars['ID']['output']
  name: Scalars['String']['output']
  /** pre-signed url to upload file */
  preSignedUrl: Scalars['String']['output']
}

export enum EmployeeQualifications {
  Sdo = 'SDO',
  Wav = 'WAV',
}

export type EmployeeQueryNotesInput = {
  /** List of note categories to filter for. If not set or empty, categories will not be filtered. */
  categories?: InputMaybe<Array<EmployeeNoteCategory>>
  dateRange?: InputMaybe<DateTimeIntervalInput>
  employeeId: Scalars['ID']['input']
  /** Lets users search through the subject, title, and public note content. */
  search?: InputMaybe<Scalars['String']['input']>
}

export type EmployeeQueryNotesResponse = {
  __typename?: 'EmployeeQueryNotesResponse'
  notes: Array<EmployeeNote>
}

export type EmployeeResendEmailVerificationInput = {
  employeeId: Scalars['ID']['input']
}

export type EmployeeResendEmailVerificationResponse = {
  __typename?: 'EmployeeResendEmailVerificationResponse'
  success: Scalars['Boolean']['output']
}

export type EmployeeResetPasswordInput = {
  employeeId: Scalars['ID']['input']
}

export type EmployeeResetPasswordResponse = {
  __typename?: 'EmployeeResetPasswordResponse'
  temporaryPassword: Scalars['String']['output']
}

export type EmployeeScheduledBlock = {
  __typename?: 'EmployeeScheduledBlock'
  employees: Array<Employee>
  id: Scalars['ID']['output']
  note: Maybe<Scalars['String']['output']>
  reason: Scalars['String']['output']
  scheduledAt: Scalars['DateTime']['output']
}

export type EmployeeSendMessagesInput = {
  /** If enabled message needs to be acknowledged by the recipient */
  acknowledgementRequired: Scalars['Boolean']['input']
  body: Scalars['String']['input']
  category?: InputMaybe<EmployeeMessageCategory>
  employeeIds: Array<Scalars['ID']['input']>
  /** If set, message can be only be read by driver, supervisor DM or hub manager */
  privacySensitive: Scalars['Boolean']['input']
  sendCopyAsMail: Scalars['Boolean']['input']
  sendCopyAsSms: Scalars['Boolean']['input']
  subject?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
}

export type EmployeeSendMessagesResponse = {
  __typename?: 'EmployeeSendMessagesResponse'
  sent: Scalars['Int']['output']
}

export type EmployeeSetEmergencyContactInput = {
  name: Scalars['String']['input']
  phone: Scalars['String']['input']
}

export enum EmployeeStatus {
  Active = 'ACTIVE',
  Deactivated = 'DEACTIVATED',
  Hired = 'HIRED',
  /** @deprecated This is a default for technical reasons, do not use it in business logic */
  Pending = 'PENDING',
}

export type EmployeeTimesheet = {
  __typename?: 'EmployeeTimesheet'
  absence: Maybe<EmployeeAbsence>
  day: Scalars['Date']['output']
  extraTimes: Array<EmployeeTimesheetExtraTime>
  lastUpdatedAt: Scalars['DateTime']['output']
  workTimes: Array<EmployeeTimesheetPosition>
}

export type EmployeeTimesheetExtraTime = {
  __typename?: 'EmployeeTimesheetExtraTime'
  end: Maybe<Scalars['DateTime']['output']>
  netDuration: Scalars['Duration']['output']
  postingKey: Scalars['String']['output']
  shift: Maybe<Shift>
  start: Maybe<Scalars['DateTime']['output']>
}

export type EmployeeTimesheetPosition = {
  __typename?: 'EmployeeTimesheetPosition'
  end: Maybe<Scalars['DateTime']['output']>
  /** Net duration for this work period. May differ from (end - start) due to extra break rules applied by GFOS */
  netDuration: Maybe<Scalars['Duration']['output']>
  shift: Maybe<Shift>
  start: Maybe<Scalars['DateTime']['output']>
}

export type EmployeeTipsResponse = {
  __typename?: 'EmployeeTipsResponse'
  monthlyTips: Array<EmployeeTipsSum>
}

export type EmployeeTipsSum = {
  __typename?: 'EmployeeTipsSum'
  amount: Money
  period: Scalars['String']['output']
}

export type EmployeeUnblockInput = {
  /** List of employee IDs to unblock */
  employees: Array<Scalars['ID']['input']>
  /** Unblocking note */
  note?: InputMaybe<Scalars['String']['input']>
  /** Reason for unblocking */
  reason: Scalars['String']['input']
}

export type EmployeeUnblockResponse = {
  __typename?: 'EmployeeUnblockResponse'
  unblockedEmployees: Array<Employee>
}

export type EmployeeUpdateContactDataInput = {
  email?: InputMaybe<Scalars['String']['input']>
  mobile?: InputMaybe<Scalars['String']['input']>
}

export type EmployeeUpdateNoteInput = {
  category: EmployeeNoteCategory
  employeeId: Scalars['ID']['input']
  files: Array<EmployeeNoteFileInput>
  note?: InputMaybe<Scalars['String']['input']>
  noteId: Scalars['ID']['input']
  personalNote?: InputMaybe<Scalars['String']['input']>
  subject: Scalars['String']['input']
}

export type EmployeeUpdateNoteResponse = {
  __typename?: 'EmployeeUpdateNoteResponse'
  note: EmployeeNote
}

export type EmployeeUpdateProfileDataInput = {
  contactData?: InputMaybe<EmployeeUpdateContactDataInput>
  fleets?: InputMaybe<Array<Scalars['ID']['input']>>
  id: Scalars['ID']['input']
  qualifications?: InputMaybe<EmployeeUpdateQualificationsInput>
  supervisors?: InputMaybe<EmployeeUpdateSupervisorsInput>
}

export type EmployeeUpdateQualificationsInput = {
  sdoQualification?: InputMaybe<Scalars['Boolean']['input']>
  wavQualification?: InputMaybe<Scalars['Boolean']['input']>
}

export type EmployeeUpdateScheduledBlockInput = {
  /** List of employee IDs to block */
  employees: Array<Scalars['ID']['input']>
  /** Blocking note */
  note?: InputMaybe<Scalars['String']['input']>
  /** Reason for blocking */
  reason: Scalars['String']['input']
  /** Scheduled block ID */
  scheduleBlockId: Scalars['ID']['input']
  /** Scheduled block time-point */
  scheduledAt: Scalars['DateTime']['input']
}

export type EmployeeUpdateSupervisorsInput = {
  deputySupervisorId?: InputMaybe<Scalars['ID']['input']>
  supervisorFirstName?: InputMaybe<Scalars['String']['input']>
  supervisorId?: InputMaybe<Scalars['ID']['input']>
  supervisorLastName?: InputMaybe<Scalars['String']['input']>
}

export type EmployeeVehicleInteraction = {
  __typename?: 'EmployeeVehicleInteraction'
  status: EmployeeVehicleInteractionStatus
  token: Maybe<Scalars['String']['output']>
}

export enum EmployeeVehicleInteractionStatus {
  EmployeeInactive = 'EMPLOYEE_INACTIVE',
  EmployeeSuspended = 'EMPLOYEE_SUSPENDED',
  HasOpenVehicle = 'HAS_OPEN_VEHICLE',
  NotCheckedIn = 'NOT_CHECKED_IN',
  NoShift = 'NO_SHIFT',
  Ok = 'OK',
  /** @deprecated Status SDO_SHIFT is unused and will be removed */
  SdoShift = 'SDO_SHIFT',
}

export type EmployeeZendeskSsoResponse = {
  __typename?: 'EmployeeZendeskSSOResponse'
  /** jwt authorized url redirecting back to the originally requested resource */
  returnTo: Scalars['String']['output']
}

export type Employees = {
  __typename?: 'Employees'
  employees: Array<Employee>
  total: Scalars['Int']['output']
  unconfirmed: Scalars['Int']['output']
}

export type EmployeesFilterInput = {
  blockingState?: InputMaybe<Array<EmployeeBlockingState>>
  contracts?: InputMaybe<Array<EmployeeDocumentValidity>>
  deputySupervisors?: InputMaybe<Array<Scalars['ID']['input']>>
  drivingLicenses?: InputMaybe<Array<EmployeeDocumentValidity>>
  fleets?: InputMaybe<Array<Scalars['ID']['input']>>
  fulltext?: InputMaybe<Scalars['String']['input']>
  hubs?: InputMaybe<Array<Scalars['ID']['input']>>
  passengerLicenses?: InputMaybe<Array<EmployeeDocumentValidity>>
  qualifications?: InputMaybe<Array<EmployeeQualifications>>
  regions?: InputMaybe<Array<Scalars['ID']['input']>>
  roles?: InputMaybe<Array<Role>>
  /** @deprecated Use regions instead */
  serviceAreaId?: InputMaybe<Scalars['ID']['input']>
  statuses?: InputMaybe<Array<EmployeeStatus>>
  supervisors?: InputMaybe<Array<Scalars['ID']['input']>>
}

export type EmployeesSetFleetsInput = {
  employeeId: Scalars['ID']['input']
  fleetIds: Array<Scalars['ID']['input']>
}

export type EnableCustomerInput = {
  id: Scalars['ID']['input']
  /** Customer tenant */
  tenant: Scalars['String']['input']
}

export type EnableCustomerResponse = {
  __typename?: 'EnableCustomerResponse'
  success: Scalars['Boolean']['output']
}

export type EncounteredOddElement = {
  __typename?: 'EncounteredOddElement'
  codebeamerDescription: Scalars['String']['output']
  codebeamerId: Scalars['String']['output']
  codebeamerUrl: Scalars['String']['output']
  deliveryId: Scalars['String']['output']
  endTime: Scalars['String']['output']
  location: Scalars['String']['output']
  meDebuggerUrl: Scalars['String']['output']
  oddElementType: Scalars['String']['output']
  sessionId: Scalars['String']['output']
  startTime: Scalars['String']['output']
  swVersion: Scalars['String']['output']
  taxonomy: Scalars['String']['output']
  testType: Scalars['String']['output']
  vehicleId: Scalars['String']['output']
  vin: Scalars['String']['output']
  vtr: Scalars['String']['output']
}

export enum EventItemType {
  Action = 'ACTION',
  Area = 'AREA',
  Line = 'LINE',
  Roadblockage = 'ROADBLOCKAGE',
  RoadblockageAdditionalSegments = 'ROADBLOCKAGE_ADDITIONAL_SEGMENTS',
  Servicearea = 'SERVICEAREA',
  Stop = 'STOP',
  Turnrestriction = 'TURNRESTRICTION',
}

export enum ExecutionState {
  Active = 'ACTIVE',
  Done = 'DONE',
  Missed = 'MISSED',
  Upcoming = 'UPCOMING',
}

export enum FccActor {
  RemoteOperator = 'REMOTE_OPERATOR',
  SafetyDriver = 'SAFETY_DRIVER',
}

export type FccAdAlert = {
  __typename?: 'FccAdAlert'
  /** @deprecated Alerts are not assigned to an operator; operators handle vehicles, see Vehicle.fccHandledBy */
  assignee: Maybe<BackofficeUser>
  createdAt: Scalars['DateTime']['output']
  id: Scalars['ID']['output']
  status: FccAdAlertStatus
  statusChanges: Array<FccAdAlertStatusChange>
  type: FccAdAlertType
  updatedAt: Scalars['DateTime']['output']
  vehicle: Maybe<Vehicle>
  /**
   * The roles this alert is visible to. Exactly one role owns an alert type, except
   * an emergency stop, which both roles handle.
   */
  visibleTo: Array<FccOperatorRoleType>
}

export enum FccAdAlertStatus {
  Assigned = 'ASSIGNED',
  Closed = 'CLOSED',
  Open = 'OPEN',
}

export type FccAdAlertStatusChange = {
  __typename?: 'FccAdAlertStatusChange'
  bySystem: Scalars['Boolean']['output']
  byUser: Maybe<BackofficeUser>
  date: Scalars['DateTime']['output']
  from: Maybe<FccAdAlertStatus>
  to: FccAdAlertStatus
}

export enum FccAdAlertType {
  CabinSafetyCheck = 'CABIN_SAFETY_CHECK',
  CabinToOperatorCall = 'CABIN_TO_OPERATOR_CALL',
  EmergencyStop = 'EMERGENCY_STOP',
  IncomingSafetyDriverCall = 'INCOMING_SAFETY_DRIVER_CALL',
  ManualNoShow = 'MANUAL_NO_SHOW',
  /** @deprecated not used */
  MissingPassengerAuthentication = 'MISSING_PASSENGER_AUTHENTICATION',
  OperatorToCabinCall = 'OPERATOR_TO_CABIN_CALL',
  OutgoingOperatorToSafetyDriverCall = 'OUTGOING_OPERATOR_TO_SAFETY_DRIVER_CALL',
  PassengerUnbuckled = 'PASSENGER_UNBUCKLED',
  SafetyDriverCalling = 'SAFETY_DRIVER_CALLING',
  VehicleGuidanceRequested = 'VEHICLE_GUIDANCE_REQUESTED',
  WaypointAttendance = 'WAYPOINT_ATTENDANCE',
}

export type FccAdAlerts = {
  __typename?: 'FccAdAlerts'
  alerts: Array<FccAdAlert>
  count: Scalars['Int']['output']
}

export type FccAuditLogEntry = {
  __typename?: 'FccAuditLogEntry'
  category: FccAuditLogEventCategory
  id: Scalars['ID']['output']
  incidentId: Maybe<Scalars['ID']['output']>
  initiationDetails: FccInitiationDetails
  location: Maybe<LocationWithTimestamp>
  type: FccAuditLogEventType
  vehicle: Maybe<Vehicle>
}

export enum FccAuditLogEventCategory {
  CabinSafetyCheck = 'CABIN_SAFETY_CHECK',
  CabinToOperatorCall = 'CABIN_TO_OPERATOR_CALL',
  EmergencyStopIncident = 'EMERGENCY_STOP_INCIDENT',
  HubReturn = 'HUB_RETURN',
  InFieldSupport = 'IN_FIELD_SUPPORT',
  ManageService = 'MANAGE_SERVICE',
  ManualCheckIn = 'MANUAL_CHECK_IN',
  ManualNoShow = 'MANUAL_NO_SHOW',
  /** @deprecated Use OPERATOR_TO_CABIN_CALL */
  OperatorCall = 'OPERATOR_CALL',
  OperatorToCabinCall = 'OPERATOR_TO_CABIN_CALL',
  /** @deprecated This event is no longer supported and will be soon removed */
  PassengerAuthenticationFallback = 'PASSENGER_AUTHENTICATION_FALLBACK',
  PassengerUnbuckledIncident = 'PASSENGER_UNBUCKLED_INCIDENT',
  SafetyDriverCalling = 'SAFETY_DRIVER_CALLING',
  SafetyDriverGuidance = 'SAFETY_DRIVER_GUIDANCE',
  VehicleAssignment = 'VEHICLE_ASSIGNMENT',
  VehicleGuidanceSession = 'VEHICLE_GUIDANCE_SESSION',
  VehicleInteraction = 'VEHICLE_INTERACTION',
  VideoStream = 'VIDEO_STREAM',
  WaypointAttendance = 'WAYPOINT_ATTENDANCE',
}

export enum FccAuditLogEventType {
  CabinSafetyCheckRequired = 'CABIN_SAFETY_CHECK_REQUIRED',
  CabinToOperatorCallConnected = 'CABIN_TO_OPERATOR_CALL_CONNECTED',
  CabinToOperatorCallEnded = 'CABIN_TO_OPERATOR_CALL_ENDED',
  CabinToOperatorCallStarted = 'CABIN_TO_OPERATOR_CALL_STARTED',
  DoorActuationClosedRequested = 'DOOR_ACTUATION_CLOSED_REQUESTED',
  DoorActuationOpenRequested = 'DOOR_ACTUATION_OPEN_REQUESTED',
  EmergencyStopTriggered = 'EMERGENCY_STOP_TRIGGERED',
  HubReturnRequested = 'HUB_RETURN_REQUESTED',
  IncidentHandlingRequired = 'INCIDENT_HANDLING_REQUIRED',
  IncidentResolved = 'INCIDENT_RESOLVED',
  IncomingSafetyDriverToOperatorCallConnected = 'INCOMING_SAFETY_DRIVER_TO_OPERATOR_CALL_CONNECTED',
  IncomingSafetyDriverToOperatorCallEnded = 'INCOMING_SAFETY_DRIVER_TO_OPERATOR_CALL_ENDED',
  IncomingSafetyDriverToOperatorCallStarted = 'INCOMING_SAFETY_DRIVER_TO_OPERATOR_CALL_STARTED',
  InFieldSupportRequested = 'IN_FIELD_SUPPORT_REQUESTED',
  ManageServiceBoardedTripsCancellationRequested = 'MANAGE_SERVICE_BOARDED_TRIPS_CANCELLATION_REQUESTED',
  ManageServiceCompleted = 'MANAGE_SERVICE_COMPLETED',
  ManageServiceFailed = 'MANAGE_SERVICE_FAILED',
  ManageServicePreBoardedTripsCancellationRequested = 'MANAGE_SERVICE_PRE_BOARDED_TRIPS_CANCELLATION_REQUESTED',
  ManageServiceServiceCancellationRequested = 'MANAGE_SERVICE_SERVICE_CANCELLATION_REQUESTED',
  ManageServiceTimeout = 'MANAGE_SERVICE_TIMEOUT',
  ManualArrivalTriggered = 'MANUAL_ARRIVAL_TRIGGERED',
  OperatorClosedDoor = 'OPERATOR_CLOSED_DOOR',
  OperatorConfirmCheckIn = 'OPERATOR_CONFIRM_CHECK_IN',
  OperatorConfirmManualNoShow = 'OPERATOR_CONFIRM_MANUAL_NO_SHOW',
  OperatorFinishedCabinSafetyCheck = 'OPERATOR_FINISHED_CABIN_SAFETY_CHECK',
  OperatorHandledIncidentCancelTrips = 'OPERATOR_HANDLED_INCIDENT_CANCEL_TRIPS',
  OperatorHandledIncidentContinueTrips = 'OPERATOR_HANDLED_INCIDENT_CONTINUE_TRIPS',
  /** @deprecated This event is no longer supported and will be soon removed */
  OperatorHandledPassengerAuthenticationSuccessful = 'OPERATOR_HANDLED_PASSENGER_AUTHENTICATION_SUCCESSFUL',
  /** @deprecated This event type is no longer supported and will be soon removed */
  OperatorProlongedVideostream = 'OPERATOR_PROLONGED_VIDEOSTREAM',
  OperatorStartedCabinSafetyCheck = 'OPERATOR_STARTED_CABIN_SAFETY_CHECK',
  OperatorStartedIncidentHandling = 'OPERATOR_STARTED_INCIDENT_HANDLING',
  OperatorStartedVideostream = 'OPERATOR_STARTED_VIDEOSTREAM',
  OperatorStoppedIncidentHandling = 'OPERATOR_STOPPED_INCIDENT_HANDLING',
  OperatorToCabinCallConnected = 'OPERATOR_TO_CABIN_CALL_CONNECTED',
  OperatorToCabinCallEnded = 'OPERATOR_TO_CABIN_CALL_ENDED',
  OperatorToCabinCallStarted = 'OPERATOR_TO_CABIN_CALL_STARTED',
  OutgoingOperatorToSafetyDriverCallConnected = 'OUTGOING_OPERATOR_TO_SAFETY_DRIVER_CALL_CONNECTED',
  OutgoingOperatorToSafetyDriverCallEnded = 'OUTGOING_OPERATOR_TO_SAFETY_DRIVER_CALL_ENDED',
  OutgoingOperatorToSafetyDriverCallStarted = 'OUTGOING_OPERATOR_TO_SAFETY_DRIVER_CALL_STARTED',
  /** @deprecated This event is no longer supported and will be soon removed */
  PassengerAuthenticationRequired = 'PASSENGER_AUTHENTICATION_REQUIRED',
  PoolingOffRequested = 'POOLING_OFF_REQUESTED',
  PoolingOnRequested = 'POOLING_ON_REQUESTED',
  VehicleAssigned = 'VEHICLE_ASSIGNED',
  VehicleGuidanceIssueResolved = 'VEHICLE_GUIDANCE_ISSUE_RESOLVED',
  VehicleGuidanceSessionDecisionFailed = 'VEHICLE_GUIDANCE_SESSION_DECISION_FAILED',
  VehicleGuidanceSessionDecisionPending = 'VEHICLE_GUIDANCE_SESSION_DECISION_PENDING',
  VehicleGuidanceSessionDecisionSubmitted = 'VEHICLE_GUIDANCE_SESSION_DECISION_SUBMITTED',
  VehicleGuidanceSessionRequested = 'VEHICLE_GUIDANCE_SESSION_REQUESTED',
  VehicleUnassigned = 'VEHICLE_UNASSIGNED',
}

export type FccAuditLogInput = {
  /** DateTimes are exclusive */
  dateTimeRange?: InputMaybe<DateTimeIntervalInput>
  pagination?: InputMaybe<CursorPaginationInput>
  vehicleId: Scalars['ID']['input']
}

export type FccAuditLogList = CursorListResponse & {
  __typename?: 'FccAuditLogList'
  logs: Array<FccAuditLogEntry>
  nextCursor: Maybe<Scalars['ID']['output']>
  total: Maybe<Scalars['Int']['output']>
}

export type FccBoardingRequirements = {
  __typename?: 'FccBoardingRequirements'
  childSeat: Scalars['Boolean']['output']
  headCount: Scalars['Int']['output']
  wheelchair: Scalars['Boolean']['output']
}

export type FccBroadcastMessageInput = {
  fleetIds: Array<Scalars['ID']['input']>
  message: Scalars['String']['input']
}

export enum FccCabinSafetyCheckState {
  CabinReady = 'CABIN_READY',
  DoorClosed = 'DOOR_CLOSED',
  PendingCabinReadyCheck = 'PENDING_CABIN_READY_CHECK',
  PendingCloseDoor = 'PENDING_CLOSE_DOOR',
}

export enum FccCabinSafetyCheckStatus {
  /** Action has been completed */
  Completed = 'COMPLETED',
  /** Action is in progress */
  InProgress = 'IN_PROGRESS',
  /** Action has not been started yet */
  Pending = 'PENDING',
}

export type FccCancelUpcomingTripInput = {
  tripId: Scalars['ID']['input']
  vehicleId: Scalars['ID']['input']
}

export enum FccCancellationReason {
  Accident = 'ACCIDENT',
  Cleaning = 'CLEANING',
  Other = 'OTHER',
  SicknessOfDriver = 'SICKNESS_OF_DRIVER',
  SpecialBreak = 'SPECIAL_BREAK',
  Training = 'TRAINING',
  UnreachableStop = 'UNREACHABLE_STOP',
  VehicleError = 'VEHICLE_ERROR',
  WrongBreakDetection = 'WRONG_BREAK_DETECTION',
  WrongHubReturn = 'WRONG_HUB_RETURN',
}

export type FccConfirmCabinSafetyInput = {
  actor?: InputMaybe<FccActor>
  vehicleId: Scalars['ID']['input']
}

export type FccCurrentOperatorAvailability = {
  __typename?: 'FccCurrentOperatorAvailability'
  activeRole: Maybe<FccOperatorRoleType>
  availability: FccOperatorAvailabilityType
  availableSince: Maybe<Scalars['DateTime']['output']>
}

export type FccDeclineIncomingCallInput = {
  vehicleId: Scalars['ID']['input']
}

export enum FccDoorState {
  Ajar = 'AJAR',
  Closed = 'CLOSED',
  Closing = 'CLOSING',
  Open = 'OPEN',
  Opening = 'OPENING',
}

export type FccFleetShutdownRequestInput = {
  fleetIds: Array<Scalars['ID']['input']>
}

export type FccHubReturnRequestInput = {
  hubId: Scalars['ID']['input']
  vehicleId: Scalars['ID']['input']
}

export type FccImpairments = {
  __typename?: 'FccImpairments'
  visual: Scalars['Boolean']['output']
}

export type FccInitiateOperatorToCabinCallInput = {
  emergencyStopAlertId?: InputMaybe<Scalars['ID']['input']>
  vehicleId: Scalars['ID']['input']
}

export type FccInitiateOperatorToSafetyDriverCallInput = {
  vehicleId: Scalars['ID']['input']
}

export type FccInitiationDetails = {
  __typename?: 'FccInitiationDetails'
  at: Scalars['DateTime']['output']
  bySystem: Scalars['Boolean']['output']
  user: Maybe<BackofficeUser>
  /** @deprecated use user */
  username: Maybe<Scalars['String']['output']>
}

export type FccJoinCabinToOperatorCallInput = {
  vehicleId: Scalars['ID']['input']
}

export type FccJoinSafetyDriverCallInput = {
  vehicleId: Scalars['ID']['input']
}

export enum FccManageServiceDecision {
  CancelAllTrips = 'CANCEL_ALL_TRIPS',
  CancelSomeTrips = 'CANCEL_SOME_TRIPS',
  Continue = 'CONTINUE',
  RestoreMission = 'RESTORE_MISSION',
}

export type FccManageServiceInput = {
  cancellationType: FccServiceCancellationTypeEnum
  decision: FccManageServiceDecision
  /** Links this action to an existing incident (e.g. from an AD alert) */
  incidentId?: InputMaybe<Scalars['ID']['input']>
  /** Required when decision is CANCEL_SOME_TRIPS */
  tripIds?: InputMaybe<Array<Scalars['ID']['input']>>
  vehicleId: Scalars['ID']['input']
}

export type FccManageServiceResponse = {
  __typename?: 'FccManageServiceResponse'
  sessionId: Scalars['ID']['output']
}

export enum FccManualPoolingOffReason {
  AdTestDrive = 'AD_TEST_DRIVE',
  Other = 'OTHER',
  ShortBreak = 'SHORT_BREAK',
  Troubleshooting = 'TROUBLESHOOTING',
}

export type FccOperatorAvailabilities = {
  __typename?: 'FccOperatorAvailabilities'
  available: Scalars['Int']['output']
  /** Can also be used for the total count of operators in a region */
  busy: Scalars['Int']['output']
}

export type FccOperatorAvailabilityByFleet = {
  __typename?: 'FccOperatorAvailabilityByFleet'
  availabilities: FccOperatorAvailabilities
  fleetId: Scalars['ID']['output']
}

export enum FccOperatorAvailabilityType {
  Available = 'AVAILABLE',
  /** Can not be set directly but is derived implicitly by active call or task assignment */
  Busy = 'BUSY',
  Offline = 'OFFLINE',
}

export enum FccOperatorRoleType {
  RemoteAssistanceOperator = 'REMOTE_ASSISTANCE_OPERATOR',
  RiderSupport = 'RIDER_SUPPORT',
}

export enum FccPassengerAuthenticationState {
  Cancelled = 'CANCELLED',
  Confirmed = 'CONFIRMED',
  InProgress = 'IN_PROGRESS',
  ManualNoShowRequested = 'MANUAL_NO_SHOW_REQUESTED',
  NoShowTriggered = 'NO_SHOW_TRIGGERED',
  Upcoming = 'UPCOMING',
}

export type FccPhone = {
  __typename?: 'FccPhone'
  id: Scalars['ID']['output']
  phoneNumber: Scalars['String']['output']
  type: FccPhoneType
  vehicleId: Scalars['ID']['output']
}

export type FccPhoneConfig = {
  __typename?: 'FccPhoneConfig'
  phoneNumber: Scalars['String']['output']
}

export enum FccPhoneType {
  Conmod = 'CONMOD',
  Tablet = 'TABLET',
  Virtual = 'VIRTUAL',
}

export type FccProvideTripCancellationReasonInput = {
  reasonDescription: Scalars['String']['input']
  tripId: Scalars['ID']['input']
  vehicleId: Scalars['ID']['input']
}

export type FccRequestDoorActuationInput = {
  doorState: FccDoorState
  vehicleId: Scalars['ID']['input']
}

export type FccRidePassengerInfo = {
  __typename?: 'FccRidePassengerInfo'
  boardingRequirements: Maybe<FccBoardingRequirements>
  customerId: Maybe<Scalars['ID']['output']>
  displayName: Maybe<Scalars['String']['output']>
  impairments: Maybe<FccImpairments>
  shortName: Maybe<Scalars['String']['output']>
}

export enum FccRouteProvider {
  HereSdk = 'HERE_SDK',
  Mobileye = 'MOBILEYE',
  Moia = 'MOIA',
}

export type FccSeat = {
  __typename?: 'FccSeat'
  occupancy: FccSeatOccupancy
  seatbelt: FccSeatbelt
}

export type FccSeatLayout = {
  __typename?: 'FccSeatLayout'
  cockpitLeft: FccSeat
  cockpitRight: FccSeat
  secondRowLeft: FccSeat
  secondRowMiddle: FccSeat
  secondRowRight: FccSeat
  thirdRowLeft: FccSeat
  thirdRowMiddle: FccSeat
  thirdRowRight: FccSeat
}

export enum FccSeatOccupancy {
  NotInstalled = 'NOT_INSTALLED',
  Occupied = 'OCCUPIED',
  Unoccupied = 'UNOCCUPIED',
}

export enum FccSeatbelt {
  Fastened = 'FASTENED',
  NotInstalled = 'NOT_INSTALLED',
  Unfastened = 'UNFASTENED',
}

export type FccSendDoorRequestInput = {
  doorStatus: FccTargetDoorStatus
  vehicleId: Scalars['ID']['input']
}

export type FccServiceCancellationRequestInput = {
  deactivateVehicleOnHubReturn: Scalars['Boolean']['input']
  otherReasonDescription?: InputMaybe<Scalars['String']['input']>
  reason: FccCancellationReason
  returnToHubId?: InputMaybe<Scalars['ID']['input']>
  vehicleId: Scalars['ID']['input']
}

export enum FccServiceCancellationTypeEnum {
  AllTrips = 'ALL_TRIPS',
  SomeTrips = 'SOME_TRIPS',
}

export type FccSetAvailabilityInput = {
  availability: FccOperatorAvailabilityType
  regionId: Scalars['ID']['input']
  role?: InputMaybe<FccOperatorRoleType>
}

/** Denormalized stop data served directly by fleet control, avoiding federation null propagation issues with the Stop entity */
export type FccStop = {
  __typename?: 'FccStop'
  /** The stop identifier */
  id: Maybe<Scalars['String']['output']>
  /** Localized display names of the stop */
  names: Scalars['DisplayNames']['output']
}

export enum FccTargetDoorStatus {
  Closed = 'CLOSED',
  Open = 'OPEN',
}

export type FccTriggerEmergencyStopInput = {
  vehicleId: Scalars['ID']['input']
}

export enum FccUpdateAdPoolingStatusError {
  GeneralError = 'GENERAL_ERROR',
  /** Communication to upstream service failed. */
  UpstreamServiceError = 'UPSTREAM_SERVICE_ERROR',
  /** The target vehicle is not an AD vehicle. */
  VehicleNotAd = 'VEHICLE_NOT_AD',
}

export type FccUpdateAdPoolingStatusFailure = {
  __typename?: 'FccUpdateAdPoolingStatusFailure'
  error: FccUpdateAdPoolingStatusError
  message: Maybe<Scalars['String']['output']>
  vehicleId: Scalars['ID']['output']
}

export type FccUpdateAdPoolingStatusInput = {
  manualPoolingOffReason?: InputMaybe<FccManualPoolingOffReason>
  poolingEnabled: Scalars['Boolean']['input']
  vehicleId: Scalars['ID']['input']
}

export type FccUpdateAdPoolingStatusStatus =
  | FccUpdateAdPoolingStatusFailure
  | FccUpdateAdPoolingStatusSuccess

export type FccUpdateAdPoolingStatusSuccess = {
  __typename?: 'FccUpdateAdPoolingStatusSuccess'
  vehicleId: Scalars['ID']['output']
}

/** An operator who has taken over a vehicle in one of the role slots. */
export type FccVehicleHandledBy = {
  __typename?: 'FccVehicleHandledBy'
  backofficeUser: Maybe<BackofficeUser>
  /** Always present, unlike `backofficeUser`, which the gateway nulls for a caller who may not read it. */
  backofficeUserId: Scalars['ID']['output']
  role: FccOperatorRoleType
  since: Scalars['DateTime']['output']
}

export type FccWaypoint = {
  __typename?: 'FccWaypoint'
  /** Actions of this waypoint */
  actions: Array<FccWaypointAction>
  /** For AD Vehicles the state of the waypoint */
  adState: Maybe<FccWaypointState>
  /** For AD Vehicles the timestamp when the state of the waypoint was updated */
  adStateUpdatedAt: Maybe<Scalars['DateTime']['output']>
  /** The current status of the cabin safety check */
  cabinSafetyCheckStatus: Maybe<FccCabinSafetyCheckStatus>
  /** The stop at this waypoint with denormalized data from fleet control */
  fccStop: Maybe<FccStop>
  id: Scalars['ID']['output']
  /** The provider of the route */
  routeProvider: Maybe<FccRouteProvider>
  /** The stop at this waypoint */
  stop: Maybe<Stop>
  /** The vehicle, whose mission this waypoint is part of */
  vehicle: Maybe<Vehicle>
}

export type FccWaypointAction =
  | FccWaypointDeliveryAction
  | FccWaypointHubReturnAction
  | FccWaypointPickupAction
  | FccWaypointReallocationAction

export type FccWaypointDeliveryAction = {
  __typename?: 'FccWaypointDeliveryAction'
  /** @deprecated Use ridePassengerInfo instead */
  customer: Maybe<Customer>
  estimatedAt: Scalars['DateTime']['output']
  id: Scalars['ID']['output']
  passengers: FccWaypointPassengerInfo
  pickedUpAt: Maybe<Scalars['DateTime']['output']>
  promisedTimeRange: DateTimeInterval
  ridePassengerInfo: Maybe<FccRidePassengerInfo>
  seats: FccWaypointSeatInfo
  status: FccWaypointDeliveryActionStatus
  trip: Maybe<Trip>
}

export enum FccWaypointDeliveryActionStatus {
  /** Action has been completed */
  Completed = 'COMPLETED',
  /** Action is in progress */
  InProgress = 'IN_PROGRESS',
  /** Action has not been started yet */
  Pending = 'PENDING',
}

export type FccWaypointHubReturnAction = {
  __typename?: 'FccWaypointHubReturnAction'
  area: Maybe<Area>
  estimatedAt: Scalars['DateTime']['output']
  id: Scalars['ID']['output']
  isPlannedHubReturn: Scalars['Boolean']['output']
  promisedTimeRange: DateTimeInterval
  reason: FccWaypointHubReturnReason
}

export enum FccWaypointHubReturnReason {
  DriverBreak = 'DRIVER_BREAK',
  OnDemand = 'ON_DEMAND',
  ShiftEnd = 'SHIFT_END',
  ShortBreak = 'SHORT_BREAK',
}

export type FccWaypointPassengerInfo = {
  __typename?: 'FccWaypointPassengerInfo'
  adults: Scalars['Int']['output']
  children: Scalars['Int']['output']
}

export type FccWaypointPickupAction = {
  __typename?: 'FccWaypointPickupAction'
  adPassengerAuthenticationState: Maybe<FccPassengerAuthenticationState>
  /** @deprecated Use ridePassengerInfo instead */
  customer: Maybe<Customer>
  estimatedAt: Scalars['DateTime']['output']
  id: Scalars['ID']['output']
  notShownUpAt: Maybe<Scalars['DateTime']['output']>
  passengers: FccWaypointPassengerInfo
  pickedUpAt: Maybe<Scalars['DateTime']['output']>
  promisedTimeRange: DateTimeInterval
  ridePassengerInfo: Maybe<FccRidePassengerInfo>
  seats: FccWaypointSeatInfo
  status: FccWaypointPickupActionStatus
  trip: Maybe<Trip>
  tripIsCancelled: Maybe<Scalars['Boolean']['output']>
}

export enum FccWaypointPickupActionStatus {
  /** Action has been completed */
  Completed = 'COMPLETED',
  /** Action is in progress */
  InProgress = 'IN_PROGRESS',
  /** Passenger pickup was a no show */
  NoShow = 'NO_SHOW',
  /** Action has not been started yet */
  Pending = 'PENDING',
}

export type FccWaypointReallocationAction = {
  __typename?: 'FccWaypointReallocationAction'
  estimatedAt: Scalars['DateTime']['output']
  id: Scalars['ID']['output']
  promisedTimeRange: DateTimeInterval
  radius: Scalars['Int']['output']
}

export type FccWaypointSeatInfo = {
  __typename?: 'FccWaypointSeatInfo'
  boosterSeats: Scalars['Int']['output']
  childSeats: Scalars['Int']['output']
  prams: Scalars['Int']['output']
  seats: Scalars['Int']['output']
  wheelchairs: Scalars['Int']['output']
}

export enum FccWaypointState {
  Changed = 'CHANGED',
  Completed = 'COMPLETED',
  Reached = 'REACHED',
}

export type Fee = {
  __typename?: 'Fee'
  feeAmount: Money
  feeType: Scalars['String']['output']
  invoiceId: Scalars['ID']['output']
  isRefundable: Scalars['Boolean']['output']
  status: Scalars['String']['output']
}

export enum FeedbackType {
  FeedbackTypeDispatcher = 'FEEDBACK_TYPE_DISPATCHER',
  FeedbackTypeDispatcherV2 = 'FEEDBACK_TYPE_DISPATCHER_V2',
  FeedbackTypeInvalid = 'FEEDBACK_TYPE_INVALID',
  FeedbackTypeLyft = 'FEEDBACK_TYPE_LYFT',
}

export type Fleet = {
  __typename?: 'Fleet'
  archivedVehiclesCount: Scalars['Int']['output']
  assignedVehiclesCount: Scalars['Int']['output']
  createdAt: Scalars['DateTime']['output']
  createdBy: Maybe<BackofficeUser>
  description: Maybe<Scalars['String']['output']>
  /** The number of employees with access to this fleet */
  employeeCount: Scalars['Int']['output']
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  operatingArea: Maybe<OperatingArea>
  operatorTenant: Scalars['String']['output']
  region: Maybe<Region>
}

export type FleetAssignVehiclesInput = {
  fleetId: Scalars['String']['input']
  vehicleIds: Array<Scalars['String']['input']>
}

/** Availability filter for the fleet calendar. */
export enum FleetCalendarAvailability {
  /** Show planned/booked shift slots. */
  Assigned = 'ASSIGNED',
  /** Show free shift slots. */
  Free = 'FREE',
  /** Show not-available shift slots. */
  NotAvailable = 'NOT_AVAILABLE',
}

/** Result of the fleet calendar query. */
export type FleetCalendarResult = {
  __typename?: 'FleetCalendarResult'
  /** Per-vehicle calendar schedules. */
  vehicles: Array<FleetCalendarVehiclePlan>
  /** Calendar weeks covered by the query range. */
  weeks: Array<FleetCampaignWeek>
}

/** A vehicle's calendar schedule across all weeks. */
export type FleetCalendarVehiclePlan = {
  __typename?: 'FleetCalendarVehiclePlan'
  /** Human-readable vehicle identifier. */
  id: Scalars['ID']['output']
  /** Weekly shift availability breakdown. */
  schedule: Array<FleetCalendarVehicleWeekShifts>
}

/** Per-week shift availability counts for a vehicle in the calendar. */
export type FleetCalendarVehicleWeekShifts = {
  __typename?: 'FleetCalendarVehicleWeekShifts'
  /** Number of free shift slots this week. */
  freeShifts: Scalars['Int']['output']
  /** Number of not-available shift slots this week. */
  notAvailableShifts: Scalars['Int']['output']
  /** Number of planned/booked shift slots this week. */
  plannedShifts: Scalars['Int']['output']
  /** Week identifier this entry belongs to. */
  weekId: Scalars['ID']['output']
}

/** User-selected settings that control how the assignment is computed. */
export type FleetCampaignAssignmentSettings = {
  __typename?: 'FleetCampaignAssignmentSettings'
  /** Which day types to include in the assignment. */
  selectedDays: Maybe<Array<FleetCampaignDay>>
  /** Which shifts to include in the assignment. */
  selectedShifts: Maybe<Array<FleetCampaignShift>>
  /** Number of vehicles to assign. */
  vehicleCount: Maybe<Scalars['Int']['output']>
}

/** Day selection filter for campaign assignments. */
export enum FleetCampaignDay {
  /** Monday through Friday. */
  Weekdays = 'WEEKDAYS',
  /** Saturday and Sunday. */
  Weekends = 'WEEKENDS',
}

/** Campaign parameters used as input for the planning algorithm. */
export type FleetCampaignParams = {
  __typename?: 'FleetCampaignParams'
  /** Unique campaign identifier. */
  campaignId: Maybe<Scalars['ID']['output']>
  /** Earliest allowed assignment date (YYYY-MM-DD). */
  earliestDate: Maybe<Scalars['Date']['output']>
  /** Required vehicle integration stage. */
  integrationStage: Maybe<Scalars['String']['output']>
  /** Latest allowed assignment date (YYYY-MM-DD). */
  latestDate: Maybe<Scalars['Date']['output']>
  /** Location where vehicles must be based. */
  location: Maybe<Scalars['String']['output']>
  /** Campaign display name. */
  name: Maybe<Scalars['String']['output']>
  /** Total number of shifts the campaign requires. */
  requiredShifts: Maybe<Scalars['Int']['output']>
}

/** Result of computing or retrieving a campaign assignment. */
export type FleetCampaignPlanningResult = {
  __typename?: 'FleetCampaignPlanningResult'
  /** User-selected assignment settings. */
  assignmentSettings: Maybe<FleetCampaignAssignmentSettings>
  /** Campaign parameters that were used as planning input. */
  campaignParams: Maybe<FleetCampaignParams>
  /** High-level summary of the computed assignment. */
  planningSummary: Maybe<FleetCampaignPlanningSummary>
  /** Per-vehicle assignment schedules. */
  vehicles: Maybe<Array<FleetCampaignVehiclePlan>>
  /** Calendar weeks covered by the assignment. */
  weeks: Maybe<Array<FleetCampaignWeek>>
}

/** Summary statistics of the computed assignment. */
export type FleetCampaignPlanningSummary = {
  __typename?: 'FleetCampaignPlanningSummary'
  /** Total calendar days covered by the assignment. */
  durationDays: Maybe<Scalars['Int']['output']>
  /** Last date with a planned booking (YYYY-MM-DD). */
  endDate: Maybe<Scalars['Date']['output']>
  /** Maximum number of vehicles needed to fulfil the campaign (capped at eligible vehicles). */
  maxVehicleCount: Scalars['Int']['output']
  /** Total number of planned shift-slots assigned across all vehicles. */
  plannedShifts: Scalars['Int']['output']
  /** Number of vehicles that received at least one booking. */
  plannedVehicles: Maybe<Scalars['Int']['output']>
  /** First date with a planned booking (YYYY-MM-DD). */
  startDate: Maybe<Scalars['Date']['output']>
}

/** Available shift types for campaign vehicle assignments. */
export enum FleetCampaignShift {
  /** Morning shift. */
  Early = 'EARLY',
  /** Evening/night shift. */
  Evening = 'EVENING',
  /** Afternoon shift. */
  Late = 'LATE',
}

/** A vehicle's full assignment schedule across all weeks. */
export type FleetCampaignVehiclePlan = {
  __typename?: 'FleetCampaignVehiclePlan'
  /** Vehicle identifier. */
  id: Scalars['ID']['output']
  /** Weekly shift breakdown for this vehicle. */
  schedule: Array<FleetCampaignVehicleWeekShifts>
}

/** Shift counts for a single vehicle in a single week. */
export type FleetCampaignVehicleWeekShifts = {
  __typename?: 'FleetCampaignVehicleWeekShifts'
  /** Number of early shifts assigned this week. */
  early: Maybe<Scalars['Int']['output']>
  /** Number of evening shifts assigned this week. */
  evening: Maybe<Scalars['Int']['output']>
  /** Number of late shifts assigned this week. */
  late: Maybe<Scalars['Int']['output']>
  /** Week identifier this entry belongs to. */
  weekId: Scalars['ID']['output']
}

/** A calendar week within the assignment plan. */
export type FleetCampaignWeek = {
  __typename?: 'FleetCampaignWeek'
  /** Sunday of this week (YYYY-MM-DD). */
  endDate: Scalars['Date']['output']
  /** Week identifier (e.g. w1, w2). */
  id: Scalars['ID']['output']
  /** Monday of this week (YYYY-MM-DD). */
  startDate: Scalars['Date']['output']
}

export type FleetCreateInput = {
  description?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
  operatingAreaId: Scalars['String']['input']
  operatorTenant: Scalars['String']['input']
  /** UUID of the region this fleet belongs to */
  region: Scalars['String']['input']
}

export type FleetEntityChange = {
  backofficeUser: Maybe<BackofficeUser>
  changedAt: Scalars['DateTime']['output']
  changes: VehicleChangeFields
}

export type FleetMapFleetsInput = {
  isSelfDriving?: InputMaybe<Scalars['Boolean']['input']>
  regionId: Scalars['String']['input']
}

export type FleetMapVehicles = {
  __typename?: 'FleetMapVehicles'
  vehicles: Array<Vehicle>
}

export type FleetMapVehiclesInput = {
  isSelfDriving?: InputMaybe<Scalars['Boolean']['input']>
  regionId: Scalars['String']['input']
}

/** A fleet planner campaign with scheduling, location, and resource data. */
export type FleetPlannerCampaign = {
  __typename?: 'FleetPlannerCampaign'
  /** Current action state of the campaign. */
  action: FleetPlannerCampaignActions
  /** Total autonomous driving hours needed. */
  adHoursNeeded: Scalars['Float']['output']
  /** Human-readable campaign name. */
  campaignName: Scalars['String']['output']
  /** Category of the campaign. */
  category: FleetPlannerCampaignCategory
  /** Earliest possible date to begin the campaign. */
  earliestDate: Scalars['Date']['output']
  /** Planned end date of the campaign. */
  endDate: Maybe<Scalars['Date']['output']>
  /** Unique campaign identifier. */
  id: Scalars['ID']['output']
  /** Integration stage the campaign targets. */
  integrationStage: Scalars['String']['output']
  /** Latest possible date to complete the campaign. */
  latestDate: Scalars['Date']['output']
  /** Locations where this campaign operates. */
  locations: Array<Scalars['String']['output']>
  /** Total operating hours needed. */
  operatingHours: Scalars['Float']['output']
  /** Number of shifts required. */
  shifts: Scalars['Int']['output']
  /** Planned start date of the campaign. */
  startDate: Maybe<Scalars['Date']['output']>
}

/** Current action state of a campaign. */
export enum FleetPlannerCampaignActions {
  /** Campaign has been completed. */
  Finished = 'FINISHED',
  /** Campaign has not started yet. */
  NonStarted = 'NON_STARTED',
  /** Campaign was started but not completed. */
  NotFinished = 'NOT_FINISHED',
}

/** Campaign category classifying the type of testing or validation work. */
export enum FleetPlannerCampaignCategory {
  /** Autonomous driving hours. */
  AdHours = 'AD_HOURS',
  /** Customer group test. */
  Cugt = 'CUGT',
  /** Development drop or release candidate. */
  DevdropRc = 'DEVDROP_RC',
  /** Development and data collection with released software. */
  DevAndDc = 'DEV_AND_DC',
  /** Mean time between incidents. */
  Mtbi = 'MTBI',
  /** Public relations campaign. */
  Pr = 'PR',
  /** Validation campaign. */
  Validation = 'VALIDATION',
  /** Verification campaign. */
  Verification = 'VERIFICATION',
}

/** Input for deleting an existing vehicle status entry. */
export type FleetPlannerDeleteVehicleStatusInput = {
  /** Status entry ID to delete. */
  id: Scalars['ID']['input']
  /**
   * Optional list of other status entries whose start/end dates should be
   * updated as a result of deleting this entry (e.g. to keep the fleet calendar
   * contiguous).
   */
  updatedDates?: InputMaybe<Array<FleetPlannerVehicleDateUpdateInput>>
}

/** Input for editing an existing vehicle status entry. */
export type FleetPlannerEditVehicleStatusInput = {
  /** End date of the status period. */
  endDate: Scalars['Date']['input']
  /** Status entry ID to edit. */
  id: Scalars['ID']['input']
  /** Integration stage name. */
  integrationStage: Scalars['String']['input']
  /** Location name. */
  location: Scalars['String']['input']
  /** Optional notes. */
  notes?: InputMaybe<Scalars['String']['input']>
  /** Start date of the status period. */
  startDate: Scalars['Date']['input']
  /** Technical status to assign. */
  technicalStatus: FleetPlannerVehicleTechnicalStatusInput
  /**
   * Optional list of other status entries whose start/end dates should be
   * updated as a result of editing this entry (e.g. to keep the fleet calendar
   * contiguous).
   */
  updatedDates?: InputMaybe<Array<FleetPlannerVehicleDateUpdateInput>>
}

/** A vehicle in the fleet, identified by its vehicle ID. */
export type FleetPlannerFleet = {
  __typename?: 'FleetPlannerFleet'
  /** Vehicle identifier (e.g. VN41S170816). */
  id: Scalars['ID']['output']
}

/** A single status entry's new start and end date, as part of a cascade update. */
export type FleetPlannerVehicleDateUpdateInput = {
  /** Status entry ID whose dates should be updated. */
  id: Scalars['ID']['input']
  /** New end date for this status entry. */
  newEndDate: Scalars['Date']['input']
  /** New start date for this status entry. */
  newStartDate: Scalars['Date']['input']
}

/** A single status entry in a vehicle's history. */
export type FleetPlannerVehicleEntry = {
  __typename?: 'FleetPlannerVehicleEntry'
  /** End date of this status period. */
  endDate: Scalars['Date']['output']
  /** Unique identifier for this status entry. */
  id: Scalars['ID']['output']
  /** Integration stage name. */
  integrationStage: Scalars['String']['output']
  /** Location name where the vehicle is stationed. */
  location: Scalars['String']['output']
  /** Optional notes about this status entry. */
  notes: Maybe<Scalars['String']['output']>
  /** Start date of this status period. */
  startDate: Scalars['Date']['output']
  /** Technical status of the vehicle during this period. */
  technicalStatus: FleetPlannerVehicleTechnicalStatus
}

/** Available filter values for the vehicle fleet view. */
export type FleetPlannerVehicleFilters = {
  __typename?: 'FleetPlannerVehicleFilters'
  /** All known integration stage names. */
  integrationStages: Maybe<Array<Scalars['String']['output']>>
  /** All known location names. */
  locations: Maybe<Array<Scalars['String']['output']>>
  /** All known technical status values. */
  technicalStatuses: Maybe<Array<Scalars['String']['output']>>
}

/**
 * A split of an existing status period as part of adding a new entry: a new
 * "after" row is created for the given dates, cloning the referenced row's
 * location, integration stage, technical status, and notes.
 */
export type FleetPlannerVehicleSplitInput = {
  /** End date of the new "after" row. */
  newEndDate: Scalars['Date']['input']
  /** Start date of the new "after" row. */
  newStartDate: Scalars['Date']['input']
  /**
   * Existing status entry to copy location, integration stage, technical status,
   * and notes from. Must belong to the target vehicle.
   */
  referenceId: Scalars['ID']['input']
}

/** Technical status of a vehicle as returned in query results. */
export enum FleetPlannerVehicleTechnicalStatus {
  /** Vehicle is AD-ready and MaaS-ready. */
  AdReadyAndMaasReady = 'AD_READY_AND_MAAS_READY',
  /** Vehicle is out of service. */
  OutOfService = 'OUT_OF_SERVICE',
}

/** Technical status of a vehicle as provided in mutation inputs. */
export enum FleetPlannerVehicleTechnicalStatusInput {
  /** Vehicle is AD-ready and MaaS-ready. */
  AdReadyAndMaasReady = 'AD_READY_AND_MAAS_READY',
  /** Vehicle is out of service. */
  OutOfService = 'OUT_OF_SERVICE',
}

export type FleetProcess = {
  /** Readable unique identifier */
  case: Scalars['ID']['output']
  finishedAt: Maybe<Scalars['DateTime']['output']>
  id: Scalars['ID']['output']
  region: Region
  startedAt: Scalars['DateTime']['output']
  state: FleetProcessState
  type: FleetProcessType
  updatedAt: Maybe<Scalars['DateTime']['output']>
  vehicle: Maybe<Vehicle>
}

export enum FleetProcessState {
  Active = 'ACTIVE',
  Complete = 'COMPLETE',
}

export type FleetProcessStateTransitionPrecondition = {
  __typename?: 'FleetProcessStateTransitionPrecondition'
  fulfilled: Scalars['Boolean']['output']
  key: Scalars['String']['output']
}

export type FleetProcessTransitionResponse = {
  __typename?: 'FleetProcessTransitionResponse'
  /** In case of success=false the missing preconditions are contained here */
  missingPreconditions: Array<FleetProcessStateTransitionPrecondition>
  process: FleetProcess
  transitionedSuccessfully: Scalars['Boolean']['output']
}

export enum FleetProcessType {
  MainInspection = 'MAIN_INSPECTION',
  MileageBasedInspection = 'MILEAGE_BASED_INSPECTION',
  VehicleInspectionCard = 'VEHICLE_INSPECTION_CARD',
}

export type FleetUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>
  id: Scalars['ID']['input']
  name: Scalars['String']['input']
}

export type FleetsInput = {
  /**
   * When true, only return fleets the current user is assigned to via their
   * token claims. Defaults to false: all fleets of the user's operator
   * tenants are returned.
   */
  assignedToCurrentUser?: InputMaybe<Scalars['Boolean']['input']>
  /** Only return fleets belonging to this region. */
  regionId?: InputMaybe<Scalars['String']['input']>
}

export type FleetsResponse = {
  __typename?: 'FleetsResponse'
  fleets: Array<Fleet>
}

/** Inclusive FloatRange, e.g. min <= x <= max */
export type FloatRangeInput = {
  max: Scalars['Float']['input']
  min: Scalars['Float']['input']
}

export type FoundCustomer = {
  __typename?: 'FoundCustomer'
  customerTenant: Scalars['String']['output']
  email: Maybe<Scalars['String']['output']>
  familyName: Maybe<Scalars['String']['output']>
  givenName: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  phoneNumber: Maybe<Scalars['String']['output']>
}

export type GeoBoundingBoxInput = {
  northEast: TripGeolocationInput
  southWest: TripGeolocationInput
}

export type GeoJson = {
  __typename?: 'GeoJson'
  features: Array<GeoJsonFeature>
  type: GeoJsonType
}

export type GeoJsonFeature = {
  __typename?: 'GeoJsonFeature'
  geometry: GeoJsonGeometryPolygon
  properties: GeoJsonProperty
  type: GeoJsonFeatureType
}

export type GeoJsonFeatureInput = {
  geometry: GeoJsonGeometryInput
  type: Scalars['String']['input']
}

export enum GeoJsonFeatureType {
  Feature = 'Feature',
}

export type GeoJsonGeometryInput = {
  coordinates: Array<Array<Scalars['Float']['input']>>
  type: Scalars['String']['input']
}

export type GeoJsonGeometryPolygon = {
  __typename?: 'GeoJsonGeometryPolygon'
  /** Arrays of coordinates, first longitude, second latitude */
  coordinates: Array<Array<Array<Scalars['Float']['output']>>>
  type: GeoJsonGeometryType
}

export enum GeoJsonGeometryType {
  Polygon = 'Polygon',
}

export type GeoJsonProperty = {
  __typename?: 'GeoJsonProperty'
  hub: Maybe<Scalars['String']['output']>
}

export enum GeoJsonType {
  FeatureCollection = 'FeatureCollection',
}

export type Geolocation = {
  __typename?: 'Geolocation'
  heading: Maybe<Scalars['Float']['output']>
  latitude: Scalars['Float']['output']
  longitude: Scalars['Float']['output']
}

export type GeolocationInput = {
  heading?: InputMaybe<Scalars['Float']['input']>
  latitude: Scalars['Float']['input']
  longitude: Scalars['Float']['input']
}

export type Geometry = {
  geoJson: Scalars['String']['output']
}

export type GeonetCoverageHeatmapDataPoint = {
  __typename?: 'GeonetCoverageHeatmapDataPoint'
  avgDuration: Scalars['Float']['output']
  geojsonGeometry: Scalars['String']['output']
  maxSpeedKmh: Scalars['Float']['output']
  metroLocation: Scalars['String']['output']
  osmEdgeCount: Scalars['Int']['output']
  osmEdgeId: Scalars['Float']['output']
  streetName: Scalars['String']['output']
  successRate: Scalars['Float']['output']
  swVersion: Scalars['String']['output']
}

export type GetIncidentsResponse = {
  __typename?: 'GetIncidentsResponse'
  description: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  resolved: Scalars['Boolean']['output']
  severity: Severity
  title: Scalars['String']['output']
}

export type GooglePay = {
  __typename?: 'GooglePay'
  /** Fake field because GraphQL does not support empty objects. Do not query, use __typename instead. */
  _: Maybe<Scalars['Boolean']['output']>
}

export type GrantPermissionCloseDoorInput = {
  vehicleId: Scalars['ID']['input']
}

/** The operation the model generated. */
export type GraphQlGeniusOperationResult = {
  __typename?: 'GraphQLGeniusOperationResult'
  /** Comments that the model added to the operation for additional help or context */
  comments: Maybe<Scalars['String']['output']>
  /** Errors or problems with the request the model encountered */
  error: Maybe<Scalars['String']['output']>
  /** Valid GraphQL Operation */
  operation: Maybe<Scalars['String']['output']>
  /** The sessionId can be used for the next request to continue the conversation. */
  sessionId: Maybe<Scalars['ID']['output']>
  /** Variables used in the operation encoded as JSON string */
  variables: Maybe<Scalars['String']['output']>
}

/**
 * If the model response is not adhearing to the schema of the default system prompt, the raw response will be returned.
 * This is the case if you overwrite the system prompt.
 */
export type GraphQlGeniusRawResult = {
  __typename?: 'GraphQLGeniusRawResult'
  response: Maybe<Scalars['String']['output']>
  /** The sessionId can be used for the next request to continue the conversation. */
  sessionId: Maybe<Scalars['ID']['output']>
}

export type GraphQlGeniusResult =
  | GraphQlGeniusOperationResult
  | GraphQlGeniusRawResult

export type GraphQlGeniusWriteOperationInput = {
  /**
   * A description of what the operation should do.
   * Example: "Get pooling flag of vehicle example-id"
   */
  prompt: Scalars['String']['input']
  /**
   * The sessionId can be used to continue a previous conversation.
   * It is returned in the response of the previous request.
   */
  sessionId?: InputMaybe<Scalars['ID']['input']>
  /** You can overwrite the default system prompt */
  systemPrompt?: InputMaybe<Scalars['String']['input']>
}

export enum GreengrassProvisioningState {
  CertPending = 'CERT_PENDING',
  DeploymentPending = 'DEPLOYMENT_PENDING',
  Draft = 'DRAFT',
  Failed = 'FAILED',
  Success = 'SUCCESS',
}

export enum GroupType {
  AdminPanel = 'ADMIN_PANEL',
  Backoffice = 'BACKOFFICE',
}

export type HardwareConfiguration = {
  __typename?: 'HardwareConfiguration'
  boxPc: BoxPc
  camera: Camera
  cdisBox: CdisBox
  keyRfid: Scalars['String']['output']
  router: Router
  tablet: Maybe<Tablet>
}

export type Heatmap = {
  __typename?: 'Heatmap'
  createdAt: Scalars['DateTime']['output']
  /** format for each element is [lat, lon, value] */
  data: Array<Array<Scalars['Float']['output']>>
  /** space between points in the raster (meters) */
  rasterSize: Scalars['Int']['output']
  stats: HeatmapStats
}

export type HeatmapConfig = {
  __typename?: 'HeatmapConfig'
  /** Whether the stop network heatmap is enabled for this service area. Defaults to true when never configured. */
  enabled: Scalars['Boolean']['output']
}

export type HeatmapConfigInput = {
  /** Whether the stop network heatmap is enabled for this service area */
  enabled: Scalars['Boolean']['input']
}

export type HeatmapData = {
  __typename?: 'HeatmapData'
  disengagements: Array<DisengagementHeatmapDataPoint>
  geonetCoverage: Array<GeonetCoverageHeatmapDataPoint>
  pce: Array<PceHeatmapDataPoint>
}

export type HeatmapFilterInput = {
  disengagementReasons?: InputMaybe<Array<Scalars['String']['input']>>
  endTimestampMs?: InputMaybe<Scalars['Float']['input']>
  eventTypes?: InputMaybe<Array<Scalars['String']['input']>>
  initiators?: InputMaybe<Array<Scalars['String']['input']>>
  softwareVersions?: InputMaybe<Array<Scalars['String']['input']>>
  startTimestampMs?: InputMaybe<Scalars['Float']['input']>
}

export type HeatmapFilters = {
  __typename?: 'HeatmapFilters'
  disengagementReasons: Array<Scalars['String']['output']>
  earliestTimestampMs: Maybe<Scalars['Float']['output']>
  eventTypes: Array<Scalars['String']['output']>
  initiators: Array<Scalars['String']['output']>
  latestTimestampMs: Maybe<Scalars['Float']['output']>
  softwareVersions: Array<Scalars['String']['output']>
}

export type HeatmapStats = {
  __typename?: 'HeatmapStats'
  avg: Scalars['Float']['output']
  max: Scalars['Float']['output']
  min: Scalars['Float']['output']
  p10: Scalars['Float']['output']
  p20: Scalars['Float']['output']
  p30: Scalars['Float']['output']
  p40: Scalars['Float']['output']
  p50: Scalars['Float']['output']
  p60: Scalars['Float']['output']
  p70: Scalars['Float']['output']
  p80: Scalars['Float']['output']
  p90: Scalars['Float']['output']
}

export enum HeatmapType {
  HeatmapTypeDisengagements = 'HEATMAP_TYPE_DISENGAGEMENTS',
  HeatmapTypeGeonetCoverage = 'HEATMAP_TYPE_GEONET_COVERAGE',
  HeatmapTypePotentialCriticalEvents = 'HEATMAP_TYPE_POTENTIAL_CRITICAL_EVENTS',
}

export type HistoryFieldChange = {
  __typename?: 'HistoryFieldChange'
  fieldName: Scalars['String']['output']
  from: Maybe<Scalars['String']['output']>
  to: Maybe<Scalars['String']['output']>
}

export type HistoryItem = {
  __typename?: 'HistoryItem'
  /** user who changed the action which affected this item */
  actionChangedBy: Maybe<Scalars['String']['output']>
  changedAt: Scalars['DateTime']['output']
  changedBy: Scalars['String']['output']
  changes: Array<HistoryFieldChange>
  eventItemId: Scalars['String']['output']
  eventItemType: EventItemType
  serviceAreaId: Scalars['String']['output']
}

export type HistoryItems = {
  __typename?: 'HistoryItems'
  items: Array<HistoryItem>
  nextCursor: Maybe<Scalars['String']['output']>
}

export type Hub = {
  __typename?: 'Hub'
  /** @deprecated Fleet legacy field, replace with geometry */
  area: Maybe<GeoJson>
  areaCapacityConfiguration: Maybe<AreaCapacityConfiguration>
  changeDescription: Maybe<Scalars['String']['output']>
  city: Scalars['String']['output']
  contact: Scalars['String']['output']
  displayName: Scalars['String']['output']
  /** The hub's geometry as a GeoJSON string */
  geometry: Scalars['String']['output']
  id: Scalars['ID']['output']
  location: Location
  name: Scalars['String']['output']
  phoneNumber: Scalars['String']['output']
  postcode: Scalars['String']['output']
  serviceAreaUUID: Scalars['ID']['output']
  streetAndNumber: Scalars['String']['output']
}

export enum HubArrivalOrDepartureType {
  BreakEndDeparture = 'BREAK_END_DEPARTURE',
  BreakStartArrival = 'BREAK_START_ARRIVAL',
  ShiftEndArrival = 'SHIFT_END_ARRIVAL',
  ShiftStartDeparture = 'SHIFT_START_DEPARTURE',
}

export type HubArrivalsOrDeparturesByType = {
  __typename?: 'HubArrivalsOrDeparturesByType'
  total: Scalars['Int']['output']
  type: HubArrivalOrDepartureType
}

export type HubDataInput = {
  changeDescription?: InputMaybe<Scalars['String']['input']>
  city: Scalars['String']['input']
  contact: Scalars['String']['input']
  description?: InputMaybe<Scalars['String']['input']>
  displayName: Scalars['String']['input']
  /** The hub's geometry as a GeoJSON string */
  geometry?: InputMaybe<Scalars['String']['input']>
  location: LocationInput
  name: Scalars['String']['input']
  phoneNumber: Scalars['String']['input']
  postcode: Scalars['String']['input']
  serviceAreaUUID: Scalars['ID']['input']
  streetAndNumber: Scalars['String']['input']
}

export type HubDetails = {
  __typename?: 'HubDetails'
  city: Scalars['String']['output']
  contact: Scalars['String']['output']
  displayName: Scalars['String']['output']
  hubStop: Maybe<NavigationStop>
  phoneNumber: Scalars['String']['output']
  postcode: Scalars['String']['output']
  streetAndNumber: Scalars['String']['output']
}

export type HubLogRecordInput = {
  employeeId: Scalars['ID']['input']
  hubId: Scalars['ID']['input']
}

export type HubReturn = {
  __typename?: 'HubReturn'
  area: Maybe<Area>
  scheduledArrival: Scalars['DateTime']['output']
  type: HubReturnType
}

export enum HubReturnReason {
  DriverBreak = 'DRIVER_BREAK',
  OnDemand = 'ON_DEMAND',
  ShiftEnd = 'SHIFT_END',
  ShortBreak = 'SHORT_BREAK',
}

export enum HubReturnType {
  BreakStart = 'BREAK_START',
  ShiftEnd = 'SHIFT_END',
}

export type HubServiceNotification = TaskNotification & {
  __typename?: 'HubServiceNotification'
  actionType: TaskActionType
  assigned: Maybe<TaskStateChangeDetails>
  createdAt: Scalars['DateTime']['output']
  employee: Maybe<Employee>
  fleetId: Maybe<Scalars['ID']['output']>
  foreignId: Scalars['ID']['output']
  id: Scalars['ID']['output']
  note: Maybe<TaskNotificationNote>
  notificationType: TaskNotificationType
  pended: Maybe<TaskStateChangeDetails>
  regionId: Maybe<Scalars['ID']['output']>
  resolved: Maybe<TaskStateChangeDetails>
  serviceAreaUUID: Scalars['ID']['output']
  severity: TaskNotificationSeverity
  shift: Maybe<Shift>
  stateChanges: Array<TaskStateChangeDetails>
  status: TaskNotificationStatus
  vehicle: Maybe<Vehicle>
  version: Scalars['Int']['output']
}

export type HubsResponse = {
  __typename?: 'HubsResponse'
  hubs: Array<Hub>
  total: Scalars['Int']['output']
}

export type IBackofficeUserIdentity = {
  firstName: Scalars['String']['output']
  id: Scalars['ID']['output']
  lastName: Scalars['String']['output']
}

export type Ignition = {
  __typename?: 'Ignition'
  ignitionState: Maybe<IgnitionState>
  /** Last time the ignition switched state */
  updatedAt: Maybe<Scalars['DateTime']['output']>
}

export enum IgnitionState {
  Off = 'OFF',
  On = 'ON',
}

export enum ImportStatus {
  Completed = 'COMPLETED',
  Processing = 'PROCESSING',
}

export enum ImportType {
  Coordinate = 'COORDINATE',
  Generated = 'GENERATED',
  Verbose = 'VERBOSE',
}

export type InAppMessage = {
  __typename?: 'InAppMessage'
  /** When this message was created (and therefore became the 'ACTIVE' message). */
  createdAt: Scalars['Instant']['output']
  customerTenant: Scalars['String']['output']
  description: LocalizedString
  /** When this message was archived. Unset if the message is currently 'ACTIVE'. */
  endDate: Maybe<Scalars['Instant']['output']>
  status: InAppMessageStatus
  title: LocalizedString
}

export type InAppMessageCreateInput = {
  description: LocalizedStringInput
  title: LocalizedStringInput
}

export enum InAppMessageStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
}

export type InAppMessageUpdateInput = {
  description: LocalizedStringInput
  title: LocalizedStringInput
}

export type InFieldBreakDetails = {
  __typename?: 'InFieldBreakDetails'
  stop: Maybe<NavigationStop>
}

export enum InactiveReasonCategory {
  ActivationPeriod = 'ACTIVATION_PERIOD',
  AuthorityApprovalPending = 'AUTHORITY_APPROVAL_PENDING',
  BadStopVoting = 'BAD_STOP_VOTING',
  Complaint = 'COMPLAINT',
  ConstructionSite = 'CONSTRUCTION_SITE',
  Demo = 'DEMO',
  IndividualEvent = 'INDIVIDUAL_EVENT',
  Other = 'OTHER',
  OutOfServiceArea = 'OUT_OF_SERVICE_AREA',
  PolygonUpdate = 'POLYGON_UPDATE',
  RecurringEvent = 'RECURRING_EVENT',
  ScheduledForDeletionWithin_24Hours = 'SCHEDULED_FOR_DELETION_WITHIN_24_HOURS',
  Stvo = 'STVO',
  Unreachable = 'UNREACHABLE',
}

export type IncidentFilterInput = {
  /** @deprecated Not used anymore. */
  calcFalseNegativeTrigger?: InputMaybe<Scalars['Int']['input']>
  /** @deprecated Not used anymore. */
  calcFalsePositiveTrigger?: InputMaybe<Scalars['Int']['input']>
  /** @deprecated Use `calcFalseNegativeTrigger` instead. */
  calc_false_negative_trigger?: InputMaybe<Scalars['Int']['input']>
  /** @deprecated Use `calcFalsePositiveTrigger` instead. */
  calc_false_positive_trigger?: InputMaybe<Scalars['Int']['input']>
  createdAfter?: InputMaybe<Scalars['DateTime']['input']>
  createdBefore?: InputMaybe<Scalars['DateTime']['input']>
  /** @deprecated Use `createdAfter` instead. */
  created_after?: InputMaybe<Scalars['DateTime']['input']>
  /** @deprecated Use `createdBefore` instead. */
  created_before?: InputMaybe<Scalars['DateTime']['input']>
  /** @deprecated Not used anymore. */
  deadlock?: InputMaybe<Scalars['Int']['input']>
  /** @deprecated Use `locations` instead, which accepts several values. */
  location?: InputMaybe<Scalars['String']['input']>
  locations?: InputMaybe<Array<Scalars['String']['input']>>
  /** @deprecated Not used anymore. */
  notDeadlockStandstill?: InputMaybe<Scalars['Int']['input']>
  /** @deprecated Use `notDeadlockStandstill` instead. */
  not_deadlock_standstill?: InputMaybe<Scalars['Int']['input']>
  /** @deprecated Not used anymore. */
  raExecFail?: InputMaybe<Scalars['Int']['input']>
  /** @deprecated Not used anymore. */
  raExecuted?: InputMaybe<Scalars['Int']['input']>
  /** @deprecated Use `raExecFail` instead. */
  ra_exec_fail?: InputMaybe<Scalars['Int']['input']>
  /** @deprecated Use `raExecuted` instead. */
  ra_executed?: InputMaybe<Scalars['Int']['input']>
  /** Free-text match against the session id and the root cause. */
  searchBy?: InputMaybe<Scalars['String']['input']>
  /** @deprecated Use `softwareVersions` instead, which accepts several values. */
  softwareVersion?: InputMaybe<Scalars['String']['input']>
  softwareVersions?: InputMaybe<Array<Scalars['String']['input']>>
  /** @deprecated Use `softwareVersions` instead, which accepts several values. */
  software_version?: InputMaybe<Scalars['String']['input']>
  /** @deprecated Not used anymore. */
  wrongAnnot?: InputMaybe<Scalars['Int']['input']>
  /** @deprecated Use `wrongAnnot` instead. */
  wrong_annot?: InputMaybe<Scalars['Int']['input']>
}

export type IncidentResponse = {
  __typename?: 'IncidentResponse'
  calcFalseNegativeTrigger: Maybe<Scalars['Int']['output']>
  calcFalsePositiveTrigger: Maybe<Scalars['Int']['output']>
  /** @deprecated Use `calcFalseNegativeTrigger` instead. */
  calc_false_negative_trigger: Maybe<Scalars['Boolean']['output']>
  /** @deprecated Use `calcFalseNegativeTrigger` instead. */
  calc_false_negative_trigger_int: Maybe<Scalars['Int']['output']>
  /** @deprecated Use `calcFalsePositiveTrigger` instead. */
  calc_false_positive_trigger: Maybe<Scalars['Boolean']['output']>
  /** @deprecated Use `calcFalsePositiveTrigger` instead. */
  calc_false_positive_trigger_int: Maybe<Scalars['Int']['output']>
  createdAt: Maybe<Scalars['DateTime']['output']>
  /** @deprecated Use `createdAt` instead. */
  created_at: Scalars['DateTime']['output']
  /** @deprecated Use `deadlockInt` instead. */
  deadlock: Maybe<Scalars['Boolean']['output']>
  deadlockInt: Maybe<Scalars['Int']['output']>
  /** @deprecated Use `deadlockInt` instead. */
  deadlock_int: Maybe<Scalars['Int']['output']>
  /** @deprecated Not used anymore. */
  diagCheckPopUp: Maybe<Scalars['Boolean']['output']>
  /** @deprecated Not used anymore. */
  diagControlTransitionIssue: Maybe<Scalars['String']['output']>
  /** @deprecated Not used anymore. */
  diagGfiControlSwitch: Maybe<Scalars['Int']['output']>
  /** @deprecated Not used anymore. */
  diagGfiMax: Maybe<Scalars['Int']['output']>
  /** @deprecated Not used anymore. */
  diagGfiMin: Maybe<Scalars['Int']['output']>
  /** @deprecated Not used anymore. */
  diagMinSpeed: Maybe<Scalars['Float']['output']>
  /** @deprecated Not used anymore. */
  diagPopUp: Maybe<Scalars['String']['output']>
  /** @deprecated Not used anymore. */
  diagTakeover: Maybe<Scalars['Int']['output']>
  /** @deprecated Not used anymore. */
  diag_check_pop_up: Maybe<Scalars['Boolean']['output']>
  /** @deprecated Not used anymore. */
  diag_control_transition_issue: Maybe<Scalars['String']['output']>
  /** @deprecated Not used anymore. */
  diag_gfi_control_switch: Maybe<Scalars['Int']['output']>
  /** @deprecated Not used anymore. */
  diag_gfi_max: Maybe<Scalars['Int']['output']>
  /** @deprecated Not used anymore. */
  diag_gfi_min: Maybe<Scalars['Int']['output']>
  /** @deprecated Not used anymore. */
  diag_min_speed: Maybe<Scalars['Float']['output']>
  /** @deprecated Not used anymore. */
  diag_pop_up: Maybe<Scalars['String']['output']>
  /** @deprecated Not used anymore. */
  diag_takeover: Maybe<Scalars['Int']['output']>
  location: Maybe<Scalars['String']['output']>
  notDeadlockStandstill: Maybe<Scalars['Int']['output']>
  /** @deprecated Use `notDeadlockStandstill` instead. */
  not_deadlock_standstill: Maybe<Scalars['Boolean']['output']>
  /** @deprecated Use `notDeadlockStandstill` instead. */
  not_deadlock_standstill_int: Maybe<Scalars['Int']['output']>
  /** @deprecated Not used anymore. */
  processedAt: Scalars['DateTime']['output']
  /** @deprecated Not used anymore. */
  processed_at: Scalars['DateTime']['output']
  raExecFail: Maybe<Scalars['Int']['output']>
  raExecuted: Maybe<Scalars['Int']['output']>
  /** @deprecated Use `raExecFail` instead. */
  ra_exec_fail: Maybe<Scalars['Boolean']['output']>
  /** @deprecated Use `raExecFail` instead. */
  ra_exec_fail_int: Maybe<Scalars['Int']['output']>
  /** @deprecated Use `raExecuted` instead. */
  ra_executed: Maybe<Scalars['Boolean']['output']>
  /** @deprecated Use `raExecuted` instead. */
  ra_executed_int: Maybe<Scalars['Int']['output']>
  rootCause: Maybe<Scalars['String']['output']>
  sdsProviderId: Scalars['ID']['output']
  /** @deprecated Use `sdsProviderId` instead. */
  sds_provider_id: Scalars['ID']['output']
  sessionId: Scalars['String']['output']
  /** @deprecated Use `sessionId` instead. */
  session_id: Scalars['String']['output']
  softwareVersion: Maybe<Scalars['String']['output']>
  /** @deprecated Use `softwareVersion` instead. */
  software_version: Maybe<Scalars['String']['output']>
  wrongAnnot: Maybe<Scalars['Int']['output']>
  /** @deprecated Use `wrongAnnot` instead. */
  wrong_annot: Maybe<Scalars['Boolean']['output']>
  /** @deprecated Use `wrongAnnot` instead. */
  wrong_annot_int: Maybe<Scalars['Int']['output']>
}

/** Severity classification of a vehicle incident */
export enum IncidentSeverity {
  /** Emergency response, IFA dispatch */
  Accident = 'ACCIDENT',
  /** Vehicle pulls over, operator confirms, comms required */
  Critical = 'CRITICAL',
  /** Monitor, consider route change, flag for hub */
  Major = 'MAJOR',
  /** Auto-log, end-of-day maintenance */
  Minor = 'MINOR',
  /** Log, batch review */
  Moderate = 'MODERATE',
}

/** Whether a vehicle incident is currently active or has been resolved */
export enum IncidentState {
  /** Incident is ongoing */
  Active = 'ACTIVE',
  /** Incident has been resolved */
  Inactive = 'INACTIVE',
}

export enum IncidentTypeIds {
  AirbagSystemError = 'AIRBAG_SYSTEM_ERROR',
  AutomaticEmergencyBrakeAebOff = 'AUTOMATIC_EMERGENCY_BRAKE_AEB_OFF',
  AutomaticEmergencyBrakeEscOff = 'AUTOMATIC_EMERGENCY_BRAKE_ESC_OFF',
  AutomaticEmergencyBrakeNoSensorView = 'AUTOMATIC_EMERGENCY_BRAKE_NO_SENSOR_VIEW',
  AutomaticEmergencyBrakeSystemError = 'AUTOMATIC_EMERGENCY_BRAKE_SYSTEM_ERROR',
  BatteryManagementChargingStatusOfHvChargingError = 'BATTERY_MANAGEMENT_CHARGING_STATUS_OF_HV_CHARGING_ERROR',
  BatteryManagementChargingStatusOfLvBatteryError = 'BATTERY_MANAGEMENT_CHARGING_STATUS_OF_LV_BATTERY_ERROR',
  BatteryManagementDcdcConverterDefective = 'BATTERY_MANAGEMENT_DCDC_CONVERTER_DEFECTIVE',
  BatteryManagementGeneratorDefective = 'BATTERY_MANAGEMENT_GENERATOR_DEFECTIVE',
  BatteryManagementRequestForBatteryService = 'BATTERY_MANAGEMENT_REQUEST_FOR_BATTERY_SERVICE',
  BodyControlModuleBrakeFluidBelowMinThreshold = 'BODY_CONTROL_MODULE_BRAKE_FLUID_BELOW_MIN_THRESHOLD',
  BodyControlModuleBrakePadBelowMinThreshold = 'BODY_CONTROL_MODULE_BRAKE_PAD_BELOW_MIN_THRESHOLD',
  BodyControlModuleCoolingFluidBelowMinThreshold = 'BODY_CONTROL_MODULE_COOLING_FLUID_BELOW_MIN_THRESHOLD',
  BodyControlModuleHoodOpenHightVel = 'BODY_CONTROL_MODULE_HOOD_OPEN_HIGHT_VEL',
  BodyControlModuleHoodOpenLowVel = 'BODY_CONTROL_MODULE_HOOD_OPEN_LOW_VEL',
  BodyControlModuleWasherFluidBelowMinThreshold = 'BODY_CONTROL_MODULE_WASHER_FLUID_BELOW_MIN_THRESHOLD',
  ButtonSr2Jammed = 'BUTTON_SR2_JAMMED',
  ButtonSr3Jammed = 'BUTTON_SR3_JAMMED',
  ChargingStatusLow = 'CHARGING_STATUS_LOW',
  ChildProtectionErrorDefect = 'CHILD_PROTECTION_ERROR_DEFECT',
  ClampControlEmergencyShutdownTextInInstrumentCluster = 'CLAMP_CONTROL_EMERGENCY_SHUTDOWN_TEXT_IN_INSTRUMENT_CLUSTER',
  ClampControlWorkshopTextInInstrumentCluster = 'CLAMP_CONTROL_WORKSHOP_TEXT_IN_INSTRUMENT_CLUSTER',
  ClimateSensorExternalTempSensorError = 'CLIMATE_SENSOR_EXTERNAL_TEMP_SENSOR_ERROR',
  ClimateSensorStatusExternalTempFault = 'CLIMATE_SENSOR_STATUS_EXTERNAL_TEMP_FAULT',
  CollisionWObjectLateralImpactDetected = 'COLLISION_W_OBJECT_LATERAL_IMPACT_DETECTED',
  CollisionWObjectLevel_1 = 'COLLISION_W_OBJECT_LEVEL_1',
  CollisionWObjectLevel_2 = 'COLLISION_W_OBJECT_LEVEL_2',
  CoolingSdsComputerMainThermomanagementCoolantTemperatureWarningSafetyDriverAboveThreshold = 'COOLING_SDS_COMPUTER_MAIN_THERMOMANAGEMENT_COOLANT_TEMPERATURE_WARNING_SAFETY_DRIVER_ABOVE_THRESHOLD',
  CoolingSdsComputerMainThermomanagementCoolantTemperatureWarningSafetyDriverTooHigh = 'COOLING_SDS_COMPUTER_MAIN_THERMOMANAGEMENT_COOLANT_TEMPERATURE_WARNING_SAFETY_DRIVER_TOO_HIGH',
  CoPilotDetectionErrorInSeatOccupancyMat = 'CO_PILOT_DETECTION_ERROR_IN_SEAT_OCCUPANCY_MAT',
  DiagnosisAutonomousDrivingAvsAuthAvsAuthorityOvertakeSecondarySdsComputerError = 'DIAGNOSIS_AUTONOMOUS_DRIVING_AVS_AUTH_AVS_AUTHORITY_OVERTAKE_SECONDARY_SDS_COMPUTER_ERROR',
  DiagnosisAutonomousDrivingAvsErrorAvsAuthorityOvertakeSecondarySdsComputerError = 'DIAGNOSIS_AUTONOMOUS_DRIVING_AVS_ERROR_AVS_AUTHORITY_OVERTAKE_SECONDARY_SDS_COMPUTER_ERROR',
  DiagnosisAutonomousDrivingCarOvertakeErrorCavsAndAvsError = 'DIAGNOSIS_AUTONOMOUS_DRIVING_CAR_OVERTAKE_ERROR_CAVS_AND_AVS_ERROR',
  DiagnosisAutonomousDrivingCarOvertakeErrorCavsAndAvsErrorHigh = 'DIAGNOSIS_AUTONOMOUS_DRIVING_CAR_OVERTAKE_ERROR_CAVS_AND_AVS_ERROR_HIGH',
  DiagnosisAutonomousDrivingCarOvertakeErrorCavsAndAvsErrorLow = 'DIAGNOSIS_AUTONOMOUS_DRIVING_CAR_OVERTAKE_ERROR_CAVS_AND_AVS_ERROR_LOW',
  DiagnosisAutonomousDrivingCarOvertakeErrorCavsAndAvsErrorMedium = 'DIAGNOSIS_AUTONOMOUS_DRIVING_CAR_OVERTAKE_ERROR_CAVS_AND_AVS_ERROR_MEDIUM',
  DiagnosisAutonomousDrivingCarOvertakeErrorCavsAndAvsUnplausibleStatAuthority = 'DIAGNOSIS_AUTONOMOUS_DRIVING_CAR_OVERTAKE_ERROR_CAVS_AND_AVS_UNPLAUSIBLE_STAT_AUTHORITY',
  DiagnosisAutonomousDrivingCarOvertakeErrorInterfaceDrivingStatusDtm = 'DIAGNOSIS_AUTONOMOUS_DRIVING_CAR_OVERTAKE_ERROR_INTERFACE_DRIVING_STATUS_DTM',
  DiagnosisAutonomousDrivingCarOvertakeErrorMrc_2A = 'DIAGNOSIS_AUTONOMOUS_DRIVING_CAR_OVERTAKE_ERROR_MRC_2A',
  DiagnosisAutonomousDrivingCarOvertakeErrorMrcEmergencyBrakingImpactSuspected = 'DIAGNOSIS_AUTONOMOUS_DRIVING_CAR_OVERTAKE_ERROR_MRC_EMERGENCY_BRAKING_IMPACT_SUSPECTED',
  DiagnosisAutonomousDrivingCarOvertakeErrorMrcImpactDetected = 'DIAGNOSIS_AUTONOMOUS_DRIVING_CAR_OVERTAKE_ERROR_MRC_IMPACT_DETECTED',
  DiagnosisAutonomousDrivingCarOvertakeErrorMrcPullover = 'DIAGNOSIS_AUTONOMOUS_DRIVING_CAR_OVERTAKE_ERROR_MRC_PULLOVER',
  DiagnosisAutonomousDrivingCarOvertakeErrorMrcStop = 'DIAGNOSIS_AUTONOMOUS_DRIVING_CAR_OVERTAKE_ERROR_MRC_STOP',
  DiagnosisAutonomousDrivingCavsAuthCavsAuthorityOvertakeSecondarySdsComputerError = 'DIAGNOSIS_AUTONOMOUS_DRIVING_CAVS_AUTH_CAVS_AUTHORITY_OVERTAKE_SECONDARY_SDS_COMPUTER_ERROR',
  DiagnosisAutonomousDrivingCavsErrorCavsAuthorityOvertakePrimarySdsComputerError = 'DIAGNOSIS_AUTONOMOUS_DRIVING_CAVS_ERROR_CAVS_AUTHORITY_OVERTAKE_PRIMARY_SDS_COMPUTER_ERROR',
  DimmingErrorKl_58XdDisplayAndInformationLighting = 'DIMMING_ERROR_KL_58XD_DISPLAY_AND_INFORMATION_LIGHTING',
  DimmingErrorKl_58XsSwitchSearchLights = 'DIMMING_ERROR_KL_58XS_SWITCH_SEARCH_LIGHTS',
  DimmingErrorKl_58XtTimerTriggeredSearchLightsEGStartStopButton = 'DIMMING_ERROR_KL_58XT_TIMER_TRIGGERED_SEARCH_LIGHTS_E_G_START_STOP_BUTTON',
  DoorLockDefect = 'DOOR_LOCK_DEFECT',
  DoorStatusError = 'DOOR_STATUS_ERROR',
  ElectronicBrakeBoosterFailure_2NdActuator = 'ELECTRONIC_BRAKE_BOOSTER_FAILURE_2ND_ACTUATOR',
  ElectronicBrakeBoosterFailureEbbWithoutHydraulicBb = 'ELECTRONIC_BRAKE_BOOSTER_FAILURE_EBB_WITHOUT_HYDRAULIC_BB',
  ElectronicBrakeBoosterFailureStandstillManagement = 'ELECTRONIC_BRAKE_BOOSTER_FAILURE_STANDSTILL_MANAGEMENT',
  ElectronicBrakeBoosterReductionOfBrakeBoost = 'ELECTRONIC_BRAKE_BOOSTER_REDUCTION_OF_BRAKE_BOOST',
  ElectronicParkBrakeFailureStartUpAssistant = 'ELECTRONIC_PARK_BRAKE_FAILURE_START_UP_ASSISTANT',
  ElectronicParkBrakeFaultSlopeHoldingAbility = 'ELECTRONIC_PARK_BRAKE_FAULT_SLOPE_HOLDING_ABILITY',
  ElectronicParkBrakeInclinationOfSlopeTooHigh = 'ELECTRONIC_PARK_BRAKE_INCLINATION_OF_SLOPE_TOO_HIGH',
  ElectronicParkBrakeSystemError = 'ELECTRONIC_PARK_BRAKE_SYSTEM_ERROR',
  ElectronicPowerControlFaultService = 'ELECTRONIC_POWER_CONTROL_FAULT_SERVICE',
  ElectronicPowerControlFaultVehicleStop = 'ELECTRONIC_POWER_CONTROL_FAULT_VEHICLE_STOP',
  ElectronicPowerControlPowerRestriction = 'ELECTRONIC_POWER_CONTROL_POWER_RESTRICTION',
  ElectronicStabilityProgramAbsLamp = 'ELECTRONIC_STABILITY_PROGRAM_ABS_LAMP',
  ElectronicStabilityProgramActiveTractionControl = 'ELECTRONIC_STABILITY_PROGRAM_ACTIVE_TRACTION_CONTROL',
  ElectronicStabilityProgramElectricalErrorWOEffectOnBrakeForceDistribution = 'ELECTRONIC_STABILITY_PROGRAM_ELECTRICAL_ERROR_W_O_EFFECT_ON_BRAKE_FORCE_DISTRIBUTION',
  ElectronicStabilityProgramErrorElectronicBrakeForceDistribution = 'ELECTRONIC_STABILITY_PROGRAM_ERROR_ELECTRONIC_BRAKE_FORCE_DISTRIBUTION',
  ElectronicStabilityProgramErrorLateralAcceleration = 'ELECTRONIC_STABILITY_PROGRAM_ERROR_LATERAL_ACCELERATION',
  ElectronicStabilityProgramErrorLongitudinalAcceleration = 'ELECTRONIC_STABILITY_PROGRAM_ERROR_LONGITUDINAL_ACCELERATION',
  ElectronicStabilityProgramErrorQbitLateralAcceleration = 'ELECTRONIC_STABILITY_PROGRAM_ERROR_QBIT_LATERAL_ACCELERATION',
  ElectronicStabilityProgramErrorQbitLongitudinalAcceleration = 'ELECTRONIC_STABILITY_PROGRAM_ERROR_QBIT_LONGITUDINAL_ACCELERATION',
  ElectronicStabilityProgramErrorVelocitySignal = 'ELECTRONIC_STABILITY_PROGRAM_ERROR_VELOCITY_SIGNAL',
  ElectronicStabilityProgramErrorWheelTickSignal = 'ELECTRONIC_STABILITY_PROGRAM_ERROR_WHEEL_TICK_SIGNAL',
  ElectronicStabilityProgramEscFaultTextInInstrumentCluster = 'ELECTRONIC_STABILITY_PROGRAM_ESC_FAULT_TEXT_IN_INSTRUMENT_CLUSTER',
  ElectronicStabilityProgramEscFaultTextInInstrumentClusterRed = 'ELECTRONIC_STABILITY_PROGRAM_ESC_FAULT_TEXT_IN_INSTRUMENT_CLUSTER_RED',
  ElectronicStabilityProgramEscLampOn = 'ELECTRONIC_STABILITY_PROGRAM_ESC_LAMP_ON',
  ElectronicStabilityProgramEscLampShortBlink = 'ELECTRONIC_STABILITY_PROGRAM_ESC_LAMP_SHORT_BLINK',
  ElectronicStabilityProgramUndervoltageVelocitySignal = 'ELECTRONIC_STABILITY_PROGRAM_UNDERVOLTAGE_VELOCITY_SIGNAL',
  EmergencyStopButtonPressed = 'EMERGENCY_STOP_BUTTON_PRESSED',
  EventDataRecorderEdrAdDataLoggerCrashAutomaticTriggerDssd = 'EVENT_DATA_RECORDER_EDR_AD_DATA_LOGGER_CRASH_AUTOMATIC_TRIGGER_DSSD',
  EventDataRecorderEdrAdDataLoggerCrashAutomaticTriggerEdr = 'EVENT_DATA_RECORDER_EDR_AD_DATA_LOGGER_CRASH_AUTOMATIC_TRIGGER_EDR',
  ESoundDefectiveError = 'E_SOUND_DEFECTIVE_ERROR',
  FrontLightsAllFrontLightsLeftRightDefect = 'FRONT_LIGHTS_ALL_FRONT_LIGHTS_LEFT_RIGHT_DEFECT',
  FrontLightsAutomaticHighBeamAssistDefect = 'FRONT_LIGHTS_AUTOMATIC_HIGH_BEAM_ASSIST_DEFECT',
  FrontLightsAutomaticHighBeamAssistSensorBlocked = 'FRONT_LIGHTS_AUTOMATIC_HIGH_BEAM_ASSIST_SENSOR_BLOCKED',
  FrontLightsCombinatedLightDefect = 'FRONT_LIGHTS_COMBINATED_LIGHT_DEFECT',
  FrontLightsDaytimeRunningLightLeftRightDefect = 'FRONT_LIGHTS_DAYTIME_RUNNING_LIGHT_LEFT_RIGHT_DEFECT',
  FrontLightsFogLightLeftRightDefect = 'FRONT_LIGHTS_FOG_LIGHT_LEFT_RIGHT_DEFECT',
  FrontLightsHeadLightRangeControlError = 'FRONT_LIGHTS_HEAD_LIGHT_RANGE_CONTROL_ERROR',
  FrontLightsHighBeamLeftRightDefectDay = 'FRONT_LIGHTS_HIGH_BEAM_LEFT_RIGHT_DEFECT_DAY',
  FrontLightsHighBeamLeftRightDefectNight = 'FRONT_LIGHTS_HIGH_BEAM_LEFT_RIGHT_DEFECT_NIGHT',
  FrontLightsIndicatorLeftRightDefect = 'FRONT_LIGHTS_INDICATOR_LEFT_RIGHT_DEFECT',
  FrontLightsIndicatorLeftRightSideDefect = 'FRONT_LIGHTS_INDICATOR_LEFT_RIGHT_SIDE_DEFECT',
  FrontLightsLowBeamLeftRightDefectDay = 'FRONT_LIGHTS_LOW_BEAM_LEFT_RIGHT_DEFECT_DAY',
  FrontLightsLowBeamLeftRightDefectNight = 'FRONT_LIGHTS_LOW_BEAM_LEFT_RIGHT_DEFECT_NIGHT',
  FrontLightsParkingLightLeftRightDefect = 'FRONT_LIGHTS_PARKING_LIGHT_LEFT_RIGHT_DEFECT',
  FrontLightsTurningLightLeftRightDefect = 'FRONT_LIGHTS_TURNING_LIGHT_LEFT_RIGHT_DEFECT',
  HvacBlowerError = 'HVAC_BLOWER_ERROR',
  ImmobilizerEmergencyModeLimpHomeModeActivated = 'IMMOBILIZER_EMERGENCY_MODE_LIMP_HOME_MODE_ACTIVATED',
  ImmobilizerKeyAuthenticationFailed = 'IMMOBILIZER_KEY_AUTHENTICATION_FAILED',
  ImmobilizerKeyNotFound = 'IMMOBILIZER_KEY_NOT_FOUND',
  IncidentHandlerWithoutFunctionFunctionIhDegradedOrErrorMode = 'INCIDENT_HANDLER_WITHOUT_FUNCTION_FUNCTION_IH_DEGRADED_OR_ERROR_MODE',
  InteriorMonitoringMrc_2ACriticalIncidentWithDriveInterruptionMrc2A = 'INTERIOR_MONITORING_MRC_2A_CRITICAL_INCIDENT_WITH_DRIVE_INTERRUPTION_MRC2A',
  InteriorMonitoringMrc_2BCriticalIncidentWithDriveInterruptionMrc2B = 'INTERIOR_MONITORING_MRC_2B_CRITICAL_INCIDENT_WITH_DRIVE_INTERRUPTION_MRC2B',
  KeylessEntryKeylessEntryDefective = 'KEYLESS_ENTRY_KEYLESS_ENTRY_DEFECTIVE',
  NoncriticalInteriorMonitoringIncidentServesForStorage = 'NONCRITICAL_INTERIOR_MONITORING_INCIDENT_SERVES_FOR_STORAGE',
  NvemDragoon1Dra1ErrorMode = 'NVEM_DRAGOON1_DRA1_ERROR_MODE',
  NvemDragoon2Dra2ErrorMode = 'NVEM_DRAGOON2_DRA2_ERROR_MODE',
  NvemDragoon3Dra3ErrorMode = 'NVEM_DRAGOON3_DRA3_ERROR_MODE',
  OnlineRemoteUpdateUpdateFailed = 'ONLINE_REMOTE_UPDATE_UPDATE_FAILED',
  OnlineRemoteUpdateUpdateIncomplete = 'ONLINE_REMOTE_UPDATE_UPDATE_INCOMPLETE',
  OverheatWarningHotDriveSlowly = 'OVERHEAT_WARNING_HOT_DRIVE_SLOWLY',
  OverheatWarningHotMaxVelocityLimited = 'OVERHEAT_WARNING_HOT_MAX_VELOCITY_LIMITED',
  PowertrainCoordinatorBrakesOverheated_1 = 'POWERTRAIN_COORDINATOR_BRAKES_OVERHEATED_1',
  PowertrainCoordinatorBrakesOverheated_2 = 'POWERTRAIN_COORDINATOR_BRAKES_OVERHEATED_2',
  PreCrashCurrentlyRestricted = 'PRE_CRASH_CURRENTLY_RESTRICTED',
  PreCrashCurrentlyRestrictedEscOff = 'PRE_CRASH_CURRENTLY_RESTRICTED_ESC_OFF',
  PreCrashDemoMode = 'PRE_CRASH_DEMO_MODE',
  PreCrashEscOff = 'PRE_CRASH_ESC_OFF',
  PreCrashNoSensorView = 'PRE_CRASH_NO_SENSOR_VIEW',
  PreCrashSystemError = 'PRE_CRASH_SYSTEM_ERROR',
  PreCrashSystemOff = 'PRE_CRASH_SYSTEM_OFF',
  RainSensorDefect = 'RAIN_SENSOR_DEFECT',
  RainVisibilityIncident = 'RAIN_VISIBILITY_INCIDENT',
  RangeRangeError = 'RANGE_RANGE_ERROR',
  RearLightsAllBrakeLightsLeftRightDefect = 'REAR_LIGHTS_ALL_BRAKE_LIGHTS_LEFT_RIGHT_DEFECT',
  RearLightsFogLightLeftRightMiddleDefect = 'REAR_LIGHTS_FOG_LIGHT_LEFT_RIGHT_MIDDLE_DEFECT',
  RearLightsIndicatorLeftRightDefect = 'REAR_LIGHTS_INDICATOR_LEFT_RIGHT_DEFECT',
  RearLightsMin_1BrakeLightLeftRightMiddleDefect = 'REAR_LIGHTS_MIN_1_BRAKE_LIGHT_LEFT_RIGHT_MIDDLE_DEFECT',
  RearLightsMin_1TailLightLeftRightMiddleDefect = 'REAR_LIGHTS_MIN_1_TAIL_LIGHT_LEFT_RIGHT_MIDDLE_DEFECT',
  RearLightsNumberPlateLightDefect = 'REAR_LIGHTS_NUMBER_PLATE_LIGHT_DEFECT',
  RearLightsRearLightsControlDefect = 'REAR_LIGHTS_REAR_LIGHTS_CONTROL_DEFECT',
  RearLightsReversingLightLeftRightMiddleDefect = 'REAR_LIGHTS_REVERSING_LIGHT_LEFT_RIGHT_MIDDLE_DEFECT',
  ReducingElectricalDrivePowerBelowGbbThreshold = 'REDUCING_ELECTRICAL_DRIVE_POWER_BELOW_GBB_THRESHOLD',
  ReducingElectricalDrivePowerBelowMinThreshold = 'REDUCING_ELECTRICAL_DRIVE_POWER_BELOW_MIN_THRESHOLD',
  ReducingElectricalDrivePowerNoDriveThrust = 'REDUCING_ELECTRICAL_DRIVE_POWER_NO_DRIVE_THRUST',
  SafetyDriverDetectionErrorInSeatOccupancyMat = 'SAFETY_DRIVER_DETECTION_ERROR_IN_SEAT_OCCUPANCY_MAT',
  SafetyDriverInterventionAcceleratorIncident = 'SAFETY_DRIVER_INTERVENTION_ACCELERATOR_INCIDENT',
  SafetyDriverInterventionBrakeIncident = 'SAFETY_DRIVER_INTERVENTION_BRAKE_INCIDENT',
  SafetyDriverInterventionSteeringIncident = 'SAFETY_DRIVER_INTERVENTION_STEERING_INCIDENT',
  SeatBeltPass_1_2NotBuckled = 'SEAT_BELT_PASS_1_2_NOT_BUCKLED',
  SeatBeltPass_1_2NotBuckledSdsEngaged = 'SEAT_BELT_PASS_1_2_NOT_BUCKLED_SDS_ENGAGED',
  SeatBeltPass_1_3NotBuckled = 'SEAT_BELT_PASS_1_3_NOT_BUCKLED',
  SeatBeltPass_1_3NotBuckledSdsEngaged = 'SEAT_BELT_PASS_1_3_NOT_BUCKLED_SDS_ENGAGED',
  SeatBeltPass_1_4NotBuckled = 'SEAT_BELT_PASS_1_4_NOT_BUCKLED',
  SeatBeltPass_1_4NotBuckledSdsEngaged = 'SEAT_BELT_PASS_1_4_NOT_BUCKLED_SDS_ENGAGED',
  SeatBeltPass_2_2NotBuckled = 'SEAT_BELT_PASS_2_2_NOT_BUCKLED',
  SeatBeltPass_2_2NotBuckledSdsEngaged = 'SEAT_BELT_PASS_2_2_NOT_BUCKLED_SDS_ENGAGED',
  SeatBeltPass_2_3NotBuckled = 'SEAT_BELT_PASS_2_3_NOT_BUCKLED',
  SeatBeltPass_2_3NotBuckledSdsEngaged = 'SEAT_BELT_PASS_2_3_NOT_BUCKLED_SDS_ENGAGED',
  SeatBeltPass_2_4NotBuckled = 'SEAT_BELT_PASS_2_4_NOT_BUCKLED',
  SeatBeltPass_2_4NotBuckledSdsEngaged = 'SEAT_BELT_PASS_2_4_NOT_BUCKLED_SDS_ENGAGED',
  SeatBeltPass_3_2NotBuckled = 'SEAT_BELT_PASS_3_2_NOT_BUCKLED',
  SeatBeltPass_3_2NotBuckledSdsEngaged = 'SEAT_BELT_PASS_3_2_NOT_BUCKLED_SDS_ENGAGED',
  SeatBeltPass_3_3NotBuckled = 'SEAT_BELT_PASS_3_3_NOT_BUCKLED',
  SeatBeltPass_3_3NotBuckledSdsEngaged = 'SEAT_BELT_PASS_3_3_NOT_BUCKLED_SDS_ENGAGED',
  SeatBeltPass_3_4NotBuckled = 'SEAT_BELT_PASS_3_4_NOT_BUCKLED',
  SeatBeltPass_3_4NotBuckledSdsEngaged = 'SEAT_BELT_PASS_3_4_NOT_BUCKLED_SDS_ENGAGED',
  ServiceCallActivationSr2NotificationOfServiceCallRequirementForStorageInTheEdr = 'SERVICE_CALL_ACTIVATION_SR2_NOTIFICATION_OF_SERVICE_CALL_REQUIREMENT_FOR_STORAGE_IN_THE_EDR',
  ServiceCallActivationSr3NotificationOfServiceCallRequirementForStorageInTheEdr = 'SERVICE_CALL_ACTIVATION_SR3_NOTIFICATION_OF_SERVICE_CALL_REQUIREMENT_FOR_STORAGE_IN_THE_EDR',
  SlidingDoor = 'SLIDING_DOOR',
  SlidingDoorAntiPinchSituation = 'SLIDING_DOOR_ANTI_PINCH_SITUATION',
  SlidingDoorCustomerIntervention = 'SLIDING_DOOR_CUSTOMER_INTERVENTION',
  SlidingDoorDriverTakeover = 'SLIDING_DOOR_DRIVER_TAKEOVER',
  SlidingDoorNotFunctioning = 'SLIDING_DOOR_NOT_FUNCTIONING',
  SlidingDoorPlayProtectionActive = 'SLIDING_DOOR_PLAY_PROTECTION_ACTIVE',
  SteeringAuthorityFailure = 'STEERING_AUTHORITY_FAILURE',
  SteeringColumnLockRequestMoveSteeringWheel = 'STEERING_COLUMN_LOCK_REQUEST_MOVE_STEERING_WHEEL',
  SteeringColumnLockRequestSclWorkshop = 'STEERING_COLUMN_LOCK_REQUEST_SCL_WORKSHOP',
  SteeringQfkError = 'STEERING_QFK_ERROR',
  SteeringWheelHeaterError = 'STEERING_WHEEL_HEATER_ERROR',
  TailgateStatusError = 'TAILGATE_STATUS_ERROR',
  TimeMasterError = 'TIME_MASTER_ERROR',
  TirePressureMonitoringSystemAllTiresWarning_1 = 'TIRE_PRESSURE_MONITORING_SYSTEM_ALL_TIRES_WARNING_1',
  TirePressureMonitoringSystemAllTiresWarning_2 = 'TIRE_PRESSURE_MONITORING_SYSTEM_ALL_TIRES_WARNING_2',
  TirePressureMonitoringSystemAllTiresWarning_3 = 'TIRE_PRESSURE_MONITORING_SYSTEM_ALL_TIRES_WARNING_3',
  TirePressureMonitoringSystemFrontLeftTireWarning_2 = 'TIRE_PRESSURE_MONITORING_SYSTEM_FRONT_LEFT_TIRE_WARNING_2',
  TirePressureMonitoringSystemFrontRightTireWarning_1 = 'TIRE_PRESSURE_MONITORING_SYSTEM_FRONT_RIGHT_TIRE_WARNING_1',
  TirePressureMonitoringSystemFrontRightTireWarning_2 = 'TIRE_PRESSURE_MONITORING_SYSTEM_FRONT_RIGHT_TIRE_WARNING_2',
  TirePressureMonitoringSystemFrontRightTireWarning_3 = 'TIRE_PRESSURE_MONITORING_SYSTEM_FRONT_RIGHT_TIRE_WARNING_3',
  TirePressureMonitoringSystemRearLeftTireWarning_1 = 'TIRE_PRESSURE_MONITORING_SYSTEM_REAR_LEFT_TIRE_WARNING_1',
  TirePressureMonitoringSystemRearLeftTireWarning_2 = 'TIRE_PRESSURE_MONITORING_SYSTEM_REAR_LEFT_TIRE_WARNING_2',
  TirePressureMonitoringSystemRearLeftTireWarning_3 = 'TIRE_PRESSURE_MONITORING_SYSTEM_REAR_LEFT_TIRE_WARNING_3',
  TirePressureMonitoringSystemRearRightTireWarning_1 = 'TIRE_PRESSURE_MONITORING_SYSTEM_REAR_RIGHT_TIRE_WARNING_1',
  TirePressureMonitoringSystemRearRightTireWarning_2 = 'TIRE_PRESSURE_MONITORING_SYSTEM_REAR_RIGHT_TIRE_WARNING_2',
  TirePressureMonitoringSystemRearRightTireWarning_3 = 'TIRE_PRESSURE_MONITORING_SYSTEM_REAR_RIGHT_TIRE_WARNING_3',
  TirePressureMonitoringSystemSystemError = 'TIRE_PRESSURE_MONITORING_SYSTEM_SYSTEM_ERROR',
  VssErrorAcceleration = 'VSS_ERROR_ACCELERATION',
  VssErrorAuthorityFailure = 'VSS_ERROR_AUTHORITY_FAILURE',
  VssErrorDragoonSync = 'VSS_ERROR_DRAGOON_SYNC',
  VssErrorDriver = 'VSS_ERROR_DRIVER',
  VssErrorEmergencyBrake = 'VSS_ERROR_EMERGENCY_BRAKE',
  VssErrorGear = 'VSS_ERROR_GEAR',
  VssErrorHms = 'VSS_ERROR_HMS',
  VssErrorParking = 'VSS_ERROR_PARKING',
  VssErrorPrimaryBrake = 'VSS_ERROR_PRIMARY_BRAKE',
  VssErrorPrimarySteering = 'VSS_ERROR_PRIMARY_STEERING',
  VssErrorRvs = 'VSS_ERROR_RVS',
  VssErrorSecondaryBrake = 'VSS_ERROR_SECONDARY_BRAKE',
  VssErrorSecondarySteering = 'VSS_ERROR_SECONDARY_STEERING',
  VssErrorSteering = 'VSS_ERROR_STEERING',
}

export type IncidentsAnalysisKpiResponse = {
  __typename?: 'IncidentsAnalysisKPIResponse'
  key: Scalars['String']['output']
  value: Scalars['Float']['output']
}

export type IncidentsLocationResponse = {
  __typename?: 'IncidentsLocationResponse'
  key: Scalars['String']['output']
  /** @deprecated Use `value` instead. */
  label: Scalars['String']['output']
  value: Scalars['String']['output']
}

export type IncidentsSoftwareVersionResponse = {
  __typename?: 'IncidentsSoftwareVersionResponse'
  key: Scalars['String']['output']
  /** @deprecated Use `value` instead. */
  label: Scalars['String']['output']
  value: Scalars['String']['output']
}

export enum Incidentstatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
}

export type InsertHubLogCheckedInRecordResponse = {
  __typename?: 'InsertHubLogCheckedInRecordResponse'
  record: ShiftStateHubLogRecord
}

export type InsertHubLogCheckedOutRecordResponse = {
  __typename?: 'InsertHubLogCheckedOutRecordResponse'
  record: ShiftStateHubLogRecord
}

export enum InspectionDoneFilter {
  InspectionProtocolMissing = 'INSPECTION_PROTOCOL_MISSING',
  InvoiceMissing = 'INVOICE_MISSING',
  Last_6Months = 'LAST_6_MONTHS',
  Last_30Days = 'LAST_30_DAYS',
  SinceStartOfLastYear = 'SINCE_START_OF_LAST_YEAR',
  SinceStartOfThisYear = 'SINCE_START_OF_THIS_YEAR',
}

export type InspectionDoneProcessesSearch = {
  doneFilter: InspectionDoneFilter
  label?: InputMaybe<Scalars['Int']['input']>
  regionId: Scalars['String']['input']
}

export type InspectionDueProcessesSearch = {
  /** days for main inspections, km for mileage-based inspections / VICs */
  dueWithin?: InputMaybe<Scalars['Int']['input']>
  label?: InputMaybe<Scalars['Int']['input']>
  regionId: Scalars['String']['input']
}

export type InspectionProcessDocumentDownloadUrlInput = {
  documentId: Scalars['String']['input']
  processId: Scalars['String']['input']
  processType: FleetProcessType
}

export type InspectionProgressProcessesSearch = {
  label?: InputMaybe<Scalars['Int']['input']>
  regionId: Scalars['String']['input']
}

export type Integration = {
  __typename?: 'Integration'
  id: Scalars['String']['output']
  name: Scalars['String']['output']
}

export enum InteractionReason {
  AppProblems = 'APP_PROBLEMS',
  Charging = 'CHARGING',
  /** @deprecated Use INSIDE_CLEANING or OUTSIDE_CLEANING instead */
  Cleaning = 'CLEANING',
  ForgotSomething = 'FORGOT_SOMETHING',
  FrontSeatsCleaning = 'FRONT_SEATS_CLEANING',
  InsideCleaning = 'INSIDE_CLEANING',
  Inspection = 'INSPECTION',
  Maintenance = 'MAINTENANCE',
  Other = 'OTHER',
  OutsideCleaning = 'OUTSIDE_CLEANING',
  Reparking = 'REPARKING',
  SafetyDriverMatching = 'SAFETY_DRIVER_MATCHING',
  ShiftAssignment = 'SHIFT_ASSIGNMENT',
  TelemetryProblems = 'TELEMETRY_PROBLEMS',
  Transfer = 'TRANSFER',
}

export type IvcTaskNotification = TaskNotification & {
  __typename?: 'IvcTaskNotification'
  actionType: TaskActionType
  assigned: Maybe<TaskStateChangeDetails>
  createdAt: Scalars['DateTime']['output']
  fleetId: Maybe<Scalars['ID']['output']>
  foreignId: Scalars['ID']['output']
  id: Scalars['ID']['output']
  note: Maybe<TaskNotificationNote>
  notificationType: TaskNotificationType
  pended: Maybe<TaskStateChangeDetails>
  regionId: Maybe<Scalars['ID']['output']>
  resolved: Maybe<TaskStateChangeDetails>
  serviceAreaUUID: Scalars['ID']['output']
  severity: TaskNotificationSeverity
  stateChanges: Array<TaskStateChangeDetails>
  status: TaskNotificationStatus
  timestamp: Scalars['DateTime']['output']
  vehicle: Maybe<Vehicle>
  version: Scalars['Int']['output']
}

export type JoinVehicleChimeMeetingResponse = {
  __typename?: 'JoinVehicleChimeMeetingResponse'
  attendee: Scalars['String']['output']
  meeting: Scalars['String']['output']
}

export type KeepOutZone = {
  __typename?: 'KeepOutZone'
  created: Scalars['DateTime']['output']
  /** Contains a GeoJSON Polygon/MultiPolygon */
  geometry: Scalars['String']['output']
  id: Scalars['ID']['output']
  isActive: Scalars['Boolean']['output']
  modified: Scalars['DateTime']['output']
  name: Scalars['String']['output']
  reason: RoadBlockageReason
  segments: Array<RoadSegment>
  status: RoadBlockageStatus
  validFrom: Maybe<Scalars['DateTime']['output']>
  validTo: Maybe<Scalars['DateTime']['output']>
}

export type KeepOutZoneActivation = {
  __typename?: 'KeepOutZoneActivation'
  id: Scalars['ID']['output']
  timeRange: TimeRange
}

export type KeepOutZoneActivationInput = {
  keepOutZoneId: Scalars['ID']['input']
  timeRange: TimeRangeInput
}

export type KeepOutZoneFilterInput = {
  reasons?: InputMaybe<Array<RoadBlockageReason>>
  statuses?: InputMaybe<Array<RoadBlockageStatus>>
}

export type KeepOutZoneInput = {
  activationTimeRange?: InputMaybe<TimeRangeInput>
  /** GeoJSON Polygon geometry for the keep-out zone */
  geometry: Scalars['String']['input']
  name: Scalars['String']['input']
  reason: RoadBlockageReason
}

export enum KeyFobState {
  Empty = 'EMPTY',
  Inserted = 'INSERTED',
}

export type KeyRfidReplacedChange = FleetEntityChange & {
  __typename?: 'KeyRfidReplacedChange'
  backofficeUser: Maybe<BackofficeUser>
  changedAt: Scalars['DateTime']['output']
  changes: KeyRfidReplacedChangeFields
}

export type KeyRfidReplacedChangeFields = VehicleChangeFields & {
  __typename?: 'KeyRfidReplacedChangeFields'
  keyRfidNew: Maybe<Scalars['String']['output']>
  keyRfidOld: Maybe<Scalars['String']['output']>
  vehicleID: Scalars['ID']['output']
}

export type Kpi = {
  __typename?: 'Kpi'
  calendarMonth: Scalars['Int']['output']
  calendarWeek: Scalars['Int']['output']
  coreCrashCount: Scalars['Int']['output']
  date: Scalars['String']['output']
  deadlockCount: Scalars['Int']['output']
  mtbxEventCount: Scalars['Int']['output']
  potentialCollisionEventCount: Scalars['Int']['output']
  roadmanshipEventCount: Scalars['Int']['output']
  swVersions: Scalars['String']['output']
  testType: Scalars['String']['output']
  timeInAutoHours: Scalars['Float']['output']
  vehicleIdShort: Scalars['Int']['output']
  vehicleVin: Scalars['String']['output']
  vtrId: Scalars['String']['output']
  vtrLocation: Scalars['String']['output']
}

export enum Language {
  De = 'DE',
  En = 'EN',
}

export enum LanguageCode {
  Aa = 'aa',
  Ab = 'ab',
  Ae = 'ae',
  Af = 'af',
  Ak = 'ak',
  Am = 'am',
  An = 'an',
  Ar = 'ar',
  As = 'as',
  Av = 'av',
  Ay = 'ay',
  Az = 'az',
  Ba = 'ba',
  Be = 'be',
  Bg = 'bg',
  Bh = 'bh',
  Bi = 'bi',
  Bm = 'bm',
  Bn = 'bn',
  Bo = 'bo',
  Br = 'br',
  Bs = 'bs',
  Ca = 'ca',
  Ce = 'ce',
  Ch = 'ch',
  Co = 'co',
  Cr = 'cr',
  Cs = 'cs',
  Cu = 'cu',
  Cv = 'cv',
  Cy = 'cy',
  Da = 'da',
  De = 'de',
  Dv = 'dv',
  Dz = 'dz',
  Ee = 'ee',
  El = 'el',
  En = 'en',
  Eo = 'eo',
  Es = 'es',
  Et = 'et',
  Eu = 'eu',
  Fa = 'fa',
  Ff = 'ff',
  Fi = 'fi',
  Fj = 'fj',
  Fo = 'fo',
  Fr = 'fr',
  Fy = 'fy',
  Ga = 'ga',
  Gd = 'gd',
  Gl = 'gl',
  Gn = 'gn',
  Gu = 'gu',
  Gv = 'gv',
  Ha = 'ha',
  He = 'he',
  Hi = 'hi',
  Ho = 'ho',
  Hr = 'hr',
  Ht = 'ht',
  Hu = 'hu',
  Hy = 'hy',
  Hz = 'hz',
  Ia = 'ia',
  Id = 'id',
  Ie = 'ie',
  Ig = 'ig',
  Ii = 'ii',
  Ik = 'ik',
  Io = 'io',
  Is = 'is',
  It = 'it',
  Iu = 'iu',
  Ja = 'ja',
  Jv = 'jv',
  Ka = 'ka',
  Kg = 'kg',
  Ki = 'ki',
  Kj = 'kj',
  Kk = 'kk',
  Kl = 'kl',
  Km = 'km',
  Kn = 'kn',
  Ko = 'ko',
  Kr = 'kr',
  Ks = 'ks',
  Ku = 'ku',
  Kv = 'kv',
  Kw = 'kw',
  Ky = 'ky',
  La = 'la',
  Lb = 'lb',
  Lg = 'lg',
  Li = 'li',
  Ln = 'ln',
  Lo = 'lo',
  Lt = 'lt',
  Lu = 'lu',
  Lv = 'lv',
  Mg = 'mg',
  Mh = 'mh',
  Mi = 'mi',
  Mk = 'mk',
  Ml = 'ml',
  Mn = 'mn',
  Mr = 'mr',
  Ms = 'ms',
  Mt = 'mt',
  My = 'my',
  Na = 'na',
  Nb = 'nb',
  Nd = 'nd',
  Ne = 'ne',
  Ng = 'ng',
  Nl = 'nl',
  Nn = 'nn',
  No = 'no',
  Nr = 'nr',
  Nv = 'nv',
  Ny = 'ny',
  Oc = 'oc',
  Oj = 'oj',
  Om = 'om',
  Or = 'or',
  Os = 'os',
  Pa = 'pa',
  Pi = 'pi',
  Pl = 'pl',
  Ps = 'ps',
  Pt = 'pt',
  Qu = 'qu',
  Rm = 'rm',
  Rn = 'rn',
  Ro = 'ro',
  Ru = 'ru',
  Rw = 'rw',
  Sa = 'sa',
  Sc = 'sc',
  Sd = 'sd',
  Se = 'se',
  Sg = 'sg',
  Si = 'si',
  Sk = 'sk',
  Sl = 'sl',
  Sm = 'sm',
  Sn = 'sn',
  So = 'so',
  Sq = 'sq',
  Sr = 'sr',
  Ss = 'ss',
  St = 'st',
  Su = 'su',
  Sv = 'sv',
  Sw = 'sw',
  Ta = 'ta',
  Te = 'te',
  Tg = 'tg',
  Th = 'th',
  Ti = 'ti',
  Tk = 'tk',
  Tl = 'tl',
  Tn = 'tn',
  To = 'to',
  Tr = 'tr',
  Ts = 'ts',
  Tt = 'tt',
  Tw = 'tw',
  Ty = 'ty',
  Ug = 'ug',
  Uk = 'uk',
  Undefined = 'undefined',
  Ur = 'ur',
  Uz = 'uz',
  Ve = 've',
  Vi = 'vi',
  Vo = 'vo',
  Wa = 'wa',
  Wo = 'wo',
  Xh = 'xh',
  Yi = 'yi',
  Yo = 'yo',
  Za = 'za',
  Zh = 'zh',
  Zu = 'zu',
}

/** Legal documents of a tenant */
export type LegalDocument = {
  __typename?: 'LegalDocument'
  /** Unique identifier of the legal document */
  id: Scalars['ID']['output']
  /** Tenant to which the legal document belongs to */
  tenant: Scalars['String']['output']
  /** The type of the legal document */
  type: Type
  /** The list of available versions of the legal document */
  versions: Array<Version>
}

export type LegalDocumentConfirmation = {
  __typename?: 'LegalDocumentConfirmation'
  /** Date when the customer confirmed the version (ISO-8601 Date and time with offset) */
  confirmationDate: Maybe<Scalars['OffsetDateTime']['output']>
  /** The id of the accepted legal document */
  legalDocumentId: Scalars['String']['output']
  /** Type of the legal document */
  legalDocumentType: Type
  /** Version of the confirmed legal document */
  version: Scalars['Int']['output']
}

export type LegalDocumentsResponse = {
  __typename?: 'LegalDocumentsResponse'
  legalDocuments: Array<Maybe<LegalDocument>>
  requiredLocales: Array<Scalars['String']['output']>
}

export enum LicensePlateCountry {
  De = 'DE',
  Gb = 'GB',
  No = 'NO',
  Us = 'US',
}

export enum LicensePlateRegion {
  /** Alaska */
  Ak = 'AK',
  /** Alabama */
  Al = 'AL',
  /** Arkansas */
  Ar = 'AR',
  /** American Samoa */
  As = 'AS',
  /** Arizona */
  Az = 'AZ',
  /** California */
  Ca = 'CA',
  /** Colorado */
  Co = 'CO',
  /** Connecticut */
  Ct = 'CT',
  /** District of Columbia */
  Dc = 'DC',
  /** Delaware */
  De = 'DE',
  /** Florida */
  Fl = 'FL',
  /** Georgia */
  Ga = 'GA',
  /** Guam */
  Gu = 'GU',
  /** Hawaii */
  Hi = 'HI',
  /** Iowa */
  Ia = 'IA',
  /** Idaho */
  Id = 'ID',
  /** Illinois */
  Il = 'IL',
  /** Indiana */
  In = 'IN',
  /** Kansas */
  Ks = 'KS',
  /** Kentucky */
  Ky = 'KY',
  /** Louisiana */
  La = 'LA',
  /** Massachusetts */
  Ma = 'MA',
  /** Maryland */
  Md = 'MD',
  /** Maine */
  Me = 'ME',
  /** Michigan */
  Mi = 'MI',
  /** Minnesota */
  Mn = 'MN',
  /** Missouri */
  Mo = 'MO',
  /** Northern Mariana Islands */
  Mp = 'MP',
  /** Mississippi */
  Ms = 'MS',
  /** Montana */
  Mt = 'MT',
  /** North Carolina */
  Nc = 'NC',
  /** North Dakota */
  Nd = 'ND',
  /** Nebraska */
  Ne = 'NE',
  /** New Hampshire */
  Nh = 'NH',
  /** New Jersey */
  Nj = 'NJ',
  /** New Mexico */
  Nm = 'NM',
  /** Nevada */
  Nv = 'NV',
  /** New York */
  Ny = 'NY',
  /** Ohio */
  Oh = 'OH',
  /** Oklahoma */
  Ok = 'OK',
  /** Oregon */
  Or = 'OR',
  /** Pennsylvania */
  Pa = 'PA',
  /** Puerto Rico */
  Pr = 'PR',
  /** Rhode Island */
  Ri = 'RI',
  /** South Carolina */
  Sc = 'SC',
  /** South Dakota */
  Sd = 'SD',
  /** Tennessee */
  Tn = 'TN',
  /** Texas */
  Tx = 'TX',
  /** Utah */
  Ut = 'UT',
  /** Virginia */
  Va = 'VA',
  /** Virgin Islands */
  Vi = 'VI',
  /** Vermont */
  Vt = 'VT',
  /** Washington */
  Wa = 'WA',
  /** Wisconsin */
  Wi = 'WI',
  /** West Virginia */
  Wv = 'WV',
  /** Wyoming */
  Wy = 'WY',
}

export type Line = {
  __typename?: 'Line'
  assignedVehicles: Array<Scalars['String']['output']>
  circular: Scalars['Boolean']['output']
  /** Display color for the line. Falls back to a default when none was set. */
  color: LineColor
  created: Scalars['DateTime']['output']
  description: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  modified: Scalars['DateTime']['output']
  modifiedBy: Scalars['String']['output']
  name: Scalars['DisplayNames']['output']
  route: Array<Location>
  serviceAreaId: Scalars['String']['output']
  stops: Array<LineStop>
}

export type LineColor = {
  __typename?: 'LineColor'
  darkMode: Scalars['String']['output']
  key: Scalars['String']['output']
  lightMode: Scalars['String']['output']
}

export type LineColorInput = {
  /** Dark mode color as a hex string (#RRGGBB) */
  darkMode: Scalars['String']['input']
  /** Opaque palette key the backoffice frontend uses to identify the selected color */
  key: Scalars['String']['input']
  /** Light mode color as a hex string (#RRGGBB) */
  lightMode: Scalars['String']['input']
}

export type LineInput = {
  /** Optional list of assigned vehicle IDs. Each vehicle can only be assigned to one line. */
  assignedVehicles?: InputMaybe<Array<Scalars['String']['input']>>
  /** Whether the line is circular (returns to start) */
  circular: Scalars['Boolean']['input']
  /** Optional light/dark mode display color for the line. Will become required once frontends always send it. */
  color?: InputMaybe<LineColorInput>
  /** Optional description of the line */
  description?: InputMaybe<Scalars['String']['input']>
  name: Scalars['DisplayNames']['input']
  /** Ordered list of stop IDs that make up the line */
  stopIds: Array<Scalars['String']['input']>
}

export type LineRoutePreview = {
  __typename?: 'LineRoutePreview'
  route: Array<Location>
}

export type LineRoutePreviewInput = {
  heading: Scalars['Int']['input']
  latitude: Scalars['Float']['input']
  longitude: Scalars['Float']['input']
}

export type LineServiceConfig = {
  __typename?: 'LineServiceConfig'
  enabled: Scalars['Boolean']['output']
  modifiedAt: Maybe<Scalars['DateTime']['output']>
  modifiedBy: Maybe<Scalars['String']['output']>
  serviceAreaId: Scalars['String']['output']
}

export type LineServiceConfigInput = {
  /** Whether the line service is enabled for this service area */
  enabled: Scalars['Boolean']['input']
}

export type LineStop = {
  __typename?: 'LineStop'
  customerDisplayLocation: Location
  heading: Scalars['Int']['output']
  location: Location
  names: Scalars['DisplayNames']['output']
  /** Activation state of the stop on the line. Inactive stops remain members of the line (so the operator sees the full configured line and can display them distinctly) but are excluded from the REST endpoint and line events consumed by downstream services. */
  stopActivation: StopActivation
  stopId: Scalars['String']['output']
}

export type LineUpdateInput = {
  /** Updated list of assigned vehicle IDs (optional). Each vehicle can only be assigned to one line. */
  assignedVehicles?: InputMaybe<Array<Scalars['String']['input']>>
  /** Updated circular flag (optional) */
  circular?: InputMaybe<Scalars['Boolean']['input']>
  /** Updated light/dark mode display color (optional) */
  color?: InputMaybe<LineColorInput>
  /** Updated description (optional) */
  description?: InputMaybe<Scalars['String']['input']>
  /** Updated name (optional) */
  name?: InputMaybe<Scalars['DisplayNames']['input']>
  /** Updated ordered list of stop IDs (optional) */
  stopIds?: InputMaybe<Array<Scalars['String']['input']>>
}

export type LinesResponse = {
  __typename?: 'LinesResponse'
  lines: Array<Line>
  total: Scalars['Int']['output']
}

export type Link = {
  __typename?: 'Link'
  name: Scalars['String']['output']
  url: Scalars['String']['output']
}

export type LinkInput = {
  name: Scalars['String']['input']
  url: Scalars['String']['input']
}

export type ListResponse = {
  /** Total items in the set that can be paginated over */
  total: Scalars['Int']['output']
}

export type LiveKitMediaStreamCredentials = {
  __typename?: 'LiveKitMediaStreamCredentials'
  token: Scalars['String']['output']
  url: Scalars['String']['output']
}

/** Localization of a Legal document version */
export type Localization = {
  __typename?: 'Localization'
  /** The locale of the legal document */
  locale: Scalars['String']['output']
  /** The localized name of the legal document */
  name: Scalars['String']['output']
  /** The url pointing to the legal document */
  url: Scalars['String']['output']
}

/** Localization of a Legal document version */
export type LocalizationInput = {
  /** The locale of the legal document */
  locale: Scalars['String']['input']
  /** The localized name of the legal document */
  name: Scalars['String']['input']
  /** The url pointing to the legal document */
  url: Scalars['String']['input']
}

export type LocalizedEntry = {
  __typename?: 'LocalizedEntry'
  language: Scalars['String']['output']
  value: Scalars['String']['output']
}

export type LocalizedEntryInput = {
  language: Scalars['String']['input']
  value: Scalars['String']['input']
}

/** A mapping of language codes to strings in those languages */
export type LocalizedString = {
  __typename?: 'LocalizedString'
  values: Array<LocalizedEntry>
}

/** A mapping of language codes to strings in those languages */
export type LocalizedStringInput = {
  values: Array<LocalizedEntryInput>
}

/** Location is a common type */
export type Location = {
  __typename?: 'Location'
  latitude: Scalars['Float']['output']
  longitude: Scalars['Float']['output']
}

export enum LocationActionCondition {
  /** Only Destination location is considered when location condition is evaluated */
  Destination = 'DESTINATION',
  /** Only Origin location is considered when location condition is evaluated */
  Origin = 'ORIGIN',
  /**
   * Both Origin and Destination locations are considered when location condition is evaluated.
   * I.e. Condition is true when either Origin or Destination location match the condition.
   */
  OriginAndDestination = 'ORIGIN_AND_DESTINATION',
}

export type LocationAttributes = {
  __typename?: 'LocationAttributes'
  area: Shape
  bottomRight: Location
  city: Scalars['String']['output']
  country: CountryCode
  defaultLocation: Location
  geometry: Scalars['String']['output']
  timezone: Scalars['TimeZone']['output']
  topLeft: Location
}

export type LocationAttributesCreationInput = {
  area: GeoJsonFeatureInput
  bottomRight: LocationInput
  city: Scalars['String']['input']
  country: CountryCode
  defaultLocation: LocationInput
  timezone: Scalars['TimeZone']['input']
  topLeft: LocationInput
}

export type LocationAttributesUpdateInput = {
  area: GeoJsonFeatureInput
  bottomRight: LocationInput
  defaultLocation: LocationInput
  timezone: Scalars['TimeZone']['input']
  topLeft: LocationInput
}

export enum LocationConditionType {
  /** Only Destination location is considered when location condition is evaluated */
  Destination = 'DESTINATION',
  /** Only Origin location is considered when location condition is evaluated */
  Origin = 'ORIGIN',
  /**
   * Both Origin and Destination locations are considered when location condition is evaluated.
   * I.e. Condition is true when either Origin or Destination location match the condition.
   */
  OriginAndDestination = 'ORIGIN_AND_DESTINATION',
}

export type LocationInput = {
  latitude: Scalars['Float']['input']
  longitude: Scalars['Float']['input']
}

export enum LocationSourceType {
  Telematic = 'TELEMATIC',
  Vip = 'VIP',
}

export type LocationWithHeading = {
  __typename?: 'LocationWithHeading'
  heading: Scalars['Float']['output']
  latitude: Scalars['Float']['output']
  longitude: Scalars['Float']['output']
}

export type LocationWithHeadingInput = {
  heading: Scalars['Float']['input']
  latitude: Scalars['Float']['input']
  longitude: Scalars['Float']['input']
}

export type LocationWithTimestamp = {
  __typename?: 'LocationWithTimestamp'
  location: Maybe<Location>
  timestamp: Maybe<Scalars['DateTime']['output']>
}

export enum LogRecordShiftType {
  NonPooling = 'NON_POOLING',
  PlutoPooling = 'PLUTO_POOLING',
  SafetyDriverOperation = 'SAFETY_DRIVER_OPERATION',
  WavPooling = 'WAV_POOLING',
}

export type MainInspectionDocumentRequest = {
  documentID: Scalars['ID']['input']
  documentType: MainInspectionProcessDocumentType
  fileName: Scalars['String']['input']
  processID: Scalars['ID']['input']
  /** Gross cost (only applicable for invoice) */
  totalGrossCost?: InputMaybe<MoneyInput>
  /** Net cost (only applicable for invoice) */
  totalNetCost?: InputMaybe<MoneyInput>
}

export type MainInspectionProcess = FleetProcess & {
  __typename?: 'MainInspectionProcess'
  /** Appointment date for the next inspection. Must be before dueDate. */
  appointmentDate: Maybe<Scalars['DateTime']['output']>
  /** Readable unique identifier */
  case: Scalars['ID']['output']
  documents: Array<MainInspectionProcessDocument>
  /** The date that the next inspection is due */
  dueDate: Scalars['DateTime']['output']
  finishedAt: Maybe<Scalars['DateTime']['output']>
  id: Scalars['ID']['output']
  /** The associated scheduled inactivation of the vehicle for this inspection */
  inactivationScheduler: Maybe<ScheduledVehicleStateChange>
  inspectionState: MainInspectionProcessState
  nextPossibleTransitions: Array<MainInspectionProcessPossibleTransition>
  region: Region
  startedAt: Scalars['DateTime']['output']
  state: FleetProcessState
  testFacility: Maybe<MainInspectionTestFacility>
  transitions: Array<MainInspectionProcessTransition>
  type: FleetProcessType
  updatedAt: Maybe<Scalars['DateTime']['output']>
  vehicle: Maybe<Vehicle>
  /** Has the vehicle been activated after the inspection */
  vehicleActivatedAt: Maybe<Scalars['DateTime']['output']>
}

export type MainInspectionProcessDocument = {
  __typename?: 'MainInspectionProcessDocument'
  documentID: Scalars['ID']['output']
  documentType: MainInspectionProcessDocumentType
  /** Original filename with extension */
  fileName: Scalars['String']['output']
  /** @deprecated we will generate the presignedUrl via inspectionProcessDocumentDownloadUrl query */
  presignedUrl: Maybe<Scalars['String']['output']>
  /** Gross cost (only applicable for invoice) */
  totalGrossCost: Maybe<Money>
  /** Net cost (only applicable for invoice) */
  totalNetCost: Maybe<Money>
  uploadedAt: Scalars['DateTime']['output']
}

export enum MainInspectionProcessDocumentType {
  Invoice = 'INVOICE',
  MainInspectionProtocol = 'MAIN_INSPECTION_PROTOCOL',
}

export type MainInspectionProcessPossibleTransition = {
  __typename?: 'MainInspectionProcessPossibleTransition'
  preconditions: Array<FleetProcessStateTransitionPrecondition>
  state: MainInspectionProcessState
}

export enum MainInspectionProcessState {
  /** Invoice uploaded */
  Done = 'DONE',
  /** The next main inspection is within the next 3 month */
  Due = 'DUE',
  /** An inspection appointment is fixed, and required data is entered */
  InProgress = 'IN_PROGRESS',
  /** Main inspection is confirmed to be done */
  MainInspectionDone = 'MAIN_INSPECTION_DONE',
  /** Main inspection protocol is uploaded */
  WaitingForInvoice = 'WAITING_FOR_INVOICE',
}

export type MainInspectionProcessTransition = {
  __typename?: 'MainInspectionProcessTransition'
  initiatedAt: Scalars['DateTime']['output']
  /** The username of the user who initiated the transition */
  initiatedBy: Scalars['String']['output']
  toState: MainInspectionProcessState
}

export type MainInspectionProcessTransitionRequest = {
  nextState: MainInspectionProcessState
  processId: Scalars['ID']['input']
}

export type MainInspectionTestFacility = {
  __typename?: 'MainInspectionTestFacility'
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  region: Region
}

export type MainInspectionUploadProcessDocumentInput = {
  documentType: MainInspectionProcessDocumentType
  processId: Scalars['ID']['input']
}

export type MainInspectionUploadProcessDocumentResult = {
  __typename?: 'MainInspectionUploadProcessDocumentResult'
  documentId: Scalars['ID']['output']
  /** The pre-signed URL for uploading the document */
  url: Scalars['String']['output']
}

/** Error structure for manually checking in a passenger */
export type ManuallyCheckInPassengerError = {
  __typename?: 'ManuallyCheckInPassengerError'
  code: ManuallyCheckInPassengerErrorCode
  message: Scalars['String']['output']
}

/** Error codes for manually checking in a passenger */
export enum ManuallyCheckInPassengerErrorCode {
  AuthenticationProcessInWrongState = 'AUTHENTICATION_PROCESS_IN_WRONG_STATE',
}

/** Input for manually checking in a passenger */
export type ManuallyCheckInPassengerInput = {
  /** The ID of the vehicle */
  fleetVehicle: Scalars['ID']['input']
  /** The ID of the trip */
  tripId: Scalars['ID']['input']
}

/** Output for manually checking in a passenger */
export type ManuallyCheckInPassengerOutput = {
  __typename?: 'ManuallyCheckInPassengerOutput'
  error: Maybe<ManuallyCheckInPassengerError>
  success: Scalars['Boolean']['output']
}

/** Error structure for manually checking in a passenger */
export type ManuallyNoShowPassengerError = {
  __typename?: 'ManuallyNoShowPassengerError'
  code: ManuallyNoShowPassengerErrorCode
  message: Scalars['String']['output']
}

/** Error codes for manually checking in a passenger */
export enum ManuallyNoShowPassengerErrorCode {
  AuthenticationProcessInWrongState = 'AUTHENTICATION_PROCESS_IN_WRONG_STATE',
}

/** Input for manually no showing a passenger */
export type ManuallyNoShowPassengerInput = {
  /** The ID of the vehicle */
  fleetVehicle: Scalars['ID']['input']
  /** The ID of the trip */
  tripId: Scalars['ID']['input']
}

/** Output for manually no showing a passenger */
export type ManuallyNoShowPassengerOutput = {
  __typename?: 'ManuallyNoShowPassengerOutput'
  error: Maybe<ManuallyNoShowPassengerError>
  success: Scalars['Boolean']['output']
}

export type MapValidation = {
  __typename?: 'MapValidation'
  map: Scalars['String']['output']
  message: Scalars['String']['output']
  route: Array<TripGeolocation>
  routeSegments: Array<SdsRouteSegment>
  success: Scalars['Boolean']['output']
}

export enum MediaStreamPlatform {
  Chime = 'CHIME',
  Livekit = 'LIVEKIT',
}

export type MetadataString = {
  __typename?: 'MetadataString'
  key: Scalars['String']['output']
  value: Scalars['String']['output']
}

export type MetadataStringInput = {
  key: Scalars['String']['input']
  value: Scalars['String']['input']
}

export type Metropolis = {
  __typename?: 'Metropolis'
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  origin: Maybe<Location>
  status: Scalars['String']['output']
}

export type MileageBasedInspectionDocumentRequest = {
  documentID: Scalars['ID']['input']
  documentType: MileageBasedInspectionProcessDocumentType
  fileName: Scalars['String']['input']
  processID: Scalars['ID']['input']
  /** Gross cost (only applicable for invoice) */
  totalGrossCost?: InputMaybe<MoneyInput>
  /** Net cost (only applicable for invoice) */
  totalNetCost?: InputMaybe<MoneyInput>
}

export type MileageBasedInspectionProcess = FleetProcess & {
  __typename?: 'MileageBasedInspectionProcess'
  /** Date for the vehicle pickup. */
  appointmentDate: Maybe<Scalars['DateTime']['output']>
  /** Readable unique identifier */
  case: Scalars['ID']['output']
  documents: Array<MileageBasedInspectionProcessDocument>
  finishedAt: Maybe<Scalars['DateTime']['output']>
  id: Scalars['ID']['output']
  /** The associated scheduled inactivation of the vehicle for this inspection. Must be before appointmentDate. */
  inactivationScheduler: Maybe<ScheduledVehicleStateChange>
  /** Mileage interval this process refers to. E.g. 30k, 60k, 90k */
  inspectionMileage: Maybe<Scalars['Int']['output']>
  inspectionState: MileageBasedInspectionProcessState
  /** The mileage at the point in time the inspection was marked as done */
  mileageAtInspectionDone: Maybe<Scalars['Float']['output']>
  mileageAtStart: Scalars['Float']['output']
  nextPossibleTransitions: Array<MileageBasedInspectionProcessPossibleTransition>
  /** UUID of hub at which the vehicle will be picked up */
  pickupHub: Maybe<Hub>
  region: Region
  startedAt: Scalars['DateTime']['output']
  state: FleetProcessState
  testFacility: Maybe<MileageBasedInspectionTestFacility>
  transitions: Array<MileageBasedInspectionProcessTransition>
  type: FleetProcessType
  updatedAt: Maybe<Scalars['DateTime']['output']>
  vehicle: Maybe<Vehicle>
  /** Has the vehicle been activated after the inspection */
  vehicleActivatedAt: Maybe<Scalars['DateTime']['output']>
}

export type MileageBasedInspectionProcessDocument = {
  __typename?: 'MileageBasedInspectionProcessDocument'
  documentID: Scalars['ID']['output']
  documentType: MileageBasedInspectionProcessDocumentType
  /** Original filename with extension */
  fileName: Scalars['String']['output']
  /** @deprecated we will generate the presignedUrl via inspectionProcessDocumentDownloadUrl query */
  presignedUrl: Maybe<Scalars['String']['output']>
  /** Gross cost (only applicable for invoice) */
  totalGrossCost: Maybe<Money>
  /** Net cost (only applicable for invoice) */
  totalNetCost: Maybe<Money>
  uploadedAt: Scalars['DateTime']['output']
}

export enum MileageBasedInspectionProcessDocumentType {
  ComplaintProtocol = 'COMPLAINT_PROTOCOL',
  Invoice = 'INVOICE',
}

export type MileageBasedInspectionProcessPossibleTransition = {
  __typename?: 'MileageBasedInspectionProcessPossibleTransition'
  preconditions: Array<FleetProcessStateTransitionPrecondition>
  state: MileageBasedInspectionProcessState
}

export enum MileageBasedInspectionProcessState {
  /** Everything is done */
  Done = 'DONE',
  /** The next inspection within x km */
  Due = 'DUE',
  /** The vehicle is waiting to get inactive */
  InProgress = 'IN_PROGRESS',
  /** The inspection is done, a manual confirmation to move to next state is needed */
  MileageBasedInspectionDone = 'MILEAGE_BASED_INSPECTION_DONE',
  /** The inspection is done but the invoice is still missing */
  WaitingForInvoice = 'WAITING_FOR_INVOICE',
  /** The vehicle is waiting to get picked up */
  WaitingForPickup = 'WAITING_FOR_PICKUP',
  /** The vehicle is waiting to get returned */
  WaitingForReturn = 'WAITING_FOR_RETURN',
}

export type MileageBasedInspectionProcessTransition = {
  __typename?: 'MileageBasedInspectionProcessTransition'
  initiatedAt: Scalars['DateTime']['output']
  /** The username of the user who initiated the transition */
  initiatedBy: Scalars['String']['output']
  toState: MileageBasedInspectionProcessState
}

export type MileageBasedInspectionProcessTransitionRequest = {
  nextState: MileageBasedInspectionProcessState
  processId: Scalars['ID']['input']
}

export type MileageBasedInspectionTestFacility = {
  __typename?: 'MileageBasedInspectionTestFacility'
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  region: Region
}

export type MileageBasedInspectionUploadProcessDocumentInput = {
  documentType: MileageBasedInspectionProcessDocumentType
  processId: Scalars['ID']['input']
}

export type MileageBasedInspectionUploadProcessDocumentResult = {
  __typename?: 'MileageBasedInspectionUploadProcessDocumentResult'
  documentId: Scalars['ID']['output']
  /** The pre-signed URL for uploading the document */
  url: Scalars['String']['output']
}

export type MinervaCitation = {
  __typename?: 'MinervaCitation'
  label: Scalars['String']['output']
  metricPaths: Array<Scalars['String']['output']>
  panelId: Maybe<Scalars['String']['output']>
  viewId: Scalars['String']['output']
}

export enum MinervaGranularity {
  Day = 'DAY',
  Hour = 'HOUR',
  Month = 'MONTH',
  Week = 'WEEK',
}

export type MinervaMetricInput = {
  cube: Scalars['String']['input']
  filterOverrides?: InputMaybe<Scalars['String']['input']>
  metricPath: Scalars['String']['input']
  rows: Scalars['String']['input']
  viewId?: InputMaybe<Scalars['String']['input']>
}

export type MinervaReactionInput = {
  fleet?: InputMaybe<Scalars['String']['input']>
  reaction: MinervaReactionType
  requestId: Scalars['ID']['input']
  responseText: Scalars['String']['input']
  serviceAreaUuid?: InputMaybe<Scalars['String']['input']>
  userGroups?: InputMaybe<Array<Scalars['String']['input']>>
}

export type MinervaReactionResponse = {
  __typename?: 'MinervaReactionResponse'
  reaction: MinervaReactionType
  requestId: Scalars['ID']['output']
}

export enum MinervaReactionType {
  Dislike = 'DISLIKE',
  Like = 'LIKE',
}

export type MinervaViewContextInput = {
  filters?: InputMaybe<Scalars['String']['input']>
  granularity: MinervaGranularity
  panelId?: InputMaybe<Scalars['String']['input']>
  serviceAreaUuid?: InputMaybe<Scalars['String']['input']>
  tenant: Scalars['String']['input']
  timeframe: Scalars['String']['input']
  title?: InputMaybe<Scalars['String']['input']>
  viewId: Scalars['String']['input']
}

export type MinervaViewSummaryInput = {
  metrics: Array<MinervaMetricInput>
  question?: InputMaybe<Scalars['String']['input']>
  viewContext: MinervaViewContextInput
}

export type MinervaViewSummaryResponse = {
  __typename?: 'MinervaViewSummaryResponse'
  citations: Array<MinervaCitation>
  requestId: Scalars['ID']['output']
  summary: Maybe<Scalars['String']['output']>
  title: Maybe<Scalars['String']['output']>
}

export type MobileyeMap = {
  __typename?: 'MobileyeMap'
  /** ISO 8601 timestamp of when the map was imported, e.g., '2024-01-01T00:00:00Z'. */
  importedAt: Scalars['String']['output']
  /** Mobileye map name, e.g., 'av-maas/MaaS_map_Hamburg_v257_260429_0901'. */
  map: Scalars['String']['output']
}

export type MobileyeProject = {
  __typename?: 'MobileyeProject'
  /** Mobileye project name, e.g., 'moia-prd-hamburg-cugt'. */
  name: Scalars['String']['output']
  /** Mobileye project identifier. */
  projectId: Scalars['String']['output']
}

export type Money = {
  __typename?: 'Money'
  /** Amount in hundredths (e.g. cents), € 1.50 = 150 */
  amount: Scalars['Int']['output']
  /** Represented as an ISO 4217 currency designator, e.g. EUR */
  currency: Scalars['String']['output']
}

export type MoneyInput = {
  /** Amount in hundredths (e.g. cents), € 1.50 = 150 */
  amount: Scalars['Int']['input']
  /** Represented as an ISO 4217 currency designator, e.g. EUR */
  currency: Scalars['String']['input']
}

export type MultiPolygon = Geometry & {
  __typename?: 'MultiPolygon'
  geoJson: Scalars['String']['output']
  polygons: Array<Shape>
}

export type Mutation = {
  __typename?: 'Mutation'
  /** Activates the climate control of a vehicle. Triggers a call to the telematic box. The target temperature is a fixed value on the telematic box. */
  activateClimateControl: ActivateClimateControlResponse
  /** Activate a demo route (make it available for use) */
  activateDemoRoute: Maybe<DemoRoute>
  activateEmergencyStopButtonIncident: Maybe<SimulatedAdVehicleIncident>
  activateSimulatedADVehicleIncident: Maybe<SimulatedAdVehicleIncident>
  /** Put a vehicle into the ACTIVE state. A lot of validation is required for this. */
  activateVehicle: StateChangeResponse
  addCustomRoadBlockageActivation: RoadBlockageActivation
  addCustomTurnRestrictionActivation: TurnRestrictionActivation
  addKeepOutZoneActivation: KeepOutZoneActivation
  addLegalDocumentVersion: LegalDocument
  addRoadBlockageActivation: RoadBlockageActivation
  addTimelineEvent: Scalars['Boolean']['output']
  addTripFeedback: Maybe<TripFeedback>
  addTripRider: Maybe<TripRider>
  addTripSegment: Maybe<TmpTrip>
  addTurnRestrictionActivation: TurnRestrictionActivation
  adminPanelSwapGroup: BackofficeUser
  allowlistPhoneNumberForSignup: SignupAllowlistEntry
  approveCustomPriceConfig: ApproveCustomPriceConfigResponse
  approveDefaultPriceConfig: ApproveDefaultPriceConfigResponse
  /** Archive the 'ACTIVE' in-app message, if there is one. (i.e. stop displaying it to customers) */
  archiveActiveInAppMessage: Maybe<Scalars['Unit']['output']>
  archivePriceConfigPolygon: ArchivePriceConfigPolygonResponse
  /** Archive a vehicle. This can only be done if the previous state was INACTIVE or DRAFT */
  archiveVehicle: StateChangeResponse
  /** Assigns a CDIS box to a vehicle */
  assignCdisBoxToVehicle: AssignedCdisBox
  /** Assign RFID Tag to CDIS Box */
  assignRfidToCdis: Scalars['Boolean']['output']
  assignSavedTrip: Maybe<TmpTrip>
  assignTabletToVehicle: HardwareConfiguration
  assignTrip: Maybe<TmpTrip>
  backofficeStatusCreate: BackofficeStatus
  backofficeStatusDelete: BackofficeStatusDeleteResponse
  backofficeStatusDeleteMediaByFileName: BackofficeStatusDeleteMediaByFileNameResponse
  backofficeStatusSetLastVisit: BackofficeStatusesLastVisitResponse
  backofficeStatusUpdate: BackofficeStatus
  backofficeUpdateCreate: BackofficeUpdate
  backofficeUpdateDelete: BackofficeUpdateDeleteResponse
  backofficeUpdateSetLastVisit: BackofficeUpdatesLastVisitResponse
  backofficeUpdateUpdate: BackofficeUpdate
  backofficeUpdatesGetMediaPresignedUrlByFileName: Maybe<BackofficeUpdateFilePresignedResponse>
  backofficeUpdatesGetPresignedUrl: BackofficeUpdateFilePresignedResponse
  backofficeUserManagementAddUserToGroup: BackofficeUser
  backofficeUserManagementCreateBackofficeGroup: BackofficeUserManagementGroup
  backofficeUserManagementCreateBackofficeUser: BackofficeUser
  backofficeUserManagementDeleteBackofficeGroup: Scalars['String']['output']
  backofficeUserManagementDeleteBackofficeUser: Scalars['String']['output']
  backofficeUserManagementDisableBackofficeUser: Scalars['String']['output']
  backofficeUserManagementEnableBackofficeUser: Scalars['String']['output']
  backofficeUserManagementLogoutBackofficeUser: Scalars['ID']['output']
  backofficeUserManagementRemoveUserFromGroup: BackofficeUser
  backofficeUserManagementResetMfaBackofficeUser: Scalars['String']['output']
  backofficeUserManagementSwapGroups: BackofficeUser
  backofficeUserManagementUpdateBackofficeGroup: BackofficeUserManagementGroup
  backofficeUserManagementUpdateBackofficeUser: BackofficeUser
  /** Updates multiple StopValidatorConfigs */
  batchUpdateStopValidatorConfigs: Array<StopValidatorConfigDto>
  /** Deactivates up to a configurable maximum number of stops (default: 50) and schedules them for deletion in 24h */
  bulkDeleteStops: Array<BulkStopDeleteError>
  /** Applies a partial attribute patch to up to a configurable maximum number of stops (default: 50) simultaneously */
  bulkUpdateStops: BulkStopUpdateResult
  /**
   * Updates the approval state of a campaign for one department (Financial, Legal, or Technical).
   * The campaign must be in APPROVAL_PENDING state.
   */
  campaignApprovalUpdate: CampaignApprovalUpdateResponse
  /** Create a new campaign (minimal initial data) */
  campaignCreate: CampaignCreateResponse
  /** Performs synchronous campaign state transition to DRAFT state */
  campaignSendBackToDraft: CampaignSendBackToDraftResponse
  /** Performs synchronous campaign state transition to APPROVAL_PENDING state */
  campaignSendForApproval: CampaignSendForApprovalResponse
  /** Initiates asynchronous test start for a VALID or STARTING_TEST_FAILED campaign, transitioning it to STARTING_TEST */
  campaignStartTest: CampaignStartTestResponse
  /** Stops an ACTIVE campaign */
  campaignStop: CampaignStopResponse
  /** Initiates asynchronous test stop for a TESTING or STOPPING_TEST_FAILED campaign, transitioning it to STOPPING_TEST */
  campaignStopTest: CampaignStopTestResponse
  /** Update an existing campaign */
  campaignUpdate: CampaignUpdateResponse
  /** Initiate asynchronous campaign validation */
  campaignValidate: CampaignValidateResponse
  /** Replace the vehicle selection for a campaign */
  campaignVehicleSelectionUpdate: CampaignVehicleSelectionUpdateResponse
  cancelTrip: Maybe<TmpTrip>
  /**
   * Reserves a vehicle exclusively for a customer. Any existing claim of
   * that customer or that vehicle is removed.
   */
  claimVehicle: Vehicle
  clearTrip: Maybe<Scalars['Boolean']['output']>
  clearTripAnnotationResolution: Maybe<TripAnnotation>
  closeTemporaryBackofficeSession: TemporaryBackofficeSession
  /** Vehicle CLOSE interaction to be used via backoffice by driver managers. */
  closeVehicleByBackofficeUser: VehicleInteractionResponse
  /** Vehicle CLOSE interaction to be used by app for drivers and service staff */
  closeVehicleByEmployee: VehicleInteractionResponse
  /** Vehicle OPEN interaction to be used via backoffice by driver managers in case of an emergency */
  closeVehicleForEmployeeInEmergency: VehicleInteractionResponse
  confirmTripSegment: Maybe<ConfirmTripSegmentResult>
  createAction: Action
  createArea: Area
  createCustomPriceConfig: CreateCustomPriceConfigResponse
  createCustomRoadBlockage: RoadBlockage
  createCustomTurnRestriction: TurnRestriction
  createDefaultPriceConfig: CreateDefaultPriceConfigResponse
  /** Create a new demo route */
  createDemoRoute: Maybe<DemoRoute>
  createHub: Hub
  createImpersonationSession: CreateTemporaryBackofficeSessionResponse
  createKeepOutZone: KeepOutZone
  createLegalDocument: LegalDocument
  /** Creates a new line in a service area */
  createLine: Line
  /** Create a new in-app message and take it 'ACTIVE' (i.e. start displaying it to customers) */
  createNewActiveInAppMessage: Maybe<Scalars['Unit']['output']>
  createOverwatchFleet: OverwatchFleet
  createOverwatchVehicle: OverwatchVehicle
  createPriceConfigPolygon: CreatePriceConfigPolygonResponse
  createPricingCampaign: CreatePricingCampaignResponse
  createRoadBlockage: RoadBlockage
  createSafetyDriverAnnotation: VnvBackofficeStatusResponse
  createSavedTrip: Maybe<SavedTripEntry>
  createScopedAccessSession: CreateTemporaryBackofficeSessionResponse
  /** Creates a new Service Area */
  createServiceArea: ServiceArea
  /** Creates a new Stop */
  createStop: Maybe<Stop>
  createTranscribedTripAnnotation: Maybe<TripAnnotation>
  createTripGeneratorTemplate: Maybe<TripGeneratorTemplate>
  createTurnRestriction: TurnRestriction
  createVehicleDataOverrides: VnvBackofficeStatusResponse
  /** Creates a vehicle list, into which an arbitrary number of vehicles can be logically grouped */
  createVehicleList: VehicleListResponse
  createWorkOrders: Scalars['Boolean']['output']
  /** Deactivate a demo route (make it unavailable for use) */
  deactivateDemoRoute: Maybe<DemoRoute>
  deactivateSimulatedADVehicleIncident: Maybe<SimulatedAdVehicleIncident>
  deactivateVehicle: StateChangeResponse
  deleteAction: Maybe<Action>
  deleteArea: Maybe<Area>
  deleteCustomPriceConfig: DeleteCustomPriceConfigResponse
  deleteCustomRoadBlockage: Maybe<RoadBlockage>
  deleteCustomRoadBlockageActivation: Scalars['Boolean']['output']
  deleteCustomTurnRestriction: Maybe<TurnRestriction>
  deleteCustomTurnRestrictionActivation: Scalars['Boolean']['output']
  deleteDefaultPriceConfig: DeleteDefaultPriceConfigResponse
  /** Delete a demo route by ID */
  deleteDemoRoute: Maybe<Scalars['Boolean']['output']>
  deleteKeepOutZone: Maybe<KeepOutZone>
  deleteKeepOutZoneActivation: Scalars['Boolean']['output']
  /** Deletes a line */
  deleteLine: Scalars['Boolean']['output']
  deleteOverwatchFleet: Scalars['Boolean']['output']
  deleteOverwatchVehicle: Scalars['Boolean']['output']
  deleteRoadBlockage: Maybe<RoadBlockage>
  deleteSafetyDriverAnnotation: VnvBackofficeStatusResponse
  deleteSavedTrip: Maybe<Scalars['Boolean']['output']>
  /** Deletes a scheduled state change, see above */
  deleteScheduleVehicleStateChange: ScheduleVehicleStateDeletionResponse
  deleteServiceBreak: Scalars['ID']['output']
  /** Deactivates a Stop and schedules it for deletion in 24h */
  deleteStop: Maybe<Stop>
  deleteTripGeneratorTemplate: TripGeneratorDeleteTemplateResult
  deleteTurnRestriction: Maybe<TurnRestriction>
  /** Delete a vehicle by id. Only vehicles in state DRAFT can be deleted */
  deleteVehicle: Scalars['Boolean']['output']
  deleteVehicleDataOverrides: VnvBackofficeStatusResponse
  deleteVehicleList: Scalars['Boolean']['output']
  /**
   * Delete a single work order with optimistic locking.
   *
   * Error codes:
   * - WORK_ORDER_NOT_AVAILABLE: The work order does not exist.
   * - CONFLICT: The work order was modified since it was last read. Re-fetch and retry.
   */
  deleteWorkOrder: DeleteWorkOrderResponse
  dialOutFromChimeMeeting: Maybe<Scalars['Void']['output']>
  disableCustomer: DisableCustomerResponse
  disapproveCustomPriceConfig: DisapproveCustomPriceConfigResponse
  disapproveDefaultPriceConfig: DisapproveDefaultPriceConfigResponse
  dsBossCreateOrUpdateScenario: DsBossCreateOrUpdateResponse
  dsBossDeleteScenario: DsBossDeleteResponse
  dsBossSaveFinalOutputToDataset: DsBossCreateOrUpdateResponse
  /** Edit the last/current state change, no scheduled one */
  editCurrentStateChange: Scalars['Boolean']['output']
  /**
   * Edit an existing vehicle status entry.
   * @deprecated Use fleetPlannerEditVehicleStatus instead. This mutation will be removed in a future release.
   */
  editVehicleInFleet: Array<FleetPlannerVehicleEntry>
  employeeAuthDataChangeValue: Employee
  employeeAuthDataResendCode: EmployeeAuthDataResendCodeResponse
  employeeAuthDataVerifyCode: Employee
  employeeBlock: EmployeeBlockResponse
  /** Mutation for Operations App to clear driver emergency contact details */
  employeeClearEmergencyContact: Employee
  employeeCreateNote: EmployeeCreateNoteResponse
  employeeCreateNotes: EmployeeCreateNotesResponse
  employeeCreateScheduledBlock: EmployeeScheduledBlock
  /** Deletes all messages with the supplied IDs, to be used by Operations App */
  employeeDeleteMessages: EmployeeDeleteMessagesResponse
  employeeDeleteNotes: EmployeeDeleteNotesResponse
  employeeDeleteProfile: EmployeeDeleteProfileResponse
  employeeDeleteScheduledBlock: EmployeeDeleteScheduledBlockResponse
  employeeNoteCreateFileGetUrl: EmployeeCreateNoteFileGetUrlResponse
  employeeNoteCreatePreSignedUrl: EmployeeNoteFilePreSignedUrlResponse
  /** The notification body should be base64-encoded. Only available on DEV for testing */
  employeeNotificationTestInjection: Scalars['Boolean']['output']
  /** Defaults to German language if nothing is set */
  employeePushTokenAdd: Scalars['Boolean']['output']
  /** Defaults to German language if nothing is set */
  employeePushTokenDelete: Scalars['Boolean']['output']
  employeeResendEmailVerification: EmployeeResendEmailVerificationResponse
  employeeResetPassword: EmployeeResetPasswordResponse
  employeeSendMessages: EmployeeSendMessagesResponse
  /** Mutation for Operations App to update driver emergency contact details */
  employeeSetEmergencyContact: Employee
  employeeUnblock: EmployeeUnblockResponse
  employeeUpdateNote: EmployeeUpdateNoteResponse
  employeeUpdateProfileData: Employee
  employeeUpdateScheduledBlock: EmployeeScheduledBlock
  employeesSetFleets: Array<Employee>
  enableCustomer: EnableCustomerResponse
  fccBroadcastFleetShutdownMessage: Maybe<Scalars['Void']['output']>
  fccCancelUpcomingTrip: Maybe<Scalars['Void']['output']>
  fccConfirmCabinSafety: Maybe<Scalars['Void']['output']>
  fccDeclineIncomingCall: Maybe<Scalars['Void']['output']>
  fccInitiateOperatorToCabinCall: Scalars['ChimeCredentials']['output']
  fccInitiateOperatorToSafetyDriverCall: Scalars['ChimeCredentials']['output']
  fccJoinCabinToOperatorCall: Scalars['ChimeCredentials']['output']
  fccJoinSafetyDriverCall: Scalars['ChimeCredentials']['output']
  fccManageService: FccManageServiceResponse
  fccProvideTripCancellationReason: Maybe<Scalars['Void']['output']>
  /**
   * Request video stream credentials for the vehicle cabin (AWS Chime)
   * @deprecated Use Vehicle Perception's video streaming credentials API, which serves both Chime and LiveKit. Removed once no client calls this.
   */
  fccRequestCabinVideoStreamCredentials: Scalars['ChimeCredentials']['output']
  /** @deprecated Use fccSendDoorRequest */
  fccRequestDoorActuation: Maybe<Scalars['Void']['output']>
  fccRequestFleetShutdown: Maybe<Scalars['Void']['output']>
  fccRequestHubReturn: Maybe<Scalars['Void']['output']>
  fccRequestServiceCancellation: Maybe<Scalars['Void']['output']>
  fccSendDoorRequest: Maybe<Scalars['Void']['output']>
  /** @deprecated Availability follows the fccVehicleHandling subscription */
  fccSetAvailability: FccCurrentOperatorAvailability
  /**
   * Handles the vehicle in the caller's own role, which decides the handling slot it occupies. An
   * operator on duty in several areas holds one slot per area, so the role cannot be inferred server
   * side and has to be the one of the area the call comes from.
   */
  fccStartHandlingVehicle: Maybe<Scalars['Void']['output']>
  fccStopHandlingVehicle: Maybe<Scalars['Void']['output']>
  /** Trigger an emergency stop (Minimal Risk Maneuver) for a vehicle */
  fccTriggerEmergencyStop: Maybe<Scalars['Void']['output']>
  fccUpdateAdPoolingStatus: FccUpdateAdPoolingStatusStatus
  /** Refund the payment for a fee */
  feeRefundByTripId: Maybe<Scalars['RefundSuccess']['output']>
  /** Flash (activate blinker/indicator) of CDIS vehicle (only possible for vehicles that aren't open) */
  flashVehicle: Scalars['Boolean']['output']
  fleetAssignVehicles: Array<Vehicle>
  fleetCreate: Fleet
  fleetDelete: Fleet
  /** Add a new status entry to a vehicle's history. */
  fleetPlannerAddEntryToVehicle: Array<FleetPlannerVehicleEntry>
  /** Delete a campaign assignment by campaign ID. */
  fleetPlannerDeleteCampaignAssignement: Maybe<Scalars['Boolean']['output']>
  /** Delete a vehicle status entry, optionally rescheduling other entries' dates. */
  fleetPlannerDeleteVehicleStatus: Array<FleetPlannerVehicleEntry>
  /** Edit an existing vehicle status entry. */
  fleetPlannerEditVehicleStatus: Array<FleetPlannerVehicleEntry>
  /** Save a campaign assignment. */
  fleetPlannerSaveCampaignAssignement: Maybe<FleetCampaignPlanningResult>
  fleetUpdate: Fleet
  generateRouteForRequirements: Maybe<RouteBuilderValidationResult>
  /** Triggers stop network generation for a given polygon within a service area */
  generateStopNetwork: StopBulkImport
  insertHubCheckedInLogRecord: InsertHubLogCheckedInRecordResponse
  insertHubCheckedOutLogRecord: InsertHubLogCheckedOutRecordResponse
  invalidateCustomRoadBlockageReport: Scalars['Boolean']['output']
  invalidateRoadBlockageReport: Scalars['Boolean']['output']
  joinVehicleChimeMeeting: JoinVehicleChimeMeetingResponse
  /** Returns a pre-signed URL for uploading a document */
  mainInspectionUploadProcessDocument: MainInspectionUploadProcessDocumentResult
  /** Manually check in a passenger. */
  manuallyCheckInPassenger: Maybe<ManuallyCheckInPassengerOutput>
  /** Manually no show a passenger for an AD vehicle. */
  manuallyNoShowPassenger: Maybe<ManuallyNoShowPassengerOutput>
  /** mark message as acknowledged, return value indicates success of operation */
  markEmployeeMessageAsAcknowledged: Maybe<EmployeeMessageResponse>
  /** mark message as read, return value indicates success of operation */
  markEmployeeMessageAsRead: Maybe<EmployeeMessageResponse>
  /** Returns a pre-signed URL for uploading a document */
  mileageBasedInspectionUploadProcessDocument: MileageBasedInspectionUploadProcessDocumentResult
  minervaReaction: MinervaReactionResponse
  /** Vehicle OPEN interaction to be used by app for drivers and service staff */
  openVehicleByEmployee: VehicleInteractionResponse
  /** To be used by backoffice users opening a vehicle for themselves */
  openVehicleForBackofficeUser: VehicleInteractionResponse
  /** Vehicle OPEN interaction to be used via backoffice by driver managers */
  openVehicleForEmployee: VehicleInteractionResponse
  /** Vehicle OPEN interaction to be used via backoffice by driver managers in case of an emergency */
  openVehicleForEmployeeInEmergency: VehicleInteractionResponse
  /** Registers or refreshes the calling user's device token for push notifications. */
  opsCareDeviceTokenAdd: OpsCareDeviceTokenAddResponse
  /** Removes a device token so the device stops receiving push notifications. */
  opsCareDeviceTokenDelete: OpsCareDeviceTokenDeleteResponse
  /**
   * Updates the OpsCare settings of the calling user. Settings apply to the user, not to the device
   * issuing the mutation.
   */
  opsCareSettingsUpdate: OpsCareSettingsUpdateResponse
  prolongTemporaryBackofficeSession: TemporaryBackofficeSession
  /** Prompt the graphql-genius to write a GraphQL Operation for you. */
  promptGenius: GraphQlGeniusResult
  /** Publish an SDS guidance decision for a vehicle issue. */
  publishSDSGuidanceDecision: Maybe<Scalars['Boolean']['output']>
  /** Triggers a call to the telematic box, which would also wake it up if it was asleep. */
  refreshVehicleTelematics: Scalars['Boolean']['output']
  /** Refund the payment for a trip */
  refundByTripId: Maybe<Scalars['RefundSuccess']['output']>
  removeAllowlistedPhoneNumber: RemoveAllowlistedPhoneNumberResponse
  removeRoadBlockageActivation: Scalars['Boolean']['output']
  removeTripFeedback: Maybe<TripFeedback>
  removeTripRider: Maybe<TripRider>
  removeTripSegment: Maybe<TmpTrip>
  removeTurnRestrictionActivation: Scalars['Boolean']['output']
  replyToOffer: Maybe<Scalars['Boolean']['output']>
  requestVehicleMediaStreamCredentials: VehicleMediaStreamCredentials
  /**
   * Resets current service class config parameters. Removes any configured
   * limits.
   */
  resetOfferAndPoolingConfig: OfferAndPoolingConfig
  rioDeleteReport: RioDeleteReportResponse
  rioSetReportStatus: RioSetReportStatusResponse
  rioShareReport: RioShareReportResponse
  rioStoreListViewConfig: RioStoreListViewConfigResponse
  rioStoreReport: RioStoreReportResponse
  rioStoreTemplate: RioStoreTemplateResponse
  /** Schedules a vehicle state change in the future to make sure the vehicle isn't in the field, for example for an upcoming event, inspections, hub transfer, etc */
  scheduleVehicleStateChange: ScheduleVehicleStateChangeResponse
  sdgAcceptIncomingCall: Scalars['ChimeCredentials']['output']
  sdgDeclineIncomingCall: Maybe<Scalars['Void']['output']>
  sdgInitiateSafetyDriverToOperatorCall: Scalars['ChimeCredentials']['output']
  serviceBreakLocationChangeState: ServiceBreakLocationChangeStateResponse
  serviceBreakLocationDelete: ServiceBreakLocationDeleteResponse
  serviceBreakLocationDeleteCapacityOverride: ServiceBreakLocationDeleteCapacityOverrideResponse
  serviceBreakLocationStoreBaseData: ServiceBreakLocationStoreBaseDataResponse
  serviceBreakLocationStoreCapacityOverride: ServiceBreakLocationStoreCapacityOverrideResponse
  serviceBreakLocationStoreCapacitySchedule: ServiceBreakLocationStoreCapacityScheduleResponse
  serviceBreakLocationUpdateRoutableLocationAndPolygon: ServiceBreakLocationUpdateRoutableLocationAndPolygonResponse
  serviceIntervalCreate: ServiceIntervalCreateResponse
  setSavedTripArchived: Maybe<SavedTripEntry>
  setShiftComment: ShiftComment
  setShiftEmployeeStatus: Maybe<ShiftEmployeeStatus>
  setTaskNotificationPending: TaskNotification
  setTripAnnotationAnswered: Maybe<TripAnnotation>
  setTripAnnotationResolved: Maybe<TripAnnotation>
  /** Defines the vehicles (via ID) in a previously created vehicle list */
  setVehiclesInList: Scalars['Boolean']['output']
  shiftCapacityPlanningCreate: ShiftCapacityPlanning
  shiftCapacityPlanningDelete: Scalars['Boolean']['output']
  shiftCapacityPlanningUpdateStatus: ShiftCapacityPlanning
  /** confirm shift related task notifications */
  shiftConfirmTaskNotification: ShiftConfirmTaskNotificationResponse
  shiftDeletePlannedHubReturnSection: ShiftDeletePlannedHubReturnSectionResponse
  shiftOverrideScheduledHubReturn: ShiftScheduledHubReturn
  /** updates shift type (WAV, SDO, or Pluto) for a given shift */
  shiftOverrideType: ShiftOverrideTypeResponse
  shiftSetPlannedHubReturnSection: ShiftSetPlannedHubReturnSectionResponse
  /** Simulate incoming "cabin ready check requested" event from Vehicle Cabin Surveillance. Only available for testing on DEV & INT. */
  simulateCabinReadyCheckRequestedEvent: Maybe<Scalars['Void']['output']>
  /**
   * Simulate incoming "close door requested" event from Vehicle Cabin Surveillance. Only available for testing on DEV & INT.
   * @deprecated This event is no longer used.
   */
  simulateCloseDoorRequestedEvent: Maybe<Scalars['Void']['output']>
  /** Simulate incoming door actuation response from Vehicle Cabin Surveillance. Only available for testing on DEV & INT. */
  simulateRemoteDoorActuationResponseEvent: Maybe<Scalars['Void']['output']>
  /** Simulate all events associated with waypoint attendance. Only available for testing on DEV & INT. */
  simulateWaypointAttendance: Maybe<Scalars['Void']['output']>
  /** Start a session; assistantText is the opening question. */
  startDisengagementVoicebotSession: DisengagementVoicebotTurn
  stopPendingDeletion: StopPendingDeletionResponse
  subscribeTripGeneratorTemplate: Maybe<TripGeneratorTemplate>
  /**
   * Turn assistant text into speech. Fails with SERVICE_UNAVAILABLE when no TTS provider is configured,
   * so clients can fall back to on-device speech synthesis.
   */
  synthesizeDisengagementVoicebotSpeech: DisengagementVoicebotSpeech
  /** Submit one transcribed driver answer and get the next question. */
  takeDisengagementVoicebotTurn: DisengagementVoicebotTurn
  trackBackofficeMetric: Scalars['Boolean']['output']
  transitionMainInspectionProcessToNextState: FleetProcessTransitionResponse
  transitionMileageBasedInspectionProcessToNextState: FleetProcessTransitionResponse
  transitionVICProcessToNextState: FleetProcessTransitionResponse
  triggerArrivalEvent: Maybe<Scalars['Boolean']['output']>
  triggerDepartureEvent: Maybe<Scalars['Boolean']['output']>
  /** Trigger manual arrival for an AD vehicle. */
  triggerManualArrivalForAdVehicle: Maybe<Scalars['Boolean']['output']>
  triggerSimulatedVehicleEvent: Maybe<Scalars['Boolean']['output']>
  /** Trigger a new task. Only available for testing on DEV & INT. */
  triggerTaskNotification: Scalars['Boolean']['output']
  /** Unarchive an ID_BUZZ_PREP vehicle, moving it back to DRAFT state. */
  unarchiveVehicle: VehicleResponse
  /** Unassigns a CDIS box from a vehicle */
  unassignCdisBoxFromVehicle: Scalars['Boolean']['output']
  unassignTabletFromVehicle: HardwareConfiguration
  /**
   * Removes the vehicle-claim of a customer. Succeeds even if the vehicle is
   * not claimed and if the customer has no claim.
   */
  unclaimVehicle: Scalars['ID']['output']
  unsubscribeTripGeneratorTemplate: Maybe<TripGeneratorTemplate>
  updateAction: Action
  /** Update the 'ACTIVE' in-app message, if there is one. */
  updateActiveInAppMessage: Maybe<Scalars['Unit']['output']>
  updateArea: Area
  updateAreaCapacity: Area
  updateCustomPriceConfig: UpdateCustomPriceConfigResponse
  updateCustomRoadBlockage: RoadBlockage
  updateCustomRoadBlockageActivation: RoadBlockageActivation
  updateCustomTurnRestriction: TurnRestriction
  updateCustomTurnRestrictionActivation: TurnRestrictionActivation
  updateCustomer: UpdateCustomerResponse
  updateDeactivationAlert: DeactivationAlert
  updateDefaultPriceConfig: UpdateDefaultPriceConfigResponse
  /** Update an existing demo route */
  updateDemoRoute: Maybe<DemoRoute>
  /** returns a pre-signed profile picture URL (valid for 60s) for picture uploads or clears the stored profile picture */
  updateEmployeePicture: UpdateEmployeeProfilePictureResponse
  /** Updates the heatmap configuration for a service area */
  updateHeatmapConfig: HeatmapConfig
  updateHub: Hub
  updateKeepOutZone: KeepOutZone
  updateKeepOutZoneActivation: KeepOutZoneActivation
  /** Updates an existing line */
  updateLine: Line
  /** Updates the line service configuration for a service area */
  updateLineServiceConfig: LineServiceConfig
  updateMainInspectionProcessData: MainInspectionProcess
  updateMileageBasedInspectionProcessData: MileageBasedInspectionProcess
  /** Updates current service class config */
  updateOfferAndPoolingConfig: OfferAndPoolingConfig
  updateOverwatchVehicle: OverwatchVehicle
  updateRoadBlockage: RoadBlockage
  updateRoadBlockageActivation: RoadBlockageActivation
  updateSafetyDriverAnnotation: VnvBackofficeStatusResponse
  updateSafetyDriverForcePudo: Maybe<TmpTrip>
  updateSafetyDriverTripConfirmationState: Maybe<TmpTrip>
  updateSavedTrip: Maybe<SavedTripEntry>
  /** Updates a Service Area */
  updateServiceArea: ServiceArea
  updateSimulatedADVehicle: Maybe<SimulatedAdVehicle>
  updateSimulatedVehicle: Maybe<SimulatedVehicle>
  /** Updates a Stop */
  updateStop: Maybe<Stop>
  /** Updates the allowed stop flags configuration for a service area */
  updateStopFlagConfig: StopFlagConfigurationDto
  /** Updates a StopValidatorConfig */
  updateStopValidatorConfig: Maybe<StopValidatorConfigDto>
  updateTaskNotificationNote: TaskNotification
  updateTaskNotificationStatus: TaskNotification
  updateTaskNotificationVehicleId: TaskNotification
  updateTrip: Maybe<TmpTrip>
  updateTripDetails: Maybe<TripDetails>
  updateTripFeedback: Maybe<TripFeedback>
  updateTripGeneratorTemplate: Maybe<TripGeneratorTemplate>
  updateTripRider: Maybe<TripRider>
  updateTripSegment: Maybe<TmpTrip>
  updateTurnRestriction: TurnRestriction
  updateTurnRestrictionActivation: TurnRestrictionActivation
  updateVICProcessData: VicProcess
  /** Update the base data of a vehicle. */
  updateVehicle: VehicleResponse
  updateVehicleDataOverrides: VnvBackofficeStatusResponse
  /** Update a vehicle list. Vehicle lists are used for marketing campaigns, events, etc */
  updateVehicleList: VehicleListResponse
  /** Update whether a vehicle is prioritized or not. Prioritized vehicles are shown on top of the available vehicles list in the employee app. */
  updateVehiclePrioritization: VehicleResponse
  /** Will disable or enable rebalancing for provided vehicle. */
  updateVehicleRebalancing: Vehicle
  /**
   * Update a single work orders. Allows to change more fields than just the status.
   *
   * Error codes:
   * - WORK_ORDER_NOT_AVAILABLE: The work order is not available for mutation (deleted or cancelled by admin).
   * - BAD_REQUEST: The update is not allowed (e.g. reopening a closed work order).
   * - CONFLICT: The work order was modified since it was last read. Re-fetch and retry.
   */
  updateWorkOrder: WorkOrder
  /** To be used to change the status of multiple work orders at once. */
  updateWorkOrders: Array<WorkOrder>
  validateRouteInternal: Maybe<RouteBuilderValidationResult>
  validateRouteSds: Maybe<ValidateRouteSdsResult>
  validateTrip: Maybe<ValidateTripResult>
  vehicleAttributesUpdate: Array<VehicleAttribute>
  vehicleCapacityConfigAssignVehicles: Array<Vehicle>
  vehicleCapacityConfigCreate: VehicleCapacityConfig
  vehicleCapacityConfigDelete: Scalars['ID']['output']
  vehicleCapacityConfigSetVehicleOverrides: Array<CapacityOverride>
  vehicleCapacityConfigUpdate: VehicleCapacityConfig
  vehicleCreate: VehicleResponse
  /** Match a safety driver to an AD vehicle. Enforces 1:1 constraints: one active match per vehicle and per safety driver. */
  vehicleMatchSafetyDriver: VehicleMatchSafetyDriverResponse
  vehiclePlanActivitiesSave: Array<VehiclePlan>
  vehiclePlanActivityDelete: VehiclePlan
  vehiclePlanActivityMove: VehiclePlanActivityMoveResult
  /**
   * Copies a template's activities onto the given vehicles. Either all of them are planned or none is, and
   * the answer holds every plan that was written — which can be two per vehicle when the template reaches
   * past midnight, because a plan covers one UTC day.
   */
  vehiclePlanTemplateApply: Array<VehiclePlan>
  /**
   * Removes a template and answers with the id that was deleted.
   * Deleting a template that does not exist is not an error. Plans that were created from the template are not deleted.
   */
  vehiclePlanTemplateDelete: Scalars['ID']['output']
  /** Creates a template when templateId is absent, otherwise replaces the existing one in full. */
  vehiclePlanTemplateSave: VehiclePlanTemplate
  /** Unmatch a safety driver from a vehicle. Only the safety driver who matched can unmatch. */
  vehicleUnmatchSafetyDriver: VehicleUnmatchSafetyDriverResponse
  wipeBoxPc: BoxPc
  /**
   * Create an automation rule for the given tenant. The rule's `referenceNumber` is allocated per tenant,
   * so it is only unique within `tenant`. A new rule has never run, so `runsCount` comes back as 0 and
   * `lastRun` as null.
   *
   * Error codes:
   * - FORBIDDEN: The caller lacks work order write rights, or has no access to `tenant` or to one of `fleetIds`.
   * - BAD_REQUEST: A `WORK_ORDER_CREATION` rule is missing `actionWorkOrderServiceItem`, or names no
   *   `fleetIds` — such a rule could never fire. Or a `REPORT_SUBMIT` rule is missing
   *   `triggerReportCondition`, or a rule of another trigger type carries one.
   * - INTERNAL_SERVER_ERROR: A unique `referenceNumber` could not be allocated after several attempts
   *   because of concurrent creates. Retry.
   */
  workOrderAutomationRuleCreate: WorkOrderAutomationRule
  /**
   * Delete an automation rule that never created a work order.
   *
   * A rule that already created work orders is kept as their origin and can only be archived through
   * `workOrderAutomationRuleStatusUpdate`.
   *
   * Error codes:
   * - FORBIDDEN: The caller lacks WORK_ORDERS_AUTOMATIONS_CRUD, or has no access to one of the rule's
   *   `fleetIds`.
   * - WORK_ORDER_AUTOMATION_RULE_NOT_AVAILABLE: No automation rule exists for `id` in a tenant the
   *   caller has access to.
   * - BAD_REQUEST: The rule has created at least one work order. Archive it instead.
   */
  workOrderAutomationRuleDelete: WorkOrderAutomationRuleDeleteResponse
  /**
   * Change the status of an existing automation rule.
   *
   * Allowed transitions:
   * - ACTIVE -> INACTIVE (deactivate)
   * - INACTIVE -> ACTIVE (activate) and INACTIVE -> ARCHIVED (archive)
   * - ARCHIVED -> INACTIVE (unarchive)
   *
   * Error codes:
   * - FORBIDDEN: The caller lacks WORK_ORDERS_AUTOMATIONS_CRUD, or has no access to one of the rule's
   *   `fleetIds`.
   * - WORK_ORDER_AUTOMATION_RULE_NOT_AVAILABLE: No automation rule exists for `id` in a tenant the
   *   caller has access to.
   * - BAD_REQUEST: The requested transition is not allowed, including a transition to the status the
   *   rule already has.
   * - CONFLICT: The rule's status changed since it was read. Re-fetch and retry.
   */
  workOrderAutomationRuleStatusUpdate: WorkOrderAutomationRuleStatusUpdateResponse
}

export type MutationActivateClimateControlArgs = {
  input: ActivateClimateControlInput
}

export type MutationActivateDemoRouteArgs = {
  id: Scalars['ID']['input']
}

export type MutationActivateEmergencyStopButtonIncidentArgs = {
  fleetVehicleId: Scalars['ID']['input']
}

export type MutationActivateSimulatedAdVehicleIncidentArgs = {
  input: UpdateSimulatedAdVehicleIncidentsInput
}

export type MutationActivateVehicleArgs = {
  input: ActivateVehicleInput
}

export type MutationAddCustomRoadBlockageActivationArgs = {
  input: RoadBlockageActivationInput
  regionId: Scalars['ID']['input']
}

export type MutationAddCustomTurnRestrictionActivationArgs = {
  input: TurnRestrictionActivationInput
  regionId: Scalars['ID']['input']
}

export type MutationAddKeepOutZoneActivationArgs = {
  input: KeepOutZoneActivationInput
  regionId: Scalars['ID']['input']
}

export type MutationAddLegalDocumentVersionArgs = {
  input: AddLegalDocumentVersionMutationInput
}

export type MutationAddRoadBlockageActivationArgs = {
  input: RoadBlockageActivationInput
}

export type MutationAddTimelineEventArgs = {
  apiCallName?: InputMaybe<Scalars['String']['input']>
  content: Scalars['String']['input']
  eventType: ApiEventType
  timestampEpochMs?: InputMaybe<Scalars['Float']['input']>
  traceId?: InputMaybe<Scalars['String']['input']>
  tripId: Scalars['String']['input']
}

export type MutationAddTripFeedbackArgs = {
  feedback: TripFeedbackInput
  tripId: Scalars['String']['input']
}

export type MutationAddTripRiderArgs = {
  rider: TripRiderInput
  tripId: Scalars['String']['input']
}

export type MutationAddTripSegmentArgs = {
  segment: TripSegmentInput
  tripId: Scalars['String']['input']
}

export type MutationAddTurnRestrictionActivationArgs = {
  input: TurnRestrictionActivationInput
}

export type MutationAdminPanelSwapGroupArgs = {
  input: AdminPanelSwapGroupInput
}

export type MutationAllowlistPhoneNumberForSignupArgs = {
  input: AllowlistPhoneNumberInput
}

export type MutationApproveCustomPriceConfigArgs = {
  input: ApproveCustomPriceConfigInput
}

export type MutationApproveDefaultPriceConfigArgs = {
  input: ApproveDefaultPriceConfigInput
}

export type MutationArchiveActiveInAppMessageArgs = {
  customerTenant: Scalars['String']['input']
}

export type MutationArchivePriceConfigPolygonArgs = {
  input: ArchivePriceConfigPolygonInput
}

export type MutationArchiveVehicleArgs = {
  input: ArchiveVehicleInput
}

export type MutationAssignCdisBoxToVehicleArgs = {
  input: AssignCdisBoxToVehicleInput
}

export type MutationAssignRfidToCdisArgs = {
  input: AssignRfidToCdisInput
}

export type MutationAssignSavedTripArgs = {
  savedTripId: Scalars['String']['input']
  vin: Scalars['String']['input']
}

export type MutationAssignTabletToVehicleArgs = {
  input: AssignTabletToVehicleInput
}

export type MutationAssignTripArgs = {
  metadata?: InputMaybe<Array<Array<Scalars['String']['input']>>>
  segments: Array<TripSegmentInput>
  type: TripType
  useStopResolver?: InputMaybe<Scalars['Boolean']['input']>
  vin: Scalars['String']['input']
}

export type MutationBackofficeStatusCreateArgs = {
  input: BackofficeStatusCreate
}

export type MutationBackofficeStatusDeleteArgs = {
  input: BackofficeStatusDelete
}

export type MutationBackofficeStatusDeleteMediaByFileNameArgs = {
  input: BackofficeUpdateGetMediaFilePresignedUrlInput
}

export type MutationBackofficeStatusUpdateArgs = {
  input: BackofficeStatusUpdate
}

export type MutationBackofficeUpdateCreateArgs = {
  input: BackofficeUpdateCreate
}

export type MutationBackofficeUpdateDeleteArgs = {
  input: BackofficeUpdateDelete
}

export type MutationBackofficeUpdateUpdateArgs = {
  input: BackofficeUpdateUpdate
}

export type MutationBackofficeUpdatesGetMediaPresignedUrlByFileNameArgs = {
  input?: InputMaybe<BackofficeUpdateGetMediaFilePresignedUrlInput>
}

export type MutationBackofficeUpdatesGetPresignedUrlArgs = {
  input?: InputMaybe<BackofficeUpdateFilePresignedUrlInput>
}

export type MutationBackofficeUserManagementAddUserToGroupArgs = {
  input: BackofficeUserManagementAddUserToGroupInput
}

export type MutationBackofficeUserManagementCreateBackofficeGroupArgs = {
  input: BackofficeUserManagementCreateBackofficeGroupInput
}

export type MutationBackofficeUserManagementCreateBackofficeUserArgs = {
  input: BackofficeUserManagementCreateBackofficeUserInput
}

export type MutationBackofficeUserManagementDeleteBackofficeGroupArgs = {
  input: BackofficeUserManagementDeleteBackofficeGroupInput
}

export type MutationBackofficeUserManagementDeleteBackofficeUserArgs = {
  input: BackofficeUserManagementDeleteBackofficeUserInput
}

export type MutationBackofficeUserManagementDisableBackofficeUserArgs = {
  input: BackofficeUserManagementDisableBackofficeUserInput
}

export type MutationBackofficeUserManagementEnableBackofficeUserArgs = {
  input: BackofficeUserManagementEnableBackofficeUserInput
}

export type MutationBackofficeUserManagementLogoutBackofficeUserArgs = {
  input: BackofficeUserManagementLogoutBackofficeUserInput
}

export type MutationBackofficeUserManagementRemoveUserFromGroupArgs = {
  input: BackofficeUserManagementRemoveUserFromGroupInput
}

export type MutationBackofficeUserManagementResetMfaBackofficeUserArgs = {
  input: BackofficeUserManagementResetMfaBackofficeUserInput
}

export type MutationBackofficeUserManagementSwapGroupsArgs = {
  input: BackofficeUserManagementSwapGroupsInput
}

export type MutationBackofficeUserManagementUpdateBackofficeGroupArgs = {
  input: BackofficeUserManagementUpdateBackofficeGroupInput
}

export type MutationBackofficeUserManagementUpdateBackofficeUserArgs = {
  input: BackofficeUserManagementUpdateBackofficeUserInput
}

export type MutationBatchUpdateStopValidatorConfigsArgs = {
  inputDtos: Array<StopValidatorConfigInput>
  serviceAreaId: Scalars['ID']['input']
}

export type MutationBulkDeleteStopsArgs = {
  serviceAreaId: Scalars['ID']['input']
  stopIds: Array<Scalars['String']['input']>
}

export type MutationBulkUpdateStopsArgs = {
  input: BulkStopUpdateInput
  serviceAreaId: Scalars['ID']['input']
  stopIds: Array<Scalars['String']['input']>
}

export type MutationCampaignApprovalUpdateArgs = {
  input: CampaignApprovalUpdateInput
}

export type MutationCampaignCreateArgs = {
  input: CampaignCreateInput
}

export type MutationCampaignSendBackToDraftArgs = {
  input: CampaignSendBackToDraftInput
}

export type MutationCampaignSendForApprovalArgs = {
  input: CampaignSendForApprovalInput
}

export type MutationCampaignStartTestArgs = {
  input: CampaignStartTestInput
}

export type MutationCampaignStopArgs = {
  input: CampaignStopInput
}

export type MutationCampaignStopTestArgs = {
  input: CampaignStopTestInput
}

export type MutationCampaignUpdateArgs = {
  input: CampaignUpdateInput
}

export type MutationCampaignValidateArgs = {
  input: CampaignValidateInput
}

export type MutationCampaignVehicleSelectionUpdateArgs = {
  input: CampaignVehicleSelectionUpdateInput
}

export type MutationCancelTripArgs = {
  cancelationReason: CancelationReason
  cancelationSource: Platform
  tripId: Scalars['String']['input']
}

export type MutationClaimVehicleArgs = {
  customerId: Scalars['ID']['input']
  vehicleId: Scalars['ID']['input']
}

export type MutationClearTripArgs = {
  vin: Scalars['String']['input']
}

export type MutationClearTripAnnotationResolutionArgs = {
  annotationId: Scalars['String']['input']
}

export type MutationCloseTemporaryBackofficeSessionArgs = {
  input: CloseTemporaryBackofficeSessionInput
}

export type MutationCloseVehicleByBackofficeUserArgs = {
  input: CloseVehicleByBackofficeUserInput
}

export type MutationCloseVehicleByEmployeeArgs = {
  input: CloseVehicleInput
}

export type MutationCloseVehicleForEmployeeInEmergencyArgs = {
  input: CloseVehicleInput
}

export type MutationConfirmTripSegmentArgs = {
  confirmation: ConfirmationType
  currentLocation?: InputMaybe<TripGeolocationInput>
  segmentId: Scalars['String']['input']
  tripId: Scalars['String']['input']
}

export type MutationCreateActionArgs = {
  input: ActionInput
  serviceAreaID: Scalars['ID']['input']
}

export type MutationCreateAreaArgs = {
  input: AreaInput
  serviceAreaId: Scalars['String']['input']
}

export type MutationCreateCustomPriceConfigArgs = {
  input: CreateCustomPriceConfigInput
}

export type MutationCreateCustomRoadBlockageArgs = {
  regionId: Scalars['ID']['input']
  roadBlockageInput: RoadBlockageInput
}

export type MutationCreateCustomTurnRestrictionArgs = {
  regionId: Scalars['ID']['input']
  turnRestrictionInput: TurnRestrictionInput
}

export type MutationCreateDefaultPriceConfigArgs = {
  input: CreateDefaultPriceConfigInput
}

export type MutationCreateDemoRouteArgs = {
  input: CreateDemoRouteInput
}

export type MutationCreateHubArgs = {
  input: HubDataInput
}

export type MutationCreateImpersonationSessionArgs = {
  input: CreateImpersonationSessionInput
}

export type MutationCreateKeepOutZoneArgs = {
  input: KeepOutZoneInput
  regionId: Scalars['ID']['input']
}

export type MutationCreateLegalDocumentArgs = {
  input: CreateLegalDocumentMutationInput
}

export type MutationCreateLineArgs = {
  input: LineInput
  serviceAreaId: Scalars['String']['input']
}

export type MutationCreateNewActiveInAppMessageArgs = {
  customerTenant: Scalars['String']['input']
  input: InAppMessageCreateInput
}

export type MutationCreateOverwatchFleetArgs = {
  input: CreateOverwatchFleetInput
}

export type MutationCreateOverwatchVehicleArgs = {
  input: CreateOverwatchVehicleInput
}

export type MutationCreatePriceConfigPolygonArgs = {
  input: CreatePriceConfigPolygonInput
}

export type MutationCreatePricingCampaignArgs = {
  input: PricingCampaignInput
}

export type MutationCreateRoadBlockageArgs = {
  roadBlockageInput: RoadBlockageInput
  serviceAreaId: Scalars['ID']['input']
}

export type MutationCreateSafetyDriverAnnotationArgs = {
  annotation: AnnotationInput
}

export type MutationCreateSavedTripArgs = {
  allWaypointsMode?: InputMaybe<Scalars['Boolean']['input']>
  assignedVtrs?: InputMaybe<Array<AssignedVtrInput>>
  associatedVtr?: InputMaybe<Scalars['String']['input']>
  codebeamerId?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  metadata?: InputMaybe<Array<Array<Scalars['String']['input']>>>
  metroId: Scalars['Int']['input']
  name: Scalars['String']['input']
  segments: Array<TripSegmentInput>
  tripId?: InputMaybe<Scalars['String']['input']>
  type: TripType
}

export type MutationCreateScopedAccessSessionArgs = {
  input: CreateScopedAccessSessionInput
}

export type MutationCreateServiceAreaArgs = {
  input: ServiceAreaCreationInput
}

export type MutationCreateStopArgs = {
  input: StopInput
  serviceAreaId: Scalars['String']['input']
}

export type MutationCreateTranscribedTripAnnotationArgs = {
  input: CreateTranscribedTripAnnotationInput
}

export type MutationCreateTripGeneratorTemplateArgs = {
  input: TripGeneratorCreateTemplateInput
}

export type MutationCreateTurnRestrictionArgs = {
  serviceAreaId: Scalars['ID']['input']
  turnRestrictionInput: TurnRestrictionInput
}

export type MutationCreateVehicleDataOverridesArgs = {
  entries: Array<VehicleDataOverrideEntry>
}

export type MutationCreateVehicleListArgs = {
  input: VehicleListInput
}

export type MutationCreateWorkOrdersArgs = {
  input: CreateWorkOrdersInput
}

export type MutationDeactivateDemoRouteArgs = {
  id: Scalars['ID']['input']
}

export type MutationDeactivateSimulatedAdVehicleIncidentArgs = {
  fleetVehicleId: Scalars['ID']['input']
  type: IncidentTypeIds
}

export type MutationDeactivateVehicleArgs = {
  input: DeactivateVehicleInput
}

export type MutationDeleteActionArgs = {
  actionID: Scalars['ID']['input']
  serviceAreaID: Scalars['ID']['input']
}

export type MutationDeleteAreaArgs = {
  areaId: Scalars['ID']['input']
  serviceAreaId: Scalars['ID']['input']
}

export type MutationDeleteCustomPriceConfigArgs = {
  input: DeleteCustomPriceConfigInput
}

export type MutationDeleteCustomRoadBlockageArgs = {
  regionId: Scalars['ID']['input']
  roadBlockageId: Scalars['ID']['input']
}

export type MutationDeleteCustomRoadBlockageActivationArgs = {
  regionId: Scalars['ID']['input']
  roadBlockageActivationID: Scalars['ID']['input']
}

export type MutationDeleteCustomTurnRestrictionArgs = {
  regionId: Scalars['ID']['input']
  turnRestrictionId: Scalars['ID']['input']
}

export type MutationDeleteCustomTurnRestrictionActivationArgs = {
  regionId: Scalars['ID']['input']
  turnRestrictionActivationId: Scalars['ID']['input']
}

export type MutationDeleteDefaultPriceConfigArgs = {
  input: DeleteDefaultPriceConfigInput
}

export type MutationDeleteDemoRouteArgs = {
  id: Scalars['ID']['input']
}

export type MutationDeleteKeepOutZoneArgs = {
  keepOutZoneId: Scalars['ID']['input']
  regionId: Scalars['ID']['input']
}

export type MutationDeleteKeepOutZoneActivationArgs = {
  keepOutZoneActivationId: Scalars['ID']['input']
  regionId: Scalars['ID']['input']
}

export type MutationDeleteLineArgs = {
  lineId: Scalars['String']['input']
  serviceAreaId: Scalars['String']['input']
}

export type MutationDeleteOverwatchFleetArgs = {
  id: Scalars['ID']['input']
}

export type MutationDeleteOverwatchVehicleArgs = {
  vin: Scalars['String']['input']
}

export type MutationDeleteRoadBlockageArgs = {
  roadBlockageId: Scalars['ID']['input']
  serviceAreaId: Scalars['ID']['input']
}

export type MutationDeleteSafetyDriverAnnotationArgs = {
  ids: Array<Scalars['ID']['input']>
}

export type MutationDeleteSavedTripArgs = {
  id: Scalars['String']['input']
}

export type MutationDeleteScheduleVehicleStateChangeArgs = {
  input: ScheduledVehicleStateChangeDeleteInput
}

export type MutationDeleteServiceBreakArgs = {
  vehicleId: Scalars['ID']['input']
}

export type MutationDeleteStopArgs = {
  serviceAreaId: Scalars['String']['input']
  stopId: Scalars['String']['input']
}

export type MutationDeleteTripGeneratorTemplateArgs = {
  cascadeSubscriptions: Scalars['Boolean']['input']
  id: Scalars['ID']['input']
}

export type MutationDeleteTurnRestrictionArgs = {
  serviceAreaId: Scalars['ID']['input']
  turnRestrictionId: Scalars['ID']['input']
}

export type MutationDeleteVehicleArgs = {
  id: Scalars['ID']['input']
}

export type MutationDeleteVehicleDataOverridesArgs = {
  entries: Array<VehicleDataOverrideDeleteEntry>
}

export type MutationDeleteVehicleListArgs = {
  id: Scalars['ID']['input']
}

export type MutationDeleteWorkOrderArgs = {
  input: DeleteWorkOrderInput
}

export type MutationDialOutFromChimeMeetingArgs = {
  phoneNumber: Scalars['String']['input']
  vehicleId: Scalars['ID']['input']
}

export type MutationDisableCustomerArgs = {
  input: DisableCustomerInput
}

export type MutationDisapproveCustomPriceConfigArgs = {
  input: DisapproveCustomPriceConfigInput
}

export type MutationDisapproveDefaultPriceConfigArgs = {
  input: DisapproveDefaultPriceConfigInput
}

export type MutationDsBossCreateOrUpdateScenarioArgs = {
  input: DsBossCreateOrUpdate
}

export type MutationDsBossDeleteScenarioArgs = {
  input: DsBossDelete
}

export type MutationDsBossSaveFinalOutputToDatasetArgs = {
  input: DsBossUpdateBasedOnScenarioId
}

export type MutationEditCurrentStateChangeArgs = {
  input: EditCurrentStateChangeInput
}

export type MutationEditVehicleInFleetArgs = {
  input: EditVehicleInFleetInput
}

export type MutationEmployeeAuthDataChangeValueArgs = {
  input: EmployeeAuthDataChangeValueInput
}

export type MutationEmployeeAuthDataResendCodeArgs = {
  input: EmployeeAuthDataResendCodeInput
}

export type MutationEmployeeAuthDataVerifyCodeArgs = {
  input: EmployeeAuthDataVerifyCodeInput
}

export type MutationEmployeeBlockArgs = {
  input: EmployeeBlockInput
}

export type MutationEmployeeCreateNoteArgs = {
  input: EmployeeCreateNoteInput
}

export type MutationEmployeeCreateNotesArgs = {
  input: EmployeeCreateNotesInput
}

export type MutationEmployeeCreateScheduledBlockArgs = {
  input: EmployeeCreateScheduledBlockInput
}

export type MutationEmployeeDeleteMessagesArgs = {
  input: EmployeeDeleteMessagesInput
}

export type MutationEmployeeDeleteNotesArgs = {
  input: EmployeeDeleteNotesInput
}

export type MutationEmployeeDeleteProfileArgs = {
  input: EmployeeDeleteProfileInput
}

export type MutationEmployeeDeleteScheduledBlockArgs = {
  input: EmployeeDeleteScheduledBlockInput
}

export type MutationEmployeeNoteCreateFileGetUrlArgs = {
  input: EmployeeNoteCreateFileGetUrlInput
}

export type MutationEmployeeNoteCreatePreSignedUrlArgs = {
  input: EmployeeNoteFilePreSignedUrlInput
}

export type MutationEmployeeNotificationTestInjectionArgs = {
  notificationBody: Scalars['String']['input']
}

export type MutationEmployeePushTokenAddArgs = {
  preferredLanguage?: InputMaybe<Scalars['String']['input']>
  pushToken: Scalars['String']['input']
}

export type MutationEmployeePushTokenDeleteArgs = {
  pushToken: Scalars['String']['input']
}

export type MutationEmployeeResendEmailVerificationArgs = {
  input: EmployeeResendEmailVerificationInput
}

export type MutationEmployeeResetPasswordArgs = {
  input: EmployeeResetPasswordInput
}

export type MutationEmployeeSendMessagesArgs = {
  input: EmployeeSendMessagesInput
}

export type MutationEmployeeSetEmergencyContactArgs = {
  input: EmployeeSetEmergencyContactInput
}

export type MutationEmployeeUnblockArgs = {
  input: EmployeeUnblockInput
}

export type MutationEmployeeUpdateNoteArgs = {
  input: EmployeeUpdateNoteInput
}

export type MutationEmployeeUpdateProfileDataArgs = {
  input: EmployeeUpdateProfileDataInput
}

export type MutationEmployeeUpdateScheduledBlockArgs = {
  input: EmployeeUpdateScheduledBlockInput
}

export type MutationEmployeesSetFleetsArgs = {
  inputs: Array<EmployeesSetFleetsInput>
}

export type MutationEnableCustomerArgs = {
  input: EnableCustomerInput
}

export type MutationFccBroadcastFleetShutdownMessageArgs = {
  input: FccBroadcastMessageInput
}

export type MutationFccCancelUpcomingTripArgs = {
  input: FccCancelUpcomingTripInput
}

export type MutationFccConfirmCabinSafetyArgs = {
  input: FccConfirmCabinSafetyInput
}

export type MutationFccDeclineIncomingCallArgs = {
  input: FccDeclineIncomingCallInput
}

export type MutationFccInitiateOperatorToCabinCallArgs = {
  input: FccInitiateOperatorToCabinCallInput
}

export type MutationFccInitiateOperatorToSafetyDriverCallArgs = {
  input: FccInitiateOperatorToSafetyDriverCallInput
}

export type MutationFccJoinCabinToOperatorCallArgs = {
  input: FccJoinCabinToOperatorCallInput
}

export type MutationFccJoinSafetyDriverCallArgs = {
  input: FccJoinSafetyDriverCallInput
}

export type MutationFccManageServiceArgs = {
  input: FccManageServiceInput
}

export type MutationFccProvideTripCancellationReasonArgs = {
  input: FccProvideTripCancellationReasonInput
}

export type MutationFccRequestCabinVideoStreamCredentialsArgs = {
  input: RequestCabinVideoStreamCredentials
}

export type MutationFccRequestDoorActuationArgs = {
  input: FccRequestDoorActuationInput
}

export type MutationFccRequestFleetShutdownArgs = {
  input: FccFleetShutdownRequestInput
}

export type MutationFccRequestHubReturnArgs = {
  input: FccHubReturnRequestInput
}

export type MutationFccRequestServiceCancellationArgs = {
  input: FccServiceCancellationRequestInput
}

export type MutationFccSendDoorRequestArgs = {
  input: FccSendDoorRequestInput
}

export type MutationFccSetAvailabilityArgs = {
  input: FccSetAvailabilityInput
}

export type MutationFccStartHandlingVehicleArgs = {
  isTakeOver?: InputMaybe<Scalars['Boolean']['input']>
  role?: InputMaybe<FccOperatorRoleType>
  vehicleId: Scalars['ID']['input']
}

export type MutationFccStopHandlingVehicleArgs = {
  role?: InputMaybe<FccOperatorRoleType>
  vehicleId: Scalars['ID']['input']
}

export type MutationFccTriggerEmergencyStopArgs = {
  input: FccTriggerEmergencyStopInput
}

export type MutationFccUpdateAdPoolingStatusArgs = {
  input: FccUpdateAdPoolingStatusInput
}

export type MutationFeeRefundByTripIdArgs = {
  id: Scalars['ID']['input']
}

export type MutationFlashVehicleArgs = {
  vehicleID: Scalars['ID']['input']
}

export type MutationFleetAssignVehiclesArgs = {
  input: FleetAssignVehiclesInput
}

export type MutationFleetCreateArgs = {
  input: FleetCreateInput
}

export type MutationFleetDeleteArgs = {
  id: Scalars['ID']['input']
}

export type MutationFleetPlannerAddEntryToVehicleArgs = {
  input: AddVehicleToFleetInput
}

export type MutationFleetPlannerDeleteCampaignAssignementArgs = {
  campaignId: Scalars['ID']['input']
}

export type MutationFleetPlannerDeleteVehicleStatusArgs = {
  input: FleetPlannerDeleteVehicleStatusInput
}

export type MutationFleetPlannerEditVehicleStatusArgs = {
  input: FleetPlannerEditVehicleStatusInput
}

export type MutationFleetPlannerSaveCampaignAssignementArgs = {
  input: SaveFleetCampaignDetailInput
}

export type MutationFleetUpdateArgs = {
  input: FleetUpdateInput
}

export type MutationGenerateRouteForRequirementsArgs = {
  boundingBox?: InputMaybe<GeoBoundingBoxInput>
  routeRequirements: Array<RouteRequirementInput>
}

export type MutationGenerateStopNetworkArgs = {
  input: StopNetworkGenerationInput
  serviceAreaId: Scalars['String']['input']
}

export type MutationInsertHubCheckedInLogRecordArgs = {
  input: HubLogRecordInput
}

export type MutationInsertHubCheckedOutLogRecordArgs = {
  input: HubLogRecordInput
}

export type MutationInvalidateCustomRoadBlockageReportArgs = {
  regionId: Scalars['ID']['input']
  roadBlockageId: Scalars['ID']['input']
}

export type MutationInvalidateRoadBlockageReportArgs = {
  roadBlockageId: Scalars['ID']['input']
  serviceAreaId: Scalars['ID']['input']
}

export type MutationJoinVehicleChimeMeetingArgs = {
  vehicleId: Scalars['ID']['input']
}

export type MutationMainInspectionUploadProcessDocumentArgs = {
  input: MainInspectionUploadProcessDocumentInput
}

export type MutationManuallyCheckInPassengerArgs = {
  input: ManuallyCheckInPassengerInput
}

export type MutationManuallyNoShowPassengerArgs = {
  input: ManuallyNoShowPassengerInput
}

export type MutationMarkEmployeeMessageAsAcknowledgedArgs = {
  employeeId: Scalars['ID']['input']
  messageId: Scalars['ID']['input']
}

export type MutationMarkEmployeeMessageAsReadArgs = {
  employeeId: Scalars['ID']['input']
  messageId: Scalars['ID']['input']
}

export type MutationMileageBasedInspectionUploadProcessDocumentArgs = {
  input: MileageBasedInspectionUploadProcessDocumentInput
}

export type MutationMinervaReactionArgs = {
  input: MinervaReactionInput
}

export type MutationOpenVehicleByEmployeeArgs = {
  input: OpenVehicleEmployeeInput
}

export type MutationOpenVehicleForBackofficeUserArgs = {
  input: OpenVehicleBackofficeSelfUserInput
}

export type MutationOpenVehicleForEmployeeArgs = {
  input: OpenVehicleBackofficeInput
}

export type MutationOpenVehicleForEmployeeInEmergencyArgs = {
  input: OpenVehicleBackofficeInput
}

export type MutationOpsCareDeviceTokenAddArgs = {
  input: OpsCareDeviceTokenAddInput
}

export type MutationOpsCareDeviceTokenDeleteArgs = {
  input: OpsCareDeviceTokenDeleteInput
}

export type MutationOpsCareSettingsUpdateArgs = {
  input: OpsCareSettingsUpdateInput
}

export type MutationProlongTemporaryBackofficeSessionArgs = {
  input: ProlongTemporaryBackofficeSessionInput
}

export type MutationPromptGeniusArgs = {
  input: GraphQlGeniusWriteOperationInput
}

export type MutationPublishSdsGuidanceDecisionArgs = {
  input: PublishSdsGuidanceDecisionInput
}

export type MutationRefreshVehicleTelematicsArgs = {
  vehicleID: Scalars['ID']['input']
}

export type MutationRefundByTripIdArgs = {
  id: Scalars['ID']['input']
}

export type MutationRemoveAllowlistedPhoneNumberArgs = {
  input: RemoveAllowlistedPhoneNumberInput
}

export type MutationRemoveRoadBlockageActivationArgs = {
  roadBlockageActivationID: Scalars['ID']['input']
  serviceAreaId: Scalars['ID']['input']
}

export type MutationRemoveTripFeedbackArgs = {
  feedbackId: Scalars['String']['input']
}

export type MutationRemoveTripRiderArgs = {
  riderId: Scalars['String']['input']
}

export type MutationRemoveTripSegmentArgs = {
  segmentId: Scalars['String']['input']
  tripId: Scalars['String']['input']
}

export type MutationRemoveTurnRestrictionActivationArgs = {
  serviceAreaId: Scalars['ID']['input']
  turnRestrictionActivationId: Scalars['ID']['input']
}

export type MutationReplyToOfferArgs = {
  offeredTripId: Scalars['String']['input']
  reason?: InputMaybe<OfferRejectionReason>
  reject: Scalars['Boolean']['input']
}

export type MutationRequestVehicleMediaStreamCredentialsArgs = {
  input: RequestVehicleMediaStreamCredentialsInput
}

export type MutationResetOfferAndPoolingConfigArgs = {
  serviceAreaUuid: Scalars['UUID']['input']
  serviceClassId: Scalars['ID']['input']
}

export type MutationRioDeleteReportArgs = {
  input: RioDeleteReportInput
}

export type MutationRioSetReportStatusArgs = {
  input: RioSetReportStatusInput
}

export type MutationRioShareReportArgs = {
  input: RioShareReportInput
}

export type MutationRioStoreListViewConfigArgs = {
  input: RioStoreListViewConfigInput
}

export type MutationRioStoreReportArgs = {
  input: RioStoreReportInput
}

export type MutationRioStoreTemplateArgs = {
  input: RioStoreTemplateInput
}

export type MutationScheduleVehicleStateChangeArgs = {
  input: ScheduleVehicleStateChangeInput
}

export type MutationSdgAcceptIncomingCallArgs = {
  input: SdgAcceptIncomingCallInput
}

export type MutationSdgDeclineIncomingCallArgs = {
  input: SdgDeclineIncomingCallInput
}

export type MutationSdgInitiateSafetyDriverToOperatorCallArgs = {
  input: SdgInitiateSafetyDriverToOperatorCallInput
}

export type MutationServiceBreakLocationChangeStateArgs = {
  input: ServiceBreakLocationChangeStateInput
}

export type MutationServiceBreakLocationDeleteArgs = {
  input: ServiceBreakLocationDeleteInput
}

export type MutationServiceBreakLocationDeleteCapacityOverrideArgs = {
  input: ServiceBreakLocationDeleteCapacityOverrideInput
}

export type MutationServiceBreakLocationStoreBaseDataArgs = {
  input: ServiceBreakLocationStoreBaseDataInput
}

export type MutationServiceBreakLocationStoreCapacityOverrideArgs = {
  input: ServiceBreakLocationStoreCapacityOverrideInput
}

export type MutationServiceBreakLocationStoreCapacityScheduleArgs = {
  input: ServiceBreakLocationStoreCapacityScheduleInput
}

export type MutationServiceBreakLocationUpdateRoutableLocationAndPolygonArgs = {
  input: ServiceBreakLocationUpdateRoutableLocationAndPolygonInput
}

export type MutationServiceIntervalCreateArgs = {
  input: ServiceIntervalCreateInput
}

export type MutationSetSavedTripArchivedArgs = {
  id: Scalars['String']['input']
  isArchived: Scalars['Boolean']['input']
}

export type MutationSetShiftCommentArgs = {
  input: ShiftCommentInput
}

export type MutationSetShiftEmployeeStatusArgs = {
  input: ShiftEmployeeStatusInput
}

export type MutationSetTaskNotificationPendingArgs = {
  id: Scalars['ID']['input']
  until?: InputMaybe<Scalars['DateTime']['input']>
  version?: InputMaybe<Scalars['Int']['input']>
}

export type MutationSetTripAnnotationAnsweredArgs = {
  annotationId: Scalars['String']['input']
  answered: Scalars['Boolean']['input']
}

export type MutationSetTripAnnotationResolvedArgs = {
  annotationId: Scalars['String']['input']
  evidenceRef: Scalars['String']['input']
  evidenceType: Scalars['String']['input']
  note?: InputMaybe<Scalars['String']['input']>
}

export type MutationSetVehiclesInListArgs = {
  listID: Scalars['ID']['input']
  vehicleIDs: Array<Scalars['ID']['input']>
}

export type MutationShiftCapacityPlanningCreateArgs = {
  input: ShiftCapacityPlanningCreateInput
}

export type MutationShiftCapacityPlanningDeleteArgs = {
  ids: Array<Scalars['ID']['input']>
}

export type MutationShiftCapacityPlanningUpdateStatusArgs = {
  input: ShiftCapacityPlanningUpdateStatusInput
}

export type MutationShiftConfirmTaskNotificationArgs = {
  input: ShiftConfirmTaskNotificationInput
}

export type MutationShiftDeletePlannedHubReturnSectionArgs = {
  input: ShiftDeletePlannedHubReturnSectionInput
}

export type MutationShiftOverrideScheduledHubReturnArgs = {
  input: ShiftOverrideScheduledHubReturnInput
}

export type MutationShiftOverrideTypeArgs = {
  input: ShiftOverrideTypeInput
}

export type MutationShiftSetPlannedHubReturnSectionArgs = {
  input: ShiftSetPlannedHubReturnSectionInput
}

export type MutationSimulateCabinReadyCheckRequestedEventArgs = {
  input: SimulateEventInput
}

export type MutationSimulateCloseDoorRequestedEventArgs = {
  input: SimulateEventInput
}

export type MutationSimulateRemoteDoorActuationResponseEventArgs = {
  input: SimulateDoorActuationResponseInput
}

export type MutationSimulateWaypointAttendanceArgs = {
  input: SimulateWaypointAttendanceInput
}

export type MutationStopPendingDeletionArgs = {
  input: StopPendingDeletionInput
}

export type MutationSubscribeTripGeneratorTemplateArgs = {
  fleetId: Scalars['String']['input']
  templateId: Scalars['ID']['input']
  vin: Scalars['String']['input']
}

export type MutationSynthesizeDisengagementVoicebotSpeechArgs = {
  text: Scalars['String']['input']
}

export type MutationTakeDisengagementVoicebotTurnArgs = {
  driverText: Scalars['String']['input']
  sessionId: Scalars['UUID']['input']
}

export type MutationTrackBackofficeMetricArgs = {
  input: BackofficeMetricInput
}

export type MutationTransitionMainInspectionProcessToNextStateArgs = {
  input: MainInspectionProcessTransitionRequest
}

export type MutationTransitionMileageBasedInspectionProcessToNextStateArgs = {
  input: MileageBasedInspectionProcessTransitionRequest
}

export type MutationTransitionVicProcessToNextStateArgs = {
  input: VicProcessTransitionRequest
}

export type MutationTriggerArrivalEventArgs = {
  hubID: Scalars['ID']['input']
  vehicleID: Scalars['ID']['input']
}

export type MutationTriggerDepartureEventArgs = {
  vehicleID: Scalars['ID']['input']
}

export type MutationTriggerManualArrivalForAdVehicleArgs = {
  input: TriggerManualArrivalForAdVehicleInput
}

export type MutationTriggerSimulatedVehicleEventArgs = {
  eventType: SimulatedVehicleEventType
  vehicleID: Scalars['ID']['input']
}

export type MutationTriggerTaskNotificationArgs = {
  input: TriggerTaskNotificationInput
}

export type MutationUnarchiveVehicleArgs = {
  input: UnarchiveVehicleInput
}

export type MutationUnassignCdisBoxFromVehicleArgs = {
  input: UnassignCdisBoxFromVehicleInput
}

export type MutationUnassignTabletFromVehicleArgs = {
  input: UnassignTabletFromVehicleInput
}

export type MutationUnclaimVehicleArgs = {
  customerId: Scalars['ID']['input']
}

export type MutationUnsubscribeTripGeneratorTemplateArgs = {
  templateId: Scalars['ID']['input']
  vin: Scalars['String']['input']
}

export type MutationUpdateActionArgs = {
  actionID: Scalars['ID']['input']
  input: ActionInput
  serviceAreaID: Scalars['ID']['input']
}

export type MutationUpdateActiveInAppMessageArgs = {
  customerTenant: Scalars['String']['input']
  input: InAppMessageUpdateInput
}

export type MutationUpdateAreaArgs = {
  areaId: Scalars['String']['input']
  input: AreaInput
  serviceAreaId: Scalars['String']['input']
}

export type MutationUpdateAreaCapacityArgs = {
  areaId: Scalars['String']['input']
  input?: InputMaybe<AreaCapacityConfigurationInput>
  serviceAreaId: Scalars['String']['input']
}

export type MutationUpdateCustomPriceConfigArgs = {
  input: UpdateCustomPriceConfigInput
}

export type MutationUpdateCustomRoadBlockageArgs = {
  regionId: Scalars['ID']['input']
  roadBlockageId: Scalars['ID']['input']
  roadBlockageInput: RoadBlockageInput
}

export type MutationUpdateCustomRoadBlockageActivationArgs = {
  input: RoadBlockageActivationInput
  regionId: Scalars['ID']['input']
  roadBlockageActivationID: Scalars['ID']['input']
}

export type MutationUpdateCustomTurnRestrictionArgs = {
  regionId: Scalars['ID']['input']
  turnRestrictionId: Scalars['ID']['input']
  turnRestrictionInput: TurnRestrictionInput
}

export type MutationUpdateCustomTurnRestrictionActivationArgs = {
  input: TurnRestrictionActivationInput
  regionId: Scalars['ID']['input']
  turnRestrictionActivationId: Scalars['ID']['input']
}

export type MutationUpdateCustomerArgs = {
  input: UpdateCustomerInput
}

export type MutationUpdateDeactivationAlertArgs = {
  id: Scalars['ID']['input']
  resolved: Scalars['Boolean']['input']
  serviceAreaId: Scalars['ID']['input']
}

export type MutationUpdateDefaultPriceConfigArgs = {
  input: UpdateDefaultPriceConfigInput
}

export type MutationUpdateDemoRouteArgs = {
  input: UpdateDemoRouteInput
}

export type MutationUpdateEmployeePictureArgs = {
  input: UpdateEmployeeProfilePictureInput
}

export type MutationUpdateHeatmapConfigArgs = {
  input: HeatmapConfigInput
  serviceAreaId: Scalars['ID']['input']
}

export type MutationUpdateHubArgs = {
  id: Scalars['ID']['input']
  input: HubDataInput
}

export type MutationUpdateKeepOutZoneArgs = {
  input: KeepOutZoneInput
  keepOutZoneId: Scalars['ID']['input']
  regionId: Scalars['ID']['input']
}

export type MutationUpdateKeepOutZoneActivationArgs = {
  input: KeepOutZoneActivationInput
  keepOutZoneActivationId: Scalars['ID']['input']
  regionId: Scalars['ID']['input']
}

export type MutationUpdateLineArgs = {
  input: LineUpdateInput
  lineId: Scalars['String']['input']
  serviceAreaId: Scalars['String']['input']
}

export type MutationUpdateLineServiceConfigArgs = {
  input: LineServiceConfigInput
  serviceAreaId: Scalars['ID']['input']
}

export type MutationUpdateMainInspectionProcessDataArgs = {
  input?: InputMaybe<UpdateMainInspectionProcessDataRequest>
}

export type MutationUpdateMileageBasedInspectionProcessDataArgs = {
  input?: InputMaybe<UpdateMileageBasedInspectionProcessDataRequest>
}

export type MutationUpdateOfferAndPoolingConfigArgs = {
  input: UpdateOfferAndPoolingConfigInput
  serviceAreaUuid: Scalars['UUID']['input']
  serviceClassId: Scalars['ID']['input']
}

export type MutationUpdateOverwatchVehicleArgs = {
  input: UpdateOverwatchVehicleInput
  vin: Scalars['String']['input']
}

export type MutationUpdateRoadBlockageArgs = {
  roadBlockageId: Scalars['ID']['input']
  roadBlockageInput: RoadBlockageInput
  serviceAreaId: Scalars['ID']['input']
}

export type MutationUpdateRoadBlockageActivationArgs = {
  input: RoadBlockageActivationInput
  roadBlockageActivationID: Scalars['ID']['input']
}

export type MutationUpdateSafetyDriverAnnotationArgs = {
  annotation: AnnotationInput
  id: Scalars['ID']['input']
}

export type MutationUpdateSafetyDriverForcePudoArgs = {
  reason: SafetyDriverForcePudoReason
  segmentId: Scalars['String']['input']
  source: Platform
  tripId: Scalars['String']['input']
  vin: Scalars['String']['input']
}

export type MutationUpdateSafetyDriverTripConfirmationStateArgs = {
  state: SafetyDriverTripConfirmationState
  tripId: Scalars['String']['input']
  vin: Scalars['String']['input']
}

export type MutationUpdateSavedTripArgs = {
  allWaypointsMode?: InputMaybe<Scalars['Boolean']['input']>
  assignedVtrs?: InputMaybe<Array<AssignedVtrInput>>
  associatedVtr?: InputMaybe<Scalars['String']['input']>
  codebeamerId?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  id: Scalars['String']['input']
  metadata?: InputMaybe<Array<Array<Scalars['String']['input']>>>
  name: Scalars['String']['input']
  segments: Array<TripSegmentInput>
  tripId?: InputMaybe<Scalars['String']['input']>
  type: TripType
}

export type MutationUpdateServiceAreaArgs = {
  input: ServiceAreaUpdateInput
  serviceAreaId: Scalars['String']['input']
}

export type MutationUpdateSimulatedAdVehicleArgs = {
  input: UpdateSimulatedAdVehicleInput
}

export type MutationUpdateSimulatedVehicleArgs = {
  input: UpdateSimulatedVehicleInput
}

export type MutationUpdateStopArgs = {
  input: StopInput
  serviceAreaId: Scalars['String']['input']
  stopId: Scalars['String']['input']
}

export type MutationUpdateStopFlagConfigArgs = {
  input: StopFlagConfigurationInput
  serviceAreaId: Scalars['ID']['input']
}

export type MutationUpdateStopValidatorConfigArgs = {
  inputDto: StopValidatorConfigInput
  serviceAreaId: Scalars['ID']['input']
}

export type MutationUpdateTaskNotificationNoteArgs = {
  id: Scalars['ID']['input']
  note?: InputMaybe<Scalars['String']['input']>
  version?: InputMaybe<Scalars['Int']['input']>
}

export type MutationUpdateTaskNotificationStatusArgs = {
  id: Scalars['ID']['input']
  status: TaskNotificationStatus
  version?: InputMaybe<Scalars['Int']['input']>
}

export type MutationUpdateTaskNotificationVehicleIdArgs = {
  id: Scalars['ID']['input']
  vehicleId: Scalars['ID']['input']
  version?: InputMaybe<Scalars['Int']['input']>
}

export type MutationUpdateTripArgs = {
  metadata?: InputMaybe<Array<Array<Scalars['String']['input']>>>
  segments: Array<TripSegmentInput>
  tripId: Scalars['String']['input']
}

export type MutationUpdateTripDetailsArgs = {
  integrationId?: InputMaybe<Scalars['String']['input']>
  tripId: Scalars['String']['input']
}

export type MutationUpdateTripFeedbackArgs = {
  feedback: TripFeedbackInput
  id: Scalars['String']['input']
}

export type MutationUpdateTripGeneratorTemplateArgs = {
  input: TripGeneratorUpdateTemplateInput
}

export type MutationUpdateTripRiderArgs = {
  id: Scalars['String']['input']
  rider: TripRiderInput
}

export type MutationUpdateTripSegmentArgs = {
  segment: TripSegmentInput
  tripId: Scalars['String']['input']
}

export type MutationUpdateTurnRestrictionArgs = {
  serviceAreaId: Scalars['ID']['input']
  turnRestrictionId: Scalars['ID']['input']
  turnRestrictionInput: TurnRestrictionInput
}

export type MutationUpdateTurnRestrictionActivationArgs = {
  input: TurnRestrictionActivationInput
  turnRestrictionActivationId: Scalars['ID']['input']
}

export type MutationUpdateVicProcessDataArgs = {
  input: UpdateVicProcessDataRequest
}

export type MutationUpdateVehicleArgs = {
  input: UpdateVehicleInput
}

export type MutationUpdateVehicleDataOverridesArgs = {
  entries: Array<VehicleDataOverrideEntry>
}

export type MutationUpdateVehicleListArgs = {
  id: Scalars['ID']['input']
  input: VehicleListInput
}

export type MutationUpdateVehiclePrioritizationArgs = {
  input: VehiclePrioritizationInput
}

export type MutationUpdateVehicleRebalancingArgs = {
  id: Scalars['ID']['input']
  input: UpdateVehicleRebalancingInput
}

export type MutationUpdateWorkOrderArgs = {
  input: UpdateWorkOrderInput
}

export type MutationUpdateWorkOrdersArgs = {
  input: UpdateWorkOrdersInput
}

export type MutationValidateRouteInternalArgs = {
  fleetId?: InputMaybe<Scalars['String']['input']>
  mapId?: InputMaybe<Scalars['Int']['input']>
  segments: Array<TripSegmentInput>
  useFleetOsRoute?: InputMaybe<Scalars['Boolean']['input']>
  useStopResolver?: InputMaybe<Scalars['Boolean']['input']>
  validateLocations?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationValidateRouteSdsArgs = {
  fleetId: Scalars['String']['input']
  route: Array<TripGeolocationInput>
}

export type MutationValidateTripArgs = {
  segments: Array<TripSegmentInput>
  useStopResolver?: InputMaybe<Scalars['Boolean']['input']>
  vin: Scalars['String']['input']
}

export type MutationVehicleAttributesUpdateArgs = {
  input: VehicleAttributesUpdateInput
}

export type MutationVehicleCapacityConfigAssignVehiclesArgs = {
  input: VehicleCapacityConfigAssignVehiclesInput
}

export type MutationVehicleCapacityConfigCreateArgs = {
  input: VehicleCapacityConfigCreateInput
}

export type MutationVehicleCapacityConfigDeleteArgs = {
  id: Scalars['ID']['input']
}

export type MutationVehicleCapacityConfigSetVehicleOverridesArgs = {
  input: CapacityConfigVehicleOverridesInput
}

export type MutationVehicleCapacityConfigUpdateArgs = {
  input: VehicleCapacityConfigUpdateInput
}

export type MutationVehicleCreateArgs = {
  input: VehicleCreateInput
}

export type MutationVehicleMatchSafetyDriverArgs = {
  input: VehicleMatchSafetyDriverInput
}

export type MutationVehiclePlanActivitiesSaveArgs = {
  input: Array<VehiclePlanActivityInput>
}

export type MutationVehiclePlanActivityDeleteArgs = {
  input: VehiclePlanActivityDeleteInput
}

export type MutationVehiclePlanActivityMoveArgs = {
  input: VehiclePlanActivityMoveInput
}

export type MutationVehiclePlanTemplateApplyArgs = {
  input: VehiclePlanTemplateApplyInput
  operatorTenant: Scalars['ID']['input']
}

export type MutationVehiclePlanTemplateDeleteArgs = {
  operatorTenant: Scalars['ID']['input']
  templateId: Scalars['ID']['input']
}

export type MutationVehiclePlanTemplateSaveArgs = {
  input: VehiclePlanTemplateSaveInput
  operatorTenant: Scalars['ID']['input']
}

export type MutationVehicleUnmatchSafetyDriverArgs = {
  input: VehicleUnmatchSafetyDriverInput
}

export type MutationWipeBoxPcArgs = {
  input: WipeBoxPcInput
}

export type MutationWorkOrderAutomationRuleCreateArgs = {
  input: WorkOrderAutomationRuleCreateInput
}

export type MutationWorkOrderAutomationRuleDeleteArgs = {
  input: WorkOrderAutomationRuleDeleteInput
}

export type MutationWorkOrderAutomationRuleStatusUpdateArgs = {
  input: WorkOrderAutomationRuleStatusUpdateInput
}

export type NamedLocation = {
  __typename?: 'NamedLocation'
  location: Maybe<TripHistoryEntryLocation>
  primaryAddress: Maybe<Scalars['String']['output']>
  primaryPoiName: Maybe<Scalars['String']['output']>
  secondaryAddress: Maybe<Scalars['String']['output']>
  secondaryPoiName: Maybe<Scalars['String']['output']>
}

export type NavigationStop = {
  __typename?: 'NavigationStop'
  active: Scalars['Boolean']['output']
  bearing: Scalars['Int']['output']
  id: Scalars['String']['output']
  routingLocation: Location
}

export type NearestVehicleType = {
  __typename?: 'NearestVehicleType'
  distanceMeters: Scalars['Float']['output']
  vehicleStatus: Maybe<VehicleStatusDetail>
}

export enum NotInServiceReason {
  Disconnected = 'DISCONNECTED',
  Inactive = 'INACTIVE',
  NoRecentValidLocation = 'NO_RECENT_VALID_LOCATION',
  OutdatedHubReturn = 'OUTDATED_HUB_RETURN',
  PoolingDisabled = 'POOLING_DISABLED',
  ServiceIntervalCancelled = 'SERVICE_INTERVAL_CANCELLED',
  Unresponsive = 'UNRESPONSIVE',
}

export type OddElement = {
  __typename?: 'ODDElement'
  elementType: OddElementType
  location: Maybe<Geolocation>
  taxonomy: Scalars['String']['output']
}

export enum OddElementType {
  OddElementTypeBusStop = 'ODD_ELEMENT_TYPE_BUS_STOP',
  OddElementTypeInvalid = 'ODD_ELEMENT_TYPE_INVALID',
  OddElementTypeNoEntry = 'ODD_ELEMENT_TYPE_NO_ENTRY',
  OddElementTypeNoTurnOnRed = 'ODD_ELEMENT_TYPE_NO_TURN_ON_RED',
  OddElementTypeOneWay = 'ODD_ELEMENT_TYPE_ONE_WAY',
  OddElementTypePedestrianCrossing = 'ODD_ELEMENT_TYPE_PEDESTRIAN_CROSSING',
  OddElementTypeRailroadCrossing = 'ODD_ELEMENT_TYPE_RAILROAD_CROSSING',
  OddElementTypeRightOnRed = 'ODD_ELEMENT_TYPE_RIGHT_ON_RED',
  OddElementTypeRoundabout = 'ODD_ELEMENT_TYPE_ROUNDABOUT',
  OddElementTypeSchoolZone = 'ODD_ELEMENT_TYPE_SCHOOL_ZONE',
  OddElementTypeStopSign = 'ODD_ELEMENT_TYPE_STOP_SIGN',
  OddElementTypeTrafficLight = 'ODD_ELEMENT_TYPE_TRAFFIC_LIGHT',
  OddElementTypeUTurn = 'ODD_ELEMENT_TYPE_U_TURN',
  OddElementTypeYieldSign = 'ODD_ELEMENT_TYPE_YIELD_SIGN',
}

export type OddElementsPage = {
  __typename?: 'ODDElementsPage'
  elements: Array<OddElement>
  totalCount: Scalars['Int']['output']
}

export type Offer = {
  __typename?: 'Offer'
  offeredDeliveryTime: Maybe<Scalars['Instant']['output']>
  offeredPickupTime: Maybe<Scalars['Instant']['output']>
  price: Maybe<TripHistoryEntryPrice>
}

/** Fleet Optimization's offer and pooling configuration */
export type OfferAndPoolingConfig = {
  __typename?: 'OfferAndPoolingConfig'
  /**
   * Upper bound on the allowed detour
   * If the value is `null`, there is no limit in place.
   */
  detourLimitAbsoluteUpper: Maybe<Scalars['Duration']['output']>
  /**
   * Upper bound on the allowed detour (in percent)
   * If the value is `null`, there is no limit in place.
   */
  detourLimitRelativeUpper: Maybe<Scalars['Int']['output']>
  /** When this service class was last modified */
  modified: Scalars['DateTime']['output']
}

export enum OfferRejectionReason {
  OfferRejectionReasonInvalid = 'OFFER_REJECTION_REASON_INVALID',
}

export type OpenVehicleBackofficeInput = {
  isBatchInteraction: Scalars['Boolean']['input']
  reason: InteractionReason
  reasonFreeText?: InputMaybe<Scalars['String']['input']>
  /** The token of the selected employee */
  token: Scalars['String']['input']
  vehicleID: Scalars['ID']['input']
}

export type OpenVehicleBackofficeSelfUserInput = {
  isBatchInteraction: Scalars['Boolean']['input']
  reason: InteractionReason
  reasonFreeText?: InputMaybe<Scalars['String']['input']>
  vehicleID: Scalars['ID']['input']
}

export type OpenVehicleEmployeeInput = {
  /** To avoid accidentally opening vehicles somewhere else */
  location: LocationInput
  /** Only used for service staff or safety drivers */
  reason?: InputMaybe<InteractionReason>
  /** Only used for service staff */
  reasonFreeText?: InputMaybe<Scalars['String']['input']>
  token: Scalars['String']['input']
  vehicleID: Scalars['ID']['input']
}

export type OperatingArea = {
  __typename?: 'OperatingArea'
  /** Geometry as a GeoJSON MultiPolygon object. */
  geometry: Scalars['String']['output']
  /** Unique identifier for the operating area as UUIDv4. */
  id: Scalars['String']['output']
  /** Human readable name for display purposes. */
  name: Scalars['String']['output']
  /** Local resolver for the region this operating area belongs to. */
  region: Maybe<Region>
  /** The region ID this operating area belongs to. */
  regionId: Scalars['String']['output']
}

export type OpsCareDeviceTokenAddInput = {
  /** FCM registration token of the device. */
  deviceToken: Scalars['String']['input']
  /** Language the notification text should be rendered in, as an IETF language tag, e.g. `de-DE`. */
  userLanguage: Scalars['String']['input']
}

export type OpsCareDeviceTokenAddResponse = {
  __typename?: 'OpsCareDeviceTokenAddResponse'
  success: Scalars['Boolean']['output']
}

export type OpsCareDeviceTokenDeleteInput = {
  deviceToken: Scalars['String']['input']
}

export type OpsCareDeviceTokenDeleteResponse = {
  __typename?: 'OpsCareDeviceTokenDeleteResponse'
  success: Scalars['Boolean']['output']
}

export type OpsCareSettings = {
  __typename?: 'OpsCareSettings'
  /**
   * Whether the user had the in-field support right when their settings were last written. Derived
   * from the caller's rights, not settable by the client.
   */
  inFieldSupport: Scalars['Boolean']['output']
  pushNotificationEnabled: Scalars['Boolean']['output']
}

export type OpsCareSettingsResponse = {
  __typename?: 'OpsCareSettingsResponse'
  /** OpsCare settings of the calling user. Null for users that have no stored settings yet. */
  settings: Maybe<OpsCareSettings>
}

export type OpsCareSettingsUpdateInput = {
  /** Whether the user wants to receive push notifications on all of their devices. */
  pushNotificationEnabled: Scalars['Boolean']['input']
}

export type OpsCareSettingsUpdateResponse = {
  __typename?: 'OpsCareSettingsUpdateResponse'
  settings: OpsCareSettings
}

export type OverwatchFleet = {
  __typename?: 'OverwatchFleet'
  aliasId: Scalars['String']['output']
  description: Scalars['String']['output']
  geonetName: Scalars['String']['output']
  id: Scalars['ID']['output']
  integrationId: Scalars['String']['output']
  /** @deprecated Phantom fleets removed. Always returns false. */
  isPhantom: Scalars['Boolean']['output']
  metropolisId: Scalars['Int']['output']
  name: Scalars['String']['output']
  tenantId: Scalars['String']['output']
}

export type OverwatchTenant = {
  __typename?: 'OverwatchTenant'
  aliasId: Maybe<Scalars['String']['output']>
  certCn: Maybe<Scalars['String']['output']>
  description: Scalars['String']['output']
  id: Scalars['String']['output']
  name: Scalars['String']['output']
}

export type OverwatchVehicle = {
  __typename?: 'OverwatchVehicle'
  fleetId: Scalars['ID']['output']
  geonetName: Scalars['String']['output']
  inService: Scalars['Boolean']['output']
  name: Scalars['String']['output']
  platform: Scalars['String']['output']
  vin: Scalars['String']['output']
}

export type PageInfo = {
  __typename?: 'PageInfo'
  endCursor: Maybe<Scalars['String']['output']>
  hasNextPage: Scalars['Boolean']['output']
  hasPreviousPage: Scalars['Boolean']['output']
  startCursor: Maybe<Scalars['String']['output']>
}

export type PaginatedIncidentResponse = {
  __typename?: 'PaginatedIncidentResponse'
  incidents: Array<IncidentResponse>
  totalItems: Maybe<Scalars['Int']['output']>
}

export type PaginatedOddElements = {
  __typename?: 'PaginatedODDElements'
  elements: Array<OddElement>
  nextPageToken: Maybe<Scalars['String']['output']>
}

export type PaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
}

export type PairedVehicle = {
  __typename?: 'PairedVehicle'
  driverId: Scalars['String']['output']
  driverName: Maybe<Scalars['String']['output']>
  fleetId: Scalars['String']['output']
  fleetName: Scalars['String']['output']
  missionType: Scalars['String']['output']
  vehicleName: Scalars['String']['output']
  vehiclePlatform: Scalars['String']['output']
  vin: Scalars['String']['output']
  vtrTicket: Scalars['String']['output']
}

/** Current passenger authentication state for a trip on a vehicle. */
export enum PassengerAuthState {
  Cancelled = 'CANCELLED',
  Confirmed = 'CONFIRMED',
  InProgress = 'IN_PROGRESS',
  ManualNoShowRequested = 'MANUAL_NO_SHOW_REQUESTED',
  NoShowTriggered = 'NO_SHOW_TRIGGERED',
  Upcoming = 'UPCOMING',
}

/** Passenger authentication state with timing information for a trip on a vehicle. */
export type PassengerAuthenticationStateInfo = {
  __typename?: 'PassengerAuthenticationStateInfo'
  /**
   * The earliest time (ISO 8601) from which passenger authentication is allowed to start.
   * Present while the trip is in UPCOMING state.
   */
  authenticationStartAllowedFrom: Maybe<Scalars['String']['output']>
  /**
   * The planned date/time (ISO 8601) when the no-show will be evaluated.
   * Present while authentication is in progress (IN_PROGRESS state).
   */
  plannedNoShowDate: Maybe<Scalars['String']['output']>
  /** The current authentication state. */
  state: PassengerAuthState
}

export type PassengerAuthentificationFallbackRequestedNotification =
  TaskNotification & {
    __typename?: 'PassengerAuthentificationFallbackRequestedNotification'
    actionType: TaskActionType
    assigned: Maybe<TaskStateChangeDetails>
    createdAt: Scalars['DateTime']['output']
    fleetId: Maybe<Scalars['ID']['output']>
    foreignId: Scalars['ID']['output']
    id: Scalars['ID']['output']
    note: Maybe<TaskNotificationNote>
    notificationType: TaskNotificationType
    pended: Maybe<TaskStateChangeDetails>
    regionId: Maybe<Scalars['ID']['output']>
    resolved: Maybe<TaskStateChangeDetails>
    serviceAreaUUID: Scalars['ID']['output']
    severity: TaskNotificationSeverity
    stateChanges: Array<TaskStateChangeDetails>
    status: TaskNotificationStatus
    trip: Maybe<Trip>
    vehicle: Maybe<Vehicle>
    version: Scalars['Int']['output']
  }

export type PassengerUnbuckled = TaskNotification & {
  __typename?: 'PassengerUnbuckled'
  actionType: TaskActionType
  assigned: Maybe<TaskStateChangeDetails>
  createdAt: Scalars['DateTime']['output']
  fleetId: Maybe<Scalars['ID']['output']>
  foreignId: Scalars['ID']['output']
  id: Scalars['ID']['output']
  note: Maybe<TaskNotificationNote>
  notificationType: TaskNotificationType
  pended: Maybe<TaskStateChangeDetails>
  regionId: Maybe<Scalars['ID']['output']>
  resolved: Maybe<TaskStateChangeDetails>
  serviceAreaUUID: Scalars['ID']['output']
  severity: TaskNotificationSeverity
  stateChanges: Array<TaskStateChangeDetails>
  status: TaskNotificationStatus
  vehicle: Maybe<Vehicle>
  version: Scalars['Int']['output']
}

export type Passengers = {
  __typename?: 'Passengers'
  adults: Maybe<Scalars['Int']['output']>
  infants: Maybe<Scalars['Int']['output']>
}

export type PayPal = {
  __typename?: 'PayPal'
  email: Scalars['String']['output']
}

export type PaymentDetails = {
  __typename?: 'PaymentDetails'
  /** Cancellation fee details */
  fee: Maybe<Fee>
  /** Unique identifier shown on the invoice for a payment. Example: M-TI-X5NY7N */
  invoiceId: Maybe<Scalars['ID']['output']>
  isRefundable: Scalars['Boolean']['output']
  paymentErrors: Array<PaymentError>
  /** Unique identifier for the payment at MOIA (Shown on invoices and customer's bank statements). Example: 7JZVAMV7 */
  paymentId: Maybe<Scalars['ID']['output']>
  paymentMethod: Maybe<PaymentMethod>
  price: Price
  /** Unique identifier for the payment at the payment service provider (Adyen). Example: PD28T3XDPGXXGN82 */
  pspTransactionId: Maybe<Scalars['ID']['output']>
  refund: Maybe<Refund>
  /** The amount that was settled for this payment, i.e. that arrived in our account */
  settledAmount: Maybe<Money>
  /** Status of the payment, describing at what stage it is in its lifecycle. Examples: Authorized, Captured, Refunded, Settled */
  status: Scalars['String']['output']
}

export type PaymentError = {
  __typename?: 'PaymentError'
  /** The error code of the error */
  code: Maybe<Scalars['String']['output']>
  /** A general error message describing the error */
  message: Scalars['String']['output']
  /** The subsystem that is responsible for the error (E.g.: Adyen) */
  subSystem: Maybe<Scalars['String']['output']>
}

export type PaymentMethod = ApplePay | CreditCard | GooglePay | PayPal

export type PceHeatmapDataPoint = {
  __typename?: 'PceHeatmapDataPoint'
  annotationCount: Scalars['Int']['output']
  eventType: Scalars['String']['output']
  location: Maybe<Geolocation>
  mission: Scalars['String']['output']
  sessionId: Scalars['String']['output']
  softwareVersion: Scalars['String']['output']
  timestampMs: Scalars['Float']['output']
  vehicleId: Scalars['String']['output']
}

export enum Platform {
  PlatformAvPilot = 'PLATFORM_AV_PILOT',
  PlatformAvSds = 'PLATFORM_AV_SDS',
  PlatformAxp = 'PLATFORM_AXP',
  PlatformClient = 'PLATFORM_CLIENT',
  PlatformHmi = 'PLATFORM_HMI',
  PlatformInvalid = 'PLATFORM_INVALID',
  PlatformMobileAndroid = 'PLATFORM_MOBILE_ANDROID',
  PlatformMobileIos = 'PLATFORM_MOBILE_IOS',
  PlatformOwUi = 'PLATFORM_OW_UI',
  PlatformSafetyDriver = 'PLATFORM_SAFETY_DRIVER',
}

export type PolygonLocationCondition = {
  __typename?: 'PolygonLocationCondition'
  polygon: Maybe<PriceConditionPolygon>
  type: Maybe<LocationConditionType>
}

export type PolygonLocationConditionInput = {
  polygon?: InputMaybe<PriceConditionPolygonInput>
  type?: InputMaybe<LocationConditionType>
}

export type Pooling = {
  __typename?: 'Pooling'
  /** Whether we have an active connection with the tablet */
  connected: Maybe<Scalars['Boolean']['output']>
  /** When was the last time the connection status was updated? */
  connectedUpdatedAt: Maybe<Scalars['DateTime']['output']>
  /** Does this vehicle participate in pooling? Preconditon for being bookable */
  enabled: Scalars['Boolean']['output']
  /** Since when was pooling enabled */
  enabledUpdatedAt: Maybe<Scalars['DateTime']['output']>
  /** In case pooling is off, what was the reason for it? */
  reason: Maybe<PoolingReason>
}

export enum PoolingReason {
  AtHub = 'AT_HUB',
  AutomatedPlannedBreakEnd = 'AUTOMATED_PLANNED_BREAK_END',
  AutomatedPlannedBreakStart = 'AUTOMATED_PLANNED_BREAK_START',
  AutomatedPlannedHubReturn = 'AUTOMATED_PLANNED_HUB_RETURN',
  AutomatedShiftEnd = 'AUTOMATED_SHIFT_END',
  AutomatedShiftStart = 'AUTOMATED_SHIFT_START',
  AutomatedShortBreakEnd = 'AUTOMATED_SHORT_BREAK_END',
  AutomatedShortBreakStart = 'AUTOMATED_SHORT_BREAK_START',
  BioBreak = 'BIO_BREAK',
  ConfirmedByHub = 'CONFIRMED_BY_HUB',
  EventModeStart = 'EVENT_MODE_START',
  ManualIncidentHandling = 'MANUAL_INCIDENT_HANDLING',
  ManualOther = 'MANUAL_OTHER',
  ManualShortBreak = 'MANUAL_SHORT_BREAK',
  ManualStart = 'MANUAL_START',
  ManualTestDrive = 'MANUAL_TEST_DRIVE',
  ManualTroubleshooting = 'MANUAL_TROUBLESHOOTING',
  PlannedBreak = 'PLANNED_BREAK',
  ServiceDisabled = 'SERVICE_DISABLED',
  ShiftEnd = 'SHIFT_END',
  ShortBreak = 'SHORT_BREAK',
  Unknown = 'UNKNOWN',
}

export type PoolingStateChangedLogRecord = ShiftStateLogRecord & {
  __typename?: 'PoolingStateChangedLogRecord'
  eventTime: Scalars['DateTime']['output']
  poolingEnabled: Scalars['Boolean']['output']
  /** reason for pooling disabled (null when pooling was enabled) */
  reason: Maybe<Scalars['String']['output']>
  shiftId: Maybe<Scalars['ID']['output']>
  type: ShiftStateLogRecordType
  vehicleId: Scalars['ID']['output']
}

export enum PowerplugState {
  Connected = 'CONNECTED',
  Disconnected = 'DISCONNECTED',
}

export type Price = {
  __typename?: 'Price'
  /** The trip price before any reductions. */
  originalAmount: Money
  /** The final price after all reductions. That is, the amount payable by the customer. */
  payableAmount: Money
}

export type PriceConditionPolygon = {
  __typename?: 'PriceConditionPolygon'
  /** ID of the corresponding polygon in the polygon library */
  id: Scalars['ID']['output']
  locations: Array<Location>
  name: Scalars['String']['output']
}

export type PriceConditionPolygonInput = {
  /** ID of the corresponding polygon in the polygon library */
  id: Scalars['ID']['input']
  locations: Array<LocationInput>
  name: Scalars['String']['input']
}

export type PriceConfigChangeLogEntry = {
  __typename?: 'PriceConfigChangeLogEntry'
  action: PriceConfigStateAction
  timestamp: Scalars['DateTime']['output']
  userEmail: Scalars['String']['output']
}

export type PriceConfigDemandParameters = {
  __typename?: 'PriceConfigDemandParameters'
  basePrice: Money
  metersIncludedInBasePrice: Scalars['Int']['output']
  percentile: Scalars['Float']['output']
  pricePerKm: Money
}

export type PriceConfigDemandParametersInput = {
  basePrice: MoneyInput
  metersIncludedInBasePrice: Scalars['Int']['input']
  percentile: Scalars['Float']['input']
  pricePerKm: MoneyInput
}

export type PriceConfigDisplayText = {
  __typename?: 'PriceConfigDisplayText'
  header: Maybe<Scalars['String']['output']>
  locale: Scalars['String']['output']
  text: Maybe<Scalars['String']['output']>
}

export type PriceConfigDisplayTextInput = {
  header?: InputMaybe<Scalars['String']['input']>
  locale: Scalars['String']['input']
  text?: InputMaybe<Scalars['String']['input']>
}

export type PriceConfigParameters = {
  __typename?: 'PriceConfigParameters'
  demandParamsHigh: PriceConfigDemandParameters
  demandParamsLow: PriceConfigDemandParameters
  groupDiscounts: Array<Scalars['Float']['output']>
  randomFraction: PriceConfigRandomFraction
}

export type PriceConfigParametersInput = {
  demandParamsHigh: PriceConfigDemandParametersInput
  demandParamsLow: PriceConfigDemandParametersInput
  groupDiscounts: Array<Scalars['Float']['input']>
  randomFraction?: InputMaybe<PriceConfigRandomFractionInput>
}

export type PriceConfigPolygon = {
  __typename?: 'PriceConfigPolygon'
  archived: Maybe<Scalars['Boolean']['output']>
  id: Scalars['ID']['output']
  locations: Array<Location>
  name: Scalars['String']['output']
  serviceAreaID: Scalars['ID']['output']
}

/** Input object for adding a pricing polygon to a condition. */
export type PriceConfigPolygonInput = {
  /** ID of the corresponding polygon in the polygon library */
  id: Scalars['ID']['input']
  locations: Array<LocationInput>
  name: Scalars['String']['input']
}

export type PriceConfigPolygonsResponse = {
  __typename?: 'PriceConfigPolygonsResponse'
  polygons: Array<PriceConfigPolygon>
}

export type PriceConfigRandomFraction = {
  __typename?: 'PriceConfigRandomFraction'
  lowerBound: Scalars['Float']['output']
  upperBound: Scalars['Float']['output']
}

export type PriceConfigRandomFractionInput = {
  lowerBound: Scalars['Float']['input']
  upperBound: Scalars['Float']['input']
}

export enum PriceConfigServiceClass {
  Autonomous = 'AUTONOMOUS',
  Classic = 'CLASSIC',
  Express = 'EXPRESS',
  WheelchairAccessible = 'WHEELCHAIR_ACCESSIBLE',
}

export enum PriceConfigState {
  Approved = 'APPROVED',
  Pending = 'PENDING',
}

export enum PriceConfigStateAction {
  Approve = 'APPROVE',
  Create = 'CREATE',
  Delete = 'DELETE',
  Disapprove = 'DISAPPROVE',
  Update = 'UPDATE',
}

export type PriceConfigTimeSlot = {
  __typename?: 'PriceConfigTimeSlot'
  from: Scalars['TimeOfDay']['output']
  to: Scalars['TimeOfDay']['output']
}

export type PriceConfigTimeSlotInput = {
  from: Scalars['TimeOfDay']['input']
  to: Scalars['TimeOfDay']['input']
}

export type PricePartitionText = {
  __typename?: 'PricePartitionText'
  description: Scalars['String']['output']
  language: Language
  title: Scalars['String']['output']
}

export type PricePartitionTextInput = {
  description: Scalars['String']['input']
  language: Language
  title: Scalars['String']['input']
}

export type PricingAdultPassengerCountCondition = {
  __typename?: 'PricingAdultPassengerCountCondition'
  maxCount: Maybe<Scalars['Int']['output']>
  minCount: Maybe<Scalars['Int']['output']>
}

export type PricingAdultPassengerCountConditionInput = {
  maxCount?: InputMaybe<Scalars['Int']['input']>
  minCount?: InputMaybe<Scalars['Int']['input']>
}

export type PricingCampaign = {
  __typename?: 'PricingCampaign'
  conditions: PricingCondition
  description: Scalars['String']['output']
  discountPercentage: Scalars['Int']['output']
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  priority: Scalars['Float']['output']
  purpose: CampaignConfigPurpose
  serviceAreaID: Scalars['ID']['output']
  translations: Maybe<Array<PricePartitionText>>
  validFrom: Scalars['DateTime']['output']
  validTo: Scalars['DateTime']['output']
}

export type PricingCampaignInput = {
  conditions: PricingConditionInput
  description: Scalars['String']['input']
  discountPercentage: Scalars['Int']['input']
  name: Scalars['String']['input']
  priority: Scalars['Float']['input']
  purpose: CampaignConfigPurpose
  serviceAreaID: Scalars['ID']['input']
  translations?: InputMaybe<Array<PricePartitionTextInput>>
  validFrom: Scalars['DateTime']['input']
  validTo: Scalars['DateTime']['input']
}

export type PricingCampaignResponse = {
  __typename?: 'PricingCampaignResponse'
  campaign: PricingCampaign
}

export type PricingCondition = {
  __typename?: 'PricingCondition'
  adultPassengerCountCondition: Maybe<PricingAdultPassengerCountCondition>
  polygonLocationConditions: Maybe<Array<PolygonLocationCondition>>
  serviceClassCondition: Maybe<PricingServiceClassCondition>
  timeCondition: Maybe<PricingTimeCondition>
}

export type PricingConditionInput = {
  adultPassengerCountCondition?: InputMaybe<PricingAdultPassengerCountConditionInput>
  polygonLocationConditions?: InputMaybe<Array<PolygonLocationConditionInput>>
  serviceClassCondition?: InputMaybe<PricingServiceClassConditionInput>
  timeCondition?: InputMaybe<PricingTimeConditionInput>
}

export type PricingServiceClassCondition = {
  __typename?: 'PricingServiceClassCondition'
  serviceClasses: Maybe<Array<PriceConfigServiceClass>>
}

export type PricingServiceClassConditionInput = {
  serviceClasses?: InputMaybe<Array<PriceConfigServiceClass>>
}

export type PricingTimeCondition = {
  __typename?: 'PricingTimeCondition'
  days: Array<DayOfWeek>
  timeSlots: Maybe<Array<TimeOfDayInterval>>
}

export type PricingTimeConditionInput = {
  days: Array<DayOfWeek>
  timeSlots?: InputMaybe<Array<TimeOfDayIntervalInput>>
}

export type ProlongTemporaryBackofficeSessionInput = {
  sessionId: Scalars['ID']['input']
}

export enum ProvisioningState {
  Done = 'DONE',
  Draft = 'DRAFT',
  Pending = 'PENDING',
}

/** Input for publishing an SDS guidance decision */
export type PublishSdsGuidanceDecisionInput = {
  /** The decision to publish */
  decision: SdsGuidanceDecisionInput
  /** The ID of the issue to decide on */
  issueId: Scalars['ID']['input']
  /** The ID of the vehicle */
  vehicleId: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type Query = {
  __typename?: 'Query'
  /** Used to check if the Federation Gateway works end-to-end. Returns your headers as stringified JSON. */
  CANARY_headers: Scalars['String']['output']
  /** Used to check if the Federation Gateway works end-to-end. Returns ISO8601 DateTime. */
  CANARY_timestamp: Scalars['String']['output']
  actionByID: Maybe<Action>
  activationsByCustomRoadBlockageId: Array<RoadBlockageActivation>
  activationsByCustomTurnRestrictionId: Array<TurnRestrictionActivation>
  activationsByKeepOutZoneId: Array<KeepOutZoneActivation>
  activationsByRoadBlockage: Array<RoadBlockageActivation>
  activationsByTurnRestriction: Array<TurnRestrictionActivation>
  activeTripByVin: Maybe<TmpTrip>
  activeTripSegmentByVin: Maybe<ActiveTripSegment>
  activeTrips: Array<TmpTrip>
  /**
   * Currently active incidents for a vehicle.
   * Ordered chronologically by occurred (descending).
   * Optionally filtered by severity.
   */
  activeVehicleIncidents: Array<VehicleIncident>
  adminPanelGroups: Array<BackofficeUserManagementGroup>
  adminPanelGroupsWithUserCount: Maybe<Array<AdminPanelGroupWithUserCount>>
  adminPanelUserManagementUserFormDetails: AdminPanelUserManagementUserFormDetails
  aggregatedVehicleHubArrivalsAndDepartures: Array<AggregatedVehicleHubArrivalsAndDeparturesResponse>
  /** All history events in reversed order for a specific item, cursor paginated and optional limited between startDate and endDate (inclusive) */
  allChanges: HistoryItems
  allChangesToCustomRoadBlockages: HistoryItems
  allChangesToCustomTurnRestrictions: HistoryItems
  allChangesToRoadBlockages: HistoryItems
  allChangesToTurnRestrictions: HistoryItems
  /** Returns all signup allowlisted phone numbers for a tenant */
  allowlistedPhoneNumbers: Array<SignupAllowlistEntry>
  analyticsCodebeamerRequirements: Array<AnalyticsCodebeamerRequirement>
  analyticsFilters: AnalyticsFilters
  analyticsKpis: Array<AnalyticsKpi>
  analyticsPrimitiveDetails: AnalyticsPrimitiveDetailsResponse
  analyticsPrimitiveLogs: AnalyticsPrimitiveLogsResponse
  analyticsPrimitiveSummaries: Array<AnalyticsPrimitiveSummary>
  areaByID: Maybe<Area>
  /** returns all areas (visible to the client by tenancy/service area) and when provided filtered by IDs and/or AreaType */
  areas: Array<Area>
  /**
   * Provides the assigned CDIS Box.
   * Null if no CDIS box is assigned.
   */
  assignedCdisBox: Maybe<AssignedCdisBox>
  /** Called by employee app. Gets a list of vehicles that are ACTIVE, ONLINE, CLOSED, above a certain SoC and ordered by distance. For service staff INACTIVE vehicles are added. */
  availableVehicles: AvailableVehiclesResponse
  backofficeOrganizations: Array<BackofficeOrganization>
  backofficeOrganizationsForUpdates: Array<BackofficeOrganization>
  backofficeStatusById: BackofficeStatus
  backofficeStatusGetLastVisit: BackofficeStatusesLastVisitResponse
  backofficeStatuses: BackofficeStatusesResponse
  backofficeUpdateById: BackofficeUpdate
  backofficeUpdateGetLastVisit: BackofficeUpdatesLastVisitResponse
  backofficeUpdates: BackofficeUpdatesResponse
  backofficeUpdatesGetMediaPresignedUrl: BackofficeUpdateFilePresignedResponse
  backofficeUserByEmail: BackofficeUserResult
  backofficeUserById: BackofficeUserResult
  backofficeUserFleetsByEmail: Maybe<Array<BackofficeUserManagementFleet>>
  backofficeUserHistory: Maybe<Array<BackofficeUserManagementUserHistory>>
  /**
   * All fleets, regardless of the actor's own tenant assignments. Admin Panel only,
   * and requires the TEMPORARY_BACKOFFICE_SESSIONS right or the
   * ADMIN_PANEL_USER_MANAGEMENT_CRUD right.
   */
  backofficeUserManagementFleets: Array<BackofficeUserManagementFleet>
  backofficeUserManagementGroupByName: BackofficeUserManagementGroupExtended
  backofficeUserManagementGroupHistory: Maybe<
    Array<BackofficeUserManagementGroupHistory>
  >
  backofficeUserManagementGroups: Array<BackofficeUserManagementGroup>
  backofficeUserManagementGroupsWithApprovers: Maybe<
    Array<BackofficeUserManagementGroupExtended>
  >
  /**
   * All service areas, regardless of the actor's own tenant assignments. Admin Panel
   * only, and requires the TEMPORARY_BACKOFFICE_SESSIONS right or the
   * ADMIN_PANEL_USER_MANAGEMENT_CRUD right.
   */
  backofficeUserManagementServiceAreas: Array<BackofficeUserManagementServiceArea>
  backofficeUserManagementUserFormDetails: BackofficeUserManagementUserFormDetails
  backofficeUserManagementUsersHistory: Maybe<
    Array<BackofficeUserManagementUserHistory>
  >
  backofficeUsers: Maybe<Array<BackofficeUserResult>>
  bookingTimeSlots: BookingTimeSlotsResponse
  /** Get a single campaign by ID */
  campaignById: Maybe<Campaign>
  /** List all fleets belonging to the given region */
  campaignFleets: CampaignFleetsResponse
  /** List the audit trail of a single campaign, newest entry first */
  campaignHistory: CampaignHistoryResponse
  /** Get all available sensors */
  campaignSensors: CampaignSensorsResponse
  /** Get SOME/IP service by name */
  campaignServiceByName: Maybe<CampaignService>
  /** Get SOME/IP services for a given ARXML version */
  campaignServicesByVersion: CampaignServicesResponse
  /** Get signal by name */
  campaignSignalByName: Maybe<CampaignSignal>
  /** Get signals for a given ARXML version */
  campaignSignalsByVersion: CampaignSignalsResponse
  /** Get the vehicle selection for a campaign */
  campaignVehicleSelection: CampaignVehicleSelectionResponse
  /** List all vehicles belonging to the given fleet */
  campaignVehicles: CampaignVehiclesResponse
  /** List campaigns */
  campaigns: Maybe<CampaignsQueryResponse>
  /**
   * Retrieves a CDIS box by the associated Fleet Vehicle ID.
   * Returns the CDIS if found, or null if no box is assigned to the given vehicle.
   */
  cdisByFleetVehicleId: Maybe<Cdis>
  closestHub: ClosestHubResponse
  csvStops: Scalars['String']['output']
  /** returns active or upcoming shift */
  currentShift: Maybe<Shift>
  /**
   * The temporary Backoffice session the requesting actor is currently inside, or
   * null when they are not inside one. Still returns a session that has expired
   * but has not been closed yet.
   */
  currentTemporaryBackofficeSession: Maybe<TemporaryBackofficeSession>
  currentlyDrivenRoute: Maybe<CurrentlyDrivenRouteResponse>
  customPriceConfig: Maybe<CustomPriceConfigResponse>
  customPriceConfigs: CustomPriceConfigsResponse
  customRoadBlockageById: Maybe<RoadBlockage>
  customRoadBlockages: Array<RoadBlockage>
  customTurnRestrictionById: Maybe<TurnRestriction>
  customTurnRestrictions: Array<TurnRestriction>
  /**
   * Returns customer profile by id
   * @deprecated Use customerV2(id, customerTenant) query instead.
   */
  customer: CustomerResponse
  /** Returns detailed customer information by id and tenant */
  customerV2: Maybe<CustomerV2>
  /** Returns customer profiles by ids in the provided order, maximum 100 profiles, null in case a customer is not found */
  customers: CustomersResponse
  /** Returns customer profiles by ids in the provided order for a single tenant, maximum 100 ids per request (rejected with an error if exceeded), null in case a customer is not found. Mixing tenants in one request is not supported: all ids are looked up within the given customerTenant only. */
  customersV2: Array<Maybe<CustomerV2>>
  /** Get deactivation alerts for a service area. Returns alerts ordered by creation time (newest first). */
  deactivationAlerts: Array<DeactivationAlert>
  defaultPriceConfig: Maybe<DefaultPriceConfigResponse>
  defaultPriceConfigs: DefaultPriceConfigsResponse
  /** Retrieve a specific demo route by its ID */
  demoRouteById: Maybe<DemoRoute>
  /**
   * Generate a route preview for a specific demo route, including path details and ETA
   * This will calculate the actual route using the routing service
   */
  demoRoutePreview: Maybe<DemoRoutePreview>
  /** Retrieve all demo routes */
  demoRoutes: Maybe<Array<DemoRoute>>
  /** Full state of a session; null if it does not exist or has expired. */
  disengagementVoicebotSession: Maybe<DisengagementVoicebotSession>
  /** Placeholder query added in order to replace service queries. */
  dispatching2LambdaExtension: Maybe<Scalars['String']['output']>
  dispatchingStatus: Maybe<DispatchedTrip>
  dsBossFileByScenarioId: DsBossGetFileResponse
  dsBossScenarioDetailsByScenarioId: DsBossScenarioDetailsResponse
  dsBossScenariosByServiceAreaId: DsBossScenariosResponse
  employee: Employee
  /** get the scheduled blocks for a given employee and all employees within the same block id */
  employeeGetScheduledBlocks: EmployeeGetScheduledBlocksResponse
  employeeHubCheckInState: EmployeeHubCheckInStateResponse
  /** returns driver log associated to the given shift */
  employeeLogByShift: EmployeeLogResponse
  employeeMessage: EmployeeMessageResponse
  /** fetch all messages of the given categories for an employee. if categories is null or empty, all messages are returned. */
  employeeMessages: EmployeeMessagesResponse
  employeeQueryNotes: EmployeeQueryNotesResponse
  /** Returns timesheets for the given employee and date range, can only be queried by drivers */
  employeeTimesheets: Array<EmployeeTimesheet>
  /** returns monthly tipping amounts for the given employee */
  employeeTips: Maybe<EmployeeTipsResponse>
  /** employee (only) can query an employee vehicle interaction token */
  employeeVehicleInteraction: Maybe<EmployeeVehicleInteraction>
  /** generate a JWT signed zendesk URL to enable SSO for drivers */
  employeeZendeskSSO: EmployeeZendeskSsoResponse
  /** can be queried with EMPLOYEE_R, for full Employee info user must have EMPLOYEE_PERSONAL_DATA_R */
  employees: Employees
  encounteredOddElements: Array<EncounteredOddElement>
  fccAuditLog: FccAuditLogList
  fccCauseError: Maybe<Scalars['Boolean']['output']>
  fccNoError: Maybe<Scalars['Boolean']['output']>
  fccNonGraphqlError: Maybe<Scalars['Boolean']['output']>
  fccOperatorAvailabilitiesByFleets: Array<FccOperatorAvailabilityByFleet>
  /** @deprecated Reports the operator's single availability, which belongs to whichever area set it last. Read the fccVehicleHandling subscription instead, whose payload is per role. */
  fccOperatorAvailability: Maybe<FccCurrentOperatorAvailability>
  /** Returns tenant-specific phone number configuration for outgoing calls. */
  fccPhoneConfig: FccPhoneConfig
  fccPhoneNumbers: Array<FccPhone>
  fccRandomlyCauseError: Maybe<Scalars['Boolean']['output']>
  fccVehicleByPhoneNumber: Maybe<Vehicle>
  findCoupons: Maybe<Array<CouponInfo>>
  fleetMapFleets: Array<Fleet>
  fleetMapVehicles: FleetMapVehicles
  /** Get the fleet calendar showing per-vehicle, per-week shift availability. */
  fleetPlannerCalendar: FleetCalendarResult
  /**
   * Get campaign assignment planning result.
   * When calculate is true, runs the planning algorithm with provided settings.
   * When calculate is false or omitted, returns saved planning if one exists, otherwise falls back to calculation.
   */
  fleetPlannerCampaignAssignement: Maybe<FleetCampaignPlanningResult>
  /** List all fleet planner campaigns with their scheduling and location data. */
  fleetPlannerCampaigns: Array<FleetPlannerCampaign>
  /** List vehicle fleet IDs, optionally filtered by location and active within a date range. */
  fleetPlannerFleets: Array<FleetPlannerFleet>
  /** Get distinct filter values for integration stages, locations, and technical statuses. */
  fleetPlannerOptions: Maybe<FleetPlannerVehicleFilters>
  /** Get the status history for a specific vehicle. */
  fleetPlannerVehicle: Array<FleetPlannerVehicleEntry>
  /** Get detailed weekly schedule for a single vehicle. */
  fleetPlannerVehicleCalendarWeekDetail: VehicleCalendarWeekDetail
  /** Used by several BOFE tables and widgets, returns a list of vehicles. */
  fleetVehicles: VehiclesResponse
  /**
   * Returns all fleets of the operator tenants the user has access to.
   * Use `input` for filtering.
   */
  fleets: FleetsResponse
  /** Returns all stop bulk imports for a specific service area */
  getAllStopBulkImports: Array<StopBulkImport>
  getIncidents: Array<GetIncidentsResponse>
  /** Gets service class configuration for a given service class. */
  getOfferAndPoolingConfig: Maybe<OfferAndPoolingConfig>
  getSimulatedADVehicle: Maybe<SimulatedAdVehicle>
  getSimulatedADVehicleIncidents: Array<SimulatedAdVehicleIncident>
  hardwareConfiguration: HardwareConfiguration
  heatmapByID: Maybe<Heatmap>
  /** Returns the heatmap configuration for a service area, defaulting to enabled when none is stored */
  heatmapConfig: HeatmapConfig
  heatmapData: HeatmapData
  heatmapFilters: HeatmapFilters
  hubByID: Hub
  /** returns all hubs visible to the client, or filtered by IDs if provided */
  hubs: HubsResponse
  /** Return all in-app messages for a customer tenant */
  inAppMessages: Maybe<Array<InAppMessage>>
  /** @deprecated Not used anymore. */
  incident: Maybe<IncidentResponse>
  /** Get Incidents Analysis KPIs. */
  incidentsAnalysisKPIs: Array<IncidentsAnalysisKpiResponse>
  /** Get all Incidents locations. */
  incidentsLocations: Array<IncidentsLocationResponse>
  /** Get all Incidents. */
  incidentsPaginated: PaginatedIncidentResponse
  /** Get all Incidents software versions. */
  incidentsSoftwareVersions: Array<IncidentsSoftwareVersionResponse>
  inspectionProcessDocumentDownloadUrl: Scalars['String']['output']
  integrations: Array<Integration>
  keepOutZoneById: Maybe<KeepOutZone>
  keepOutZones: Array<KeepOutZone>
  kml: Scalars['String']['output']
  /** Return last trips for customerId */
  lastTripsByCustomerId: Maybe<Array<Trip>>
  /** Return last trips for vehicleId */
  lastTripsByVehicleId: Maybe<Array<Trip>>
  /** Latest history event for a specific item. Optional fieldChanged is a RegEx to find only the latest history event where matching fields changed. */
  latestChange: Maybe<HistoryItem>
  latestChangeToCustomRoadBlockage: Maybe<HistoryItem>
  latestChangeToCustomTurnRestriction: Maybe<HistoryItem>
  latestChangeToKeepOutZone: Maybe<HistoryItem>
  latestChangeToRoadBlockage: Maybe<HistoryItem>
  latestChangeToTurnRestriction: Maybe<HistoryItem>
  /** Returns a line by ID */
  lineById: Maybe<Line>
  /** Returns a route preview (polyline) for a given sequence of stops without persisting a line */
  lineRoutePreview: LineRoutePreview
  /** Returns the line service configuration for a service area */
  lineServiceConfig: LineServiceConfig
  /** Returns all lines for a given service area */
  lines: LinesResponse
  /** Returns all lines containing a specific stop */
  linesByStopId: LinesResponse
  mainInspectionDoneProcesses: Array<MainInspectionProcess>
  mainInspectionDueProcesses: Array<MainInspectionProcess>
  mainInspectionProgressProcesses: Array<MainInspectionProcess>
  mainInspectionTestFacilities: Array<MainInspectionTestFacility>
  mappedEdges: Array<EdgeGeolocations>
  metropolises: Array<Metropolis>
  migrationTestPleaseIgnore: Maybe<Scalars['Boolean']['output']>
  migrationTestPleaseIgnore2: Maybe<Scalars['String']['output']>
  mileageBasedInspectionDoneProcesses: Array<MileageBasedInspectionProcess>
  mileageBasedInspectionDueProcesses: Array<MileageBasedInspectionProcess>
  mileageBasedInspectionProgressProcesses: Array<MileageBasedInspectionProcess>
  mileageBasedInspectionTestFacilities: Array<MileageBasedInspectionTestFacility>
  minervaViewSummary: MinervaViewSummaryResponse
  nearestVehicles: Array<NearestVehicleType>
  oddElements: Array<OddElement>
  oddElementsByAttributes: PaginatedOddElements
  oddElementsForRoute: Array<RouteWithElements>
  oddElementsPaged: OddElementsPage
  /** Called by employee app. Gets a list of vehicles for which the last interaction was an OPEN interaction by this employee. */
  openVehiclesForEmployee: Array<Vehicle>
  /** Get one operating area by its ID (tenant-aware via corresponding region). */
  operatingArea: OperatingArea
  /** Get all operating areas (tenant-aware via corresponding region). */
  operatingAreasByRegionId: Array<OperatingArea>
  /** OpsCare settings of the calling user. `settings` is null for a user who has never stored any */
  opsCareSettings: OpsCareSettingsResponse
  overwatchFleets: Array<OverwatchFleet>
  overwatchTenants: Array<OverwatchTenant>
  overwatchVehicles: Array<OverwatchVehicle>
  /** DEPRECATED: Use `paginatedTripsByCustomerIdSortedByCreation` instead. Return a relay connection of the latest trips of a customer, sorted by creation time */
  paginatedTripsByCustomerId: Maybe<TripConnection>
  /** Return a relay connection of the latest trips of a customer, sorted by creation time */
  paginatedTripsByCustomerIdSortedByCreation: Maybe<TripConnection>
  /** Return a relay connection of the latest trips of a customer, sorted by promised pickup time */
  paginatedTripsByCustomerIdSortedByPickup: Maybe<TripConnection>
  /** Return a Relay connection of the latest trips of a vehicle, sorted by creation time */
  paginatedTripsByVehicleId: Maybe<TripConnection>
  /** Return a Relay connection of the latest trips of a vehicle, sorted by promised pickup time */
  paginatedTripsByVehicleIdSortedByPickup: Maybe<TripConnection>
  pairedVehicles: Array<PairedVehicle>
  /** Get the current passenger authentication state for a trip on a vehicle. */
  passengerAuthenticationState: PassengerAuthenticationStateInfo
  priceConfigPolygons: PriceConfigPolygonsResponse
  pricingCampaign: Maybe<PricingCampaignResponse>
  /** Get recent stop deactivations for a service area, ordered by deactivation time (newest first). Returns deactivations within the specified time range. When stopFlags is provided, only stops containing any of the specified flags are returned. */
  recentStopDeactivations: StopDeactivationFeed
  recurredAnnotations: Array<RecurredAnnotation>
  /** List of the customers that were referred */
  referees: Array<RefereeInfo>
  /** Who referred the customer */
  referrerInfo: Maybe<ReferrerInfo>
  /** Get one region by its ID (tenant-aware). */
  region: Region
  /** Get all regions (tenant-aware). */
  regions: Array<Region>
  rioAddressAutocomplete: RioAddressAutocompleteResponse
  rioAddressFromLocation: RioAddressFromLocationResponse
  rioAppPhotoUpload: RioAppPhotoUploadResponse
  rioAttachmentDownloadUrl: RioAttachmentDownloadUrlResponse
  rioAttachmentUploadUrl: RioAttachmentUploadUrlResponse
  rioExportReport: RioExportReportResponse
  rioLatestTemplate: RioLatestTemplateResponse
  rioReport: RioReportResponse
  rioReports: RioReportsResponse
  rioTempAttachmentDownloadUrl: RioTempAttachmentDownloadUrlResponse
  rioTemplateSelection: RioTemplateSelectionResponse
  roadBlockageById: Maybe<RoadBlockage>
  roadBlockages: Array<RoadBlockage>
  roadSegmentSuggestion: Maybe<RoadSegmentSuggestion>
  roadSegmentSuggestionsInsidePolygon: Array<RoadSegmentSuggestion>
  routeTimeDataForTrip: Maybe<TripRouteTimeData>
  safetyDriverAnnotation: AnnotationQueryResponse
  safetyDriverAnnotations: AnnotationsQueryResponse
  /** Returns the vehicle the calling safety driver is currently matched to, or null if there is no active match. */
  safetyDriverAssignedVehicle: Maybe<Vehicle>
  safetyDriverConfig: ConfigQueryResponse
  /** Resolve option labels for ids already stored on an annotation, so they render without holding the whole list client-side. Ids with no matching option are omitted. */
  safetyDriverConfigOptionsByIds: Array<ConfigOption>
  /** Search one option list of safetyDriverConfig. Case-insensitive substring match on the option name; an empty query returns the first `limit` options. Prefer this over safetyDriverConfig, which returns every option of every list. */
  safetyDriverConfigSearch: Array<ConfigOption>
  safetyDriverDashboardConfig: VnvBackofficeDashboardConfigQueryResponse
  /** Resolve option labels for ids already held in a dashboard filter, so a selected value renders without holding the whole list client-side. Ids with no matching option are omitted. */
  safetyDriverDashboardConfigOptionsByIds: Array<ConfigOption>
  /** Search one option list of safetyDriverDashboardConfig. Case-insensitive substring match on the option name; an empty query returns the first `limit` options. Prefer this over safetyDriverDashboardConfig, which returns every option of every list. */
  safetyDriverDashboardConfigSearch: Array<ConfigOption>
  safetyDriverDbtUnassessed: VnvBackofficeUnassessedQueryResponse
  safetyDriverDbtUnassessedSessionList: VnvBackofficeUnassessedSessionListQueryResponse
  safetyDriverMedTriages: VnvBackofficeMedTriagesQueryResponse
  safetyDriverPceAnalysis: VnvBackofficePceAnalysisQueryResponse
  safetyDriverSearch: AnnotationsQueryResponse
  savedRouteDetails: Maybe<SavedRouteDetails>
  savedRoutes: Array<SavedRoute>
  savedTripsByVtrs: Array<SavedTripsByVtrEntry>
  /** Get the current SDS guidance operator session for a vehicle. */
  sdsGuidanceOperatorSession: Maybe<SdsGuidanceOperatorSession>
  /** Get the current raw SDS guidance session for a vehicle. */
  sdsGuidanceSession: Maybe<SdsGuidanceSession>
  searchCustomersV2: SearchCustomersResult
  searchV3: SearchResultV3
  segmentsForTrip: Array<SegmentMetric>
  /** Returns all anchor points for a service area, generating them if none exist */
  serviceAreaAnchorPoints: Array<AnchorPoint>
  /** returns service area by ID or UUID */
  serviceAreaById: Maybe<ServiceArea>
  /** returns service areas */
  serviceAreas: Array<ServiceArea>
  serviceBreakLocationAddressAutocomplete: ServiceBreakLocationAddressAutocompleteResponse
  serviceBreakLocationById: Maybe<ServiceBreakLocation>
  serviceBreakLocationHistory: Array<ServiceBreakLocationHistoryEntry>
  serviceBreakLocations: ServiceBreakLocationsResponse
  /** returns service class config by ID or UUID */
  serviceClassConfig: Maybe<ServiceClassConfig>
  /** returns shift by id */
  shift: Maybe<Shift>
  shiftCapacityPlanningFiles: Array<ShiftCapacityPlanningFile>
  /** Returns a list of RMP files that can be chosen for new capacity plannings. List is ordered, whereas the last file is the youngest. */
  shiftCapacityPlanningRmpFiles: Array<ShiftCapacityPlanningRmpFile>
  shiftCapacityPlannings: Array<ShiftCapacityPlanning>
  /** Returns the utilization of a selected area for a specific time */
  shiftHubReturnUtilization: ShiftPlannedHubReturnUtilizationResponse
  /** returns planned hub return section options for a given shift ID */
  shiftPlannedHubReturnSectionOptions: Maybe<ShiftPlannedHubReturnSectionOptionsResponse>
  /** returns execution state for a given shift ID */
  shiftState: Maybe<ShiftState>
  /** returns the available shift types for a given service area */
  shiftTypes: Array<ShiftType>
  /** Returns demand and supply of shifts for the given service area and date-time range (from/to inclusive) */
  shiftsDemandSupply: Array<ShiftsDemandSupplyData>
  shiftsForEmployee: Array<Shift>
  /** returns all shifts for a region given input filters */
  shiftsInRange: Array<Shift>
  /** Returns supply for selected interval. */
  shiftsSupply: Array<ShiftsSupplyData>
  simulatedVehicleByID: Maybe<SimulatedVehicle>
  /** SMS delivery events for a phone number within one tenant, newest first. Requires BACKOFFICE_CUSTOMER_PHONE_NUMBER_R. */
  smsEvents: Array<SmsEvent>
  /** Computes reachability routes between a stop and all anchor points in the service area */
  stopAnchorReachability: Array<AnchorRoute>
  /** returns stops by ID */
  stopById: Maybe<Stop>
  stopCount: StopCountResult
  /** Returns the stop flag configuration for a service area */
  stopFlagConfig: StopFlagConfigurationDto
  /** returns a suggested stop for a coordinate */
  stopSuggestion: StopSuggestion
  /** returns validation results for a stop */
  stopValidation: StopValidationResults
  /** returns all stop validator configurations for the given service area */
  stopValidatorConfigs: Array<StopValidatorConfigDto>
  /** returns all stops for the given service area */
  stops: Array<Stop>
  stopsByIds: Array<SearchResultStopItemV3>
  taskNotificationById: Maybe<TaskNotification>
  taskNotifications: TaskNotificationList
  taxonomies: Array<Scalars['String']['output']>
  /**
   * A single temporary Backoffice session by its id, or null when no session with
   * that id exists. Admin Panel only.
   */
  temporaryBackofficeSession: Maybe<TemporaryBackofficeSession>
  /** Every temporary Backoffice session. Admin Panel only. */
  temporaryBackofficeSessions: Array<TemporaryBackofficeSession>
  /** Returns all latest legal documents available for a tenant */
  tenantLegalDocuments: LegalDocumentsResponse
  trip: Maybe<TmpTrip>
  tripAnnotationAudioUrl: TripAnnotationAudio
  tripAnnotations: Array<TripAnnotation>
  /** Return a trip with payment details for a given invoiceId */
  tripByInvoiceId: Maybe<Trip>
  /** Return a trip with payment details for a given paymentId */
  tripByPaymentId: Maybe<Trip>
  /** Return a trip with payment details for a given pspTransactionId */
  tripByPspTransactionId: Maybe<Trip>
  /** Return a trip with payment details */
  tripByTripId: Maybe<Trip>
  /** Return trip for tripName */
  tripByTripName: Maybe<Trip>
  tripDetails: Maybe<TripDetails>
  tripEventsForTrip: Array<TripTimelineEvent>
  tripFeedback: Array<TripFeedback>
  tripGeneratorExpiredTemplates: Array<TripGeneratorTemplate>
  tripGeneratorSubscription: Maybe<TripGeneratorVehicleSubscription>
  tripGeneratorTemplate: Maybe<TripGeneratorTemplate>
  tripGeneratorTemplates: Array<TripGeneratorTemplate>
  tripHistoryEntries: TripHistoryEntriesResponse
  tripProgress: Maybe<TripProgressResponse>
  tripReportFieldValues: Array<Scalars['String']['output']>
  tripReports: TripReportPage
  tripRiders: Array<TripRider>
  tripRoutePolyline: Maybe<TripRoutePolylineResponse>
  trips: Array<TripRecord>
  tripsWithDetails: Array<TripWithDetails>
  turnRestrictionById: Maybe<TurnRestriction>
  turnRestrictions: Array<TurnRestriction>
  /**
   * Lists boxes that are unassigned for a vehicle
   * Telemetry data will not be forwarded from the box unless it is assigned.
   */
  unassignedCdisBoxes: Array<UnassignedCdisBox>
  unassignedTablets: Array<Tablet>
  vehicleAssets: Array<VehicleAsset>
  /** Returns a vehicle for a given label, service area and tenant */
  vehicleByID: Vehicle
  vehicleCapacityConfigs: Array<VehicleCapacityConfig>
  vehicleChanges: VehicleChangeList
  vehicleClusters: Array<VehicleClusterType>
  vehicleDataOverrideHistory: Array<VehicleDataOverrideEvent>
  vehicleDataOverrideSearch: VehicleDataOverrideQueryResponse
  vehicleDetails: Array<VehicleDetails>
  vehicleHubArrivals: VehicleHubArrivalsResponse
  /**
   * All incidents for a vehicle within the retention window.
   * Ordered chronologically by occurred (descending).
   * Optionally filtered by severity.
   */
  vehicleIncidents: Array<VehicleIncident>
  /** Returns a list of interactions for a specific vehicle (when and where a vehicle was opened or closed). Needed for the interactions tab of a vehicle. */
  vehicleInteractions: VehicleInteractionsResponse
  vehicleListsByRegion: VehicleListsResponse
  /** Driven mileage per vehicle per local calendar day, derived from vehicle mileage (odometer) readings. Day boundaries are computed in the caller-supplied time zone so the dashboard can bucket by browser-local time. */
  vehicleMileageDeltas: VehicleMileageDeltasResponse
  vehicleMissionSync: Scalars['String']['output']
  /** Templates of one operator tenant. The caller must be authorized for that tenant. */
  vehiclePlanTemplates: Array<VehiclePlanTemplate>
  vehicleSearch: Array<VehicleStatusDetail>
  vehicleStatus: Maybe<VehicleStatusDetail>
  vehicleStatusTelemetry: Maybe<VehicleStatusVehicleTelemetry>
  vehicleStatuses: Array<VehicleStatusDetail>
  vehicleSummaries: Array<VehicleSummaryType>
  vehiclesByIDs: Array<Vehicle>
  /** resolves the VGA app version for an specific vehicle ID. */
  vgaVersion: VgaVersionInfo
  vicDoneProcesses: Array<VicProcess>
  vicDueProcesses: Array<VicProcess>
  vtrData: Maybe<VtrData>
  vtrJiraTickets: Array<VtrJiraTicket>
  vtrKpis: Array<Kpi>
  /**
   * Returns a single automation rule by ID. `automationRule` is null when no such rule exists in a
   * tenant the caller has access to. Requires WORK_ORDERS_AUTOMATIONS_R or WORK_ORDERS_AUTOMATIONS_CRUD.
   *
   * Error codes:
   * - FORBIDDEN: The caller lacks the required right.
   */
  workOrderAutomationRule: WorkOrderAutomationRuleResponse
  /**
   * Returns automation rules for the given tenant, each with its `lastRun` and `runsCount`. Requires
   * WORK_ORDERS_AUTOMATIONS_R or WORK_ORDERS_AUTOMATIONS_CRUD.
   *
   * Error codes:
   * - FORBIDDEN: The caller lacks the required right, or has no access to `tenant`.
   */
  workOrderAutomationRules: WorkOrderAutomationRulesResponse
  /**
   * Work orders relevant to the calling user: unassigned OPEN ones, plus their own
   * OPEN/IN_PROGRESS ones and recently CANCELLED ones.
   *
   * INCIDENT work orders are only visible to users holding the
   * APP_OPSCARE_IN_FIELD_SUPPORT right. For everyone else they are omitted from
   * `workOrders` and INCIDENT is absent from `allowedCategoryFilter`.
   */
  workOrdersByCurrentUser: WorkOrdersByCurrentUserResponse
  workOrdersByRegion: WorkOrdersQueryResponse
}

/** Vehicle Incident API */
export type QueryActionByIdArgs = {
  actionID: Scalars['ID']['input']
  serviceAreaID: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryActivationsByCustomRoadBlockageIdArgs = {
  regionId: Scalars['ID']['input']
  roadBlockageId: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryActivationsByCustomTurnRestrictionIdArgs = {
  regionId: Scalars['ID']['input']
  turnRestrictionId: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryActivationsByKeepOutZoneIdArgs = {
  keepOutZoneId: Scalars['ID']['input']
  regionId: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryActivationsByRoadBlockageArgs = {
  roadBlockageId: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryActivationsByTurnRestrictionArgs = {
  turnRestrictionId: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryActiveTripByVinArgs = {
  filter?: InputMaybe<TripFilterInput>
  vin: Scalars['String']['input']
}

/** Vehicle Incident API */
export type QueryActiveTripSegmentByVinArgs = {
  filter?: InputMaybe<TripFilterInput>
  vin: Scalars['String']['input']
}

/** Vehicle Incident API */
export type QueryActiveTripsArgs = {
  vins: Array<Scalars['String']['input']>
}

/** Vehicle Incident API */
export type QueryActiveVehicleIncidentsArgs = {
  severity?: InputMaybe<IncidentSeverity>
  vehicleId: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryAggregatedVehicleHubArrivalsAndDeparturesArgs = {
  hubID: Scalars['ID']['input']
  intervals: Array<DateTimeIntervalInput>
}

/** Vehicle Incident API */
export type QueryAllChangesArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>
  fieldChanged?: InputMaybe<Scalars['String']['input']>
  id: Scalars['String']['input']
  nextCursor?: InputMaybe<Scalars['String']['input']>
  serviceAreaId?: InputMaybe<Scalars['String']['input']>
  startDate?: InputMaybe<Scalars['DateTime']['input']>
  type: EventItemType
}

/** Vehicle Incident API */
export type QueryAllChangesToCustomRoadBlockagesArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>
  fieldChanged?: InputMaybe<Scalars['String']['input']>
  nextCursor?: InputMaybe<Scalars['String']['input']>
  regionId: Scalars['ID']['input']
  roadBlockageId: Scalars['ID']['input']
  startDate?: InputMaybe<Scalars['DateTime']['input']>
}

/** Vehicle Incident API */
export type QueryAllChangesToCustomTurnRestrictionsArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>
  fieldChanged?: InputMaybe<Scalars['String']['input']>
  nextCursor?: InputMaybe<Scalars['String']['input']>
  regionId: Scalars['ID']['input']
  startDate?: InputMaybe<Scalars['DateTime']['input']>
  turnRestrictionId: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryAllChangesToRoadBlockagesArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>
  fieldChanged?: InputMaybe<Scalars['String']['input']>
  nextCursor?: InputMaybe<Scalars['String']['input']>
  roadBlockageId: Scalars['ID']['input']
  serviceAreaId: Scalars['ID']['input']
  startDate?: InputMaybe<Scalars['DateTime']['input']>
}

/** Vehicle Incident API */
export type QueryAllChangesToTurnRestrictionsArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>
  fieldChanged?: InputMaybe<Scalars['String']['input']>
  nextCursor?: InputMaybe<Scalars['String']['input']>
  serviceAreaId: Scalars['ID']['input']
  startDate?: InputMaybe<Scalars['DateTime']['input']>
  turnRestrictionId: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryAllowlistedPhoneNumbersArgs = {
  tenant: Scalars['String']['input']
}

/** Vehicle Incident API */
export type QueryAnalyticsCodebeamerRequirementsArgs = {
  codebeamerId?: InputMaybe<Scalars['String']['input']>
  taxonomies?: InputMaybe<Array<Scalars['String']['input']>>
}

/** Vehicle Incident API */
export type QueryAnalyticsKpisArgs = {
  filters?: InputMaybe<AnalyticsFiltersInput>
}

/** Vehicle Incident API */
export type QueryAnalyticsPrimitiveDetailsArgs = {
  filters?: InputMaybe<AnalyticsFiltersInput>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  primitiveName: Scalars['String']['input']
  primitiveType: Scalars['String']['input']
}

/** Vehicle Incident API */
export type QueryAnalyticsPrimitiveLogsArgs = {
  filters?: InputMaybe<AnalyticsFiltersInput>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  taxonomies: Array<Scalars['String']['input']>
}

/** Vehicle Incident API */
export type QueryAnalyticsPrimitiveSummariesArgs = {
  filters?: InputMaybe<AnalyticsFiltersInput>
}

/** Vehicle Incident API */
export type QueryAreaByIdArgs = {
  areaID: Scalars['ID']['input']
  serviceAreaID: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryAreasArgs = {
  areaTypes?: InputMaybe<Array<AreaType>>
  ids?: InputMaybe<Array<Scalars['ID']['input']>>
  serviceAreaID?: InputMaybe<Scalars['ID']['input']>
}

/** Vehicle Incident API */
export type QueryAssignedCdisBoxArgs = {
  fleetVehicleId: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryAvailableVehiclesArgs = {
  location: LocationInput
  token?: InputMaybe<Scalars['String']['input']>
}

/** Vehicle Incident API */
export type QueryBackofficeOrganizationsArgs = {
  allOrganizations?: InputMaybe<Scalars['Boolean']['input']>
}

/** Vehicle Incident API */
export type QueryBackofficeStatusByIdArgs = {
  id: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryBackofficeUpdateByIdArgs = {
  id: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryBackofficeUpdatesGetMediaPresignedUrlArgs = {
  input: BackofficeUpdateGetMediaFilePresignedUrlInput
}

/** Vehicle Incident API */
export type QueryBackofficeUserByEmailArgs = {
  email: Scalars['String']['input']
}

/** Vehicle Incident API */
export type QueryBackofficeUserByIdArgs = {
  id: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryBackofficeUserFleetsByEmailArgs = {
  email: Scalars['String']['input']
}

/** Vehicle Incident API */
export type QueryBackofficeUserHistoryArgs = {
  id: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryBackofficeUserManagementGroupByNameArgs = {
  name: Scalars['String']['input']
}

/** Vehicle Incident API */
export type QueryBackofficeUserManagementGroupHistoryArgs = {
  name: Scalars['String']['input']
}

/** Vehicle Incident API */
export type QueryBackofficeUserManagementGroupsArgs = {
  allGroups?: InputMaybe<Scalars['Boolean']['input']>
}

/** Vehicle Incident API */
export type QueryBackofficeUserManagementUsersHistoryArgs = {
  input: BackofficeUserManagementUsersHistoryInput
}

/** Vehicle Incident API */
export type QueryBookingTimeSlotsArgs = {
  input: BookingTimeSlotsInput
}

/** Vehicle Incident API */
export type QueryCampaignByIdArgs = {
  id: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryCampaignFleetsArgs = {
  regionId: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryCampaignHistoryArgs = {
  input: CampaignHistoryQueryInput
}

/** Vehicle Incident API */
export type QueryCampaignServiceByNameArgs = {
  name: Scalars['String']['input']
}

/** Vehicle Incident API */
export type QueryCampaignServicesByVersionArgs = {
  version: Scalars['String']['input']
}

/** Vehicle Incident API */
export type QueryCampaignSignalByNameArgs = {
  name: Scalars['String']['input']
  version: Scalars['String']['input']
}

/** Vehicle Incident API */
export type QueryCampaignSignalsByVersionArgs = {
  version: Scalars['String']['input']
}

/** Vehicle Incident API */
export type QueryCampaignVehicleSelectionArgs = {
  campaignId: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryCampaignVehiclesArgs = {
  input: CampaignVehiclesQueryInput
}

/** Vehicle Incident API */
export type QueryCampaignsArgs = {
  input: CursorPaginationInput
}

/** Vehicle Incident API */
export type QueryCdisByFleetVehicleIdArgs = {
  fleetVehicleId: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryClosestHubArgs = {
  locationInput: LocationInput
}

/** Vehicle Incident API */
export type QueryCsvStopsArgs = {
  searchInput: SearchInput
  serviceAreaID: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryCurrentShiftArgs = {
  employeeId: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryCurrentlyDrivenRouteArgs = {
  vehicleId: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryCustomPriceConfigArgs = {
  id: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryCustomPriceConfigsArgs = {
  dateRangeFilter?: InputMaybe<DateTimeIntervalInput>
  nameFilter?: InputMaybe<Scalars['String']['input']>
  orderBy?: InputMaybe<CustomConfigOrderByInput>
  pagination?: InputMaybe<PaginationInput>
  serviceAreaID: Scalars['ID']['input']
  stateFilter?: InputMaybe<PriceConfigState>
}

/** Vehicle Incident API */
export type QueryCustomRoadBlockageByIdArgs = {
  regionId: Scalars['ID']['input']
  roadBlockageId: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryCustomRoadBlockagesArgs = {
  filter?: InputMaybe<CustomRoadBlockageFilterInput>
  regionId: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryCustomTurnRestrictionByIdArgs = {
  regionId: Scalars['ID']['input']
  turnRestrictionId: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryCustomTurnRestrictionsArgs = {
  filter?: InputMaybe<CustomTurnRestrictionFilterInput>
  regionId: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryCustomerArgs = {
  id: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryCustomerV2Args = {
  customerTenant: Scalars['String']['input']
  id: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryCustomersArgs = {
  ids: Array<Scalars['ID']['input']>
}

/** Vehicle Incident API */
export type QueryCustomersV2Args = {
  customerTenant: Scalars['String']['input']
  ids: Array<Scalars['ID']['input']>
}

/** Vehicle Incident API */
export type QueryDeactivationAlertsArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>
  serviceAreaId: Scalars['ID']['input']
  startDate?: InputMaybe<Scalars['DateTime']['input']>
}

/** Vehicle Incident API */
export type QueryDefaultPriceConfigArgs = {
  id: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryDefaultPriceConfigsArgs = {
  dateRangeFilter?: InputMaybe<DateTimeIntervalInput>
  nameFilter?: InputMaybe<Scalars['String']['input']>
  pagination?: InputMaybe<PaginationInput>
  serviceAreaID: Scalars['ID']['input']
  stateFilter?: InputMaybe<PriceConfigState>
}

/** Vehicle Incident API */
export type QueryDemoRouteByIdArgs = {
  id: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryDemoRoutePreviewArgs = {
  input: DemoRoutePreviewInput
}

/** Vehicle Incident API */
export type QueryDisengagementVoicebotSessionArgs = {
  sessionId: Scalars['UUID']['input']
}

/** Vehicle Incident API */
export type QueryDispatchingStatusArgs = {
  savedTripId: Scalars['String']['input']
  vin: Scalars['String']['input']
}

/** Vehicle Incident API */
export type QueryDsBossFileByScenarioIdArgs = {
  input: DsBossGetBasedOnScenarioId
}

/** Vehicle Incident API */
export type QueryDsBossScenarioDetailsByScenarioIdArgs = {
  input: DsBossGetBasedOnScenarioId
}

/** Vehicle Incident API */
export type QueryDsBossScenariosByServiceAreaIdArgs = {
  input: DsBossGetBasedOnServiceAreaId
}

/** Vehicle Incident API */
export type QueryEmployeeArgs = {
  id: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryEmployeeGetScheduledBlocksArgs = {
  employeeId: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryEmployeeHubCheckInStateArgs = {
  employeeId: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryEmployeeLogByShiftArgs = {
  shiftId: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryEmployeeMessageArgs = {
  employeeId: Scalars['ID']['input']
  messageId: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryEmployeeMessagesArgs = {
  categories?: InputMaybe<Array<EmployeeMessageCategory>>
  employeeID: Scalars['ID']['input']
  year?: InputMaybe<Scalars['Int']['input']>
}

/** Vehicle Incident API */
export type QueryEmployeeQueryNotesArgs = {
  input: EmployeeQueryNotesInput
}

/** Vehicle Incident API */
export type QueryEmployeeTimesheetsArgs = {
  employeeId: Scalars['ID']['input']
  from: Scalars['Date']['input']
  to: Scalars['Date']['input']
}

/** Vehicle Incident API */
export type QueryEmployeeTipsArgs = {
  employeeId: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryEmployeeVehicleInteractionArgs = {
  employeeId: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryEmployeeZendeskSsoArgs = {
  returnTo: Scalars['String']['input']
}

/** Vehicle Incident API */
export type QueryEmployeesArgs = {
  employeesFilter?: InputMaybe<EmployeesFilterInput>
  pagination?: InputMaybe<PaginationInput>
}

/** Vehicle Incident API */
export type QueryFccAuditLogArgs = {
  input: FccAuditLogInput
}

/** Vehicle Incident API */
export type QueryFccOperatorAvailabilitiesByFleetsArgs = {
  regionId: Scalars['ID']['input']
  role?: InputMaybe<FccOperatorRoleType>
}

/** Vehicle Incident API */
export type QueryFccOperatorAvailabilityArgs = {
  regionId: Scalars['ID']['input']
  role?: InputMaybe<FccOperatorRoleType>
}

/** Vehicle Incident API */
export type QueryFccPhoneConfigArgs = {
  vehicleId: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryFccPhoneNumbersArgs = {
  vehicleId: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryFccVehicleByPhoneNumberArgs = {
  phoneNumber: Scalars['String']['input']
}

/** Vehicle Incident API */
export type QueryFindCouponsArgs = {
  code: Scalars['String']['input']
}

/** Vehicle Incident API */
export type QueryFleetMapFleetsArgs = {
  input: FleetMapFleetsInput
}

/** Vehicle Incident API */
export type QueryFleetMapVehiclesArgs = {
  input: FleetMapVehiclesInput
}

/** Vehicle Incident API */
export type QueryFleetPlannerCalendarArgs = {
  availability: Array<FleetCalendarAvailability>
  endDate: Scalars['Date']['input']
  location: Scalars['String']['input']
  selectedDays: Array<FleetCampaignDay>
  selectedShifts: Array<FleetCampaignShift>
  startDate: Scalars['Date']['input']
  vehicleId?: InputMaybe<Scalars['ID']['input']>
}

/** Vehicle Incident API */
export type QueryFleetPlannerCampaignAssignementArgs = {
  assignmentDays?: InputMaybe<Array<FleetCampaignDay>>
  assignmentShifts?: InputMaybe<Array<FleetCampaignShift>>
  calculate?: InputMaybe<Scalars['Boolean']['input']>
  campaignId?: InputMaybe<Scalars['ID']['input']>
  vehicleCount?: InputMaybe<Scalars['Int']['input']>
}

/** Vehicle Incident API */
export type QueryFleetPlannerFleetsArgs = {
  endDate: Scalars['Date']['input']
  location?: InputMaybe<Scalars['String']['input']>
  startDate: Scalars['Date']['input']
}

/** Vehicle Incident API */
export type QueryFleetPlannerVehicleArgs = {
  id: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryFleetPlannerVehicleCalendarWeekDetailArgs = {
  endDate: Scalars['Date']['input']
  location: Scalars['String']['input']
  startDate: Scalars['Date']['input']
  vehicleId: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryFleetVehiclesArgs = {
  input: VehicleSearchInput
}

/** Vehicle Incident API */
export type QueryFleetsArgs = {
  input?: InputMaybe<FleetsInput>
}

/** Vehicle Incident API */
export type QueryGetAllStopBulkImportsArgs = {
  serviceAreaId: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryGetIncidentsArgs = {
  affected?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  from?: InputMaybe<Scalars['DateTime']['input']>
  open: Scalars['Boolean']['input']
  severity?: InputMaybe<Array<InputMaybe<Severity>>>
  to?: InputMaybe<Scalars['DateTime']['input']>
}

/** Vehicle Incident API */
export type QueryGetOfferAndPoolingConfigArgs = {
  serviceAreaUuid: Scalars['UUID']['input']
  serviceClassId: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryGetSimulatedAdVehicleArgs = {
  id: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryGetSimulatedAdVehicleIncidentsArgs = {
  fleetVehicleId: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryHardwareConfigurationArgs = {
  vehicleId: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryHeatmapByIdArgs = {
  id: Scalars['ID']['input']
  serviceAreaID: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryHeatmapConfigArgs = {
  serviceAreaId: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryHeatmapDataArgs = {
  filters?: InputMaybe<HeatmapFilterInput>
  heatmapType: HeatmapType
  metroId: Scalars['Int']['input']
}

/** Vehicle Incident API */
export type QueryHeatmapFiltersArgs = {
  heatmapType: HeatmapType
  metroId: Scalars['Int']['input']
}

/** Vehicle Incident API */
export type QueryHubByIdArgs = {
  id: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryHubsArgs = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>
  serviceAreaUUID?: InputMaybe<Scalars['ID']['input']>
}

/** Vehicle Incident API */
export type QueryInAppMessagesArgs = {
  customerTenant: Scalars['String']['input']
}

/** Vehicle Incident API */
export type QueryIncidentArgs = {
  sds_provider_id: Scalars['ID']['input']
  session_id: Scalars['String']['input']
}

/** Vehicle Incident API */
export type QueryIncidentsPaginatedArgs = {
  filter?: InputMaybe<IncidentFilterInput>
  limit: Scalars['Int']['input']
  page: Scalars['Int']['input']
}

/** Vehicle Incident API */
export type QueryInspectionProcessDocumentDownloadUrlArgs = {
  input: InspectionProcessDocumentDownloadUrlInput
}

/** Vehicle Incident API */
export type QueryKeepOutZoneByIdArgs = {
  keepOutZoneId: Scalars['ID']['input']
  regionId: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryKeepOutZonesArgs = {
  filter?: InputMaybe<KeepOutZoneFilterInput>
  regionId: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryKmlArgs = {
  searchInput: SearchInput
  serviceAreaID: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryLastTripsByCustomerIdArgs = {
  id: Scalars['ID']['input']
  limit: Scalars['Int']['input']
}

/** Vehicle Incident API */
export type QueryLastTripsByVehicleIdArgs = {
  id: Scalars['ID']['input']
  limit: Scalars['Int']['input']
}

/** Vehicle Incident API */
export type QueryLatestChangeArgs = {
  fieldChanged?: InputMaybe<Scalars['String']['input']>
  id: Scalars['String']['input']
  type: EventItemType
}

/** Vehicle Incident API */
export type QueryLatestChangeToCustomRoadBlockageArgs = {
  regionId: Scalars['ID']['input']
  roadBlockageId: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryLatestChangeToCustomTurnRestrictionArgs = {
  regionId: Scalars['ID']['input']
  turnRestrictionId: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryLatestChangeToKeepOutZoneArgs = {
  keepOutZoneId: Scalars['ID']['input']
  regionId: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryLatestChangeToRoadBlockageArgs = {
  roadBlockageId: Scalars['ID']['input']
  serviceAreaId: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryLatestChangeToTurnRestrictionArgs = {
  serviceAreaId: Scalars['ID']['input']
  turnRestrictionId: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryLineByIdArgs = {
  lineId: Scalars['ID']['input']
  serviceAreaId: Scalars['ID']['input']
  showInactiveStops?: InputMaybe<Scalars['Boolean']['input']>
}

/** Vehicle Incident API */
export type QueryLineRoutePreviewArgs = {
  circular?: InputMaybe<Scalars['Boolean']['input']>
  stops: Array<LineRoutePreviewInput>
}

/** Vehicle Incident API */
export type QueryLineServiceConfigArgs = {
  serviceAreaId: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryLinesArgs = {
  serviceAreaId: Scalars['ID']['input']
  showInactiveStops?: InputMaybe<Scalars['Boolean']['input']>
}

/** Vehicle Incident API */
export type QueryLinesByStopIdArgs = {
  serviceAreaId: Scalars['ID']['input']
  showInactiveStops?: InputMaybe<Scalars['Boolean']['input']>
  stopId: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryMainInspectionDoneProcessesArgs = {
  input: InspectionDoneProcessesSearch
}

/** Vehicle Incident API */
export type QueryMainInspectionDueProcessesArgs = {
  input: InspectionDueProcessesSearch
}

/** Vehicle Incident API */
export type QueryMainInspectionProgressProcessesArgs = {
  input: InspectionProgressProcessesSearch
}

/** Vehicle Incident API */
export type QueryMainInspectionTestFacilitiesArgs = {
  regionId: Scalars['String']['input']
}

/** Vehicle Incident API */
export type QueryMappedEdgesArgs = {
  metroId: Scalars['Int']['input']
}

/** Vehicle Incident API */
export type QueryMileageBasedInspectionDoneProcessesArgs = {
  input: InspectionDoneProcessesSearch
}

/** Vehicle Incident API */
export type QueryMileageBasedInspectionDueProcessesArgs = {
  input: InspectionDueProcessesSearch
}

/** Vehicle Incident API */
export type QueryMileageBasedInspectionProgressProcessesArgs = {
  input: InspectionProgressProcessesSearch
}

/** Vehicle Incident API */
export type QueryMileageBasedInspectionTestFacilitiesArgs = {
  regionId: Scalars['String']['input']
}

/** Vehicle Incident API */
export type QueryMinervaViewSummaryArgs = {
  input: MinervaViewSummaryInput
}

/** Vehicle Incident API */
export type QueryNearestVehiclesArgs = {
  coordinate: CoordinateInput
  disconnectThresholdSeconds?: InputMaybe<Scalars['Int']['input']>
  maxRadiusKm: Scalars['Float']['input']
  maxVehicles: Scalars['Int']['input']
}

/** Vehicle Incident API */
export type QueryOddElementsArgs = {
  centerLocation?: InputMaybe<GeolocationInput>
  metroId: Scalars['Int']['input']
  oddElementTypes?: InputMaybe<Array<OddElementType>>
  radiusMeters?: InputMaybe<Scalars['Float']['input']>
  taxonomies?: InputMaybe<Array<Scalars['String']['input']>>
}

/** Vehicle Incident API */
export type QueryOddElementsByAttributesArgs = {
  excludeOddElementTypes?: InputMaybe<Array<OddElementType>>
  includeOddElementTypes?: InputMaybe<Array<OddElementType>>
  metroId: Scalars['Int']['input']
  pageSize?: InputMaybe<Scalars['Int']['input']>
  pageToken?: InputMaybe<Scalars['String']['input']>
  targetOddElementType: OddElementType
}

/** Vehicle Incident API */
export type QueryOddElementsForRouteArgs = {
  metroId: Scalars['Int']['input']
  oddElementTypes?: InputMaybe<Array<OddElementType>>
  routes: Array<RouteInput>
  taxonomies?: InputMaybe<Array<Scalars['String']['input']>>
}

/** Vehicle Incident API */
export type QueryOddElementsPagedArgs = {
  centerLocation?: InputMaybe<GeolocationInput>
  limit: Scalars['Int']['input']
  metroId: Scalars['Int']['input']
  oddElementTypes?: InputMaybe<Array<OddElementType>>
  offset?: InputMaybe<Scalars['Int']['input']>
  radiusMeters?: InputMaybe<Scalars['Float']['input']>
  taxonomies?: InputMaybe<Array<Scalars['String']['input']>>
}

/** Vehicle Incident API */
export type QueryOperatingAreaArgs = {
  id: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryOperatingAreasByRegionIdArgs = {
  regionId: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryOverwatchVehiclesArgs = {
  fleetIds?: InputMaybe<Array<Scalars['ID']['input']>>
}

/** Vehicle Incident API */
export type QueryPaginatedTripsByCustomerIdArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  dateTimeInterval?: InputMaybe<DateTimeIntervalInput>
  first?: InputMaybe<Scalars['Int']['input']>
  id: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryPaginatedTripsByCustomerIdSortedByCreationArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  dateTimeInterval?: InputMaybe<DateTimeIntervalInput>
  first?: InputMaybe<Scalars['Int']['input']>
  id: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryPaginatedTripsByCustomerIdSortedByPickupArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  dateTimeInterval?: InputMaybe<DateTimeIntervalInput>
  first?: InputMaybe<Scalars['Int']['input']>
  id: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryPaginatedTripsByVehicleIdArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  dateTimeInterval?: InputMaybe<DateTimeIntervalInput>
  first?: InputMaybe<Scalars['Int']['input']>
  id: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryPaginatedTripsByVehicleIdSortedByPickupArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  dateTimeInterval?: InputMaybe<DateTimeIntervalInput>
  first?: InputMaybe<Scalars['Int']['input']>
  id: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryPairedVehiclesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
}

/** Vehicle Incident API */
export type QueryPassengerAuthenticationStateArgs = {
  fleetVehicle: Scalars['ID']['input']
  tripId: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryPriceConfigPolygonsArgs = {
  serviceAreaID: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryPricingCampaignArgs = {
  id: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryRecentStopDeactivationsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>
  from: Scalars['DateTime']['input']
  limit?: InputMaybe<Scalars['Int']['input']>
  serviceAreaId: Scalars['String']['input']
  stopFlags?: InputMaybe<Array<StopFlag>>
  to: Scalars['DateTime']['input']
}

/** Vehicle Incident API */
export type QueryRecurredAnnotationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
}

/** Vehicle Incident API */
export type QueryRefereesArgs = {
  customerId: Scalars['String']['input']
}

/** Vehicle Incident API */
export type QueryReferrerInfoArgs = {
  customerId: Scalars['String']['input']
}

/** Vehicle Incident API */
export type QueryRegionArgs = {
  id: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryRioAddressAutocompleteArgs = {
  input: RioAddressAutocompleteInput
}

/** Vehicle Incident API */
export type QueryRioAddressFromLocationArgs = {
  input: RioAddressFromLocationInput
}

/** Vehicle Incident API */
export type QueryRioAttachmentDownloadUrlArgs = {
  input: RioAttachmentDownloadUrlInput
}

/** Vehicle Incident API */
export type QueryRioAttachmentUploadUrlArgs = {
  input: RioAttachmentUploadUrlInput
}

/** Vehicle Incident API */
export type QueryRioExportReportArgs = {
  input: RioExportReportInput
}

/** Vehicle Incident API */
export type QueryRioLatestTemplateArgs = {
  input: RioLatestTemplateInput
}

/** Vehicle Incident API */
export type QueryRioReportArgs = {
  input: RioReportInput
}

/** Vehicle Incident API */
export type QueryRioReportsArgs = {
  input: RioReportsInput
}

/** Vehicle Incident API */
export type QueryRioTempAttachmentDownloadUrlArgs = {
  input: RioTempAttachmentDownloadUrlInput
}

/** Vehicle Incident API */
export type QueryRioTemplateSelectionArgs = {
  input: RioTemplateSelectionInput
}

/** Vehicle Incident API */
export type QueryRoadBlockageByIdArgs = {
  roadBlockageId: Scalars['ID']['input']
  serviceAreaId: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryRoadBlockagesArgs = {
  reportStatuses?: InputMaybe<Array<RoadBlockageReportStatus>>
  serviceAreaId: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryRoadSegmentSuggestionArgs = {
  location: LocationInput
  segmentId?: InputMaybe<Scalars['String']['input']>
  serviceAreaId?: InputMaybe<Scalars['ID']['input']>
}

/** Vehicle Incident API */
export type QueryRoadSegmentSuggestionsInsidePolygonArgs = {
  completelyInside: Scalars['Boolean']['input']
  locations: Array<LocationInput>
  serviceAreaId?: InputMaybe<Scalars['ID']['input']>
}

/** Vehicle Incident API */
export type QueryRouteTimeDataForTripArgs = {
  tripId: Scalars['String']['input']
}

/** Vehicle Incident API */
export type QuerySafetyDriverAnnotationArgs = {
  id: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QuerySafetyDriverAnnotationsArgs = {
  limit?: Scalars['Int']['input']
  offset?: Scalars['Int']['input']
  sort?: InputMaybe<SafetyDriverSortInput>
}

/** Vehicle Incident API */
export type QuerySafetyDriverConfigOptionsByIdsArgs = {
  field: VnvBackofficeConfigOptionField
  ids: Array<Scalars['String']['input']>
}

/** Vehicle Incident API */
export type QuerySafetyDriverConfigSearchArgs = {
  field: VnvBackofficeConfigOptionField
  limit?: Scalars['Int']['input']
  query?: Scalars['String']['input']
}

/** Vehicle Incident API */
export type QuerySafetyDriverDashboardConfigOptionsByIdsArgs = {
  field: VnvBackofficeDashboardOptionField
  ids: Array<Scalars['String']['input']>
}

/** Vehicle Incident API */
export type QuerySafetyDriverDashboardConfigSearchArgs = {
  field: VnvBackofficeDashboardOptionField
  limit?: Scalars['Int']['input']
  query?: Scalars['String']['input']
}

/** Vehicle Incident API */
export type QuerySafetyDriverDbtUnassessedArgs = {
  filters: VnvBackofficeDashboardFilterInput
}

/** Vehicle Incident API */
export type QuerySafetyDriverDbtUnassessedSessionListArgs = {
  filters: VnvBackofficeDashboardFilterInput
  limit?: Scalars['Int']['input']
  offset?: Scalars['Int']['input']
  severity: VnvBackofficeAssessmentSeverity
}

/** Vehicle Incident API */
export type QuerySafetyDriverMedTriagesArgs = {
  filters: VnvBackofficeDashboardFilterInput
}

/** Vehicle Incident API */
export type QuerySafetyDriverPceAnalysisArgs = {
  filters: VnvBackofficeDashboardFilterInput
  limit?: Scalars['Int']['input']
  offset?: Scalars['Int']['input']
}

/** Vehicle Incident API */
export type QuerySafetyDriverSearchArgs = {
  filters: Array<SafetyDriverFilterInput>
  limit?: Scalars['Int']['input']
  offset?: Scalars['Int']['input']
  sort?: InputMaybe<SafetyDriverSortInput>
}

/** Vehicle Incident API */
export type QuerySavedRouteDetailsArgs = {
  routeId: Scalars['String']['input']
}

/** Vehicle Incident API */
export type QuerySavedRoutesArgs = {
  filter?: InputMaybe<SavedRouteFilterInput>
  metroId?: InputMaybe<Scalars['Int']['input']>
  tripType?: InputMaybe<TripType>
}

/** Vehicle Incident API */
export type QuerySavedTripsByVtrsArgs = {
  associatedVtrs: Array<Scalars['String']['input']>
}

/** Vehicle Incident API */
export type QuerySdsGuidanceOperatorSessionArgs = {
  vehicleId: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QuerySdsGuidanceSessionArgs = {
  vehicleId: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QuerySearchCustomersV2Args = {
  maxResults: Scalars['Int']['input']
  searchTerm: Scalars['String']['input']
  tenant: Scalars['String']['input']
}

/** Vehicle Incident API */
export type QuerySearchV3Args = {
  searchInput: SearchInput
  serviceAreaID: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QuerySegmentsForTripArgs = {
  tripId: Scalars['String']['input']
}

/** Vehicle Incident API */
export type QueryServiceAreaAnchorPointsArgs = {
  serviceAreaId: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryServiceAreaByIdArgs = {
  id: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryServiceBreakLocationAddressAutocompleteArgs = {
  input: ServiceBreakLocationAddressAutocompleteInput
}

/** Vehicle Incident API */
export type QueryServiceBreakLocationByIdArgs = {
  id: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryServiceBreakLocationHistoryArgs = {
  id: Scalars['ID']['input']
  limit?: InputMaybe<Scalars['Int']['input']>
}

/** Vehicle Incident API */
export type QueryServiceBreakLocationsArgs = {
  input: ServiceBreakLocationsInput
}

/** Vehicle Incident API */
export type QueryServiceClassConfigArgs = {
  serviceAreaId: Scalars['ID']['input']
  serviceClassId: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryShiftArgs = {
  shiftId: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryShiftCapacityPlanningFilesArgs = {
  capacityPlanningID: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryShiftHubReturnUtilizationArgs = {
  input: ShiftPlannedHubReturnUtilizationInput
}

/** Vehicle Incident API */
export type QueryShiftPlannedHubReturnSectionOptionsArgs = {
  shiftId: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryShiftStateArgs = {
  shiftId: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryShiftTypesArgs = {
  serviceAreaUUID: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryShiftsDemandSupplyArgs = {
  from: Scalars['DateTime']['input']
  serviceAreaId: Scalars['ID']['input']
  to: Scalars['DateTime']['input']
}

/** Vehicle Incident API */
export type QueryShiftsForEmployeeArgs = {
  employeeId: Scalars['ID']['input']
  from: Scalars['Date']['input']
  to: Scalars['Date']['input']
}

/** Vehicle Incident API */
export type QueryShiftsInRangeArgs = {
  input: ShiftsInRangeInput
}

/** Vehicle Incident API */
export type QueryShiftsSupplyArgs = {
  from: Scalars['DateTime']['input']
  hubId?: InputMaybe<Scalars['ID']['input']>
  serviceAreaId: Scalars['ID']['input']
  to: Scalars['DateTime']['input']
}

/** Vehicle Incident API */
export type QuerySimulatedVehicleByIdArgs = {
  id: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QuerySmsEventsArgs = {
  customerTenant: Scalars['String']['input']
  phoneNumber: Scalars['String']['input']
}

/** Vehicle Incident API */
export type QueryStopAnchorReachabilityArgs = {
  serviceAreaId: Scalars['ID']['input']
  stopId: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryStopByIdArgs = {
  serviceAreaId: Scalars['ID']['input']
  stopId: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryStopCountArgs = {
  serviceAreaID: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryStopFlagConfigArgs = {
  serviceAreaId: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryStopSuggestionArgs = {
  location: LocationInput
  serviceAreaId: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryStopValidationArgs = {
  serviceAreaId: Scalars['ID']['input']
  stopId: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryStopValidatorConfigsArgs = {
  serviceAreaId: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryStopsArgs = {
  insideServiceAreaOnly?: InputMaybe<Scalars['Boolean']['input']>
  serviceAreaId: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryStopsByIdsArgs = {
  ids: Array<Scalars['ID']['input']>
  serviceAreaID: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryTaskNotificationByIdArgs = {
  id: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryTaskNotificationsArgs = {
  assignedToMe?: InputMaybe<Scalars['Boolean']['input']>
  fleetId?: InputMaybe<Scalars['ID']['input']>
  pagination?: InputMaybe<PaginationInput>
  regionId?: InputMaybe<Scalars['ID']['input']>
  search?: InputMaybe<Scalars['String']['input']>
  serviceAreaUUID?: InputMaybe<Scalars['ID']['input']>
  sorting?: InputMaybe<Array<TaskNotificationSorting>>
  status?: InputMaybe<Array<TaskNotificationStatus>>
  types?: InputMaybe<Array<TaskNotificationType>>
  vehicleHubLocation?: InputMaybe<Array<Scalars['ID']['input']>>
}

/** Vehicle Incident API */
export type QueryTaxonomiesArgs = {
  metroId: Scalars['Int']['input']
}

/** Vehicle Incident API */
export type QueryTemporaryBackofficeSessionArgs = {
  id: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryTenantLegalDocumentsArgs = {
  tenant: Scalars['String']['input']
}

/** Vehicle Incident API */
export type QueryTripArgs = {
  tripId: Scalars['String']['input']
}

/** Vehicle Incident API */
export type QueryTripAnnotationAudioUrlArgs = {
  annotationId: Scalars['String']['input']
}

/** Vehicle Incident API */
export type QueryTripAnnotationsArgs = {
  tripId?: InputMaybe<Scalars['String']['input']>
  vtrId?: InputMaybe<Scalars['String']['input']>
}

/** Vehicle Incident API */
export type QueryTripByInvoiceIdArgs = {
  id: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryTripByPaymentIdArgs = {
  id: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryTripByPspTransactionIdArgs = {
  id: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryTripByTripIdArgs = {
  id: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryTripByTripNameArgs = {
  name: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryTripDetailsArgs = {
  tripId: Scalars['String']['input']
}

/** Vehicle Incident API */
export type QueryTripEventsForTripArgs = {
  tripId: Scalars['String']['input']
}

/** Vehicle Incident API */
export type QueryTripFeedbackArgs = {
  tripId: Scalars['String']['input']
}

/** Vehicle Incident API */
export type QueryTripGeneratorExpiredTemplatesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  metropolisId?: InputMaybe<Scalars['Int']['input']>
}

/** Vehicle Incident API */
export type QueryTripGeneratorSubscriptionArgs = {
  vin: Scalars['String']['input']
}

/** Vehicle Incident API */
export type QueryTripGeneratorTemplateArgs = {
  id: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryTripGeneratorTemplatesArgs = {
  fleetId?: InputMaybe<Scalars['String']['input']>
  metropolisId?: InputMaybe<Scalars['Int']['input']>
}

/** Vehicle Incident API */
export type QueryTripHistoryEntriesArgs = {
  customerId: Scalars['ID']['input']
  customerTenant: Scalars['String']['input']
}

/** Vehicle Incident API */
export type QueryTripProgressArgs = {
  vin: Scalars['String']['input']
}

/** Vehicle Incident API */
export type QueryTripReportFieldValuesArgs = {
  field: Scalars['String']['input']
}

/** Vehicle Incident API */
export type QueryTripReportsArgs = {
  from: Scalars['Int']['input']
  queryParams?: InputMaybe<TripReportQueryParamsInput>
  size: Scalars['Int']['input']
  sortAsc?: InputMaybe<Scalars['Boolean']['input']>
  sortBy?: InputMaybe<Scalars['String']['input']>
}

/** Vehicle Incident API */
export type QueryTripRidersArgs = {
  tripId: Scalars['String']['input']
}

/** Vehicle Incident API */
export type QueryTripRoutePolylineArgs = {
  vin: Scalars['String']['input']
}

/** Vehicle Incident API */
export type QueryTripsArgs = {
  filter?: InputMaybe<TripHistoryFilterInput>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
}

/** Vehicle Incident API */
export type QueryTripsWithDetailsArgs = {
  filter?: InputMaybe<TripDetailsFilterInput>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
}

/** Vehicle Incident API */
export type QueryTurnRestrictionByIdArgs = {
  serviceAreaId: Scalars['ID']['input']
  turnRestrictionId: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryTurnRestrictionsArgs = {
  serviceAreaId: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryUnassignedCdisBoxesArgs = {
  fleetVehicleId: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryVehicleByIdArgs = {
  id?: InputMaybe<Scalars['ID']['input']>
}

/** Vehicle Incident API */
export type QueryVehicleCapacityConfigsArgs = {
  operatorTenant: Scalars['String']['input']
}

/** Vehicle Incident API */
export type QueryVehicleChangesArgs = {
  input: VehicleChangesQueryInput
}

/** Vehicle Incident API */
export type QueryVehicleClustersArgs = {
  filter?: InputMaybe<VehicleStatusFilterInput>
  numClusters: Scalars['Int']['input']
}

/** Vehicle Incident API */
export type QueryVehicleDataOverrideHistoryArgs = {
  externalId: Scalars['String']['input']
  source: VehicleDataSource
}

/** Vehicle Incident API */
export type QueryVehicleDataOverrideSearchArgs = {
  filters: Array<VehicleDataOverrideFilterInput>
  limit?: Scalars['Int']['input']
  offset?: Scalars['Int']['input']
  onlyWithOverrides?: Scalars['Boolean']['input']
  sort?: InputMaybe<VehicleDataOverrideSortInput>
}

/** Vehicle Incident API */
export type QueryVehicleDetailsArgs = {
  disconnectThresholdSeconds?: InputMaybe<Scalars['Int']['input']>
  vins?: InputMaybe<Array<Scalars['String']['input']>>
}

/** Vehicle Incident API */
export type QueryVehicleHubArrivalsArgs = {
  hubID: Scalars['ID']['input']
  interval: DateTimeIntervalInput
}

/** Vehicle Incident API */
export type QueryVehicleIncidentsArgs = {
  severity?: InputMaybe<IncidentSeverity>
  vehicleId: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryVehicleInteractionsArgs = {
  vehicleInteractionsQueryInput: VehicleInteractionsQueryInput
}

/** Vehicle Incident API */
export type QueryVehicleListsByRegionArgs = {
  regionId: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryVehicleMileageDeltasArgs = {
  input: VehicleMileageDeltasInput
}

/** Vehicle Incident API */
export type QueryVehiclePlanTemplatesArgs = {
  operatorTenant: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryVehicleSearchArgs = {
  filter?: InputMaybe<VehicleStatusFilterInput>
  search: Scalars['String']['input']
}

/** Vehicle Incident API */
export type QueryVehicleStatusArgs = {
  disconnectThresholdSeconds?: InputMaybe<Scalars['Int']['input']>
  vin: Scalars['String']['input']
}

/** Vehicle Incident API */
export type QueryVehicleStatusTelemetryArgs = {
  vehicleId: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryVehicleStatusesArgs = {
  disconnectThresholdSeconds?: InputMaybe<Scalars['Int']['input']>
  filter?: InputMaybe<VehicleStatusFilterInput>
  vins?: InputMaybe<Array<Scalars['String']['input']>>
}

/** Vehicle Incident API */
export type QueryVehicleSummariesArgs = {
  filter?: InputMaybe<VehicleStatusFilterInput>
  vins?: InputMaybe<Array<Scalars['String']['input']>>
}

/** Vehicle Incident API */
export type QueryVehiclesByIDsArgs = {
  ids: Array<Scalars['ID']['input']>
}

/** Vehicle Incident API */
export type QueryVgaVersionArgs = {
  vehicleId: Scalars['ID']['input']
}

/** Vehicle Incident API */
export type QueryVicDoneProcessesArgs = {
  input: InspectionDoneProcessesSearch
}

/** Vehicle Incident API */
export type QueryVicDueProcessesArgs = {
  input: InspectionDueProcessesSearch
}

/** Vehicle Incident API */
export type QueryVtrDataArgs = {
  ticketNumber: Scalars['String']['input']
}

/** Vehicle Incident API */
export type QueryWorkOrderAutomationRuleArgs = {
  input: WorkOrderAutomationRuleInput
}

/** Vehicle Incident API */
export type QueryWorkOrderAutomationRulesArgs = {
  input: WorkOrderAutomationRulesInput
}

/** Vehicle Incident API */
export type QueryWorkOrdersByCurrentUserArgs = {
  input?: InputMaybe<WorkOrdersByCurrentUserInput>
}

/** Vehicle Incident API */
export type QueryWorkOrdersByRegionArgs = {
  input: WorkOrdersByRegionInput
}

export type RecurredAnnotation = {
  __typename?: 'RecurredAnnotation'
  annotation: TripAnnotation
  firstRecurrenceAtMs: Scalars['Float']['output']
  firstRecurrenceId: Scalars['String']['output']
  recurrenceCount: Scalars['Int']['output']
}

export type ReducedEmployee = {
  __typename?: 'ReducedEmployee'
  /** @deprecated Use the Employee field instead */
  employeeVehicleInteraction: EmployeeVehicleInteraction
  id: Scalars['ID']['output']
}

export type RefereeInfo = {
  __typename?: 'RefereeInfo'
  customerId: Scalars['String']['output']
  customerV2: CustomerV2
  /** The time when the referral was redeemed */
  redeemedOn: Scalars['DateTime']['output']
  referralStatus: ReferralStatus
  /** Information on the profile who referred the current customer */
  referredBy: Maybe<ReferrerInfo>
  /** The time when the reward was sent out */
  rewardSentOn: Maybe<Scalars['String']['output']>
}

export enum ReferralStatus {
  /** The reward requirements are fulfilled but the reward was not yet received */
  AwaitingReward = 'AWAITING_REWARD',
  /** The reward requirements were not fulfilled during the referral time-frame */
  Failed = 'FAILED',
  /** The reward was received */
  RewardReceived = 'REWARD_RECEIVED',
  /** The referral had been redeemed but the reward requirements are not yet fulfilled */
  Started = 'STARTED',
}

export type ReferrerInfo = {
  __typename?: 'ReferrerInfo'
  customerId: Scalars['String']['output']
  customerV2: CustomerV2
  /** Referral code of the customer */
  referralCode: Maybe<Scalars['String']['output']>
  /** Information on the profile who referred the current customer */
  referredBy: Maybe<ReferrerInfo>
}

export type Refund = {
  __typename?: 'Refund'
  /** The amount to be refunded, i.e. returned to the customer's account. */
  refundedAmount: Maybe<Money>
  /** The amount payed out to the customer's account. */
  settledAmount: Maybe<Money>
}

export type Region = {
  __typename?: 'Region'
  /** Bounding box of the region. */
  boundingBox: BoundingBox
  /** Unique identifier of the region as UUIDv4. */
  id: Scalars['String']['output']
  /** Whether the region follows left-hand traffic rules. */
  leftHandTraffic: Scalars['Boolean']['output']
  /** Mobileye map configured for AD coverage matching (if any), does not necessarily have to match the current map in use! */
  mobileyeMap: Maybe<MobileyeMap>
  /** Mobileye project associated with this region and used for coverage file import (if any). */
  mobileyeProject: Maybe<MobileyeProject>
  /** Human-readable name for display purposes. */
  name: Scalars['String']['output']
  /** Identifier of the tenant that operates this region. */
  operatorTenant: Scalars['String']['output']
  /** IANA time zone identifier for this region (e.g., "Europe/Berlin"). */
  timeZoneId: Scalars['String']['output']
}

export type RemoveAllowlistedPhoneNumberInput = {
  phoneNumber: Scalars['String']['input']
  tenant: Scalars['String']['input']
}

export type RemoveAllowlistedPhoneNumberResponse = {
  __typename?: 'RemoveAllowlistedPhoneNumberResponse'
  success: Scalars['Boolean']['output']
}

export type RequestCabinVideoStreamCredentials = {
  vehicleId: Scalars['String']['input']
}

export type RequestVehicleMediaStreamCredentialsInput = {
  vehicleId: Scalars['ID']['input']
}

export type RioAddress = {
  __typename?: 'RioAddress'
  address: Scalars['String']['output']
  location: Maybe<Location>
}

export type RioAddressAutocompleteInput = {
  language: RioLanguage
  regionId: Scalars['String']['input']
  searchTerm: Scalars['String']['input']
}

export type RioAddressAutocompleteResponse = {
  __typename?: 'RioAddressAutocompleteResponse'
  addressesOptions: Array<RioAddress>
}

export type RioAddressFromLocationInput = {
  language: RioLanguage
  latitude: Scalars['Float']['input']
  longitude: Scalars['Float']['input']
}

export type RioAddressFromLocationResponse = {
  __typename?: 'RioAddressFromLocationResponse'
  address: Scalars['String']['output']
}

export type RioAppPhotoUploadResponse = {
  __typename?: 'RioAppPhotoUploadResponse'
  reports: Maybe<Array<RioAppReportPhotoUpload>>
}

export type RioAppReportPhotoUpload = {
  __typename?: 'RioAppReportPhotoUpload'
  photos: Maybe<Array<RioPhoto>>
  reportId: Scalars['ID']['output']
  shortId: Scalars['ID']['output']
}

export type RioAttachment = {
  __typename?: 'RioAttachment'
  attachmentId: Scalars['ID']['output']
  attachmentType: Maybe<RioAttachmentType>
  fileName: Scalars['String']['output']
  photoCategory: Maybe<RioPhotoCategory>
  size: Scalars['Int']['output']
  uploadedAt: Scalars['DateTime']['output']
  uploadedBy: Maybe<RioUser>
}

export type RioAttachmentDownloadUrl = {
  __typename?: 'RioAttachmentDownloadUrl'
  attachmentId: Scalars['String']['output']
  thumbnailUrl: Maybe<Scalars['String']['output']>
  url: Scalars['String']['output']
}

export type RioAttachmentDownloadUrlInput = {
  attachmentIds: Array<Scalars['String']['input']>
  reportId: Scalars['ID']['input']
}

export type RioAttachmentDownloadUrlResponse = {
  __typename?: 'RioAttachmentDownloadUrlResponse'
  urls: Maybe<Array<RioAttachmentDownloadUrl>>
}

export enum RioAttachmentType {
  Document = 'Document',
  Image = 'Image',
  Video = 'Video',
}

export type RioAttachmentUploadUrl = {
  __typename?: 'RioAttachmentUploadUrl'
  attachmentId: Scalars['String']['output']
  url: Scalars['String']['output']
}

export type RioAttachmentUploadUrlInput = {
  category?: InputMaybe<RioCategory>
  fileName: Scalars['String']['input']
  fileSize: Scalars['Int']['input']
  photoCategory?: InputMaybe<RioPhotoCategory>
  reportId?: InputMaybe<Scalars['ID']['input']>
}

export type RioAttachmentUploadUrlResponse = {
  __typename?: 'RioAttachmentUploadUrlResponse'
  url: RioAttachmentUploadUrl
}

export enum RioCalculatedOutcomeValue {
  Fail = 'Fail',
  Pass = 'Pass',
}

export enum RioCategory {
  Accident = 'Accident',
  DamageReport = 'DamageReport',
  Disruption = 'Disruption',
  NonAdVehicleChecks = 'NonAdVehicleChecks',
  VehicleChecks = 'VehicleChecks',
}

export type RioComponent = {
  componentId: Scalars['String']['output']
  componentType: RioComponentType
  dependingComponentIds: Maybe<Array<Scalars['String']['output']>>
  domainIdentifier: Maybe<RioDomainIdentifier>
  label: RioLabel
}

export type RioComponentCheckbox = RioComponent & {
  __typename?: 'RioComponentCheckbox'
  checkboxLabel: Maybe<RioLabel>
  componentId: Scalars['String']['output']
  componentType: RioComponentType
  dependingComponentIds: Maybe<Array<Scalars['String']['output']>>
  description: Maybe<RioLabel>
  domainIdentifier: Maybe<RioDomainIdentifier>
  falseLabel: RioLabel
  label: RioLabel
  overrideFailValue: Maybe<Scalars['Boolean']['output']>
  topDivider: Maybe<Scalars['Boolean']['output']>
  trueLabel: RioLabel
  viewLabel: Maybe<RioLabel>
}

export type RioComponentCheckboxInput = {
  checkboxLabel?: InputMaybe<RioLabelInput>
  componentId: Scalars['String']['input']
  componentToDomainEventMapping?: InputMaybe<RioDomainIdentifier>
  dependingComponentIds?: InputMaybe<Array<Scalars['String']['input']>>
  description?: InputMaybe<RioLabelInput>
  falseLabel: RioLabelInput
  label: RioLabelInput
  overrideFailValue?: InputMaybe<Scalars['Boolean']['input']>
  topDivider?: InputMaybe<Scalars['Boolean']['input']>
  trueLabel: RioLabelInput
  viewLabel?: InputMaybe<RioLabelInput>
}

export type RioComponentDate = RioComponent & {
  __typename?: 'RioComponentDate'
  allowFutureDates: Maybe<Scalars['Boolean']['output']>
  componentId: Scalars['String']['output']
  componentType: RioComponentType
  dependingComponentIds: Maybe<Array<Scalars['String']['output']>>
  domainIdentifier: Maybe<RioDomainIdentifier>
  label: RioLabel
}

export type RioComponentDateInput = {
  allowFutureDates?: InputMaybe<Scalars['Boolean']['input']>
  componentId: Scalars['String']['input']
  componentToDomainEventMapping?: InputMaybe<RioDomainIdentifier>
  dependingComponentIds?: InputMaybe<Array<Scalars['String']['input']>>
  label: RioLabelInput
}

export type RioComponentDateTime = RioComponent & {
  __typename?: 'RioComponentDateTime'
  allowFutureDates: Maybe<Scalars['Boolean']['output']>
  componentId: Scalars['String']['output']
  componentType: RioComponentType
  context: Maybe<RioDateTimeContext>
  dependingComponentIds: Maybe<Array<Scalars['String']['output']>>
  domainIdentifier: Maybe<RioDomainIdentifier>
  label: RioLabel
}

export type RioComponentDateTimeInput = {
  allowFutureDates?: InputMaybe<Scalars['Boolean']['input']>
  componentId: Scalars['String']['input']
  componentToDomainEventMapping?: InputMaybe<RioDomainIdentifier>
  context?: InputMaybe<RioDateTimeContext>
  dependingComponentIds?: InputMaybe<Array<Scalars['String']['input']>>
  label: RioLabelInput
}

export type RioComponentExpirationTime = RioComponent & {
  __typename?: 'RioComponentExpirationTime'
  componentId: Scalars['String']['output']
  componentType: RioComponentType
  dependingComponentIds: Maybe<Array<Scalars['String']['output']>>
  domainIdentifier: Maybe<RioDomainIdentifier>
  expiresInHours: Scalars['Int']['output']
  label: RioLabel
}

export type RioComponentExpirationTimeInput = {
  componentId: Scalars['String']['input']
  dependingComponentIds?: InputMaybe<Array<Scalars['String']['input']>>
  expiresInHours: Scalars['Int']['input']
  label: RioLabelInput
}

export type RioComponentExternalLink = RioComponent & {
  __typename?: 'RioComponentExternalLink'
  componentId: Scalars['String']['output']
  componentType: RioComponentType
  dependingComponentIds: Maybe<Array<Scalars['String']['output']>>
  domainIdentifier: Maybe<RioDomainIdentifier>
  fallbackLinkText: RioLabel
  label: RioLabel
  placeholder: Maybe<RioLabel>
}

export type RioComponentExternalLinkInput = {
  componentId: Scalars['String']['input']
  dependingComponentIds?: InputMaybe<Array<Scalars['String']['input']>>
  fallbackLinkText: RioLabelInput
  label: RioLabelInput
  placeholder?: InputMaybe<RioLabelInput>
}

export type RioComponentGeolocation = RioComponent & {
  __typename?: 'RioComponentGeolocation'
  componentId: Scalars['String']['output']
  componentType: RioComponentType
  dependingComponentIds: Maybe<Array<Scalars['String']['output']>>
  domainIdentifier: Maybe<RioDomainIdentifier>
  label: RioLabel
  latitudeLabel: Maybe<RioLabel>
  latitudeTooltipLabel: Maybe<RioLabel>
  longitudeLabel: Maybe<RioLabel>
  longitudeTooltipLabel: Maybe<RioLabel>
  viewLabel: Maybe<RioLabel>
}

export type RioComponentGeolocationInput = {
  componentId: Scalars['String']['input']
  componentToDomainEventMapping?: InputMaybe<RioDomainIdentifier>
  dependingComponentIds?: InputMaybe<Array<Scalars['String']['input']>>
  label: RioLabelInput
  latitudeLabel?: InputMaybe<RioLabelInput>
  latitudeTooltipLabel?: InputMaybe<RioLabelInput>
  longitudeLabel?: InputMaybe<RioLabelInput>
  longitudeTooltipLabel?: InputMaybe<RioLabelInput>
  viewLabel?: InputMaybe<RioLabelInput>
}

export type RioComponentOptions = RioComponent & {
  __typename?: 'RioComponentOptions'
  componentId: Scalars['String']['output']
  componentType: RioComponentType
  dependingComponentIds: Maybe<Array<Scalars['String']['output']>>
  domainIdentifier: Maybe<RioDomainIdentifier>
  label: RioLabel
  multiValue: Maybe<Scalars['Boolean']['output']>
  options: Array<RioOptionValue>
}

export type RioComponentOptionsInput = {
  componentId: Scalars['String']['input']
  componentToDomainEventMapping?: InputMaybe<RioDomainIdentifier>
  dependingComponentIds?: InputMaybe<Array<Scalars['String']['input']>>
  label: RioLabelInput
  multiValue?: InputMaybe<Scalars['Boolean']['input']>
  options: Array<RioOptionValueInput>
}

export type RioComponentPassFail = RioComponent & {
  __typename?: 'RioComponentPassFail'
  componentId: Scalars['String']['output']
  componentType: RioComponentType
  dependingComponentIds: Maybe<Array<Scalars['String']['output']>>
  description: Maybe<RioLabel>
  domainIdentifier: Maybe<RioDomainIdentifier>
  failLabel: RioLabel
  label: RioLabel
  passFailValues: RioPassFailValues
  passLabel: RioLabel
  preselectedValue: Maybe<RioPassFailValue>
  topDivider: Maybe<Scalars['Boolean']['output']>
  viewLabel: Maybe<RioLabel>
}

export type RioComponentPassFailInput = {
  componentId: Scalars['String']['input']
  componentToDomainEventMapping?: InputMaybe<RioDomainIdentifier>
  dependingComponentIds?: InputMaybe<Array<Scalars['String']['input']>>
  description?: InputMaybe<RioLabelInput>
  failLabel: RioLabelInput
  label: RioLabelInput
  passFailValues: RioPassFailValuesInput
  passLabel: RioLabelInput
  preselectedValue?: InputMaybe<RioPassFailValue>
  topDivider?: InputMaybe<Scalars['Boolean']['input']>
  viewLabel?: InputMaybe<RioLabelInput>
}

export type RioComponentRadioButtonGroup = RioComponent & {
  __typename?: 'RioComponentRadioButtonGroup'
  componentId: Scalars['String']['output']
  componentType: RioComponentType
  dependingComponentIds: Maybe<Array<Scalars['String']['output']>>
  domainIdentifier: Maybe<RioDomainIdentifier>
  label: RioLabel
  radioButtons: Array<RioRadioButton>
}

export type RioComponentRadioButtonGroupInput = {
  componentId: Scalars['String']['input']
  componentToDomainEventMapping?: InputMaybe<RioDomainIdentifier>
  dependingComponentIds?: InputMaybe<Array<Scalars['String']['input']>>
  label: RioLabelInput
  radioButtons: Array<RioRadioButtonInput>
}

export type RioComponentSimple = RioComponent & {
  __typename?: 'RioComponentSimple'
  componentId: Scalars['String']['output']
  componentType: RioComponentType
  dependingComponentIds: Maybe<Array<Scalars['String']['output']>>
  domainIdentifier: Maybe<RioDomainIdentifier>
  label: RioLabel
  placeholder: Maybe<RioLabel>
}

export type RioComponentSimpleInput = {
  componentId: Scalars['String']['input']
  componentToDomainEventMapping?: InputMaybe<RioDomainIdentifier>
  componentType: RioComponentType
  dependingComponentIds?: InputMaybe<Array<Scalars['String']['input']>>
  label: RioLabelInput
  placeholder?: InputMaybe<RioLabelInput>
}

export type RioComponentStaticValue = RioComponent & {
  __typename?: 'RioComponentStaticValue'
  componentId: Scalars['String']['output']
  componentType: RioComponentType
  dependingComponentIds: Maybe<Array<Scalars['String']['output']>>
  domainIdentifier: Maybe<RioDomainIdentifier>
  label: RioLabel
  staticValue: RioStaticValue
}

export type RioComponentStaticValueInput = {
  componentId: Scalars['String']['input']
  componentToDomainEventMapping?: InputMaybe<RioDomainIdentifier>
  dependingComponentIds?: InputMaybe<Array<Scalars['String']['input']>>
  label: RioLabelInput
  staticValue: RioStaticValue
}

export type RioComponentStatus = RioComponent & {
  __typename?: 'RioComponentStatus'
  componentId: Scalars['String']['output']
  componentType: RioComponentType
  dependingComponentIds: Maybe<Array<Scalars['String']['output']>>
  domainIdentifier: Maybe<RioDomainIdentifier>
  label: RioLabel
  statusOptions: Array<RioStatusOptions>
}

export type RioComponentStatusInput = {
  componentId: Scalars['String']['input']
  dependingComponentIds?: InputMaybe<Array<Scalars['String']['input']>>
  label: RioLabelInput
  statusOptions: Array<RioStatusOptions>
}

export type RioComponentTextArea = RioComponent & {
  __typename?: 'RioComponentTextArea'
  caption: Maybe<RioLabel>
  componentId: Scalars['String']['output']
  componentType: RioComponentType
  dependingComponentIds: Maybe<Array<Scalars['String']['output']>>
  domainIdentifier: Maybe<RioDomainIdentifier>
  label: RioLabel
  placeholder: Maybe<RioLabel>
}

export type RioComponentTextAreaInput = {
  caption?: InputMaybe<RioLabelInput>
  componentId: Scalars['String']['input']
  componentToDomainEventMapping?: InputMaybe<RioDomainIdentifier>
  dependingComponentIds?: InputMaybe<Array<Scalars['String']['input']>>
  label: RioLabelInput
  placeholder?: InputMaybe<RioLabelInput>
}

export type RioComponentTroublemaker = RioComponent & {
  __typename?: 'RioComponentTroublemaker'
  componentId: Scalars['String']['output']
  componentType: RioComponentType
  dependingComponentIds: Maybe<Array<Scalars['String']['output']>>
  domainIdentifier: Maybe<RioDomainIdentifier>
  label: RioLabel
  troublemakerOptions: Array<RioTroublemakerOptions>
}

export type RioComponentTroublemakerInput = {
  componentId: Scalars['String']['input']
  componentToDomainEventMapping?: InputMaybe<RioDomainIdentifier>
  dependingComponentIds?: InputMaybe<Array<Scalars['String']['input']>>
  label: RioLabelInput
  troublemakerOptions: Array<RioTroublemakerOptions>
}

export enum RioComponentType {
  Address = 'Address',
  Assignee = 'Assignee',
  Author = 'Author',
  CalculatedOutcome = 'CalculatedOutcome',
  Checkbox = 'Checkbox',
  Counter = 'Counter',
  CreationContext = 'CreationContext',
  CreationTime = 'CreationTime',
  Date = 'Date',
  DateTime = 'DateTime',
  DeleteAttachments = 'DeleteAttachments',
  Duration = 'Duration',
  Employee = 'Employee',
  EmployeeLastName = 'EmployeeLastName',
  EmployeeUuid = 'EmployeeUuid',
  ExpirationTime = 'ExpirationTime',
  ExternalLink = 'ExternalLink',
  FleetId = 'FleetId',
  FleetName = 'FleetName',
  Geolocation = 'Geolocation',
  HubUuid = 'HubUuid',
  NhtsaSeverity = 'NhtsaSeverity',
  Options = 'Options',
  PassFail = 'PassFail',
  RadioButtonGroup = 'RadioButtonGroup',
  Region = 'Region',
  ReportId = 'ReportId',
  StaticText = 'StaticText',
  StaticValue = 'StaticValue',
  Status = 'Status',
  Text = 'Text',
  TextArea = 'TextArea',
  Time = 'Time',
  Trip = 'Trip',
  Troublemaker = 'Troublemaker',
  UploadAttachments = 'UploadAttachments',
  Vehicle = 'Vehicle',
  VehicleAvKitVersion = 'VehicleAvKitVersion',
  VehicleBattery = 'VehicleBattery',
  VehicleCabinSafety = 'VehicleCabinSafety',
  VehicleHubName = 'VehicleHubName',
  VehicleLicensePlate = 'VehicleLicensePlate',
  VehicleMapVersion = 'VehicleMapVersion',
  VehicleMileage = 'VehicleMileage',
  VehicleMissionControl = 'VehicleMissionControl',
  VehicleOperatorInteraction = 'VehicleOperatorInteraction',
  VehicleSdsAutonomousVehicle = 'VehicleSdsAutonomousVehicle',
  VehicleSdsConnectivity = 'VehicleSdsConnectivity',
  VehicleType = 'VehicleType',
  VehicleUuid = 'VehicleUuid',
  VehicleVin = 'VehicleVin',
  ZendeskTicketNumber = 'ZendeskTicketNumber',
}

export type RioComponentsInput = {
  checkbox?: InputMaybe<Array<RioComponentCheckboxInput>>
  date?: InputMaybe<Array<RioComponentDateInput>>
  dateTime?: InputMaybe<Array<RioComponentDateTimeInput>>
  expirationTime?: InputMaybe<Array<RioComponentExpirationTimeInput>>
  externalLink?: InputMaybe<Array<RioComponentExternalLinkInput>>
  geolocation?: InputMaybe<RioComponentGeolocationInput>
  options?: InputMaybe<Array<RioComponentOptionsInput>>
  passFail?: InputMaybe<Array<RioComponentPassFailInput>>
  radioButtonGroup?: InputMaybe<Array<RioComponentRadioButtonGroupInput>>
  simple?: InputMaybe<Array<RioComponentSimpleInput>>
  staticValue?: InputMaybe<Array<RioComponentStaticValueInput>>
  status?: InputMaybe<RioComponentStatusInput>
  textArea?: InputMaybe<Array<RioComponentTextAreaInput>>
  troublemaker?: InputMaybe<RioComponentTroublemakerInput>
}

export type RioDateRange = {
  from: Scalars['DateTime']['input']
  to: Scalars['DateTime']['input']
}

export enum RioDateTimeContext {
  DurationEnd = 'DurationEnd',
  DurationStart = 'DurationStart',
}

export type RioDeleteReportInput = {
  reportId: Scalars['ID']['input']
  version: Scalars['Int']['input']
}

export type RioDeleteReportResponse = {
  __typename?: 'RioDeleteReportResponse'
  success: Scalars['Boolean']['output']
}

export enum RioDomainIdentifier {
  AKitCoolingSystem = 'AKitCoolingSystem',
  AccidentTime = 'AccidentTime',
  AdModeActive = 'AdModeActive',
  AirbagDeployed = 'AirbagDeployed',
  Cause = 'Cause',
  Charging = 'Charging',
  CheckType = 'CheckType',
  Context = 'Context',
  D9Drive = 'D9Drive',
  D9HardDrivesErased = 'D9HardDrivesErased',
  DamageSeverity = 'DamageSeverity',
  DamagedParts = 'DamagedParts',
  DashCam = 'DashCam',
  DisruptionDescription = 'DisruptionDescription',
  DisruptionDuration = 'DisruptionDuration',
  DisruptionEnd = 'DisruptionEnd',
  DisruptionStart = 'DisruptionStart',
  DisruptionType = 'DisruptionType',
  DocumentsEquipment = 'DocumentsEquipment',
  Doors = 'Doors',
  Equipment = 'Equipment',
  ExteriorBodyPanels = 'ExteriorBodyPanels',
  ExteriorDamage = 'ExteriorDamage',
  ExteriorLights = 'ExteriorLights',
  FailedNonAdVehicleCheckAnswers = 'FailedNonAdVehicleCheckAnswers',
  Fatalities = 'Fatalities',
  Fault = 'Fault',
  FireExtinguisher = 'FireExtinguisher',
  Fluids = 'Fluids',
  Fuses = 'Fuses',
  GinLogger = 'GinLogger',
  GinLoggerDoorClosed = 'GinLoggerDoorClosed',
  Horn = 'Horn',
  HvacSystem = 'HvacSystem',
  InfluenceOfIntoxicants = 'InfluenceOfIntoxicants',
  Intercom = 'Intercom',
  InteriorDamage = 'InteriorDamage',
  InteriorLighting = 'InteriorLighting',
  InvolvedBicycles = 'InvolvedBicycles',
  InvolvedBuses = 'InvolvedBuses',
  InvolvedMotorcycles = 'InvolvedMotorcycles',
  InvolvedPassengerCars = 'InvolvedPassengerCars',
  InvolvedPedestrians = 'InvolvedPedestrians',
  InvolvedTrucks = 'InvolvedTrucks',
  Keys = 'Keys',
  MinorInjuries = 'MinorInjuries',
  Outcome = 'Outcome',
  OverallCleanliness = 'OverallCleanliness',
  Paperwork = 'Paperwork',
  ParkingBrake = 'ParkingBrake',
  PassengerCompartmentReadiness = 'PassengerCompartmentReadiness',
  PassengerUsbPort = 'PassengerUsbPort',
  Resolution = 'Resolution',
  RoadCondition = 'RoadCondition',
  SafetyDriverTablet = 'SafetyDriverTablet',
  Screens = 'Screens',
  Seatbelts = 'Seatbelts',
  Seating = 'Seating',
  Sensors = 'Sensors',
  SeriousInjuries = 'SeriousInjuries',
  ServiceCancelled = 'ServiceCancelled',
  ServiceImpact = 'ServiceImpact',
  ShiftId = 'ShiftId',
  Situation = 'Situation',
  SoftwareVersionMatch = 'SoftwareVersionMatch',
  TestDriveSuccessful = 'TestDriveSuccessful',
  TirePressure = 'TirePressure',
  TiresRims = 'TiresRims',
  TowingNecessary = 'TowingNecessary',
  TwelveVBattery = 'TwelveVBattery',
  TypeOfDamages = 'TypeOfDamages',
  VehicleFluidsSufficient = 'VehicleFluidsSufficient',
  VehicleReadiness = 'VehicleReadiness',
  VisibleDamage = 'VisibleDamage',
  WasherSprayWipers = 'WasherSprayWipers',
  WeatherAndLightConditions = 'WeatherAndLightConditions',
  Windows = 'Windows',
}

export type RioExportReportInput = {
  language: RioLanguage
  reportId: Scalars['ID']['input']
}

export type RioExportReportResponse = {
  __typename?: 'RioExportReportResponse'
  url: Scalars['String']['output']
}

export type RioFilterConfig = {
  __typename?: 'RioFilterConfig'
  label: RioLabel
  value: Scalars['String']['output']
}

export type RioFilterConfigInput = {
  label: RioLabelInput
  value: Scalars['String']['input']
}

export type RioLabel = {
  __typename?: 'RioLabel'
  de: Maybe<Scalars['String']['output']>
  en: Maybe<Scalars['String']['output']>
}

export type RioLabelInput = {
  de?: InputMaybe<Scalars['String']['input']>
  en?: InputMaybe<Scalars['String']['input']>
}

export enum RioLanguage {
  De = 'de',
  En = 'en',
}

export type RioLatestTemplateInput = {
  category: RioCategory
  name: Scalars['String']['input']
  tenant: Scalars['String']['input']
}

export type RioLatestTemplateResponse = {
  __typename?: 'RioLatestTemplateResponse'
  template: Maybe<RioTemplate>
}

export type RioListViewColumnMapping = {
  __typename?: 'RioListViewColumnMapping'
  columnSize: Scalars['Int']['output']
  columnType: RioListViewColumnType
  componentIdLink: Maybe<Array<Scalars['String']['output']>>
  componentIdValue: Maybe<Array<Scalars['String']['output']>>
  initialSortColumn: Maybe<SortOrder>
  label: RioLabel
  reportAttribute: Maybe<Scalars['String']['output']>
}

export type RioListViewColumnMappingInput = {
  columnSize: Scalars['Int']['input']
  columnType: RioListViewColumnType
  componentIdLink?: InputMaybe<Array<Scalars['String']['input']>>
  componentIdValue?: InputMaybe<Array<Scalars['String']['input']>>
  initialSortColumn?: InputMaybe<SortOrder>
  label: RioLabelInput
  reportAttribute?: InputMaybe<Scalars['String']['input']>
}

export enum RioListViewColumnType {
  Attachment = 'Attachment',
  Author = 'Author',
  Boolean = 'Boolean',
  DateTime = 'DateTime',
  Disruption = 'Disruption',
  Duration = 'Duration',
  Employee = 'Employee',
  NhtsaSeverity = 'NhtsaSeverity',
  Options = 'Options',
  RadioButtonGroup = 'RadioButtonGroup',
  ShortId = 'ShortId',
  Situation = 'Situation',
  Status = 'Status',
  Trips = 'Trips',
  Troublemaker = 'Troublemaker',
  Vehicle = 'Vehicle',
  VehicleCheckOutcome = 'VehicleCheckOutcome',
  VehicleCheckType = 'VehicleCheckType',
  ZendeskTicket = 'ZendeskTicket',
}

export type RioListViewConfig = {
  __typename?: 'RioListViewConfig'
  category: RioCategory
  columns: Array<RioListViewColumnMapping>
  filters: Array<RioListViewFilter>
  tenant: Scalars['String']['output']
}

export type RioListViewFilter = {
  __typename?: 'RioListViewFilter'
  componentType: RioComponentType
  /** Narrows the filter to the components carrying this domain identifier. */
  domainIdentifier: Maybe<RioDomainIdentifier>
  filterConfigs: Maybe<Array<RioFilterConfig>>
  label: RioLabel
  showSelectedLabel: Maybe<Scalars['Boolean']['output']>
}

export type RioListViewFilterInput = {
  componentType: RioComponentType
  /** Narrows the filter to the components carrying this domain identifier. */
  domainIdentifier?: InputMaybe<RioDomainIdentifier>
  filterConfigs?: InputMaybe<Array<RioFilterConfigInput>>
  label: RioLabelInput
  showSelectedLabel?: InputMaybe<Scalars['Boolean']['input']>
}

export type RioOptionValue = {
  __typename?: 'RioOptionValue'
  label: RioLabel
  value: Scalars['String']['output']
}

export type RioOptionValueInput = {
  label: RioLabelInput
  value: Scalars['String']['input']
}

export enum RioPassFailValue {
  Fail = 'Fail',
  FailAKitCoolingSystem = 'FailAKitCoolingSystem',
  FailCharging = 'FailCharging',
  FailD9Drive = 'FailD9Drive',
  FailD9HardDrives = 'FailD9HardDrives',
  FailDashCam = 'FailDashCam',
  FailDataPrivacySigns = 'FailDataPrivacySigns',
  FailDocumentFolders = 'FailDocumentFolders',
  FailDoors = 'FailDoors',
  FailEquipment = 'FailEquipment',
  FailExterior = 'FailExterior',
  FailExteriorBodyPanels = 'FailExteriorBodyPanels',
  FailExteriorLights = 'FailExteriorLights',
  FailFireExtinguisher = 'FailFireExtinguisher',
  FailFluids = 'FailFluids',
  FailFuses = 'FailFuses',
  FailGinLogger = 'FailGinLogger',
  FailGinLoggerDoorClosed = 'FailGinLoggerDoorClosed',
  FailHorn = 'FailHorn',
  FailHvacSystem = 'FailHvacSystem',
  FailIntercom = 'FailIntercom',
  FailInterior = 'FailInterior',
  FailInteriorLighting = 'FailInteriorLighting',
  FailKeys = 'FailKeys',
  FailOverallCleanliness = 'FailOverallCleanliness',
  FailPaperwork = 'FailPaperwork',
  FailParkingBrake = 'FailParkingBrake',
  FailPassengerUsbPort = 'FailPassengerUsbPort',
  FailSafetyDriverTablet = 'FailSafetyDriverTablet',
  FailScreens = 'FailScreens',
  FailSeatbelts = 'FailSeatbelts',
  FailSeating = 'FailSeating',
  FailSensors = 'FailSensors',
  FailSoftwareVersionMatch = 'FailSoftwareVersionMatch',
  FailTirePressure = 'FailTirePressure',
  FailTiresRims = 'FailTiresRims',
  FailTwelveVBattery = 'FailTwelveVBattery',
  FailVehicleReadiness = 'FailVehicleReadiness',
  FailWasherSprayWipers = 'FailWasherSprayWipers',
  FailWindows = 'FailWindows',
  Pass = 'Pass',
  PassAKitCoolingSystem = 'PassAKitCoolingSystem',
  PassCharging = 'PassCharging',
  PassD9Drive = 'PassD9Drive',
  PassD9HardDrives = 'PassD9HardDrives',
  PassDashCam = 'PassDashCam',
  PassDataPrivacySigns = 'PassDataPrivacySigns',
  PassDocumentFolders = 'PassDocumentFolders',
  PassDoors = 'PassDoors',
  PassEquipment = 'PassEquipment',
  PassExterior = 'PassExterior',
  PassExteriorBodyPanels = 'PassExteriorBodyPanels',
  PassExteriorLights = 'PassExteriorLights',
  PassFireExtinguisher = 'PassFireExtinguisher',
  PassFluids = 'PassFluids',
  PassFuses = 'PassFuses',
  PassGinLogger = 'PassGinLogger',
  PassGinLoggerDoorClosed = 'PassGinLoggerDoorClosed',
  PassHorn = 'PassHorn',
  PassHvacSystem = 'PassHvacSystem',
  PassIntercom = 'PassIntercom',
  PassInterior = 'PassInterior',
  PassInteriorLighting = 'PassInteriorLighting',
  PassKeys = 'PassKeys',
  PassOverallCleanliness = 'PassOverallCleanliness',
  PassPaperwork = 'PassPaperwork',
  PassParkingBrake = 'PassParkingBrake',
  PassPassengerUsbPort = 'PassPassengerUsbPort',
  PassSafetyDriverTablet = 'PassSafetyDriverTablet',
  PassScreens = 'PassScreens',
  PassSeatbelts = 'PassSeatbelts',
  PassSeating = 'PassSeating',
  PassSensors = 'PassSensors',
  PassSoftwareVersionMatch = 'PassSoftwareVersionMatch',
  PassTirePressure = 'PassTirePressure',
  PassTiresRims = 'PassTiresRims',
  PassTwelveVBattery = 'PassTwelveVBattery',
  PassVehicleReadiness = 'PassVehicleReadiness',
  PassWasherSprayWipers = 'PassWasherSprayWipers',
  PassWindows = 'PassWindows',
}

export type RioPassFailValues = {
  __typename?: 'RioPassFailValues'
  fail: RioPassFailValue
  pass: RioPassFailValue
}

export type RioPassFailValuesInput = {
  fail: RioPassFailValue
  pass: RioPassFailValue
}

export type RioPhoto = {
  __typename?: 'RioPhoto'
  attachmentId: Scalars['String']['output']
  photoCategory: RioPhotoCategory
}

export enum RioPhotoCategory {
  AccidentSurroundings = 'AccidentSurroundings',
  OpponentVehicleDamage = 'OpponentVehicleDamage',
  PoliceCaseNumber = 'PoliceCaseNumber',
  VehicleDamage = 'VehicleDamage',
}

export type RioRadioButton = {
  __typename?: 'RioRadioButton'
  label: RioLabel
  value: Scalars['String']['output']
  viewLabel: RioLabel
}

export type RioRadioButtonInput = {
  label: RioLabelInput
  value: Scalars['String']['input']
  viewLabel: RioLabelInput
}

/** A report-io report, resolved by the report-io subgraph. */
export type RioReport = {
  __typename?: 'RioReport'
  assignee: Maybe<BackofficeUser>
  attachments: Maybe<Array<RioAttachment>>
  initialVersionCreatedAt: Scalars['DateTime']['output']
  initialVersionCreatedBy: RioUser
  region: Region
  reportId: Scalars['ID']['output']
  shortId: Scalars['ID']['output']
  template: RioTemplate
  values: Array<RioValue>
  version: Scalars['Int']['output']
  versionCreatedAt: Scalars['DateTime']['output']
  versionCreatedBy: RioUser
}

export type RioReportHistoryLogEntry = {
  __typename?: 'RioReportHistoryLogEntry'
  attachmentsAdded: Maybe<Scalars['Int']['output']>
  attachmentsDeleted: Maybe<Scalars['Int']['output']>
  status: Maybe<RioStatusOptions>
  valuesChanged: Maybe<Array<RioValuesChanged>>
  versionCreatedAt: Scalars['DateTime']['output']
  versionCreatedBy: RioUser
}

export type RioReportInput = {
  reportId: Scalars['ID']['input']
}

export type RioReportResponse = {
  __typename?: 'RioReportResponse'
  historyLog: Maybe<Array<RioReportHistoryLogEntry>>
  report: RioReport
}

export type RioReportsFilter = {
  componentType: RioComponentType
  /** Narrows the filter to the components carrying this domain identifier. */
  domainIdentifier?: InputMaybe<RioDomainIdentifier>
  values: Array<Scalars['String']['input']>
}

export type RioReportsInput = {
  category: RioCategory
  creationDateRange?: InputMaybe<RioDateRange>
  filters?: InputMaybe<Array<RioReportsFilter>>
  regionId: Scalars['String']['input']
  searchTerm?: InputMaybe<Scalars['String']['input']>
}

export type RioReportsResponse = {
  __typename?: 'RioReportsResponse'
  listViewConfig: Maybe<RioListViewConfig>
  reports: Maybe<Array<RioReport>>
  usedTemplates: Array<RioTemplate>
}

export type RioRule = {
  __typename?: 'RioRule'
  componentId: Maybe<Scalars['String']['output']>
  label: Maybe<RioLabel>
  otherComponentId: Maybe<Scalars['String']['output']>
  otherComponentValue: Maybe<Scalars['String']['output']>
  rule: RioRuleDefinition
  sectionId: Maybe<Scalars['String']['output']>
}

export enum RioRuleDefinition {
  Mandatory = 'Mandatory',
  MandatoryOnValue = 'MandatoryOnValue',
  VisibleOnValue = 'VisibleOnValue',
}

export type RioRuleInput = {
  componentId?: InputMaybe<Scalars['String']['input']>
  label?: InputMaybe<RioLabelInput>
  otherComponentId?: InputMaybe<Scalars['String']['input']>
  otherComponentValue?: InputMaybe<Scalars['String']['input']>
  rule: RioRuleDefinition
  sectionId?: InputMaybe<Scalars['String']['input']>
}

export type RioSection = {
  __typename?: 'RioSection'
  componentIds: Array<Scalars['String']['output']>
  label: Maybe<RioLabel>
  sectionId: Scalars['String']['output']
  width: Maybe<RioSectionWidth>
}

export type RioSectionInput = {
  componentIds: Array<Scalars['String']['input']>
  label: RioLabelInput
  sectionId: Scalars['String']['input']
  width?: InputMaybe<RioSectionWidth>
}

export enum RioSectionWidth {
  Full = 'Full',
  Half = 'Half',
}

export type RioSetReportStatusInput = {
  reportId: Scalars['ID']['input']
  status: RioStatusOptions
  version: Scalars['Int']['input']
}

export type RioSetReportStatusResponse = {
  __typename?: 'RioSetReportStatusResponse'
  reportId: Scalars['ID']['output']
  version: Scalars['Int']['output']
}

export type RioShareReportInput = {
  recipients: Array<Scalars['String']['input']>
  reportId: Scalars['ID']['input']
}

export type RioShareReportResponse = {
  __typename?: 'RioShareReportResponse'
  success: Scalars['Boolean']['output']
}

export enum RioStaticValue {
  Arrival = 'Arrival',
  Departure = 'Departure',
}

export enum RioStatusOptions {
  Acknowledged = 'Acknowledged',
  Blocked = 'Blocked',
  Closed = 'Closed',
  DriverPhotoUpload = 'DriverPhotoUpload',
  InProgress = 'InProgress',
  InRepair = 'InRepair',
  InReview = 'InReview',
  Intake = 'Intake',
  New = 'New',
  Open = 'Open',
  Pending = 'Pending',
}

export type RioStoreListViewConfigInput = {
  category: RioCategory
  columns: Array<RioListViewColumnMappingInput>
  filters: Array<RioListViewFilterInput>
  tenant: Scalars['String']['input']
}

export type RioStoreListViewConfigResponse = {
  __typename?: 'RioStoreListViewConfigResponse'
  config: Maybe<RioListViewConfig>
}

export type RioStoreReportInput = {
  regionId: Scalars['String']['input']
  reportId?: InputMaybe<Scalars['ID']['input']>
  shortId?: InputMaybe<Scalars['ID']['input']>
  templateId: Scalars['ID']['input']
  values: Array<RioValueInput>
  version?: InputMaybe<Scalars['Int']['input']>
}

export type RioStoreReportResponse = {
  __typename?: 'RioStoreReportResponse'
  reportId: Scalars['ID']['output']
  version: Scalars['Int']['output']
}

export type RioStoreTemplateInput = {
  category: RioCategory
  components: RioComponentsInput
  editReportTitle?: InputMaybe<RioLabelInput>
  editSections: Array<RioSectionInput>
  immutable?: InputMaybe<Scalars['Boolean']['input']>
  name: Scalars['String']['input']
  newReportTitle?: InputMaybe<RioLabelInput>
  overwrite?: InputMaybe<Scalars['Boolean']['input']>
  rules?: InputMaybe<Array<RioRuleInput>>
  /** @deprecated No longer used for access control */
  supportedFleets?: InputMaybe<Array<Scalars['String']['input']>>
  tenant: Scalars['String']['input']
  title?: InputMaybe<RioLabelInput>
  version: Scalars['Int']['input']
  viewReportTitle?: InputMaybe<RioLabelInput>
  viewSections: Array<RioSectionInput>
}

export type RioStoreTemplateResponse = {
  __typename?: 'RioStoreTemplateResponse'
  template: Maybe<RioTemplate>
}

export type RioTempAttachmentDownloadUrlInput = {
  attachmentId: Scalars['String']['input']
  category: RioCategory
}

export type RioTempAttachmentDownloadUrlResponse = {
  __typename?: 'RioTempAttachmentDownloadUrlResponse'
  url: RioAttachmentDownloadUrl
}

export type RioTemplate = {
  __typename?: 'RioTemplate'
  category: RioCategory
  components: Array<RioComponent>
  editReportTitle: Maybe<RioLabel>
  editSections: Array<RioSection>
  id: Scalars['ID']['output']
  immutable: Maybe<Scalars['Boolean']['output']>
  name: Scalars['String']['output']
  newReportTitle: Maybe<RioLabel>
  rules: Maybe<Array<RioRule>>
  /** @deprecated No longer used for access control */
  supportedFleets: Maybe<Array<Scalars['String']['output']>>
  tenant: Scalars['String']['output']
  title: Maybe<RioLabel>
  version: Scalars['Int']['output']
  viewReportTitle: Maybe<RioLabel>
  viewSections: Array<RioSection>
}

export type RioTemplateSelectionInput = {
  categories?: InputMaybe<Array<RioCategory>>
  /** @deprecated Use categories instead */
  category?: InputMaybe<RioCategory>
  /** @deprecated No longer used for access control */
  fleetId?: InputMaybe<Scalars['String']['input']>
  tenant: Scalars['String']['input']
}

export type RioTemplateSelectionResponse = {
  __typename?: 'RioTemplateSelectionResponse'
  templates: Array<RioTemplate>
}

export enum RioTroublemakerOptions {
  Driver = 'Driver',
  External = 'External',
  Other = 'Other',
  Passenger = 'Passenger',
  Vehicle = 'Vehicle',
}

export type RioUser = {
  __typename?: 'RioUser'
  backofficeUser: Maybe<BackofficeUser>
  employee: Maybe<Employee>
}

export type RioValue = {
  __typename?: 'RioValue'
  componentId: Scalars['String']['output']
  value: Scalars['String']['output']
}

export type RioValueInput = {
  componentId: Scalars['String']['input']
  value: Scalars['String']['input']
}

export type RioValuesChanged = {
  __typename?: 'RioValuesChanged'
  componentId: Scalars['String']['output']
  newValue: Maybe<Scalars['String']['output']>
  oldValue: Maybe<Scalars['String']['output']>
}

export type RoadBlockage = {
  __typename?: 'RoadBlockage'
  created: Scalars['DateTime']['output']
  id: Scalars['ID']['output']
  isActive: Scalars['Boolean']['output']
  modified: Scalars['DateTime']['output']
  name: Scalars['String']['output']
  reason: RoadBlockageReason
  reportCount: Maybe<Scalars['Int']['output']>
  reportStatus: Maybe<RoadBlockageReportStatus>
  segments: Array<RoadSegment>
  status: RoadBlockageStatus
  validFrom: Maybe<Scalars['DateTime']['output']>
  validTo: Maybe<Scalars['DateTime']['output']>
}

export type RoadBlockageActivation = {
  __typename?: 'RoadBlockageActivation'
  id: Scalars['ID']['output']
  timeRange: TimeRange
}

export type RoadBlockageActivationInput = {
  roadBlockageId: Scalars['ID']['input']
  serviceAreaId: Scalars['ID']['input']
  timeRange: TimeRangeInput
}

export type RoadBlockageFilterInput = {
  reportStatus?: InputMaybe<Array<SearchRoadBlockageReportStatus>>
  status?: InputMaybe<Array<SearchRoadBlockageStatus>>
  type?: InputMaybe<Array<SearchRoadBlockageType>>
}

export type RoadBlockageInput = {
  activationTimeRange?: InputMaybe<TimeRangeInput>
  name: Scalars['String']['input']
  reason: RoadBlockageReason
  reportStatus?: InputMaybe<RoadBlockageReportStatus>
  segments: Array<RoadSegmentInput>
}

export enum RoadBlockageReason {
  Event = 'Event',
  KeepOutZone = 'KeepOutZone',
  LongTermConstructionSite = 'LongTermConstructionSite',
  MoiaOnly = 'MOIAOnly',
  ReportedByDriver = 'ReportedByDriver',
  ShortTermConstructionSite = 'ShortTermConstructionSite',
  StructuralChange = 'StructuralChange',
}

export enum RoadBlockageReportStatus {
  Confirmed = 'Confirmed',
  Invalid = 'Invalid',
  Reported = 'Reported',
}

export enum RoadBlockageStatus {
  Active = 'Active',
  Expired = 'Expired',
  Inactive = 'Inactive',
  Scheduled = 'Scheduled',
}

export type RoadBlockageTaskNotification = TaskNotification & {
  __typename?: 'RoadBlockageTaskNotification'
  actionType: TaskActionType
  assigned: Maybe<TaskStateChangeDetails>
  createdAt: Scalars['DateTime']['output']
  fleetId: Maybe<Scalars['ID']['output']>
  foreignId: Scalars['ID']['output']
  id: Scalars['ID']['output']
  note: Maybe<TaskNotificationNote>
  notificationType: TaskNotificationType
  pended: Maybe<TaskStateChangeDetails>
  regionId: Maybe<Scalars['ID']['output']>
  resolved: Maybe<TaskStateChangeDetails>
  roadBlockage: Maybe<RoadBlockage>
  serviceAreaId: Maybe<Scalars['String']['output']>
  serviceAreaUUID: Scalars['ID']['output']
  severity: TaskNotificationSeverity
  stateChanges: Array<TaskStateChangeDetails>
  status: TaskNotificationStatus
  version: Scalars['Int']['output']
}

export enum RoadCategory {
  Highway = 'HIGHWAY',
  LocalAccess = 'LOCAL_ACCESS',
  Main = 'MAIN',
  Residential = 'RESIDENTIAL',
  ResidentialMinor = 'RESIDENTIAL_MINOR',
}

export type RoadSegment = {
  __typename?: 'RoadSegment'
  direction: RoadSegmentDirection
  /** Contains a GeoJSON MultiLineString */
  geometry: Scalars['String']['output']
  hereSegmentId: Scalars['String']['output']
  /** Determines if the order of the segment's geometry is inverted */
  inverted: Maybe<Scalars['Boolean']['output']>
  name: Scalars['String']['output']
}

/** Direction of travel applicable for a segment going from the lower left node (lower latitude, or if equal then lower longitude, or if equal then lower z-level) towards the other node. */
export enum RoadSegmentDirection {
  Backward = 'BACKWARD',
  Both = 'BOTH',
  Forward = 'FORWARD',
}

export type RoadSegmentInput = {
  direction: RoadSegmentDirection
  /** Contains a GeoJSON MultiLineString */
  geometry: Scalars['String']['input']
  hereSegmentId: Scalars['String']['input']
  /** Determines if the order of the segment's geometry is inverted */
  inverted?: InputMaybe<Scalars['Boolean']['input']>
  name: Scalars['String']['input']
}

export type RoadSegmentSuggestion = {
  __typename?: 'RoadSegmentSuggestion'
  /** Connections are only available in single segment suggestion queries and only one level deep */
  connections: Array<RoadSegmentSuggestion>
  direction: RoadSegmentDirection
  geometry: Scalars['String']['output']
  /** Determines if the order of the segment's geometry is inverted */
  inverted: Scalars['Boolean']['output']
  name: Scalars['String']['output']
  segmentId: Scalars['String']['output']
}

export enum Role {
  Draft = 'DRAFT',
  Driver = 'DRIVER',
  FieldTester = 'FIELD_TESTER',
  VehicleService = 'VEHICLE_SERVICE',
}

export type RouteBuilderValidationResult = {
  __typename?: 'RouteBuilderValidationResult'
  routeViolations: Array<RouteViolation>
  segments: Array<TripSegment>
}

export type RouteInput = {
  routeCoordinates: Array<GeolocationInput>
}

export type RoutePolyline = {
  __typename?: 'RoutePolyline'
  coordinates: Array<RoutePolylineCoordinate>
  segmentId: Scalars['String']['output']
  sequenceId: Scalars['Int']['output']
}

export type RoutePolylineCoordinate = {
  __typename?: 'RoutePolylineCoordinate'
  latitude: Scalars['Float']['output']
  longitude: Scalars['Float']['output']
}

export type RouteRequirementInput = {
  elementType: TripOddElementType
  metroId: Scalars['Int']['input']
  totalEncounterCount: Scalars['Int']['input']
  uniqueElementCount: Scalars['Int']['input']
}

export type RouteViolation = {
  __typename?: 'RouteViolation'
  coordinatesCount: Scalars['Int']['output']
  geolocation: Array<TripGeolocation>
  legIndex: Scalars['Int']['output']
  startIndex: Scalars['Int']['output']
  violationType: RouteViolationType
}

export enum RouteViolationType {
  ViolationTypeBlockedRoadUsed = 'VIOLATION_TYPE_BLOCKED_ROAD_USED',
  ViolationTypeForbiddenTurnUsed = 'VIOLATION_TYPE_FORBIDDEN_TURN_USED',
  ViolationTypeIntermediateLocalZoneUsed = 'VIOLATION_TYPE_INTERMEDIATE_LOCAL_ZONE_USED',
  ViolationTypeInvalid = 'VIOLATION_TYPE_INVALID',
  ViolationTypeRoadForbiddenForVehicleConfigurationUsed = 'VIOLATION_TYPE_ROAD_FORBIDDEN_FOR_VEHICLE_CONFIGURATION_USED',
  ViolationTypeTimeDependentRestrictionViolated = 'VIOLATION_TYPE_TIME_DEPENDENT_RESTRICTION_VIOLATED',
  ViolationTypeTurnForbiddenForVehicleConfigurationUsed = 'VIOLATION_TYPE_TURN_FORBIDDEN_FOR_VEHICLE_CONFIGURATION_USED',
  ViolationTypeWrongDirectionAtDestination = 'VIOLATION_TYPE_WRONG_DIRECTION_AT_DESTINATION',
  ViolationTypeWrongDirectionAtOrigin = 'VIOLATION_TYPE_WRONG_DIRECTION_AT_ORIGIN',
}

export type RouteWithElements = {
  __typename?: 'RouteWithElements'
  oddElements: Array<OddElement>
  routeCoordinates: Array<Geolocation>
}

export type Router = {
  __typename?: 'Router'
  macAddr: Scalars['String']['output']
  provisioningState: ProvisioningState
  serialNumber: Scalars['ID']['output']
}

export type RouterReplacedChange = FleetEntityChange & {
  __typename?: 'RouterReplacedChange'
  backofficeUser: Maybe<BackofficeUser>
  changedAt: Scalars['DateTime']['output']
  changes: RouterReplacedChangeFields
}

export type RouterReplacedChangeFields = VehicleChangeFields & {
  __typename?: 'RouterReplacedChangeFields'
  routerNew: Maybe<Router>
  routerOld: Maybe<Router>
  vehicleID: Scalars['ID']['output']
}

/** Input for an SDS guidance decision */
export type SdsGuidanceDecisionInput = {
  /** A maneuver decision (exactly one of maneuver or other must be set) */
  maneuver?: InputMaybe<SdsGuidanceManeuver>
  /** A custom decision (exactly one of maneuver or other must be set) */
  other?: InputMaybe<SdsGuidanceManeuverOtherInput>
}

/** Available standard maneuver decisions */
export enum SdsGuidanceManeuver {
  BypassFromLeft = 'BYPASS_FROM_LEFT',
  BypassFromRight = 'BYPASS_FROM_RIGHT',
  Wait = 'WAIT',
}

/** Input for a custom maneuver decision */
export type SdsGuidanceManeuverOtherInput = {
  /** The id of the custom maneuver */
  id: Scalars['ID']['input']
}

/** An issue tracked in an SDS guidance operator session. */
export type SdsGuidanceOperatorIssue = {
  __typename?: 'SDSGuidanceOperatorIssue'
  issueId: Scalars['ID']['output']
  maneuverOptions: SdsGuidanceSessionManeuverOptions
  sessionStatus: SdsGuidanceSessionStatus
  sessionStatusReason: Maybe<SdsGuidanceSessionStatusReason>
  situationType: SdsGuidanceSessionSituationType
}

/** The current SDS guidance operator session for a vehicle. */
export type SdsGuidanceOperatorSession = {
  __typename?: 'SDSGuidanceOperatorSession'
  createdAt: Maybe<Scalars['String']['output']>
  issues: Array<SdsGuidanceOperatorIssue>
  openIssue: Maybe<SdsGuidanceOperatorIssue>
  updatedAt: Maybe<Scalars['String']['output']>
  vehicleId: Scalars['ID']['output']
}

/** Raw operator status reported for an SDS guidance session. */
export enum SdsGuidanceOperatorStatus {
  OperatorStatusClosedBySystem = 'OPERATOR_STATUS_CLOSED_BY_SYSTEM',
  OperatorStatusInvalid = 'OPERATOR_STATUS_INVALID',
  OperatorStatusInSession = 'OPERATOR_STATUS_IN_SESSION',
  OperatorStatusPending = 'OPERATOR_STATUS_PENDING',
  OperatorStatusRaoClosed = 'OPERATOR_STATUS_RAO_CLOSED',
  OperatorStatusRequestSession = 'OPERATOR_STATUS_REQUEST_SESSION',
  OperatorStatusResolutionSubmitted = 'OPERATOR_STATUS_RESOLUTION_SUBMITTED',
}

/** The current raw SDS guidance session for a vehicle. */
export type SdsGuidanceSession = {
  __typename?: 'SDSGuidanceSession'
  issueId: Maybe<Scalars['ID']['output']>
  lastUpdatedAt: Scalars['String']['output']
  maneuverOptions: SdsGuidanceSessionManeuverOptions
  operatorStatus: Maybe<SdsGuidanceOperatorStatus>
  sessionId: Scalars['ID']['output']
  sessionStatus: SdsGuidanceSessionStatus
  sessionStatusReason: Maybe<SdsGuidanceSessionStatusReason>
  situationType: SdsGuidanceSessionSituationType
  vehicleId: Scalars['ID']['output']
}

/** A maneuver option in a raw SDS guidance session. */
export type SdsGuidanceSessionManeuverOption = {
  __typename?: 'SDSGuidanceSessionManeuverOption'
  description: Maybe<Scalars['String']['output']>
  maneuverId: Scalars['ID']['output']
  maneuverType: SdsGuidanceSessionManeuverType
}

/** Available maneuver options in a raw SDS guidance session. */
export type SdsGuidanceSessionManeuverOptions = {
  __typename?: 'SDSGuidanceSessionManeuverOptions'
  maneuvers: Array<SdsGuidanceSessionManeuverOption>
}

/** Raw maneuver type reported by SDS for a guidance session. */
export enum SdsGuidanceSessionManeuverType {
  CrossTheLine = 'CROSS_THE_LINE',
  DontBlock = 'DONT_BLOCK',
  Go = 'GO',
  HazardBlink = 'HAZARD_BLINK',
  Invalid = 'INVALID',
  LeftBlink = 'LEFT_BLINK',
  NotObstacle = 'NOT_OBSTACLE',
  NoBlink = 'NO_BLINK',
  OvertakeFromLeft = 'OVERTAKE_FROM_LEFT',
  OvertakeFromRight = 'OVERTAKE_FROM_RIGHT',
  RightBlink = 'RIGHT_BLINK',
  Stop = 'STOP',
}

/** Raw situation type reported by SDS for a guidance session. */
export enum SdsGuidanceSessionSituationType {
  Invalid = 'INVALID',
  TqiDebugTeleop = 'TQI_DEBUG_TELEOP',
  TqiDontBlock = 'TQI_DONT_BLOCK',
  TqiObstacle = 'TQI_OBSTACLE',
  TqiOther = 'TQI_OTHER',
  TqiSolidLine = 'TQI_SOLID_LINE',
}

/** Raw lifecycle status of an SDS guidance session or issue. */
export enum SdsGuidanceSessionStatus {
  Closed = 'CLOSED',
  ClosedBySystem = 'CLOSED_BY_SYSTEM',
  Open = 'OPEN',
  OpenObserverSession = 'OPEN_OBSERVER_SESSION',
  ReceivedResolution = 'RECEIVED_RESOLUTION',
  ResolutionRejected = 'RESOLUTION_REJECTED',
  Resolved = 'RESOLVED',
  Unknown = 'UNKNOWN',
}

/** Raw reason associated with an SDS guidance session status. */
export enum SdsGuidanceSessionStatusReason {
  ChangeOfIssue = 'CHANGE_OF_ISSUE',
  IssueVanished = 'ISSUE_VANISHED',
  NewIssueAfterResolved = 'NEW_ISSUE_AFTER_RESOLVED',
  RejectedAlreadyPerforming = 'REJECTED_ALREADY_PERFORMING',
  RejectedInvalidIssue = 'REJECTED_INVALID_ISSUE',
  RejectedInvalidSession = 'REJECTED_INVALID_SESSION',
  SafetyDriverTakeover = 'SAFETY_DRIVER_TAKEOVER',
  SessionTimeout = 'SESSION_TIMEOUT',
  SessionUnhandled = 'SESSION_UNHANDLED',
  TeleopDuringRaSession = 'TELEOP_DURING_RA_SESSION',
  Unknown = 'UNKNOWN',
  VehicleGhosted = 'VEHICLE_GHOSTED',
}

export enum SdsMode {
  Disengaged = 'DISENGAGED',
  Engaged = 'ENGAGED',
  Fault = 'FAULT',
  InCalibration = 'IN_CALIBRATION',
  NotAuthorized = 'NOT_AUTHORIZED',
  Transportation = 'TRANSPORTATION',
}

export type SdsModeWithTimestamp = {
  __typename?: 'SDSModeWithTimestamp'
  sdsMode: SdsMode
  timestamp: Scalars['DateTime']['output']
}

export enum SdsProvider {
  Mobileye = 'MOBILEYE',
  None = 'NONE',
  Simulated = 'SIMULATED',
  Wayve = 'WAYVE',
}

/** Result of validating a route against SDS */
export type SdsValidationResult = {
  __typename?: 'SDSValidationResult'
  isValid: Scalars['Boolean']['output']
  map: Scalars['String']['output']
  routeSegments: Array<SdsValidationRouteSegment>
}

/** A segment of a route validated against SDS, indicating drivable status */
export type SdsValidationRouteSegment = {
  __typename?: 'SDSValidationRouteSegment'
  drivable: Scalars['Boolean']['output']
  endIndex: Scalars['Int']['output']
  length: Scalars['Float']['output']
  startIndex: Scalars['Int']['output']
}

export enum SafetyDriverAnnotationField {
  Annotation = 'ANNOTATION',
  AssessedOn = 'ASSESSED_ON',
  BucketConnection = 'BUCKET_CONNECTION',
  Category = 'CATEGORY',
  CatType = 'CAT_TYPE',
  City = 'CITY',
  Codriver = 'CODRIVER',
  Comment = 'COMMENT',
  CorrespondingFeatures = 'CORRESPONDING_FEATURES',
  CorrespondingScenario = 'CORRESPONDING_SCENARIO',
  CorrespondingTrigger = 'CORRESPONDING_TRIGGER',
  Country = 'COUNTRY',
  CreationDate = 'CREATION_DATE',
  Driver = 'DRIVER',
  EgoManoeuvre = 'EGO_MANOEUVRE',
  EnvironmentConditions = 'ENVIRONMENT_CONDITIONS',
  EventJiraTicket = 'EVENT_JIRA_TICKET',
  EventTags = 'EVENT_TAGS',
  FailedRequirements = 'FAILED_REQUIREMENTS',
  FullEventId = 'FULL_EVENT_ID',
  JiraIssue = 'JIRA_ISSUE',
  MapVersion = 'MAP_VERSION',
  Mission = 'MISSION',
  MissionSegment = 'MISSION_SEGMENT',
  ParameterSet = 'PARAMETER_SET',
  RcRoute = 'RC_ROUTE',
  RcRun = 'RC_RUN',
  RelevantOddElements = 'RELEVANT_ODD_ELEMENTS',
  ReqCategory_1 = 'REQ_CATEGORY_1',
  ReqCategory_2 = 'REQ_CATEGORY_2',
  ReqCategory_3 = 'REQ_CATEGORY_3',
  SdsProviderId = 'SDS_PROVIDER_ID',
  SessionId = 'SESSION_ID',
  SwRelease = 'SW_RELEASE',
  Testcase = 'TESTCASE',
  TestEnvironment = 'TEST_ENVIRONMENT',
  Timestamp = 'TIMESTAMP',
  TriageNotes = 'TRIAGE_NOTES',
  Vehicle = 'VEHICLE',
  VnvComment = 'VNV_COMMENT',
  VnvConfirmation = 'VNV_CONFIRMATION',
}

export enum SafetyDriverCondition {
  Contains = 'CONTAINS',
  EndsWith = 'ENDS_WITH',
  Equals = 'EQUALS',
  NotContains = 'NOT_CONTAINS',
  NotEndsWith = 'NOT_ENDS_WITH',
  NotStartsWith = 'NOT_STARTS_WITH',
  StartsWith = 'STARTS_WITH',
}

export type SafetyDriverFilterInput = {
  condition: SafetyDriverCondition
  field: SafetyDriverAnnotationField
  value: Scalars['String']['input']
}

export enum SafetyDriverForcePudoReason {
  SafetyDriverForcePudoReasonInvalid = 'SAFETY_DRIVER_FORCE_PUDO_REASON_INVALID',
  SafetyDriverForcePudoReasonNotReached = 'SAFETY_DRIVER_FORCE_PUDO_REASON_NOT_REACHED',
  SafetyDriverForcePudoReasonOther = 'SAFETY_DRIVER_FORCE_PUDO_REASON_OTHER',
  SafetyDriverForcePudoReasonRiderRequested = 'SAFETY_DRIVER_FORCE_PUDO_REASON_RIDER_REQUESTED',
}

export type SafetyDriverSortInput = {
  direction?: VnvBackofficeSortDirection
  field: SafetyDriverAnnotationField
}

export enum SafetyDriverTripConfirmationState {
  SafetyDriverTripConfirmationStateArrivedDropoff = 'SAFETY_DRIVER_TRIP_CONFIRMATION_STATE_ARRIVED_DROPOFF',
  SafetyDriverTripConfirmationStateArrivedPickup = 'SAFETY_DRIVER_TRIP_CONFIRMATION_STATE_ARRIVED_PICKUP',
  SafetyDriverTripConfirmationStateInvalid = 'SAFETY_DRIVER_TRIP_CONFIRMATION_STATE_INVALID',
}

/** Input for saving a campaign assignment. */
export type SaveFleetCampaignDetailInput = {
  /** Day types to include (defaults to all if omitted). */
  assignmentDays?: InputMaybe<Array<FleetCampaignDay>>
  /** Shifts to include (defaults to all if omitted). */
  assignmentShifts?: InputMaybe<Array<FleetCampaignShift>>
  /** Campaign to assign vehicles to. */
  campaignId?: InputMaybe<Scalars['ID']['input']>
  /** Number of vehicles to assign. */
  vehicleCount: Scalars['Int']['input']
}

export type SavedRoute = {
  __typename?: 'SavedRoute'
  assignedVtrs: Array<AssignedVtr>
  createdById: Scalars['String']['output']
  createdMs: Scalars['Float']['output']
  description: Scalars['String']['output']
  distance: Scalars['Float']['output']
  id: Scalars['String']['output']
  isArchived: Scalars['Boolean']['output']
  metroId: Scalars['Int']['output']
  name: Scalars['String']['output']
  tripType: TripType
  updatedById: Scalars['String']['output']
  updatedMs: Scalars['Float']['output']
}

export type SavedRouteDetails = {
  __typename?: 'SavedRouteDetails'
  assignedVtrs: Array<AssignedVtr>
  createdById: Scalars['String']['output']
  createdMs: Scalars['Float']['output']
  description: Scalars['String']['output']
  distance: Scalars['Float']['output']
  id: Scalars['String']['output']
  isArchived: Scalars['Boolean']['output']
  metroId: Scalars['Int']['output']
  name: Scalars['String']['output']
  trip: Maybe<TmpTrip>
  updatedById: Scalars['String']['output']
  updatedMs: Scalars['Float']['output']
}

export type SavedRouteFilterInput = {
  associatedVtrs?: InputMaybe<Array<Scalars['String']['input']>>
  codebeamerIds?: InputMaybe<Array<Scalars['String']['input']>>
  createdByIds?: InputMaybe<Array<Scalars['String']['input']>>
  metroIds?: InputMaybe<Array<Scalars['Int']['input']>>
}

export type SavedTripEntry = {
  __typename?: 'SavedTripEntry'
  assignedVtrs: Array<AssignedVtr>
  createdById: Scalars['String']['output']
  createdMs: Scalars['Float']['output']
  description: Scalars['String']['output']
  distance: Scalars['Float']['output']
  id: Scalars['String']['output']
  isArchived: Scalars['Boolean']['output']
  metroId: Scalars['Int']['output']
  name: Scalars['String']['output']
  trip: Maybe<TmpTrip>
  updatedById: Scalars['String']['output']
  updatedMs: Scalars['Float']['output']
}

export type SavedTripsByVtrEntry = {
  __typename?: 'SavedTripsByVtrEntry'
  savedTrips: Array<SavedTripEntry>
  vtr: Scalars['String']['output']
}

export type ScheduleVehicleStateChangeInput = {
  changeReasonFreeText?: InputMaybe<Scalars['String']['input']>
  /** Date and time when the vehicle is expected to be activated again, basically a downtime forecast. */
  expectedActivationAt?: InputMaybe<Scalars['DateTime']['input']>
  scheduledAt: Scalars['DateTime']['input']
  vehicleID: Scalars['ID']['input']
  vehicleStateChangeReason: VehicleStateChangeReason
}

export type ScheduleVehicleStateChangeResponse = {
  __typename?: 'ScheduleVehicleStateChangeResponse'
  scheduledVehicleStateChange: ScheduledVehicleStateChange
}

export type ScheduleVehicleStateDeletionResponse = {
  __typename?: 'ScheduleVehicleStateDeletionResponse'
  id: Maybe<Scalars['ID']['output']>
  vehicleID: Scalars['ID']['output']
}

export type ScheduledVehicleStateChange = {
  __typename?: 'ScheduledVehicleStateChange'
  id: Scalars['ID']['output']
  nextState: VehicleState
  scheduledAt: Scalars['DateTime']['output']
  updatedAt: Scalars['DateTime']['output']
  vehicle: Vehicle
  vehicleStateChange: VehicleStateChange
}

export type ScheduledVehicleStateChangeDeleteInput = {
  /** The ID of of the scheduled state change */
  id: Scalars['ID']['input']
}

export type ScopedAccessSessionPermissionsInput = {
  allFleets: Scalars['Boolean']['input']
  fleets: Array<Scalars['String']['input']>
  organizationId: Scalars['String']['input']
  timedGroups: Array<BackofficeUserTimeGroupInput>
  timedServiceAreas: Array<BackofficeUserTimeAreaInput>
}

export type SdgAcceptIncomingCallInput = {
  vehicleId: Scalars['ID']['input']
}

export type SdgDeclineIncomingCallInput = {
  vehicleId: Scalars['ID']['input']
}

export type SdgInitiateSafetyDriverToOperatorCallInput = {
  vehicleId: Scalars['ID']['input']
}

export type SdsRouteSegment = {
  __typename?: 'SdsRouteSegment'
  drivable: Scalars['Boolean']['output']
  endIndex: Scalars['Int']['output']
  length: Scalars['Float']['output']
  reason: ValidationFailureReason
  startIndex: Scalars['Int']['output']
}

export enum SearchAreaStatus {
  Active = 'Active',
  Expired = 'Expired',
  Inactive = 'Inactive',
  Scheduled = 'Scheduled',
}

export enum SearchAreaType {
  Ad = 'AD',
  ConstructionSite = 'ConstructionSite',
  Cooperation = 'Cooperation',
  Event = 'Event',
  Funding = 'Funding',
  Hub = 'Hub',
  InFieldBreak = 'InFieldBreak',
  Other = 'Other',
  Scouting = 'Scouting',
  ShortBreak = 'ShortBreak',
}

export type SearchCustomersResult = {
  __typename?: 'SearchCustomersResult'
  customers: Array<FoundCustomer>
  total: Scalars['Int']['output']
}

export enum SearchDirection {
  Backward = 'Backward',
  Both = 'Both',
  Forward = 'Forward',
}

export type SearchInput = {
  areas?: InputMaybe<AreaFilterInput>
  boundingBox?: InputMaybe<BoundingBoxFilterInput>
  polygon?: InputMaybe<Scalars['String']['input']>
  roadBlockages?: InputMaybe<RoadBlockageFilterInput>
  searchTerm?: InputMaybe<Scalars['String']['input']>
  stops?: InputMaybe<StopFilterInput>
  turnRestrictions?: InputMaybe<TurnRestrictionFilterInput>
}

export type SearchResultAreaItemV3 = SearchResultItemV3 & {
  __typename?: 'SearchResultAreaItemV3'
  areaType: Maybe<SearchAreaType>
  id: Scalars['ID']['output']
  keepOutZone: Scalars['Boolean']['output']
  name: Scalars['String']['output']
  polygon: Shape
  status: SearchResultItemStatusV3
}

export enum SearchResultItemStatusV3 {
  Active = 'Active',
  Expired = 'Expired',
  Inactive = 'Inactive',
  Scheduled = 'Scheduled',
}

export type SearchResultItemV3 = {
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
}

export type SearchResultRoadBlockageItemV3 = SearchResultItemV3 & {
  __typename?: 'SearchResultRoadBlockageItemV3'
  created: Scalars['DateTime']['output']
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  reportCount: Scalars['Int']['output']
  reportStatus: Maybe<SearchRoadBlockageReportStatus>
  roadBlockageType: Maybe<SearchRoadBlockageType>
  segments: Array<SearchRoadSegment>
  status: SearchResultItemStatusV3
  validFrom: Maybe<Scalars['DateTime']['output']>
  validTo: Maybe<Scalars['DateTime']['output']>
}

export type SearchResultStopItemV3 = SearchResultItemV3 & {
  __typename?: 'SearchResultStopItemV3'
  active: Scalars['Boolean']['output']
  customerDisplayLocation: Location
  excludeFromReallocations: Scalars['Boolean']['output']
  flags: Array<SearchStopFlag>
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  stopType: Maybe<SearchStopType>
}

export type SearchResultTurnRestrictionItemV3 = SearchResultItemV3 & {
  __typename?: 'SearchResultTurnRestrictionItemV3'
  created: Scalars['DateTime']['output']
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  segments: Array<SearchRoadSegment>
  status: SearchResultItemStatusV3
  turnRestrictionType: Maybe<SearchTurnRestrictionType>
  validFrom: Maybe<Scalars['DateTime']['output']>
  validTo: Maybe<Scalars['DateTime']['output']>
}

export type SearchResultV3 = {
  __typename?: 'SearchResultV3'
  items: Array<Maybe<SearchResultItemV3>>
}

export enum SearchRoadBlockageReportStatus {
  Confirmed = 'Confirmed',
  Invalid = 'Invalid',
  Reported = 'Reported',
}

export enum SearchRoadBlockageStatus {
  Active = 'Active',
  Expired = 'Expired',
  Inactive = 'Inactive',
  Scheduled = 'Scheduled',
}

export enum SearchRoadBlockageType {
  Event = 'Event',
  LongTermConstructionSite = 'LongTermConstructionSite',
  MoiaOnly = 'MOIAOnly',
  ReportedByDriver = 'ReportedByDriver',
  ShortTermConstructionSite = 'ShortTermConstructionSite',
  StructuralChange = 'StructuralChange',
}

export type SearchRoadSegment = {
  __typename?: 'SearchRoadSegment'
  direction: Maybe<SearchDirection>
  geometry: Scalars['String']['output']
  hereSegmentId: Scalars['String']['output']
  name: Scalars['String']['output']
}

export enum SearchStopFlag {
  Ad = 'AD',
  HumanDriver = 'HumanDriver',
  HvvSwitchStop = 'HvvSwitchStop',
  Partnership = 'Partnership',
  PhysicalPromotion = 'PhysicalPromotion',
  RegularPassengers = 'RegularPassengers',
  WheelchairAccessible = 'WheelchairAccessible',
}

export enum SearchStopStatus {
  Active = 'Active',
  Inactive = 'Inactive',
}

export enum SearchStopType {
  Hub = 'Hub',
  InFieldBreak = 'InFieldBreak',
  Passenger = 'Passenger',
  PublicTransportation = 'PublicTransportation',
  ShortBreak = 'ShortBreak',
}

export enum SearchTurnRestrictionStatus {
  Active = 'Active',
  Expired = 'Expired',
  Inactive = 'Inactive',
  Scheduled = 'Scheduled',
}

export enum SearchTurnRestrictionType {
  Event = 'Event',
  LongTermConstructionSite = 'LongTermConstructionSite',
  MoiaOnly = 'MOIAOnly',
  ShortTermConstructionSite = 'ShortTermConstructionSite',
  StructuralChange = 'StructuralChange',
}

export type Seat = {
  __typename?: 'Seat'
  occupancy: SeatOccupancy
  seatbelt: Seatbelt
  seatbeltWarning: Scalars['Boolean']['output']
}

export type SeatInfo = {
  __typename?: 'SeatInfo'
  childSeats: Maybe<Scalars['Int']['output']>
  seats: Maybe<Scalars['Int']['output']>
  wheelchairs: Maybe<Scalars['Int']['output']>
}

export type SeatInput = {
  occupancy?: InputMaybe<SeatOccupancy>
  seatbelt?: InputMaybe<Seatbelt>
  seatbeltWarning?: InputMaybe<Scalars['Boolean']['input']>
}

export enum SeatOccupancy {
  Empty = 'EMPTY',
  NotInstalled = 'NOT_INSTALLED',
  Occupied = 'OCCUPIED',
}

export enum Seatbelt {
  Fastened = 'FASTENED',
  NotAvailable = 'NOT_AVAILABLE',
  NotFastened = 'NOT_FASTENED',
  NotInstalled = 'NOT_INSTALLED',
}

export type Seats = {
  __typename?: 'Seats'
  cockpitLeft: Seat
  cockpitRight: Seat
  secondRowLeft: Seat
  secondRowMiddle: Seat
  secondRowRight: Seat
  thirdRowLeft: Seat
  thirdRowMiddle: Seat
  thirdRowRight: Seat
}

export type SeatsInput = {
  cockpitLeft?: InputMaybe<SeatInput>
  cockpitRight?: InputMaybe<SeatInput>
  secondRowLeft?: InputMaybe<SeatInput>
  secondRowMiddle?: InputMaybe<SeatInput>
  secondRowRight?: InputMaybe<SeatInput>
  thirdRowLeft?: InputMaybe<SeatInput>
  thirdRowMiddle?: InputMaybe<SeatInput>
  thirdRowRight?: InputMaybe<SeatInput>
}

export type SegmentMetric = {
  __typename?: 'SegmentMetric'
  arrivedTimeMs: Scalars['Float']['output']
  autoDurationSeconds: Scalars['Int']['output']
  autoPercentage: Scalars['Float']['output']
  completionStatus: TripCompletionStatus
  customerId: Scalars['String']['output']
  destinationAddress: Scalars['String']['output']
  endTimeMs: Scalars['Float']['output']
  numPassengers: Scalars['Int']['output']
  predictedDistanceMeters: Scalars['Float']['output']
  predictedEtaSeconds: Scalars['Int']['output']
  protected: Scalars['Boolean']['output']
  remoteGuidanceInProgressDurationSeconds: Scalars['Int']['output']
  remoteGuidanceInProgressRatio: Scalars['Float']['output']
  requestedDestination: Maybe<TripHistoryGeolocation>
  riders: Array<Scalars['String']['output']>
  route: Array<TripHistoryGeolocation>
  segmentId: Scalars['String']['output']
  segmentSubstatus: Scalars['String']['output']
  sequenceId: Scalars['Int']['output']
  snappedDestination: Maybe<TripHistoryGeolocation>
  startTimeMs: Scalars['Float']['output']
  tripId: Scalars['String']['output']
  updateTripReasons: Array<Scalars['String']['output']>
  vehicleInitialLocation: Maybe<TripHistoryGeolocation>
}

export enum SegmentSource {
  SegmentSourceAv = 'SEGMENT_SOURCE_AV',
  SegmentSourceClient = 'SEGMENT_SOURCE_CLIENT',
  SegmentSourceInvalid = 'SEGMENT_SOURCE_INVALID',
}

export enum SegmentStatus {
  SegmentStatusArrived = 'SEGMENT_STATUS_ARRIVED',
  SegmentStatusCancelled = 'SEGMENT_STATUS_CANCELLED',
  SegmentStatusCompleted = 'SEGMENT_STATUS_COMPLETED',
  SegmentStatusFailed = 'SEGMENT_STATUS_FAILED',
  SegmentStatusInvalid = 'SEGMENT_STATUS_INVALID',
  SegmentStatusInProgress = 'SEGMENT_STATUS_IN_PROGRESS',
  SegmentStatusNeedAssistance = 'SEGMENT_STATUS_NEED_ASSISTANCE',
  SegmentStatusNotStarted = 'SEGMENT_STATUS_NOT_STARTED',
  SegmentStatusQueued = 'SEGMENT_STATUS_QUEUED',
}

export enum SegmentSubstatus {
  SegmentSubstatusClientCancelled = 'SEGMENT_SUBSTATUS_CLIENT_CANCELLED',
  SegmentSubstatusDispatchFailed = 'SEGMENT_SUBSTATUS_DISPATCH_FAILED',
  SegmentSubstatusForcePudoCompleted = 'SEGMENT_SUBSTATUS_FORCE_PUDO_COMPLETED',
  SegmentSubstatusForcePudoInprogress = 'SEGMENT_SUBSTATUS_FORCE_PUDO_INPROGRESS',
  SegmentSubstatusHmiCancelled = 'SEGMENT_SUBSTATUS_HMI_CANCELLED',
  SegmentSubstatusInvalid = 'SEGMENT_SUBSTATUS_INVALID',
  SegmentSubstatusNone = 'SEGMENT_SUBSTATUS_NONE',
  SegmentSubstatusNoRouteAvailable = 'SEGMENT_SUBSTATUS_NO_ROUTE_AVAILABLE',
  SegmentSubstatusNoShowCancelled = 'SEGMENT_SUBSTATUS_NO_SHOW_CANCELLED',
  SegmentSubstatusPilotCancelled = 'SEGMENT_SUBSTATUS_PILOT_CANCELLED',
  SegmentSubstatusRtsCancelled = 'SEGMENT_SUBSTATUS_RTS_CANCELLED',
  SegmentSubstatusSdsCancelled = 'SEGMENT_SUBSTATUS_SDS_CANCELLED',
}

export type SendVehicleToHubLogRecord = ShiftStateLogRecord & {
  __typename?: 'SendVehicleToHubLogRecord'
  area: Maybe<Area>
  eventTime: Scalars['DateTime']['output']
  expectedTimeAtHub: Maybe<Scalars['DateTime']['output']>
  returnReason: SendVehicleToHubReturnReason
  serviceBreakLocation: Maybe<ServiceBreakLocation>
  shiftId: Maybe<Scalars['ID']['output']>
  type: ShiftStateLogRecordType
  vehicle: Maybe<Vehicle>
}

export enum SendVehicleToHubReturnReason {
  Break = 'BREAK',
  OnDemand = 'ON_DEMAND',
  ShiftEnd = 'SHIFT_END',
  ShortBreak = 'SHORT_BREAK',
}

export type ServiceArea = {
  __typename?: 'ServiceArea'
  /** Experimental field: Please don't rely on this to be present in the future */
  autonomousVehiclesOnly: Scalars['Boolean']['output']
  childAge: ChildAge
  created: Scalars['DateTime']['output']
  currency: CurrencyCode
  customerTenants: Array<Scalars['String']['output']>
  defaultLanguage: LanguageCode
  displayNames: Scalars['DisplayNames']['output']
  id: Scalars['String']['output']
  locationAttributes: LocationAttributes
  modified: Scalars['DateTime']['output']
  modifiedBy: Scalars['String']['output']
  operatingAreaId: Maybe<Scalars['String']['output']>
  operatorTenants: Array<Scalars['String']['output']>
  ridepoolingServiceTenant: Scalars['String']['output']
  serviceClasses: Array<ServiceClass>
  /**
   * Deprecated field: Please don't rely on this to be present in the future
   * @deprecated ServiceParameters is deprecated and will be removed in a future version.
   */
  serviceParameters: Maybe<ServiceParameters>
  tenants: Array<Scalars['String']['output']>
  useCaseType: UseCaseType
  uuid: Scalars['UUID']['output']
  validFrom: Scalars['DateTime']['output']
  vehicleOperationMode: Maybe<VehicleOperationMode>
}

export type ServiceAreaCreationInput = {
  childAge: ChildAgeInput
  currency: CurrencyCode
  customerTenants?: InputMaybe<Array<Scalars['String']['input']>>
  defaultLanguage: LanguageCode
  displayNames: Scalars['DisplayNames']['input']
  idSuffix?: InputMaybe<Scalars['String']['input']>
  locationAttributes: LocationAttributesCreationInput
  operatingAreaId: Scalars['String']['input']
  operatorTenants?: InputMaybe<Array<Scalars['String']['input']>>
  referenceId?: InputMaybe<Scalars['String']['input']>
  ridepoolingServiceTenant?: InputMaybe<Scalars['String']['input']>
  serviceClasses?: InputMaybe<Array<ServiceClassInput>>
  /**
   * Deprecated field: Please don't rely on this to be present in the future
   * @deprecated ServiceParameters is deprecated and will be removed in a future version.
   */
  serviceParameters?: InputMaybe<ServiceParametersInput>
  useCaseType: UseCaseType
  validFrom: Scalars['DateTime']['input']
  vehicleOperationMode?: InputMaybe<VehicleOperationMode>
}

export type ServiceAreaUpdateInput = {
  childAge: ChildAgeInput
  customerTenants?: InputMaybe<Array<Scalars['String']['input']>>
  displayNames: Scalars['DisplayNames']['input']
  locationAttributes: LocationAttributesUpdateInput
  operatingAreaId?: InputMaybe<Scalars['String']['input']>
  operatorTenants?: InputMaybe<Array<Scalars['String']['input']>>
  ridepoolingServiceTenant?: InputMaybe<Scalars['String']['input']>
  serviceClasses?: InputMaybe<Array<ServiceClassInput>>
  /**
   * Deprecated field: Please don't rely on this to be present in the future
   * @deprecated ServiceParameters is deprecated and will be removed in a future version.
   */
  serviceParameters?: InputMaybe<ServiceParametersInput>
  validFrom: Scalars['DateTime']['input']
}

export type ServiceBreakLocation = {
  __typename?: 'ServiceBreakLocation'
  address: Scalars['String']['output']
  addressCoordinates: Maybe<Location>
  available: Scalars['Boolean']['output']
  baseCapacity: ServiceBreakLocationBaseCapacity
  bookingSlots: Maybe<BookingTimeSlotsResponse>
  capabilities: ServiceBreakLocationCapabilities
  capacityOverrides: Array<ServiceBreakLocationCapacityOverride>
  capacitySchedule: Array<ServiceBreakLocationCapacityScheduleEntry>
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  polygon: Maybe<Scalars['String']['output']>
  region: Region
  routableLocation: Maybe<LocationWithHeading>
  state: ServiceBreakLocationState
  type: ServiceBreakLocationType
  version: Scalars['Int']['output']
}

export type ServiceBreakLocationBookingSlotsArgs = {
  end: Scalars['DateTime']['input']
  start: Scalars['DateTime']['input']
}

export type ServiceBreakLocationAddressAutocompleteInput = {
  language: ServiceBreakLocationLanguage
  regionId: Scalars['String']['input']
  searchTerm: Scalars['String']['input']
}

export type ServiceBreakLocationAddressAutocompleteResponse = {
  __typename?: 'ServiceBreakLocationAddressAutocompleteResponse'
  addressesOptions: Array<ServiceBreakLocationAddressOption>
}

export type ServiceBreakLocationAddressOption = {
  __typename?: 'ServiceBreakLocationAddressOption'
  address: Scalars['String']['output']
  location: Maybe<Location>
}

export type ServiceBreakLocationBaseCapacity = {
  __typename?: 'ServiceBreakLocationBaseCapacity'
  availableDcChargers: Scalars['Int']['output']
  concurrentBreaks: Scalars['Int']['output']
  maxDcChargers: Scalars['Int']['output']
}

export type ServiceBreakLocationCapabilities = {
  __typename?: 'ServiceBreakLocationCapabilities'
  ad: Scalars['Boolean']['output']
  break: Scalars['Boolean']['output']
  nonAd: Scalars['Boolean']['output']
  shortBreak: Scalars['Boolean']['output']
}

export type ServiceBreakLocationCapacity = {
  __typename?: 'ServiceBreakLocationCapacity'
  availableDcChargers: Scalars['Int']['output']
  concurrentBreaks: Scalars['Int']['output']
}

export type ServiceBreakLocationCapacityInput = {
  availableDcChargers: Scalars['Int']['input']
  concurrentBreaks: Scalars['Int']['input']
}

export type ServiceBreakLocationCapacityOverride = {
  __typename?: 'ServiceBreakLocationCapacityOverride'
  annuallyRecurring: Scalars['Boolean']['output']
  capacity: ServiceBreakLocationCapacity
  description: Maybe<Scalars['String']['output']>
  end: Maybe<Scalars['DateTime']['output']>
  id: Scalars['ID']['output']
  reason: ServiceBreakLocationCapacityOverrideReason
  start: Scalars['DateTime']['output']
  status: ServiceBreakLocationCapacityOverrideStatus
}

export enum ServiceBreakLocationCapacityOverrideReason {
  ConstructionSite = 'CONSTRUCTION_SITE',
  Event = 'EVENT',
  Other = 'OTHER',
}

export enum ServiceBreakLocationCapacityOverrideStatus {
  Ongoing = 'ONGOING',
  Planned = 'PLANNED',
}

export type ServiceBreakLocationCapacityScheduleEntry = {
  __typename?: 'ServiceBreakLocationCapacityScheduleEntry'
  capacity: ServiceBreakLocationCapacity
  endTime: Scalars['TimeOfDay']['output']
  startTime: Scalars['TimeOfDay']['output']
  weekday: DayOfWeek
}

export type ServiceBreakLocationCapacityScheduleEntryInput = {
  capacity: ServiceBreakLocationCapacityInput
  endTime: Scalars['TimeOfDay']['input']
  startTime: Scalars['TimeOfDay']['input']
  weekday: DayOfWeek
}

export type ServiceBreakLocationChangeStateInput = {
  newState: ServiceBreakLocationState
  serviceBreakLocationId: Scalars['ID']['input']
  version: Scalars['Int']['input']
}

export type ServiceBreakLocationChangeStateResponse = {
  __typename?: 'ServiceBreakLocationChangeStateResponse'
  serviceBreakLocation: ServiceBreakLocation
}

export type ServiceBreakLocationDeleteCapacityOverrideInput = {
  id: Scalars['ID']['input']
  serviceBreakLocationId: Scalars['ID']['input']
  version: Scalars['Int']['input']
}

export type ServiceBreakLocationDeleteCapacityOverrideResponse = {
  __typename?: 'ServiceBreakLocationDeleteCapacityOverrideResponse'
  serviceBreakLocation: ServiceBreakLocation
}

export type ServiceBreakLocationDeleteInput = {
  serviceBreakLocationId: Scalars['ID']['input']
  version: Scalars['Int']['input']
}

export type ServiceBreakLocationDeleteResponse = {
  __typename?: 'ServiceBreakLocationDeleteResponse'
  success: Scalars['Boolean']['output']
}

export type ServiceBreakLocationFilters = {
  states?: InputMaybe<Array<ServiceBreakLocationState>>
  types?: InputMaybe<Array<ServiceBreakLocationType>>
}

export type ServiceBreakLocationHistoryEntry = {
  __typename?: 'ServiceBreakLocationHistoryEntry'
  createdAt: Scalars['DateTime']['output']
  createdBy: Maybe<BackofficeUser>
  operationType: ServiceBreakLocationHistoryOperationType
}

export enum ServiceBreakLocationHistoryOperationType {
  Activated = 'ACTIVATED',
  Archived = 'ARCHIVED',
  BaseDataUpdated = 'BASE_DATA_UPDATED',
  CapacityScheduleUpdated = 'CAPACITY_SCHEDULE_UPDATED',
  Created = 'CREATED',
  RoutableLocationAdded = 'ROUTABLE_LOCATION_ADDED',
  RoutableLocationUpdated = 'ROUTABLE_LOCATION_UPDATED',
  UnavailabilityAdded = 'UNAVAILABILITY_ADDED',
  UnavailabilityDeleted = 'UNAVAILABILITY_DELETED',
  UnavailabilityUpdated = 'UNAVAILABILITY_UPDATED',
}

export enum ServiceBreakLocationLanguage {
  De = 'de',
  En = 'en',
}

export enum ServiceBreakLocationState {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
}

export type ServiceBreakLocationStoreBaseDataInput = {
  ad: Scalars['Boolean']['input']
  address: Scalars['String']['input']
  addressCoordinates?: InputMaybe<LocationInput>
  availableDcChargers: Scalars['Int']['input']
  break: Scalars['Boolean']['input']
  concurrentBreaks: Scalars['Int']['input']
  id?: InputMaybe<Scalars['ID']['input']>
  maxDcChargers: Scalars['Int']['input']
  name: Scalars['String']['input']
  nonAd: Scalars['Boolean']['input']
  regionId: Scalars['String']['input']
  shortBreak: Scalars['Boolean']['input']
  state: ServiceBreakLocationState
  type: ServiceBreakLocationType
  version?: InputMaybe<Scalars['Int']['input']>
}

export type ServiceBreakLocationStoreBaseDataResponse = {
  __typename?: 'ServiceBreakLocationStoreBaseDataResponse'
  serviceBreakLocation: ServiceBreakLocation
}

export type ServiceBreakLocationStoreCapacityOverrideInput = {
  annuallyRecurring: Scalars['Boolean']['input']
  availableDcChargers?: InputMaybe<Scalars['Int']['input']>
  concurrentBreaks?: InputMaybe<Scalars['Int']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  end?: InputMaybe<Scalars['DateTime']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  reason: ServiceBreakLocationCapacityOverrideReason
  serviceBreakLocationId: Scalars['ID']['input']
  start: Scalars['DateTime']['input']
  version: Scalars['Int']['input']
}

export type ServiceBreakLocationStoreCapacityOverrideResponse = {
  __typename?: 'ServiceBreakLocationStoreCapacityOverrideResponse'
  serviceBreakLocation: ServiceBreakLocation
}

export type ServiceBreakLocationStoreCapacityScheduleInput = {
  capacitySchedule: Array<ServiceBreakLocationCapacityScheduleEntryInput>
  serviceBreakLocationId: Scalars['ID']['input']
  version: Scalars['Int']['input']
}

export type ServiceBreakLocationStoreCapacityScheduleResponse = {
  __typename?: 'ServiceBreakLocationStoreCapacityScheduleResponse'
  serviceBreakLocation: ServiceBreakLocation
}

export enum ServiceBreakLocationType {
  Break = 'BREAK',
  Hub = 'HUB',
}

export type ServiceBreakLocationUpdateRoutableLocationAndPolygonInput = {
  polygon: Scalars['String']['input']
  routableLocation: LocationWithHeadingInput
  serviceBreakLocationId: Scalars['ID']['input']
  version: Scalars['Int']['input']
}

export type ServiceBreakLocationUpdateRoutableLocationAndPolygonResponse = {
  __typename?: 'ServiceBreakLocationUpdateRoutableLocationAndPolygonResponse'
  serviceBreakLocation: ServiceBreakLocation
}

export type ServiceBreakLocationUtilization = {
  __typename?: 'ServiceBreakLocationUtilization'
  serviceBreakLocation: ServiceBreakLocation
  utilization: Scalars['Int']['output']
}

export type ServiceBreakLocationsInput = {
  filters?: InputMaybe<ServiceBreakLocationFilters>
  regionId: Scalars['ID']['input']
  searchTerm?: InputMaybe<Scalars['String']['input']>
}

export type ServiceBreakLocationsResponse = {
  __typename?: 'ServiceBreakLocationsResponse'
  serviceBreakLocations: Array<ServiceBreakLocation>
}

export type ServiceClass = {
  __typename?: 'ServiceClass'
  created: Scalars['DateTime']['output']
  id: Scalars['String']['output']
  status: ServiceClassStatus
}

/** Service class configuration entity that can be referenced by other subgraphs */
export type ServiceClassConfig = {
  __typename?: 'ServiceClassConfig'
  /**
   * Upper bound on the allowed detour
   * If the value is `null`, there is no limit in place.
   */
  detourLimit: Maybe<Scalars['Duration']['output']>
  /**
   * Upper bound on the allowed detour (in percent) for given service area
   * If the value is `null`, there is no limit in place.
   */
  relativeDetourTime: Maybe<Scalars['Int']['output']>
  serviceAreaUuid: Scalars['UUID']['output']
  serviceClassId: Scalars['ID']['output']
  status: ServiceClassStatus
}

export type ServiceClassInput = {
  created: Scalars['DateTime']['input']
  id: Scalars['String']['input']
  status: ServiceClassStatus
}

export type ServiceClassParameters = {
  __typename?: 'ServiceClassParameters'
  maxPrice: Money
  maxPricePercentageOfTaxiPrice: Scalars['Float']['output']
  minPrice: Maybe<Money>
  offerPriceDiscount: Maybe<Scalars['Float']['output']>
  prebookingSurcharge: Surcharge
}

export type ServiceClassParametersInput = {
  maxPrice: MoneyInput
  maxPricePercentageOfTaxiPrice: Scalars['Float']['input']
  minPrice?: InputMaybe<MoneyInput>
  offerPriceDiscount?: InputMaybe<Scalars['Float']['input']>
  prebookingSurcharge: SurchargeInput
}

export enum ServiceClassStatus {
  ServiceClassStatusActive = 'SERVICE_CLASS_STATUS_ACTIVE',
  ServiceClassStatusInactive = 'SERVICE_CLASS_STATUS_INACTIVE',
  ServiceClassStatusUnspecified = 'SERVICE_CLASS_STATUS_UNSPECIFIED',
}

export type ServiceIntervalCreateInput = {
  vehicleId: Scalars['ID']['input']
  vehiclePlanActivityId: Scalars['ID']['input']
}

export type ServiceIntervalCreateResponse = {
  __typename?: 'ServiceIntervalCreateResponse'
  serviceIntervalId: Scalars['ID']['output']
}

/** Deprecated field: Please don't rely on this to be present in the future */
export type ServiceParameters = {
  __typename?: 'ServiceParameters'
  childSeats: Scalars['Int']['output']
  maxSeats: Scalars['Int']['output']
  wheelchairSeats: Scalars['Int']['output']
}

/** Deprecated field: Please don't rely on this to be present in the future */
export type ServiceParametersInput = {
  childSeats: Scalars['Int']['input']
  maxSeats: Scalars['Int']['input']
  wheelchairSeats: Scalars['Int']['input']
}

/**
 * A one-time code used to transfer an already-authenticated Admin Panel
 * session into a new Backoffice session, without entering credentials.
 */
export type SessionTransferTokenResponse = {
  __typename?: 'SessionTransferTokenResponse'
  cognitoUsername: Scalars['String']['output']
  token: Scalars['String']['output']
}

/** The accessibility flag for severely disabled customers */
export type SeverelyDisabled = {
  __typename?: 'SeverelyDisabled'
  /** Eligibility for another people */
  eligibility: Maybe<Eligibility>
  /** Validity of the severely disabled medical ID */
  validUntil: Maybe<Scalars['OffsetDateTime']['output']>
}

export enum SeverelyDisabledState {
  Companion = 'COMPANION',
  None = 'NONE',
  Self = 'SELF',
  SelfAndCompanion = 'SELF_AND_COMPANION',
}

export enum Severity {
  Disrupted = 'DISRUPTED',
  Down = 'DOWN',
  Notice = 'NOTICE',
}

export type Shape = Geometry & {
  __typename?: 'Shape'
  geoJson: Scalars['String']['output']
  points: Array<Location>
}

export type Shift = {
  __typename?: 'Shift'
  breaks: Array<ShiftBreak>
  driver: Maybe<Employee>
  employeeAbsenceKey: Maybe<EmployeeAbsenceKey>
  fixedSetupTimes: ShiftFixedSetupTimes
  /** @deprecated Use serviceBreakLocation instead */
  hub: Maybe<Hub>
  id: Scalars['ID']['output']
  /** Time this driver is expected to check-in for the shift start (includes fixed setup time for productive time) */
  plannedCheckIn: Scalars['DateTime']['output']
  /** Time this driver is expected to check-out the for shift end (includes fixed setup time for productive time) */
  plannedCheckOut: Scalars['DateTime']['output']
  /** Time this driver is expected to depart for the first drive */
  plannedFirstDeparture: Scalars['DateTime']['output']
  /** Time this driver is expected to arrive for the end of shift */
  plannedLastArrival: Scalars['DateTime']['output']
  /** returns the planned net working time for this shift (excluding planned break duration, excluding fixed setup time) */
  plannedNetWorkingTime: Scalars['Duration']['output']
  /** returns the planned net working time for this shift (excluding planned break duration, including fixed setup time) */
  plannedProductiveTime: Maybe<Scalars['Duration']['output']>
  serviceBreakLocation: Maybe<ServiceBreakLocation>
  shiftType: ShiftType
  shiftTypeOverrideDetails: Maybe<ShiftTypeOverrideDetails>
  state: ShiftState
}

export type ShiftBreak = {
  __typename?: 'ShiftBreak'
  duration: Scalars['Duration']['output']
  earliestStart: Scalars['DateTime']['output']
  latestEnd: Scalars['DateTime']['output']
  latestStart: Scalars['DateTime']['output']
}

export type ShiftCapacityPlanning = {
  __typename?: 'ShiftCapacityPlanning'
  createdAt: Scalars['DateTime']['output']
  createdBy: Maybe<BackofficeUser>
  /** The status of the execution of the capacity planning job in the backend */
  executionStatus: ShiftCapacityPlanningExecutionStatus
  id: Scalars['ID']['output']
  month: Scalars['YearMonth']['output']
  name: Scalars['String']['output']
  rmpIteration: Scalars['YearMonth']['output']
  shiftHours: Scalars['Int']['output']
  /** A user defined status of the capacity planning */
  status: ShiftCapacityPlanningStatus
}

export type ShiftCapacityPlanningCreateInput = {
  month: Scalars['YearMonth']['input']
  name: Scalars['String']['input']
  rmpFilename: Scalars['String']['input']
  shiftHours: Scalars['Int']['input']
}

export enum ShiftCapacityPlanningExecutionStatus {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Running = 'RUNNING',
  Succeeded = 'SUCCEEDED',
}

export type ShiftCapacityPlanningFile = {
  __typename?: 'ShiftCapacityPlanningFile'
  mimeType: Scalars['String']['output']
  name: Scalars['String']['output']
  /** The size of the file in bytes */
  size: Scalars['Int']['output']
  url: Scalars['String']['output']
}

export type ShiftCapacityPlanningRmpFile = {
  __typename?: 'ShiftCapacityPlanningRmpFile'
  fileName: Scalars['String']['output']
  lastModified: Scalars['DateTime']['output']
  /** The minimum year and month this RMP file can create a capacity planning for */
  minimumPlannableMonth: Scalars['YearMonth']['output']
  /** The year and month of the RMP iteration for this file */
  rmpIteration: Scalars['YearMonth']['output']
}

export enum ShiftCapacityPlanningStatus {
  Draft = 'DRAFT',
  Final = 'FINAL',
}

export type ShiftCapacityPlanningUpdateStatusInput = {
  id: Scalars['ID']['input']
  newStatus: ShiftCapacityPlanningStatus
}

export type ShiftChangedLogRecord = ShiftStateLogRecord & {
  __typename?: 'ShiftChangedLogRecord'
  eventTime: Scalars['DateTime']['output']
  logRecordNewShiftType: LogRecordShiftType
  logRecordOldShiftType: LogRecordShiftType
  shiftId: Maybe<Scalars['ID']['output']>
  type: ShiftStateLogRecordType
}

export type ShiftComment = {
  __typename?: 'ShiftComment'
  author: Maybe<Scalars['String']['output']>
  backofficeUser: Maybe<BackofficeUser>
  comment: Scalars['String']['output']
  updatedAt: Scalars['DateTime']['output']
}

export type ShiftCommentInput = {
  comment: Scalars['String']['input']
  shiftId: Scalars['ID']['input']
}

export type ShiftConfirmTaskNotificationInput = {
  foreignId: Scalars['ID']['input']
}

export type ShiftConfirmTaskNotificationResponse = {
  __typename?: 'ShiftConfirmTaskNotificationResponse'
  confirmed: Scalars['Boolean']['output']
  foreignId: Scalars['ID']['output']
}

export type ShiftDeletePlannedHubReturnSectionInput = {
  section: ShiftPlannedHubReturnSectionCategory
  shiftId: Scalars['ID']['input']
}

export type ShiftDeletePlannedHubReturnSectionResponse = {
  __typename?: 'ShiftDeletePlannedHubReturnSectionResponse'
  planned: Array<ShiftPlannedHubReturnSection>
}

export type ShiftDeviationNotification = TaskNotification & {
  __typename?: 'ShiftDeviationNotification'
  actionType: TaskActionType
  assigned: Maybe<TaskStateChangeDetails>
  createdAt: Scalars['DateTime']['output']
  fleetId: Maybe<Scalars['ID']['output']>
  foreignId: Scalars['ID']['output']
  id: Scalars['ID']['output']
  note: Maybe<TaskNotificationNote>
  notificationType: TaskNotificationType
  pended: Maybe<TaskStateChangeDetails>
  regionId: Maybe<Scalars['ID']['output']>
  resolved: Maybe<TaskStateChangeDetails>
  serviceAreaUUID: Scalars['ID']['output']
  severity: TaskNotificationSeverity
  shift: Maybe<Shift>
  stateChanges: Array<TaskStateChangeDetails>
  status: TaskNotificationStatus
  version: Scalars['Int']['output']
}

export type ShiftEmployeeStatus = {
  __typename?: 'ShiftEmployeeStatus'
  type: ShiftEmployeeStatusType
  updatedAt: Scalars['DateTime']['output']
  /** @deprecated Use updatedByUser instead */
  updatedBy: Maybe<Scalars['String']['output']>
  updatedByUser: Maybe<BackofficeUser>
}

export type ShiftEmployeeStatusInput = {
  shiftId: Scalars['ID']['input']
  type?: InputMaybe<ShiftEmployeeStatusType>
}

export enum ShiftEmployeeStatusType {
  Event = 'EVENT',
  NoShow = 'NO_SHOW',
  SickLeave = 'SICK_LEAVE',
  SickWithoutNote = 'SICK_WITHOUT_NOTE',
  SickWithNote = 'SICK_WITH_NOTE',
  SpecialTime = 'SPECIAL_TIME',
  Vacation = 'VACATION',
  WorkingAtHub = 'WORKING_AT_HUB',
}

export type ShiftFixedSetupTimes = {
  __typename?: 'ShiftFixedSetupTimes'
  /** Duration of after-shift activities (cleaning car, etc.) */
  afterShift: Scalars['Duration']['output']
  /** Setup duration before shift starts */
  beforeShift: Scalars['Duration']['output']
  /** Before break setup duration (e.g. finding a parking spot) */
  breakTotal: Scalars['Duration']['output']
}

export type ShiftOverrideScheduledHubReturnInput = {
  shiftId: Scalars['ID']['input']
}

export type ShiftOverrideTypeInput = {
  shiftId: Scalars['ID']['input']
  shiftType: ShiftType
}

export type ShiftOverrideTypeResponse = {
  __typename?: 'ShiftOverrideTypeResponse'
  shift: Shift
}

export type ShiftPlannedHubReturn = {
  __typename?: 'ShiftPlannedHubReturn'
  hubReturnReason: ShiftPlannedHubReturnReason
  /** @deprecated Use plannedServiceBreakLocation instead */
  plannedArea: Maybe<Area>
  plannedReturnTime: Scalars['DateTime']['output']
  plannedServiceBreakLocation: Maybe<ServiceBreakLocation>
  providedReason: Maybe<ShiftPlannedHubReturnProvidedReason>
}

export type ShiftPlannedHubReturnArrivals = {
  __typename?: 'ShiftPlannedHubReturnArrivals'
  sectionBreakArrivalAt: Maybe<Scalars['DateTime']['output']>
  sectionFirstArrivalAt: Maybe<Scalars['DateTime']['output']>
  sectionSecondArrivalAt: Maybe<Scalars['DateTime']['output']>
  sectionShiftEndArrivalAt: Maybe<Scalars['DateTime']['output']>
}

export enum ShiftPlannedHubReturnProvidedReason {
  AccompanyingDrive = 'ACCOMPANYING_DRIVE',
  EmployeeTalk = 'EMPLOYEE_TALK',
  Event = 'EVENT',
  FixedTimeBreak = 'FIXED_TIME_BREAK',
  HubService = 'HUB_SERVICE',
  OtherReason = 'OTHER_REASON',
  SdoShiftDocumentation = 'SDO_SHIFT_DOCUMENTATION',
  Training = 'TRAINING',
  VehicleCleaning = 'VEHICLE_CLEANING',
  VehicleMaintenance = 'VEHICLE_MAINTENANCE',
  VehicleSwap = 'VEHICLE_SWAP',
  WorkersCouncil = 'WORKERS_COUNCIL',
}

export enum ShiftPlannedHubReturnReason {
  Break = 'BREAK',
  ShiftEnd = 'SHIFT_END',
}

export type ShiftPlannedHubReturnSection = {
  __typename?: 'ShiftPlannedHubReturnSection'
  /** @deprecated Use plannedServiceBreakLocation instead */
  plannedArea: Maybe<Area>
  plannedReturnTime: Scalars['DateTime']['output']
  plannedServiceBreakLocation: Maybe<ServiceBreakLocation>
  providedReason: Maybe<ShiftPlannedHubReturnProvidedReason>
  section: ShiftPlannedHubReturnSectionCategory
}

export enum ShiftPlannedHubReturnSectionCategory {
  SectionBreak = 'SECTION_BREAK',
  SectionFirst = 'SECTION_FIRST',
  SectionSecond = 'SECTION_SECOND',
  SectionShiftEnd = 'SECTION_SHIFT_END',
}

export type ShiftPlannedHubReturnSectionOption = {
  __typename?: 'ShiftPlannedHubReturnSectionOption'
  /**
   * contains only areas of type hub
   * @deprecated Use availableServiceBreakLocations instead
   */
  availableAreas: Array<Area>
  /** @deprecated Use availableServiceBreakLocations instead */
  availableBreakLocations: Array<Area>
  /** contains hub and break type */
  availableServiceBreakLocations: Array<ServiceBreakLocation>
  availableStartTimes: Array<Scalars['DateTime']['output']>
  earliestSectionStart: Maybe<Scalars['DateTime']['output']>
  latestSectionEnd: Maybe<Scalars['DateTime']['output']>
  /** @deprecated Use plannedServiceBreakLocation instead */
  plannedArea: Maybe<Area>
  plannedReturnTime: Maybe<Scalars['DateTime']['output']>
  plannedServiceBreakLocation: Maybe<ServiceBreakLocation>
  providedReason: Maybe<ShiftPlannedHubReturnProvidedReason>
  section: ShiftPlannedHubReturnSectionCategory
}

export type ShiftPlannedHubReturnSectionOptionsResponse = {
  __typename?: 'ShiftPlannedHubReturnSectionOptionsResponse'
  comment: Maybe<ShiftComment>
  options: Array<ShiftPlannedHubReturnSectionOption>
}

export type ShiftPlannedHubReturnSections = {
  __typename?: 'ShiftPlannedHubReturnSections'
  arrivals: ShiftPlannedHubReturnArrivals
  deletePossibleFor: Array<ShiftPlannedHubReturnSectionCategory>
  planned: Array<ShiftPlannedHubReturnSection>
  planningPossibleFor: Array<ShiftPlannedHubReturnSectionCategory>
}

export type ShiftPlannedHubReturnUtilizationInput = {
  /** @deprecated Use serviceBreakLocationId instead */
  areaId?: InputMaybe<Scalars['String']['input']>
  selectedTimeslot: Scalars['DateTime']['input']
  serviceBreakLocationId?: InputMaybe<Scalars['String']['input']>
  shiftId: Scalars['String']['input']
}

export type ShiftPlannedHubReturnUtilizationResponse = {
  __typename?: 'ShiftPlannedHubReturnUtilizationResponse'
  /** @deprecated Use serviceBreakLocationUtilization instead */
  areasUtilization: Array<AreaUtilization>
  serviceBreakLocationUtilization: Array<ServiceBreakLocationUtilization>
}

export type ShiftPlannedHubReturns = {
  __typename?: 'ShiftPlannedHubReturns'
  planned: Array<ShiftPlannedHubReturn>
  planningPossibleFor: Array<ShiftPlannedHubReturnReason>
}

export type ShiftScheduledHubReturn = {
  __typename?: 'ShiftScheduledHubReturn'
  id: Scalars['ID']['output']
  overriddenAt: Maybe<Scalars['DateTime']['output']>
  overriddenBy: Maybe<Scalars['String']['output']>
  overriddenByUser: Maybe<BackofficeUser>
  returnReason: ShiftScheduledHubReturnReason
  source: ShiftScheduledHubReturnSource
}

export enum ShiftScheduledHubReturnReason {
  PlannedBreak = 'PLANNED_BREAK',
  SectionFirst = 'SECTION_FIRST',
  SectionSecond = 'SECTION_SECOND',
  ShiftEnd = 'SHIFT_END',
}

export enum ShiftScheduledHubReturnSource {
  Override = 'OVERRIDE',
  System = 'SYSTEM',
}

export type ShiftSetPlannedHubReturnSectionInput = {
  comment?: InputMaybe<Scalars['String']['input']>
  /** @deprecated Use plannedServiceBreakLocationId instead */
  plannedAreaId?: InputMaybe<Scalars['ID']['input']>
  plannedReturnTime: Scalars['DateTime']['input']
  plannedServiceBreakLocationId?: InputMaybe<Scalars['ID']['input']>
  providedReason?: InputMaybe<ShiftPlannedHubReturnProvidedReason>
  section: ShiftPlannedHubReturnSectionCategory
  shiftId: Scalars['ID']['input']
}

export type ShiftSetPlannedHubReturnSectionResponse = {
  __typename?: 'ShiftSetPlannedHubReturnSectionResponse'
  planned: Array<ShiftPlannedHubReturnSection>
  shiftComment: Maybe<ShiftComment>
}

export type ShiftState = {
  __typename?: 'ShiftState'
  break: ShiftStateBreak
  /** true if driver was checked out by operator/driver manager */
  checkedOutByOperator: Scalars['Boolean']['output']
  comment: Maybe<ShiftComment>
  employeeStatus: Maybe<ShiftEmployeeStatus>
  /** returns the current execution state (upcoming, active, missed, done). Null represents an unknown state */
  executionState: Maybe<ExecutionState>
  firstDepartureAt: Maybe<Scalars['DateTime']['output']>
  firstHubCheckIn: Maybe<Scalars['DateTime']['output']>
  lastArrivalAt: Maybe<Scalars['DateTime']['output']>
  lastHubCheckOut: Maybe<Scalars['DateTime']['output']>
  plannedHubReturnSections: ShiftPlannedHubReturnSections
  plannedHubReturns: ShiftPlannedHubReturns
  productiveEnd: Maybe<Scalars['DateTime']['output']>
  productiveStart: Maybe<Scalars['DateTime']['output']>
  scheduledHubReturn: Maybe<ShiftScheduledHubReturn>
  scheduledHubReturnForBreak: Maybe<Scalars['DateTime']['output']>
  shiftId: Scalars['ID']['output']
  shortBreaks: ShiftStateShortBreaks
  vehicle: Maybe<Vehicle>
  visibleHubReturn: Maybe<ShiftVisibleHubReturn>
  workingTimes: ShiftStateWorkingTime
}

export type ShiftStateBreak = {
  __typename?: 'ShiftStateBreak'
  duration: Maybe<Scalars['Duration']['output']>
  endedAt: Maybe<Scalars['DateTime']['output']>
  startedAt: Maybe<Scalars['DateTime']['output']>
}

export type ShiftStateBreakLogRecord = ShiftStateLogRecord & {
  __typename?: 'ShiftStateBreakLogRecord'
  duration: Scalars['Int']['output']
  earliestStart: Scalars['DateTime']['output']
  eventTime: Scalars['DateTime']['output']
  latestStart: Scalars['DateTime']['output']
  shiftId: Maybe<Scalars['ID']['output']>
  type: ShiftStateLogRecordType
}

export type ShiftStateHubLogRecord = ShiftStateLogRecord & {
  __typename?: 'ShiftStateHubLogRecord'
  createdBy: Scalars['String']['output']
  eventTime: Scalars['DateTime']['output']
  /** @deprecated Use serviceBreakLocation instead */
  hub: Maybe<Hub>
  serviceBreakLocation: Maybe<ServiceBreakLocation>
  shiftId: Maybe<Scalars['ID']['output']>
  type: ShiftStateLogRecordType
}

export type ShiftStateLogRecord = {
  eventTime: Scalars['DateTime']['output']
  shiftId: Maybe<Scalars['ID']['output']>
  type: ShiftStateLogRecordType
}

export enum ShiftStateLogRecordType {
  AreaArrival = 'AREA_ARRIVAL',
  AreaDeparture = 'AREA_DEPARTURE',
  BreakStarted = 'BREAK_STARTED',
  HubCheckedIn = 'HUB_CHECKED_IN',
  HubCheckedOut = 'HUB_CHECKED_OUT',
  PoolingStateChanged = 'POOLING_STATE_CHANGED',
  SendVehicleToHub = 'SEND_VEHICLE_TO_HUB',
  ShiftChanged = 'SHIFT_CHANGED',
  ShortBreakStarted = 'SHORT_BREAK_STARTED',
  VehicleClosed = 'VEHICLE_CLOSED',
  VehicleOpened = 'VEHICLE_OPENED',
}

export type ShiftStateShortBreakLogRecord = ShiftStateLogRecord & {
  __typename?: 'ShiftStateShortBreakLogRecord'
  eventTime: Scalars['DateTime']['output']
  shiftId: Maybe<Scalars['ID']['output']>
  type: ShiftStateLogRecordType
}

export type ShiftStateShortBreakTaken = {
  __typename?: 'ShiftStateShortBreakTaken'
  duration: Scalars['Duration']['output']
  end: Scalars['DateTime']['output']
  start: Scalars['DateTime']['output']
}

export type ShiftStateShortBreaks = {
  __typename?: 'ShiftStateShortBreaks'
  /** Starting time of the currently running short breaks (or null if not in break) */
  inShortBreakSince: Maybe<Scalars['DateTime']['output']>
  /** History of executed short breaks */
  shortBreaksTaken: Array<ShiftStateShortBreakTaken>
}

export type ShiftStateVehicleLogRecord = ShiftStateLogRecord & {
  __typename?: 'ShiftStateVehicleLogRecord'
  createdBy: Scalars['String']['output']
  eventTime: Scalars['DateTime']['output']
  shiftId: Maybe<Scalars['ID']['output']>
  type: ShiftStateLogRecordType
  vehicle: Vehicle
}

export type ShiftStateWorkingTime = {
  __typename?: 'ShiftStateWorkingTime'
  currentlyProductive: Scalars['Boolean']['output']
  netWorkingTime: Maybe<Scalars['Duration']['output']>
  productiveTime: Maybe<Scalars['Duration']['output']>
}

export enum ShiftType {
  NonPooling = 'NON_POOLING',
  PlutoPooling = 'PLUTO_POOLING',
  SafetyDriverOperation = 'SAFETY_DRIVER_OPERATION',
  WavPooling = 'WAV_POOLING',
}

export type ShiftTypeOverrideDetails = {
  __typename?: 'ShiftTypeOverrideDetails'
  /** New shift type value after override or `null` if no override is active */
  newShiftType: Maybe<ShiftType>
  /** Original shift type value before override */
  originalShiftType: ShiftType
  overriddenAt: Scalars['DateTime']['output']
  overriddenBy: Maybe<BackofficeUser>
}

export type ShiftVisibleHubReturn = {
  __typename?: 'ShiftVisibleHubReturn'
  /** @deprecated Use serviceBreakLocation instead */
  area: Maybe<Area>
  expectedArrival: Scalars['DateTime']['output']
  reason: SendVehicleToHubReturnReason
  serviceBreakLocation: Maybe<ServiceBreakLocation>
}

export type ShiftsDemandSupplyData = {
  __typename?: 'ShiftsDemandSupplyData'
  demandInShifts: Scalars['Float']['output']
  inServiceHours: Scalars['Boolean']['output']
  supplyInShifts: Scalars['Float']['output']
  timestamp: Scalars['DateTime']['output']
  updatedAt: Scalars['DateTime']['output']
}

export type ShiftsInRangeInput = {
  /** if not null or empty, only shifts planned for the given hubs are returned (default: all hubs allowed) */
  filterHubs?: InputMaybe<Array<Scalars['String']['input']>>
  /** denotes start of the time range for filtered shifts */
  from: Scalars['DateTime']['input']
  /** if enabled, include shifts that have started before but end within the specified range (default: true) */
  includeAlreadyStartedShifts: Scalars['Boolean']['input']
  /** only shifts within the given region are returned */
  regionId: Scalars['ID']['input']
  /** if set, only shifts by employees supervised by given user id are selected (default: null) */
  supervisorUserId?: InputMaybe<Scalars['ID']['input']>
  /** denotes end of the time range for filtered shifts */
  to: Scalars['DateTime']['input']
}

export type ShiftsSupplyData = {
  __typename?: 'ShiftsSupplyData'
  latestUpdate: Scalars['DateTime']['output']
  nonPoolingShifts: Scalars['Int']['output']
  supplyInPlutoShifts: Scalars['Int']['output']
  supplyInSdoShifts: Scalars['Int']['output']
  supplyInWavShifts: Scalars['Int']['output']
  timestamp: Scalars['DateTime']['output']
}

export type ShortBreakDetails = {
  __typename?: 'ShortBreakDetails'
  stop: Maybe<NavigationStop>
}

export type SignupAllowlistEntry = {
  __typename?: 'SignupAllowlistEntry'
  /** Time when the signup allowlist phone number given access */
  allowlistedAt: Scalars['OffsetDateTime']['output']
  /** Id of the signup allowlist customer */
  customerId: Maybe<Scalars['String']['output']>
  /** Phone number that is allowed to access the app */
  phoneNumber: Scalars['String']['output']
  /** Registration time of the signup allowlist customer */
  registeredAt: Maybe<Scalars['OffsetDateTime']['output']>
  /** Tenant to which the signup allowlist phone number belongs to */
  tenant: Scalars['String']['output']
}

export type SimulateDoorActuationResponseInput = {
  /** The error added to the Cabin Safety event. No error signals a successful response. */
  error?: InputMaybe<TestDoorActuationError>
  transactionId: Scalars['ID']['input']
  vin: Scalars['ID']['input']
}

export type SimulateEventInput = {
  transactionId?: InputMaybe<Scalars['ID']['input']>
  vin: Scalars['ID']['input']
}

export enum SimulateWaypointAttendanceActionType {
  Delivery = 'DELIVERY',
  Pickup = 'PICKUP',
}

export enum SimulateWaypointAttendanceEventType {
  Changed = 'CHANGED',
  Completed = 'COMPLETED',
  Reached = 'REACHED',
}

export type SimulateWaypointAttendanceInput = {
  actionType: SimulateWaypointAttendanceActionType
  eventType: SimulateWaypointAttendanceEventType
  vehicleId: Scalars['ID']['input']
}

export type SimulatedAdVehicle = {
  __typename?: 'SimulatedADVehicle'
  centralLockState: CentralLockState
  /** Connection state between vehicle and mqtt broker */
  connectedState: Scalars['Boolean']['output']
  /** Current vehicle power consumption in watts per second */
  consumedEnergy: Scalars['Float']['output']
  /** true if there is any door open */
  doorsOpen: Scalars['Boolean']['output']
  exteriorAirTemperature: Scalars['Float']['output']
  /** Heading of the vehicle in degrees clock-wise, 0 is north */
  heading: Scalars['Float']['output']
  highVoltBatteryPercentage: Scalars['Percentage']['output']
  id: Scalars['ID']['output']
  ignitionState: IgnitionState
  interiorTemperature: Scalars['Float']['output']
  /** 0%  door closed, 100% door opened until soft end stop, >100% door opened beyond the soft end stop */
  leftSlidingDoorPosition: Scalars['Percentage']['output']
  location: Location
  /** Mileage in km range from 0 to 1048573. */
  mileage: Scalars['Int']['output']
  /** Remaining cruising range in kilometers */
  remainingCruisingRange: Scalars['Float']['output']
  /** 0%  door closed, 100% door opened until soft end stop, >100% door opened beyond the soft end stop */
  rightSlidingDoorPosition: Scalars['Percentage']['output']
  /** Mode of the Self Driving System */
  sdsMode: SdsMode
  /** Seatbelt and occupancy states for each seat of vehicle */
  seats: Seats
  /** Current speed in meters / second */
  speed: Scalars['Float']['output']
  tireWarning: TireWarning
  updatedAt: Maybe<Scalars['String']['output']>
  vin: Scalars['String']['output']
}

export type SimulatedAdVehicleIncident = {
  __typename?: 'SimulatedADVehicleIncident'
  criticality: Criticality
  description: Scalars['String']['output']
  fleetVehicleId: Scalars['ID']['output']
  occurrenceTimestamp: Scalars['Date']['output']
  status: Incidentstatus
  tripInterruption: TripInterruptions
  type: IncidentTypeIds
  vehicleIncidentId: Scalars['Int']['output']
}

export type SimulatedVehicle = {
  __typename?: 'SimulatedVehicle'
  cdisError: Maybe<CdisError>
  id: Scalars['String']['output']
  telematics: Maybe<TelematicBoxState>
  vin: Scalars['String']['output']
}

export enum SimulatedVehicleEventType {
  Battery = 'BATTERY',
  ChargingCable = 'CHARGING_CABLE',
  ClimateControl = 'CLIMATE_CONTROL',
  Connectivity = 'CONNECTIVITY',
  Ignition = 'IGNITION',
  Position = 'POSITION',
  State = 'STATE',
  WakeUp = 'WAKE_UP',
}

/** An SMS delivery event of the login/signup verification-code flow */
export type SmsEvent = {
  __typename?: 'SmsEvent'
  /** Tenant this event belongs to. Always set; never mixed across tenants in one response. */
  customerTenant: Scalars['String']['output']
  /** Block reason or provider response text. Never the SMS body or the verification code. */
  details: Maybe<Scalars['String']['output']>
  eventTime: Scalars['OffsetDateTime']['output']
  eventType: SmsEventType
  /** Normalised E.164 phone number this event belongs to */
  phoneNumber: Scalars['String']['output']
  /** AWS End User Messaging message id. Null when nothing was published. Correlates an attempt with its delivery events. */
  providerMessageId: Maybe<Scalars['String']['output']>
}

export enum SmsEventType {
  BlockedBotCheck = 'BLOCKED_BOT_CHECK',
  BlockedCountry = 'BLOCKED_COUNTRY',
  BlockedInvalidInstallationId = 'BLOCKED_INVALID_INSTALLATION_ID',
  BlockedRateLimit = 'BLOCKED_RATE_LIMIT',
  BlockedUnsupportedCountry = 'BLOCKED_UNSUPPORTED_COUNTRY',
  Delivered = 'DELIVERED',
  DeliveryFailed = 'DELIVERY_FAILED',
  ProviderRejected = 'PROVIDER_REJECTED',
  SentToProvider = 'SENT_TO_PROVIDER',
}

export enum Sort {
  Asc = 'asc',
  Desc = 'desc',
}

export enum SortOrder {
  Asc = 'ASC',
  Desc = 'DESC',
}

export type StateChangeResponse = {
  __typename?: 'StateChangeResponse'
  state: VehicleState
  success: Scalars['Boolean']['output']
}

/** Entry describing a past event of disabling or enabling user */
export type StatusHistoryEntry = {
  __typename?: 'StatusHistoryEntry'
  /** Whether customer was enabled or disabled */
  action: StatusHistoryEntryAction
  /** Reason why customer was disabled */
  disabledReason: Maybe<DisabledReason>
  /** When customer was disabled or enabled */
  timestamp: Scalars['OffsetDateTime']['output']
}

/** Whether customer was enabled or disabled */
export enum StatusHistoryEntryAction {
  /** Disabled */
  Disabled = 'DISABLED',
  /** Enabled */
  Enabled = 'ENABLED',
}

export type Stop = {
  __typename?: 'Stop'
  actions: Array<Action>
  address: StopAddress
  areas: Array<Area>
  bearing: Scalars['Int']['output']
  created: Scalars['DateTime']['output']
  customerDisplayLocation: Location
  enabledForStoppingManeuverTesting: Scalars['Boolean']['output']
  excludeFromReallocations: Scalars['Boolean']['output']
  flags: Maybe<Array<StopFlag>>
  hasOverlappingActions: Scalars['Boolean']['output']
  id: Scalars['String']['output']
  location: Maybe<Location>
  modified: Scalars['DateTime']['output']
  modifiedBy: Scalars['String']['output']
  modifiedByActionId: Maybe<Scalars['String']['output']>
  names: Scalars['DisplayNames']['output']
  roadCategory: Maybe<RoadCategory>
  routingLocation: Location
  serviceArea: ServiceArea
  stopActivation: StopActivation
  stopType: Maybe<StopType>
}

export type StopAccessibilityDownvotedByDrivers = TaskNotification & {
  __typename?: 'StopAccessibilityDownvotedByDrivers'
  actionType: TaskActionType
  assigned: Maybe<TaskStateChangeDetails>
  createdAt: Scalars['DateTime']['output']
  fleetId: Maybe<Scalars['ID']['output']>
  foreignId: Scalars['ID']['output']
  id: Scalars['ID']['output']
  note: Maybe<TaskNotificationNote>
  notificationType: TaskNotificationType
  pended: Maybe<TaskStateChangeDetails>
  regionId: Maybe<Scalars['ID']['output']>
  resolved: Maybe<TaskStateChangeDetails>
  serviceAreaUUID: Scalars['ID']['output']
  severity: TaskNotificationSeverity
  stateChanges: Array<TaskStateChangeDetails>
  status: TaskNotificationStatus
  stop: Maybe<Stop>
  version: Scalars['Int']['output']
}

export type StopActivation = {
  __typename?: 'StopActivation'
  active: Scalars['Boolean']['output']
  inactiveReasonCategory: Maybe<InactiveReasonCategory>
  inactiveReasonLabel: Maybe<Scalars['String']['output']>
}

export type StopActivationFailedNotification = TaskNotification & {
  __typename?: 'StopActivationFailedNotification'
  actionType: TaskActionType
  assigned: Maybe<TaskStateChangeDetails>
  createdAt: Scalars['DateTime']['output']
  fleetId: Maybe<Scalars['ID']['output']>
  foreignId: Scalars['ID']['output']
  id: Scalars['ID']['output']
  note: Maybe<TaskNotificationNote>
  notificationType: TaskNotificationType
  pended: Maybe<TaskStateChangeDetails>
  regionId: Maybe<Scalars['ID']['output']>
  resolved: Maybe<TaskStateChangeDetails>
  serviceAreaUUID: Scalars['ID']['output']
  severity: TaskNotificationSeverity
  stateChanges: Array<TaskStateChangeDetails>
  status: TaskNotificationStatus
  stop: Maybe<Stop>
  version: Scalars['Int']['output']
}

export type StopAddress = {
  __typename?: 'StopAddress'
  city: Maybe<Scalars['String']['output']>
  houseNumber: Maybe<Scalars['String']['output']>
  postalCode: Maybe<Scalars['String']['output']>
  street: Maybe<Scalars['String']['output']>
}

export type StopAddressInput = {
  city?: InputMaybe<Scalars['String']['input']>
  houseNumber?: InputMaybe<Scalars['String']['input']>
  postalCode?: InputMaybe<Scalars['String']['input']>
  street?: InputMaybe<Scalars['String']['input']>
}

export type StopAreaMissingActiveStopsNotification = TaskNotification & {
  __typename?: 'StopAreaMissingActiveStopsNotification'
  actionType: TaskActionType
  area: Maybe<Area>
  assigned: Maybe<TaskStateChangeDetails>
  createdAt: Scalars['DateTime']['output']
  fleetId: Maybe<Scalars['ID']['output']>
  foreignId: Scalars['ID']['output']
  id: Scalars['ID']['output']
  note: Maybe<TaskNotificationNote>
  notificationType: TaskNotificationType
  pended: Maybe<TaskStateChangeDetails>
  regionId: Maybe<Scalars['ID']['output']>
  resolved: Maybe<TaskStateChangeDetails>
  serviceAreaUUID: Scalars['ID']['output']
  severity: TaskNotificationSeverity
  stateChanges: Array<TaskStateChangeDetails>
  status: TaskNotificationStatus
  version: Scalars['Int']['output']
}

/** A stop network bulk import job */
export type StopBulkImport = {
  __typename?: 'StopBulkImport'
  errorFileName: Maybe<Scalars['String']['output']>
  errorFileS3Path: Maybe<Scalars['String']['output']>
  failedStopsCount: Maybe<Scalars['Int']['output']>
  id: Scalars['String']['output']
  importDate: Scalars['DateTime']['output']
  importType: ImportType
  modified: Scalars['DateTime']['output']
  modifiedBy: Scalars['String']['output']
  originalFileName: Scalars['String']['output']
  originalFileS3Path: Scalars['String']['output']
  serviceAreaId: Scalars['String']['output']
  status: ImportStatus
  successfulStopsCount: Maybe<Scalars['Int']['output']>
  totalStopsCount: Maybe<Scalars['Int']['output']>
}

export type StopCountResult = {
  __typename?: 'StopCountResult'
  active: Scalars['Int']['output']
  inactive: Scalars['Int']['output']
  total: Scalars['Int']['output']
}

export type StopDeactivationEvent = {
  __typename?: 'StopDeactivationEvent'
  areaId: Maybe<Scalars['String']['output']>
  areaName: Maybe<Scalars['String']['output']>
  deactivatedAt: Scalars['DateTime']['output']
  deactivatedBy: Scalars['String']['output']
  reason: Maybe<ActionReason>
  reasonLabel: Maybe<Scalars['String']['output']>
  scheduledEndTime: Maybe<Scalars['DateTime']['output']>
  stopFlags: Array<StopFlag>
  stopId: Scalars['String']['output']
  stopName: Scalars['String']['output']
  stopType: Maybe<StopType>
}

export type StopDeactivationFeed = {
  __typename?: 'StopDeactivationFeed'
  items: Array<StopDeactivationEvent>
  nextCursor: Maybe<Scalars['String']['output']>
}

export type StopDownVotedByDrivers = TaskNotification & {
  __typename?: 'StopDownVotedByDrivers'
  actionType: TaskActionType
  assigned: Maybe<TaskStateChangeDetails>
  createdAt: Scalars['DateTime']['output']
  fleetId: Maybe<Scalars['ID']['output']>
  foreignId: Scalars['ID']['output']
  id: Scalars['ID']['output']
  note: Maybe<TaskNotificationNote>
  notificationType: TaskNotificationType
  pended: Maybe<TaskStateChangeDetails>
  regionId: Maybe<Scalars['ID']['output']>
  resolved: Maybe<TaskStateChangeDetails>
  serviceAreaUUID: Scalars['ID']['output']
  severity: TaskNotificationSeverity
  stateChanges: Array<TaskStateChangeDetails>
  status: TaskNotificationStatus
  stop: Maybe<Stop>
  version: Scalars['Int']['output']
}

export type StopFilterInput = {
  excludeFromReallocations?: InputMaybe<Scalars['Boolean']['input']>
  flags?: InputMaybe<Array<SearchStopFlag>>
  insideServiceArea?: InputMaybe<Scalars['Boolean']['input']>
  status?: InputMaybe<Array<SearchStopStatus>>
  type?: InputMaybe<Array<SearchStopType>>
}

export enum StopFlag {
  Ad = 'AD',
  HumanDriver = 'HUMAN_DRIVER',
  HvvSwitchStop = 'HVV_SWITCH_STOP',
  Partnership = 'PARTNERSHIP',
  PhysicalPromotion = 'PHYSICAL_PROMOTION',
  RegularPassengers = 'REGULAR_PASSENGERS',
  WheelchairAccessible = 'WHEELCHAIR_ACCESSIBLE',
}

export type StopFlagConfigurationDto = {
  __typename?: 'StopFlagConfigurationDto'
  allowedFlags: Array<StopFlag>
}

export type StopFlagConfigurationInput = {
  allowedFlags: Array<StopFlag>
}

export type StopInput = {
  address: StopAddressInput
  bearing: Scalars['Int']['input']
  customerDisplayLocation: LocationInput
  /** Defaults to 'false' on creation, keeps the existing value on update if not provided */
  enabledForStoppingManeuverTesting?: InputMaybe<Scalars['Boolean']['input']>
  /** Defaults to 'false' */
  excludeFromReallocations?: InputMaybe<Scalars['Boolean']['input']>
  flags?: InputMaybe<Array<StopFlag>>
  names: Scalars['DisplayNames']['input']
  roadCategory?: InputMaybe<RoadCategory>
  routingLocation: LocationInput
  stopType?: InputMaybe<StopType>
}

export enum StopLocationValidatorName {
  ActiveOnlyInsideServiceArea = 'ACTIVE_ONLY_INSIDE_SERVICE_AREA',
  AddressesMatch = 'ADDRESSES_MATCH',
  BearingAndStreetMatch = 'BEARING_AND_STREET_MATCH',
  CustomerAndRoutingLocationDistance = 'CUSTOMER_AND_ROUTING_LOCATION_DISTANCE',
  DefaultLocaleNameIsPresent = 'DEFAULT_LOCALE_NAME_IS_PRESENT',
  DistanceToBusStop = 'DISTANCE_TO_BUS_STOP',
  DistanceToFireBrigadeAccess = 'DISTANCE_TO_FIRE_BRIGADE_ACCESS',
  DistanceToIntersection = 'DISTANCE_TO_INTERSECTION',
  DistanceToLevelCrossing = 'DISTANCE_TO_LEVEL_CROSSING',
  DistanceToOtherStops = 'DISTANCE_TO_OTHER_STOPS',
  DistanceToPedestrianCrossing = 'DISTANCE_TO_PEDESTRIAN_CROSSING',
  DistanceToTaxiStand = 'DISTANCE_TO_TAXI_STAND',
  DistanceToTrafficLights = 'DISTANCE_TO_TRAFFIC_LIGHTS',
  HubsNotUpdatable = 'HUBS_NOT_UPDATABLE',
  InsideServiceAreaBounds = 'INSIDE_SERVICE_AREA_BOUNDS',
  LocationMustBeRoutableByCar = 'LOCATION_MUST_BE_ROUTABLE_BY_CAR',
  NonPassengerStop = 'NON_PASSENGER_STOP',
  OutsideSharpCurve = 'OUTSIDE_SHARP_CURVE',
  ReallocationDistanceToServiceAreaBorder = 'REALLOCATION_DISTANCE_TO_SERVICE_AREA_BORDER',
  RequireOneOfFlagsPresent = 'REQUIRE_ONE_OF_FLAGS_PRESENT',
  RoadCategory = 'ROAD_CATEGORY',
  UpdateInsideRadius = 'UPDATE_INSIDE_RADIUS',
  WheelchairLanes = 'WHEELCHAIR_LANES',
  WheelchairObstacles = 'WHEELCHAIR_OBSTACLES',
  WheelchairSidewalkIncline = 'WHEELCHAIR_SIDEWALK_INCLINE',
  WheelchairSidewalkSurface = 'WHEELCHAIR_SIDEWALK_SURFACE',
  WheelchairStreetSurface = 'WHEELCHAIR_STREET_SURFACE',
  WheelchairStreetWidth = 'WHEELCHAIR_STREET_WIDTH',
}

/** Input for generating a stop network within a polygon */
export type StopNetworkGenerationInput = {
  /** GeoJSON geometry string defining the generation area. If null, the service area polygon is used. */
  polygon?: InputMaybe<Scalars['String']['input']>
  /** Number of stops to generate (1-500) */
  targetStopCount: Scalars['Int']['input']
}

export type StopPendingDeletionInput = {
  id: Scalars['ID']['input']
  tenant: Scalars['String']['input']
}

export type StopPendingDeletionResponse = {
  __typename?: 'StopPendingDeletionResponse'
  success: Scalars['Boolean']['output']
}

export type StopPotentiallyUnreachable = TaskNotification & {
  __typename?: 'StopPotentiallyUnreachable'
  actionType: TaskActionType
  assigned: Maybe<TaskStateChangeDetails>
  createdAt: Scalars['DateTime']['output']
  fleetId: Maybe<Scalars['ID']['output']>
  foreignId: Scalars['ID']['output']
  id: Scalars['ID']['output']
  note: Maybe<TaskNotificationNote>
  notificationType: TaskNotificationType
  pended: Maybe<TaskStateChangeDetails>
  regionId: Maybe<Scalars['ID']['output']>
  resolved: Maybe<TaskStateChangeDetails>
  serviceAreaUUID: Scalars['ID']['output']
  severity: TaskNotificationSeverity
  stateChanges: Array<TaskStateChangeDetails>
  status: TaskNotificationStatus
  stop: Maybe<Stop>
  version: Scalars['Int']['output']
}

export type StopSuggestion = {
  __typename?: 'StopSuggestion'
  address: Maybe<StopAddress>
  bearing: Maybe<Scalars['Int']['output']>
  customerDisplayLocation: Maybe<Location>
  errors: Array<StopValidationError>
  flags: Maybe<Array<StopFlag>>
  names: Maybe<Scalars['DisplayNames']['output']>
  oneWayStreet: Maybe<Scalars['Boolean']['output']>
  roadCategory: Maybe<RoadCategory>
  routingLocation: Maybe<Location>
  stopActivation: Maybe<StopActivation>
  validation: Maybe<StopValidationResults>
}

export enum StopType {
  StopTypeHub = 'STOP_TYPE_HUB',
  StopTypeInFieldBreak = 'STOP_TYPE_IN_FIELD_BREAK',
  StopTypePublicTransportation = 'STOP_TYPE_PUBLIC_TRANSPORTATION',
  StopTypeShortBreak = 'STOP_TYPE_SHORT_BREAK',
}

export type StopValidationError = {
  __typename?: 'StopValidationError'
  code: Scalars['String']['output']
  details: Array<DetailsDto>
  message: Scalars['String']['output']
}

export type StopValidationFailed = TaskNotification & {
  __typename?: 'StopValidationFailed'
  actionType: TaskActionType
  assigned: Maybe<TaskStateChangeDetails>
  createdAt: Scalars['DateTime']['output']
  fleetId: Maybe<Scalars['ID']['output']>
  foreignId: Scalars['ID']['output']
  id: Scalars['ID']['output']
  note: Maybe<TaskNotificationNote>
  notificationType: TaskNotificationType
  pended: Maybe<TaskStateChangeDetails>
  regionId: Maybe<Scalars['ID']['output']>
  resolved: Maybe<TaskStateChangeDetails>
  serviceAreaUUID: Scalars['ID']['output']
  severity: TaskNotificationSeverity
  stateChanges: Array<TaskStateChangeDetails>
  status: TaskNotificationStatus
  stop: Maybe<Stop>
  version: Scalars['Int']['output']
}

export type StopValidationResult = {
  __typename?: 'StopValidationResult'
  actual: Maybe<Scalars['String']['output']>
  error: Maybe<Scalars['String']['output']>
  expected: Maybe<Scalars['String']['output']>
  status: StopValidationStatus
  validator: StopLocationValidatorName
}

export type StopValidationResults = {
  __typename?: 'StopValidationResults'
  accessibilityResults: Array<StopValidationResult>
  accessibilityStatus: StopValidationStatus
  results: Array<StopValidationResult>
  status: StopValidationStatus
}

export enum StopValidationStatus {
  Failed = 'FAILED',
  NotApplicable = 'NOT_APPLICABLE',
  Passed = 'PASSED',
  Unknown = 'UNKNOWN',
}

export type StopValidatorConfigDto = {
  __typename?: 'StopValidatorConfigDto'
  enabled: Scalars['Boolean']['output']
  stopLocationValidatorName: StopLocationValidatorName
  threshold: Maybe<Scalars['Float']['output']>
}

export type StopValidatorConfigInput = {
  enabled: Scalars['Boolean']['input']
  stopLocationValidatorName: StopLocationValidatorName
  threshold?: InputMaybe<Scalars['Float']['input']>
}

/** Represents a surcharge. Either relativeSurcharge or absoluteSurcharge has to be set, depending on the value in surchargeType */
export type Surcharge = {
  __typename?: 'Surcharge'
  /** Absolute surcharge */
  absoluteSurcharge: Maybe<Money>
  relativeSurcharge: Maybe<Scalars['Float']['output']>
  surchargeType: SurchargeType
}

/** Represents a surcharge. Either relativeSurcharge or absoluteSurcharge has to be set, depending on the value in surchargeType */
export type SurchargeInput = {
  /** Absolute surcharge */
  absoluteSurcharge?: InputMaybe<MoneyInput>
  relativeSurcharge?: InputMaybe<Scalars['Float']['input']>
  surchargeType: SurchargeType
}

export enum SurchargeType {
  Absolute = 'ABSOLUTE',
  Relative = 'RELATIVE',
}

export type Tablet = {
  __typename?: 'Tablet'
  /** Tablet has development mode enabled, is in development MDM organization group */
  developmentMode: Maybe<Scalars['Boolean']['output']>
  imei: Scalars['ID']['output']
  /** Indicates if the tablet is a simulated tablet (not connected to the MDM) */
  isSimulated: Maybe<Scalars['Boolean']['output']>
  phoneNumber: Maybe<Scalars['String']['output']>
}

export type TabletPhoneNumberReplacedChange = FleetEntityChange & {
  __typename?: 'TabletPhoneNumberReplacedChange'
  backofficeUser: Maybe<BackofficeUser>
  changedAt: Scalars['DateTime']['output']
  changes: TabletPhoneNumberReplacedChangeFields
}

export type TabletPhoneNumberReplacedChangeFields = VehicleChangeFields & {
  __typename?: 'TabletPhoneNumberReplacedChangeFields'
  phoneNumberNew: Maybe<Scalars['String']['output']>
  phoneNumberOld: Maybe<Scalars['String']['output']>
  vehicleID: Scalars['ID']['output']
}

export type TabletReplacedChange = FleetEntityChange & {
  __typename?: 'TabletReplacedChange'
  backofficeUser: Maybe<BackofficeUser>
  changedAt: Scalars['DateTime']['output']
  changes: TabletReplacedChangeFields
}

export type TabletReplacedChangeFields = VehicleChangeFields & {
  __typename?: 'TabletReplacedChangeFields'
  tabletNew: Maybe<Tablet>
  tabletOld: Maybe<Tablet>
  vehicleID: Scalars['ID']['output']
}

export enum TaskActionType {
  Alert = 'ALERT',
  Task = 'TASK',
}

export enum TaskColumns {
  AssignedAt = 'ASSIGNED_AT',
  CreatedAt = 'CREATED_AT',
  CustomTimestamp = 'CUSTOM_TIMESTAMP',
  ResolvedAt = 'RESOLVED_AT',
  State = 'STATE',
  /** Sort by the hub display name the assigned vehicle is currently located at. */
  VehicleHubLocation = 'VEHICLE_HUB_LOCATION',
  VehicleLabel = 'VEHICLE_LABEL',
}

export type TaskNotification = {
  actionType: TaskActionType
  assigned: Maybe<TaskStateChangeDetails>
  createdAt: Scalars['DateTime']['output']
  fleetId: Maybe<Scalars['ID']['output']>
  foreignId: Scalars['ID']['output']
  id: Scalars['ID']['output']
  note: Maybe<TaskNotificationNote>
  notificationType: TaskNotificationType
  pended: Maybe<TaskStateChangeDetails>
  regionId: Maybe<Scalars['ID']['output']>
  resolved: Maybe<TaskStateChangeDetails>
  serviceAreaUUID: Scalars['ID']['output']
  severity: TaskNotificationSeverity
  stateChanges: Array<TaskStateChangeDetails>
  status: TaskNotificationStatus
  version: Scalars['Int']['output']
}

export type TaskNotificationList = ListResponse & {
  __typename?: 'TaskNotificationList'
  tasks: Array<TaskNotification>
  total: Scalars['Int']['output']
}

export type TaskNotificationNote = {
  __typename?: 'TaskNotificationNote'
  backofficeUser: Maybe<BackofficeUser>
  note: Scalars['String']['output']
  timestamp: Scalars['DateTime']['output']
}

export enum TaskNotificationSeverity {
  High = 'HIGH',
  Low = 'LOW',
  Normal = 'NORMAL',
}

export type TaskNotificationSorting = {
  column: TaskColumns
  order: SortOrder
}

export enum TaskNotificationStatus {
  InProgress = 'IN_PROGRESS',
  New = 'NEW',
  Pending = 'PENDING',
  Solved = 'SOLVED',
}

export enum TaskNotificationType {
  /** @deprecated Removed support for passenger authentication alerts after introduction of manual no show */
  FcPassengerAuthenticationFallbackRequestNotification = 'FC_PASSENGER_AUTHENTICATION_FALLBACK_REQUEST_NOTIFICATION',
  /** @deprecated Migrated to fcc-ad-alerts. Use FccAdAlert (type: FccAdAlertType.PASSENGER_UNBUCKLED) instead. */
  FcPassengerUnbuckled = 'FC_PASSENGER_UNBUCKLED',
  FcVehicleCabinSafetyCheckRequiredNotification = 'FC_VEHICLE_CABIN_SAFETY_CHECK_REQUIRED_NOTIFICATION',
  /** @deprecated Migrated to fcc-ad-alerts. Use FccAdAlert (type: FccAdAlertType.EMERGENCY_STOP) instead.  */
  FcVehicleEmergencyStopNotification = 'FC_VEHICLE_EMERGENCY_STOP_NOTIFICATION',
  FcVehicleOutOfServiceNotification = 'FC_VEHICLE_OUT_OF_SERVICE_NOTIFICATION',
  /** @deprecated Migrated to fcc-ad-alerts. Use FccAdAlert (type: FccAdAlertType.WAYPOINT_ATTENDANCE) instead.  */
  FcVehicleWaypointAttendance = 'FC_VEHICLE_WAYPOINT_ATTENDANCE',
  IvcCameraErrorCameraNotReachable = 'IVC_CAMERA_ERROR_CAMERA_NOT_REACHABLE',
  IvcCameraErrorCameraRecordingsNotChecked = 'IVC_CAMERA_ERROR_CAMERA_RECORDINGS_NOT_CHECKED',
  IvcCameraErrorCameraResponseTypeError = 'IVC_CAMERA_ERROR_CAMERA_RESPONSE_TYPE_ERROR',
  IvcCameraErrorCameraSdCardNotFound = 'IVC_CAMERA_ERROR_CAMERA_SD_CARD_NOT_FOUND',
  IvcCameraErrorCameraSdCardSizeMismatch = 'IVC_CAMERA_ERROR_CAMERA_SD_CARD_SIZE_MISMATCH',
  IvcCameraErrorCameraWebserverNotReachable = 'IVC_CAMERA_ERROR_CAMERA_WEBSERVER_NOT_REACHABLE',
  IvcCameraErrorNoMatchingRecordingsFound = 'IVC_CAMERA_ERROR_NO_MATCHING_RECORDINGS_FOUND',
  IvcCameraErrorNoTimedateFromCamera = 'IVC_CAMERA_ERROR_NO_TIMEDATE_FROM_CAMERA',
  IvcCameraErrorNtpNotConfigured = 'IVC_CAMERA_ERROR_NTP_NOT_CONFIGURED',
  IvcCdisErrorHostUnreachable = 'IVC_CDIS_ERROR_HOST_UNREACHABLE',
  IvcCdisErrorTimedOut = 'IVC_CDIS_ERROR_TIMED_OUT',
  IvcCdisNotReachable = 'IVC_CDIS_NOT_REACHABLE',
  IvcCdisNoMapAvailable = 'IVC_CDIS_NO_MAP_AVAILABLE',
  IvcInternetNotReachable = 'IVC_INTERNET_NOT_REACHABLE',
  IvcRouterNotReachable = 'IVC_ROUTER_NOT_REACHABLE',
  IvcRouterOffline = 'IVC_ROUTER_OFFLINE',
  IvcSdcardDeviceNotPresent = 'IVC_SDCARD_DEVICE_NOT_PRESENT',
  IvcSdcardNotMounted = 'IVC_SDCARD_NOT_MOUNTED',
  IvcSdcardPartitionIsNotExt4 = 'IVC_SDCARD_PARTITION_IS_NOT_EXT4',
  IvcSdcardPartitionNotPresent = 'IVC_SDCARD_PARTITION_NOT_PRESENT',
  SamRoadBlockageReported = 'SAM_ROAD_BLOCKAGE_REPORTED',
  /** @deprecated Will be split into various SHIFT_XXX enum values */
  ShiftDeviationNotification = 'SHIFT_DEVIATION_NOTIFICATION',
  ShiftDrivingWithoutBreakNotification = 'SHIFT_DRIVING_WITHOUT_BREAK_NOTIFICATION',
  ShiftMissingBreakStartedNotification = 'SHIFT_MISSING_BREAK_STARTED_NOTIFICATION',
  ShiftMissingHubCheckinNotification = 'SHIFT_MISSING_HUB_CHECKIN_NOTIFICATION',
  ShiftMissingHubCheckoutNotification = 'SHIFT_MISSING_HUB_CHECKOUT_NOTIFICATION',
  ShiftPoolingOffDepartureNotification = 'SHIFT_POOLING_OFF_DEPARTURE_NOTIFICATION',
  ShiftTimesInvalidBreakNotification = 'SHIFT_TIMES_INVALID_BREAK_NOTIFICATION',
  /** @deprecated Not emitted anymore, use SHIFT_TIMES_MISSING_CLOCK_EVENT_NOTIFICATION instead */
  ShiftTimesMissingBreakEndNotification = 'SHIFT_TIMES_MISSING_BREAK_END_NOTIFICATION',
  ShiftTimesMissingClockEventNotification = 'SHIFT_TIMES_MISSING_CLOCK_EVENT_NOTIFICATION',
  ShiftTimesShiftTypeChangeNotification = 'SHIFT_TIMES_SHIFT_TYPE_CHANGE_NOTIFICATION',
  StopAccessibilityDownvotedByDrivers = 'STOP_ACCESSIBILITY_DOWNVOTED_BY_DRIVERS',
  StopAccessibilityValidationFailed = 'STOP_ACCESSIBILITY_VALIDATION_FAILED',
  StopActivationFailedNotification = 'STOP_ACTIVATION_FAILED_NOTIFICATION',
  StopAreaMissingActiveStopsNotification = 'STOP_AREA_MISSING_ACTIVE_STOPS_NOTIFICATION',
  StopDownVotedByDrivers = 'STOP_DOWN_VOTED_BY_DRIVERS',
  StopPotentiallyUnreachable = 'STOP_POTENTIALLY_UNREACHABLE',
  StopValidationFailed = 'STOP_VALIDATION_FAILED',
  TripPrebookingNoAssignment = 'TRIP_PREBOOKING_NO_ASSIGNMENT',
  Vehicle_12VBatteryCriticalNotification = 'VEHICLE_12V_BATTERY_CRITICAL_NOTIFICATION',
  VehicleCdisInterruptedNotification = 'VEHICLE_CDIS_INTERRUPTED_NOTIFICATION',
  VehicleChargingErrorNotification = 'VEHICLE_CHARGING_ERROR_NOTIFICATION',
  VehicleChargingNeededNotification = 'VEHICLE_CHARGING_NEEDED_NOTIFICATION',
  VehicleLowStateOfChargeNotification = 'VEHICLE_LOW_STATE_OF_CHARGE_NOTIFICATION',
  VehicleNoBookingNotification = 'VEHICLE_NO_BOOKING_NOTIFICATION',
  VehicleNoHubReturnNotification = 'VEHICLE_NO_HUB_RETURN_NOTIFICATION',
  VehicleOutOfServiceAreaNotification = 'VEHICLE_OUT_OF_SERVICE_AREA_NOTIFICATION',
  VehicleWithoutDriverNotification = 'VEHICLE_WITHOUT_DRIVER_NOTIFICATION',
}

export type TaskStateChangeDetails = {
  __typename?: 'TaskStateChangeDetails'
  backofficeUser: Maybe<BackofficeUser>
  backofficeUserId: Maybe<Scalars['ID']['output']>
  initiatedBySystem: Scalars['Boolean']['output']
  timestamp: Maybe<Scalars['DateTime']['output']>
  to: TaskNotificationStatus
}

export type TelematicBoxState = {
  __typename?: 'TelematicBoxState'
  batteryEnergy: Maybe<Scalars['Float']['output']>
  /** The voltage of the 12V battery */
  batteryVoltage: Maybe<Scalars['Float']['output']>
  /** A representation of the physical central lock. Independent from our purely digital representation of vehicle interactions */
  centralLock: Maybe<CentralLockState>
  chargingMode: Maybe<ChargingMode>
  climateControlActive: Maybe<Scalars['Boolean']['output']>
  connectedState: Maybe<ConnectedState>
  consumedEnergy: Maybe<Scalars['Float']['output']>
  cruisingRange: Maybe<Scalars['Float']['output']>
  doors: Maybe<DoorState>
  /** State of health of the battery of CDIS vehicles */
  highVoltageBatteryHealth: Maybe<Scalars['Float']['output']>
  /** Only for electric vehicles, also referred to as State of Charge (SoC). Provided in % */
  highVoltageBatteryLevel: Maybe<Scalars['Float']['output']>
  ignition: Maybe<IgnitionState>
  interiorTemperature: Maybe<Scalars['Float']['output']>
  /** The vehicle key needs to be inserted into a specific holder in the driver cabin. */
  keyFob: Maybe<KeyFobState>
  location: Maybe<Location>
  locationTimestamp: Maybe<Scalars['DateTime']['output']>
  mileage: Maybe<Scalars['Float']['output']>
  powerPlug: Maybe<PowerplugState>
  /** How many kilometers the vehicle can still go without getting charged */
  remainingCruisingRange: Maybe<Scalars['Float']['output']>
  sdsMode: Maybe<SdsMode>
  speed: Maybe<Scalars['Float']['output']>
  targetTemperature: Maybe<Scalars['Float']['output']>
  timestamp: Maybe<Scalars['DateTime']['output']>
  windows: Maybe<WindowState>
}

export type TelematicBoxStateInput = {
  batteryVoltage: Scalars['Float']['input']
  centralLock: CentralLockState
  chargingMode: ChargingMode
  climateControlActive: Scalars['Boolean']['input']
  connectedState: ConnectedState
  cruisingRange: Scalars['Float']['input']
  doors: DoorState
  highVoltageBatteryHealth: Scalars['Float']['input']
  highVoltageBatteryLevel: Scalars['Float']['input']
  ignition: IgnitionState
  interiorTemperature: Scalars['Float']['input']
  keyFob: KeyFobState
  location: LocationInput
  locationTimestamp: Scalars['DateTime']['input']
  mileage: Scalars['Float']['input']
  powerPlug: PowerplugState
  targetTemperature: Scalars['Float']['input']
  windows: WindowState
}

export type TemporaryBackofficeSession = {
  __typename?: 'TemporaryBackofficeSession'
  actorEmail: Scalars['String']['output']
  actorId: Scalars['String']['output']
  actorName: Scalars['String']['output']
  closedAt: Maybe<Scalars['DateTime']['output']>
  closureNotes: Maybe<Scalars['String']['output']>
  createdAt: Scalars['DateTime']['output']
  customerDataModified: Maybe<Scalars['Boolean']['output']>
  expiresAt: Scalars['DateTime']['output']
  id: Scalars['ID']['output']
  lifecycleEvents: Array<TemporaryBackofficeSessionLifecycleEvent>
  permissions: TemporaryBackofficeSessionPermissions
  reason: Scalars['String']['output']
  status: TemporaryBackofficeSessionStatus
  targetUserEmail: Maybe<Scalars['String']['output']>
  targetUserName: Maybe<Scalars['String']['output']>
  ticketReference: Maybe<Scalars['String']['output']>
  type: TemporaryBackofficeSessionType
}

export type TemporaryBackofficeSessionLifecycleEvent = {
  __typename?: 'TemporaryBackofficeSessionLifecycleEvent'
  expiresAt: Maybe<Scalars['DateTime']['output']>
  timestamp: Scalars['DateTime']['output']
  type: TemporaryBackofficeSessionLifecycleEventType
}

export enum TemporaryBackofficeSessionLifecycleEventType {
  Closed = 'closed',
  Expired = 'expired',
  Prolonged = 'prolonged',
  Started = 'started',
}

export type TemporaryBackofficeSessionPermissions = {
  __typename?: 'TemporaryBackofficeSessionPermissions'
  allFleets: Scalars['Boolean']['output']
  customerTenants: Array<Scalars['String']['output']>
  fleets: Array<Scalars['String']['output']>
  /** Resolves `fleets` (IDs) to their full fleet objects. */
  fullFleets: Maybe<Array<BackofficeUserManagementFleet>>
  operatorTenants: Array<Scalars['String']['output']>
  organizationId: Scalars['String']['output']
  /**
   * Display name of the organization identified by `organizationId`, resolved
   * regardless of whether the requesting actor has access to that organization.
   */
  organizationName: Maybe<Scalars['String']['output']>
  ridepoolingServiceTenants: Array<Scalars['String']['output']>
  timedGroups: Array<BackofficeUserTimeGroup>
  timedServiceAreas: Array<BackofficeUserTimeArea>
}

export enum TemporaryBackofficeSessionStatus {
  Active = 'active',
  Closed = 'closed',
  Expired = 'expired',
  Opened = 'opened',
}

export enum TemporaryBackofficeSessionType {
  Impersonation = 'impersonation',
  ScopedAccess = 'scopedAccess',
}

export enum TestDoorActuationError {
  SlidingDoorDeactivated = 'SLIDING_DOOR_DEACTIVATED',
  UnknownError = 'UNKNOWN_ERROR',
  VehicleMoving = 'VEHICLE_MOVING',
  VehicleNotParked = 'VEHICLE_NOT_PARKED',
}

export enum TestTaskNotificationSeverity {
  High = 'HIGH',
  Low = 'LOW',
  Normal = 'NORMAL',
}

export type TimeManagementNotification = TaskNotification & {
  __typename?: 'TimeManagementNotification'
  actionType: TaskActionType
  assigned: Maybe<TaskStateChangeDetails>
  createdAt: Scalars['DateTime']['output']
  employee: Maybe<Employee>
  fleetId: Maybe<Scalars['ID']['output']>
  foreignId: Scalars['ID']['output']
  id: Scalars['ID']['output']
  note: Maybe<TaskNotificationNote>
  notificationType: TaskNotificationType
  pended: Maybe<TaskStateChangeDetails>
  regionId: Maybe<Scalars['ID']['output']>
  resolved: Maybe<TaskStateChangeDetails>
  serviceAreaUUID: Scalars['ID']['output']
  severity: TaskNotificationSeverity
  shift: Maybe<Shift>
  stateChanges: Array<TaskStateChangeDetails>
  status: TaskNotificationStatus
  vehicle: Maybe<Vehicle>
  version: Scalars['Int']['output']
}

export type TimeOfDayInterval = {
  __typename?: 'TimeOfDayInterval'
  from: Scalars['TimeOfDay']['output']
  to: Scalars['TimeOfDay']['output']
}

export type TimeOfDayIntervalInput = {
  from: Scalars['TimeOfDay']['input']
  to: Scalars['TimeOfDay']['input']
}

export type TimeRange = {
  __typename?: 'TimeRange'
  from: Scalars['DateTime']['output']
  recurring: Maybe<Scalars['String']['output']>
  to: Maybe<Scalars['DateTime']['output']>
}

export type TimeRangeInput = {
  from: Scalars['DateTime']['input']
  recurring?: InputMaybe<Scalars['String']['input']>
  to?: InputMaybe<Scalars['DateTime']['input']>
}

export enum TireWarning {
  Acoustics = 'ACOUSTICS',
  CalibrateTirePressures = 'CALIBRATE_TIRE_PRESSURES',
  CalibrateTirePressureTextGong = 'CALIBRATE_TIRE_PRESSURE_TEXT_GONG',
  CalibrateTirePressureTextGongLamp = 'CALIBRATE_TIRE_PRESSURE_TEXT_GONG_LAMP',
  FrontLeftWarningLevel_1 = 'FRONT_LEFT_WARNING_LEVEL_1',
  FrontLeftWarningLevel_2 = 'FRONT_LEFT_WARNING_LEVEL_2',
  FrontLeftWarningLevel_3 = 'FRONT_LEFT_WARNING_LEVEL_3',
  FrontLeftWarningLevelLampText = 'FRONT_LEFT_WARNING_LEVEL_LAMP_TEXT',
  FrontRightWarningLevel_1 = 'FRONT_RIGHT_WARNING_LEVEL_1',
  FrontRightWarningLevel_2 = 'FRONT_RIGHT_WARNING_LEVEL_2',
  FrontRightWarningLevel_3 = 'FRONT_RIGHT_WARNING_LEVEL_3',
  FrontRightWarningLevelLampText = 'FRONT_RIGHT_WARNING_LEVEL_LAMP_TEXT',
  GeneralWarningLevel_1 = 'GENERAL_WARNING_LEVEL_1',
  GeneralWarningLevel_2 = 'GENERAL_WARNING_LEVEL_2',
  GeneralWarningLevel_3 = 'GENERAL_WARNING_LEVEL_3',
  GeneralWarningLevelLampText = 'GENERAL_WARNING_LEVEL_LAMP_TEXT',
  IndicatorLight = 'INDICATOR_LIGHT',
  NoWarning = 'NO_WARNING',
  RearLeftWarningLevel_1 = 'REAR_LEFT_WARNING_LEVEL_1',
  RearLeftWarningLevel_2 = 'REAR_LEFT_WARNING_LEVEL_2',
  RearLeftWarningLevel_3 = 'REAR_LEFT_WARNING_LEVEL_3',
  RearLeftWarningLevelLampText = 'REAR_LEFT_WARNING_LEVEL_LAMP_TEXT',
  RearRightWarningLevel_1 = 'REAR_RIGHT_WARNING_LEVEL_1',
  RearRightWarningLevel_2 = 'REAR_RIGHT_WARNING_LEVEL_2',
  RearRightWarningLevel_3 = 'REAR_RIGHT_WARNING_LEVEL_3',
  RearRightWarningLevelLampText = 'REAR_RIGHT_WARNING_LEVEL_LAMP_TEXT',
  SystemFailure = 'SYSTEM_FAILURE',
  SystemFailureLampText = 'SYSTEM_FAILURE_LAMP_TEXT',
  TireChangeDetected = 'TIRE_CHANGE_DETECTED',
}

export type TmpTrip = {
  __typename?: 'TmpTrip'
  allWaypointsMode: Scalars['Boolean']['output']
  cabinReadyV2Enabled: Scalars['Boolean']['output']
  id: Scalars['ID']['output']
  metadata: Array<Array<Scalars['String']['output']>>
  safetyDriverTripConfirmationState: SafetyDriverTripConfirmationState
  segments: Array<TripSegmentWithStatus>
  status: TripStatus
  terminationInfo: Maybe<TripTerminationInfo>
  type: TripType
  vin: Scalars['String']['output']
}

export type TranscriptTurn = {
  __typename?: 'TranscriptTurn'
  speaker: TranscriptTurnSpeaker
  spokenAtMs: Maybe<Scalars['Float']['output']>
  text: Scalars['String']['output']
}

export type TranscriptTurnInput = {
  speaker: TranscriptTurnSpeaker
  spokenAtMs?: InputMaybe<Scalars['Float']['input']>
  text: Scalars['String']['input']
}

export enum TranscriptTurnSpeaker {
  SpeakerDriver = 'SPEAKER_DRIVER',
  SpeakerInvalid = 'SPEAKER_INVALID',
  SpeakerVoicebot = 'SPEAKER_VOICEBOT',
}

export enum TranscriptionVendor {
  TranscriptionVendorDeepgram = 'TRANSCRIPTION_VENDOR_DEEPGRAM',
  TranscriptionVendorElevenlabs = 'TRANSCRIPTION_VENDOR_ELEVENLABS',
  TranscriptionVendorInvalid = 'TRANSCRIPTION_VENDOR_INVALID',
  TranscriptionVendorSfSpeechRecognizer = 'TRANSCRIPTION_VENDOR_SF_SPEECH_RECOGNIZER',
  TranscriptionVendorSpeechAnalyzer = 'TRANSCRIPTION_VENDOR_SPEECH_ANALYZER',
  TranscriptionVendorWebSpeechApi = 'TRANSCRIPTION_VENDOR_WEB_SPEECH_API',
}

/** Input for triggering manual arrival of an ad vehicle */
export type TriggerManualArrivalForAdVehicleInput = {
  /** The ID of the vehicle */
  fleetVehicle: Scalars['ID']['input']
}

export type TriggerTaskNotificationInput = {
  area_id?: InputMaybe<Scalars['ID']['input']>
  employee_id?: InputMaybe<Scalars['ID']['input']>
  fleetId?: InputMaybe<Scalars['ID']['input']>
  regionId?: InputMaybe<Scalars['ID']['input']>
  serviceAreaUUID?: InputMaybe<Scalars['ID']['input']>
  severity?: InputMaybe<TestTaskNotificationSeverity>
  shift_id?: InputMaybe<Scalars['ID']['input']>
  stop_id?: InputMaybe<Scalars['ID']['input']>
  stop_id_2?: InputMaybe<Scalars['ID']['input']>
  tenant?: InputMaybe<Scalars['String']['input']>
  timestamp?: InputMaybe<Scalars['DateTime']['input']>
  trip_id?: InputMaybe<Scalars['ID']['input']>
  /** One of TaskNotificationType */
  type: Scalars['String']['input']
  vehicle_id?: InputMaybe<Scalars['ID']['input']>
}

export type Trip = {
  __typename?: 'Trip'
  /** Whether the trip is active (not in an end state). */
  active: Scalars['Boolean']['output']
  /** Amount of people age 14 or older. */
  adults: Scalars['Int']['output']
  /** Amount of people younger than 14. */
  children: Scalars['Int']['output']
  /** Moment of creation of the Trip. */
  createdAt: Scalars['DateTime']['output']
  /**
   * The customer who ordered the trip.
   * @deprecated Use customerV2.
   */
  customer: Maybe<Customer>
  /** The id of the customer of the trip. */
  customerId: Scalars['ID']['output']
  /** The customer who ordered the trip. */
  customerV2: CustomerV2
  /** The moment when the customer was delivered. */
  deliveredAt: Maybe<Scalars['DateTime']['output']>
  /** The location where the customer has actually been delivered. */
  deliveredLocation: Maybe<Location>
  /** Transfer information for the delivery. */
  delivery: TripTransferInformation
  /** The committed delivery stop, null until a delivery stop was committed to. */
  deliveryStop: Maybe<TripStop>
  /** The delivery window at the time of trip creation. */
  deliveryWindowAtCreation: Maybe<DateTimeInterval>
  /** Coordinates and street name (optional POI) of the place where the passenger wants to go after being dropped off. */
  destination: TripNamedLocation
  /** The driver of the vehicle at the time of the trip, this is undefined until Pickup or NoShow Event and for non-AD trips. */
  driver: Maybe<Employee>
  /** The id of the driver of the vehicle, this is undefined until Pickup or NoShow Event and for non-AD trips. */
  driverId: Maybe<Scalars['ID']['output']>
  /** Indicates the driving system of vehicles acceptable to the user. */
  drivingSystem: TripDrivingSystem
  /** The earliest pickup time at the time of trip creation. */
  earliestPickupTimeAtCreation: Maybe<Scalars['DateTime']['output']>
  /**
   * Parameters for the 'Express' service class.
   * @deprecated see serviceClass property
   */
  express: Scalars['Boolean']['output']
  /** The fixed vehicle, if already specified. */
  fixedVehicle: Maybe<Vehicle>
  /** The fixed vehicle ID. */
  fixedVehicleId: Maybe<Scalars['ID']['output']>
  /** The globally unique id of the trip. */
  id: Scalars['ID']['output']
  /** The globally unique name of the trip. */
  name: Scalars['ID']['output']
  /** The location of the vehicle at the moment of a no-show. */
  notShownUpLocation: Maybe<Location>
  /** The time when the customer's order is received by booking. */
  orderTime: Scalars['DateTime']['output']
  /** Coordinates and street name (optional POI) of the place where the passenger starts walking towards the next virtual stop. */
  origin: TripNamedLocation
  paymentDetails: Maybe<PaymentDetails>
  /** The moment when the customer was picked up. */
  pickedUpAt: Maybe<Scalars['DateTime']['output']>
  /** The location where the customer has actually been picked up. */
  pickedUpLocation: Maybe<Location>
  /** Transfer information for the pickup. */
  pickup: TripTransferInformation
  /** The committed pickup stop, this is null until a pickup stop was committed to. */
  pickupStop: Maybe<TripStop>
  /** The pickup window at the time of trip creation. */
  pickupWindowAtCreation: Maybe<DateTimeInterval>
  /** If the trip was pre-booked. */
  prebooked: Scalars['Boolean']['output']
  /** Price of the trip. */
  price: Maybe<Money>
  /** The ridepooling service tenant that owns the trip. */
  ridepoolingServiceTenant: Scalars['TripRidepoolingServiceTenant']['output']
  /** Latest estimated pickup and dropoff schedule. This is only set after first vehicle assignment. */
  schedule: Maybe<TripSchedule>
  /** The seat configuration for the trip. */
  seatInfo: TripSeatInfo
  /** The service area in which the trip is executed. */
  serviceArea: Maybe<ServiceArea>
  /** The id of the service area in which the trip is executed. */
  serviceAreaId: Scalars['String']['output']
  /** The service class of the trip */
  serviceClass: Maybe<Scalars['String']['output']>
  /** Current state of the trip. */
  state: TripExecutionStatus
  /** The customer tenant the trip was ordered through. */
  tenant: Scalars['TripTenant']['output']
  /** Moment of latest update of the Trip. */
  updatedAt: Scalars['DateTime']['output']
  /** The assigned vehicle, this is null until a vehicle is assigned. */
  vehicles: Array<TripVehicle>
}

export type TripAnnotation = {
  __typename?: 'TripAnnotation'
  annotationId: Scalars['String']['output']
  answeredAtMs: Maybe<Scalars['Float']['output']>
  answeredBy: Maybe<Scalars['String']['output']>
  audioS3Uri: Scalars['String']['output']
  classification: Maybe<AnnotationClassification>
  driverId: Scalars['String']['output']
  jiraIssueKey: Maybe<Scalars['String']['output']>
  languageCode: Maybe<Scalars['String']['output']>
  location: TripGeolocation
  recordedAtMs: Scalars['Float']['output']
  resolution: Maybe<AnnotationResolution>
  severity: TripAnnotationSeverity
  transcript: Maybe<Scalars['String']['output']>
  transcriptTurns: Array<TranscriptTurn>
  transcriptionStatus: TripAnnotationTranscriptionStatus
  transcriptionVendor: Maybe<TranscriptionVendor>
  tripId: Maybe<Scalars['String']['output']>
  vehicleId: Scalars['String']['output']
  vtrId: Maybe<Scalars['String']['output']>
}

export type TripAnnotationAudio = {
  __typename?: 'TripAnnotationAudio'
  expiresAtMs: Maybe<Scalars['Float']['output']>
  noAudioReason: Maybe<TripAnnotationNoAudioReason>
  url: Maybe<Scalars['String']['output']>
}

export enum TripAnnotationNoAudioReason {
  ClipMissing = 'CLIP_MISSING',
  ForeignBucket = 'FOREIGN_BUCKET',
  Unknown = 'UNKNOWN',
  UnreadableUri = 'UNREADABLE_URI',
}

export enum TripAnnotationSeverity {
  TripAnnotationSeverityHigh = 'TRIP_ANNOTATION_SEVERITY_HIGH',
  TripAnnotationSeverityInvalid = 'TRIP_ANNOTATION_SEVERITY_INVALID',
  TripAnnotationSeverityLow = 'TRIP_ANNOTATION_SEVERITY_LOW',
  TripAnnotationSeverityMedium = 'TRIP_ANNOTATION_SEVERITY_MEDIUM',
  TripAnnotationSeverityNonPerformant = 'TRIP_ANNOTATION_SEVERITY_NON_PERFORMANT',
}

export enum TripAnnotationTranscriptionStatus {
  TranscriptionStatusCompleted = 'TRANSCRIPTION_STATUS_COMPLETED',
  TranscriptionStatusFailed = 'TRANSCRIPTION_STATUS_FAILED',
  TranscriptionStatusInvalid = 'TRANSCRIPTION_STATUS_INVALID',
  TranscriptionStatusInProgress = 'TRANSCRIPTION_STATUS_IN_PROGRESS',
  TranscriptionStatusPending = 'TRANSCRIPTION_STATUS_PENDING',
  TranscriptionStatusSkipped = 'TRANSCRIPTION_STATUS_SKIPPED',
}

export enum TripCompletionStatus {
  CompletionStatusCancelled = 'COMPLETION_STATUS_CANCELLED',
  CompletionStatusCompleted = 'COMPLETION_STATUS_COMPLETED',
  CompletionStatusFailed = 'COMPLETION_STATUS_FAILED',
  CompletionStatusInvalid = 'COMPLETION_STATUS_INVALID',
  CompletionStatusPulledOver = 'COMPLETION_STATUS_PULLED_OVER',
  CompletionStatusUnfinished = 'COMPLETION_STATUS_UNFINISHED',
}

export type TripConnection = {
  __typename?: 'TripConnection'
  /** Models a Relay connection edge for the type Trip. */
  edges: Array<TripEdge>
  /** Models pagination info for a connection. */
  pageInfo: PageInfo
}

export type TripDestination = {
  __typename?: 'TripDestination'
  desiredAddress: Scalars['String']['output']
  desiredLocation: Maybe<TripGeolocation>
  destinationBehavior: Maybe<TripDestinationBehavior>
  name: Scalars['String']['output']
  oddElementType: TripOddElementType
  snappedAddress: Scalars['String']['output']
  snappedLocation: Maybe<TripGeolocation>
}

export type TripDestinationBehavior = {
  __typename?: 'TripDestinationBehavior'
  fpa: Maybe<TripDestinationFpa>
  stopType: TripStopType
  types: Array<DestinationType>
}

export type TripDestinationBehaviorInput = {
  fpa?: InputMaybe<TripDestinationFpaInput>
  stopType: TripStopType
  types: Array<DestinationType>
}

export type TripDestinationFpa = {
  __typename?: 'TripDestinationFpa'
  id: Scalars['String']['output']
  name: Scalars['String']['output']
  polygon: Maybe<Array<TripGeolocation>>
  pqls: Array<TripDestinationPql>
}

export type TripDestinationFpaInput = {
  id: Scalars['String']['input']
  name: Scalars['String']['input']
}

export type TripDestinationInput = {
  desiredAddress?: InputMaybe<Scalars['String']['input']>
  desiredLocation?: InputMaybe<TripGeolocationInput>
  destinationBehavior?: InputMaybe<TripDestinationBehaviorInput>
  name: Scalars['String']['input']
  oddElementType?: InputMaybe<TripOddElementType>
  snappedAddress?: InputMaybe<Scalars['String']['input']>
  snappedLocation?: InputMaybe<TripGeolocationInput>
}

export type TripDestinationPql = {
  __typename?: 'TripDestinationPql'
  id: Scalars['String']['output']
  location: Maybe<TripGeolocation>
  name: Scalars['String']['output']
}

export type TripDestinationPqlInput = {
  id: Scalars['String']['input']
  location?: InputMaybe<TripGeolocationInput>
  name: Scalars['String']['input']
}

export type TripDetails = {
  __typename?: 'TripDetails'
  integrationId: Scalars['String']['output']
}

export type TripDetailsFilterInput = {
  endTimeMs?: InputMaybe<Scalars['String']['input']>
  integrationId?: InputMaybe<Scalars['String']['input']>
  riderName?: InputMaybe<Scalars['String']['input']>
  riderPhoneNumber?: InputMaybe<Scalars['String']['input']>
  startTimeMs?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<TripStatus>
  tripIds?: InputMaybe<Array<Scalars['String']['input']>>
  vins?: InputMaybe<Array<Scalars['String']['input']>>
}

export enum TripDrivingSystem {
  /** Autonomous vehicle. */
  Autonomous = 'Autonomous',
  /** Human driver vehicle. */
  Manual = 'Manual',
}

export type TripEdge = {
  __typename?: 'TripEdge'
  /** Pagination cursor for the current edge. */
  cursor: Scalars['String']['output']
  /** Trip for the current edge. */
  node: Trip
}

export type TripEta = {
  __typename?: 'TripEta'
  remainingMeters: Scalars['Float']['output']
  remainingSeconds: Scalars['Int']['output']
}

export enum TripExecutionStatus {
  /** The service has been aborted by MOIA. This means that the trip will not be executed. */
  Aborted = 'Aborted',
  /** The trip was accepted. This means that the system will try to execute the trip. */
  Accepted = 'Accepted',
  /** The customer is sitting in the car. */
  Boarded = 'Boarded',
  /** The AD vehicle is at the pickup stop and the customer completed boarding authentication. */
  BoardingAuthenticationCompleted = 'BoardingAuthenticationCompleted',
  /** The trip was cancelled by the customer. This means that the trip will not be executed. */
  Cancelled = 'Cancelled',
  /** The trip was cancelled by the integrator. This means that the trip will not be executed. */
  CancelledByIntegrator = 'CancelledByIntegrator',
  /** The customer was delivered. */
  Delivered = 'Delivered',
  /** A vehicle has been found and assigned. */
  Dispatched = 'Dispatched',
  /** The customer did not show up at the pickup stop. This means that the trip will not be executed. */
  NoShow = 'NoShow',
  /** The AD vehicle has arrived at the pickup stop and is ready for the boarding authentication. */
  ReadyForBoardingAuthentication = 'ReadyForBoardingAuthentication',
  /** The trip could not be committed and is rejected. This means that the trip will not be executed. */
  Rejected = 'Rejected',
  /** The trip lost its vehicle assignment and could not be saved. This means that the trip will not be executed. */
  TripLost = 'TripLost',
  /** Initial state after ordering a trip. */
  Uncommitted = 'Uncommitted',
}

export type TripFeedback = {
  __typename?: 'TripFeedback'
  feedback: Scalars['String']['output']
  feedbackType: FeedbackType
  id: Scalars['String']['output']
  rating: Scalars['Int']['output']
}

export type TripFeedbackInput = {
  feedback: Scalars['String']['input']
  feedbackType: FeedbackType
  rating: Scalars['Int']['input']
}

export type TripFilterInput = {
  type: TripType
}

export type TripGeneratorCreateTemplateInput = {
  name: Scalars['String']['input']
  properties: TripGeneratorTemplatePropertiesInput
}

export type TripGeneratorDeleteTemplateResult = {
  __typename?: 'TripGeneratorDeleteTemplateResult'
  id: Scalars['ID']['output']
  unsubscribedVehiclesCount: Scalars['Int']['output']
}

export type TripGeneratorGeoPolygon = {
  __typename?: 'TripGeneratorGeoPolygon'
  coordinates: Array<TripGeneratorGeolocation>
}

export type TripGeneratorGeoPolygonInput = {
  coordinates: Array<TripGeneratorGeolocationInput>
}

export type TripGeneratorGeolocation = {
  __typename?: 'TripGeneratorGeolocation'
  latitude: Scalars['Float']['output']
  longitude: Scalars['Float']['output']
}

export type TripGeneratorGeolocationInput = {
  latitude: Scalars['Float']['input']
  longitude: Scalars['Float']['input']
}

export type TripGeneratorKizDocument = {
  __typename?: 'TripGeneratorKizDocument'
  polygons: Array<TripGeneratorGeoPolygon>
}

export type TripGeneratorKizDocumentInput = {
  polygons: Array<TripGeneratorGeoPolygonInput>
}

export type TripGeneratorTemplate = {
  __typename?: 'TripGeneratorTemplate'
  createdBy: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  properties: Maybe<TripGeneratorTemplateProperties>
  subscribedVehicles: Array<Scalars['String']['output']>
}

export type TripGeneratorTemplateProperties = {
  __typename?: 'TripGeneratorTemplateProperties'
  disableRollThrough: Scalars['Boolean']['output']
  expiresMs: Maybe<Scalars['String']['output']>
  favLocTag: Maybe<Scalars['String']['output']>
  fleetId: Maybe<Scalars['String']['output']>
  infinite: Scalars['Boolean']['output']
  kizDocument: Maybe<TripGeneratorKizDocument>
  maxTripSegments: Scalars['Int']['output']
  metropolisId: Scalars['Int']['output']
  minimumDistance: Scalars['Int']['output']
  numTripSegments: Scalars['Int']['output']
  savedTripId: Maybe<Scalars['String']['output']>
  tenantId: Maybe<Scalars['String']['output']>
  useLyftPrepositioning: Scalars['Boolean']['output']
}

export type TripGeneratorTemplatePropertiesInput = {
  disableRollThrough?: InputMaybe<Scalars['Boolean']['input']>
  expiresMs?: InputMaybe<Scalars['String']['input']>
  fleetId?: InputMaybe<Scalars['String']['input']>
  infinite?: InputMaybe<Scalars['Boolean']['input']>
  kizDocument?: InputMaybe<TripGeneratorKizDocumentInput>
  metropolisId: Scalars['Int']['input']
  minimumDistance?: InputMaybe<Scalars['Int']['input']>
  numTripSegments: Scalars['Int']['input']
  savedTripId?: InputMaybe<Scalars['String']['input']>
}

export type TripGeneratorUpdateTemplateInput = {
  id: Scalars['ID']['input']
  name?: InputMaybe<Scalars['String']['input']>
  properties?: InputMaybe<TripGeneratorTemplatePropertiesInput>
}

export type TripGeneratorVehicleSubscription = {
  __typename?: 'TripGeneratorVehicleSubscription'
  fleetId: Scalars['String']['output']
  templateId: Scalars['String']['output']
  vin: Scalars['String']['output']
}

export type TripGeolocation = {
  __typename?: 'TripGeolocation'
  heading: Scalars['Float']['output']
  latitude: Scalars['Float']['output']
  longitude: Scalars['Float']['output']
}

export type TripGeolocationInput = {
  heading?: InputMaybe<Scalars['Float']['input']>
  latitude: Scalars['Float']['input']
  longitude: Scalars['Float']['input']
}

export type TripHistoryEntriesResponse = {
  __typename?: 'TripHistoryEntriesResponse'
  tripHistoryEntries: Array<TripHistoryEntry>
}

export type TripHistoryEntry = {
  __typename?: 'TripHistoryEntry'
  cancellationType: Maybe<CancellationType>
  cardData: Maybe<CardData>
  completionTimestamp: Maybe<Scalars['Instant']['output']>
  customerId: Scalars['String']['output']
  customerTenant: Scalars['String']['output']
  destination: Maybe<NamedLocation>
  failedReason: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  invoiceIdShort: Maybe<Scalars['String']['output']>
  offer: Maybe<Offer>
  orderTimestamp: Maybe<Scalars['Instant']['output']>
  origin: Maybe<NamedLocation>
  passengers: Maybe<Passengers>
  pickupTimestamp: Maybe<Scalars['Instant']['output']>
  price: Maybe<TripHistoryEntryPrice>
  seatInfo: Maybe<SeatInfo>
  serviceAreaId: Maybe<Scalars['String']['output']>
  ttl: Maybe<Scalars['Instant']['output']>
}

export type TripHistoryEntryLocation = {
  __typename?: 'TripHistoryEntryLocation'
  lat: Maybe<Scalars['Float']['output']>
  lon: Maybe<Scalars['Float']['output']>
}

export type TripHistoryEntryPrice = {
  __typename?: 'TripHistoryEntryPrice'
  amount: Maybe<Scalars['String']['output']>
  currency: Maybe<Scalars['String']['output']>
}

export type TripHistoryFilterInput = {
  timeRangeEndMs?: InputMaybe<Scalars['Float']['input']>
  timeRangeStartMs?: InputMaybe<Scalars['Float']['input']>
  vin?: InputMaybe<Scalars['String']['input']>
}

export type TripHistoryGeolocation = {
  __typename?: 'TripHistoryGeolocation'
  latitude: Scalars['Float']['output']
  longitude: Scalars['Float']['output']
}

export enum TripInterruptions {
  ImmediateStopReq = 'IMMEDIATE_STOP_REQ',
  NoInterruption = 'NO_INTERRUPTION',
  PulloverAsapReq = 'PULLOVER_ASAP_REQ',
  PulloverReq = 'PULLOVER_REQ',
  ReducedDynamics = 'REDUCED_DYNAMICS',
}

export type TripNamedLocation = {
  __typename?: 'TripNamedLocation'
  /** The location as latitude and longitude. */
  location: Location
  /** Street name and number, used for trip-history and domain events. */
  primaryAddress: Scalars['String']['output']
  /** The name of a point of interest (e.g. Hamburg Airport). */
  primaryPoiName: Maybe<Scalars['String']['output']>
  /** Secondary address line, usually containing zip code and city, might also contain the country. */
  secondaryAddress: Maybe<Scalars['String']['output']>
  /** Additional information for a point of interest (e.g. City, Country). */
  secondaryPoiName: Maybe<Scalars['String']['output']>
}

export enum TripOddElementType {
  OddElementTypeAllWayStop = 'ODD_ELEMENT_TYPE_ALL_WAY_STOP',
  OddElementTypeBusStop = 'ODD_ELEMENT_TYPE_BUS_STOP',
  OddElementTypeInvalid = 'ODD_ELEMENT_TYPE_INVALID',
  OddElementTypeNoEntry = 'ODD_ELEMENT_TYPE_NO_ENTRY',
  OddElementTypeNoTurnOnRed = 'ODD_ELEMENT_TYPE_NO_TURN_ON_RED',
  OddElementTypeOneWay = 'ODD_ELEMENT_TYPE_ONE_WAY',
  OddElementTypeOpsHub = 'ODD_ELEMENT_TYPE_OPS_HUB',
  OddElementTypePedestrianCrossing = 'ODD_ELEMENT_TYPE_PEDESTRIAN_CROSSING',
  OddElementTypeRailroadCrossing = 'ODD_ELEMENT_TYPE_RAILROAD_CROSSING',
  OddElementTypeRightOnRed = 'ODD_ELEMENT_TYPE_RIGHT_ON_RED',
  OddElementTypeRoundabout = 'ODD_ELEMENT_TYPE_ROUNDABOUT',
  OddElementTypeSchoolZone = 'ODD_ELEMENT_TYPE_SCHOOL_ZONE',
  OddElementTypeStopSign = 'ODD_ELEMENT_TYPE_STOP_SIGN',
  OddElementTypeTrafficLight = 'ODD_ELEMENT_TYPE_TRAFFIC_LIGHT',
  OddElementTypeYieldSign = 'ODD_ELEMENT_TYPE_YIELD_SIGN',
}

export type TripOddElement = {
  __typename?: 'TripOddElement'
  approximatePassTimeMs: Scalars['Float']['output']
  location: Maybe<TripHistoryGeolocation>
  taxonomy: Scalars['String']['output']
}

export type TripPrebookingNoAssignment = TaskNotification & {
  __typename?: 'TripPrebookingNoAssignment'
  actionType: TaskActionType
  assigned: Maybe<TaskStateChangeDetails>
  createdAt: Scalars['DateTime']['output']
  dropoffStop: Maybe<Stop>
  fleetId: Maybe<Scalars['ID']['output']>
  foreignId: Scalars['ID']['output']
  id: Scalars['ID']['output']
  note: Maybe<TaskNotificationNote>
  notificationType: TaskNotificationType
  pended: Maybe<TaskStateChangeDetails>
  pickupStop: Maybe<Stop>
  regionId: Maybe<Scalars['ID']['output']>
  rejectionAt: Scalars['DateTime']['output']
  resolved: Maybe<TaskStateChangeDetails>
  serviceAreaUUID: Scalars['ID']['output']
  severity: TaskNotificationSeverity
  stateChanges: Array<TaskStateChangeDetails>
  status: TaskNotificationStatus
  trip: Maybe<Trip>
  vehicle: Maybe<Vehicle>
  version: Scalars['Int']['output']
}

export type TripProgress = {
  __typename?: 'TripProgress'
  checkpoints: Array<CheckpointProgress>
  eta: Maybe<TripEta>
  routeStatus: TripProgressRouteStatus
  routeVersionNumber: Scalars['Int']['output']
  tripId: Scalars['String']['output']
  vehiclePosition: Maybe<TripGeolocation>
  vin: Scalars['String']['output']
}

export type TripProgressResponse = {
  __typename?: 'TripProgressResponse'
  tripProgress: Maybe<TripProgress>
  tripSnapshot: Maybe<TripSnapshot>
}

export enum TripProgressRouteStatus {
  TripProgressRouteStatusInvalid = 'TRIP_PROGRESS_ROUTE_STATUS_INVALID',
  TripProgressRouteStatusOffRoute = 'TRIP_PROGRESS_ROUTE_STATUS_OFF_ROUTE',
  TripProgressRouteStatusOnRoute = 'TRIP_PROGRESS_ROUTE_STATUS_ON_ROUTE',
}

export enum TripPunctuality {
  /** Vehicle is delayed. */
  Delayed = 'Delayed',
  /** Vehicle is too early. */
  Early = 'Early',
  /** Vehicle on time. */
  OnTime = 'OnTime',
}

export type TripRecord = {
  __typename?: 'TripRecord'
  tripCompletedTime: Scalars['Float']['output']
  tripCompletionStatus: TripCompletionStatus
  tripId: Scalars['String']['output']
  vin: Scalars['String']['output']
}

export type TripReport = {
  __typename?: 'TripReport'
  client: Scalars['String']['output']
  clientRideId: Scalars['String']['output']
  clients: Array<Scalars['String']['output']>
  completionStatus: TripCompletionStatus
  date: Scalars['String']['output']
  driverEmail: Scalars['String']['output']
  fleetId: Scalars['String']['output']
  isPhantom: Scalars['Boolean']['output']
  mapIds: Array<Scalars['Int']['output']>
  metroId: Scalars['Int']['output']
  riders: Array<Scalars['String']['output']>
  segmentMetrics: Array<SegmentMetric>
  tenantId: Scalars['String']['output']
  tripCompletionTimeMs: Scalars['Float']['output']
  tripId: Scalars['String']['output']
  tripInitiatedTimeMs: Scalars['Float']['output']
  tripName: Scalars['String']['output']
  tripType: Scalars['String']['output']
  vehicleName: Scalars['String']['output']
  vehiclePlatform: Scalars['String']['output']
  vin: Scalars['String']['output']
}

export type TripReportPage = {
  __typename?: 'TripReportPage'
  totalNumResults: Scalars['Float']['output']
  tripReports: Array<TripReport>
}

export type TripReportQueryParamsInput = {
  client?: InputMaybe<Array<Scalars['String']['input']>>
  clients?: InputMaybe<Array<Scalars['String']['input']>>
  completionStatus?: InputMaybe<Array<Scalars['String']['input']>>
  fleetId?: InputMaybe<Array<Scalars['String']['input']>>
  includePhantoms?: InputMaybe<Scalars['Boolean']['input']>
  metroId?: InputMaybe<Array<Scalars['Int']['input']>>
  safetyDriverEmail?: InputMaybe<Array<Scalars['String']['input']>>
  textSearch?: InputMaybe<Scalars['String']['input']>
  tripCompletionTimeMsRangeEnd?: InputMaybe<Scalars['Float']['input']>
  tripCompletionTimeMsRangeStart?: InputMaybe<Scalars['Float']['input']>
  tripId?: InputMaybe<Array<Scalars['String']['input']>>
  tripInitiationTimeMsRangeEnd?: InputMaybe<Scalars['Float']['input']>
  tripInitiationTimeMsRangeStart?: InputMaybe<Scalars['Float']['input']>
  tripName?: InputMaybe<Array<Scalars['String']['input']>>
  vehicleName?: InputMaybe<Array<Scalars['String']['input']>>
  vehiclePlatform?: InputMaybe<Array<Scalars['String']['input']>>
  vin?: InputMaybe<Array<Scalars['String']['input']>>
}

export type TripRider = {
  __typename?: 'TripRider'
  id: Scalars['String']['output']
  riderName: Scalars['String']['output']
  riderPhoneNumber: Scalars['String']['output']
}

export type TripRiderInput = {
  riderName: Scalars['String']['input']
  riderPhoneNumber: Scalars['String']['input']
}

export type TripRoute = {
  __typename?: 'TripRoute'
  coordinates: Array<TripGeolocation>
  distanceMeters: Scalars['Int']['output']
  etaSeconds: Scalars['Int']['output']
  routeVersionNumber: Scalars['Int']['output']
}

export type TripRouteInput = {
  coordinates: Array<TripGeolocationInput>
  distanceMeters?: InputMaybe<Scalars['Int']['input']>
  etaSeconds?: InputMaybe<Scalars['Int']['input']>
}

export type TripRoutePolylineResponse = {
  __typename?: 'TripRoutePolylineResponse'
  routeVersionNumber: Scalars['Int']['output']
  segments: Array<RoutePolyline>
  tripId: Scalars['String']['output']
}

export type TripRouteTimeData = {
  __typename?: 'TripRouteTimeData'
  actualDropOffAddress: Scalars['String']['output']
  actualDropOffLocation: Maybe<TripHistoryGeolocation>
  actualDropoffTime: Scalars['Float']['output']
  actualPickUpAddress: Scalars['String']['output']
  actualPickUpLocation: Maybe<TripHistoryGeolocation>
  actualPickupTime: Scalars['Float']['output']
  desiredDropOffAddress: Scalars['String']['output']
  desiredDropOffLocation: Maybe<TripHistoryGeolocation>
  desiredPickUpAddress: Scalars['String']['output']
  desiredPickUpLocation: Maybe<TripHistoryGeolocation>
  dropOffRoute: Array<TripHistoryGeolocation>
  dropoffOddElements: Array<TripOddElement>
  estimatedDropoffTime: Scalars['Float']['output']
  estimatedPickupTime: Scalars['Float']['output']
  intermediateWaypoints: Array<TripHistoryGeolocation>
  pickUpRoute: Array<TripHistoryGeolocation>
  pickupOddElements: Array<TripOddElement>
}

export type TripSchedule = {
  __typename?: 'TripSchedule'
  /** Expected time when the vehicle will be at the delivery point. */
  delivery: Scalars['DateTime']['output']
  /** Indicates punctuality for the apps for the delivery. */
  deliveryPunctuality: TripPunctuality
  /** Expected time when the vehicle will be at the pickup point (communicated ETA to the customer). */
  pickup: Scalars['DateTime']['output']
  /** Indicates punctuality for the apps for the pickup. */
  pickupPunctuality: TripPunctuality
}

export type TripSeatInfo = {
  __typename?: 'TripSeatInfo'
  /** Number of booster seats (>125cm / >22kg). Need a corresponding seat and child. */
  boosterSeats: Scalars['Int']['output']
  /** Number of child seats (9-36kg). Need a corresponding seat and child. */
  childSeats: Scalars['Int']['output']
  /** Total amount of seats. */
  seats: Scalars['Int']['output']
  /** Number of wheelchairs. Only if this feature is supported in the service-area and by the tenant. */
  wheelchairs: Scalars['Int']['output']
}

export type TripSegment = {
  __typename?: 'TripSegment'
  clientIds: Array<Scalars['String']['output']>
  customerId: Scalars['String']['output']
  destination: Maybe<TripGeolocation>
  disallowSnapping: Scalars['Boolean']['output']
  endUserIds: Array<Scalars['String']['output']>
  id: Scalars['String']['output']
  lingerSecs: Scalars['Int']['output']
  metadata: Array<Array<Scalars['String']['output']>>
  numPassengers: Scalars['Int']['output']
  protected: Scalars['Boolean']['output']
  route: Maybe<TripRoute>
  sequenceId: Scalars['Int']['output']
  source: SegmentSource
  startTime: Scalars['Float']['output']
  stop: Maybe<TripDestination>
  successfulSegmentConfirmations: Array<ConfirmationType>
  version: Scalars['Int']['output']
  viapoints: Array<TripGeolocation>
}

export type TripSegmentInput = {
  clientIds?: InputMaybe<Array<Scalars['String']['input']>>
  customerId?: InputMaybe<Scalars['String']['input']>
  destination?: InputMaybe<TripGeolocationInput>
  disallowSnapping?: InputMaybe<Scalars['Boolean']['input']>
  endUserIds?: InputMaybe<Array<Scalars['String']['input']>>
  id?: InputMaybe<Scalars['String']['input']>
  lingerSecs?: InputMaybe<Scalars['Int']['input']>
  metadata?: InputMaybe<Array<Array<Scalars['String']['input']>>>
  numPassengers?: InputMaybe<Scalars['Int']['input']>
  protected?: InputMaybe<Scalars['Boolean']['input']>
  route?: InputMaybe<TripRouteInput>
  sequenceId?: InputMaybe<Scalars['Int']['input']>
  source?: InputMaybe<SegmentSource>
  startTime?: InputMaybe<Scalars['Float']['input']>
  stop?: InputMaybe<TripDestinationInput>
  viapoints?: InputMaybe<Array<TripGeolocationInput>>
}

export type TripSegmentWithStatus = {
  __typename?: 'TripSegmentWithStatus'
  safetyDriverForcePudoReason: SafetyDriverForcePudoReason
  segment: Maybe<TripSegment>
  status: SegmentStatus
  substatus: SegmentSubstatus
}

export type TripSnapshot = {
  __typename?: 'TripSnapshot'
  isCancelled: Scalars['Boolean']['output']
  metadata: Maybe<Array<Array<Scalars['String']['output']>>>
  safetyDriverTripConfirmationState: SafetyDriverTripConfirmationState
  status: TripStatus
  tripId: Scalars['String']['output']
}

export enum TripStatus {
  TripStatusActive = 'TRIP_STATUS_ACTIVE',
  TripStatusCancelled = 'TRIP_STATUS_CANCELLED',
  TripStatusCancelling = 'TRIP_STATUS_CANCELLING',
  TripStatusCompleted = 'TRIP_STATUS_COMPLETED',
  TripStatusInvalid = 'TRIP_STATUS_INVALID',
  TripStatusOffered = 'TRIP_STATUS_OFFERED',
  TripStatusPulledOver = 'TRIP_STATUS_PULLED_OVER',
  TripStatusPullingOver = 'TRIP_STATUS_PULLING_OVER',
  TripStatusRegistered = 'TRIP_STATUS_REGISTERED',
  TripStatusRejected = 'TRIP_STATUS_REJECTED',
}

export type TripStop = {
  __typename?: 'TripStop'
  stop: Maybe<Stop>
  stopId: Scalars['String']['output']
}

export enum TripStopType {
  StopTypeInvalid = 'STOP_TYPE_INVALID',
  StopTypeNormal = 'STOP_TYPE_NORMAL',
  StopTypePql = 'STOP_TYPE_PQL',
  StopTypeRollThrough = 'STOP_TYPE_ROLL_THROUGH',
}

export type TripTerminationInfo = {
  __typename?: 'TripTerminationInfo'
  reason: CancelationReason
  source: Platform
}

export type TripTimelineEvent = {
  __typename?: 'TripTimelineEvent'
  apiCallName: Scalars['String']['output']
  confirmationType: Scalars['String']['output']
  deviceLocation: Maybe<TripHistoryGeolocation>
  eventTimestampMs: Scalars['Float']['output']
  eventType: Scalars['String']['output']
  route: Array<TripHistoryGeolocation>
  segmentId: Scalars['String']['output']
  segmentStatus: Scalars['String']['output']
  sequenceId: Scalars['Int']['output']
  traceId: Scalars['String']['output']
  tripId: Scalars['String']['output']
}

export type TripTransferInformation = {
  __typename?: 'TripTransferInformation'
  /** Promised time when the transfer will happen. Used for internal optimization and PrebookingAlerting on BOFE (not for customer facing ETA) */
  promisedTime: DateTimeInterval
}

export enum TripType {
  TripTypeGoods = 'TRIP_TYPE_GOODS',
  TripTypeInternal = 'TRIP_TYPE_INTERNAL',
  TripTypeInvalid = 'TRIP_TYPE_INVALID',
  TripTypePassenger = 'TRIP_TYPE_PASSENGER',
  TripTypeVnv = 'TRIP_TYPE_VNV',
}

export type TripVehicle = {
  __typename?: 'TripVehicle'
  /** Whether the vehicle has been fixed, guaranteeing no further assignments. */
  fixed: Scalars['Boolean']['output']
  vehicle: Maybe<Vehicle>
  vehicleId: Scalars['ID']['output']
}

export type TripWithDetails = {
  __typename?: 'TripWithDetails'
  details: Maybe<TripDetails>
  ratingAvg: Scalars['Float']['output']
  riders: Array<TripRider>
  status: TripStatus
  tripId: Scalars['String']['output']
  tripStartTimeMs: Scalars['String']['output']
  vin: Scalars['String']['output']
}

export type TurnRestriction = {
  __typename?: 'TurnRestriction'
  created: Scalars['DateTime']['output']
  id: Scalars['ID']['output']
  modified: Scalars['DateTime']['output']
  name: Scalars['String']['output']
  reason: TurnRestrictionReason
  segments: Array<RoadSegment>
  status: TurnRestrictionStatus
  validFrom: Maybe<Scalars['DateTime']['output']>
  validTo: Maybe<Scalars['DateTime']['output']>
}

export type TurnRestrictionActivation = {
  __typename?: 'TurnRestrictionActivation'
  id: Scalars['ID']['output']
  timeRange: TimeRange
}

export type TurnRestrictionActivationInput = {
  serviceAreaId: Scalars['ID']['input']
  timeRange: TimeRangeInput
  turnRestrictionId: Scalars['ID']['input']
}

export type TurnRestrictionFilterInput = {
  status?: InputMaybe<Array<SearchTurnRestrictionStatus>>
  type?: InputMaybe<Array<SearchTurnRestrictionType>>
}

export type TurnRestrictionInput = {
  activationTimeRange?: InputMaybe<TimeRangeInput>
  name: Scalars['String']['input']
  reason: TurnRestrictionReason
  segments: Array<RoadSegmentInput>
}

export enum TurnRestrictionReason {
  Event = 'Event',
  LongTermConstructionSite = 'LongTermConstructionSite',
  MoiaOnly = 'MOIAOnly',
  ShortTermConstructionSite = 'ShortTermConstructionSite',
  StructuralChange = 'StructuralChange',
}

export enum TurnRestrictionStatus {
  Active = 'Active',
  Expired = 'Expired',
  Inactive = 'Inactive',
  Scheduled = 'Scheduled',
}

export enum Type {
  /** Privacy policy document */
  PrivacyPolicy = 'PRIVACY_POLICY',
  /** Terms and conditions document */
  TermsAndConditions = 'TERMS_AND_CONDITIONS',
}

export type UnarchiveVehicleInput = {
  fleetId: Scalars['ID']['input']
  vehicleId: Scalars['ID']['input']
}

export type UnassignCdisBoxFromVehicleInput = {
  fleetVehicleId: Scalars['ID']['input']
  imei: Scalars['String']['input']
}

export type UnassignTabletFromVehicleInput = {
  vehicleId: Scalars['ID']['input']
}

/** A Cdis box that has reported for a vehicle but whose connection has not been approved */
export type UnassignedCdisBox = {
  __typename?: 'UnassignedCdisBox'
  /** A unique serial number for identifying devices (International Mobile Equipment Identity) */
  imei: Scalars['String']['output']
  /** Timestamp at which the box was last updated */
  updatedAt: Scalars['Date']['output']
}

export type UpdateCustomPriceConfigInput = {
  childrenPricing: ChildrenPricingInput
  classicServiceClass: ServiceClassParametersInput
  conditions?: InputMaybe<CustomPriceConfigConditionsInput>
  couponsAllowed?: InputMaybe<Scalars['Boolean']['input']>
  displayText: Array<CustomPriceConfigDisplayTextInput>
  dynamicPricing?: InputMaybe<DynamicPricingInput>
  expressServiceClass: ServiceClassParametersInput
  expressServiceClassSurcharge: MoneyInput
  id: Scalars['ID']['input']
  name: Scalars['String']['input']
  parameters: PriceConfigParametersInput
  priority?: InputMaybe<Scalars['Int']['input']>
  purpose?: InputMaybe<CustomPriceConfigPurpose>
  validFrom: Scalars['DateTime']['input']
  validUntil: Scalars['DateTime']['input']
  version: Scalars['Int']['input']
}

/** For possible errors see type CreateDefaultPriceConfigResponse */
export type UpdateCustomPriceConfigResponse = {
  __typename?: 'UpdateCustomPriceConfigResponse'
  config: CustomPriceConfigResponse
}

export type UpdateCustomerInput = {
  email?: InputMaybe<Scalars['String']['input']>
  firstName?: InputMaybe<Scalars['String']['input']>
  id: Scalars['ID']['input']
  lastName?: InputMaybe<Scalars['String']['input']>
  locale?: InputMaybe<Scalars['String']['input']>
  severelyDisabled?: InputMaybe<UpdateCustomerSeverelyDisabledInput>
}

export type UpdateCustomerResponse = {
  __typename?: 'UpdateCustomerResponse'
  data: Maybe<UpdateCustomerResponseData>
  errors: Maybe<Array<UpdateCustomerResponseError>>
}

export type UpdateCustomerResponseData = {
  __typename?: 'UpdateCustomerResponseData'
  customer: Maybe<Customer>
}

export type UpdateCustomerResponseError = {
  __typename?: 'UpdateCustomerResponseError'
  message: Scalars['String']['output']
  path: Array<Scalars['String']['output']>
}

export type UpdateCustomerSeverelyDisabledDataInput = {
  eligibility: Eligibility
  validUntil: Scalars['String']['input']
}

export type UpdateCustomerSeverelyDisabledInput = {
  data?: InputMaybe<UpdateCustomerSeverelyDisabledDataInput>
}

export type UpdateDefaultPriceConfigInput = {
  childrenPricing: ChildrenPricingInput
  classicServiceClass: ServiceClassParametersInput
  dynamicPricing?: InputMaybe<DynamicPricingInput>
  expressServiceClass: ServiceClassParametersInput
  expressServiceClassSurcharge: MoneyInput
  id: Scalars['ID']['input']
  name: Scalars['String']['input']
  parameters: PriceConfigParametersInput
  validFrom: Scalars['DateTime']['input']
  version: Scalars['Int']['input']
}

/** For possible errors see type CreateDefaultPriceConfigResponse */
export type UpdateDefaultPriceConfigResponse = {
  __typename?: 'UpdateDefaultPriceConfigResponse'
  config: DefaultPriceConfigResponse
}

/** Input for updating an existing demo route */
export type UpdateDemoRouteInput = {
  /** New ending point for the route (if provided) */
  destination?: InputMaybe<DemoRouteWaypointInput>
  /** ID of the demo route to update */
  id: Scalars['ID']['input']
  /** New active status for the route (if provided) */
  isActive?: InputMaybe<Scalars['Boolean']['input']>
  /** New name for the route (if provided) */
  name?: InputMaybe<Scalars['String']['input']>
  /** New starting point for the route (if provided) */
  origin?: InputMaybe<DemoRouteWaypointInput>
  /** New intermediate waypoints for the route (if provided) */
  viaPoints?: InputMaybe<Array<DemoRouteWaypointInput>>
}

export enum UpdateEmployeeProfilePictureAction {
  Delete = 'DELETE',
  GenerateUploadUrl = 'GENERATE_UPLOAD_URL',
}

export type UpdateEmployeeProfilePictureInput = {
  action: UpdateEmployeeProfilePictureAction
  id: Scalars['String']['input']
}

export type UpdateEmployeeProfilePictureResponse = {
  __typename?: 'UpdateEmployeeProfilePictureResponse'
  deleted: Scalars['Boolean']['output']
  url: Maybe<Scalars['String']['output']>
}

/** Note: All fields need to be retrieved. Fields with a `null` value will be deleted. */
export type UpdateMainInspectionProcessDataRequest = {
  /** Appointment date for the next inspection. Must be before dueDate. */
  appointmentDate?: InputMaybe<Scalars['DateTime']['input']>
  documents?: InputMaybe<Array<MainInspectionDocumentRequest>>
  /** The associated scheduled inactivation of the vehicle for this inspection (TODO: add type when ScheduledVehicleStateChange is a top-level type with a resolver in fleet-backend) */
  inactivationSchedulerId?: InputMaybe<Scalars['ID']['input']>
  processId: Scalars['ID']['input']
  testFacilityId?: InputMaybe<Scalars['ID']['input']>
}

export type UpdateMileageBasedInspectionProcessDataRequest = {
  /** Pickup date for the vehicle. */
  appointmentDate?: InputMaybe<Scalars['DateTime']['input']>
  documents?: InputMaybe<Array<MileageBasedInspectionDocumentRequest>>
  /** The associated scheduled inactivation of the vehicle for this inspection (TODO: add type when ScheduledVehicleStateChange is a top-level type with a resolver in fleet-backend) */
  inactivationSchedulerId?: InputMaybe<Scalars['ID']['input']>
  /** UUID of hub at which the vehicle will be picked up */
  pickupHub?: InputMaybe<Scalars['ID']['input']>
  processId: Scalars['ID']['input']
  testFacilityId?: InputMaybe<Scalars['ID']['input']>
}

/** Updates Fleet Optimization's offer and pooling configuration */
export type UpdateOfferAndPoolingConfigInput = {
  /**
   * The maximum absolute detour. If the value is `null`, there is no limit
   * in place.
   */
  detourLimitAbsoluteUpper?: InputMaybe<Scalars['Duration']['input']>
  /**
   * The maximum relative detour in percent. If the value is `null`, there is
   * no limit in place.
   */
  detourLimitRelativeUpper?: InputMaybe<Scalars['Int']['input']>
}

export type UpdateOverwatchVehicleInput = {
  fleetId?: InputMaybe<Scalars['ID']['input']>
  geonetName?: InputMaybe<Scalars['String']['input']>
  inService?: InputMaybe<Scalars['Boolean']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  platform?: InputMaybe<Scalars['String']['input']>
}

export type UpdateSimulatedAdVehicleIncidentsInput = {
  criticality?: Criticality
  description?: InputMaybe<Scalars['String']['input']>
  fleetVehicleId: Scalars['ID']['input']
  occurrenceTimestamp?: InputMaybe<Scalars['Date']['input']>
  tripInterruption?: TripInterruptions
  type: IncidentTypeIds
}

export type UpdateSimulatedAdVehicleInput = {
  centralLockState?: InputMaybe<CentralLockState>
  connectedState?: InputMaybe<Scalars['Boolean']['input']>
  consumedEnergy?: InputMaybe<Scalars['Float']['input']>
  doorsOpen?: InputMaybe<Scalars['Boolean']['input']>
  exteriorAirTemperature?: InputMaybe<Scalars['Float']['input']>
  fleetVehicleId: Scalars['ID']['input']
  heading?: InputMaybe<Scalars['Float']['input']>
  highVoltBatteryPercentage?: InputMaybe<Scalars['Percentage']['input']>
  ignitionState?: InputMaybe<IgnitionState>
  interiorTemperature?: InputMaybe<Scalars['Float']['input']>
  latitude?: InputMaybe<Scalars['Float']['input']>
  leftSlidingDoorPosition?: InputMaybe<Scalars['Percentage']['input']>
  longitude?: InputMaybe<Scalars['Float']['input']>
  mileage?: InputMaybe<Scalars['Int']['input']>
  remainingCruisingRange?: InputMaybe<Scalars['Float']['input']>
  rightSlidingDoorPosition?: InputMaybe<Scalars['Percentage']['input']>
  sdsMode?: InputMaybe<SdsMode>
  seats?: InputMaybe<SeatsInput>
  speed?: InputMaybe<Scalars['Float']['input']>
  tireWarning?: InputMaybe<TireWarning>
}

export type UpdateSimulatedVehicleInput = {
  cdisError?: InputMaybe<CdisError>
  id: Scalars['ID']['input']
  telematics: TelematicBoxStateInput
  vin: Scalars['ID']['input']
}

export type UpdateVicProcessDataRequest = {
  processId: Scalars['ID']['input']
  /** UUID of a hub */
  testFacility?: InputMaybe<Scalars['ID']['input']>
  /** Date for the inspection */
  testingDate?: InputMaybe<Scalars['DateTime']['input']>
}

export type UpdateVehicleInput = {
  id: Scalars['ID']['input']
  vehicleConfiguration: VehicleConfigurationInput
}

export type UpdateVehicleRebalancingInput = {
  /** Activate or deactivate rebalancing for this vehicle */
  rebalancingEnabled: Scalars['Boolean']['input']
  /**
   * How long the rebalancing setting be valid. After this time, the setting
   * will be reset to the global rebalancing behavior.
   */
  validUntil: Scalars['DateTime']['input']
}

export type UpdateWorkOrderInput = {
  assigneeId?: InputMaybe<Scalars['ID']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  dueAt?: InputMaybe<Scalars['DateTime']['input']>
  id: Scalars['ID']['input']
  operationalImpact?: InputMaybe<WorkOrderOperationalImpact>
  priority?: InputMaybe<WorkOrderPriority>
  serviceItem: WorkOrderServiceItem
  status: WorkOrderStatus
  updatedAt: Scalars['DateTime']['input']
}

export type UpdateWorkOrdersInput = {
  inputs: Array<UpdateWorkOrderInput>
}

export enum UseCaseType {
  InternalTest = 'INTERNAL_TEST',
  Real = 'REAL',
  SimulationFleet = 'SIMULATION_FLEET',
  SimulationFull = 'SIMULATION_FULL',
  Systemtest = 'SYSTEMTEST',
}

export enum UserStatus {
  Archived = 'ARCHIVED',
  Compromised = 'COMPROMISED',
  Confirmed = 'CONFIRMED',
  ExternalProvider = 'EXTERNAL_PROVIDER',
  ForceChangePassword = 'FORCE_CHANGE_PASSWORD',
  ResetRequired = 'RESET_REQUIRED',
  Unconfirmed = 'UNCONFIRMED',
  Unknown = 'UNKNOWN',
}

export enum UserType {
  Admin = 'ADMIN',
  PlatformAdmin = 'PLATFORM_ADMIN',
  Standard = 'STANDARD',
}

export type VgaVersionInfo = {
  __typename?: 'VGAVersionInfo'
  appVersion: Maybe<Scalars['String']['output']>
  appVersionCode: Maybe<Scalars['Int']['output']>
  fleetVehicleId: Maybe<Scalars['ID']['output']>
}

export type VicProcess = FleetProcess & {
  __typename?: 'VICProcess'
  /** Readable unique identifier */
  case: Scalars['ID']['output']
  finishedAt: Maybe<Scalars['DateTime']['output']>
  id: Scalars['ID']['output']
  /** Has the vehicle been activated after the inspection */
  inspectionState: VicProcessState
  /** The mileage at the point in time the inspection was marked as done */
  mileageAtInspectionDone: Maybe<Scalars['Float']['output']>
  mileageAtStart: Scalars['Float']['output']
  /** A vehicle inspection is triggered after thresholds of 15_000 km, 45_000 km, etc */
  mileageThreshold: Scalars['Float']['output']
  region: Region
  startedAt: Scalars['DateTime']['output']
  state: FleetProcessState
  /** UUID of a hub */
  testFacility: Maybe<Hub>
  /** Date for the inspection */
  testingDate: Maybe<Scalars['DateTime']['output']>
  type: FleetProcessType
  updatedAt: Maybe<Scalars['DateTime']['output']>
  vehicle: Maybe<Vehicle>
}

export enum VicProcessState {
  Done = 'DONE',
  Due = 'DUE',
}

export type VicProcessTransitionRequest = {
  nextState: VicProcessState
  processId: Scalars['ID']['input']
}

export type ValidateRouteSdsResult = {
  __typename?: 'ValidateRouteSdsResult'
  mapValidations: Array<MapValidation>
}

export type ValidateTripResult = {
  __typename?: 'ValidateTripResult'
  routeViolations: Array<RouteViolation>
  segments: Array<TripSegment>
  vin: Scalars['String']['output']
}

export enum ValidationFailureReason {
  ValidationFailureReasonInvalid = 'VALIDATION_FAILURE_REASON_INVALID',
  ValidationFailureReasonNoMapCoverage = 'VALIDATION_FAILURE_REASON_NO_MAP_COVERAGE',
  ValidationFailureReasonSegmentTooShort = 'VALIDATION_FAILURE_REASON_SEGMENT_TOO_SHORT',
}

export type Vehicle = {
  __typename?: 'Vehicle'
  /** Available for autonomous vehicles only. */
  adSeatsLayout: Maybe<FccSeatLayout>
  attributes: Maybe<Array<VehicleAttribute>>
  baseServiceBreakLocation: Maybe<ServiceBreakLocation>
  /** The voltage of the 12V battery */
  boardVoltage: Maybe<Scalars['Float']['output']>
  /** @deprecated Do not use this field. */
  cabinSafetyCheckState: Maybe<FccCabinSafetyCheckState>
  capacityConfig: Maybe<VehicleCapacityConfig>
  /** Vehicle-level overrides that reduce capacity counts from the base capacity config. */
  capacityOverrides: Array<CapacityOverride>
  /** A representation of the physical central lock. Independent from our purely digital representation of vehicle interactions */
  centralLocked: Maybe<Scalars['Boolean']['output']>
  changeReasonFreeText: Maybe<Scalars['String']['output']>
  chargingMode: Maybe<ChargingMode>
  chargingSinceTimestamp: Maybe<Scalars['DateTime']['output']>
  /**
   * The active claim of this vehicle, or `null` if the vehicle is not
   * claimed.
   */
  claim: Maybe<VehicleClaim>
  climateControlState: Maybe<ClimateControlState>
  /** Primary exterior color of the vehicle */
  color: Maybe<VehicleColor>
  /** Indicated the type of concession this vehicle has associated with it */
  concessionType: Maybe<VehicleConcessionType>
  /** The connectivity of the CDIS box */
  connectedState: Maybe<ConnectedState>
  createdAt: Maybe<Scalars['DateTime']['output']>
  cruisingRange: Maybe<Scalars['Float']['output']>
  /** The SLB, if a vehicle is currently inside a service break location */
  currentlyLocatedInServiceBreakLocation: Maybe<ServiceBreakLocation>
  currentlyOpen: Scalars['Boolean']['output']
  deFleetingDate: Maybe<Scalars['DateTime']['output']>
  engineType: Maybe<VehicleEngineType>
  fccCauseError: Maybe<Scalars['Boolean']['output']>
  fccCurrentAdAlerts: Maybe<FccAdAlerts>
  /** One entry per occupied role slot. */
  fccHandledBy: Array<FccVehicleHandledBy>
  /** @deprecated Legacy handling without a role, use fccHandledBy */
  fccHandledByOperator: Maybe<BackofficeUser>
  /**
   * The Remote Assistance Operator currently handling this vehicle, if any.
   * @deprecated Use fccHandledBy, which also works for users of other organisations
   */
  fccHandledByRao: Maybe<BackofficeUser>
  /**
   * The Rider Support operator currently handling this vehicle, if any.
   * @deprecated Use fccHandledBy, which also works for users of other organisations
   */
  fccHandledByRs: Maybe<BackofficeUser>
  fccNextHubReturn: Maybe<FccWaypointHubReturnAction>
  fccNextWaypoint: Maybe<FccWaypoint>
  fccNoError: Maybe<Scalars['Boolean']['output']>
  /**
   * Includes recently handled alerts and alerts to be handled by the current operator assigned to this vehicle.
   * If the current operator is not handling the vehicle, this list is empty.
   */
  fccOperatorAdAlerts: Maybe<FccAdAlerts>
  /** Waypoints in the route that are unfinished including a Hub Return at the very end. */
  fccUpcomingWaypoints: Maybe<Array<FccWaypoint>>
  firstRegistrationDate: Maybe<Scalars['DateTime']['output']>
  /** Indicates which fleet the vehicle belongs to */
  fleet: Maybe<Fleet>
  /** Only for (archived) vehicles with combustion engines */
  fuelLevel: Maybe<Scalars['Float']['output']>
  hardwareConfiguration: Maybe<HardwareConfiguration>
  /** Only for electric vehicles, also referred to as State of Charge (SoC). Provided in % */
  highVoltageBatteryLevel: Maybe<Scalars['Float']['output']>
  /** The SLB at which the vehicle was registered (use currentlyLocatedInServiceBreakLocation to find out where it currently is) */
  homeServiceBreakLocation: Maybe<ServiceBreakLocation>
  id: Scalars['ID']['output']
  /** Ignition state with a timestamp */
  ignition: Maybe<Ignition>
  inFleetingDate: Maybe<Scalars['DateTime']['output']>
  /**
   * [TrEx] Is this vehicle considered to be in service ("bookable")? Based on a lot of different factors
   *     including active, connected, pooling, responsiveness, recent location updates and not having an old hub return
   */
  inService: Maybe<Scalars['Boolean']['output']>
  inVehicleLists: Array<VehicleList>
  /** The date since when the vehicle is inactive, even if the reason changed in between. Null if vehicle is not inactive. */
  inactiveSince: Maybe<Scalars['DateTime']['output']>
  interiorTemperature: Maybe<Scalars['Float']['output']>
  /** Convenience condition: state == ACTIVE && lastInteractionType != OPEN && lastInteractionHardwareKeyUsed != true && highVoltageBatteryLevel > 60.0 */
  isAvailable: Scalars['Boolean']['output']
  isNotMoving: Scalars['Boolean']['output']
  /** Indicates whether the vehicle is prioritized or not */
  isPrioritized: Scalars['Boolean']['output']
  /**
   * [TrEx] Is this vehicle responsive? This means it could accept mission updates.
   * Needed for consideration if a vehicle is in service
   */
  isResponsive: Maybe<Scalars['Boolean']['output']>
  isSelfDriving: Scalars['Boolean']['output']
  label: Maybe<Scalars['Int']['output']>
  lastHUDate: Maybe<Scalars['DateTime']['output']>
  /** The regular interval of the last inspection in km. Missing value indicates that there was no inspection so far. */
  lastMileageBasedInspectionRegularInterval: Maybe<Scalars['Int']['output']>
  /** Last time a vehicle was closed by driver */
  lastUsedInShift: Maybe<Scalars['DateTime']['output']>
  lastVehicleInteraction: Maybe<VehicleInteraction>
  /** The last occurrence when the state of the vehicle was changed, adding why, when and by whom */
  lastVehicleStateChange: Maybe<VehicleStateChange>
  latestADTelemetry: Maybe<AdTelemetry>
  latestLocation: Maybe<VehicleLocation>
  licensePlate: Maybe<Scalars['String']['output']>
  /** Country code for the license plate in ISO 3166‑1 alpha‑2 (two letter) format (e.g. US, DE) */
  licensePlateCountry: Maybe<LicensePlateCountry>
  /** Two-letter US state/territory abbreviation for the license plate. */
  licensePlateRegion: Maybe<LicensePlateRegion>
  mileage: Maybe<Scalars['Float']['output']>
  /** Year of manufacture of the vehicle */
  modelYear: Maybe<Scalars['Int']['output']>
  nextHubReturn: Maybe<HubReturn>
  /** The date until which the next main inspection (Hauptuntersuchung) has to happen (by law) */
  nextMainInspectionDate: Maybe<Scalars['DateTime']['output']>
  /** The mileage in km at which the next mileage based inspection is planned. */
  nextMileageBasedInspectionAt: Maybe<Scalars['Int']['output']>
  /** [TrEx] The next waypoint ahead */
  nextWaypoint: Maybe<Waypoint>
  /**
   * The reasons that currently keep the vehicle NON_OPERATIONAL, one entry per reason, ordered by nonOperationalDate ASC.
   * Empty for vehicles without an operationalState. Reasons that only become effective in the future (e.g. a work order
   * that is not critical yet) are not included. A vehicle with several critical work orders carries one WORK_ORDER entry
   * per work order.
   */
  nonOperationalReasons: Array<VehicleNonOperationalReason>
  /** [TrEx] A list of the reasons that are contributing to marking the vehicle as not in-service */
  notInServiceReasons: Maybe<Array<NotInServiceReason>>
  /** If open. Null indicates a closed vehicle */
  openedBy: Maybe<VehicleInteractionUserType>
  operationalState: Maybe<VehicleOperationalState>
  /** Changes to the operationalState of the vehicle, sorted by occurrence time in descending order */
  operationalStateHistory: Array<VehicleOperationalStateChange>
  /**
   * Not-yet-executed state changes, ordered by scheduled date ASC. Superset of scheduledStateChanges:
   * also includes changes whose scheduledAt has already passed but which have not been applied yet
   * (e.g. a scheduled deactivation deferred because the vehicle is still open).
   */
  pendingStateChanges: Maybe<Array<ScheduledVehicleStateChange>>
  /** [TrEx] Information around the pooling state, if it is enabled, the reason for it and if there is a connection */
  pooling: Maybe<Pooling>
  powerPlugState: Maybe<PowerplugState>
  /** Indicates the reasons as to why the vehicle can not be prioritized, if it's blank, it's prioritizable! */
  prioritizationImpossibleReasons: Array<VehiclePrioritizationImpossibleReason>
  rebalancingEnabled: Scalars['Boolean']['output']
  rebalancingSettingValidUntil: Scalars['DateTime']['output']
  /** Indicates which region the vehicle belongs to */
  region: Maybe<Region>
  /** [TrEx] When was responsiveness updated the last time */
  responsivenessUpdatedAt: Maybe<Scalars['DateTime']['output']>
  /** Upcoming state changes (e.g. for inspections, marketing events, etc), ordered by scheduled date ASC */
  scheduledStateChanges: Maybe<Array<ScheduledVehicleStateChange>>
  sdsProvider: SdsProvider
  state: VehicleState
  /** [TrEx] Location from the tablet. This is a distinct value from the telemetry location from the vehicle itself, and should generally be preferred as this is the source-of-truth for pooling */
  tabletLocation: Maybe<Location>
  /** [TrEx] Last time the location was updated from the tablet. */
  tabletLocationUpdatedAt: Maybe<Scalars['DateTime']['output']>
  taskNotifications: Maybe<TaskNotificationList>
  tenant: Scalars['String']['output']
  /** [TrEx] How many children are currently in the vehicle? Based on child seats */
  totalChildrenInVehicle: Maybe<Scalars['Int']['output']>
  /** [TrEx] How many passengers are currently in the vehicle? */
  totalPassengersInVehicle: Maybe<Scalars['Int']['output']>
  /** [TrEx] Amount of passengers that will be picked up */
  totalPassengersToPickUp: Maybe<Scalars['Int']['output']>
  /** [TrEx] How many wheelchair users are currently in the vehicle? */
  totalWheelchairUsersInVehicle: Maybe<Scalars['Int']['output']>
  updatedAt: Maybe<Scalars['DateTime']['output']>
  vehiclePlans: Array<VehiclePlan>
  vehicleStateChangeReason: Maybe<VehicleStateChangeReason>
  vehicleStatusTelemetry: Maybe<VehicleStatusVehicleTelemetry>
  vehicleType: VehicleType
  vgaVersion: Maybe<VgaVersionInfo>
  vin: Maybe<Scalars['String']['output']>
  /** [TrEx] All waypoints ahead */
  waypoints: Maybe<Array<Waypoint>>
  /**
   * Work orders belonging to this vehicle, newest first. If `statuses` is not
   * present, work orders with all statuses are returned.
   */
  workOrders: Maybe<Array<WorkOrder>>
}

export type VehicleFccCurrentAdAlertsArgs = {
  role?: InputMaybe<FccOperatorRoleType>
}

export type VehicleTaskNotificationsArgs = {
  status: Array<TaskNotificationStatus>
  types: Array<TaskNotificationType>
}

export type VehicleVehiclePlansArgs = {
  from: Scalars['DateTime']['input']
  to: Scalars['DateTime']['input']
}

export type VehicleWorkOrdersArgs = {
  statuses?: InputMaybe<Array<WorkOrderStatus>>
}

/** A vehicle asset as tracked in Jira Assets, mirrored into Redshift. */
export type VehicleAsset = {
  __typename?: 'VehicleAsset'
  currentLocation: Scalars['String']['output']
  id: Scalars['Int']['output']
  key: Scalars['String']['output']
  name: Scalars['String']['output']
  objecttypeName: Scalars['String']['output']
  targetDestination: Scalars['String']['output']
  vehicleCategory: Scalars['String']['output']
  vehicleStatusTechnical: Scalars['String']['output']
  vin: Scalars['String']['output']
}

export enum VehicleAssetName {
  Checks = 'CHECKS',
  Conmod = 'CONMOD',
  Identifiers = 'IDENTIFIERS',
  MaasEcu = 'MAAS_ECU',
  SafetyDriverTablet = 'SAFETY_DRIVER_TABLET',
  Sds = 'SDS',
  Software = 'SOFTWARE',
  SystemOfSystemsCompound = 'SYSTEM_OF_SYSTEMS_COMPOUND',
  Vehicle = 'VEHICLE',
}

export type VehicleAttribute = {
  __typename?: 'VehicleAttribute'
  allowedValues: Maybe<Array<Scalars['String']['output']>>
  assetName: VehicleAssetName
  attributeName: VehicleAttributeName
  attributeValue: Scalars['String']['output']
  readOnly: Scalars['Boolean']['output']
  type: VehicleAttributeType
  updatedAt: Scalars['DateTime']['output']
}

export type VehicleAttributeInput = {
  attributeName: VehicleAttributeName
  attributeValue: Scalars['String']['input']
}

export enum VehicleAttributeName {
  AdmtVehicleAcceptanceTests = 'ADMT_VEHICLE_ACCEPTANCE_TESTS',
  AvqaNumber = 'AVQA_NUMBER',
  CassiopeiaSw = 'CASSIOPEIA_SW',
  ConmodPhoneNumber = 'CONMOD_PHONE_NUMBER',
  CountryCode = 'COUNTRY_CODE',
  DragoonSw = 'DRAGOON_SW',
  EndOfLineHwCheck = 'END_OF_LINE_HW_CHECK',
  IncidentHandlerConfiguration = 'INCIDENT_HANDLER_CONFIGURATION',
  InventoryNumber = 'INVENTORY_NUMBER',
  MaasEcuHardwareId = 'MAAS_ECU_HARDWARE_ID',
  MaasEcuRelease = 'MAAS_ECU_RELEASE',
  MobileyeProjectName = 'MOBILEYE_PROJECT_NAME',
  SafetyDriverTabletImei = 'SAFETY_DRIVER_TABLET_IMEI',
  SafetyDriverTabletPhoneNumber = 'SAFETY_DRIVER_TABLET_PHONE_NUMBER',
  SdsAutonomousVehicle = 'SDS_AUTONOMOUS_VEHICLE',
  SdsAvDisplay = 'SDS_AV_DISPLAY',
  SdsMetadataMapName = 'SDS_METADATA_MAP_NAME',
  SdsVehicleCloudLayer = 'SDS_VEHICLE_CLOUD_LAYER',
  SmartAntennaSimCardSerialNumber = 'SMART_ANTENNA_SIM_CARD_SERIAL_NUMBER',
  SoscRelease = 'SOSC_RELEASE',
  Tyres = 'TYRES',
  VehicleVersion = 'VEHICLE_VERSION',
  VwSpecifier = 'VW_SPECIFIER',
}

export enum VehicleAttributeType {
  Boolean = 'BOOLEAN',
  ImeiNumber = 'IMEI_NUMBER',
  PhoneNumber = 'PHONE_NUMBER',
  ReadOnly = 'READ_ONLY',
  Select = 'SELECT',
  Text = 'TEXT',
}

export type VehicleAttributeUpdatedChange = FleetEntityChange & {
  __typename?: 'VehicleAttributeUpdatedChange'
  backofficeUser: Maybe<BackofficeUser>
  changedAt: Scalars['DateTime']['output']
  changes: VehicleAttributeUpdatedChangeFields
}

export type VehicleAttributeUpdatedChangeFields = VehicleChangeFields & {
  __typename?: 'VehicleAttributeUpdatedChangeFields'
  attributeName: Maybe<Scalars['String']['output']>
  attributeValueNew: Maybe<Scalars['String']['output']>
  attributeValueOld: Maybe<Scalars['String']['output']>
  vehicleID: Scalars['ID']['output']
}

export type VehicleAttributesUpdateInput = {
  attributes: Array<VehicleAttributeInput>
  vehicleId: Scalars['ID']['input']
}

export enum VehicleAvailability {
  Available = 'AVAILABLE',
  Unavailable = 'UNAVAILABLE',
}

export type VehicleAvailabilityNotification = TaskNotification & {
  __typename?: 'VehicleAvailabilityNotification'
  actionType: TaskActionType
  assigned: Maybe<TaskStateChangeDetails>
  createdAt: Scalars['DateTime']['output']
  employee: Maybe<Employee>
  fleetId: Maybe<Scalars['ID']['output']>
  foreignId: Scalars['ID']['output']
  id: Scalars['ID']['output']
  note: Maybe<TaskNotificationNote>
  notificationType: TaskNotificationType
  pended: Maybe<TaskStateChangeDetails>
  regionId: Maybe<Scalars['ID']['output']>
  resolved: Maybe<TaskStateChangeDetails>
  serviceAreaUUID: Scalars['ID']['output']
  severity: TaskNotificationSeverity
  stateChanges: Array<TaskStateChangeDetails>
  status: TaskNotificationStatus
  vehicle: Maybe<Vehicle>
  version: Scalars['Int']['output']
}

export type VehicleCabinState = {
  __typename?: 'VehicleCabinState'
  atLeastOneBackSeatbeltBuckled: Scalars['Boolean']['output']
  backLeftDoorOpen: Scalars['Boolean']['output']
  backRightDoorOpen: Scalars['Boolean']['output']
  cabinReady: Scalars['Boolean']['output']
  cabinReadyWithoutPassengerReady: Scalars['Boolean']['output']
  frontLeftDoorOpen: Scalars['Boolean']['output']
  frontRightDoorOpen: Scalars['Boolean']['output']
  onboardingTimerRemainingSecs: Scalars['Int']['output']
  v3Enabled: Scalars['Boolean']['output']
}

/** A single day in the vehicle calendar week detail. */
export type VehicleCalendarDay = {
  __typename?: 'VehicleCalendarDay'
  /** Date string (YYYY-MM-DD). */
  date: Scalars['Date']['output']
  /** Day identifier. */
  id: Scalars['ID']['output']
}

/** A single shift entry for a day in the vehicle week detail. */
export type VehicleCalendarDayEntry = {
  __typename?: 'VehicleCalendarDayEntry'
  /** Campaign name if the slot is assigned. */
  campaignName: Maybe<Scalars['String']['output']>
  /** Day identifier this entry belongs to. */
  dayId: Scalars['ID']['output']
  /** Status of this shift slot. */
  status: VehicleCalendarShiftStatus
}

/** Shift schedule grouped by shift type for the week detail. */
export type VehicleCalendarShiftSchedule = {
  __typename?: 'VehicleCalendarShiftSchedule'
  /** Early shift entries for each day. */
  early: Array<VehicleCalendarDayEntry>
  /** Late shift entries for each day. */
  late: Array<VehicleCalendarDayEntry>
  /** Night shift entries for each day. */
  night: Array<VehicleCalendarDayEntry>
}

/** Status of a single shift slot in the vehicle calendar week detail. */
export enum VehicleCalendarShiftStatus {
  /** Shift is assigned to a campaign. */
  Assigned = 'ASSIGNED',
  /** Shift slot is free. */
  Free = 'FREE',
  /** Vehicle is not available (out of service). */
  NotAvailable = 'NOT_AVAILABLE',
}

/** Detail view of a vehicle's schedule for a single week. */
export type VehicleCalendarWeekDetail = {
  __typename?: 'VehicleCalendarWeekDetail'
  /** Days in this week. */
  days: Array<VehicleCalendarDay>
  /** Shift schedule for each day. */
  schedule: VehicleCalendarShiftSchedule
}

export type VehicleCapacityConfig = {
  __typename?: 'VehicleCapacityConfig'
  capacityClaims: Array<CapacityClaim>
  capacityTypes: Array<CapacityType>
  convertibleTypes: Array<ConvertibleType>
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  operatorTenant: Scalars['String']['output']
  totalVehicles: Scalars['Int']['output']
  vehicleType: VehicleType
}

export type VehicleCapacityConfigAssignVehiclesInput = {
  capacityConfigId: Scalars['ID']['input']
  vehicleIds: Array<Scalars['ID']['input']>
}

export type VehicleCapacityConfigCreateInput = {
  capacityClaims: Array<CapacityClaimInput>
  capacityTypes: Array<CapacityTypeInput>
  convertibleTypes: Array<ConvertibleTypeInput>
  name: Scalars['String']['input']
  operatorTenant: Scalars['String']['input']
  vehicleType: VehicleType
}

export type VehicleCapacityConfigUpdateInput = {
  capacityClaims: Array<CapacityClaimInput>
  capacityTypes: Array<CapacityTypeInput>
  convertibleTypes: Array<ConvertibleTypeInput>
  id: Scalars['ID']['input']
  name: Scalars['String']['input']
}

export type VehicleCapacityOverriddenChange = FleetEntityChange & {
  __typename?: 'VehicleCapacityOverriddenChange'
  backofficeUser: Maybe<BackofficeUser>
  changedAt: Scalars['DateTime']['output']
  changes: VehicleCapacityOverriddenChangeFields
}

export type VehicleCapacityOverriddenChangeFields = VehicleChangeFields & {
  __typename?: 'VehicleCapacityOverriddenChangeFields'
  capacityConfig: Maybe<VehicleCapacityConfig>
  vehicleID: Scalars['ID']['output']
}

export type VehicleCapacityUpdatedChange = FleetEntityChange & {
  __typename?: 'VehicleCapacityUpdatedChange'
  backofficeUser: Maybe<BackofficeUser>
  changedAt: Scalars['DateTime']['output']
  changes: VehicleCapacityUpdatedChangeFields
}

export type VehicleCapacityUpdatedChangeFields = VehicleChangeFields & {
  __typename?: 'VehicleCapacityUpdatedChangeFields'
  capacityConfigNew: Maybe<VehicleCapacityConfig>
  capacityConfigOld: Maybe<VehicleCapacityConfig>
  vehicleID: Scalars['ID']['output']
}

export enum VehicleCellularNetworkType {
  CellularNetworkTypeGsm = 'CELLULAR_NETWORK_TYPE_GSM',
  CellularNetworkTypeInvalid = 'CELLULAR_NETWORK_TYPE_INVALID',
  CellularNetworkTypeLte = 'CELLULAR_NETWORK_TYPE_LTE',
  CellularNetworkTypeNr5G = 'CELLULAR_NETWORK_TYPE_NR5G',
  CellularNetworkTypeOther = 'CELLULAR_NETWORK_TYPE_OTHER',
  CellularNetworkTypeWcdma = 'CELLULAR_NETWORK_TYPE_WCDMA',
}

export type VehicleCellularSignal = {
  __typename?: 'VehicleCellularSignal'
  cellularNetworkType: VehicleCellularNetworkType
  strengthDbm: Scalars['Int']['output']
}

export type VehicleChangeFields = {
  vehicleID: Scalars['ID']['output']
}

export type VehicleChangeList = CursorListResponse & {
  __typename?: 'VehicleChangeList'
  nextCursor: Maybe<Scalars['ID']['output']>
  total: Scalars['Int']['output']
  vehicleChanges: Array<FleetEntityChange>
}

export enum VehicleChangeType {
  BoxPcReplaced = 'BOX_PC_REPLACED',
  BoxPcWiped = 'BOX_PC_WIPED',
  CameraReplaced = 'CAMERA_REPLACED',
  CdisBoxReplaced = 'CDIS_BOX_REPLACED',
  HuDatesUpdated = 'HU_DATES_UPDATED',
  KeyRfidReplaced = 'KEY_RFID_REPLACED',
  RouterReplaced = 'ROUTER_REPLACED',
  TabletPhoneNumberReplaced = 'TABLET_PHONE_NUMBER_REPLACED',
  TabletReplaced = 'TABLET_REPLACED',
  VehicleAttributeUpdated = 'VEHICLE_ATTRIBUTE_UPDATED',
  VehicleCapacityOverridden = 'VEHICLE_CAPACITY_OVERRIDDEN',
  VehicleCapacityUpdated = 'VEHICLE_CAPACITY_UPDATED',
  VehicleCreated = 'VEHICLE_CREATED',
  VehicleOperationalStateUpdated = 'VEHICLE_OPERATIONAL_STATE_UPDATED',
  VehicleServiceAborted = 'VEHICLE_SERVICE_ABORTED',
  VehicleStateUpdated = 'VEHICLE_STATE_UPDATED',
  VehicleUpdated = 'VEHICLE_UPDATED',
}

export type VehicleChangesQueryInput = {
  changeType?: InputMaybe<VehicleChangeType>
  fromDateTime?: InputMaybe<Scalars['DateTime']['input']>
  pagination?: InputMaybe<CursorPaginationInput>
  toDateTime?: InputMaybe<Scalars['DateTime']['input']>
  vehicleID: Scalars['ID']['input']
}

/** An exclusive reservation of a vehicle for a single customer. */
export type VehicleClaim = {
  __typename?: 'VehicleClaim'
  /** When the claim was created. */
  claimedAt: Scalars['DateTime']['output']
  /** Backoffice user id of the user who created the claim. */
  claimedByUserId: Scalars['ID']['output']
  /** The customer this vehicle is reserved for. */
  customerId: Scalars['ID']['output']
  /** When the claim expires. Always 30 days after `claimedAt`. */
  validUntil: Scalars['DateTime']['output']
}

export type VehicleClusterType = {
  __typename?: 'VehicleClusterType'
  centroid: Maybe<Geolocation>
  vins: Array<Scalars['String']['output']>
}

export enum VehicleColor {
  Beige = 'BEIGE',
  Black = 'BLACK',
  Blue = 'BLUE',
  Brown = 'BROWN',
  DarkBlue = 'DARK_BLUE',
  DarkGray = 'DARK_GRAY',
  DarkRed = 'DARK_RED',
  Gold = 'GOLD',
  Gray = 'GRAY',
  Green = 'GREEN',
  LightBlue = 'LIGHT_BLUE',
  LightGreen = 'LIGHT_GREEN',
  Orange = 'ORANGE',
  Pink = 'PINK',
  Purple = 'PURPLE',
  Red = 'RED',
  Silver = 'SILVER',
  Tan = 'TAN',
  White = 'WHITE',
  Yellow = 'YELLOW',
}

export enum VehicleConcessionType {
  None = 'NONE',
  Rental = 'RENTAL',
  RentalAndTransport = 'RENTAL_AND_TRANSPORT',
  Transport = 'TRANSPORT',
}

export type VehicleConfigurationInput = {
  color?: InputMaybe<VehicleColor>
  concessionType?: InputMaybe<VehicleConcessionType>
  deFleetingDate?: InputMaybe<Scalars['DateTime']['input']>
  firstRegistrationDate?: InputMaybe<Scalars['DateTime']['input']>
  fleetId: Scalars['ID']['input']
  hubId?: InputMaybe<Scalars['ID']['input']>
  label?: InputMaybe<Scalars['Int']['input']>
  licensePlate?: InputMaybe<Scalars['String']['input']>
  /** Country code for the license plate in ISO 3166‑1 alpha‑2 (two letter) format (e.g. US, DE) */
  licensePlateCountry?: InputMaybe<LicensePlateCountry>
  /** Two-letter US state/territory abbreviation for the license plate. */
  licensePlateRegion?: InputMaybe<LicensePlateRegion>
  /** Year of manufacture of the vehicle */
  modelYear?: InputMaybe<Scalars['Int']['input']>
  nextMainInspectionDate?: InputMaybe<Scalars['DateTime']['input']>
  serviceAreaUUID?: InputMaybe<Scalars['String']['input']>
}

export type VehicleCreateInput = {
  fleetId: Scalars['ID']['input']
  sdsProvider: SdsProvider
  tenant: Scalars['String']['input']
  vehicleType: VehicleType
  vin: Scalars['String']['input']
}

export type VehicleCreatedChange = FleetEntityChange & {
  __typename?: 'VehicleCreatedChange'
  backofficeUser: Maybe<BackofficeUser>
  changedAt: Scalars['DateTime']['output']
  changes: VehicleCreatedChangeFields
}

export type VehicleCreatedChangeFields = VehicleChangeFields & {
  __typename?: 'VehicleCreatedChangeFields'
  tenant: Maybe<Scalars['String']['output']>
  vehicleID: Scalars['ID']['output']
  vin: Maybe<Scalars['ID']['output']>
}

export type VehicleDailyMileageDelta = {
  __typename?: 'VehicleDailyMileageDelta'
  /** Local calendar day this bucket represents. Format: YYYY-MM-DD. */
  date: Scalars['Date']['output']
  /** Kilometres driven this day (max − min odometer). Null if no readings that day. */
  drivenKm: Maybe<Scalars['Float']['output']>
}

export type VehicleDataOverride = {
  __typename?: 'VehicleDataOverride'
  externalId: Scalars['String']['output']
  hasOverrides: Scalars['Boolean']['output']
  sessionId: Scalars['String']['output']
  source: VehicleDataSource
  vehicleId: Scalars['String']['output']
  vehicleIdShort: Scalars['String']['output']
  vtrId: Scalars['String']['output']
}

export type VehicleDataOverrideChangedFields = {
  __typename?: 'VehicleDataOverrideChangedFields'
  sessionId: Maybe<Scalars['String']['output']>
  vehicleId: Maybe<Scalars['String']['output']>
  vehicleIdShort: Maybe<Scalars['String']['output']>
  vtrId: Maybe<Scalars['String']['output']>
}

export type VehicleDataOverrideDeleteEntry = {
  externalId: Scalars['String']['input']
  source: VehicleDataSource
}

export type VehicleDataOverrideEntry = {
  externalId?: InputMaybe<Scalars['String']['input']>
  sessionId?: InputMaybe<Scalars['String']['input']>
  source: VehicleDataSource
  vehicleId?: InputMaybe<Scalars['String']['input']>
  vehicleIdShort?: InputMaybe<Scalars['String']['input']>
  vtrId?: InputMaybe<Scalars['String']['input']>
}

export type VehicleDataOverrideEvent = {
  __typename?: 'VehicleDataOverrideEvent'
  externalId: Scalars['String']['output']
  fieldName: Scalars['String']['output']
  id: Scalars['Int']['output']
  newValue: Maybe<Scalars['String']['output']>
  newValues: Maybe<VehicleDataOverrideChangedFields>
  oldValue: Maybe<Scalars['String']['output']>
  oldValues: Maybe<VehicleDataOverrideChangedFields>
  operation: ChangeEventOperation
  performedAt: Scalars['DateTime']['output']
  performedBy: Maybe<Scalars['String']['output']>
  source: Maybe<VehicleDataSource>
}

export enum VehicleDataOverrideField {
  ExternalId = 'EXTERNAL_ID',
  SessionId = 'SESSION_ID',
  Source = 'SOURCE',
  VehicleId = 'VEHICLE_ID',
  VehicleIdShort = 'VEHICLE_ID_SHORT',
  VtrId = 'VTR_ID',
}

export type VehicleDataOverrideFilterInput = {
  condition: VnvBackofficeFilterCondition
  field: VehicleDataOverrideField
  value: Scalars['String']['input']
}

export type VehicleDataOverrideQueryResponse = {
  __typename?: 'VehicleDataOverrideQueryResponse'
  items: Array<VehicleDataOverride>
  pageInfo: VnvBackofficePageInfo
}

/** Sort for vehicle data override search. SOURCE is not a valid sort field. */
export type VehicleDataOverrideSortInput = {
  direction?: VnvBackofficeSortDirection
  field: VehicleDataOverrideField
}

export enum VehicleDataSource {
  D9Session = 'D9_SESSION',
  GinDelivery = 'GIN_DELIVERY',
}

export type VehicleDetails = {
  __typename?: 'VehicleDetails'
  cabinState: Maybe<VehicleCabinState>
  geonetName: Scalars['String']['output']
  inService: Scalars['Boolean']['output']
  isConnected: Scalars['Boolean']['output']
  location: Maybe<Geolocation>
  missionTag: Scalars['Int']['output']
  orientation: Maybe<VehicleOrientation>
  partnerServiceState: VehiclePartnerServiceState
  platform: Scalars['String']['output']
  speedMps: Scalars['Float']['output']
  tripId: Scalars['String']['output']
  tripSegmentDistanceRemainingMeters: Scalars['Float']['output']
  tripSegmentEtaRemainingSeconds: Scalars['Int']['output']
  tripSegmentId: Scalars['Int']['output']
  tripSegmentStatus: VehicleTripSegmentStatus
  vehicleInstanceName: Scalars['String']['output']
  vehicleMissionState: Maybe<VehicleMissionState>
  vin: Scalars['String']['output']
}

export enum VehicleEngineType {
  Electric = 'ELECTRIC',
  Fuel = 'FUEL',
}

export type VehicleHubArrivalsResponse = ListResponse & {
  __typename?: 'VehicleHubArrivalsResponse'
  total: Scalars['Int']['output']
  vehicles: Array<Vehicle>
}

/** A unified vehicle incident normalized from any platform adapter */
export type VehicleIncident = {
  __typename?: 'VehicleIncident'
  /** Human-readable description of the incident */
  description: Scalars['String']['output']
  /** Short identifier for the incident type */
  name: Scalars['String']['output']
  /** ISO 8601 date-time with timezone, e.g. 2024-03-15T10:30:00Z */
  occurred: Scalars['String']['output']
  /** Severity level of the incident */
  severity: IncidentSeverity
  /** Whether the incident is currently active or has been resolved */
  state: IncidentState
  /** The vehicle this incident is associated with */
  vehicleId: Scalars['ID']['output']
}

export type VehicleIncidentNotification = TaskNotification & {
  __typename?: 'VehicleIncidentNotification'
  actionType: TaskActionType
  assigned: Maybe<TaskStateChangeDetails>
  createdAt: Scalars['DateTime']['output']
  fleetId: Maybe<Scalars['ID']['output']>
  foreignId: Scalars['ID']['output']
  id: Scalars['ID']['output']
  note: Maybe<TaskNotificationNote>
  notificationType: TaskNotificationType
  pended: Maybe<TaskStateChangeDetails>
  regionId: Maybe<Scalars['ID']['output']>
  resolved: Maybe<TaskStateChangeDetails>
  serviceAreaUUID: Scalars['ID']['output']
  severity: TaskNotificationSeverity
  stateChanges: Array<TaskStateChangeDetails>
  status: TaskNotificationStatus
  vehicle: Maybe<Vehicle>
  version: Scalars['Int']['output']
}

export type VehicleInteraction = {
  __typename?: 'VehicleInteraction'
  /** If the interaction was executed via backoffice, this is a reference to the user that did that */
  backofficeUser: Maybe<BackofficeUser>
  /** The employee (driver, service staff, etc) for whom the interaction was executed */
  employee: Maybe<Employee>
  /** True if the emergeny tab in the backoffice was used */
  hardwareKeyUsed: Scalars['Boolean']['output']
  /** The high voltage battery level of the vehicle at the time of the interaction */
  highVoltageBatteryLevel: Maybe<Scalars['Float']['output']>
  id: Scalars['ID']['output']
  /** Whether the interaction was executed from the backoffice or employee app */
  isBackofficeInteraction: Scalars['Boolean']['output']
  /** The vehicle mileage at the time of the interaction */
  mileage: Maybe<Scalars['Float']['output']>
  /** If the interaction was executed from the backoffice, a reason may be provided */
  reason: Maybe<Scalars['String']['output']>
  /** Only set if the vehicle that was interacted with was inside a service break location */
  serviceBreakLocation: Maybe<ServiceBreakLocation>
  /** Shift ID of the employee (driver, service staff, etc) for whom the interaction was executed */
  shiftId: Maybe<Scalars['ID']['output']>
  timestamp: Scalars['DateTime']['output']
  type: VehicleInteractionType
}

export enum VehicleInteractionError {
  AlreadyOpenedAnotherVehicle = 'ALREADY_OPENED_ANOTHER_VEHICLE',
  BoxProviderException = 'BOX_PROVIDER_EXCEPTION',
  CentralLockingTimeout = 'CENTRAL_LOCKING_TIMEOUT',
  EmployeeIdMissing = 'EMPLOYEE_ID_MISSING',
  EmployeeSuspended = 'EMPLOYEE_SUSPENDED',
  MissingPermission = 'MISSING_PERMISSION',
  NoBoxId = 'NO_BOX_ID',
  NoMatchingInteraction = 'NO_MATCHING_INTERACTION',
  PreconditionDoorOpen = 'PRECONDITION_DOOR_OPEN',
  PreconditionFuelCardMissing = 'PRECONDITION_FUEL_CARD_MISSING',
  PreconditionIgnitionOn = 'PRECONDITION_IGNITION_ON',
  PreconditionKeyFob = 'PRECONDITION_KEY_FOB',
  PreconditionLightsOn = 'PRECONDITION_LIGHTS_ON',
  PreconditionWindowOpen = 'PRECONDITION_WINDOW_OPEN',
  ShiftIdMissing = 'SHIFT_ID_MISSING',
  StateIncompatible = 'STATE_INCOMPATIBLE',
  Unknown = 'UNKNOWN',
  VehicleAlreadyClosed = 'VEHICLE_ALREADY_CLOSED',
  VehicleAlreadyOpen = 'VEHICLE_ALREADY_OPEN',
  VehicleClosedWithHardwareKey = 'VEHICLE_CLOSED_WITH_HARDWARE_KEY',
  VehicleInteractionInFlightConflict = 'VEHICLE_INTERACTION_IN_FLIGHT_CONFLICT',
  VehicleNotFound = 'VEHICLE_NOT_FOUND',
  VehicleOpenedWithHardwareKey = 'VEHICLE_OPENED_WITH_HARDWARE_KEY',
  VehicleReservedToOpen = 'VEHICLE_RESERVED_TO_OPEN',
  VehicleTooFarAway = 'VEHICLE_TOO_FAR_AWAY',
  WrongEmployee = 'WRONG_EMPLOYEE',
}

export type VehicleInteractionResponse = {
  __typename?: 'VehicleInteractionResponse'
  errors: Array<VehicleInteractionError>
  interactionID: Maybe<Scalars['ID']['output']>
}

export enum VehicleInteractionType {
  Close = 'CLOSE',
  Open = 'OPEN',
}

export enum VehicleInteractionUserType {
  Driver = 'DRIVER',
  FieldTester = 'FIELD_TESTER',
  Service = 'SERVICE',
}

export type VehicleInteractionsQueryInput = {
  fromDateTime?: InputMaybe<Scalars['DateTime']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  toDateTime?: InputMaybe<Scalars['DateTime']['input']>
  vehicleID: Scalars['ID']['input']
}

export type VehicleInteractionsResponse = {
  __typename?: 'VehicleInteractionsResponse'
  count: Scalars['Int']['output']
  vehicleInteractions: Array<VehicleInteraction>
}

export enum VehicleJourneyState {
  VehicleJourneyStateAssessDrivingNeed = 'VEHICLE_JOURNEY_STATE_ASSESS_DRIVING_NEED',
  VehicleJourneyStateAtStop = 'VEHICLE_JOURNEY_STATE_AT_STOP',
  VehicleJourneyStateEmergencyInProgress = 'VEHICLE_JOURNEY_STATE_EMERGENCY_IN_PROGRESS',
  VehicleJourneyStateEmergencyParked = 'VEHICLE_JOURNEY_STATE_EMERGENCY_PARKED',
  VehicleJourneyStateIdle = 'VEHICLE_JOURNEY_STATE_IDLE',
  VehicleJourneyStateInvalid = 'VEHICLE_JOURNEY_STATE_INVALID',
  VehicleJourneyStateOnDuty = 'VEHICLE_JOURNEY_STATE_ON_DUTY',
  VehicleJourneyStateRequestToDrive = 'VEHICLE_JOURNEY_STATE_REQUEST_TO_DRIVE',
  VehicleJourneyStateSafetyCheck = 'VEHICLE_JOURNEY_STATE_SAFETY_CHECK',
  VehicleJourneyStateSdsGuidance = 'VEHICLE_JOURNEY_STATE_SDS_GUIDANCE',
}

export type VehicleList = {
  __typename?: 'VehicleList'
  createdAt: Scalars['DateTime']['output']
  description: Maybe<Scalars['String']['output']>
  entries: Array<VehicleListEntry>
  /** UUID, generated by the backend */
  id: Scalars['ID']['output']
  lastEditedAt: Scalars['DateTime']['output']
  /** Provided by the backoffice user */
  name: Scalars['String']['output']
  /** UUID of the region this vehicle list belongs to */
  regionId: Maybe<Scalars['ID']['output']>
  tenant: Scalars['String']['output']
}

export type VehicleListEntry = {
  __typename?: 'VehicleListEntry'
  addedAt: Scalars['DateTime']['output']
  addedBy: Maybe<BackofficeUser>
  vehicle: Vehicle
}

export type VehicleListInput = {
  /** Extra description of the vehicle list */
  description?: InputMaybe<Scalars['String']['input']>
  /** Name of the vehicle list */
  name: Scalars['String']['input']
  /** The region this list belongs to (and all of its vehicles) */
  regionId: Scalars['ID']['input']
  /** The tenant this vehicle list belongs to */
  tenant: Scalars['String']['input']
}

export type VehicleListResponse = {
  __typename?: 'VehicleListResponse'
  success: Scalars['Boolean']['output']
  vehicleList: VehicleList
}

export type VehicleListsResponse = {
  __typename?: 'VehicleListsResponse'
  total: Scalars['Int']['output']
  vehicleLists: Array<VehicleList>
}

export type VehicleLocation = {
  __typename?: 'VehicleLocation'
  heading: Maybe<Scalars['Float']['output']>
  location: Maybe<Location>
  locationSource: Maybe<LocationSourceType>
  timestamp: Maybe<Scalars['DateTime']['output']>
}

export type VehicleMatchSafetyDriverInput = {
  vehicleId: Scalars['ID']['input']
}

export type VehicleMatchSafetyDriverResponse = {
  __typename?: 'VehicleMatchSafetyDriverResponse'
  vehicle: Vehicle
}

/** Credentials for joining a vehicle media stream. */
export type VehicleMediaStreamCredentials = {
  __typename?: 'VehicleMediaStreamCredentials'
  /** Present when meetingType is CHIME, null otherwise. */
  chime: Maybe<Scalars['ChimeMediaStreamCredentials']['output']>
  /** Present when meetingType is LIVEKIT, null otherwise. */
  livekit: Maybe<LiveKitMediaStreamCredentials>
  /** Indicates which credentials field is populated. */
  meetingType: MediaStreamPlatform
}

export type VehicleMileageDeltas = {
  __typename?: 'VehicleMileageDeltas'
  days: Array<VehicleDailyMileageDelta>
  vehicleId: Scalars['ID']['output']
  vehicleLabel: Maybe<Scalars['Int']['output']>
}

export type VehicleMileageDeltasInput = {
  /** Optional restriction to vehicles in these fleets (by current fleet membership). If omitted, all vehicles in the region are returned. */
  fleetIds?: InputMaybe<Array<Scalars['ID']['input']>>
  /** First local calendar day to include (inclusive). Format: YYYY-MM-DD. */
  fromDate: Scalars['Date']['input']
  /** Region to scope the query to. */
  regionId: Scalars['ID']['input']
  /** IANA time zone name (e.g. "Europe/Berlin") for local-day boundaries. Supplied by the browser. */
  timeZone: Scalars['String']['input']
  /** Last local calendar day to include (inclusive). Format: YYYY-MM-DD. */
  toDate: Scalars['Date']['input']
}

export type VehicleMileageDeltasResponse = {
  __typename?: 'VehicleMileageDeltasResponse'
  vehicles: Array<VehicleMileageDeltas>
}

/**
 * MOIA vehicle-mission-control state. Null when MOIA has reported nothing for the
 * vehicle — which is not the same as being IDLE with no errors.
 */
export type VehicleMissionState = {
  __typename?: 'VehicleMissionState'
  journeyState: VehicleJourneyState
  journeyStateTimestamp: Scalars['Float']['output']
  /** Unresolved SDS ride-execution errors, oldest first. */
  sdsRideExecutionErrors: Array<VehicleSdsRideExecutionError>
}

/** A single reason that keeps a vehicle NON_OPERATIONAL */
export type VehicleNonOperationalReason = {
  __typename?: 'VehicleNonOperationalReason'
  /** The date from which this reason makes the vehicle NON_OPERATIONAL. Always in the past for reasons reported here */
  nonOperationalDate: Scalars['DateTime']['output']
  type: VehicleNonOperationalReasonType
  /** The work order that caused this reason. Only set for type WORK_ORDER */
  workOrderId: Maybe<Scalars['ID']['output']>
}

export enum VehicleNonOperationalReasonType {
  /** The validity of the last successful pre-ride check has run out, a fresh check is needed */
  PreRideCheckExpired = 'PRE_RIDE_CHECK_EXPIRED',
  /** The last pre-ride check found critical issues that need to be resolved */
  PreRideCheckInvalid = 'PRE_RIDE_CHECK_INVALID',
  /** The vehicle has been activated but no pre-ride check result has arrived yet */
  PreRideCheckPending = 'PRE_RIDE_CHECK_PENDING',
  /** The vehicle was set to INACTIVE */
  VehicleDeactivated = 'VEHICLE_DEACTIVATED',
  /** A work order on the vehicle has become critical */
  WorkOrder = 'WORK_ORDER',
}

export enum VehicleOperationMode {
  Autonomous = 'Autonomous',
  Invalid = 'Invalid',
  Manual = 'Manual',
}

export enum VehicleOperationalState {
  NonOperational = 'NON_OPERATIONAL',
  Operational = 'OPERATIONAL',
}

export type VehicleOperationalStateChange = {
  __typename?: 'VehicleOperationalStateChange'
  backofficeUser: Maybe<BackofficeUser>
  createdAt: Scalars['DateTime']['output']
  operationalState: VehicleOperationalState
  reason: Maybe<VehicleNonOperationalReasonType>
  /** The work order that caused this change. Only set when reason is WORK_ORDER */
  workOrderId: Maybe<Scalars['ID']['output']>
}

export type VehicleOperationalStateUpdatedChange = FleetEntityChange & {
  __typename?: 'VehicleOperationalStateUpdatedChange'
  backofficeUser: Maybe<BackofficeUser>
  changedAt: Scalars['DateTime']['output']
  changes: VehicleOperationalStateUpdatedChangeFields
}

export type VehicleOperationalStateUpdatedChangeFields = VehicleChangeFields & {
  __typename?: 'VehicleOperationalStateUpdatedChangeFields'
  operationalStateNew: Maybe<VehicleOperationalState>
  operationalStateOld: Maybe<VehicleOperationalState>
  reason: Maybe<VehicleNonOperationalReasonType>
  vehicleID: Scalars['ID']['output']
  /** The work order that caused this change. Only set when reason is WORK_ORDER */
  workOrderId: Maybe<Scalars['ID']['output']>
}

export type VehicleOrientation = {
  __typename?: 'VehicleOrientation'
  pitch: Scalars['Float']['output']
  roll: Scalars['Float']['output']
  yaw: Scalars['Float']['output']
}

export enum VehicleOutOfServiceReason {
  OutOfServiceReasonBreak = 'OUT_OF_SERVICE_REASON_BREAK',
  OutOfServiceReasonCleaning = 'OUT_OF_SERVICE_REASON_CLEANING',
  OutOfServiceReasonDisconnected = 'OUT_OF_SERVICE_REASON_DISCONNECTED',
  OutOfServiceReasonEndOfShift = 'OUT_OF_SERVICE_REASON_END_OF_SHIFT',
  OutOfServiceReasonFleetTakedown = 'OUT_OF_SERVICE_REASON_FLEET_TAKEDOWN',
  OutOfServiceReasonIngest = 'OUT_OF_SERVICE_REASON_INGEST',
  OutOfServiceReasonInvalid = 'OUT_OF_SERVICE_REASON_INVALID',
  OutOfServiceReasonLastTrip = 'OUT_OF_SERVICE_REASON_LAST_TRIP',
  OutOfServiceReasonOperatorAction = 'OUT_OF_SERVICE_REASON_OPERATOR_ACTION',
  OutOfServiceReasonRefueling = 'OUT_OF_SERVICE_REASON_REFUELING',
  OutOfServiceReasonTroubleshooting = 'OUT_OF_SERVICE_REASON_TROUBLESHOOTING',
}

export enum VehiclePartnerServiceState {
  PartnerServiceStateInvalid = 'PARTNER_SERVICE_STATE_INVALID',
  PartnerServiceStateInService = 'PARTNER_SERVICE_STATE_IN_SERVICE',
  PartnerServiceStateOutOfService = 'PARTNER_SERVICE_STATE_OUT_OF_SERVICE',
}

export type VehiclePlan = {
  __typename?: 'VehiclePlan'
  activities: Array<VehiclePlanActivity>
  date: Scalars['Date']['output']
  vehicleId: Scalars['ID']['output']
  vehiclePlanVersion: Scalars['Int']['output']
}

export type VehiclePlanActivity = {
  __typename?: 'VehiclePlanActivity'
  activityId: Scalars['ID']['output']
  assignedTo: Maybe<BackofficeUser>
  comment: Maybe<Scalars['String']['output']>
  endAt: Scalars['DateTime']['output']
  link: Maybe<Link>
  plannedServiceBreakLocation: Maybe<ServiceBreakLocation>
  purpose: VehiclePlanActivityPurpose
  shorteningAllowed: Scalars['Boolean']['output']
  startAt: Scalars['DateTime']['output']
}

export type VehiclePlanActivityDeleteInput = {
  activityId: Scalars['ID']['input']
  date: Scalars['Date']['input']
  vehicleId: Scalars['ID']['input']
  vehiclePlanVersion: Scalars['Int']['input']
}

export type VehiclePlanActivityInput = {
  activityId?: InputMaybe<Scalars['ID']['input']>
  assignedToBackofficeUserId?: InputMaybe<Scalars['ID']['input']>
  comment?: InputMaybe<Scalars['String']['input']>
  endAt: Scalars['DateTime']['input']
  link?: InputMaybe<LinkInput>
  plannedServiceBreakLocationId?: InputMaybe<Scalars['ID']['input']>
  purpose: VehiclePlanActivityPurpose
  /** LocalDate of the plan the activity currently lives on. Only used when updating an existing activity (activityId set) whose startAt moves across a UTC day boundary, so the activity can still be located on its original plan. Ignored on create/add, where the plan is always startAt's UTC date. */
  sourceDate?: InputMaybe<Scalars['Date']['input']>
  startAt: Scalars['DateTime']['input']
  vehicleId: Scalars['ID']['input']
  vehiclePlanVersion?: InputMaybe<Scalars['Int']['input']>
}

export type VehiclePlanActivityMoveInput = {
  activityId: Scalars['ID']['input']
  /** New start of the activity; its duration is preserved (endAt = newStartAt + previous duration). The receiving plan is the one for newStartAt's UTC date. */
  newStartAt: Scalars['DateTime']['input']
  receivingVehicleId: Scalars['ID']['input']
  /** Version of the receiving plan; omit when the receiving vehicle has no plan for newStartAt's UTC date yet. */
  receivingVehiclePlanVersion?: InputMaybe<Scalars['Int']['input']>
  /** LocalDate of the source plan; identifies the plan independently of the activity's UTC instant. */
  sourceDate: Scalars['Date']['input']
  sourceVehicleId: Scalars['ID']['input']
  sourceVehiclePlanVersion: Scalars['Int']['input']
}

export type VehiclePlanActivityMoveResult = {
  __typename?: 'VehiclePlanActivityMoveResult'
  receivingVehiclePlan: VehiclePlan
  sourceVehiclePlan: VehiclePlan
}

export enum VehiclePlanActivityPurpose {
  Demo = 'DEMO',
  DemoMaas = 'DEMO_MAAS',
  Maas = 'MAAS',
  Testing = 'TESTING',
  TestingMaas = 'TESTING_MAAS',
}

/** A reusable set of activities that a planner can apply to vehicles. Belongs to an operator tenant, not to a user. */
export type VehiclePlanTemplate = {
  __typename?: 'VehiclePlanTemplate'
  /** The template's activities, sorted by start time of day. */
  activities: Array<VehiclePlanTemplateActivity>
  /** Free text, empty when none was given. */
  description: Scalars['String']['output']
  /** When the template was last changed. */
  lastModifiedAt: Scalars['DateTime']['output']
  /** Null when the editor is no longer stored. */
  lastModifiedBy: Maybe<BackofficeUser>
  /** Shown in the templates list. Not unique within a tenant. */
  name: Scalars['String']['output']
  /** Stable id of the template, assigned on creation. */
  templateId: Scalars['ID']['output']
}

/** One activity of a template. Applying a template copies these values into vehicle plans. */
export type VehiclePlanTemplateActivity = {
  __typename?: 'VehiclePlanTemplateActivity'
  /** Null when nobody is assigned, and also when the reference is no longer stored. */
  assignedTo: Maybe<BackofficeUser>
  /** Free text for the planner. */
  comment: Maybe<Scalars['String']['output']>
  /** Local time of day at which the activity ends. */
  endAt: Scalars['LocalTime']['output']
  /** Link to further information, e.g. a wiki page. */
  link: Maybe<Link>
  /** Where the driver is meant to take the planned service break. */
  plannedServiceBreakLocation: Maybe<ServiceBreakLocation>
  /** What the vehicle is meant to do during the activity. */
  purpose: VehiclePlanActivityPurpose
  /** Local time of day. A template carries no date, so an endAt before startAt means the activity runs past midnight. */
  startAt: Scalars['LocalTime']['output']
  /** Stable id of the activity within its template, assigned on creation. */
  templateActivityId: Scalars['ID']['output']
}

/** One activity of a template. Activities of the same template must not overlap. */
export type VehiclePlanTemplateActivityInput = {
  /** The driver this activity is meant for. Kept only for a limited retention period. */
  assignedToBackofficeUserId?: InputMaybe<Scalars['ID']['input']>
  /** Free text for the planner, optional. */
  comment?: InputMaybe<Scalars['String']['input']>
  /** Local time of day at which the activity ends. Before startAt means it runs past midnight. Must differ from startAt. */
  endAt: Scalars['LocalTime']['input']
  /** Optional link to further information, e.g. a wiki page. */
  link?: InputMaybe<LinkInput>
  /** Where the driver is meant to take the planned service break. */
  plannedServiceBreakLocationId?: InputMaybe<Scalars['ID']['input']>
  /** What the vehicle is meant to do during the activity. */
  purpose: VehiclePlanActivityPurpose
  /** Local time of day at which the activity starts. */
  startAt: Scalars['LocalTime']['input']
  /** Absent for an activity that is added by this call. */
  templateActivityId?: InputMaybe<Scalars['ID']['input']>
}

/** Which template to apply, to which vehicles, and on which day. */
export type VehiclePlanTemplateApplyInput = {
  /**
   * The local calendar date the planner picked. The times in the template are read as local times of the
   * region the vehicles belong to, so the resulting plans can fall on a different UTC date than this one.
   */
  startDate: Scalars['Date']['input']
  /** The template whose activities are copied. The copies keep no reference to it. */
  templateId: Scalars['ID']['input']
  /**
   * The vehicles to plan, at most 40 per call. A vehicle listed twice is planned once. They must all belong
   * to one region, because a single local time cannot mean two instants at once.
   */
  vehicleIds: Array<Scalars['ID']['input']>
}

/** The full content of a template. Activities left out of this list are removed from the template. */
export type VehiclePlanTemplateSaveInput = {
  /** The template's activities in full, in any order. */
  activities: Array<VehiclePlanTemplateActivityInput>
  /** Free text, optional. An absent description is stored as empty. */
  description?: InputMaybe<Scalars['String']['input']>
  /** Shown in the templates list. Not required to be unique within a tenant. */
  name: Scalars['String']['input']
  /** Absent when creating a new template. */
  templateId?: InputMaybe<Scalars['ID']['input']>
}

export enum VehiclePrioritizationImpossibleReason {
  InsufficientStateOfCharge = 'INSUFFICIENT_STATE_OF_CHARGE',
  NotActive = 'NOT_ACTIVE',
  NotClosed = 'NOT_CLOSED',
  NotOnline = 'NOT_ONLINE',
}

export type VehiclePrioritizationInput = {
  isPrioritized: Scalars['Boolean']['input']
  vehicleID: Scalars['ID']['input']
}

export type VehicleResponse = {
  __typename?: 'VehicleResponse'
  success: Scalars['Boolean']['output']
  vehicle: Vehicle
}

export type VehicleRoute = {
  __typename?: 'VehicleRoute'
  routeShape: Scalars['String']['output']
}

export type VehicleSdsRideExecutionError = {
  __typename?: 'VehicleSdsRideExecutionError'
  errorId: Scalars['String']['output']
  errorTimestamp: Scalars['Float']['output']
  errorType: VehicleSdsRideExecutionErrorType
  /** INVALID unless errorType is one of the RIDE_REJECTED_* variants. */
  rejectionReason: VehicleSdsRideRejectionReason
}

export enum VehicleSdsRideExecutionErrorType {
  SdsRideExecutionErrorTypeDrivingTimeout = 'SDS_RIDE_EXECUTION_ERROR_TYPE_DRIVING_TIMEOUT',
  SdsRideExecutionErrorTypeInvalid = 'SDS_RIDE_EXECUTION_ERROR_TYPE_INVALID',
  SdsRideExecutionErrorTypeRideAcceptedTimeout = 'SDS_RIDE_EXECUTION_ERROR_TYPE_RIDE_ACCEPTED_TIMEOUT',
  SdsRideExecutionErrorTypeRideRejectedOnDuty = 'SDS_RIDE_EXECUTION_ERROR_TYPE_RIDE_REJECTED_ON_DUTY',
  SdsRideExecutionErrorTypeRideRejectedStationary = 'SDS_RIDE_EXECUTION_ERROR_TYPE_RIDE_REJECTED_STATIONARY',
}

export enum VehicleSdsRideRejectionReason {
  SdsRideRejectionReasonInvalid = 'SDS_RIDE_REJECTION_REASON_INVALID',
  SdsRideRejectionReasonRouteRejected = 'SDS_RIDE_REJECTION_REASON_ROUTE_REJECTED',
  SdsRideRejectionReasonSdsInWrongStatus = 'SDS_RIDE_REJECTION_REASON_SDS_IN_WRONG_STATUS',
  SdsRideRejectionReasonSdsNotActive = 'SDS_RIDE_REJECTION_REASON_SDS_NOT_ACTIVE',
  SdsRideRejectionReasonSdsNotEngaged = 'SDS_RIDE_REJECTION_REASON_SDS_NOT_ENGAGED',
}

export type VehicleSearchInput = {
  /** If not provided will return both available and unavailable vehicles */
  availability?: InputMaybe<VehicleAvailability>
  /** The base hub is the hub from where the vehicle starts and where its shifts end. */
  baseHubs?: InputMaybe<Array<Scalars['ID']['input']>>
  boardVoltageRange?: InputMaybe<FloatRangeInput>
  /** Filter by capacity config IDs */
  capacityConfigIds?: InputMaybe<Array<Scalars['ID']['input']>>
  chargingModes?: InputMaybe<Array<ChargingMode>>
  concessionTypes?: InputMaybe<Array<VehicleConcessionType>>
  /** Filters Vehicles by CDIS box states */
  connectedStates?: InputMaybe<Array<ConnectedState>>
  /** Values can be hub IDs or 'IN_FIELD'. If empty vehicles won't be filtered. */
  currentLocations?: InputMaybe<Array<Scalars['String']['input']>>
  deactivation?: InputMaybe<Deactivation>
  engineType?: InputMaybe<VehicleEngineType>
  fleets?: InputMaybe<Array<Scalars['ID']['input']>>
  hasScheduledStateChange?: InputMaybe<Scalars['Boolean']['input']>
  highVoltageBatteryPercentageRanges?: InputMaybe<Array<FloatRangeInput>>
  /** Filter by vehicles that are part of vehicle lists with the provided IDs */
  inVehicleLists?: InputMaybe<Array<Scalars['ID']['input']>>
  isSelfDriving?: InputMaybe<Scalars['Boolean']['input']>
  lastInteracted?: InputMaybe<DateTimeIntervalInput>
  lastInteractionTypeFilter?: InputMaybe<Array<VehicleInteractionType>>
  lastInteractionUserTypes?: InputMaybe<Array<VehicleInteractionUserType>>
  /** Whether the vehicle is physically locked. Independent from the vehicle interaction state. */
  locked?: InputMaybe<Scalars['Boolean']['input']>
  operationalStates?: InputMaybe<Array<VehicleOperationalState>>
  pluggedIn?: InputMaybe<Scalars['Boolean']['input']>
  regions?: InputMaybe<Array<Scalars['ID']['input']>>
  /** Search by label, license plate or VIN */
  search?: InputMaybe<Scalars['String']['input']>
  serviceAreaUUID?: InputMaybe<Scalars['ID']['input']>
  states?: InputMaybe<Array<VehicleState>>
  vehicleTypes?: InputMaybe<Array<VehicleType>>
}

export type VehicleServiceAbortedChange = FleetEntityChange & {
  __typename?: 'VehicleServiceAbortedChange'
  backofficeUser: Maybe<BackofficeUser>
  changedAt: Scalars['DateTime']['output']
  changes: VehicleServiceAbortedChangeFields
}

export type VehicleServiceAbortedChangeFields = VehicleChangeFields & {
  __typename?: 'VehicleServiceAbortedChangeFields'
  otherReasonDescription: Maybe<Scalars['String']['output']>
  reason: Maybe<FccCancellationReason>
  returnToServiceBreakLocation: Maybe<ServiceBreakLocation>
  vehicleID: Scalars['ID']['output']
}

export enum VehicleServiceState {
  ServiceStateInvalid = 'SERVICE_STATE_INVALID',
  ServiceStateInService = 'SERVICE_STATE_IN_SERVICE',
  ServiceStateNotReadyForMission = 'SERVICE_STATE_NOT_READY_FOR_MISSION',
  ServiceStateOutOfService = 'SERVICE_STATE_OUT_OF_SERVICE',
  ServiceStateReadyForMission = 'SERVICE_STATE_READY_FOR_MISSION',
  ServiceStateShutdown = 'SERVICE_STATE_SHUTDOWN',
  ServiceStateStartup = 'SERVICE_STATE_STARTUP',
}

export type VehicleServiceStateData = {
  __typename?: 'VehicleServiceStateData'
  outOfServiceReasons: Array<VehicleOutOfServiceReason>
  serviceState: VehicleServiceState
}

export enum VehicleState {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
  Inactive = 'INACTIVE',
}

export type VehicleStateChange = {
  __typename?: 'VehicleStateChange'
  changeReasonFreeText: Maybe<Scalars['String']['output']>
  createdAt: Maybe<Scalars['DateTime']['output']>
  createdByUser: Maybe<BackofficeUser>
  /** Date and time when the vehicle is expected to be activated again, basically a downtime forecast. */
  expectedActivationAt: Maybe<Scalars['DateTime']['output']>
  updatedAt: Maybe<Scalars['DateTime']['output']>
  updatedBy: Maybe<BackofficeUser>
  vehicleStateChangeReason: Maybe<VehicleStateChangeReason>
}

export enum VehicleStateChangeReason {
  DamagesOther = 'DAMAGES_OTHER',
  DamagesSelfRepairAtHub = 'DAMAGES_SELF_REPAIR_AT_HUB',
  DamagesSmartRepairAtHub = 'DAMAGES_SMART_REPAIR_AT_HUB',
  DamagesWorkshop = 'DAMAGES_WORKSHOP',
  Defects_12V = 'DEFECTS_12V',
  DefectsErrorMessage = 'DEFECTS_ERROR_MESSAGE',
  DefectsHighVoltage = 'DEFECTS_HIGH_VOLTAGE',
  DefectsHighVoltageBjb = 'DEFECTS_HIGH_VOLTAGE_BJB',
  DefectsIvc = 'DEFECTS_IVC',
  DefectsOther = 'DEFECTS_OTHER',
  EventsCleaning = 'EVENTS_CLEANING',
  EventsDefleeting = 'EVENTS_DEFLEETING',
  EventsMarketing = 'EVENTS_MARKETING',
  EventsOther = 'EVENTS_OTHER',
  EventsRental = 'EVENTS_RENTAL',
  EventsServiceCancellation = 'EVENTS_SERVICE_CANCELLATION',
  EventsStickers = 'EVENTS_STICKERS',
  EventsUsableReserve = 'EVENTS_USABLE_RESERVE',
  ServiceMainInspection = 'SERVICE_MAIN_INSPECTION',
  ServiceMileageInspection = 'SERVICE_MILEAGE_INSPECTION',
  ServiceMoiaVwAction = 'SERVICE_MOIA_VW_ACTION',
  ServiceOther = 'SERVICE_OTHER',
  ServiceTireCheckSwap = 'SERVICE_TIRE_CHECK_SWAP',
  ServiceVic = 'SERVICE_VIC',
}

export type VehicleStateUpdatedChange = FleetEntityChange & {
  __typename?: 'VehicleStateUpdatedChange'
  backofficeUser: Maybe<BackofficeUser>
  changedAt: Scalars['DateTime']['output']
  /** Timestamp of the last entity change of the same type */
  changedAtPreviously: Maybe<Scalars['DateTime']['output']>
  changes: VehicleStateUpdatedChangeFields
}

export type VehicleStateUpdatedChangeFields = VehicleChangeFields & {
  __typename?: 'VehicleStateUpdatedChangeFields'
  reasonFreeTextNew: Maybe<Scalars['String']['output']>
  reasonFreeTextOld: Maybe<Scalars['String']['output']>
  scheduledNew: Maybe<Scalars['Boolean']['output']>
  scheduledOld: Maybe<Scalars['Boolean']['output']>
  stateNew: Maybe<VehicleState>
  stateOld: Maybe<VehicleState>
  vehicleID: Scalars['ID']['output']
  vehicleStateChangeReasonNew: Maybe<VehicleStateChangeReason>
  vehicleStateChangeReasonOld: Maybe<VehicleStateChangeReason>
}

export type VehicleStatusBooleanSignal = {
  __typename?: 'VehicleStatusBooleanSignal'
  updatedAt: Scalars['String']['output']
  value: Scalars['Boolean']['output']
}

export type VehicleStatusCabinConnectivitySignal = {
  __typename?: 'VehicleStatusCabinConnectivitySignal'
  connectivityState: Scalars['Boolean']['output']
  updatedAt: Scalars['String']['output']
}

export enum VehicleStatusChargingState {
  ChargingCompleted = 'CHARGING_COMPLETED',
  ChargingError = 'CHARGING_ERROR',
  ChargingInProgress = 'CHARGING_IN_PROGRESS',
  ChargingSessionNotStarted = 'CHARGING_SESSION_NOT_STARTED',
  ChargingSessionStarted = 'CHARGING_SESSION_STARTED',
}

export type VehicleStatusChargingStateSignal = {
  __typename?: 'VehicleStatusChargingStateSignal'
  state: VehicleStatusChargingState
  updatedAt: Scalars['String']['output']
}

export type VehicleStatusConnectionSignal = {
  __typename?: 'VehicleStatusConnectionSignal'
  connected: Scalars['Boolean']['output']
  updatedAt: Scalars['String']['output']
}

export type VehicleStatusDetail = {
  __typename?: 'VehicleStatusDetail'
  actualNamespace: Scalars['String']['output']
  appliedKozDocumentId: Scalars['String']['output']
  appliedKozDocumentVersionId: Scalars['String']['output']
  autonomyEnabled: Scalars['Boolean']['output']
  cabinState: Maybe<VehicleCabinState>
  cellularSignal: Maybe<VehicleCellularSignal>
  codriver: Scalars['String']['output']
  configuredNamespace: Scalars['String']['output']
  coordinate: Maybe<Geolocation>
  currentLaneSegmentId: Scalars['Int']['output']
  deviceIds: Array<Scalars['String']['output']>
  driver: Scalars['String']['output']
  driverEmail: Scalars['String']['output']
  geonetName: Scalars['String']['output']
  gpsTime: Scalars['Float']['output']
  inService: Scalars['Boolean']['output']
  ingestType: Scalars['String']['output']
  isConnected: Scalars['Boolean']['output']
  kozDocumentId: Scalars['String']['output']
  kozDocumentVersionId: Scalars['String']['output']
  lastRouteUpdateVehicleTime: Scalars['Float']['output']
  localizedDistance: Scalars['Float']['output']
  localizedGeolocation: Maybe<Geolocation>
  logFullName: Scalars['String']['output']
  logId: Scalars['Int']['output']
  logName: Scalars['String']['output']
  mapCollecting: Scalars['Boolean']['output']
  mapIds: Array<Scalars['Int']['output']>
  missionTag: Scalars['String']['output']
  odometerKm: Scalars['Float']['output']
  orientation: Maybe<VehicleOrientation>
  partnerServiceState: VehiclePartnerServiceState
  platform: Scalars['String']['output']
  poseQuality: Scalars['Float']['output']
  rangeKm: Scalars['Int']['output']
  remoteGuidanceState: Scalars['String']['output']
  sequenceId: Scalars['Int']['output']
  serverTime: Scalars['Float']['output']
  serviceStateData: Maybe<VehicleServiceStateData>
  serviceStateOverride: Scalars['Boolean']['output']
  softwareTag: Scalars['String']['output']
  speedMps: Scalars['Float']['output']
  ticketName: Scalars['String']['output']
  transmissionShiftState: Scalars['String']['output']
  tripAssignmentsSupported: Scalars['Boolean']['output']
  tripId: Scalars['String']['output']
  tripSegmentDistanceRemainingMeters: Scalars['Float']['output']
  tripSegmentEtaRemainingSeconds: Scalars['Int']['output']
  tripSegmentId: Scalars['String']['output']
  tripSegmentStatus: VehicleTripSegmentStatus
  vehicleId: Scalars['String']['output']
  vehicleInstanceName: Scalars['String']['output']
  vehicleMissionState: Maybe<VehicleMissionState>
  vehicleTime: Scalars['Float']['output']
  vin: Scalars['String']['output']
}

export enum VehicleStatusDoorPosition {
  PassengerDoorLeft = 'PASSENGER_DOOR_LEFT',
  PassengerDoorRight = 'PASSENGER_DOOR_RIGHT',
}

export enum VehicleStatusDoorState {
  Ajar = 'AJAR',
  Closed = 'CLOSED',
  Closing = 'CLOSING',
  Open = 'OPEN',
  Opening = 'OPENING',
}

export type VehicleStatusDoorStateSignal = {
  __typename?: 'VehicleStatusDoorStateSignal'
  position: VehicleStatusDoorPosition
  state: VehicleStatusDoorState
  updatedAt: Scalars['String']['output']
}

export type VehicleStatusDoorStates = {
  __typename?: 'VehicleStatusDoorStates'
  states: Array<VehicleStatusDoorStateSignal>
}

export enum VehicleStatusDrivingMode {
  Autonomous = 'AUTONOMOUS',
  Manual = 'MANUAL',
}

export type VehicleStatusDrivingModeSignal = {
  __typename?: 'VehicleStatusDrivingModeSignal'
  updatedAt: Scalars['String']['output']
  value: VehicleStatusDrivingMode
}

export type VehicleStatusFilterInput = {
  fleetId?: InputMaybe<Scalars['String']['input']>
  geonetName?: InputMaybe<Scalars['String']['input']>
  inServiceOnly?: InputMaybe<Scalars['Boolean']['input']>
  metropolisId?: InputMaybe<Scalars['Int']['input']>
  outOfServiceReasons?: InputMaybe<Array<VehicleOutOfServiceReason>>
  serviceState?: InputMaybe<VehicleServiceState>
}

export type VehicleStatusFloatSignal = {
  __typename?: 'VehicleStatusFloatSignal'
  updatedAt: Scalars['String']['output']
  value: Scalars['Float']['output']
}

export enum VehicleStatusGearState {
  Drive = 'DRIVE',
  Neutral = 'NEUTRAL',
  Park = 'PARK',
  Reverse = 'REVERSE',
}

export type VehicleStatusGearStateSignal = {
  __typename?: 'VehicleStatusGearStateSignal'
  gear: VehicleStatusGearState
  parkBrakeEngaged: Scalars['Boolean']['output']
  updatedAt: Scalars['String']['output']
}

export enum VehicleStatusKneeLevelState {
  DefaultHeight = 'DEFAULT_HEIGHT',
  HeightLowered = 'HEIGHT_LOWERED',
  LevellingInProgress = 'LEVELLING_IN_PROGRESS',
  LowLevel_1 = 'LOW_LEVEL_1',
  LowLevel_2 = 'LOW_LEVEL_2',
  LowLevel_3 = 'LOW_LEVEL_3',
  LowLevel_4 = 'LOW_LEVEL_4',
  LowLevel_5 = 'LOW_LEVEL_5',
  UpLevel_1 = 'UP_LEVEL_1',
  UpLevel_2 = 'UP_LEVEL_2',
  UpLevel_3 = 'UP_LEVEL_3',
  UpLevel_4 = 'UP_LEVEL_4',
  UpLevel_5 = 'UP_LEVEL_5',
}

export type VehicleStatusKneeLevelStateSignal = {
  __typename?: 'VehicleStatusKneeLevelStateSignal'
  state: VehicleStatusKneeLevelState
  updatedAt: Scalars['String']['output']
}

export type VehicleStatusLocationSignal = {
  __typename?: 'VehicleStatusLocationSignal'
  heading: Maybe<Scalars['Float']['output']>
  latitude: Scalars['Float']['output']
  longitude: Scalars['Float']['output']
  updatedAt: Scalars['String']['output']
}

export enum VehicleStatusMrmState {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  NotActive = 'NOT_ACTIVE',
}

export type VehicleStatusMrmStateSignal = {
  __typename?: 'VehicleStatusMrmStateSignal'
  updatedAt: Scalars['String']['output']
  value: VehicleStatusMrmState
}

export enum VehicleStatusRampState {
  Extended = 'EXTENDED',
  Extending = 'EXTENDING',
  PartiallyExtended = 'PARTIALLY_EXTENDED',
  Retracted = 'RETRACTED',
  Retracting = 'RETRACTING',
}

export type VehicleStatusRampStateSignal = {
  __typename?: 'VehicleStatusRampStateSignal'
  state: VehicleStatusRampState
  updatedAt: Scalars['String']['output']
}

export enum VehicleStatusSdsMode {
  Disengaged = 'DISENGAGED',
  Engaged = 'ENGAGED',
  Fault = 'FAULT',
}

export type VehicleStatusSdsModeSignal = {
  __typename?: 'VehicleStatusSdsModeSignal'
  updatedAt: Scalars['String']['output']
  value: VehicleStatusSdsMode
}

export type VehicleStatusSeatOccupancy = {
  __typename?: 'VehicleStatusSeatOccupancy'
  seatbeltWarning: Scalars['Boolean']['output']
  state: VehicleStatusSeatOccupancyState
  updatedAt: Scalars['String']['output']
}

export enum VehicleStatusSeatOccupancyState {
  StateEmpty = 'STATE_EMPTY',
  StateNotInstalled = 'STATE_NOT_INSTALLED',
  StateOccupied = 'STATE_OCCUPIED',
}

export enum VehicleStatusSeatPosition {
  CockpitLeft = 'COCKPIT_LEFT',
  CockpitRight = 'COCKPIT_RIGHT',
  SecondRowLeft = 'SECOND_ROW_LEFT',
  SecondRowMiddle = 'SECOND_ROW_MIDDLE',
  SecondRowRight = 'SECOND_ROW_RIGHT',
  ThirdRowLeft = 'THIRD_ROW_LEFT',
  ThirdRowMiddle = 'THIRD_ROW_MIDDLE',
  ThirdRowRight = 'THIRD_ROW_RIGHT',
}

export type VehicleStatusSeatState = {
  __typename?: 'VehicleStatusSeatState'
  occupancy: Maybe<VehicleStatusSeatOccupancy>
  position: VehicleStatusSeatPosition
  seatbelt: Maybe<VehicleStatusSeatbelt>
}

export type VehicleStatusSeatStates = {
  __typename?: 'VehicleStatusSeatStates'
  states: Array<VehicleStatusSeatState>
}

export type VehicleStatusSeatbelt = {
  __typename?: 'VehicleStatusSeatbelt'
  state: VehicleStatusSeatbeltState
  updatedAt: Scalars['String']['output']
}

export enum VehicleStatusSeatbeltState {
  StateFastened = 'STATE_FASTENED',
  StateNotFastened = 'STATE_NOT_FASTENED',
  StateNotInstalled = 'STATE_NOT_INSTALLED',
}

export type VehicleStatusVehicleCapabilities = {
  __typename?: 'VehicleStatusVehicleCapabilities'
  cabinConnectivity: Scalars['Boolean']['output']
  centralLockLocked: Scalars['Boolean']['output']
  chargingState: Scalars['Boolean']['output']
  connectionStatus: Scalars['Boolean']['output']
  consumedEnergyWattPerSecond: Scalars['Boolean']['output']
  doorState: Scalars['Boolean']['output']
  drivingMode: Scalars['Boolean']['output']
  exteriorTemperatureCelsius: Scalars['Boolean']['output']
  gearState: Scalars['Boolean']['output']
  highVoltBatterySocPercentage: Scalars['Boolean']['output']
  ignitionOn: Scalars['Boolean']['output']
  interiorTemperatureCelsius: Scalars['Boolean']['output']
  kneeLevelState: Scalars['Boolean']['output']
  location: Scalars['Boolean']['output']
  mileage: Scalars['Boolean']['output']
  mrmState: Scalars['Boolean']['output']
  rampState: Scalars['Boolean']['output']
  remainingCruisingRangeKilometer: Scalars['Boolean']['output']
  sdsConnectionStatus: Scalars['Boolean']['output']
  sdsMode: Scalars['Boolean']['output']
  seatStates: Scalars['Boolean']['output']
  signalConnectivity: Scalars['Boolean']['output']
  speed: Scalars['Boolean']['output']
  vmcConnectionStatus: Scalars['Boolean']['output']
}

export type VehicleStatusVehicleTelemetry = {
  __typename?: 'VehicleStatusVehicleTelemetry'
  cabinConnectivity: Maybe<VehicleStatusCabinConnectivitySignal>
  capabilities: VehicleStatusVehicleCapabilities
  centralLockLocked: Maybe<VehicleStatusBooleanSignal>
  chargingState: Maybe<VehicleStatusChargingStateSignal>
  connectionStatus: Maybe<VehicleStatusConnectionSignal>
  consumedEnergyWattPerSecond: Maybe<VehicleStatusFloatSignal>
  doorState: VehicleStatusDoorStates
  drivingMode: Maybe<VehicleStatusDrivingModeSignal>
  exteriorTemperatureCelsius: Maybe<VehicleStatusFloatSignal>
  gearState: Maybe<VehicleStatusGearStateSignal>
  highVoltBatterySocPercentage: Maybe<VehicleStatusFloatSignal>
  ignitionOn: Maybe<VehicleStatusBooleanSignal>
  interiorTemperatureCelsius: Maybe<VehicleStatusFloatSignal>
  kneeLevelState: Maybe<VehicleStatusKneeLevelStateSignal>
  location: Maybe<VehicleStatusLocationSignal>
  mileage: Maybe<VehicleStatusFloatSignal>
  mrmState: Maybe<VehicleStatusMrmStateSignal>
  rampState: Maybe<VehicleStatusRampStateSignal>
  remainingCruisingRangeKilometer: Maybe<VehicleStatusFloatSignal>
  sdsConnectionStatus: Maybe<VehicleStatusConnectionSignal>
  sdsMode: Maybe<VehicleStatusSdsModeSignal>
  seatStates: VehicleStatusSeatStates
  signalConnectivity: Maybe<VehicleStatusBooleanSignal>
  speed: Maybe<VehicleStatusFloatSignal>
  vehicleId: Scalars['ID']['output']
  vmcConnectionStatus: Maybe<VehicleStatusConnectionSignal>
}

export type VehicleSummaryType = {
  __typename?: 'VehicleSummaryType'
  autonomyEnabled: Scalars['Boolean']['output']
  gpsGeolocation: Maybe<Geolocation>
  inService: Scalars['Boolean']['output']
  name: Scalars['String']['output']
  poseGeolocation: Maybe<Geolocation>
  poseQuality: Scalars['Float']['output']
  serviceStateData: Maybe<VehicleServiceStateData>
  vin: Scalars['String']['output']
  yaw: Scalars['Float']['output']
}

export type VehicleSurveillanceNotification = TaskNotification & {
  __typename?: 'VehicleSurveillanceNotification'
  actionType: TaskActionType
  assigned: Maybe<TaskStateChangeDetails>
  createdAt: Scalars['DateTime']['output']
  employee: Maybe<Employee>
  fleetId: Maybe<Scalars['ID']['output']>
  foreignId: Scalars['ID']['output']
  id: Scalars['ID']['output']
  note: Maybe<TaskNotificationNote>
  notificationType: TaskNotificationType
  pended: Maybe<TaskStateChangeDetails>
  regionId: Maybe<Scalars['ID']['output']>
  resolved: Maybe<TaskStateChangeDetails>
  serviceAreaUUID: Scalars['ID']['output']
  severity: TaskNotificationSeverity
  stateChanges: Array<TaskStateChangeDetails>
  status: TaskNotificationStatus
  vehicle: Maybe<Vehicle>
  version: Scalars['Int']['output']
}

export enum VehicleTripSegmentStatus {
  TripSegmentStatusCompleted = 'TRIP_SEGMENT_STATUS_COMPLETED',
  TripSegmentStatusInvalid = 'TRIP_SEGMENT_STATUS_INVALID',
  TripSegmentStatusInProgress = 'TRIP_SEGMENT_STATUS_IN_PROGRESS',
  TripSegmentStatusNotStarted = 'TRIP_SEGMENT_STATUS_NOT_STARTED',
}

export enum VehicleType {
  ECrafter = 'E_CRAFTER',
  IdBuzzAd = 'ID_BUZZ_AD',
  IdBuzzPrep = 'ID_BUZZ_PREP',
  MachE = 'MACH_E',
  Mover = 'MOVER',
  Pluto = 'PLUTO',
  /** @deprecated Not in use anymore */
  T6 = 'T6',
}

export type VehicleUnmatchSafetyDriverInput = {
  vehicleId: Scalars['ID']['input']
}

export type VehicleUnmatchSafetyDriverResponse = {
  __typename?: 'VehicleUnmatchSafetyDriverResponse'
  vehicle: Vehicle
}

export type VehicleUpdatedChange = FleetEntityChange & {
  __typename?: 'VehicleUpdatedChange'
  backofficeUser: Maybe<BackofficeUser>
  changedAt: Scalars['DateTime']['output']
  changes: VehicleUpdatedChangeFields
}

export type VehicleUpdatedChangeFields = VehicleChangeFields & {
  __typename?: 'VehicleUpdatedChangeFields'
  boxPcNew: Maybe<BoxPc>
  boxPcOld: Maybe<BoxPc>
  concessionTypeNew: Maybe<VehicleConcessionType>
  concessionTypeOld: Maybe<VehicleConcessionType>
  deFleetingDateNew: Maybe<Scalars['DateTime']['output']>
  deFleetingDateOld: Maybe<Scalars['DateTime']['output']>
  firstRegistrationDateNew: Maybe<Scalars['DateTime']['output']>
  firstRegistrationDateOld: Maybe<Scalars['DateTime']['output']>
  fleetNew: Maybe<Fleet>
  fleetOld: Maybe<Fleet>
  inFleetingDateNew: Maybe<Scalars['DateTime']['output']>
  inFleetingDateOld: Maybe<Scalars['DateTime']['output']>
  ioTNameNew: Maybe<Scalars['String']['output']>
  ioTNameOld: Maybe<Scalars['String']['output']>
  labelNew: Maybe<Scalars['Int']['output']>
  labelOld: Maybe<Scalars['Int']['output']>
  lastMainInspectionDateNew: Maybe<Scalars['DateTime']['output']>
  lastMainInspectionDateOld: Maybe<Scalars['DateTime']['output']>
  licensePlateCountryNew: Maybe<Scalars['String']['output']>
  licensePlateCountryOld: Maybe<Scalars['String']['output']>
  licensePlateNew: Maybe<Scalars['String']['output']>
  licensePlateOld: Maybe<Scalars['String']['output']>
  licensePlateRegionNew: Maybe<Scalars['String']['output']>
  licensePlateRegionOld: Maybe<Scalars['String']['output']>
  nextMainInspectionDateNew: Maybe<Scalars['DateTime']['output']>
  nextMainInspectionDateOld: Maybe<Scalars['DateTime']['output']>
  phoneNumberNew: Maybe<Scalars['String']['output']>
  phoneNumberOld: Maybe<Scalars['String']['output']>
  regionNew: Maybe<Region>
  regionOld: Maybe<Region>
  /** @deprecated Vehicle seat fields have been removed */
  reservedChildSeatsNew: Maybe<Scalars['Int']['output']>
  /** @deprecated Vehicle seat fields have been removed */
  reservedChildSeatsOld: Maybe<Scalars['Int']['output']>
  /** @deprecated Vehicle seat fields have been removed */
  reservedSeatsNew: Maybe<Scalars['Int']['output']>
  /** @deprecated Vehicle seat fields have been removed */
  reservedSeatsOld: Maybe<Scalars['Int']['output']>
  /** @deprecated Vehicle seat fields have been removed */
  reservedWheelchairSeatsNew: Maybe<Scalars['Int']['output']>
  /** @deprecated Vehicle seat fields have been removed */
  reservedWheelchairSeatsOld: Maybe<Scalars['Int']['output']>
  serviceBreakLocationNew: Maybe<ServiceBreakLocation>
  serviceBreakLocationOld: Maybe<ServiceBreakLocation>
  /** @deprecated Please use TabletReplacedChangeFields instead */
  tabletIdNew: Maybe<Scalars['String']['output']>
  /** @deprecated Please use TabletReplacedChangeFields instead */
  tabletIdOld: Maybe<Scalars['String']['output']>
  /** @deprecated Vehicle groups have been removed */
  vehicleGroupIdNew: Maybe<Scalars['ID']['output']>
  /** @deprecated Vehicle groups have been removed */
  vehicleGroupIdOld: Maybe<Scalars['ID']['output']>
  vehicleID: Scalars['ID']['output']
}

export type VehicleWaypointAttendance = TaskNotification & {
  __typename?: 'VehicleWaypointAttendance'
  actionType: TaskActionType
  assigned: Maybe<TaskStateChangeDetails>
  createdAt: Scalars['DateTime']['output']
  fleetId: Maybe<Scalars['ID']['output']>
  foreignId: Scalars['ID']['output']
  id: Scalars['ID']['output']
  note: Maybe<TaskNotificationNote>
  notificationType: TaskNotificationType
  pended: Maybe<TaskStateChangeDetails>
  regionId: Maybe<Scalars['ID']['output']>
  resolved: Maybe<TaskStateChangeDetails>
  serviceAreaUUID: Scalars['ID']['output']
  severity: TaskNotificationSeverity
  stateChanges: Array<TaskStateChangeDetails>
  status: TaskNotificationStatus
  vehicle: Maybe<Vehicle>
  version: Scalars['Int']['output']
}

export type VehiclesForVehicleListInput = {
  label?: InputMaybe<Scalars['Int']['input']>
  serviceAreaUUID: Scalars['ID']['input']
  tenant: Scalars['String']['input']
}

export type VehiclesResponse = {
  __typename?: 'VehiclesResponse'
  total: Scalars['Int']['output']
  vehicles: Array<Vehicle>
}

/** A version of Legal document */
export type Version = {
  __typename?: 'Version'
  /** The time at which the legal document was created */
  createdAt: Scalars['OffsetDateTime']['output']
  /** Available localizations of the legal document */
  localization: Array<Localization>
  /** The version of the legal document */
  version: Scalars['Int']['output']
}

export enum VnvBackofficeAssessmentSeverity {
  High = 'HIGH',
  Medium = 'MEDIUM',
}

/** Names one option list of safetyDriverConfig, for the search and id-lookup queries that serve a page of it instead of all of it. */
export enum VnvBackofficeConfigOptionField {
  BucketConnection = 'BUCKET_CONNECTION',
  CorrespondingFeatures = 'CORRESPONDING_FEATURES',
  CorrespondingScenario = 'CORRESPONDING_SCENARIO',
  CorrespondingTriggering = 'CORRESPONDING_TRIGGERING',
  EgoManoeuvre = 'EGO_MANOEUVRE',
  EnvironmentConditions = 'ENVIRONMENT_CONDITIONS',
  EventTag = 'EVENT_TAG',
  FailedRequirements = 'FAILED_REQUIREMENTS',
  JiraTicket = 'JIRA_TICKET',
  RcRoute = 'RC_ROUTE',
  RcRun = 'RC_RUN',
  RelevantOdd = 'RELEVANT_ODD',
  Testcase = 'TESTCASE',
  TestEnvironment = 'TEST_ENVIRONMENT',
  VnvConfirmation = 'VNV_CONFIRMATION',
}

export type VnvBackofficeCountByDimension = {
  __typename?: 'VnvBackofficeCountByDimension'
  count: Scalars['Int']['output']
  key: Maybe<Scalars['String']['output']>
}

export type VnvBackofficeDashboardConfigQueryResponse = {
  __typename?: 'VnvBackofficeDashboardConfigQueryResponse'
  fullEventId: Array<ConfigOption>
  fullEventIdPce: Array<ConfigOption>
  intervention: Array<ConfigOption>
  location: Array<ConfigOption>
  softwareVersion: Array<ConfigOption>
  swVersionPce: Array<ConfigOption>
  testType: Array<ConfigOption>
  vehicle: Array<ConfigOption>
  vtr: Array<ConfigOption>
}

export type VnvBackofficeDashboardFilterInput = {
  endDate?: InputMaybe<Scalars['Date']['input']>
  fullEventId?: InputMaybe<Array<Scalars['String']['input']>>
  intervention?: InputMaybe<Array<Scalars['String']['input']>>
  location?: InputMaybe<Array<Scalars['String']['input']>>
  locationExclude?: InputMaybe<Array<Scalars['String']['input']>>
  mission?: InputMaybe<Scalars['String']['input']>
  sessionId?: InputMaybe<Scalars['String']['input']>
  severityVerbal?: InputMaybe<Scalars['String']['input']>
  softwareVersion?: InputMaybe<Array<Scalars['String']['input']>>
  startDate?: InputMaybe<Scalars['Date']['input']>
  testType?: InputMaybe<Array<Scalars['String']['input']>>
  vehicle?: InputMaybe<Array<Scalars['String']['input']>>
  vtr?: InputMaybe<Array<Scalars['String']['input']>>
  vtrExclude?: InputMaybe<Array<Scalars['String']['input']>>
  vtrSummary?: InputMaybe<Scalars['String']['input']>
}

/** Names one option list of safetyDriverDashboardConfig, for the search and id-lookup queries that serve a page of it instead of all of it. */
export enum VnvBackofficeDashboardOptionField {
  FullEventId = 'FULL_EVENT_ID',
  FullEventIdPce = 'FULL_EVENT_ID_PCE',
  Intervention = 'INTERVENTION',
  Location = 'LOCATION',
  SoftwareVersion = 'SOFTWARE_VERSION',
  SwVersionPce = 'SW_VERSION_PCE',
  TestType = 'TEST_TYPE',
  Vehicle = 'VEHICLE',
  Vtr = 'VTR',
}

export enum VnvBackofficeFilterCondition {
  Contains = 'CONTAINS',
  EndsWith = 'ENDS_WITH',
  Equals = 'EQUALS',
  NotContains = 'NOT_CONTAINS',
  NotEndsWith = 'NOT_ENDS_WITH',
  NotStartsWith = 'NOT_STARTS_WITH',
  StartsWith = 'STARTS_WITH',
}

export type VnvBackofficeMedTriagesQueryResponse = {
  __typename?: 'VnvBackofficeMedTriagesQueryResponse'
  severityList: Array<VnvBackofficeCountByDimension>
  vehicleList: Array<VnvBackofficeCountByDimension>
  vtrList: Array<VnvBackofficeCountByDimension>
  vtrLocationList: Array<VnvBackofficeCountByDimension>
}

export type VnvBackofficePageInfo = {
  __typename?: 'VnvBackofficePageInfo'
  hasNextPage: Scalars['Boolean']['output']
  limit: Scalars['Int']['output']
  offset: Scalars['Int']['output']
  total: Scalars['Int']['output']
}

export type VnvBackofficePceAnalysis = {
  __typename?: 'VnvBackofficePceAnalysis'
  driverComment: Maybe<Scalars['String']['output']>
  eventJiraTicket: Maybe<Scalars['String']['output']>
  fullEventId: Maybe<Scalars['String']['output']>
  integrationStage: Maybe<Scalars['String']['output']>
  intervention: Maybe<Scalars['String']['output']>
  isAssessed: Maybe<Scalars['Boolean']['output']>
  jiraIntervention: Maybe<Scalars['String']['output']>
  jiraIssue: Maybe<Scalars['String']['output']>
  platform: Maybe<Scalars['String']['output']>
  rowId: Maybe<Scalars['String']['output']>
  sdsProviderId: Maybe<Scalars['String']['output']>
  sessionId: Maybe<Scalars['String']['output']>
  severityVerbal: Maybe<Scalars['String']['output']>
  swVersion: Maybe<Scalars['String']['output']>
  triageFormSummary: Maybe<Scalars['String']['output']>
  uuid: Maybe<Scalars['String']['output']>
  vehicle: Maybe<Scalars['String']['output']>
  vtrLocation: Maybe<Scalars['String']['output']>
  vtrSummary: Maybe<Scalars['String']['output']>
  vtrType: Maybe<Scalars['String']['output']>
}

export type VnvBackofficePceAnalysisQueryResponse = {
  __typename?: 'VnvBackofficePceAnalysisQueryResponse'
  items: Array<VnvBackofficePceAnalysis>
  pageInfo: VnvBackofficePageInfo
}

export enum VnvBackofficeSortDirection {
  Asc = 'ASC',
  Desc = 'DESC',
}

export type VnvBackofficeStatusResponse = {
  __typename?: 'VnvBackofficeStatusResponse'
  message: Scalars['String']['output']
  status: Scalars['Boolean']['output']
}

export type VnvBackofficeUnassessedByDate = {
  __typename?: 'VnvBackofficeUnassessedByDate'
  count: Scalars['Int']['output']
  dateFromSessionId: Maybe<Scalars['Date']['output']>
}

export type VnvBackofficeUnassessedBySession = {
  __typename?: 'VnvBackofficeUnassessedBySession'
  count: Scalars['Int']['output']
  dateFromSessionId: Maybe<Scalars['Date']['output']>
  mission: Maybe<Scalars['String']['output']>
  sessionId: Maybe<Scalars['String']['output']>
  vtrLocation: Maybe<Scalars['String']['output']>
}

export type VnvBackofficeUnassessedHighByMission = {
  __typename?: 'VnvBackofficeUnassessedHighByMission'
  count: Scalars['Int']['output']
  mission: Maybe<Scalars['String']['output']>
  vtrSummary: Maybe<Scalars['String']['output']>
}

export type VnvBackofficeUnassessedQueryResponse = {
  __typename?: 'VnvBackofficeUnassessedQueryResponse'
  dateHigh: Array<VnvBackofficeUnassessedByDate>
  dateMedium: Array<VnvBackofficeUnassessedByDate>
  high: VnvBackofficeUnassessedTotal
  locationHigh: Array<VnvBackofficeCountByDimension>
  medium: VnvBackofficeUnassessedTotal
  missionHigh: Array<VnvBackofficeUnassessedHighByMission>
  swHigh: Array<VnvBackofficeCountByDimension>
  vehicleHigh: Array<VnvBackofficeCountByDimension>
}

export type VnvBackofficeUnassessedSessionListQueryResponse = {
  __typename?: 'VnvBackofficeUnassessedSessionListQueryResponse'
  items: Array<VnvBackofficeUnassessedBySession>
  pageInfo: VnvBackofficePageInfo
}

export type VnvBackofficeUnassessedTotal = {
  __typename?: 'VnvBackofficeUnassessedTotal'
  count: Scalars['Int']['output']
}

export type VtrData = {
  __typename?: 'VtrData'
  cbData: Array<CbPreview>
  codebeamerId: Scalars['String']['output']
  description: Scalars['String']['output']
  deviationPermission: Scalars['String']['output']
  epicLink: Scalars['String']['output']
  feature: Scalars['String']['output']
  fixVersion: Scalars['String']['output']
  key: Scalars['String']['output']
  label: Scalars['String']['output']
  links: Scalars['String']['output']
  location: Scalars['String']['output']
  mapVersion: Scalars['String']['output']
  priority: Scalars['String']['output']
  requestedSoftwareVersion: Scalars['String']['output']
  resolution: Scalars['String']['output']
  riskLevel: Scalars['String']['output']
  securityLevel: Scalars['String']['output']
  sprint: Scalars['String']['output']
  status: Scalars['String']['output']
  targetCompoundRelease: Scalars['String']['output']
  testSpecification: Scalars['String']['output']
  testType: Scalars['String']['output']
  type: Scalars['String']['output']
}

export type VtrJiraTicket = {
  __typename?: 'VtrJiraTicket'
  fleetTarget: Scalars['String']['output']
  key: Scalars['String']['output']
  location: Scalars['String']['output']
  metroId: Maybe<Scalars['Int']['output']>
  missionType: Scalars['String']['output']
  reportedDate: Maybe<Scalars['Float']['output']>
  requestedSw: Scalars['String']['output']
  status: Scalars['String']['output']
  summary: Scalars['String']['output']
  ticketCreatedDate: Maybe<Scalars['Float']['output']>
}

export type Waypoint = {
  __typename?: 'Waypoint'
  /**
   * Actions of this waypoint
   * @deprecated Use `waypointActions`, this field will be removed soon.
   */
  actions: Array<WaypointActionKind>
  /** The stop at this waypoint */
  stop: Maybe<Stop>
  /** Is this waypoint visible for the driver? */
  visible: Scalars['Boolean']['output']
  /** Actions of this waypoint */
  waypointActions: Array<WaypointAction>
}

export type WaypointAction = {
  __typename?: 'WaypointAction'
  /** The time when this action should take place */
  at: Maybe<Scalars['DateTime']['output']>
  /** In case of a hub return what is the reason for it? */
  hubReturnReason: Maybe<HubReturnReason>
  /** Unique identifier for this action */
  id: Scalars['ID']['output']
  /** What is planned to happen at this waypoint? */
  kind: WaypointActionKind
  /** In case of a reallocation what is the radius */
  reallocationRadius: Maybe<Scalars['Int']['output']>
  /** An id referencing the thing that is about to happen at that waypoint. E.g. a tripId for a trip */
  referenceId: Maybe<Scalars['String']['output']>
  /** specification when this action SHOULD happen. */
  timeWindow: Maybe<WaypointActionTimeWindow>
  /** How many children are affected for this waypoint action? Based on child seats */
  totalChildren: Maybe<Scalars['Int']['output']>
  /** How many passengers are affected for this waypoint action? */
  totalPassengers: Maybe<Scalars['Int']['output']>
  /** How many wheelchair users are affected for this waypoint action? */
  totalWheelchairUsers: Maybe<Scalars['Int']['output']>
  /** In case of a delivery or pickup, this contains the resolved Trip */
  trip: Maybe<Trip>
}

export enum WaypointActionKind {
  Delivery = 'DELIVERY',
  Hubreturn = 'HUBRETURN',
  Pickup = 'PICKUP',
  Reallocation = 'REALLOCATION',
}

export type WaypointActionTimeWindow = {
  __typename?: 'WaypointActionTimeWindow'
  end: Maybe<Scalars['DateTime']['output']>
  start: Maybe<Scalars['DateTime']['output']>
}

export enum WindowState {
  AllClosed = 'ALL_CLOSED',
  Open = 'OPEN',
}

export type WipeBoxPcInput = {
  vehicleId: Scalars['ID']['input']
}

export type WorkOrder = {
  __typename?: 'WorkOrder'
  assignee: Maybe<BackofficeUser>
  automationRule: Maybe<WorkOrderAutomationRule>
  createdAt: Scalars['DateTime']['output']
  createdBy: Maybe<BackofficeUser>
  description: Maybe<Scalars['String']['output']>
  dueAt: Maybe<Scalars['DateTime']['output']>
  id: Scalars['ID']['output']
  /** Only set if the work order is closed. Unit is km. */
  mileageAtClosing: Maybe<Scalars['Int']['output']>
  operationalImpact: Maybe<WorkOrderOperationalImpact>
  orderNumber: Scalars['Int']['output']
  priority: Maybe<WorkOrderPriority>
  regionID: Maybe<Scalars['ID']['output']>
  /** @deprecated Use regionID instead */
  serviceAreaUUID: Scalars['ID']['output']
  serviceCategory: Maybe<WorkOrderServiceCategory>
  serviceItem: WorkOrderServiceItem
  source: Maybe<WorkOrderSource>
  status: WorkOrderStatus
  statusChangedAt: Maybe<Scalars['DateTime']['output']>
  statusChangedBy: Maybe<BackofficeUser>
  updatedAt: Scalars['DateTime']['output']
  vehicle: Maybe<Vehicle>
  vehicleTenant: Maybe<Scalars['String']['output']>
}

export type WorkOrderAutomationRule = {
  __typename?: 'WorkOrderAutomationRule'
  actionType: WorkOrderAutomationRuleActionType
  /** Offset in minutes from the trigger, used as the created work order's dueAt. */
  actionWorkOrderDueIn: Maybe<Scalars['Int']['output']>
  actionWorkOrderPriority: Maybe<WorkOrderPriority>
  actionWorkOrderServiceItem: Maybe<WorkOrderServiceItem>
  /** Backoffice user the created work orders are assigned to. */
  assignee: Maybe<BackofficeUser>
  createdAt: Scalars['DateTime']['output']
  createdBy: Maybe<BackofficeUser>
  description: Maybe<Scalars['String']['output']>
  fleetIds: Array<Scalars['ID']['output']>
  id: Scalars['ID']['output']
  lastRun: Maybe<Scalars['DateTime']['output']>
  /** Human-facing rule number. Unique per tenant, not globally. */
  referenceNumber: Scalars['Int']['output']
  runsCount: Maybe<Scalars['Int']['output']>
  status: WorkOrderAutomationRuleStatus
  tenant: Scalars['String']['output']
  title: Scalars['String']['output']
  triggerReportCondition: Maybe<WorkOrderAutomationRuleReportCondition>
  triggerType: WorkOrderAutomationRuleTriggerType
  triggerWorkOrderServiceTask: Maybe<WorkOrderServiceItem>
  updatedAt: Scalars['DateTime']['output']
  updatedBy: Maybe<BackofficeUser>
}

export enum WorkOrderAutomationRuleActionType {
  WorkOrderCreation = 'WORK_ORDER_CREATION',
}

export type WorkOrderAutomationRuleCreateInput = {
  actionType: WorkOrderAutomationRuleActionType
  /** Offset in minutes from the trigger, used as the created work order's dueAt. */
  actionWorkOrderDueIn?: InputMaybe<Scalars['Int']['input']>
  actionWorkOrderPriority?: InputMaybe<WorkOrderPriority>
  actionWorkOrderServiceItem?: InputMaybe<WorkOrderServiceItem>
  /** Backoffice user the created work orders are assigned to. If not present, they are left unassigned. */
  assigneeId?: InputMaybe<Scalars['ID']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  /** If not present, the rule applies to all fleets of the tenant. */
  fleetIds?: InputMaybe<Array<Scalars['ID']['input']>>
  status: WorkOrderAutomationRuleStatus
  tenant: Scalars['String']['input']
  title: Scalars['String']['input']
  /** Required for a REPORT_SUBMIT rule, and must be absent for every other trigger type. */
  triggerReportCondition?: InputMaybe<WorkOrderAutomationRuleReportConditionInput>
  triggerType: WorkOrderAutomationRuleTriggerType
  /** Must be absent for a REPORT_SUBMIT rule, which matches on a report rather than on a service task. */
  triggerWorkOrderServiceTask?: InputMaybe<WorkOrderServiceItem>
}

export type WorkOrderAutomationRuleDeleteInput = {
  id: Scalars['ID']['input']
}

export type WorkOrderAutomationRuleDeleteResponse = {
  __typename?: 'WorkOrderAutomationRuleDeleteResponse'
  success: Scalars['Boolean']['output']
}

export type WorkOrderAutomationRuleInput = {
  id: Scalars['ID']['input']
}

/** Report category a REPORT_SUBMIT rule listens to. */
export enum WorkOrderAutomationRuleReportCategory {
  Accident = 'ACCIDENT',
  DamageReport = 'DAMAGE_REPORT',
  Disruption = 'DISRUPTION',
  VehicleChecks = 'VEHICLE_CHECKS',
}

/**
 * The condition a REPORT_SUBMIT rule matches submitted reports against. Mirrors
 * `WorkOrderAutomationRuleReportConditionInput`, where the criteria are documented.
 */
export type WorkOrderAutomationRuleReportCondition = {
  __typename?: 'WorkOrderAutomationRuleReportCondition'
  category: WorkOrderAutomationRuleReportCategory
  disruptionType: Maybe<Scalars['String']['output']>
  failedChecks: Maybe<Array<Scalars['String']['output']>>
  outcome: Maybe<Scalars['String']['output']>
  severity: Maybe<Scalars['String']['output']>
  status: Maybe<Scalars['String']['output']>
  templateName: Scalars['String']['output']
}

/**
 * Narrows which submitted reports a REPORT_SUBMIT rule fires for. The criteria are strings because
 * their allowed values come from the report template and differ per tenant; an absent one is not
 * filtered on.
 */
export type WorkOrderAutomationRuleReportConditionInput = {
  category: WorkOrderAutomationRuleReportCategory
  disruptionType?: InputMaybe<Scalars['String']['input']>
  failedChecks?: InputMaybe<Array<Scalars['String']['input']>>
  outcome?: InputMaybe<Scalars['String']['input']>
  severity?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<Scalars['String']['input']>
  /** Name of the report template, e.g. `pluto-damage-report`. Not version-specific. */
  templateName: Scalars['String']['input']
}

export type WorkOrderAutomationRuleResponse = {
  __typename?: 'WorkOrderAutomationRuleResponse'
  /** Null when no rule with the requested ID exists in a tenant the caller has access to. */
  automationRule: Maybe<WorkOrderAutomationRule>
}

export enum WorkOrderAutomationRuleStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Inactive = 'INACTIVE',
}

export type WorkOrderAutomationRuleStatusUpdateInput = {
  id: Scalars['ID']['input']
  /** The status the rule should end up in. */
  status: WorkOrderAutomationRuleStatus
}

export type WorkOrderAutomationRuleStatusUpdateResponse = {
  __typename?: 'WorkOrderAutomationRuleStatusUpdateResponse'
  /**
   * The rule as it stands after the status change. Never null: a rule that cannot be transitioned is
   * reported as an error instead.
   */
  automationRule: WorkOrderAutomationRule
}

export enum WorkOrderAutomationRuleTriggerType {
  ReportSubmit = 'REPORT_SUBMIT',
  WorkOrderCompleted = 'WORK_ORDER_COMPLETED',
}

export type WorkOrderAutomationRulesInput = {
  /**
   * The statuses to return; required so that the result set follows from the query
   * rather than from a default applied server-side. An empty list returns no rules.
   */
  statuses: Array<WorkOrderAutomationRuleStatus>
  tenant: Scalars['String']['input']
}

export type WorkOrderAutomationRulesResponse = {
  __typename?: 'WorkOrderAutomationRulesResponse'
  automationRules: Array<WorkOrderAutomationRule>
}

export enum WorkOrderOperationalImpact {
  /** Input only: removes the impact. Omitting the field keeps it. */
  None = 'NONE',
  NonOperational = 'NON_OPERATIONAL',
  NonOperationalAtDue = 'NON_OPERATIONAL_AT_DUE',
}

export enum WorkOrderPriority {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM',
}

export enum WorkOrderServiceCategory {
  DamagesDefects = 'DAMAGES_DEFECTS',
  HubActivities = 'HUB_ACTIVITIES',
  Incident = 'INCIDENT',
  /** @deprecated Not in use anymore. Keep for backwards compatibility */
  Ivc = 'IVC',
  MaintenanceService = 'MAINTENANCE_SERVICE',
  Other = 'OTHER',
}

export enum WorkOrderServiceItem {
  /** @deprecated No longer used */
  ActionInternal = 'ACTION_INTERNAL',
  /** @deprecated No longer used */
  ActionManufacturer = 'ACTION_MANUFACTURER',
  BrakeFluidChange = 'BRAKE_FLUID_CHANGE',
  Charging = 'CHARGING',
  /** @deprecated Use INSIDE_CLEANING or OUTSIDE_CLEANING instead */
  Cleaning = 'CLEANING',
  DemoCleaning = 'DEMO_CLEANING',
  InsideCleaning = 'INSIDE_CLEANING',
  InternalInspection = 'INTERNAL_INSPECTION',
  InFieldSupport = 'IN_FIELD_SUPPORT',
  Maintenance = 'MAINTENANCE',
  MainInspection = 'MAIN_INSPECTION',
  MileageInspection = 'MILEAGE_INSPECTION',
  OnSiteTireChange = 'ON_SITE_TIRE_CHANGE',
  Other = 'OTHER',
  OutsideCleaning = 'OUTSIDE_CLEANING',
  SeatComplaint = 'SEAT_COMPLAINT',
  SmartRepairDent = 'SMART_REPAIR_DENT',
  SmartRepairPaintwork = 'SMART_REPAIR_PAINTWORK',
  SparePartsRequest = 'SPARE_PARTS_REQUEST',
  /** @deprecated Use INSIDE_CLEANING or OUTSIDE_CLEANING instead */
  SpecialCleaning = 'SPECIAL_CLEANING',
  TabletUpdate = 'TABLET_UPDATE',
  TransferRide = 'TRANSFER_RIDE',
  VehicleLettering = 'VEHICLE_LETTERING',
}

export enum WorkOrderSortType {
  DueDate = 'DUE_DATE',
  Priority = 'PRIORITY',
}

/**
 * Origin a work order was created from: the completed work order that triggered the rule, or the
 * submitted report that did.
 */
export type WorkOrderSource = RioReport | WorkOrder

export enum WorkOrderStatus {
  Cancelled = 'CANCELLED',
  Closed = 'CLOSED',
  InProgress = 'IN_PROGRESS',
  Open = 'OPEN',
}

export type WorkOrdersByCurrentUserInput = {
  fleets?: InputMaybe<Array<Scalars['ID']['input']>>
  serviceItems?: InputMaybe<Array<WorkOrderServiceItem>>
  sortType?: InputMaybe<WorkOrderSortType>
}

export type WorkOrdersByCurrentUserResponse = {
  __typename?: 'WorkOrdersByCurrentUserResponse'
  allowedCategoryFilter: Array<WorkOrderServiceCategory>
  total: Scalars['Int']['output']
  workOrders: Array<WorkOrder>
}

export type WorkOrdersByRegionInput = {
  baseHubs?: InputMaybe<Array<Scalars['ID']['input']>>
  /** Either null (all vehicles), a hub ID or 'IN_FIELD' */
  currentLocation?: InputMaybe<Scalars['String']['input']>
  fleets?: InputMaybe<Array<Scalars['ID']['input']>>
  priorities?: InputMaybe<Array<WorkOrderPriority>>
  regionID: Scalars['ID']['input']
  /** If this field is not present, work orders with all kinds of service categories will be returned */
  serviceCategories?: InputMaybe<Array<WorkOrderServiceCategory>>
  /** If this field is not present, work orders with all kinds of service Items will be returned */
  serviceItems?: InputMaybe<Array<WorkOrderServiceItem>>
  statuses?: InputMaybe<Array<WorkOrderStatus>>
  vehicleID?: InputMaybe<Scalars['ID']['input']>
  vehicleLists?: InputMaybe<Array<Scalars['ID']['input']>>
}

export type WorkOrdersQueryResponse = {
  __typename?: 'WorkOrdersQueryResponse'
  total: Scalars['Int']['output']
  workOrders: Array<WorkOrder>
}
